import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: number;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  GUID: any;
  JSON: any;
  JSONObject: any;
  Void: any;
};

export type AiCallInputPayload = {
  bankName?: InputMaybe<Scalars['String']>;
  buyRate?: InputMaybe<Scalars['String']>;
  currentMiles__vscMiles?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  dealSource?: InputMaybe<Scalars['String']>;
  driverName?: InputMaybe<Scalars['String']>;
  firstPaymentDate?: InputMaybe<Scalars['String']>;
  isBuyerNotLessee?: InputMaybe<Scalars['String']>;
  isDirectPayDeal?: InputMaybe<Scalars['String']>;
  isLesseeOnlyOrDoubleTax?: InputMaybe<Scalars['String']>;
  isRegTransferEligible?: InputMaybe<Scalars['String']>;
  isTitleOnly?: InputMaybe<Scalars['String']>;
  isWalkInRequired?: InputMaybe<Scalars['String']>;
  lienholderName?: InputMaybe<Scalars['String']>;
  maxMarkup?: InputMaybe<Scalars['String']>;
  moneyDown?: InputMaybe<Scalars['String']>;
  monthlyPaymentWithGap?: InputMaybe<Scalars['String']>;
  monthlyPaymentWithNoCoverage?: InputMaybe<Scalars['String']>;
  monthlyPaymentWithVSC?: InputMaybe<Scalars['String']>;
  monthlyPaymentWithVSCGAP?: InputMaybe<Scalars['String']>;
  originalWarrantyMiles?: InputMaybe<Scalars['String']>;
  originalWarrantyYears?: InputMaybe<Scalars['String']>;
  payoffAmount?: InputMaybe<Scalars['String']>;
  repName?: InputMaybe<Scalars['String']>;
  sellRate?: InputMaybe<Scalars['String']>;
  termInMonths?: InputMaybe<Scalars['String']>;
  vehicleMileage?: InputMaybe<Scalars['String']>;
  vehicleYearMakeModel?: InputMaybe<Scalars['String']>;
  vscMiles?: InputMaybe<Scalars['String']>;
  vscYears?: InputMaybe<Scalars['String']>;
};

export type AiCallPayload = {
  __typename?: 'AICallPayload';
  bankName?: Maybe<Scalars['String']>;
  buyRate?: Maybe<Scalars['String']>;
  currentMiles__vscMiles?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  dealSource?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  firstPaymentDate?: Maybe<Scalars['String']>;
  isBuyerNotLessee?: Maybe<Scalars['String']>;
  isDirectPayDeal?: Maybe<Scalars['String']>;
  isLesseeOnlyOrDoubleTax?: Maybe<Scalars['String']>;
  isRegTransferEligible?: Maybe<Scalars['String']>;
  isTitleOnly?: Maybe<Scalars['String']>;
  isWalkInRequired?: Maybe<Scalars['String']>;
  lienholderName?: Maybe<Scalars['String']>;
  maxMarkup?: Maybe<Scalars['String']>;
  moneyDown?: Maybe<Scalars['String']>;
  monthlyPaymentWithGap?: Maybe<Scalars['String']>;
  monthlyPaymentWithNoCoverage?: Maybe<Scalars['String']>;
  monthlyPaymentWithVSC?: Maybe<Scalars['String']>;
  monthlyPaymentWithVSCGAP?: Maybe<Scalars['String']>;
  originalWarrantyMiles?: Maybe<Scalars['String']>;
  originalWarrantyYears?: Maybe<Scalars['String']>;
  payoffAmount?: Maybe<Scalars['String']>;
  repName?: Maybe<Scalars['String']>;
  sellRate?: Maybe<Scalars['String']>;
  termInMonths?: Maybe<Scalars['String']>;
  vehicleMileage?: Maybe<Scalars['String']>;
  vehicleYearMakeModel?: Maybe<Scalars['String']>;
  vscMiles?: Maybe<Scalars['String']>;
  vscYears?: Maybe<Scalars['String']>;
};

export type AiCloserCallStatus = {
  __typename?: 'AICloserCallStatus';
  callSuccessful?: Maybe<Scalars['Boolean']>;
  callSummary?: Maybe<Scalars['String']>;
  dealId: Scalars['ID'];
  event: Scalars['String'];
  inVoicemail?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  userSentiment?: Maybe<Scalars['String']>;
};

export type AcquirePayoffResponse = {
  __typename?: 'AcquirePayoffResponse';
  received: Scalars['Boolean'];
};

export type AddressDetail = {
  __typename?: 'AddressDetail';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AddressInputV2 = {
  addressLine?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  county?: InputMaybe<Scalars['String']>;
  monthlyPayment?: InputMaybe<Scalars['Float']>;
  monthsAtHome?: InputMaybe<Scalars['Int']>;
  residenceType?: InputMaybe<ResidenceTypeEnum>;
  state?: InputMaybe<Region>;
  yearsAtHome?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum AddressTypeEnum {
  Buyer = 'buyer',
  CoBuyer = 'co_buyer',
  Current = 'current',
  DriversLicense = 'drivers_license',
  Mailing = 'mailing',
  Previous = 'previous'
}

/** The advisor bar's queue activity for the chosen pool and time frame. */
export type AdvisorSummaryStats = {
  __typename?: 'AdvisorSummaryStats';
  /** Deals that first entered Closing in the time frame. */
  apps: Scalars['Int'];
  /** Deals that got a setter in the time frame. */
  assigned: Scalars['Int'];
};

export type AdvisorSummaryStatsReply = {
  __typename?: 'AdvisorSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: AdvisorSummaryStats;
};

export type AffiliateApiKey = {
  __typename?: 'AffiliateApiKey';
  affiliate_provider_id?: Maybe<Scalars['String']>;
  api_key_hash?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_used_at?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type AffiliateApiKeyInput = {
  affiliate_provider_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type AffiliateDuplicateFound = {
  __typename?: 'AffiliateDuplicateFound';
  deal_id: Scalars['ID'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type AffiliateInput = {
  affiliate_provider_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  decision_accepted?: InputMaybe<Scalars['Boolean']>;
  decision_response?: InputMaybe<Lending_Tree_Decision_Response_Input>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lead_request?: InputMaybe<Scalars['JSONObject']>;
  ssn_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type AffiliateProviderInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type AffiliateProviderRead = {
  __typename?: 'AffiliateProviderRead';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum AiInvolvementStatus {
  Complete = 'complete',
  Fail = 'fail',
  InProgress = 'in_progress',
  None = 'none'
}

export type Alert = {
  __typename?: 'Alert';
  alert_message?: Maybe<AlertMessage>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  priority: AlertPriority;
  seen_at?: Maybe<Scalars['DateTime']>;
  type: AlertType;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type AlertMessage = {
  __typename?: 'AlertMessage';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  message: Scalars['String'];
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type AlertPreferences = {
  __typename?: 'AlertPreferences';
  soundVolume: Scalars['Float'];
};

export type AlertPreferencesInput = {
  soundVolume?: InputMaybe<Scalars['Float']>;
};

export enum AlertPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type AlertRecipientsChangedPayload = {
  __typename?: 'AlertRecipientsChangedPayload';
  addedAlerts: Array<Alert>;
  removedAlertIds: Array<Scalars['ID']>;
};

export enum AlertSortColumn {
  CreatedAt = 'created_at',
  Priority = 'priority',
  SeenAt = 'seen_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type AlertSortingType = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<AlertSortColumn>;
};

export enum AlertType {
  AppointmentUpcoming = 'appointment_upcoming',
  ContractApproved = 'contract_approved',
  ContractFunded = 'contract_funded',
  ContractHeld = 'contract_held',
  ContractRejected = 'contract_rejected',
  DashboardDocumentUploaded = 'dashboard_document_uploaded',
  DealImportedInactivity = 'deal_imported_inactivity',
  DealIssueRaised = 'deal_issue_raised',
  DealIssueResolved = 'deal_issue_resolved',
  DownPaymentReceived = 'down_payment_received',
  DuplicatedDealImport = 'duplicated_deal_import',
  DuplicatedInfo = 'duplicated_info',
  DuplicatedLendingTreeInfo = 'duplicated_lending_tree_info',
  FundingRequirementAdded = 'funding_requirement_added',
  FundingRequirementResolved = 'funding_requirement_resolved',
  MissedCall = 'missed_call',
  NoteCreated = 'note_created',
  PayoffRequestCompleted = 'payoff_request_completed',
  PayoffRequestFailed = 'payoff_request_failed',
  SecureFormCompleted = 'secure_form_completed',
  SecureFormExpired = 'secure_form_expired',
  TextMessageReceived = 'text_message_received',
  TieDownApproved = 'tie_down_approved',
  TieDownCountered = 'tie_down_countered',
  TieDownDeclined = 'tie_down_declined',
  TieDownSubmitted = 'tie_down_submitted'
}

export type AlertsConnection = {
  __typename?: 'AlertsConnection';
  items: Array<Maybe<Alert>>;
  pagination: Pagination;
  total: Scalars['Int'];
};

export type AlertsFilter = {
  created_at?: InputMaybe<DateFilter>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  priorities?: InputMaybe<Array<InputMaybe<AlertPriority>>>;
  seenOnly?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<AlertType>>>;
  unseenOnly?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<DateFilter>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AlertsMarkedSeenPayload = {
  __typename?: 'AlertsMarkedSeenPayload';
  alertIds: Array<Scalars['ID']>;
};

export type AllDealsColumnSet = {
  __typename?: 'AllDealsColumnSet';
  /** Map of TanStack column id to boolean (true=shown, false=hidden). */
  columnVisibility: Scalars['JSON'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AllDealsColumnSetInput = {
  columnVisibility: Scalars['JSON'];
  id: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type AllDealsFilterSet = {
  __typename?: 'AllDealsFilterSet';
  columnSetId?: Maybe<Scalars['String']>;
  /** Saved filter snapshot in the flat all-deals search-param shape. */
  filters: Scalars['JSON'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AllDealsFilterSetInput = {
  columnSetId?: InputMaybe<Scalars['String']>;
  filters: Scalars['JSON'];
  id: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type AllDealsTablePreferences = {
  __typename?: 'AllDealsTablePreferences';
  columnSets: Array<AllDealsColumnSet>;
  filterSets: Array<AllDealsFilterSet>;
};

export type AllDealsTablePreferencesInput = {
  columnSets?: InputMaybe<Array<AllDealsColumnSetInput>>;
  filterSets?: InputMaybe<Array<AllDealsFilterSetInput>>;
};

export enum AssignmentMode {
  Frequency = 'frequency',
  MaxDeals = 'max_deals'
}

export type Auth0Role = {
  __typename?: 'Auth0Role';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Auth0RoleInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum Auth0RoleName {
  AccountingTeam = 'AccountingTeam',
  Admin = 'Admin',
  CSuite = 'CSuite',
  CustomerService = 'CustomerService',
  D2dAdmin = 'D2dAdmin',
  D2dCloser = 'D2dCloser',
  D2dDev = 'D2dDev',
  D2dSetter = 'D2dSetter',
  D2dSetterLead = 'D2dSetterLead',
  FinanceTeam = 'FinanceTeam',
  FsManager = 'FsManager',
  FundingClerk = 'FundingClerk',
  FundingClerkManager = 'FundingClerkManager',
  InboundFinancialSpecialist = 'InboundFinancialSpecialist',
  InboundSalesAdvisor = 'InboundSalesAdvisor',
  InboundSalesPodLead = 'InboundSalesPodLead',
  OutboundAdvisorManager = 'OutboundAdvisorManager',
  OutboundSetter = 'OutboundSetter',
  OutboundWebAdvisor = 'OutboundWebAdvisor',
  PayoffClerk = 'PayoffClerk',
  PayoffManager = 'PayoffManager',
  SecondTurnFinancialSpecialist = 'SecondTurnFinancialSpecialist',
  StructuringAssistant = 'StructuringAssistant',
  StructuringManager = 'StructuringManager',
  TitleClerk = 'TitleClerk',
  TitleManager = 'TitleManager',
  WebAdmin = 'WebAdmin'
}

export type AutoStructureBankLogo = {
  __typename?: 'AutoStructureBankLogo';
  bank_name?: Maybe<Scalars['String']>;
  bank_slug?: Maybe<TtNewBankEnum>;
  logo_url?: Maybe<Scalars['String']>;
};

export type BackendLimits = {
  __typename?: 'BackendLimits';
  max_backend_amount?: Maybe<Scalars['Float']>;
  max_backend_percentage?: Maybe<Scalars['Float']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BootReasonInputV2 = {
  author_id?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  reason: BootReasonsEnum;
};

export enum BootReasonsEnum {
  BadContactInfo = 'bad_contact_info',
  BoughtOutThroughDifferentSource = 'bought_out_through_different_source',
  CashBuyer = 'cash_buyer',
  CustomerDoesNotQualify = 'customer_does_not_qualify',
  CustomerDoesNotWantToGiveInformationToProceed = 'customer_does_not_want_to_give_information_to_proceed',
  CustomerWaitingUntilEndOfLease = 'customer_waiting_until_end_of_lease',
  DealWasUnwound = 'deal_was_unwound',
  DirectPayState = 'direct_pay_state',
  DocFeeTooHigh = 'doc_fee_too_high',
  DuplicateDeal = 'duplicate_deal',
  ExtendedLease = 'extended_lease',
  LienholderNotApproved = 'lienholder_not_approved',
  ManufacturerNotApproved = 'manufacturer_not_approved',
  NoResponse = 'no_response',
  Other = 'other',
  PaymentOnApprovalTooHigh = 'payment_on_approval_too_high',
  PayoffAmountTooHighForFinancing = 'payoff_amount_too_high_for_financing',
  QuoteTooHigh = 'quote_too_high',
  RateTooHigh = 'rate_too_high',
  SalesTaxIssue = 'sales_tax_issue',
  ThoughtWeWereManufacturer = 'thought_we_were_manufacturer',
  TurnedVehicleBackInToDealership = 'turned_vehicle_back_in_to_dealership',
  VehicleDoesNotQualifyForOurFinancing = 'vehicle_does_not_qualify_for_our_financing'
}

export type CudlComment = {
  __typename?: 'CUDLComment';
  Body?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
};

export type CudlComments = {
  __typename?: 'CUDLComments';
  Comment?: Maybe<Array<Maybe<CudlComment>>>;
};

export type CudlDecision = {
  __typename?: 'CUDLDecision';
  ID?: Maybe<Scalars['String']>;
  IsCurrent?: Maybe<Scalars['Boolean']>;
  OtherData?: Maybe<CudlDecisionOtherData>;
  Reasons?: Maybe<CudlReasons>;
  Status?: Maybe<Scalars['String']>;
  Stipulations?: Maybe<CudlStipulations>;
};

export type CudlDecisionOtherData = {
  __typename?: 'CUDLDecisionOtherData';
  ReferralReasons?: Maybe<CudlReferralReasons>;
};

export type CudlDecisionReason = {
  __typename?: 'CUDLDecisionReason';
  Description?: Maybe<Scalars['String']>;
};

export type CudlDecisions = {
  __typename?: 'CUDLDecisions';
  Decision?: Maybe<Array<Maybe<CudlDecision>>>;
};

export type CudlReasons = {
  __typename?: 'CUDLReasons';
  DecisionReason?: Maybe<Array<Maybe<CudlDecisionReason>>>;
};

export type CudlReferralReason = {
  __typename?: 'CUDLReferralReason';
  ReferralReasonText?: Maybe<Scalars['String']>;
};

export type CudlReferralReasons = {
  __typename?: 'CUDLReferralReasons';
  ReferralReason?: Maybe<Array<Maybe<CudlReferralReason>>>;
};

export type CudlStipulations = {
  __typename?: 'CUDLStipulations';
  Stipulation?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CudlVehicleLoanApplication = {
  __typename?: 'CUDLVehicleLoanApplication';
  Comments?: Maybe<CudlComments>;
  Decision?: Maybe<CudlDecision>;
  Decisions?: Maybe<CudlDecisions>;
  ID?: Maybe<Scalars['String']>;
};

export type CalculateDealFeesResult = {
  __typename?: 'CalculateDealFeesResult';
  financialInfo: FinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type CallEvent = {
  __typename?: 'CallEvent';
  error_code?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  event_type: Scalars['String'];
  hunt_group_slug?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  occurred_at: Scalars['String'];
  participant_label?: Maybe<Scalars['String']>;
  participant_number?: Maybe<Scalars['String']>;
  participant_user_id?: Maybe<Scalars['String']>;
  participant_user_name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sequence_number?: Maybe<Scalars['Int']>;
  sip_response_code?: Maybe<Scalars['String']>;
};

export enum CallEventDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export enum CallEventStatus {
  Answered = 'answered',
  Failed = 'failed',
  Missed = 'missed',
  Unknown = 'unknown',
  Voicemail = 'voicemail'
}

export type CallEventV2 = {
  __typename?: 'CallEventV2';
  agentName?: Maybe<Scalars['String']>;
  callDuration?: Maybe<Scalars['String']>;
  callStatus: CallEventStatus;
  callerName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  direction: CallEventDirection;
  id?: Maybe<Scalars['ID']>;
};

export type CallHistoryItem = {
  __typename?: 'CallHistoryItem';
  agent_name?: Maybe<Scalars['String']>;
  callDuration?: Maybe<Scalars['String']>;
  calledNumber?: Maybe<Scalars['String']>;
  conference_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  customer_name?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['String']>;
  fromNumber?: Maybe<Scalars['String']>;
  hunt_group_name?: Maybe<Scalars['String']>;
  hunt_group_slug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  outcome?: Maybe<Scalars['String']>;
  participants?: Maybe<Scalars['String']>;
  recording_url?: Maybe<Scalars['String']>;
  sip_failure_count?: Maybe<Scalars['Int']>;
  twilioNumber?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  voicemail_reason?: Maybe<Scalars['String']>;
  voicemail_recording_url?: Maybe<Scalars['String']>;
  was_transferred?: Maybe<Scalars['Boolean']>;
};

export type CallHistoryResult = {
  __typename?: 'CallHistoryResult';
  calls: Array<CallHistoryItem>;
  totalRecords: Scalars['Int'];
};

export type CallHistoryStats = {
  __typename?: 'CallHistoryStats';
  answeredCalls: Scalars['Int'];
  avgDurationSeconds?: Maybe<Scalars['Float']>;
  callsByDay: Array<DayCount>;
  callsByFlowType: Array<FlowCount>;
  callsByOutcome: Array<OutcomeCount>;
  sipFailures: Scalars['Int'];
  totalCalls: Scalars['Int'];
  transferredCalls: Scalars['Int'];
  voicemailCalls: Scalars['Int'];
};

export type CallLifecycle = {
  __typename?: 'CallLifecycle';
  call: CallHistoryItem;
  events: Array<CallEvent>;
  participants: Array<CdrParticipantInLifecycle>;
};

export enum CallStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type CdrParticipantInLifecycle = {
  __typename?: 'CdrParticipantInLifecycle';
  call_id?: Maybe<Scalars['String']>;
  concluded_at?: Maybe<Scalars['String']>;
  conference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  joined_at?: Maybe<Scalars['String']>;
  participant_number?: Maybe<Scalars['String']>;
  participant_user_id?: Maybe<Scalars['String']>;
  transferred?: Maybe<Scalars['Boolean']>;
  transferred_from_number?: Maybe<Scalars['String']>;
};

export type CheckPayoffRequestRequirementsResponse = {
  __typename?: 'CheckPayoffRequestRequirementsResponse';
  doubleTax: Scalars['Boolean'];
  missingCombinationFields: Array<Array<Scalars['String']>>;
  missingRequiredFields: Array<Scalars['String']>;
  prsRequirementsMet: Scalars['Boolean'];
  requirementsMet: Scalars['Boolean'];
};

export type ClosingNoteSnapshot = {
  __typename?: 'ClosingNoteSnapshot';
  amountFinanced?: Maybe<Scalars['Float']>;
  bank?: Maybe<Scalars['String']>;
  buyerNotLessee?: Maybe<Scalars['Boolean']>;
  closedByUserName?: Maybe<Scalars['String']>;
  daysToPayment?: Maybe<Scalars['Float']>;
  firstPaymentDate?: Maybe<Scalars['String']>;
  gapPrice?: Maybe<Scalars['Float']>;
  keyReplacementPrice?: Maybe<Scalars['Float']>;
  moneyDown?: Maybe<Scalars['Float']>;
  movedStateDuringLease?: Maybe<Scalars['Boolean']>;
  optionType?: Maybe<Scalars['String']>;
  payment?: Maybe<Scalars['Float']>;
  plateTransfer?: Maybe<Scalars['Boolean']>;
  productsLabel?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['Float']>;
  sellRate?: Maybe<Scalars['Float']>;
  taxes?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Float']>;
  tireWheelPrice?: Maybe<Scalars['Float']>;
  titleRegistrationOption?: Maybe<Scalars['String']>;
  vscPrice?: Maybe<Scalars['Float']>;
  vscTerm?: Maybe<Scalars['String']>;
  vscType?: Maybe<Scalars['String']>;
};

export type CommunicationEventEdge = {
  __typename?: 'CommunicationEventEdge';
  cursor: Scalars['String'];
  node: CommunicationEventV2;
};

export type CommunicationEventV2 = CallEventV2 | MessageV2;

export type CommunicationHistoryConnection = {
  __typename?: 'CommunicationHistoryConnection';
  edges: Array<CommunicationEventEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CommunicationHistoryFilter = {
  dealId?: InputMaybe<Scalars['Int']>;
  phoneNumber: Scalars['String'];
};

export type ComparePrequalSocials = {
  __typename?: 'ComparePrequalSocials';
  cobuyerMatches?: Maybe<Scalars['Boolean']>;
  customerMatches?: Maybe<Scalars['Boolean']>;
};

export enum ConsentAction {
  Detected = 'detected',
  OptIn = 'opt_in',
  OptOut = 'opt_out'
}

export enum ConsentBasis {
  Dnss = 'dnss',
  Glba = 'glba',
  Gpc = 'gpc'
}

export type ConsentDecisionInput = {
  action: ConsentAction;
  basis: ConsentBasis;
  identifiers: Array<ConsentIdentifierInput>;
  in_scope?: InputMaybe<Scalars['Boolean']>;
  notice_version?: InputMaybe<Scalars['String']>;
  page_url?: InputMaybe<Scalars['String']>;
  resolution_source?: InputMaybe<Scalars['String']>;
  source: ConsentSource;
  state?: InputMaybe<Scalars['String']>;
};

export enum ConsentHowLinked {
  AtChoice = 'at_choice',
  IdentifiedOnOptedOutBrowser = 'identified_on_opted_out_browser',
  MatchedFromAnotherDevice = 'matched_from_another_device',
  TypedIntoForm = 'typed_into_form'
}

export enum ConsentIdType {
  AnonymousId = 'anonymous_id',
  Auth0Id = 'auth0_id',
  CustomerId = 'customer_id',
  Email = 'email',
  Phone = 'phone'
}

export type ConsentIdentifierInput = {
  id_type: ConsentIdType;
  id_value: Scalars['String'];
};

export enum ConsentSource {
  GpcAuto = 'gpc_auto',
  LimitSharing = 'limit_sharing',
  PrivacyChoices = 'privacy_choices'
}

export type ContractDistribution = {
  __typename?: 'ContractDistribution';
  conversation_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  error_message?: Maybe<Scalars['String']>;
  funder_comments?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  jacket_id?: Maybe<Scalars['String']>;
  sent_by_user_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ContractFundingRules = {
  __typename?: 'ContractFundingRules';
  first_contract_funds?: Maybe<Scalars['Boolean']>;
  funding_priority_rules?: Maybe<Array<Maybe<Scalars['String']>>>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  customerName: Scalars['String'];
  dealId?: Maybe<Scalars['Int']>;
  dealState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastMessageBody?: Maybe<Scalars['String']>;
  lastMessageDate?: Maybe<Scalars['DateTime']>;
  lastMessageFromCustomer?: Maybe<Scalars['Boolean']>;
  lastMissedCallDate?: Maybe<Scalars['DateTime']>;
  phoneNumber: Scalars['String'];
  /** Whether the row is the person's Home number or their Mobile. Contacts, original lessees and numbers on no deal are always Mobile. */
  phoneType: PhoneType;
  /** Deals a number on no deal used to text or call from, newest first. */
  previousDeals?: Maybe<Array<PreviousDeal>>;
  /** The Lease End number replies to a number on no deal go out from. Deal threads read it from the deal. */
  textNumber?: Maybe<Scalars['String']>;
  unreadCount: Scalars['Int'];
  unseenMissedCallCount: Scalars['Int'];
  unseenMissedCallIds: Array<Scalars['ID']>;
};

export type ConversationSummaryEdge = {
  __typename?: 'ConversationSummaryEdge';
  cursor: Scalars['String'];
  node: ConversationSummary;
};

export type ConversationsInboxConnection = {
  __typename?: 'ConversationsInboxConnection';
  edges: Array<ConversationSummaryEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConversationsInboxFilter = {
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  height?: Maybe<Scalars['Float']>;
  pageNumber?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
  xPosition?: Maybe<Scalars['Float']>;
  yPosition?: Maybe<Scalars['Float']>;
};

export enum Country {
  Ca = 'CA',
  Us = 'US'
}

export type CreateAndSendSecureLinkResult = {
  __typename?: 'CreateAndSendSecureLinkResult';
  emailError?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  textError?: Maybe<Scalars['String']>;
};

export type CreateBookSheetsV2Response = {
  __typename?: 'CreateBookSheetsV2Response';
  category: DocumentCategoryId;
  cbbError?: Maybe<Scalars['String']>;
  files: Array<EnhancedDealMedia>;
  jdpError?: Maybe<Scalars['String']>;
  kbbError?: Maybe<Scalars['String']>;
};

export type CreateDealInput = {
  /** Defaults to true: assign the creating user as setter (and closer when permitted) and derive the pod and source from their sales pod. Pass false to leave the deal unassigned with a web source. */
  autoAssign?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Country>;
  customer: CustomerInput;
  notes?: InputMaybe<Array<NoteInput>>;
  /** Defaults to buyout. */
  type?: InputMaybe<DealType>;
};

export type CreateFinixIdentityGraphQlType = {
  __typename?: 'CreateFinixIdentityGraphQLType';
  id?: Maybe<Scalars['String']>;
  pi_b?: Maybe<Scalars['String']>;
  pi_em?: Maybe<Scalars['String']>;
  pi_ey?: Maybe<Scalars['String']>;
  pi_lf?: Maybe<Scalars['String']>;
  pi_t?: Maybe<Scalars['String']>;
};

export type CreateFinixMerchantGraphQlType = {
  __typename?: 'CreateFinixMerchantGraphQLType';
  id?: Maybe<Scalars['String']>;
};

export type CreateReferralPayload = {
  __typename?: 'CreateReferralPayload';
  id?: Maybe<Scalars['Int']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateReferrerGraphQlType = {
  __typename?: 'CreateReferrerGraphQLType';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id?: Maybe<Scalars['Int']>;
  email_sent_instrument_expired_at?: Maybe<Scalars['DateTime']>;
  email_sent_welcome_at?: Maybe<Scalars['DateTime']>;
  finix_identity?: Maybe<Scalars['String']>;
  finix_instrument?: Maybe<Scalars['String']>;
  finix_merchant?: Maybe<Scalars['String']>;
  finix_verify?: Maybe<Scalars['String']>;
  flow_starts?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  instrument_brand?: Maybe<Scalars['String']>;
  instrument_exp_mo?: Maybe<Scalars['String']>;
  instrument_exp_yr?: Maybe<Scalars['String']>;
  instrument_expired?: Maybe<Scalars['Boolean']>;
  instrument_last_four?: Maybe<Scalars['String']>;
  instrument_type?: Maybe<Scalars['String']>;
  opted_in_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  url_views?: Maybe<Scalars['Int']>;
};

export type CreateTieDownInput = {
  deal_id: Scalars['ID'];
  items: Array<TieDownItemInput>;
  note?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<ProductSlug>>;
  ready_to_sign_today: Scalars['Boolean'];
};

export type CreateTransactionInput = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<TtConditionFilterInput>;
  parameters?: InputMaybe<TtFeesInput>;
  processor?: InputMaybe<Processor>;
  state?: InputMaybe<StateAbbreviation>;
  types?: InputMaybe<Array<InputMaybe<TtProductType>>>;
  userEmail?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  auth0Roles: Array<InputMaybe<Auth0RoleInput>>;
  email: Scalars['String'];
  huntGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location?: InputMaybe<LocationType>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  recruiterId?: InputMaybe<Scalars['String']>;
};

export type CreditAppInput = {
  cobuyer?: InputMaybe<CustomerInput>;
  contact?: InputMaybe<DealContactInput>;
  customer: CustomerInput;
  financial_info: FinancialInfoInput;
  id: Scalars['ID'];
  odometer_status?: InputMaybe<OdometerStatus>;
  original_lessee?: InputMaybe<OriginalLesseeInput>;
  second_contact?: InputMaybe<DealContactInput>;
  state: Scalars['String'];
};

export type CreditApplicationSubmission = {
  __typename?: 'CreditApplicationSubmission';
  created_at?: Maybe<Scalars['DateTime']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type CreditApplicationSubmissionFilter = {
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CreditDecisionCreatedPayload = {
  __typename?: 'CreditDecisionCreatedPayload';
  creditDecisionId: Scalars['ID'];
  dealId: Scalars['ID'];
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum CustomDateKeyEnum {
  AtAuction = 'at_auction',
  Booted = 'booted',
  Closed = 'closed',
  Closing = 'closing',
  DownPaymentReceived = 'down_payment_received',
  DownPaymentScheduled = 'down_payment_scheduled',
  Estimate = 'estimate',
  Finalized = 'finalized',
  Floor = 'floor',
  Funded = 'funded',
  PaidOff = 'paid_off',
  ReadyForPickup = 'ready_for_pickup',
  SendPayoff = 'send_payoff',
  SentToAudit = 'sent_to_audit',
  SentToBank = 'sent_to_bank',
  SentToProcessor = 'sent_to_processor',
  Signatures = 'signatures',
  Signed = 'signed',
  SoftClose = 'soft_close',
  Sold = 'sold',
  Structuring = 'structuring',
  StructuringInProgress = 'structuring_in_progress',
  TemporaryRegistrationTagsExpirationDate = 'temporary_registration_tags_expiration_date',
  TemporaryRegistrationTagsSentDate = 'temporary_registration_tags_sent_date',
  TitleReceived = 'title_received',
  TitleSent = 'title_sent',
  WaitingForTitle = 'waiting_for_title',
  WetSigReceivedDate = 'wet_sig_received_date',
  WetSigSentDate = 'wet_sig_sent_date'
}

export type CustomDateUpdatedPayload = {
  __typename?: 'CustomDateUpdatedPayload';
  date?: Maybe<Scalars['DateTime']>;
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID'];
};

export type CustomerContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  homePhoneNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  relationToBuyer?: InputMaybe<RelationToBuyerEnum>;
  suffix?: InputMaybe<NameSuffix>;
};

export enum CustomerNotificationCallToActions {
  OpenFrozenOrLockedCreditModal = 'OpenFrozenOrLockedCreditModal'
}

export type CustomerPhoneNumberChange = {
  __typename?: 'CustomerPhoneNumberChange';
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id: Scalars['Int'];
  deal_id: Scalars['Int'];
  /** Customer phone column that changed on the deal. Expected values: phone_number, home_phone_number. */
  field: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  new_value?: Maybe<Scalars['String']>;
  previous_value: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DdSoftPull = {
  __typename?: 'DDSoftPull';
  cobuyer?: Maybe<Prequalification>;
  customer: Prequalification;
};

export type DashboardDealsWithCounts = {
  __typename?: 'DashboardDealsWithCounts';
  deals?: Maybe<Array<Maybe<Deal>>>;
  hasMore?: Maybe<Scalars['Boolean']>;
  stateCounts?: Maybe<Array<Maybe<StateCount>>>;
};

export type DashboardDocumentUpload = {
  __typename?: 'DashboardDocumentUpload';
  deal: Deal;
  fileType: Scalars['String'];
};

export type DateFilter = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
};

export type DayCount = {
  __typename?: 'DayCount';
  count: Scalars['Int'];
  date: Scalars['String'];
};

export enum DealActionIssue {
  ActivePayoffRequest = 'active_payoff_request',
  CalculateGap = 'calculate_gap',
  CalculateKeyReplacement = 'calculate_key_replacement',
  CalculateTireWheel = 'calculate_tire_wheel',
  CalculateVsc = 'calculate_vsc',
  CobuyerCountryMismatch = 'cobuyer_country_mismatch',
  CobuyerRequired = 'cobuyer_required',
  GapPriceLessThanCost = 'gap_price_less_than_cost',
  GoodThroughDateNotInFuture = 'good_through_date_not_in_future',
  IncompleteCobuyerContactInfo = 'incomplete_cobuyer_contact_info',
  IncompleteCobuyerEmploymentInfo = 'incomplete_cobuyer_employment_info',
  IncompleteCobuyerPersonalInfo = 'incomplete_cobuyer_personal_info',
  IncompleteCobuyerResidentialInfo = 'incomplete_cobuyer_residential_info',
  IncompleteContactInfo = 'incomplete_contact_info',
  IncompleteEmploymentInfo = 'incomplete_employment_info',
  IncompletePersonalInfo = 'incomplete_personal_info',
  IncompleteResidentialInfo = 'incomplete_residential_info',
  IncompleteVehicleInfo = 'incomplete_vehicle_info',
  KeyPriceLessThanCost = 'key_price_less_than_cost',
  MarkupAboveMax = 'markup_above_max',
  MissingBank = 'missing_bank',
  MissingDaysToPayment = 'missing_days_to_payment',
  MissingFundingClerk = 'missing_funding_clerk',
  MissingGoodThroughDate = 'missing_good_through_date',
  MissingLienholder = 'missing_lienholder',
  MissingPermission = 'missing_permission',
  MissingPrequalification = 'missing_prequalification',
  MissingTerm = 'missing_term',
  MissingVehiclePayoff = 'missing_vehicle_payoff',
  NoSelectedPackage = 'no_selected_package',
  ScheduledFollowUp = 'scheduled_follow_up',
  SellRateLessThanBuyRate = 'sell_rate_less_than_buy_rate',
  TwPriceLessThanCost = 'tw_price_less_than_cost',
  VehiclePayoffNotGreaterThanZero = 'vehicle_payoff_not_greater_than_zero',
  VscPriceLessThanCost = 'vsc_price_less_than_cost'
}

export type DealActionValidation = {
  __typename?: 'DealActionValidation';
  isValid: Scalars['Boolean'];
  issues?: Maybe<Array<Maybe<DealActionIssue>>>;
};

export type DealActivityLoggedSubscriptionPayload = {
  __typename?: 'DealActivityLoggedSubscriptionPayload';
  dealId: Scalars['Int'];
};

export type DealAssignmentFilter = {
  /** When ownerIds contains exactly the authenticated user, also includes unassigned deals claimable by that user based on their permissions. */
  includeClaimableByCurrentUser?: InputMaybe<Scalars['Boolean']>;
  /** Assignees to match across the selected roles. Omitted or empty means no ownership filter. */
  ownerIds?: InputMaybe<Array<Scalars['String']>>;
  /** Limits which assignment fields are searched when ownerIds are provided. When omitted or empty, all assignment roles are searched. */
  roles?: InputMaybe<Array<DealAssignmentRole>>;
};

export type DealAssignmentLogEntry = {
  __typename?: 'DealAssignmentLogEntry';
  /** Assignment actor identifier. Usually a user ID; can also be system markers: system, historical. */
  assigned_by?: Maybe<Scalars['String']>;
  assigned_by_user?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  /** Assignment role field that changed on the deal. Expected values: setter_id, closer_id, closer2_id, second_turn_financial_specialist_id, title_clerk_id, title_clerk2_id, funding_clerk_id, structuring_manager_id. */
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DealAssignmentLogEntryInput = {
  /** Assignment actor identifier. Usually a user ID; can also be system markers: system, historical. */
  assigned_by?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Assignment role field that changed on the deal. Expected values: setter_id, closer_id, closer2_id, second_turn_financial_specialist_id, title_clerk_id, title_clerk2_id, funding_clerk_id, structuring_manager_id. */
  role?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export enum DealAssignmentRole {
  Advisor = 'advisor',
  FinancialSpecialist1 = 'financialSpecialist1',
  FinancialSpecialist2 = 'financialSpecialist2',
  FundingClerk = 'fundingClerk',
  RegistrationAssistant = 'registrationAssistant',
  StructuringManager = 'structuringManager',
  TitleClerk = 'titleClerk'
}

export type DealContact = {
  __typename?: 'DealContact';
  created_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  opt_out_sent_at?: Maybe<Scalars['DateTime']>;
  phone_number?: Maybe<Scalars['String']>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealContactInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  opt_out_sent_at?: InputMaybe<Scalars['DateTime']>;
  phone_number?: InputMaybe<Scalars['String']>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
};

export type DealDates = {
  __typename?: 'DealDates';
  created_at?: Maybe<Scalars['DateTime']>;
  /** JSON map of custom milestone timestamps. Supports deal state keys plus wet_sig_sent_date, wet_sig_received_date, sent_to_audit, temporary_registration_tags_sent_date, and temporary_registration_tags_expiration_date. */
  custom_dates?: Maybe<Scalars['JSON']>;
  /** JSON map keyed by deal state values with the UTC timestamp of the most recent entry into each state. Unlike deal_states, this does not preserve full transition history. */
  dates?: Maybe<Scalars['JSON']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealDatesInput = {
  /** JSON map of custom milestone timestamps. Supports deal state keys plus wet_sig_sent_date, wet_sig_received_date, sent_to_audit, temporary_registration_tags_sent_date, and temporary_registration_tags_expiration_date. */
  custom_dates?: InputMaybe<Scalars['JSON']>;
  /** JSON map keyed by deal state values with the UTC timestamp of the most recent entry into each state. Unlike deal_states, this does not preserve full transition history. */
  dates?: InputMaybe<Scalars['JSON']>;
  deal_id?: InputMaybe<Scalars['ID']>;
};

export type DealDocument = {
  __typename?: 'DealDocument';
  completedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  dealJacketId?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  docStatCode?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentName?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  signAttributes?: Maybe<Array<Maybe<DealDocumentSignAttribute>>>;
  signatureStatus?: Maybe<DocumentSignatureStatus>;
  wetSignature?: Maybe<Scalars['Boolean']>;
};

export type DealDocumentSignAttribute = {
  __typename?: 'DealDocumentSignAttribute';
  actorName?: Maybe<Scalars['String']>;
  actorType?: Maybe<ActorType>;
  dateCoordinates?: Maybe<Coordinate>;
  dateFieldName?: Maybe<Scalars['String']>;
  initialsType?: Maybe<Scalars['Boolean']>;
  signCaptureTms?: Maybe<Scalars['String']>;
  signFieldName?: Maybe<Scalars['String']>;
  signPadText?: Maybe<Scalars['String']>;
  signRequired?: Maybe<Scalars['Boolean']>;
  signatureCoordinates?: Maybe<Coordinate>;
};

export type DealFinancialFieldChange = {
  __typename?: 'DealFinancialFieldChange';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  /** financial_infos column that was manually edited on the deal. Expected values: base_tax_amount, new_registration_fee. */
  field: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  new_value?: Maybe<Scalars['Float']>;
  previous_value?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DealImported = {
  __typename?: 'DealImported';
  deal_id: Scalars['ID'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type DealIssue = {
  __typename?: 'DealIssue';
  comment: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  resolved_at?: Maybe<Scalars['DateTime']>;
  slug: DealIssueSlug;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealIssueResolutionStatusChanged = {
  __typename?: 'DealIssueResolutionStatusChanged';
  dealId: Scalars['Int'];
  dealIssues: Array<DealIssue>;
};

export enum DealIssueSlug {
  AddressMismatch = 'address_mismatch',
  ContractOutOfBalance = 'contract_out_of_balance',
  DownPaymentDiscrepancy = 'down_payment_discrepancy',
  NameMismatch = 'name_mismatch',
  Other = 'other',
  PayoffChange = 'payoff_change',
  RateChange = 'rate_change',
  SalesTaxIssue = 'sales_tax_issue',
  StructureViolation = 'structure_violation',
  VehicleInfoMismatch = 'vehicle_info_mismatch'
}

export enum DealLockStatus {
  AiCall = 'ai_call',
  CustomerEntry = 'customer_entry',
  MovingToClosing = 'moving_to_closing'
}

export type DealLockStatusSubscriptionPayload = {
  __typename?: 'DealLockStatusSubscriptionPayload';
  dealId: Scalars['Int'];
  lockStatus?: Maybe<DealLockStatus>;
};

export enum DealMediaCustomerTypeEnum {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  Emissions = 'emissions',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  LicensePlate = 'license_plate',
  OdometerPicture = 'odometer_picture',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  Registration = 'registration',
  SafetyInspection = 'safety_inspection',
  SmogInspection = 'smog_inspection',
  VinInspection = 'vin_inspection'
}

export enum DealMediaNoSignatureUploadTypeEnum {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BookSheet = 'book_sheet',
  CpsGuaranteeOfTitle = 'cps_guarantee_of_title',
  CreditApproval = 'credit_approval',
  ElectronicSignatureAttestation = 'electronic_signature_attestation',
  ElectronicSignatureCertification = 'electronic_signature_certification',
  Emissions = 'emissions',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  LicensePlate = 'license_plate',
  OdometerPicture = 'odometer_picture',
  PayoffDocs = 'payoff_docs',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  RateExceptionForm = 'rate_exception_form',
  Registration = 'registration',
  ReleaseOfInterest = 'release_of_interest',
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation',
  SafetyInspection = 'safety_inspection',
  SantanderGuaranteeOfTitle = 'santander_guarantee_of_title',
  SignedDocs = 'signed_docs',
  SmogInspection = 'smog_inspection',
  TitleRelease = 'title_release',
  VinInspection = 'vin_inspection'
}

export enum DealMediaReleaseOfInterestTypeEnum {
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation'
}

export enum DealMediaSourceEnum {
  Customer = 'customer',
  System = 'system',
  User = 'user'
}

export enum DealMediaStateEnum {
  Active = 'active',
  Pending = 'pending'
}

export type DealMovedSubscriptionPayload = {
  __typename?: 'DealMovedSubscriptionPayload';
  dealId: Scalars['Int'];
  rewritesMoney: Scalars['Boolean'];
};

export enum DealNotificationFilter {
  Appointment = 'Appointment',
  Booted = 'Booted',
  Reminder = 'Reminder',
  UnreadTexts = 'UnreadTexts'
}

export type DealPackageConfig = {
  __typename?: 'DealPackageConfig';
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int'];
};

export type DealPackageConfigInput = {
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int'];
};

export type DealPodChange = {
  __typename?: 'DealPodChange';
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  new_pod?: Maybe<Pod>;
  new_pod_id?: Maybe<Scalars['Int']>;
  /** Pod assignment column that changed on the deal. Expected values: pod_id, fs_pod_id, titling_pod_id. */
  pod_type: Scalars['String'];
  previous_pod?: Maybe<Pod>;
  previous_pod_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DealProduct = {
  __typename?: 'DealProduct';
  cost?: Maybe<Scalars['Float']>;
  coverage_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  id: Scalars['Int'];
  is_currently_offered?: Maybe<Scalars['Boolean']>;
  pen_contract_number?: Maybe<Scalars['String']>;
  pen_form_id?: Maybe<Scalars['Int']>;
  pen_rate_id?: Maybe<Scalars['Int']>;
  pen_session_id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  product_catalog?: Maybe<ProductCatalogV2>;
  product_catalog_id: Scalars['Int'];
  tax_amount?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealProductInputV2 = {
  cost: Scalars['Float'];
  coverageType?: InputMaybe<Scalars['String']>;
  penRateId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Float'];
  productCatalogId: Scalars['Int'];
  taxAmount?: InputMaybe<Scalars['Float']>;
  term?: InputMaybe<Scalars['String']>;
};

export type DealProductRateFailure = {
  __typename?: 'DealProductRateFailure';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  slug: ProductSlug;
};

export type DealProductRateInput = {
  cost?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  slug: ProductSlug;
};

export type DealProductRatesResult = {
  __typename?: 'DealProductRatesResult';
  dealProducts: Array<DealProduct>;
  failedSlugs: Array<DealProductRateFailure>;
  paymentOptions: PaymentOptionsV2;
};

export enum DealSortColumn {
  ApprovedDate = 'approved_date',
  CreatedAt = 'created_at',
  CustomerName = 'customer_name',
  DealStage = 'deal_stage',
  DefaultSortDate = 'default_sort_date',
  FollowUpDate = 'follow_up_date',
  LaneArrivalUtc = 'lane_arrival_utc',
  PriorityQueue = 'priority_queue',
  Profit = 'profit',
  TieDownSubmittedAt = 'tie_down_submitted_at',
  UsState = 'us_state'
}

export enum DealSource {
  All = 'all',
  CallIn = 'call_in',
  D2d = 'd2d',
  Outbound = 'outbound',
  Web = 'web'
}

export type DealSourceChange = {
  __typename?: 'DealSourceChange';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  /** Deal source value before/after an update. Persisted values: call-in, d2d, web, outbound. */
  new_source: Scalars['String'];
  /** Deal source value before/after an update. Persisted values: call-in, d2d, web, outbound. */
  previous_source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export enum DealStateEnum {
  AtAuction = 'at_auction',
  Booted = 'booted',
  Closed = 'closed',
  Closing = 'closing',
  Estimate = 'estimate',
  Finalized = 'finalized',
  Floor = 'floor',
  Funded = 'funded',
  PaidOff = 'paid_off',
  ReadyForPickup = 'ready_for_pickup',
  SendPayoff = 'send_payoff',
  SentToProcessor = 'sent_to_processor',
  Signatures = 'signatures',
  Signed = 'signed',
  SoftClose = 'soft_close',
  Sold = 'sold',
  Structuring = 'structuring',
  StructuringInProgress = 'structuring_in_progress',
  TitleReceived = 'title_received',
  TitleSent = 'title_sent',
  WaitingForTitle = 'waiting_for_title'
}

export type DealStats = {
  __typename?: 'DealStats';
  created_at?: Maybe<Scalars['DateTime']>;
  done_count: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  in_progress_count: Scalars['Int'];
  last_computed_at: Scalars['DateTime'];
  manufacturer: Scalars['String'];
  state: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealStatsByManufacturer = {
  __typename?: 'DealStatsByManufacturer';
  done_count: Scalars['Int'];
  in_progress_count: Scalars['Int'];
  last_computed_at: Scalars['DateTime'];
  manufacturer: Scalars['String'];
};

export type DealStatsByState = {
  __typename?: 'DealStatsByState';
  done_count: Scalars['Int'];
  in_progress_count: Scalars['Int'];
  last_computed_at: Scalars['DateTime'];
  state: Scalars['String'];
};

export type DealTieDown = {
  __typename?: 'DealTieDown';
  /** Whether the requesting user may review this deal's tie downs. Deal-level twin of TieDown.can_review: the predicate only depends on the deal and the user, so selecting it here avoids resolving it once per history row. */
  can_review: Scalars['Boolean'];
  current?: Maybe<TieDown>;
  history: Array<TieDown>;
};

export enum DealType {
  Acquisition = 'acquisition',
  Buyout = 'buyout',
  Marketplace = 'marketplace',
  Refi = 'refi'
}

export type DealTypeChange = {
  __typename?: 'DealTypeChange';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  /** Deal type value before/after an update. Expected values: marketplace, buyout, refi, acquisition. */
  new_type: Scalars['String'];
  /** Deal type value before/after an update. Expected values: marketplace, buyout, refi, acquisition. */
  previous_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DealUnreadMessageCount = {
  __typename?: 'DealUnreadMessageCount';
  byRecipient: Array<RecipientUnreadCount>;
  missedCallCount: Scalars['Int'];
  totalUnread: Scalars['Int'];
};

export type DealWithErrors = {
  __typename?: 'DealWithErrors';
  deal?: Maybe<Deal>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Dealer = {
  __typename?: 'Dealer';
  created_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealsConnection = {
  __typename?: 'DealsConnection';
  items: Array<Maybe<Deal>>;
  pagination: Pagination;
  total: Scalars['Int'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type DealsFilter = {
  /** Only deals with an actioned tie down (approved, countered, or declined) on a pod the current user leads, or on any deal with See:All FS Pods, excluding signed and dead deals. */
  actionedTieDownReview?: InputMaybe<Scalars['Boolean']>;
  approved_date?: InputMaybe<DateFilter>;
  assignment?: InputMaybe<DealAssignmentFilter>;
  banks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  completion_date?: InputMaybe<DateFilter>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['GUID']>>>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  created_at?: InputMaybe<DateFilter>;
  excludeScheduledFollowUps?: InputMaybe<Scalars['Boolean']>;
  fsPodIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Only deals routed to an FS pod the current user belongs to, regardless of assignee. See:All FS Pods removes the pod restriction, including deals without an FS pod. */
  fsPodScoped?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isFinalized?: InputMaybe<Scalars['Boolean']>;
  leaseIds?: InputMaybe<Array<InputMaybe<Scalars['GUID']>>>;
  notifications?: InputMaybe<Array<DealNotificationFilter>>;
  payoffLienholderSlugs?: InputMaybe<Array<LienholderSlugEnum>>;
  /** Only deals awaiting financial specialist assignment (closer and closer2 unset), routed to an FS pod the current user belongs to (all FS pods with See:All FS Pods). */
  pendingFsAssignment?: InputMaybe<Scalars['Boolean']>;
  /** Deals awaiting FS assignment, plus uncalled deals from Closing through Signed, routed to an FS pod the current user belongs to (all FS pods with See:All FS Pods). FS-assigned deals stay until their first customer call. */
  pendingFsContact?: InputMaybe<Scalars['Boolean']>;
  /** Only deals with a pending tie down on a pod the current user leads, or on any deal with See:All FS Pods. */
  pendingTieDownReview?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchValue?: InputMaybe<Scalars['String']>;
  selectedProducts?: InputMaybe<Array<InputMaybe<ProductSlug>>>;
  /** true for deals handed to the bank (the Bank lane), false for those not yet sent (the Signed lane). Omit to include both. */
  sentToBank?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<DealSource>;
  sources?: InputMaybe<Array<InputMaybe<DealSource>>>;
  state?: InputMaybe<Array<InputMaybe<DealStateEnum>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<DealType>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
  updated_at?: InputMaybe<DateFilter>;
  usStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum DecisionStipulation {
  BankruptcyDischargeRequired = 'bankruptcy_discharge_required',
  BuyersOrderRequired = 'buyers_order_required',
  EmploymentVerificationRequired = 'employment_verification_required',
  InsuranceRequired = 'insurance_required',
  PoiRequired = 'poi_required',
  PorRequired = 'por_required',
  ValidIdRequired = 'valid_id_required'
}

export type DeleteFinixInstrumentGraphQlType = {
  __typename?: 'DeleteFinixInstrumentGraphQLType';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DobSsnInput = {
  dob?: InputMaybe<Scalars['Date']>;
  ssn?: InputMaybe<Scalars['String']>;
};

export type DocumentCategories = {
  __typename?: 'DocumentCategories';
  driver_files: DocumentCategory;
  miscellaneous: DocumentCategory;
  release_of_interest: DocumentCategory;
  signature_documents: DocumentCategory;
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  deal_id: Scalars['ID'];
  documents?: Maybe<Array<EnhancedDealMedia>>;
  id: DocumentCategoryId;
  progress: Scalars['Int'];
  total: Scalars['Int'];
  uploaded: Scalars['Int'];
  verified: Scalars['Int'];
};

export enum DocumentCategoryId {
  DriverFiles = 'driver_files',
  Miscellaneous = 'miscellaneous',
  ReleaseOfInterest = 'release_of_interest',
  SignatureDocuments = 'signature_documents'
}

export type DocumentInfo = {
  __typename?: 'DocumentInfo';
  adobe_agreement_id?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  sent_at?: Maybe<Scalars['DateTime']>;
  signed_at?: Maybe<Scalars['DateTime']>;
  type?: Maybe<DocumentInfoType>;
};

export type DocumentInfoInput = {
  adobe_agreement_id?: InputMaybe<Scalars['String']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<DocumentInfoType>;
};

export enum DocumentInfoType {
  Customer = 'customer',
  Roi = 'roi'
}

export type DocumentPreparationProgress = {
  __typename?: 'DocumentPreparationProgress';
  dealId: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  mediaLabel: Scalars['String'];
  mediaType: DealMediaTypeEnum;
  status: DocumentPreparationStatus;
};

export type DocumentPreparationProgressSubscriptionArgs = {
  dealId: Scalars['Int'];
  mediaType: DealMediaTypeEnum;
};

export enum DocumentPreparationStatus {
  Error = 'Error',
  Generated = 'Generated',
  PendingGeneration = 'PendingGeneration',
  PendingUpload = 'PendingUpload',
  Uploaded = 'Uploaded'
}

export enum DocumentProgressStatus {
  Failed = 'failed',
  GenerateDocuments = 'generate_documents',
  PendingLender = 'pending_lender',
  PendingR1 = 'pending_r1',
  ReadyForSignatures = 'ready_for_signatures',
  Required = 'required',
  SentForSignatures = 'sent_for_signatures',
  Signed = 'signed',
  UploadDocuments = 'upload_documents'
}

export enum DocumentSignatureStatus {
  Completed = 'completed',
  InProcess = 'in_process',
  Unstarted = 'unstarted'
}

export type DocumentationRequirements = {
  __typename?: 'DocumentationRequirements';
  bankruptcy_discharge_required?: Maybe<Scalars['Boolean']>;
  buyers_order_required?: Maybe<Scalars['Boolean']>;
  employment_verification_required?: Maybe<Scalars['Boolean']>;
  insurance_required?: Maybe<Scalars['Boolean']>;
  poi_required?: Maybe<Scalars['Boolean']>;
  por_required?: Maybe<Scalars['Boolean']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
  valid_id_required?: Maybe<Scalars['Boolean']>;
};

export type DownPaymentReceived = {
  __typename?: 'DownPaymentReceived';
  amount: Scalars['Float'];
  dealId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type: Scalars['String'];
};

export type DriversLicenseGql = {
  __typename?: 'DriversLicenseGQL';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum DuplicateTypeEnum {
  CustomerOnly = 'customer_only',
  Entire = 'entire'
}

export type DuplicatedDealImport = {
  __typename?: 'DuplicatedDealImport';
  deal_id: Scalars['ID'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type DuplicatedInfo = {
  __typename?: 'DuplicatedInfo';
  deal_id: Scalars['ID'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  state: Scalars['String'];
};

export type EmbeddedInsuranceNotification = {
  __typename?: 'EmbeddedInsuranceNotification';
  customer_id: Scalars['ID'];
  deal_id: Scalars['ID'];
  filename?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum EmployerPhoneLookupForm {
  BuyerCurrent = 'BUYER_CURRENT',
  BuyerPrevious = 'BUYER_PREVIOUS',
  CobuyerCurrent = 'COBUYER_CURRENT',
  CobuyerPrevious = 'COBUYER_PREVIOUS'
}

export type EmployerPhoneLookupInput = {
  city: Scalars['String'];
  employerName: Scalars['String'];
  form: EmployerPhoneLookupForm;
  selfEmployed?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
  temporaryInfoId: Scalars['ID'];
  userPhone?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type EmployerPhoneLookupResult = {
  __typename?: 'EmployerPhoneLookupResult';
  phoneNumber?: Maybe<Scalars['String']>;
  source: EmployerPhoneLookupSource;
};

export enum EmployerPhoneLookupSource {
  GooglePlaces = 'GOOGLE_PLACES',
  NotFound = 'NOT_FOUND',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type EmploymentInfoInput = {
  customerId?: InputMaybe<Scalars['Int']>;
  dealId: Scalars['Int'];
  employment?: InputMaybe<EmploymentInputV2>;
  prevEmployment?: InputMaybe<EmploymentInputV2>;
};

export type EmploymentInputV2 = {
  grossIncome?: InputMaybe<Scalars['Float']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  monthsAtJob?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  payFrequency?: InputMaybe<IncomeIntervalEnum>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  yearsAtJob?: InputMaybe<Scalars['Int']>;
};

export enum EmploymentStatusEnum {
  Employed = 'employed',
  NotEmployed = 'not_employed',
  Retired = 'retired'
}

export enum EmploymentTypeEnum {
  Current = 'current',
  Previous = 'previous'
}

export type EnhancedDealMedia = {
  __typename?: 'EnhancedDealMedia';
  calculated?: Maybe<EnhancedDealMediaCalculatedFields>;
  created_at?: Maybe<Scalars['DateTime']>;
  cudl_document_id?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['ID']>;
  generation_batch?: Maybe<Scalars['DateTime']>;
  has_verified_digital_signature?: Maybe<Scalars['Boolean']>;
  has_wet_signature?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  is_notarized?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  r1_document_id?: Maybe<Scalars['String']>;
  signed_url?: Maybe<Scalars['String']>;
  source?: Maybe<DealMediaSourceEnum>;
  state?: Maybe<DealMediaStateEnum>;
  type?: Maybe<DealMediaTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
  uploaded_by?: Maybe<User>;
  uploaded_by_user_id?: Maybe<Scalars['String']>;
  uploaded_via_com?: Maybe<Scalars['Boolean']>;
  verified?: Maybe<Scalars['Boolean']>;
  wet_signature_required?: Maybe<Scalars['Boolean']>;
};

export type EnhancedDealMediaCalculatedFields = {
  __typename?: 'EnhancedDealMediaCalculatedFields';
  fileName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  verificationRules?: Maybe<Array<Maybe<TtValidationName>>>;
};

export type ExperianOutput = {
  __typename?: 'ExperianOutput';
  errors?: Maybe<Array<Scalars['String']>>;
  riskModel?: Maybe<ExperianRiskModel>;
};

export type ExperianRiskModel = {
  __typename?: 'ExperianRiskModel';
  score?: Maybe<Scalars['String']>;
};

export type ExternalCustomerInput = {
  dashboard_visited?: InputMaybe<Scalars['Boolean']>;
  last_authenticated_route?: InputMaybe<Scalars['String']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
};

export type ExternalDealInputType = {
  auto_import_variation?: InputMaybe<AutoImportVariation>;
};

export type ExternalPayoffIntelligenceFieldsInput = {
  address_line?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ExtractedDocumentGql = {
  __typename?: 'ExtractedDocumentGQL';
  documentName?: Maybe<Scalars['ID']>;
  fields?: Maybe<Array<Maybe<ExtractedField>>>;
  key?: Maybe<Scalars['String']>;
};

export type ExtractedField = {
  __typename?: 'ExtractedField';
  confidence?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FeeGql = {
  __typename?: 'FeeGQL';
  baseTaxAmount?: Maybe<Scalars['Float']>;
  docFeeTaxAmount?: Maybe<Scalars['Float']>;
  feeProcessor?: Maybe<Scalars['String']>;
  registrationTransferFee?: Maybe<Scalars['Float']>;
  salesTaxRate?: Maybe<Scalars['Float']>;
  state?: Maybe<StateAbbreviation>;
  taxProcessor?: Maybe<Scalars['String']>;
  totalFeeAmount?: Maybe<Scalars['Float']>;
  warrantyTaxAmount?: Maybe<Scalars['Float']>;
};

export type FetchDealProductRatesInput = {
  dealId: Scalars['Int'];
  productSlugs?: InputMaybe<Array<ProductSlug>>;
};

export type File = {
  __typename?: 'File';
  filename?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  mediaType?: Maybe<DealMediaTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

export type FillMessageTemplateInput = {
  dealId?: InputMaybe<Scalars['ID']>;
  /** The open thread's person id. */
  recipientId?: InputMaybe<Scalars['Int']>;
  recipientPhone: Scalars['String'];
  /** The open thread's person, as markRecipientThreadSeen names it (customer, cobuyer, contact, secondContact, originalLessee). With recipientId it picks {{RECIPIENT}}; without, the party carrying recipientPhone does. */
  recipientType?: InputMaybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type FillMessageTemplateResult = {
  __typename?: 'FillMessageTemplateResult';
  renderedMessage: Scalars['String'];
};

export type FilterType = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  closedDateFrom?: InputMaybe<Scalars['DateTime']>;
  closedDateTo?: InputMaybe<Scalars['DateTime']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  dealStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasTitleReceived?: InputMaybe<Scalars['Boolean']>;
  lienholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  processors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  titleDateFrom?: InputMaybe<Scalars['DateTime']>;
  titleDateTo?: InputMaybe<Scalars['DateTime']>;
  titlingPods?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  usStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vins?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FinancialInfoFilter = {
  dealId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type FinancialInfoInputV2Input = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']>;
  bank_fees?: InputMaybe<Scalars['Float']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']>;
  base_tax_amount?: InputMaybe<Scalars['Float']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']>;
  closer_commission?: InputMaybe<Scalars['Float']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  doc_fee?: InputMaybe<Scalars['Float']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']>;
  first_payment_date?: InputMaybe<Scalars['Date']>;
  money_down?: InputMaybe<Scalars['Float']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']>;
  new_lienholder?: InputMaybe<BankInput>;
  new_registration_fee?: InputMaybe<Scalars['Float']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['Float']>;
  quick_notes?: InputMaybe<Scalars['String']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']>;
  setter_commission?: InputMaybe<Scalars['Float']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
  title_fee?: InputMaybe<Scalars['Float']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']>;
};

export type FinixPaymentInstrumentGraphQlType = {
  __typename?: 'FinixPaymentInstrumentGraphQLType';
  brand?: Maybe<Scalars['String']>;
  card_type?: Maybe<Scalars['String']>;
  expiration_month?: Maybe<Scalars['Int']>;
  expiration_year?: Maybe<Scalars['Int']>;
  last_four?: Maybe<Scalars['String']>;
};

export type FlowCount = {
  __typename?: 'FlowCount';
  count: Scalars['Int'];
  flow: Scalars['String'];
};

export type FsSummaryStats = {
  __typename?: 'FsSummaryStats';
  funded?: Maybe<Scalars['Int']>;
  leads?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
};

export type FsSummaryStatsReply = {
  __typename?: 'FsSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: FsSummaryStats;
};

export type FundingRequirement = {
  __typename?: 'FundingRequirement';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['Int'];
  file?: Maybe<DealMedia>;
  file_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  resolved_at?: Maybe<Scalars['DateTime']>;
  slug: FundingRequirementSlug;
  source: FundingRequirementSource;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type FundingRequirementResolutionStatusChanged = {
  __typename?: 'FundingRequirementResolutionStatusChanged';
  dealId: Scalars['Int'];
  fundingRequirements: Array<FundingRequirement>;
};

export enum FundingRequirementSlug {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BankInterview = 'bank_interview',
  BankruptcyDischargeRequired = 'bankruptcy_discharge_required',
  BankruptcyLetter = 'bankruptcy_letter',
  BuyersOrderRequired = 'buyers_order_required',
  DownPayment = 'down_payment',
  Emissions = 'emissions',
  EmploymentVerificationRequired = 'employment_verification_required',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  InsuranceRequired = 'insurance_required',
  LicensePlate = 'license_plate',
  NameChangeDoc = 'name_change_doc',
  OdometerPicture = 'odometer_picture',
  PayoffVerification = 'payoff_verification',
  PersonalReferences = 'personal_references',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  PoiRequired = 'poi_required',
  PorRequired = 'por_required',
  ProofOfCurrMortgage = 'proof_of_curr_mortgage',
  ProofOfIncome = 'proof_of_income',
  ProofOfIncomeCobuyer = 'proof_of_income_cobuyer',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  ProofOfSsn = 'proof_of_ssn',
  PropertyTaxReceipt = 'property_tax_receipt',
  PurchaseOrder = 'purchase_order',
  Registration = 'registration',
  ReleaseOfInterest = 'release_of_interest',
  SafetyInspection = 'safety_inspection',
  SmogInspection = 'smog_inspection',
  ValidIdRequired = 'valid_id_required',
  VciDocs = 'vci_docs',
  VinInspection = 'vin_inspection'
}

export enum FundingRequirementSource {
  DecisionStipulation = 'decision_stipulation',
  Manual = 'manual',
  RequiredDocument = 'required_document'
}

export type GapLimits = {
  __typename?: 'GAPLimits';
  max_fltv?: Maybe<Scalars['Float']>;
  max_gap_amount?: Maybe<Scalars['Float']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetRelationshipToDealByPhoneNumberResponse = {
  __typename?: 'GetRelationshipToDealByPhoneNumberResponse';
  relationship: Scalars['String'];
};

export type HuntGroup = {
  __typename?: 'HuntGroup';
  created_at?: Maybe<Scalars['DateTime']>;
  default_queue?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  ring_all?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum ImportType {
  AcquisitionAutoImport = 'acquisition_auto_import',
  AcquisitionFlowFinished = 'acquisition_flow_finished',
  Affiliate = 'affiliate',
  AffiliateAutomatic = 'affiliate_automatic',
  AffiliateFromThunder = 'affiliate_from_thunder',
  AffiliateInactivityImport = 'affiliate_inactivity_import',
  AutoStructureConditioned = 'auto_structure_conditioned',
  AutoStructureFailure = 'auto_structure_failure',
  AutoStructureSuccessImmediateImport = 'auto_structure_success_immediate_import',
  AutoStructureTimeout = 'auto_structure_timeout',
  AutomaticAssistant = 'automatic_assistant',
  AutomaticEquity = 'automatic_equity',
  AutomaticPayment = 'automatic_payment',
  Canada = 'canada',
  DocumentsPageFinished = 'documents_page_finished',
  FrozenOrLockedCredit = 'frozen_or_locked_credit',
  InactivityImport = 'inactivity_import',
  LienholderNotApproved = 'lienholder_not_approved',
  ManualImportPostHardPull = 'manual_import_post_hard_pull',
  ManualImportPostSoftPull = 'manual_import_post_soft_pull',
  ManualImportPreSoftPull = 'manual_import_pre_soft_pull',
  MarketingNurturePaymentCalculator = 'marketing_nurture_payment_calculator',
  MarketingNurtureVip = 'marketing_nurture_vip',
  NoKbbValuesFailure = 'no_kbb_values_failure',
  OtherLienholder = 'other_lienholder',
  PayoffRequestFailure = 'payoff_request_failure',
  PayoffRequestSuccess = 'payoff_request_success',
  PiUnavailable = 'pi_unavailable',
  PostHardPullAutoImport = 'post_hard_pull_auto_import',
  SoftPullFailure = 'soft_pull_failure',
  SoftPullFailureAutoImport = 'soft_pull_failure_auto_import',
  SoftPullSuccessAutoImport = 'soft_pull_success_auto_import'
}

export enum IncomeIntervalEnum {
  Annually = 'annually',
  Biweekly = 'biweekly',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type IncrementReferrer = {
  __typename?: 'IncrementReferrer';
  ok: Scalars['Boolean'];
};

export type KbbSelectedOptionsInput = {
  categoryGroup?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lendingOptionPrice?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  removed?: InputMaybe<Scalars['Boolean']>;
  retailOptionPrice?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type KbbSelectedOptionsObject = {
  __typename?: 'KbbSelectedOptionsObject';
  carId?: Maybe<Scalars['Int']>;
  selected_options?: Maybe<Array<Maybe<KbbSelectedOptionsType>>>;
};

export type KbbSelectedOptionsObjectInput = {
  selected_options?: InputMaybe<Array<InputMaybe<KbbSelectedOptionsInput>>>;
};

export enum LeExperianErrorCodeEnum {
  Frozen = 'FROZEN',
  Locked = 'LOCKED',
  NoRecordFound = 'NO_RECORD_FOUND'
}

export type LeadMatch = {
  __typename?: 'LeadMatch';
  address?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last_name?: Maybe<Scalars['String']>;
  line_type?: Maybe<PhoneLineType>;
  match_score: Scalars['Int'];
  middle_name?: Maybe<Scalars['String']>;
  phone_confidence?: Maybe<PhoneConfidence>;
  phone_confidence_score?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LeaseBuyoutStats = {
  __typename?: 'LeaseBuyoutStats';
  mileage?: Maybe<Mileage>;
  money?: Maybe<Money>;
  popularity?: Maybe<Popularity>;
  reliability?: Maybe<Reliability>;
  summary?: Maybe<Summary>;
  time?: Maybe<Time>;
};

export type Lender = {
  __typename?: 'Lender';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum LendingNetwork {
  Cudl = 'CUDL',
  R1 = 'R1'
}

export type LienholderContact = {
  __typename?: 'LienholderContact';
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export enum LienholderRequirement {
  AddressLine = 'addressLine',
  City = 'city',
  Dob = 'dob',
  DobYear = 'dobYear',
  FirstName = 'firstName',
  LastFourSsn = 'lastFourSSN',
  LastName = 'lastName',
  LastSixSsn = 'lastSixSSN',
  Make = 'make',
  Mileage = 'mileage',
  Model = 'model',
  PhoneNumber1 = 'phoneNumber1',
  Ssn = 'ssn',
  State = 'state',
  Vin = 'vin',
  Year = 'year',
  Zip = 'zip'
}

export enum LienholderSlugEnum {
  AcuraFinancialServices = 'acura_financial_services',
  Ally = 'ally',
  AudiFinancialServices = 'audi_financial_services',
  BentleyFinancialServices = 'bentley_financial_services',
  BethpageFcu = 'bethpage_fcu',
  BmwFs = 'bmw_fs',
  CalAutomotive = 'cal_automotive',
  CentennialLending = 'centennial_lending',
  ChaseAutoFinance = 'chase_auto_finance',
  ChrystlerCapitalCcap = 'chrystler_capital_ccap',
  DmAutoLeasing = 'dm_auto_leasing',
  FifthThirdBank = 'fifth_third_bank',
  FordMotorCredit = 'ford_motor_credit',
  FusionAutoFinance = 'fusion_auto_finance',
  GenesisFinance = 'genesis_finance',
  GmFinancial = 'gm_financial',
  HondaFinancialServices = 'honda_financial_services',
  HudsonValleyCu = 'hudson_valley_cu',
  HuntingtonNationalBank = 'huntington_national_bank',
  HyundaiMotorFinance = 'hyundai_motor_finance',
  KiaFinance = 'kia_finance',
  LandRoverFg = 'land_rover_fg',
  LexusFinancialServices = 'lexus_financial_services',
  MazdaFinancialServices = 'mazda_financial_services',
  MclarenFinancialServices = 'mclaren_financial_services',
  MercedesBenzFs = 'mercedes_benz_fs',
  MetroCu = 'metro_cu',
  MichiganStateUniversityFcu = 'michigan_state_university_fcu',
  MiniFs = 'mini_fs',
  Nbt = 'nbt',
  NissanFinance = 'nissan_finance',
  Other = 'other',
  PorchePaymentCenter = 'porche_payment_center',
  RocklandFcu = 'rockland_fcu',
  SantanderConsumerUsa = 'santander_consumer_usa',
  SeToyota = 'se_toyota',
  StellantisFinancialServicesInc = 'stellantis_financial_services_inc',
  SubaruMotorFinance = 'subaru_motor_finance',
  TeachersFcu = 'teachers_fcu',
  TeslaFinance = 'tesla_finance',
  Toyota = 'toyota',
  UsBank = 'us_bank',
  VisionsFcu = 'visions_fcu',
  VolkswagenCredit = 'volkswagen_credit',
  VolvoCarFs = 'volvo_car_fs',
  Westlake = 'westlake'
}

export type LienholderTrackRecord = {
  __typename?: 'LienholderTrackRecord';
  allTimeFundedCount?: Maybe<Scalars['Int']>;
  lienholderFundedCount?: Maybe<Scalars['Int']>;
};

export type LikelyAddress = {
  __typename?: 'LikelyAddress';
  address_line: Scalars['String'];
  address_line_2: Scalars['String'];
  city: Scalars['String'];
  county: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LoanLimits = {
  __typename?: 'LoanLimits';
  max_finance_amount?: Maybe<Scalars['Float']>;
  max_loan_amount?: Maybe<Scalars['Float']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum LocationType {
  Idaho = 'idaho',
  Utah_1 = 'utah_1',
  Utah_2 = 'utah_2'
}

export type MarkAlertsAsSeenInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type MediaSendResult = {
  __typename?: 'MediaSendResult';
  contentType?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
};

export type MediaV2Response = {
  __typename?: 'MediaV2Response';
  categories: DocumentCategories;
  jurisdictionError?: Maybe<Scalars['String']>;
  latestGenerationBatch?: Maybe<Scalars['DateTime']>;
};

export type MergedDocuments = {
  __typename?: 'MergedDocuments';
  filename: Scalars['String'];
  key: Scalars['String'];
  url: Scalars['String'];
};

export type MessageData = {
  __typename?: 'MessageData';
  deals?: Maybe<Array<Maybe<Deal>>>;
  message?: Maybe<Message>;
  messageDetail?: Maybe<MessageDetail>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String'];
  node: MessageV2;
};

export type MessageNotificationsMarkedSeen = {
  __typename?: 'MessageNotificationsMarkedSeen';
  dealIds: Array<Scalars['ID']>;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  body: Scalars['String'];
  category: MessageTemplateCategory;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: MessageTemplateType;
  updated_at?: Maybe<Scalars['DateTime']>;
  use_count: Scalars['Int'];
};

export enum MessageTemplateCategory {
  Funding = 'funding',
  Payoff = 'payoff',
  Reviews = 'reviews',
  Sales = 'sales',
  Structuring = 'structuring',
  Titling = 'titling'
}

export enum MessageTemplateKey {
  ComAfterHoursHeldWelcome = 'com_after_hours_held_welcome',
  ComOptOut = 'com_opt_out',
  ComReferralFriend = 'com_referral_friend',
  ComReferralOwner = 'com_referral_owner',
  ComSignatureReminder = 'com_signature_reminder',
  ComStructuringWelcome = 'com_structuring_welcome',
  SecureLink = 'secure_link',
  TitlingTemporaryTags = 'titling_temporary_tags'
}

export enum MessageTemplateType {
  Email = 'email',
  Text = 'text'
}

export type MessageV2 = {
  __typename?: 'MessageV2';
  body?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** Twilio's error code when the text failed or went undelivered. */
  errorCode?: Maybe<Scalars['Int']>;
  /** Why the text failed or went undelivered, in plain words; null without an error code. */
  errorReason?: Maybe<Scalars['String']>;
  fromCustomer?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  mediaListObj?: Maybe<MediaListObj>;
  sortId?: Maybe<Scalars['Int']>;
  /** Twilio's status for the text, e.g. delivered. */
  status?: Maybe<Scalars['String']>;
  /** The Lease End number on this text: the one it went to, or the one it went out from. */
  textNumber?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type MessagesCursorConnection = {
  __typename?: 'MessagesCursorConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MessagesFilter = {
  dealId?: InputMaybe<Scalars['Int']>;
  dealPhoneNumber: Scalars['String'];
};

/** A phone number that has opted out of messaging with the deal’s sending number. Derived from text_messages at read time. Unrelated to the persons’ opt_out_sent_at column, which records that we sent them the opt-out disclosure. */
export type MessagingOptOut = {
  __typename?: 'MessagingOptOut';
  opted_out_at: Scalars['DateTime'];
  phone_number: Scalars['String'];
};

export type MethodFiAccount = {
  __typename?: 'MethodFiAccount';
  created_at?: Maybe<Scalars['String']>;
  error?: Maybe<MethodFiError>;
  holder_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liability?: Maybe<MethodFiAccountLiability>;
  metadata?: Maybe<Scalars['JSONObject']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  restricted_products?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  update?: Maybe<Scalars['JSONObject']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type MethodFiAccountLiability = {
  __typename?: 'MethodFiAccountLiability';
  fingerprint?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
  mch_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownership?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MethodFiConnect = {
  __typename?: 'MethodFiConnect';
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  error?: Maybe<MethodFiError>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type MethodFiConnectAndRetrieveData = {
  __typename?: 'MethodFiConnectAndRetrieveData';
  accounts?: Maybe<Array<Maybe<MethodFiAccount>>>;
  connectedEntity?: Maybe<MethodFiConnect>;
  entity?: Maybe<MethodFiEntity>;
  vehicles?: Maybe<Array<Maybe<MethodFiVehicle>>>;
};

export type MethodFiEntity = {
  __typename?: 'MethodFiEntity';
  address?: Maybe<MethodFiEntityAddress>;
  available_subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  created_at?: Maybe<Scalars['String']>;
  error?: Maybe<MethodFiError>;
  id: Scalars['String'];
  individual?: Maybe<MethodFiEntityIndividual>;
  metadata?: Maybe<Scalars['JSONObject']>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  restricted_products?: Maybe<Array<Maybe<Scalars['String']>>>;
  restricted_subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  verification?: Maybe<MethodFiEntityVerification>;
};

export type MethodFiEntityAddress = {
  __typename?: 'MethodFiEntityAddress';
  city?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MethodFiEntityIndividual = {
  __typename?: 'MethodFiEntityIndividual';
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  ssn_4?: Maybe<Scalars['String']>;
};

export type MethodFiEntityVerification = {
  __typename?: 'MethodFiEntityVerification';
  identity?: Maybe<MethodFiEntityVerificationIdentity>;
  phone?: Maybe<MethodFiEntityVerificationPhone>;
};

export type MethodFiEntityVerificationIdentity = {
  __typename?: 'MethodFiEntityVerificationIdentity';
  latest_verification_session?: Maybe<Scalars['String']>;
  matched?: Maybe<Scalars['Boolean']>;
  methods?: Maybe<Array<Maybe<Scalars['String']>>>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type MethodFiEntityVerificationPhone = {
  __typename?: 'MethodFiEntityVerificationPhone';
  latest_verification_session?: Maybe<Scalars['String']>;
  methods?: Maybe<Array<Maybe<Scalars['String']>>>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type MethodFiError = {
  __typename?: 'MethodFiError';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  sub_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MethodFiIdentity = {
  __typename?: 'MethodFiIdentity';
  address?: Maybe<MethodFiIdentityAddress>;
  dob?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type MethodFiIdentityAddress = {
  __typename?: 'MethodFiIdentityAddress';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type MethodFiRetrieveIdentitiesData = {
  __typename?: 'MethodFiRetrieveIdentitiesData';
  entity?: Maybe<MethodFiEntity>;
  ssnId?: Maybe<Scalars['String']>;
};

export type MethodFiSessionState = {
  __typename?: 'MethodFiSessionState';
  entity?: Maybe<MethodFiEntity>;
  entityId: Scalars['String'];
  identities?: Maybe<Array<Maybe<MethodFiIdentity>>>;
  tempInfoFormattedData?: Maybe<MethodFiTempInfoFormattedData>;
  vehicles?: Maybe<Array<Maybe<MethodFiVehicle>>>;
};

export type MethodFiTempInfoFormattedData = {
  __typename?: 'MethodFiTempInfoFormattedData';
  address_line?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MethodFiVehicle = {
  __typename?: 'MethodFiVehicle';
  major_color?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type MethodFiVerificationSession = {
  __typename?: 'MethodFiVerificationSession';
  byo_kyc?: Maybe<Scalars['JSONObject']>;
  byo_sms?: Maybe<Scalars['JSONObject']>;
  created_at?: Maybe<Scalars['String']>;
  entity_id: Scalars['String'];
  error?: Maybe<MethodFiError>;
  id: Scalars['String'];
  kba?: Maybe<Scalars['JSONObject']>;
  method?: Maybe<Scalars['String']>;
  sms?: Maybe<Scalars['JSONObject']>;
  sna?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Mileage = {
  __typename?: 'Mileage';
  over_perc: Scalars['Int'];
  score: Scalars['Boolean'];
};

export enum MileageUnit {
  Kilometers = 'kilometers',
  Miles = 'miles'
}

export type Money = {
  __typename?: 'Money';
  equity?: Maybe<Scalars['Float']>;
  replacement?: Maybe<Scalars['Float']>;
  score: Scalars['Boolean'];
};

export type MyAppointmentSlotV2 = {
  __typename?: 'MyAppointmentSlotV2';
  dateUtc: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type NpsSurveyResultInput = {
  deal_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  feedback: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
};

export enum NameSuffix {
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Sr = 'SR',
  V = 'V'
}

export type NavBarTextNotifications = {
  __typename?: 'NavBarTextNotifications';
  booted: Scalars['Boolean'];
  completed: Scalars['Boolean'];
  followUp: Scalars['Boolean'];
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['String'];
  node: Note;
};

export type NoteInputV2 = {
  author_id?: InputMaybe<Scalars['String']>;
  creation_date_tz?: InputMaybe<Scalars['String']>;
  deal_id: Scalars['ID'];
  note_type?: InputMaybe<Scalars['String']>;
  notification_id?: InputMaybe<Scalars['ID']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  recordingid?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type NotesCursorConnection = {
  __typename?: 'NotesCursorConnection';
  edges: Array<NoteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NotesFilter = {
  created_at?: InputMaybe<DateFilter>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<DateFilter>;
};

export type NotificationSubscriber = {
  __typename?: 'NotificationSubscriber';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  subscriber_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type NotificationSubscriberInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  subscriber_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type NotificationUser = {
  __typename?: 'NotificationUser';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  notification_id?: Maybe<Scalars['ID']>;
  seen_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['String']>;
};

export type NotificationUserInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  notification_id?: InputMaybe<Scalars['ID']>;
  seen_at?: InputMaybe<Scalars['DateTime']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export enum OdometerStatus {
  Changed = 'Changed',
  CustomerProvided = 'CustomerProvided',
  Mismatch = 'Mismatch',
  Verified = 'Verified',
  Warning = 'Warning'
}

export type OriginalLessee = {
  __typename?: 'OriginalLessee';
  address_line?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  ssn_id?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['String']>;
};

export type OriginalLesseeInput = {
  address_line?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  ssn_id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OriginalLesseeV2 = {
  __typename?: 'OriginalLesseeV2';
  address_line?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  ssn_id?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['String']>;
};

export type OriginalLesseeV2Input = {
  address_line?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  ssn_id?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Other = {
  __typename?: 'Other';
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OutcomeCount = {
  __typename?: 'OutcomeCount';
  count: Scalars['Int'];
  outcome: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedBootedDeals = {
  __typename?: 'PaginatedBootedDeals';
  results?: Maybe<Array<Maybe<Deal>>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type PaginatedCallHistory = {
  __typename?: 'PaginatedCallHistory';
  calls?: Maybe<Array<Maybe<Call>>>;
  newMissedCallIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type PaginatedDeals = {
  __typename?: 'PaginatedDeals';
  deals?: Maybe<Array<Maybe<Deal>>>;
  dealsMaxAge?: Maybe<Scalars['DateTime']>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  results?: Maybe<Array<Maybe<User>>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum PaperworkType {
  Adobe = 'adobe',
  LeaseEnd = 'lease_end',
  Paper = 'paper',
  RouteOne = 'route_one'
}

export type PatchDealProductPriceItemV2 = {
  cost: Scalars['Float'];
  price: Scalars['Float'];
  productCatalogId: Scalars['Int'];
};

export type PatchDealProductPricesInputV2 = {
  dealId: Scalars['Int'];
  products: Array<PatchDealProductPriceItemV2>;
};

export type PaymentLimits = {
  __typename?: 'PaymentLimits';
  max_payment_amount?: Maybe<Scalars['Float']>;
  max_payment_percentage?: Maybe<Scalars['Float']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentOptionsInput = {
  creditDecisionId?: InputMaybe<Scalars['ID']>;
  dealId?: InputMaybe<Scalars['ID']>;
  bank?: InputMaybe<Scalars['String']>;
  bankFees?: InputMaybe<Scalars['Float']>;
  banks?: InputMaybe<Array<InputMaybe<BankInput>>>;
  baseTaxAmount?: InputMaybe<Scalars['Float']>;
  buyRate?: InputMaybe<Scalars['Float']>;
  carMileage?: InputMaybe<Scalars['Int']>;
  carYear?: InputMaybe<Scalars['Int']>;
  clientName?: InputMaybe<Scalars['String']>;
  closer2Id?: InputMaybe<Scalars['String']>;
  closerId?: InputMaybe<Scalars['String']>;
  customerState?: InputMaybe<Scalars['String']>;
  daysToPayment?: InputMaybe<Scalars['Int']>;
  docFee?: InputMaybe<Scalars['Float']>;
  gapCost?: InputMaybe<Scalars['Float']>;
  gapPrice?: InputMaybe<Scalars['Float']>;
  lienholder?: InputMaybe<Scalars['String']>;
  moneyDown?: InputMaybe<Scalars['Float']>;
  newRegistrationFee?: InputMaybe<Scalars['Float']>;
  prequalificationCreditScore?: InputMaybe<Scalars['Int']>;
  registrationTransferFee?: InputMaybe<Scalars['Float']>;
  sellRate?: InputMaybe<Scalars['Float']>;
  setterId?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
  tier?: InputMaybe<Scalars['String']>;
  titleFee?: InputMaybe<Scalars['Float']>;
  titleRegistrationOption?: InputMaybe<TitleRegistrationOption>;
  userEnteredReserve?: InputMaybe<Scalars['Float']>;
  vehiclePayoff?: InputMaybe<Scalars['Float']>;
  vscCost?: InputMaybe<Scalars['Float']>;
  vscPrice?: InputMaybe<Scalars['Float']>;
  warrantyTaxAmount?: InputMaybe<Scalars['Float']>;
};

export type PaymentOptionsPackageProductV2 = {
  __typename?: 'PaymentOptionsPackageProductV2';
  cost: Scalars['Float'];
  price: Scalars['Float'];
  productCatalogId?: Maybe<Scalars['Int']>;
  slug: ProductSlug;
  taxAmount: Scalars['Float'];
};

export type PaymentOptionsPackageV2 = {
  __typename?: 'PaymentOptionsPackageV2';
  amountFinanced: Scalars['Float'];
  buyPayment: Scalars['Float'];
  closerCommission: Scalars['Float'];
  isSelected: Scalars['Boolean'];
  legacyOptionType: Scalars['String'];
  products: Array<PaymentOptionsPackageProductV2>;
  profit: Scalars['Float'];
  reserve: Scalars['Float'];
  selectedProductSlugs: Array<ProductSlug>;
  sellPayment: Scalars['Float'];
  setterCommission: Scalars['Float'];
  slotIndex: Scalars['Int'];
};

export type PaymentOptionsV2Input = {
  dealId: Scalars['Int'];
  overrides?: InputMaybe<PaymentOptionsV2OverridesInput>;
  packageConfigs?: InputMaybe<Array<DealPackageConfigInput>>;
};

export type PaymentOptionsV2OverridesInput = {
  bank?: InputMaybe<Scalars['String']>;
  bankFees?: InputMaybe<Scalars['Float']>;
  baseTaxAmount?: InputMaybe<Scalars['Float']>;
  buyRate?: InputMaybe<Scalars['Float']>;
  carMileage?: InputMaybe<Scalars['Int']>;
  carYear?: InputMaybe<Scalars['Int']>;
  daysToPayment?: InputMaybe<Scalars['Int']>;
  docFee?: InputMaybe<Scalars['Float']>;
  moneyDown?: InputMaybe<Scalars['Float']>;
  newRegistrationFee?: InputMaybe<Scalars['Float']>;
  prequalificationCreditScore?: InputMaybe<Scalars['Int']>;
  productOverrides?: InputMaybe<Array<PaymentOptionsV2ProductOverrideInput>>;
  registrationTransferFee?: InputMaybe<Scalars['Float']>;
  sellRate?: InputMaybe<Scalars['Float']>;
  term?: InputMaybe<Scalars['Int']>;
  tier?: InputMaybe<Scalars['String']>;
  titleFee?: InputMaybe<Scalars['Float']>;
  titleRegistrationOption?: InputMaybe<TitleRegistrationOption>;
  userEnteredReserve?: InputMaybe<Scalars['Float']>;
  vehiclePayoff?: InputMaybe<Scalars['Float']>;
  warrantyTaxAmount?: InputMaybe<Scalars['Float']>;
};

export type PaymentOptionsV2ProductOverrideInput = {
  cost?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productCatalogId?: InputMaybe<Scalars['Int']>;
  productSlug?: InputMaybe<ProductSlug>;
  taxAmount?: InputMaybe<Scalars['Float']>;
};

export type PayoffChange = {
  __typename?: 'PayoffChange';
  created_at?: Maybe<Scalars['DateTime']>;
  double_tax_applied?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  payoff_id?: Maybe<Scalars['Int']>;
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']>;
  sales_tax_from_payoff?: Maybe<Scalars['Float']>;
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
};

export type PayoffChangeInput = {
  double_tax_applied?: InputMaybe<Scalars['Boolean']>;
  payoff_id?: InputMaybe<Scalars['Int']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']>;
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
};

export type PayoffQueue = {
  __typename?: 'PayoffQueue';
  items: Array<PayoffQueueItem>;
  pagination: Pagination;
  total: Scalars['Int'];
};

/** Minimal payoff request tile, backed by either a deal or temporary info. */
export type PayoffQueueItem = {
  __typename?: 'PayoffQueueItem';
  createdAt: Scalars['DateTime'];
  customerName: Scalars['String'];
  dealId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lienholderName: Scalars['String'];
  needsPayoffDocuments?: Maybe<Scalars['Boolean']>;
  payoffClerkId?: Maybe<Scalars['String']>;
  payoffDocumentsUploaded?: Maybe<Scalars['Boolean']>;
  status: PayoffRequestStatus;
  temporaryInfoId?: Maybe<Scalars['ID']>;
  vehicleDescription: Scalars['String'];
};

export type PayoffQueueUpdate = {
  __typename?: 'PayoffQueueUpdate';
  id: Scalars['ID'];
};

export type PayoffRequestStatusUpdateV2 = {
  __typename?: 'PayoffRequestStatusUpdateV2';
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']>;
  status?: Maybe<PayoffRequestStatus>;
};

export type PayoffRequestStatusUpdateV2WithMessage = {
  __typename?: 'PayoffRequestStatusUpdateV2WithMessage';
  message?: Maybe<Scalars['String']>;
  payoffRequest: PayoffRequestStatusUpdateV2;
};

export type PayoffUpdateV2Result = {
  __typename?: 'PayoffUpdateV2Result';
  paymentOptions: PaymentOptionsV2;
  payoff: Payoff;
};

export type PersonalInfoInput = {
  customerId?: InputMaybe<Scalars['Int']>;
  dealId: Scalars['Int'];
  personalInfo?: InputMaybe<DobSsnInput>;
};

export enum PhoneConfidence {
  High = 'high',
  Highest = 'highest',
  Low = 'low',
  Lowest = 'lowest',
  Medium = 'medium'
}

export enum PhoneLineType {
  FixedVoip = 'fixedVoip',
  Landline = 'landline',
  Mobile = 'mobile',
  Other = 'other',
  Voip = 'voip'
}

export enum PhoneType {
  Home = 'Home',
  Mobile = 'Mobile'
}

export type PhotoToken = {
  __typename?: 'PhotoToken';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['ID'];
  expires_at: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  token: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type PhotoTokenValidationResult = {
  __typename?: 'PhotoTokenValidationResult';
  authToken: Scalars['String'];
  dealId: Scalars['ID'];
};

export type PodSummaryStats = {
  __typename?: 'PodSummaryStats';
  arpa?: Maybe<Scalars['Float']>;
  assigned?: Maybe<Scalars['Int']>;
  closePercentage?: Maybe<Scalars['Float']>;
  funded?: Maybe<Scalars['Int']>;
  gapPercentage?: Maybe<Scalars['Float']>;
  revenue?: Maybe<Scalars['Float']>;
  rpt?: Maybe<Scalars['Float']>;
  signed?: Maybe<Scalars['Int']>;
  vscPercentage?: Maybe<Scalars['Float']>;
};

export type PodSummaryStatsReply = {
  __typename?: 'PodSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: PodSummaryStats;
};

export type Popularity = {
  __typename?: 'Popularity';
  make?: Maybe<Scalars['Float']>;
  make_perc?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['Float']>;
  model_perc?: Maybe<Scalars['Float']>;
  score: Scalars['Boolean'];
};

export type PrequalificationCheck = {
  __typename?: 'PrequalificationCheck';
  key: Scalars['String'];
  label: Scalars['String'];
  passed: Scalars['Boolean'];
  requiredForAutostructure: Scalars['Boolean'];
  value: Scalars['String'];
};

export type PrequalificationCreditReport = {
  __typename?: 'PrequalificationCreditReport';
  addresses?: Maybe<Array<PrequalificationCreditReportAddress>>;
  employments?: Maybe<Array<PrequalificationCreditReportEmployment>>;
  informationalMessages?: Maybe<Array<Scalars['String']>>;
  names?: Maybe<PrequalificationCreditReportNames>;
  scoreFactors?: Maybe<Array<PrequalificationCreditScoreScoreFactor>>;
  tradelines?: Maybe<PrequalificationCreditReportTradelines>;
};

export type PrequalificationCreditReportAddress = {
  __typename?: 'PrequalificationCreditReportAddress';
  city?: Maybe<Scalars['String']>;
  firstReportedDate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetPrefix?: Maybe<Scalars['String']>;
  streetSuffix?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PrequalificationCreditReportEmployment = {
  __typename?: 'PrequalificationCreditReportEmployment';
  addressExtraLine?: Maybe<Scalars['String']>;
  addressFirstLine?: Maybe<Scalars['String']>;
  addressSecondLine?: Maybe<Scalars['String']>;
  firstReportedDate?: Maybe<Scalars['String']>;
  lastUpdatedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PrequalificationCreditReportName = {
  __typename?: 'PrequalificationCreditReportName';
  firstName: Scalars['String'];
  generationCode?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  secondSurname?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PrequalificationCreditReportNames = {
  __typename?: 'PrequalificationCreditReportNames';
  aliases: Array<Maybe<PrequalificationCreditReportName>>;
  customerName?: Maybe<PrequalificationCreditReportName>;
};

export type PrequalificationCreditReportTradeline = {
  __typename?: 'PrequalificationCreditReportTradeline';
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  amount1?: Maybe<Scalars['String']>;
  amount1Qualifier?: Maybe<Scalars['String']>;
  amount2?: Maybe<Scalars['String']>;
  amount2Qualifier?: Maybe<Scalars['String']>;
  amountPastDue?: Maybe<Scalars['String']>;
  balanceAmount?: Maybe<Scalars['String']>;
  balanceDate?: Maybe<Scalars['String']>;
  delinquency30Days?: Maybe<Scalars['String']>;
  delinquency60Days?: Maybe<Scalars['String']>;
  delinquency90to180Days?: Maybe<Scalars['String']>;
  ecoa?: Maybe<Scalars['String']>;
  kob?: Maybe<Scalars['String']>;
  monthlyPaymentAmount?: Maybe<Scalars['String']>;
  monthsHistory?: Maybe<Scalars['String']>;
  openDate?: Maybe<Scalars['String']>;
  openOrClosed?: Maybe<Scalars['String']>;
  paymentHistory?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriberName?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type PrequalificationCreditReportTradelines = {
  __typename?: 'PrequalificationCreditReportTradelines';
  installment: Array<PrequalificationCreditReportTradeline>;
  revolving: Array<PrequalificationCreditReportTradeline>;
  unknown: Array<PrequalificationCreditReportTradeline>;
};

export type PrequalificationCreditReports = {
  __typename?: 'PrequalificationCreditReports';
  cobuyer?: Maybe<PrequalificationCreditReport>;
  customer: PrequalificationCreditReport;
};

export type PrequalificationCreditScoreScoreFactor = {
  __typename?: 'PrequalificationCreditScoreScoreFactor';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PrequalificationRequest = {
  __typename?: 'PrequalificationRequest';
  first_name?: Maybe<Scalars['String']>;
  gross_income?: Maybe<Scalars['Float']>;
  income_sources?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  lending_book_value?: Maybe<Scalars['Float']>;
  money_down?: Maybe<Scalars['Float']>;
  pay_frequency?: Maybe<Scalars['String']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
  zip?: Maybe<Scalars['String']>;
};

export type PrequalificationStatus = {
  __typename?: 'PrequalificationStatus';
  can_run: Scalars['Boolean'];
  checks: Array<PrequalificationCheck>;
  retry_notice?: Maybe<Scalars['String']>;
  validation_errors: Array<Scalars['String']>;
};

export type PreviousDeal = {
  __typename?: 'PreviousDeal';
  customerName: Scalars['String'];
  dealId: Scalars['Int'];
  lastSeenAt: Scalars['DateTime'];
  /** Whose number it was on that deal; null when only calls tie it to the deal. */
  party?: Maybe<Scalars['String']>;
};

export type PriorCobuyer = {
  __typename?: 'PriorCobuyer';
  cobuyer: CreditApplicationBuyer;
  creditApplicationId: Scalars['ID'];
  provider: LendingNetwork;
  relationshipToBuyer?: Maybe<RelationToBuyerEnum>;
  submittedAt: Scalars['DateTime'];
};

export type PriorityQueueUpdate = {
  __typename?: 'PriorityQueueUpdate';
  dealId: Scalars['Int'];
  followUpStatus?: Maybe<FollowUpStatusEnum>;
  previousFollowUpStatus?: Maybe<FollowUpStatusEnum>;
  previousState?: Maybe<DealStateEnum>;
  reason: Scalars['String'];
  state: DealStateEnum;
};

export enum Processor {
  Atc = 'Atc',
  DlrDmv = 'DlrDmv',
  TaterTitle = 'TaterTitle',
  Vitu = 'Vitu'
}

export type ProductCatalogV2 = {
  __typename?: 'ProductCatalogV2';
  base_cost: Scalars['Float'];
  base_price: Scalars['Float'];
  bonus_amount: Scalars['Float'];
  display_order: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_user_selectable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  slug: ProductSlug;
};

export enum ProductSlug {
  AllyLimitedWarranty = 'ally_limited_warranty',
  Gap = 'gap',
  KeyReplacement = 'key_replacement',
  Maintenance = 'maintenance',
  TireWheel = 'tire_wheel',
  Vsc = 'vsc'
}

export type ProviderDecisionData = CudlVehicleLoanApplication | R1CreditDecisionData;

export type Query = {
  __typename?: 'Query';
  acquisitionOffer?: Maybe<AcquisitionOffer>;
  addressDetail?: Maybe<AddressDetail>;
  /** Returns the advisor bar's stats for the chosen pool and time frame. */
  advisorSummaryStatsV2: AdvisorSummaryStatsReply;
  affiliateByPhoneNumber?: Maybe<Affiliate>;
  affiliateDetails?: Maybe<Affiliate>;
  affiliateProviders?: Maybe<Array<Maybe<AffiliateProviderRead>>>;
  aiCallPayload?: Maybe<AiCallPayload>;
  alerts: AlertsConnection;
  articleImageUploadUrl?: Maybe<ArticleImageUploadUrl>;
  articles?: Maybe<Array<Maybe<Article>>>;
  auctionAverageTransportCost?: Maybe<Scalars['Int']>;
  auctionDistances?: Maybe<AuctionDistances>;
  auctions?: Maybe<Array<Maybe<Auction>>>;
  bankInfo?: Maybe<Bank>;
  bankLogo?: Maybe<Scalars['String']>;
  banks?: Maybe<Array<Maybe<Bank>>>;
  bookmarkedDeals: Array<Deal>;
  calculateOptions?: Maybe<Array<Maybe<KbbOption>>>;
  call?: Maybe<Call>;
  callInProgress?: Maybe<Conference>;
  carDetailLicensePlate?: Maybe<Car>;
  carDetailVin?: Maybe<Car>;
  carDistinctMake?: Maybe<Array<Maybe<CarDistinctMake>>>;
  carDistinctModel?: Maybe<Array<Maybe<CarDistinctModel>>>;
  cbbValues?: Maybe<CbbValuation>;
  cbbVin: CbbTrimResult;
  checkAffiliateDealExists?: Maybe<Scalars['Boolean']>;
  checkExistingAccountByEmail?: Maybe<Scalars['Boolean']>;
  checkExistingAccountHasPassword?: Maybe<Scalars['Boolean']>;
  checkFlowStatus?: Maybe<FlowStatus>;
  checkPayoffRequestRequirements: CheckPayoffRequestRequirementsResponse;
  checkSupportedLienholder: SupportedLienholderResponse;
  communicationHistoryV2: CommunicationHistoryConnection;
  comparePrequalSocials?: Maybe<ComparePrequalSocials>;
  completedDeals?: Maybe<PaginatedDeals>;
  consentOptOutLookup: Array<ConsentBasis>;
  conversationInboxThread: ConversationSummary;
  conversationsInbox: ConversationsInboxConnection;
  createFetchUrlsFromCom: Array<Scalars['String']>;
  createReferral?: Maybe<CreateReferralPayload>;
  createReferrer?: Maybe<CreateReferrerGraphQlType>;
  creditApplicationSubmissions: Array<Maybe<CreditApplicationSubmission>>;
  creditApplicationV2?: Maybe<CreditApplication>;
  creditDecisionV2?: Maybe<CreditDecision>;
  currentConsentAgreementText?: Maybe<ConsentAgreement>;
  customer?: Maybe<Customer>;
  customerNotifications?: Maybe<Array<Maybe<CustomerNotification>>>;
  dashboardDeals?: Maybe<DashboardDealsWithCounts>;
  deal?: Maybe<Deal>;
  dealAdvisors?: Maybe<Deal>;
  dealContractDistribution?: Maybe<ContractDistribution>;
  dealIssues: Array<DealIssue>;
  dealPackageConfigs: Array<DealPackageConfig>;
  dealProductsV2: Array<DealProduct>;
  dealSetter?: Maybe<DealSetter>;
  dealStates?: Maybe<Array<Maybe<DealState>>>;
  dealStats?: Maybe<DealStats>;
  dealStatsByManufacturer?: Maybe<DealStatsByManufacturer>;
  dealStatsByState?: Maybe<DealStatsByState>;
  dealTieDowns: DealTieDown;
  dealUnreadMessageCount: DealUnreadMessageCount;
  dealV2?: Maybe<Deal>;
  dealVscRates: Array<VscRateOption>;
  dealerProducts?: Maybe<Array<Maybe<Product>>>;
  dealers: Array<Dealer>;
  dealsV2: DealsConnection;
  decodeAffiliateCarDetails?: Maybe<TemporaryData>;
  decryptTempInfoSSN?: Maybe<Scalars['String']>;
  determineApprovalQuery?: Maybe<DetermineApproval>;
  duplicateDeals?: Maybe<Array<Maybe<Deal>>>;
  experianCreditReport?: Maybe<PrequalificationCreditReports>;
  externalUserPayoffRequest?: Maybe<PayoffRequest>;
  financialInfoPaymentEstimate?: Maybe<Array<Maybe<FinancialInfoPaymentEstimate>>>;
  financialInfoPaymentEstimateAffiliate?: Maybe<Array<Maybe<FinancialInfoPaymentEstimate>>>;
  financialInfoV2: FinancialInfo;
  followUp?: Maybe<FollowUp>;
  /** Returns the FS bar's stats for the chosen pool and time frame. */
  fsSummaryStatsV2: FsSummaryStatsReply;
  fundingRequirements: Array<FundingRequirement>;
  gapRates?: Maybe<Array<Maybe<Rate>>>;
  generateContracts?: Maybe<Contracts>;
  generateDocuments?: Maybe<Documents>;
  generatePurchaseOrder?: Maybe<PurchaseOrder>;
  generateR1EContract: Scalars['Boolean'];
  generateROIDocuments?: Maybe<Documents>;
  generateTestDocuments?: Maybe<Scalars['Boolean']>;
  getAffiliateApiKeys?: Maybe<Array<Maybe<AffiliateApiKey>>>;
  getAllHuntGroups?: Maybe<Array<Maybe<HuntGroup>>>;
  getAuth0Roles?: Maybe<Array<Auth0Role>>;
  getAvailableUsers?: Maybe<Array<Maybe<GetAvailableUsers>>>;
  getBase64StringFromS3Object?: Maybe<Scalars['String']>;
  getBootedDeals?: Maybe<PaginatedBootedDeals>;
  getByAuth0Id?: Maybe<Customer>;
  getCallHistory: CallHistoryResult;
  getCallHistoryStats: CallHistoryStats;
  getCallLifecycle?: Maybe<CallLifecycle>;
  getCreditDecisionByProviderLender?: Maybe<CreditDecision>;
  getDDSoftPull: DdSoftPull;
  getDownPaymentAmountByMethod?: Maybe<Scalars['Float']>;
  getEntity?: Maybe<MethodFiEntity>;
  getExternalAutoStructureBankLogos?: Maybe<Array<Maybe<AutoStructureBankLogo>>>;
  getFees?: Maybe<FeeGql>;
  getFinixPaymentInstrument?: Maybe<FinixPaymentInstrumentGraphQlType>;
  getFollowUpDealsPaginated?: Maybe<PaginatedDeals>;
  getInProgressCalls: Array<Maybe<Conference>>;
  getMethodFiSessionState?: Maybe<MethodFiSessionState>;
  getOperatingHoursAndTimeSlots?: Maybe<OperatingHoursTimeSlots>;
  getOwedAsReferee?: Maybe<Scalars['Int']>;
  getR1CustomerCopy?: Maybe<Array<Maybe<DealDocument>>>;
  getR1DealDocument?: Maybe<DealDocument>;
  getRandomVin?: Maybe<Scalars['String']>;
  getReferrerAggregate?: Maybe<ReferrerAggregateGraphQlType>;
  getReferrerByCustomerId?: Maybe<ReferrerGraphQlType>;
  getReferrerById?: Maybe<ReferrerGraphQlType>;
  getRelationshipToDealByPhoneNumber?: Maybe<GetRelationshipToDealByPhoneNumberResponse>;
  getSignaturePacketStatus?: Maybe<SignaturePacketStatus>;
  getThunderConversationHistoryByPhoneNumber?: Maybe<ThunderConversationHistory>;
  getTwilioNumbers?: Maybe<Array<Maybe<TwilioNumber>>>;
  getUploadUrl?: Maybe<MediaUploadUrl>;
  getUserCallHistory?: Maybe<PaginatedCallHistory>;
  getUserCreationData?: Maybe<UserCreationData>;
  getUserTwilioNumber?: Maybe<Scalars['String']>;
  getUsers?: Maybe<PaginatedUser>;
  getWaitingCalls?: Maybe<GetWaitingCalls>;
  getWarrantyInfo?: Maybe<CarWarranty>;
  hasAnyDeal?: Maybe<Scalars['Boolean']>;
  hasNpsSurveyResult?: Maybe<Scalars['Boolean']>;
  inbox?: Maybe<InboxMessagesType>;
  incrementFlowStarts?: Maybe<IncrementReferrer>;
  incrementImpressions?: Maybe<IncrementReferrer>;
  inquiryPartner?: Maybe<Scalars['Void']>;
  jdpValues?: Maybe<Car>;
  jurisdiction?: Maybe<TtJurisdiction>;
  kbbValues?: Maybe<KbbValuesResult>;
  kbbVin?: Maybe<KbbVinObjectResult>;
  kbbVinAffiliate?: Maybe<KbbVinObjectResult>;
  keyMetrics?: Maybe<Array<Maybe<KeyMetric>>>;
  keyReplacementRates?: Maybe<Array<Maybe<Rate>>>;
  laneKeyMetrics?: Maybe<Array<Maybe<LaneKeyMetric>>>;
  laneKeyMetricsReader?: Maybe<Array<Maybe<LaneKeyMetric>>>;
  latestThirdPartyPayoffSend?: Maybe<ThirdPartyPayoffSend>;
  leadMatches?: Maybe<Array<Maybe<LeadMatch>>>;
  leaderboardSetter: Array<LeaderboardSetterStats>;
  leaseBuyoutFromVehicleInfo?: Maybe<LeaseBuyoutStats>;
  lenders?: Maybe<Array<Maybe<Lender>>>;
  lienholderContact?: Maybe<LienholderContact>;
  lienholderTrackRecord?: Maybe<LienholderTrackRecord>;
  lienholderUtility?: Maybe<Array<Maybe<Scalars['String']>>>;
  likelyAddress?: Maybe<LikelyAddress>;
  loggedUser?: Maybe<User>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  mediaFromCom?: Maybe<Array<DealMedia>>;
  mediaV2?: Maybe<MediaV2Response>;
  messageTemplateByKey?: Maybe<MessageTemplate>;
  messageTemplatesByType?: Maybe<Array<Maybe<MessageTemplate>>>;
  messages?: Maybe<MessagesWithErrors>;
  messagesDbCursorV2: MessagesCursorConnection;
  messagesDbPaginated?: Maybe<MessagesDbPaginated>;
  metricsPages?: Maybe<Array<Maybe<MetricsPages>>>;
  mmr?: Maybe<MmrResult>;
  myAppointmentSlotsV2: Array<MyAppointmentSlotV2>;
  myUnfinishedThunderClaims: Array<Maybe<ThunderCallNotification>>;
  navBarTextNotifications?: Maybe<NavBarTextNotifications>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notesV2Cursor: NotesCursorConnection;
  paymentEstimate?: Maybe<PaymentEstimate>;
  paymentEstimateAffiliate?: Maybe<PaymentEstimate>;
  paymentOptions?: Maybe<PaymentOptions>;
  paymentOptionsV2: PaymentOptionsV2;
  payoffCountMake?: Maybe<Array<Maybe<PayoffCountMake>>>;
  payoffCountModel?: Maybe<Array<Maybe<PayoffCountModel>>>;
  payoffDashboardDeals?: Maybe<PayoffDashboard>;
  payoffQueueRequests: PayoffQueue;
  payoffRequest?: Maybe<PayoffRequest>;
  payoffStatsMakeModelYearAffiliate?: Maybe<Array<Maybe<PayoffStatsMakeModel>>>;
  pendingTieDownsForReview: Array<TieDown>;
  pod?: Maybe<Pod>;
  podHours?: Maybe<Array<Maybe<PodHours>>>;
  /** Returns the pod bar's stats for the chosen pool and time frame. */
  podSummaryStatsV2: PodSummaryStatsReply;
  pods?: Maybe<Array<Maybe<Pod>>>;
  podsAll?: Maybe<Array<Maybe<Pod>>>;
  priorCobuyersForDeal: Array<PriorCobuyer>;
  products?: Maybe<Array<Maybe<Product>>>;
  productsCatalogV2: Array<ProductCatalogV2>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  recommendedLienholderSlugs: Array<Scalars['String']>;
  retrieveDealDocsUploadedToR1?: Maybe<Array<Maybe<DealDocument>>>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  searchDeals: Array<Deal>;
  searchWebLeads?: Maybe<Array<Maybe<TemporaryInfo>>>;
  sendOwnerReferralLinkEmail?: Maybe<SendReferralLinkPayload>;
  sendOwnerReferralLinkSms?: Maybe<SendReferralLinkPayload>;
  sendReferralLinkEmail?: Maybe<SendReferralLinkPayload>;
  sendReferralLinkSms?: Maybe<SendReferralLinkPayload>;
  sidebarAppointmentsV2: Array<SidebarAppointmentV2>;
  smartPayoff?: Maybe<SmartPayoff>;
  smartPayoffAffiliate?: Maybe<SmartPayoffAffiliate>;
  socialProofStats?: Maybe<SocialProofStats>;
  startR1DocumentsFlow?: Maybe<Scalars['Boolean']>;
  structuringFollowUp?: Maybe<StructuringFollowUp>;
  structuringFollowUpDeals?: Maybe<PaginatedDeals>;
  suggestedMessage?: Maybe<Scalars['String']>;
  surcharges?: Maybe<Array<Maybe<Surcharge>>>;
  tags: Array<Tag>;
  taughtCallUrl?: Maybe<Scalars['String']>;
  temporaryInfo?: Maybe<TemporaryInfo>;
  temporaryInfoAuthenticated?: Maybe<TemporaryInfo>;
  temporaryRegistrationTagsDeals?: Maybe<PaginatedDeals>;
  tieDown?: Maybe<TieDown>;
  tireWheelRates?: Maybe<Array<Maybe<Rate>>>;
  titlingDashboardDeals?: Maybe<PaginatedDeals>;
  titlingPodsAll?: Maybe<Array<Maybe<Pod>>>;
  titlingUsers?: Maybe<Array<Maybe<PodUser>>>;
  totalCompletedDeals?: Maybe<Scalars['Int']>;
  userDeal?: Maybe<ExternalDeal>;
  userDeals?: Maybe<Array<Maybe<Deals>>>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  userPreferences: UserPreferences;
  userTitlingPods?: Maybe<Array<Maybe<Pod>>>;
  validZip?: Maybe<Scalars['Boolean']>;
  validateBankContract?: Maybe<Scalars['Boolean']>;
  validateCreditApplicationV2?: Maybe<Array<Maybe<Scalars['String']>>>;
  validateDealBeforeAction?: Maybe<DealActionValidation>;
  validatePhotoToken?: Maybe<PhotoTokenValidationResult>;
  validateReferrer?: Maybe<ValidateReferrer>;
  validateSecureLink?: Maybe<Scalars['Boolean']>;
  vehicleMileage?: Maybe<VehicleMileageGql>;
  visibleArticles?: Maybe<VisibleArticles>;
  visibleReviews?: Maybe<Array<Maybe<Review>>>;
  vscRates?: Maybe<Array<Maybe<Rate>>>;
};


export type QueryAcquisitionOfferArgs = {
  accidents: AccidentsEnumType;
  book_value?: InputMaybe<Scalars['Int']>;
  lienholder?: InputMaybe<Scalars['String']>;
  lienholder_slug?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mmr_value?: InputMaybe<Scalars['Float']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};


export type QueryAddressDetailArgs = {
  address?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryAdvisorSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};


export type QueryAffiliateByPhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryAffiliateDetailsArgs = {
  affiliateExternalId?: InputMaybe<Scalars['String']>;
};


export type QueryAiCallPayloadArgs = {
  dealId: Scalars['String'];
};


export type QueryAlertsArgs = {
  filter?: InputMaybe<AlertsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<AlertSortingType>;
};


export type QueryArticleImageUploadUrlArgs = {
  fileName: Scalars['String'];
};


export type QueryAuctionAverageTransportCostArgs = {
  customerAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAuctionDistancesArgs = {
  data?: InputMaybe<AuctionDistancesInput>;
};


export type QueryBankInfoArgs = {
  deal_id: Scalars['ID'];
};


export type QueryBankLogoArgs = {
  bank_name: Scalars['String'];
};


export type QueryBanksArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  county?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
  selectedBank?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryCalculateOptionsArgs = {
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>>>;
  color?: InputMaybe<Scalars['String']>;
  configToModify?: InputMaybe<Array<InputMaybe<KbbConfigType>>>;
  startingVehicleOptions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vehicleId?: InputMaybe<Scalars['Int']>;
  vin: Scalars['String'];
};


export type QueryCallArgs = {
  call_id?: InputMaybe<Scalars['String']>;
  conference_id?: InputMaybe<Scalars['String']>;
};


export type QueryCarDetailLicensePlateArgs = {
  license_plate_number: Scalars['String'];
  license_plate_state: Scalars['String'];
};


export type QueryCarDetailVinArgs = {
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryCarDistinctModelArgs = {
  make: Scalars['String'];
};


export type QueryCbbValuesArgs = {
  data: CbbValuesDataType;
};


export type QueryCbbVinArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  vin: Scalars['String'];
};


export type QueryCheckAffiliateDealExistsArgs = {
  affiliateExternalId?: InputMaybe<Scalars['String']>;
};


export type QueryCheckExistingAccountByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryCheckFlowStatusArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryCheckPayoffRequestRequirementsArgs = {
  dealId: Scalars['Int'];
  lienholderSlug?: InputMaybe<Scalars['String']>;
};


export type QueryCheckSupportedLienholderArgs = {
  dealId?: InputMaybe<Scalars['Int']>;
  lienholderSlug?: InputMaybe<Scalars['String']>;
};


export type QueryCommunicationHistoryV2Args = {
  filter: CommunicationHistoryFilter;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryComparePrequalSocialsArgs = {
  cobuyerId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
};


export type QueryCompletedDealsArgs = {
  addressState?: InputMaybe<Scalars['String']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  dealState?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sources: Array<InputMaybe<Scalars['String']>>;
  startDate: Scalars['DateTime'];
  types: Array<InputMaybe<DealType>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryConsentOptOutLookupArgs = {
  identifiers: Array<ConsentIdentifierInput>;
};


export type QueryConversationInboxThreadArgs = {
  dealId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryConversationsInboxArgs = {
  filter?: InputMaybe<ConversationsInboxFilter>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryCreateFetchUrlsFromComArgs = {
  keys: Array<InputMaybe<Scalars['String']>>;
};


export type QueryCreateReferralArgs = {
  deal_id?: InputMaybe<Scalars['Int']>;
  referrer_id: Scalars['Int'];
  temporary_info_id?: InputMaybe<Scalars['String']>;
};


export type QueryCreateReferrerArgs = {
  customer_id: Scalars['Int'];
};


export type QueryCreditApplicationSubmissionsArgs = {
  filter?: InputMaybe<CreditApplicationSubmissionFilter>;
};


export type QueryCreditApplicationV2Args = {
  id: Scalars['ID'];
};


export type QueryCreditDecisionV2Args = {
  id: Scalars['Int'];
};


export type QueryCurrentConsentAgreementTextArgs = {
  agreementType?: InputMaybe<ConsentAgreementTypeEnum>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerNotificationsArgs = {
  dealId: Scalars['ID'];
  isCobuyer: Scalars['Boolean'];
};


export type QueryDashboardDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
  closerLocation?: InputMaybe<LocationType>;
  fsPodIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  loadAll?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']>;
  sources: Array<InputMaybe<Scalars['String']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types: Array<InputMaybe<DealType>>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryDealArgs = {
  id: Scalars['ID'];
  sources: Array<InputMaybe<Scalars['String']>>;
  types: Array<InputMaybe<DealType>>;
};


export type QueryDealAdvisorsArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryDealContractDistributionArgs = {
  dealId: Scalars['ID'];
};


export type QueryDealIssuesArgs = {
  dealId: Scalars['Int'];
};


export type QueryDealPackageConfigsArgs = {
  dealId: Scalars['Int'];
};


export type QueryDealProductsV2Args = {
  dealId: Scalars['Int'];
};


export type QueryDealSetterArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryDealStatesArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryDealStatsArgs = {
  manufacturer: Scalars['String'];
  state: Scalars['String'];
};


export type QueryDealStatsByManufacturerArgs = {
  manufacturer: Scalars['String'];
};


export type QueryDealStatsByStateArgs = {
  state: Scalars['String'];
};


export type QueryDealTieDownsArgs = {
  dealId: Scalars['ID'];
};


export type QueryDealUnreadMessageCountArgs = {
  dealId: Scalars['Int'];
};


export type QueryDealV2Args = {
  id?: InputMaybe<Scalars['Int']>;
  leaseId?: InputMaybe<Scalars['GUID']>;
};


export type QueryDealVscRatesArgs = {
  dealId: Scalars['Int'];
};


export type QueryDealerProductsArgs = {
  dealer_id: Scalars['ID'];
};


export type QueryDealsV2Args = {
  filter?: InputMaybe<DealsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<SortingTypeV2>;
};


export type QueryDecodeAffiliateCarDetailsArgs = {
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']>;
  license_plate_number?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  temp_info_id?: InputMaybe<Scalars['ID']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryDecryptTempInfoSsnArgs = {
  tempInfoId: Scalars['ID'];
};


export type QueryDetermineApprovalQueryArgs = {
  data?: InputMaybe<DetermineApprovalQueryInput>;
};


export type QueryDuplicateDealsArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  homePhoneNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  matchBootedDeals: Scalars['Boolean'];
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryExperianCreditReportArgs = {
  dealId: Scalars['ID'];
};


export type QueryExternalUserPayoffRequestArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryFinancialInfoPaymentEstimateArgs = {
  endDate: Scalars['String'];
  make: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type QueryFinancialInfoPaymentEstimateAffiliateArgs = {
  endDate: Scalars['String'];
  make: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type QueryFinancialInfoV2Args = {
  filter?: InputMaybe<FinancialInfoFilter>;
};


export type QueryFollowUpArgs = {
  deal_id: Scalars['ID'];
};


export type QueryFsSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};


export type QueryFundingRequirementsArgs = {
  dealId: Scalars['Int'];
};


export type QueryGapRatesArgs = {
  bank?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID'];
};


export type QueryGenerateContractsArgs = {
  data?: InputMaybe<ContractsInput>;
};


export type QueryGenerateDocumentsArgs = {
  data?: InputMaybe<DocumentsInput>;
};


export type QueryGeneratePurchaseOrderArgs = {
  deal_id: Scalars['ID'];
};


export type QueryGenerateR1EContractArgs = {
  dealJacketId: Scalars['String'];
};


export type QueryGenerateRoiDocumentsArgs = {
  data?: InputMaybe<DocumentsInput>;
};


export type QueryGenerateTestDocumentsArgs = {
  update_deal_id: Scalars['ID'];
};


export type QueryGetAllHuntGroupsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBase64StringFromS3ObjectArgs = {
  key: Scalars['String'];
};


export type QueryGetBootedDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['DateTime'];
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sources: Array<InputMaybe<Scalars['String']>>;
  startDate: Scalars['DateTime'];
  types: Array<InputMaybe<DealType>>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCallHistoryArgs = {
  agentUserId?: InputMaybe<Scalars['String']>;
  callSid?: InputMaybe<Scalars['String']>;
  conferenceId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  flowType?: InputMaybe<Scalars['String']>;
  hasEventType?: InputMaybe<Scalars['String']>;
  huntGroupSlug?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCallHistoryStatsArgs = {
  agentUserId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  flowType?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
};


export type QueryGetCallLifecycleArgs = {
  callId?: InputMaybe<Scalars['String']>;
  conferenceId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCreditDecisionByProviderLenderArgs = {
  deal_id: Scalars['ID'];
  provider_lender_id: Scalars['String'];
};


export type QueryGetDdSoftPullArgs = {
  dealId: Scalars['ID'];
  paymentEstimateInput: PaymentEstimateInput;
  shouldForceRetry?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDownPaymentAmountByMethodArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  paymentType?: InputMaybe<PaymentInstrumentType>;
};


export type QueryGetEntityArgs = {
  entityId: Scalars['String'];
};


export type QueryGetFeesArgs = {
  address?: InputMaybe<Scalars['String']>;
  bookValue?: InputMaybe<Scalars['Float']>;
  city?: InputMaybe<Scalars['String']>;
  cobuyerAddress?: InputMaybe<Scalars['String']>;
  cobuyerCity?: InputMaybe<Scalars['String']>;
  cobuyerCounty?: InputMaybe<Scalars['String']>;
  cobuyerDob?: InputMaybe<Scalars['String']>;
  cobuyerEmail?: InputMaybe<Scalars['String']>;
  cobuyerFirstName?: InputMaybe<Scalars['String']>;
  cobuyerLastName?: InputMaybe<Scalars['String']>;
  cobuyerMiddleName?: InputMaybe<Scalars['String']>;
  cobuyerPhone?: InputMaybe<Scalars['String']>;
  cobuyerState?: InputMaybe<StateAbbreviation>;
  cobuyerSuffix?: InputMaybe<Scalars['String']>;
  cobuyerZip?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  docFee?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  estimatedPayoff?: InputMaybe<Scalars['Float']>;
  financialInfoId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<TtFuelType>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insurancePolicyExpirationDate?: InputMaybe<Scalars['String']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  mailingCity?: InputMaybe<Scalars['String']>;
  mailingCounty?: InputMaybe<Scalars['String']>;
  mailingState?: InputMaybe<StateAbbreviation>;
  mailingZipCode?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  newBank?: InputMaybe<Scalars['String']>;
  newBankAddress?: InputMaybe<Scalars['String']>;
  newBankAddress2?: InputMaybe<Scalars['String']>;
  newBankCity?: InputMaybe<Scalars['String']>;
  newBankEltCode?: InputMaybe<Scalars['String']>;
  newBankState?: InputMaybe<StateAbbreviation>;
  newBankZip?: InputMaybe<Scalars['String']>;
  newBankZipPlus4?: InputMaybe<Scalars['String']>;
  odometerReading?: InputMaybe<Scalars['Int']>;
  payoff?: InputMaybe<Scalars['Float']>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']>;
  payoffWithoutSalesTax?: InputMaybe<Scalars['Float']>;
  previouslyTitledState?: InputMaybe<StateAbbreviation>;
  retailBookValue?: InputMaybe<Scalars['Float']>;
  salesTax?: InputMaybe<Scalars['Float']>;
  signedDate?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateAbbreviation>;
  suffix?: InputMaybe<Scalars['String']>;
  titleRegistrationOption?: InputMaybe<Scalars['String']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  uniqueId?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<TtVehicleType>;
  vin?: InputMaybe<Scalars['String']>;
  warranty?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type QueryGetFinixPaymentInstrumentArgs = {
  paymentInstrumentId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFollowUpDealsPaginatedArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequested?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  resultsPerPage?: InputMaybe<Scalars['Int']>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
  sortColumn: Scalars['String'];
  sortDirection: Scalars['String'];
  sources: Array<InputMaybe<Scalars['String']>>;
  types: Array<InputMaybe<DealType>>;
};


export type QueryGetOwedAsRefereeArgs = {
  customer_id: Scalars['Int'];
};


export type QueryGetR1CustomerCopyArgs = {
  dealId: Scalars['ID'];
  dealJacketID: Scalars['String'];
  includeExtraPDFBinaries?: InputMaybe<Scalars['Boolean']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetR1DealDocumentArgs = {
  dealId: Scalars['ID'];
  dealJacketID: Scalars['String'];
  documentID: Scalars['String'];
  includePdfBinary?: InputMaybe<Scalars['Boolean']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetReferrerAggregateArgs = {
  referrer_id: Scalars['Int'];
};


export type QueryGetReferrerByCustomerIdArgs = {
  customer_id: Scalars['Int'];
};


export type QueryGetReferrerByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetRelationshipToDealByPhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryGetSignaturePacketStatusArgs = {
  dealId: Scalars['ID'];
};


export type QueryGetThunderConversationHistoryByPhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryGetUploadUrlArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  useD2dDocumentCenterBucket?: InputMaybe<Scalars['Boolean']>;
  useD2dVoiceRecordingsBucket?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetUserCallHistoryArgs = {
  items_per_page?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUsersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  podId?: InputMaybe<Scalars['ID']>;
  roleNames?: InputMaybe<Array<InputMaybe<Auth0RoleName>>>;
  searchText?: InputMaybe<Scalars['String']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  teamType?: InputMaybe<TeamType>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetWarrantyInfoArgs = {
  make: Scalars['String'];
  mileage: Scalars['Int'];
  year: Scalars['String'];
};


export type QueryHasAnyDealArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryHasNpsSurveyResultArgs = {
  dealId: Scalars['Int'];
};


export type QueryInboxArgs = {
  filterBy?: InputMaybe<InboxFilterByEnum>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<InboxOrderByEnum>;
  page?: InputMaybe<Scalars['Int']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryIncrementFlowStartsArgs = {
  code: Scalars['String'];
};


export type QueryIncrementImpressionsArgs = {
  code: Scalars['String'];
};


export type QueryInquiryPartnerArgs = {
  company: Scalars['String'];
  company_website?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  partner_type: Scalars['String'];
  phone: Scalars['String'];
  social_media?: InputMaybe<Scalars['String']>;
};


export type QueryJdpValuesArgs = {
  mileage: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
};


export type QueryJurisdictionArgs = {
  county?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateAbbreviation>;
};


export type QueryKbbValuesArgs = {
  data: KbbValuesDataType;
};


export type QueryKbbVinArgs = {
  vin: Scalars['String'];
};


export type QueryKbbVinAffiliateArgs = {
  vin: Scalars['String'];
};


export type QueryKeyMetricsArgs = {
  end_date: Scalars['DateTime'];
  pod_ids: Array<InputMaybe<Scalars['String']>>;
  start_date: Scalars['DateTime'];
};


export type QueryKeyReplacementRatesArgs = {
  bank?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID'];
};


export type QueryLaneKeyMetricsArgs = {
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sources: Array<InputMaybe<Scalars['String']>>;
  today?: InputMaybe<Scalars['DateTime']>;
  types: Array<InputMaybe<DealType>>;
};


export type QueryLaneKeyMetricsReaderArgs = {
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sources: Array<InputMaybe<Scalars['String']>>;
  today?: InputMaybe<Scalars['DateTime']>;
  types: Array<InputMaybe<DealType>>;
};


export type QueryLatestThirdPartyPayoffSendArgs = {
  dealId: Scalars['ID'];
};


export type QueryLeadMatchesArgs = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type QueryLeaderboardSetterArgs = {
  after: Scalars['DateTime'];
  before: Scalars['DateTime'];
  teamType?: InputMaybe<TeamType>;
};


export type QueryLeaseBuyoutFromVehicleInfoArgs = {
  email?: InputMaybe<Scalars['String']>;
  license_plate?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  lienholder?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryLendersArgs = {
  query: Scalars['String'];
};


export type QueryLienholderContactArgs = {
  dealId: Scalars['Int'];
};


export type QueryLienholderTrackRecordArgs = {
  lienholderSlug?: InputMaybe<Scalars['String']>;
};


export type QueryLienholderUtilityArgs = {
  make?: InputMaybe<Scalars['String']>;
};


export type QueryLikelyAddressArgs = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type QueryMediaArgs = {
  dealId: Scalars['ID'];
};


export type QueryMediaFromComArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type QueryMediaV2Args = {
  dealId: Scalars['ID'];
};


export type QueryMessageTemplateByKeyArgs = {
  key: MessageTemplateKey;
};


export type QueryMessageTemplatesByTypeArgs = {
  type?: InputMaybe<MessageTemplateType>;
};


export type QueryMessagesArgs = {
  dealPhoneNumber?: InputMaybe<Scalars['String']>;
};


export type QueryMessagesDbCursorV2Args = {
  filter: MessagesFilter;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryMessagesDbPaginatedArgs = {
  dealId: Scalars['String'];
  dealPhoneNumber: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryMmrArgs = {
  color: Scalars['String'];
  grade: Scalars['Float'];
  mileage: Scalars['Int'];
  state: Scalars['String'];
  trim: Scalars['String'];
  vin: Scalars['String'];
};


export type QueryMyAppointmentSlotsV2Args = {
  date: Scalars['String'];
  tz?: InputMaybe<Scalars['String']>;
};


export type QueryNavBarTextNotificationsArgs = {
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<Scalars['ID']>>;
  sources: Array<Scalars['String']>;
  types: Array<DealType>;
};


export type QueryNotesArgs = {
  deal_id: Scalars['ID'];
};


export type QueryNotesV2CursorArgs = {
  filter?: InputMaybe<NotesFilter>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryPaymentEstimateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
};


export type QueryPaymentEstimateAffiliateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
};


export type QueryPaymentOptionsArgs = {
  data?: InputMaybe<PaymentOptionsInput>;
};


export type QueryPaymentOptionsV2Args = {
  input: PaymentOptionsV2Input;
};


export type QueryPayoffCountMakeArgs = {
  make: Scalars['String'];
};


export type QueryPayoffCountModelArgs = {
  make: Scalars['String'];
  model: Scalars['String'];
};


export type QueryPayoffQueueRequestsArgs = {
  mine?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPayoffRequestArgs = {
  deal_id?: InputMaybe<Scalars['ID']>;
};


export type QueryPayoffStatsMakeModelYearAffiliateArgs = {
  end_date: Scalars['String'];
  make: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  trim?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};


export type QueryPodArgs = {
  id: Scalars['ID'];
};


export type QueryPodSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};


export type QueryPodsArgs = {
  hideArchived?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pod_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  team_type?: InputMaybe<Array<InputMaybe<TeamType>>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryPriorCobuyersForDealArgs = {
  dealId: Scalars['Int'];
};


export type QueryProductsArgs = {
  provider_id: Scalars['ID'];
};


export type QueryRecommendedLienholderSlugsArgs = {
  dealId: Scalars['Int'];
};


export type QueryRetrieveDealDocsUploadedToR1Args = {
  dealId: Scalars['ID'];
  includeAll?: InputMaybe<Scalars['Boolean']>;
  includePdfBinary?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchDealsArgs = {
  query: Scalars['String'];
};


export type QuerySearchWebLeadsArgs = {
  query: Scalars['String'];
};


export type QuerySendOwnerReferralLinkEmailArgs = {
  email: Scalars['String'];
  url: Scalars['String'];
};


export type QuerySendOwnerReferralLinkSmsArgs = {
  phone: Scalars['String'];
  url: Scalars['String'];
};


export type QuerySendReferralLinkEmailArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  url: Scalars['String'];
};


export type QuerySendReferralLinkSmsArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  url: Scalars['String'];
};


export type QuerySmartPayoffArgs = {
  vin: Scalars['String'];
  zip_code: Scalars['String'];
};


export type QuerySmartPayoffAffiliateArgs = {
  vin: Scalars['String'];
  zip_code: Scalars['String'];
};


export type QuerySocialProofStatsArgs = {
  dealId: Scalars['ID'];
};


export type QueryStartR1DocumentsFlowArgs = {
  dealId: Scalars['ID'];
};


export type QueryStructuringFollowUpArgs = {
  dealId: Scalars['ID'];
};


export type QueryStructuringFollowUpDealsArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  bootRequested?: InputMaybe<Scalars['Boolean']>;
  dealTypes: Array<InputMaybe<DealType>>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']>;
  sortColumn: StructuringFollowUpSortColumn;
  sortDirection: SortDirection;
  sources: Array<InputMaybe<Scalars['String']>>;
};


export type QuerySuggestedMessageArgs = {
  customerId: Scalars['ID'];
  dealId: Scalars['ID'];
  draftMessage?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


export type QuerySurchargesArgs = {
  product_id: Scalars['Int'];
};


export type QueryTagsArgs = {
  input?: InputMaybe<TagsInput>;
};


export type QueryTaughtCallUrlArgs = {
  callId?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['Int']>;
};


export type QueryTemporaryInfoArgs = {
  allowImported?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryTemporaryInfoAuthenticatedArgs = {
  id: Scalars['ID'];
};


export type QueryTemporaryRegistrationTagsDealsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryTieDownArgs = {
  id: Scalars['ID'];
};


export type QueryTireWheelRatesArgs = {
  bank?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID'];
};


export type QueryTitlingDashboardDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<FilterType>;
  includeTitleNotes?: InputMaybe<Scalars['Boolean']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  sorting?: InputMaybe<SortingType>;
  sources: Array<InputMaybe<Scalars['String']>>;
  types: Array<InputMaybe<DealType>>;
};


export type QueryTitlingUsersArgs = {
  titling_pod_id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserDealArgs = {
  id?: InputMaybe<Scalars['ID']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUserPermissionsArgs = {
  user_id?: InputMaybe<Scalars['String']>;
};


export type QueryValidZipArgs = {
  zipCode: Scalars['String'];
};


export type QueryValidateBankContractArgs = {
  deal_id: Scalars['ID'];
};


export type QueryValidateCreditApplicationV2Args = {
  id: Scalars['ID'];
};


export type QueryValidateDealBeforeActionArgs = {
  dealId: Scalars['Int'];
  nextDealState?: InputMaybe<DealStateEnum>;
};


export type QueryValidatePhotoTokenArgs = {
  token: Scalars['String'];
};


export type QueryValidateReferrerArgs = {
  code: Scalars['String'];
};


export type QueryValidateSecureLinkArgs = {
  token: Scalars['String'];
};


export type QueryVehicleMileageArgs = {
  vin?: InputMaybe<Scalars['String']>;
};


export type QueryVisibleArticlesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryVscRatesArgs = {
  bank?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID'];
};

export type R1ContractValidationErrors = {
  __typename?: 'R1ContractValidationErrors';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type R1ContractValidationErrorsInput = {
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type R1ContractValidationWarnings = {
  __typename?: 'R1ContractValidationWarnings';
  warnings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type R1ContractValidationWarningsInput = {
  warnings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RecipientUnreadCount = {
  __typename?: 'RecipientUnreadCount';
  count: Scalars['Int'];
  /** When the newest unread text or missed call in this thread arrived. */
  lastUnreadAt?: Maybe<Scalars['DateTime']>;
  /** Unread inbox missed calls from this phone, under the same rules as the deal-level missedCallCount. */
  missedCallCount: Scalars['Int'];
  /** E.164 phone the unread texts came from: the thread (mobile or home) they belong to. */
  phoneNumber: Scalars['String'];
  recipientId: Scalars['Int'];
  recipientType: Scalars['String'];
};

export enum ReferralSourceEnum {
  DidNotAsk = 'did_not_ask',
  InternetSearch = 'internet_search',
  Mailer = 'mailer',
  Other = 'other',
  RecommendationFromFriend = 'recommendation_from_friend',
  SocialMediaOrBlogPost = 'social_media_or_blog_post',
  Text = 'text',
  TrustedReview = 'trusted_review'
}

export type ReferrerAggregateGraphQlType = {
  __typename?: 'ReferrerAggregateGraphQLType';
  owed_referrals?: Maybe<Scalars['Int']>;
  paid_referrals?: Maybe<Scalars['Int']>;
  pending_referrals?: Maybe<Scalars['Int']>;
  total_referrals?: Maybe<Scalars['Int']>;
};

export type ReferrerDataGraphQlType = {
  __typename?: 'ReferrerDataGraphQLType';
  dfn?: Maybe<Scalars['String']>;
  did?: Maybe<Scalars['Int']>;
  dln?: Maybe<Scalars['String']>;
  dmdl?: Maybe<Scalars['String']>;
  dmke?: Maybe<Scalars['String']>;
  rid?: Maybe<Scalars['Int']>;
};

export type ReferrerGraphQlType = {
  __typename?: 'ReferrerGraphQLType';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_first_name?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_last_name?: Maybe<Scalars['String']>;
  email_sent_instrument_expired_at?: Maybe<Scalars['DateTime']>;
  email_sent_welcome_at?: Maybe<Scalars['DateTime']>;
  finix_identity?: Maybe<Scalars['String']>;
  finix_instrument?: Maybe<Scalars['String']>;
  finix_merchant?: Maybe<Scalars['String']>;
  finix_verify?: Maybe<Scalars['String']>;
  flow_starts?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  instrument_brand?: Maybe<Scalars['String']>;
  instrument_exp_mo?: Maybe<Scalars['String']>;
  instrument_exp_yr?: Maybe<Scalars['String']>;
  instrument_expired?: Maybe<Scalars['Boolean']>;
  instrument_last_four?: Maybe<Scalars['String']>;
  instrument_type?: Maybe<Scalars['String']>;
  opted_in_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  url_views?: Maybe<Scalars['Int']>;
};

export type ReferrerUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  email_sent_instrument_expired_at?: InputMaybe<Scalars['DateTime']>;
  email_sent_welcome_at?: InputMaybe<Scalars['DateTime']>;
  finix_identity?: InputMaybe<Scalars['String']>;
  finix_instrument?: InputMaybe<Scalars['String']>;
  finix_merchant?: InputMaybe<Scalars['String']>;
  finix_verify?: InputMaybe<Scalars['String']>;
  flow_starts?: InputMaybe<Scalars['Int']>;
  instrument_brand?: InputMaybe<Scalars['String']>;
  instrument_exp_mo?: InputMaybe<Scalars['String']>;
  instrument_exp_yr?: InputMaybe<Scalars['String']>;
  instrument_expired?: InputMaybe<Scalars['Boolean']>;
  instrument_last_four?: InputMaybe<Scalars['String']>;
  instrument_type?: InputMaybe<Scalars['String']>;
  opted_in_at?: InputMaybe<Scalars['String']>;
  url_views?: InputMaybe<Scalars['Int']>;
};

export enum Region {
  Ab = 'AB',
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Bc = 'BC',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Mb = 'MB',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nb = 'NB',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nl = 'NL',
  Nm = 'NM',
  Ns = 'NS',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  On = 'ON',
  Or = 'OR',
  Pa = 'PA',
  Pe = 'PE',
  Pr = 'PR',
  Pw = 'PW',
  Qc = 'QC',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Sk = 'SK',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type Reliability = {
  __typename?: 'Reliability';
  make?: Maybe<Scalars['Float']>;
  make_perc?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['Float']>;
  model_perc?: Maybe<Scalars['Float']>;
  score: Scalars['Boolean'];
};

export enum ResidenceTypeEnum {
  Buying = 'buying',
  Family = 'family',
  Own = 'own',
  Rent = 'rent'
}

export type ResidentialInfoInput = {
  address?: InputMaybe<AddressInputV2>;
  customerId?: InputMaybe<Scalars['Int']>;
  dealId: Scalars['Int'];
  livesWithOtherBuyer?: InputMaybe<Scalars['Boolean']>;
  prevAddress?: InputMaybe<AddressInputV2>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acquirePayoffForDeal: AcquirePayoffResponse;
  acquirePayoffForTemporaryInfo: AcquirePayoffResponse;
  acquisitionDealInfoUpsert?: Maybe<Deal>;
  addDealBookmark: Array<Deal>;
  addDocumentsToMediaCenter?: Maybe<Scalars['Boolean']>;
  addLendersToCreditApplicationV2: CreditApplication;
  addNote?: Maybe<Note>;
  addParticipant?: Maybe<ResultAddParticipant>;
  applyDocumentSignature?: Maybe<Scalars['Void']>;
  approveTieDown: TieDown;
  archivePod?: Maybe<Scalars['Void']>;
  attachFundingRequirementFile: FundingRequirement;
  auctionUpsert?: Maybe<Auction>;
  authenticateAnonymousCustomer: Scalars['String'];
  automateCreditApplication?: Maybe<Deal>;
  buyerCobuyerSwap?: Maybe<Deal>;
  buyerCobuyerSwapV2?: Maybe<Deal>;
  calculateDealFees: CalculateDealFeesResult;
  callOut?: Maybe<Call>;
  callOutWithAi?: Maybe<Scalars['String']>;
  cancelBootRequestV2?: Maybe<Deal>;
  cancelPayoffRequestByTemporaryInfoId?: Maybe<PayoffRequest>;
  cancelTieDown: TieDown;
  clearR1DealDocs?: Maybe<Array<Maybe<EnhancedDealMedia>>>;
  conditionReportUpsert?: Maybe<ConditionReportUpsert>;
  connectAndRetrieveEntityData?: Maybe<MethodFiConnectAndRetrieveData>;
  counterTieDown: TieDown;
  createAffiliateApiKey?: Maybe<Scalars['String']>;
  createAffiliateProvider?: Maybe<AffiliateProviderRead>;
  createAffiliateTemporaryInfo?: Maybe<TemporaryInfo>;
  createAndSendSecureLink?: Maybe<CreateAndSendSecureLinkResult>;
  createArticle?: Maybe<Article>;
  createBookSheetsV2: CreateBookSheetsV2Response;
  createCreditApplicationV2: CreditApplication;
  createDdDevDeal?: Maybe<Scalars['ID']>;
  createDealIssue: DealIssue;
  createDealV2: Deal;
  createDownPaymentLink?: Maybe<Scalars['String']>;
  createEmbeddedInsuranceLeadAndGetLink?: Maybe<CreateEmbeddedInsuranceLeadAndGetLinkGraphQlType>;
  createExternalDealUploadUrl?: Maybe<ExternalDealUploadUrl>;
  createExternalTempInfoUploadUrl?: Maybe<ExternalTempInfoUploadUrl>;
  createFeedback?: Maybe<Scalars['Void']>;
  createFinixPaymentInstrumentTokenResolver?: Maybe<CreateFinixIdentityGraphQlType>;
  createFinixPaymentMerchantResolver?: Maybe<CreateFinixMerchantGraphQlType>;
  createFundingRequirement: FundingRequirement;
  createIndividualEntity?: Maybe<MethodFiEntity>;
  createJDPBookSheet?: Maybe<Scalars['Boolean']>;
  createKBBBookSheet?: Maybe<Scalars['Boolean']>;
  createKyoVerification?: Maybe<MethodFiVerificationSession>;
  createManualEntryTemporaryInfo?: Maybe<TemporaryInfo>;
  createManualPayoffRequest?: Maybe<PayoffRequest>;
  createNewEstimateAndSetFollowUp?: Maybe<Deal>;
  createNewEstimateFromFiles?: Maybe<CreateNewEstimateFromFiles>;
  createNpsSurveyResult?: Maybe<Scalars['Boolean']>;
  createOptEvent?: Maybe<OptEvent>;
  createPayoffRequest?: Maybe<PayoffRequest>;
  createPotentialUser?: Maybe<PotentialUser>;
  createReferrerPaymentInstrumentResolver?: Maybe<CreateFinixIdentityGraphQlType>;
  createReview?: Maybe<Review>;
  createStructuringFollowUp?: Maybe<Scalars['Boolean']>;
  createTemporaryInfo?: Maybe<TemporaryInfo>;
  createTemporaryInfoAffiliate?: Maybe<TemporaryInfo>;
  createTieDown: TieDown;
  createTransaction?: Maybe<Scalars['Float']>;
  createUser?: Maybe<User>;
  createVerificationSession?: Maybe<MethodFiVerificationSession>;
  customDatesUpdate?: Maybe<DealDates>;
  customerInfoUpsert?: Maybe<Deal>;
  deactivateAffiliateApiKey?: Maybe<Scalars['Boolean']>;
  dealAssign?: Maybe<Deal>;
  /** @deprecated DD 1.0 only. Use dealCompletedV2. */
  dealCompleted?: Maybe<Deal>;
  dealCompletedV2?: Maybe<Deal>;
  dealDetailNetsuite?: Maybe<Deal>;
  dealFinalizeAcquisition?: Maybe<Scalars['Boolean']>;
  dealInfoUpsert?: Maybe<Deal>;
  dealSeen?: Maybe<Scalars['Boolean']>;
  dealSendToBank?: Maybe<DealDates>;
  dealTagsUpsert: Array<Tag>;
  dealUnwound?: Maybe<Deal>;
  dealUpdateAssignments?: Maybe<Deal>;
  dealUpdateRequestBoot?: Maybe<Deal>;
  dealUpdateState?: Maybe<DealWithErrors>;
  dealUpdateStateAndSendEmails?: Maybe<Deal>;
  declineTieDown: TieDown;
  decryptSSN?: Maybe<DecryptedSsn>;
  deleteAndReplaceFiles?: Maybe<Scalars['Boolean']>;
  deleteArticle?: Maybe<Article>;
  deleteComFlowFile?: Maybe<Scalars['Void']>;
  deleteContracts?: Maybe<Scalars['Boolean']>;
  deleteCreditApplicationV2: Scalars['ID'];
  deleteDealIssue: Scalars['ID'];
  deleteDealV2: Scalars['Int'];
  deleteFundingRequirement: Scalars['ID'];
  deleteNote: Scalars['ID'];
  deleteReview?: Maybe<Review>;
  deleteStructuringFollowUp?: Maybe<Scalars['Boolean']>;
  determineApprovalMutation?: Maybe<DetermineApproval>;
  disableFinixPaymentInstrumentResolver?: Maybe<DeleteFinixInstrumentGraphQlType>;
  dismissCustomerNotification?: Maybe<Array<Maybe<CustomerNotification>>>;
  distributeR1Contract: ContractDistribution;
  duplicateDeal: Deal;
  eiRedirect?: Maybe<EiRedirectGraphQlType>;
  employerPhoneLookup: EmployerPhoneLookupResult;
  ensureFinixIdentity?: Maybe<Scalars['String']>;
  estimateUpsert?: Maybe<Deal>;
  executeCardDownPayment?: Maybe<FinixTransfer>;
  executeDownPayment?: Maybe<FinixTransfer>;
  executeExternalSoftPull?: Maybe<Scalars['Boolean']>;
  externalAcquirePayoffForDeal: AcquirePayoffResponse;
  externalCustomerSetTempPassword?: Maybe<Customer>;
  externalCustomerUpdate?: Maybe<Customer>;
  externalUpdateDeal?: Maybe<Deal>;
  fetchDealProductRates: DealProductRatesResult;
  fileSend?: Maybe<Message>;
  fillMessageTemplate: FillMessageTemplateResult;
  finalizeR1Signing?: Maybe<Scalars['Void']>;
  financialInfoAcquisitionUpsert?: Maybe<FinancialInfoAcquisition>;
  followUpComplete?: Maybe<FollowUp>;
  followUpDelete?: Maybe<FollowUp>;
  followUpInsert?: Maybe<FollowUp>;
  followUpUpdate?: Maybe<FollowUp>;
  generatePhotoToken?: Maybe<PhotoToken>;
  getMarketPrequalification: MarketPrequalification;
  getMarketPrequalificationAffiliate: MarketPrequalification;
  handleThunderOutboundCall?: Maybe<ResultHandleThunderOutboundCall>;
  handleThunderOutboundCallOutcome?: Maybe<Scalars['Boolean']>;
  hangUpCall?: Maybe<Scalars['Boolean']>;
  importDeal?: Maybe<Deal>;
  insertDevAffiliateFromTempInfo?: Maybe<Scalars['String']>;
  linkConsentIdentifiers: Scalars['Boolean'];
  linkIdentifiersToOptOuts: Scalars['Boolean'];
  logSigningError?: Maybe<SigningError>;
  logViewedDocumentEvent?: Maybe<Scalars['Void']>;
  manuallySelectBank: FinancialInfo;
  markAlertsAsSeen: Array<Alert>;
  markCustomerNotificationAsSeen?: Maybe<Array<Maybe<CustomerNotification>>>;
  markCustomerNotificationsAsSeen?: Maybe<Array<Maybe<CustomerNotification>>>;
  markMissedSipNotificationAsSeen?: Maybe<Scalars['Boolean']>;
  markRecipientThreadSeen: DealUnreadMessageCount;
  markUnknownNumberThreadSeen: ConversationSummary;
  mediaDelete?: Maybe<Scalars['Boolean']>;
  mediaDeleteFromCom?: Maybe<Scalars['Boolean']>;
  mediaInsert?: Maybe<DealMedia>;
  mediaInsertCom?: Maybe<DealMedia>;
  mediaRename?: Maybe<Scalars['Boolean']>;
  mediaUpdate?: Maybe<DealMedia>;
  mediaUpdateCom?: Maybe<DealMedia>;
  mergeCreditApplicationV2?: Maybe<Scalars['Boolean']>;
  mergeFiles?: Maybe<MergedDocuments>;
  messageSend?: Maybe<Message>;
  messageSendV2?: Maybe<MessageV2>;
  mockDealProcessing?: Maybe<Scalars['Void']>;
  newEstimateUpsert?: Maybe<Deal>;
  noteCreate?: Maybe<Note>;
  noteDelete?: Maybe<Note>;
  noteUpdate?: Maybe<Note>;
  notificationsSeen?: Maybe<Scalars['Boolean']>;
  optOut?: Maybe<Scalars['Void']>;
  overrideCalledByFinancialSpecialist?: Maybe<Deal>;
  patchDealProductPricesV2: Array<DealProduct>;
  payoffRequestCancel?: Maybe<PayoffRequest>;
  payoffRequestConfirm?: Maybe<PayoffRequest>;
  payoffRequestFail?: Maybe<PayoffRequest>;
  payoffRequestFailureRequest?: Maybe<PayoffRequest>;
  payoffRequestUpdate?: Maybe<PayoffRequest>;
  payoffUpdate?: Maybe<Payoff>;
  payoffUpdateV2: PayoffUpdateV2Result;
  podUpsert?: Maybe<Pod>;
  podUpsertAndPodUsersUpdate?: Maybe<BasePod>;
  processPaperwork?: Maybe<Deal>;
  recordConsentDecision: Scalars['ID'];
  registerDealer?: Maybe<Scalars['String']>;
  registerProduct?: Maybe<Scalars['String']>;
  removeDealBookmark: Array<Deal>;
  removeDuplicateFinancialInfos?: Maybe<Scalars['Boolean']>;
  requestBootV2?: Maybe<Deal>;
  resendEmails?: Maybe<Scalars['Boolean']>;
  resetPasswordAndSendEmail?: Maybe<Scalars['Void']>;
  resetProcessorAssignment?: Maybe<FinancialInfo>;
  resolveDealIssue: DealIssue;
  resolveFundingRequirement: FundingRequirement;
  restoreCobuyerFromCreditApplicationV2: Customer;
  retrieveEntityIdentities?: Maybe<MethodFiRetrieveIdentitiesData>;
  reviveBoot?: Maybe<Scalars['Boolean']>;
  reviveBootV2?: Maybe<Deal>;
  runAutoStructureCrons?: Maybe<Scalars['Void']>;
  saveConsent: SaveConsent;
  saveNewCustomerCallOutcome?: Maybe<Call>;
  secureLinkCustomerUpdate?: Maybe<Scalars['Void']>;
  selectCreditDecision?: Maybe<SelectCreditDecision>;
  selectCreditDecisionV2: SelectCreditDecisionV2Result;
  selectDealProductVscRate: SelectDealProductVscRateResult;
  selectPackageSlot: Deal;
  sendContracts?: Maybe<Scalars['Boolean']>;
  sendDevAffiliateToThunder?: Maybe<Scalars['JSONObject']>;
  sendDocumentsWithAdobeAndUpdateState?: Maybe<Deal>;
  sendPaymentEstimateEmailAndText?: Maybe<Scalars['Boolean']>;
  sendPaymentEstimateEmailAndTextAffiliate?: Maybe<Scalars['Boolean']>;
  sendROIDocumentsWithAdobe?: Maybe<Deal>;
  sendThirdPartyPayoff: ThirdPartyPayoffSend;
  setDealProductManualTerm: DealProduct;
  setDealSubscription: Deal;
  setNotePinned: Note;
  setReadyForSignaturesStatus?: Maybe<Scalars['Boolean']>;
  skipTimelineStep?: Maybe<Deal>;
  softDeleteUser?: Maybe<Scalars['Boolean']>;
  storeSignatureData?: Maybe<Scalars['Boolean']>;
  submitAfterHoursSelfServePayoff?: Maybe<PayoffRequest>;
  submitCreditApplicationV2: CreditApplication;
  submitMarketplaceSelfServePayoff?: Maybe<Deal>;
  submitToProviders?: Maybe<Deal>;
  submitToProvidersV2?: Maybe<Deal>;
  temporaryInfoImport?: Maybe<Deal>;
  temporaryInfoImportAffiliate?: Maybe<Deal>;
  temporaryInfoSsnUpdate?: Maybe<TemporaryInfo>;
  temporaryInfoUpdate?: Maybe<TemporaryInfo>;
  temporaryInfoUpdateAffiliate?: Maybe<TemporaryInfo>;
  transformLendingTreeLeadToDeal?: Maybe<Deal>;
  undoTieDownDecision: TieDown;
  unlinkTemporaryInfo?: Maybe<TemporaryInfo>;
  unlockDeal?: Maybe<Scalars['Boolean']>;
  updateArticle?: Maybe<Article>;
  updateCar?: Maybe<Car>;
  updateCreditAppOnDeal?: Maybe<UpdateCreditAppOnDealResponse>;
  updateCreditApplicationV2: CreditApplication;
  updateCustomDate?: Maybe<DealDates>;
  updateCustomer?: Maybe<Customer>;
  updateCustomerAndAddress?: Maybe<Customer>;
  updateCustomerContactInfoAccordion?: Maybe<Customer>;
  updateDealContactV2?: Maybe<DealContact>;
  updateDealNeedsElectronicSignatureVerification?: Maybe<Deal>;
  updateDealPackageConfigSlot: UpdateDealPackageConfigSlotPayload;
  updateDealProductRates: DealProductRatesResult;
  updateDealProductsV2: Deal;
  updateDealV2: Deal;
  updateEmploymentInfo?: Maybe<Customer>;
  updateFinancialInfoV2: FinancialInfo;
  updateInsuranceInfo?: Maybe<ProofOfInsurance>;
  updateNoteText: Note;
  updateOriginalLesseeV2?: Maybe<OriginalLesseeV2>;
  updatePayoffClerk?: Maybe<Scalars['Boolean']>;
  updatePersonalInformation?: Maybe<Customer>;
  updateProcessor?: Maybe<FinancialInfo>;
  updateReferrer?: Maybe<ReferrerGraphQlType>;
  updateResidentialInfo?: Maybe<Customer>;
  updateReview?: Maybe<Review>;
  updateSSN?: Maybe<Scalars['ID']>;
  updateStructuringFollowUpNotes?: Maybe<Scalars['Boolean']>;
  updateSubscriptionToNotificationsStatus?: Maybe<NotificationSubscriber>;
  updateTitlingOptions: TitlingOptionsResult;
  updateUser?: Maybe<User>;
  updateUserCallStatus?: Maybe<User>;
  updateUserPreferences: UserPreferences;
  updateUserSettings?: Maybe<User>;
  updateVerificationSession?: Maybe<MethodFiVerificationSession>;
  uploadAndSendMedia?: Maybe<MediaSendResult>;
  uploadDocument?: Maybe<ExtractedDocumentGql>;
  uploadDocumentToRouteOne?: Maybe<Scalars['Boolean']>;
  /** Uploads one document to the deal's Route One funding jacket and returns the updated media row. */
  uploadDocumentToRouteOneV2?: Maybe<EnhancedDealMedia>;
  uploadDocumentsToCUDL?: Maybe<UploadDocumentsToCudlResult>;
  uploadDriversLicense?: Maybe<DriversLicenseGql>;
  upsertDealPackageConfigs: Array<DealPackageConfig>;
  upsertOriginalLessee?: Maybe<OriginalLessee>;
  vehicleInfoUpsert?: Maybe<Deal>;
  verifyAccount?: Maybe<Scalars['Void']>;
  verifyFinixPaymentInstrumentResolver?: Maybe<VerifyFinixInstrumentGraphQlType>;
};


export type RootMutationTypeAcquirePayoffForDealArgs = {
  dealId: Scalars['Int'];
  payloadFields: Array<Scalars['String']>;
};


export type RootMutationTypeAcquirePayoffForTemporaryInfoArgs = {
  payloadFields: Array<Scalars['String']>;
};


export type RootMutationTypeAcquisitionDealInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};


export type RootMutationTypeAddDealBookmarkArgs = {
  dealId: Scalars['Int'];
};


export type RootMutationTypeAddDocumentsToMediaCenterArgs = {
  deal_id: Scalars['ID'];
  files?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
};


export type RootMutationTypeAddLendersToCreditApplicationV2Args = {
  id: Scalars['ID'];
  lenderIds: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeAddNoteArgs = {
  input: NoteInputV2;
};


export type RootMutationTypeAddParticipantArgs = {
  agent_phone?: InputMaybe<Scalars['String']>;
  conference_command?: InputMaybe<Scalars['String']>;
  conference_id?: InputMaybe<Scalars['String']>;
  hunt_group_slug?: InputMaybe<Scalars['String']>;
  new_agent_phone?: InputMaybe<Scalars['String']>;
  new_agent_user_id?: InputMaybe<Scalars['String']>;
  waiting_call_id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeApplyDocumentSignatureArgs = {
  dealId: Scalars['ID'];
  dealJacketID: Scalars['String'];
  documentID: Scalars['String'];
  documentName: Scalars['String'];
  isCobuyer?: InputMaybe<Scalars['Boolean']>;
  isLastSignature?: InputMaybe<Scalars['Boolean']>;
  signatureData: Scalars['String'];
  signatureFieldName: Scalars['String'];
};


export type RootMutationTypeApproveTieDownArgs = {
  id: Scalars['ID'];
  review_note?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeArchivePodArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type RootMutationTypeAttachFundingRequirementFileArgs = {
  fileId: Scalars['Int'];
  id: Scalars['Int'];
};


export type RootMutationTypeAuctionUpsertArgs = {
  auction?: InputMaybe<AuctionInput>;
};


export type RootMutationTypeAuthenticateAnonymousCustomerArgs = {
  tempInfoId: Scalars['String'];
};


export type RootMutationTypeAutomateCreditApplicationArgs = {
  deal_id: Scalars['ID'];
};


export type RootMutationTypeBuyerCobuyerSwapArgs = {
  cobuyer_id: Scalars['ID'];
  customer_id: Scalars['ID'];
  deal_id: Scalars['ID'];
};


export type RootMutationTypeBuyerCobuyerSwapV2Args = {
  dealId: Scalars['Int'];
};


export type RootMutationTypeCalculateDealFeesArgs = {
  dealId: Scalars['Int'];
};


export type RootMutationTypeCallOutArgs = {
  calledNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  thunderCallerIdOverride?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCallOutWithAiArgs = {
  calledNumber: Scalars['String'];
  payload: AiCallInputPayload;
};


export type RootMutationTypeCancelBootRequestV2Args = {
  id: Scalars['Int'];
};


export type RootMutationTypeCancelPayoffRequestByTemporaryInfoIdArgs = {
  temporaryInfoId: Scalars['ID'];
};


export type RootMutationTypeCancelTieDownArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeClearR1DealDocsArgs = {
  dealId: Scalars['Int'];
};


export type RootMutationTypeConditionReportUpsertArgs = {
  conditionReport?: InputMaybe<ConditionReportUpsertInput>;
};


export type RootMutationTypeConnectAndRetrieveEntityDataArgs = {
  devOldCarOverride?: InputMaybe<Scalars['Boolean']>;
  entityId: Scalars['String'];
  separateIdentityCall?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeCounterTieDownArgs = {
  id: Scalars['ID'];
  review_note?: InputMaybe<Scalars['String']>;
  values: Array<TieDownCounteredValueInput>;
};


export type RootMutationTypeCreateAffiliateApiKeyArgs = {
  affiliateApiKey?: InputMaybe<AffiliateApiKeyInput>;
};


export type RootMutationTypeCreateAffiliateProviderArgs = {
  affiliateProvider?: InputMaybe<AffiliateProviderInput>;
};


export type RootMutationTypeCreateAffiliateTemporaryInfoArgs = {
  country?: InputMaybe<Country>;
  device_type?: InputMaybe<Scalars['String']>;
  query_params?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateAndSendSecureLinkArgs = {
  customerId: Scalars['ID'];
  expiresInHours: Scalars['Int'];
  sendEmail: Scalars['Boolean'];
  sendText: Scalars['Boolean'];
};


export type RootMutationTypeCreateArticleArgs = {
  article?: InputMaybe<ArticleInput>;
};


export type RootMutationTypeCreateBookSheetsV2Args = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeCreateCreditApplicationV2Args = {
  input: CreditApplicationCreateInput;
};


export type RootMutationTypeCreateDealIssueArgs = {
  comment: Scalars['String'];
  dealId: Scalars['Int'];
  slug: DealIssueSlug;
};


export type RootMutationTypeCreateDealV2Args = {
  input: CreateDealInput;
};


export type RootMutationTypeCreateEmbeddedInsuranceLeadAndGetLinkArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeCreateExternalDealUploadUrlArgs = {
  dealId: Scalars['ID'];
  fileDescription: Scalars['String'];
  fileName: Scalars['String'];
};


export type RootMutationTypeCreateExternalTempInfoUploadUrlArgs = {
  fileDescription: Scalars['String'];
  fileName: Scalars['String'];
  guid: Scalars['ID'];
};


export type RootMutationTypeCreateFeedbackArgs = {
  deal_id: Scalars['ID'];
  email: Scalars['String'];
  improvements: Scalars['String'];
  name: Scalars['String'];
  rating: Scalars['Int'];
};


export type RootMutationTypeCreateFinixPaymentInstrumentTokenResolverArgs = {
  identity: Scalars['String'];
  token: Scalars['String'];
};


export type RootMutationTypeCreateFinixPaymentMerchantResolverArgs = {
  identity: Scalars['String'];
};


export type RootMutationTypeCreateFundingRequirementArgs = {
  dealId: Scalars['Int'];
  slug: FundingRequirementSlug;
};


export type RootMutationTypeCreateIndividualEntityArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type RootMutationTypeCreateJdpBookSheetArgs = {
  customerState: Scalars['String'];
  dealId: Scalars['ID'];
};


export type RootMutationTypeCreateKbbBookSheetArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeCreateKyoVerificationArgs = {
  entityId: Scalars['String'];
};


export type RootMutationTypeCreateManualEntryTemporaryInfoArgs = {
  device_type?: InputMaybe<Scalars['String']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  fuel_type?: InputMaybe<Scalars['String']>;
  kbb_trim_name?: InputMaybe<Scalars['String']>;
  license_plate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  query_params?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateManualPayoffRequestArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeCreateNewEstimateAndSetFollowUpArgs = {
  address_line?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  date_utc: Scalars['DateTime'];
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  phone_number: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateNewEstimateFromFilesArgs = {
  data?: InputMaybe<TemporaryDataInput>;
  files?: InputMaybe<Array<InputMaybe<NewEstimateFileInput>>>;
};


export type RootMutationTypeCreateNpsSurveyResultArgs = {
  input: NpsSurveyResultInput;
};


export type RootMutationTypeCreateOptEventArgs = {
  event: OptEventInput;
};


export type RootMutationTypeCreatePayoffRequestArgs = {
  dealId: Scalars['ID'];
  digitalPayoffAvailable: Scalars['Boolean'];
  doubleTaxApplicable: Scalars['Boolean'];
};


export type RootMutationTypeCreatePotentialUserArgs = {
  potential_user?: InputMaybe<PotentialUserInput>;
};


export type RootMutationTypeCreateReferrerPaymentInstrumentResolverArgs = {
  identity: Scalars['String'];
  token: Scalars['String'];
};


export type RootMutationTypeCreateReviewArgs = {
  review?: InputMaybe<ReviewInput>;
};


export type RootMutationTypeCreateStructuringFollowUpArgs = {
  dealId: Scalars['ID'];
  notes: Scalars['String'];
};


export type RootMutationTypeCreateTemporaryInfoArgs = {
  deal_type?: InputMaybe<DealType>;
  device_type?: InputMaybe<Scalars['String']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']>;
  is_methodfi_flow?: InputMaybe<Scalars['Boolean']>;
  license_plate_number?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  methodfi_flow_variation?: InputMaybe<Scalars['Int']>;
  query_params?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateTemporaryInfoAffiliateArgs = {
  device_type?: InputMaybe<Scalars['String']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']>;
  license_plate_number?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  query_params?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateTieDownArgs = {
  input: CreateTieDownInput;
};


export type RootMutationTypeCreateTransactionArgs = {
  input?: InputMaybe<CreateTransactionInput>;
};


export type RootMutationTypeCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type RootMutationTypeCreateVerificationSessionArgs = {
  entityId: Scalars['String'];
};


export type RootMutationTypeCustomDatesUpdateArgs = {
  date: Scalars['DateTime'];
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID'];
};


export type RootMutationTypeCustomerInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};


export type RootMutationTypeDeactivateAffiliateApiKeyArgs = {
  affiliateApiKeyId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDealAssignArgs = {
  allow_reassign?: InputMaybe<Scalars['Boolean']>;
  assignee_id?: InputMaybe<Scalars['String']>;
  deal_id: Scalars['ID'];
  deal_state?: InputMaybe<Scalars['String']>;
  role: Scalars['String'];
};


export type RootMutationTypeDealCompletedArgs = {
  id: Scalars['ID'];
  state: Scalars['String'];
};


export type RootMutationTypeDealCompletedV2Args = {
  id: Scalars['Int'];
};


export type RootMutationTypeDealDetailNetsuiteArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDealFinalizeAcquisitionArgs = {
  address_line: Scalars['String'];
  address_line_2?: InputMaybe<Scalars['String']>;
  cash_to_customer: Scalars['Float'];
  city: Scalars['String'];
  county: Scalars['String'];
  dob: Scalars['Date'];
  id: Scalars['ID'];
  mileage?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
  zip: Scalars['String'];
};


export type RootMutationTypeDealInfoUpsertArgs = {
  car?: InputMaybe<CarInput>;
  customer?: InputMaybe<CustomerInput>;
  financialInfo?: InputMaybe<FinancialInfoInput>;
  publishUpdates?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeDealSeenArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeDealSendToBankArgs = {
  dealId: Scalars['ID'];
  sent: Scalars['Boolean'];
  skipDistribute?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeDealTagsUpsertArgs = {
  dealId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type RootMutationTypeDealUnwoundArgs = {
  boot_reason: BootReasonInput;
  id: Scalars['ID'];
};


export type RootMutationTypeDealUpdateAssignmentsArgs = {
  closer2_id?: InputMaybe<Scalars['String']>;
  closer_id?: InputMaybe<Scalars['String']>;
  deal_source?: InputMaybe<Scalars['String']>;
  fs_pod_id?: InputMaybe<Scalars['ID']>;
  funding_clerk_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pod_id?: InputMaybe<Scalars['ID']>;
  setter_id?: InputMaybe<Scalars['String']>;
  structuring_manager_id?: InputMaybe<Scalars['String']>;
  title_clerk2_id?: InputMaybe<Scalars['String']>;
  title_clerk_id?: InputMaybe<Scalars['String']>;
  titling_pod_id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<DealType>;
};


export type RootMutationTypeDealUpdateRequestBootArgs = {
  boot_deal?: InputMaybe<Scalars['Boolean']>;
  boot_reason: BootReasonInput;
  id: Scalars['ID'];
  partial_note?: InputMaybe<NoteInput>;
  request_boot: Scalars['Boolean'];
};


export type RootMutationTypeDealUpdateStateArgs = {
  clearApprovedDate?: InputMaybe<Scalars['Boolean']>;
  clearSetDate?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDealUpdateStateAndSendEmailsArgs = {
  contactType?: InputMaybe<ContactType>;
  date?: InputMaybe<Scalars['DateTime']>;
  dealIsSigningOnCom?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isR1ContractUploaded?: InputMaybe<Scalars['Boolean']>;
  isR1ContractValidated?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
};


export type RootMutationTypeDeclineTieDownArgs = {
  id: Scalars['ID'];
  review_note?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDecryptSsnArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  originalLesseeId?: InputMaybe<Scalars['ID']>;
  tempInfoId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeDeleteAndReplaceFilesArgs = {
  deal_id: Scalars['ID'];
  files_to_delete?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
  files_to_upload?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
};


export type RootMutationTypeDeleteArticleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeDeleteComFlowFileArgs = {
  key: Scalars['String'];
};


export type RootMutationTypeDeleteContractsArgs = {
  filePaths: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeDeleteCreditApplicationV2Args = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteDealIssueArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteDealV2Args = {
  id: Scalars['Int'];
};


export type RootMutationTypeDeleteFundingRequirementArgs = {
  id: Scalars['Int'];
};


export type RootMutationTypeDeleteNoteArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteReviewArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeDeleteStructuringFollowUpArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDetermineApprovalMutationArgs = {
  data: DetermineApprovalInput;
};


export type RootMutationTypeDisableFinixPaymentInstrumentResolverArgs = {
  identity: Scalars['String'];
  instrument: Scalars['String'];
};


export type RootMutationTypeDismissCustomerNotificationArgs = {
  dealId: Scalars['ID'];
  id: Scalars['ID'];
  isCobuyer: Scalars['Boolean'];
};


export type RootMutationTypeDistributeR1ContractArgs = {
  dealId: Scalars['ID'];
  documentIds: Array<Scalars['String']>;
};


export type RootMutationTypeDuplicateDealArgs = {
  dealId: Scalars['ID'];
  duplicationType: DuplicateTypeEnum;
};


export type RootMutationTypeEiRedirectArgs = {
  leadId: Scalars['String'];
};


export type RootMutationTypeEmployerPhoneLookupArgs = {
  input: EmployerPhoneLookupInput;
};


export type RootMutationTypeEnsureFinixIdentityArgs = {
  address_city: Scalars['String'];
  address_line_1: Scalars['String'];
  address_postal_code: Scalars['String'];
  address_state: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  phone_number: Scalars['String'];
  referrer_id: Scalars['Int'];
};


export type RootMutationTypeEstimateUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};


export type RootMutationTypeExecuteCardDownPaymentArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  dealId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  idempotencyId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeExecuteDownPaymentArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  bank?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  idempotencyId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  plaidAccountId?: InputMaybe<Scalars['String']>;
  plaidToken?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeExecuteExternalSoftPullArgs = {
  isHardPull: Scalars['Boolean'];
  paymentEstimateInput: PaymentEstimateInput;
};


export type RootMutationTypeExternalAcquirePayoffForDealArgs = {
  dealId: Scalars['ID'];
  fields: ExternalPayoffIntelligenceFieldsInput;
  payloadFields: Array<LienholderRequirement>;
};


export type RootMutationTypeExternalCustomerSetTempPasswordArgs = {
  customerId: Scalars['Int'];
};


export type RootMutationTypeExternalCustomerUpdateArgs = {
  customer?: InputMaybe<ExternalCustomerInput>;
  customerId: Scalars['ID'];
};


export type RootMutationTypeExternalUpdateDealArgs = {
  data?: InputMaybe<ExternalDealInputType>;
  dealId?: InputMaybe<Scalars['ID']>;
  tempInfoId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeFetchDealProductRatesArgs = {
  input: FetchDealProductRatesInput;
};


export type RootMutationTypeFileSendArgs = {
  dealPhoneNumber: Scalars['String'];
  file: Scalars['String'];
  id: Scalars['ID'];
};


export type RootMutationTypeFillMessageTemplateArgs = {
  input: FillMessageTemplateInput;
};


export type RootMutationTypeFinalizeR1SigningArgs = {
  dealId: Scalars['ID'];
  dealJacketID: Scalars['String'];
};


export type RootMutationTypeFinancialInfoAcquisitionUpsertArgs = {
  car_id?: InputMaybe<Scalars['ID']>;
  clear_override?: InputMaybe<Scalars['Boolean']>;
  financialInfoAcquisition?: InputMaybe<FinancialInfoAcquisitionInput>;
  id: Scalars['ID'];
  mmr?: InputMaybe<Scalars['Float']>;
  override?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
};


export type RootMutationTypeFollowUpCompleteArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeFollowUpDeleteArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeFollowUpInsertArgs = {
  date_utc: Scalars['DateTime'];
  deal_id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  type: FollowUpTypeEnum;
  tz: Scalars['String'];
};


export type RootMutationTypeFollowUpUpdateArgs = {
  date_utc: Scalars['DateTime'];
  deal_id: Scalars['ID'];
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  type: FollowUpTypeEnum;
  tz: Scalars['String'];
};


export type RootMutationTypeGeneratePhotoTokenArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeGetMarketPrequalificationArgs = {
  addressLine?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  prequalId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeGetMarketPrequalificationAffiliateArgs = {
  addressLine?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  prequalId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeHandleThunderOutboundCallArgs = {
  hunt_group_slug?: InputMaybe<Scalars['String']>;
  thunder_call_notification_id?: InputMaybe<Scalars['ID']>;
  waiting_call_id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeHandleThunderOutboundCallOutcomeArgs = {
  answered?: InputMaybe<Scalars['Boolean']>;
  attemptNum?: InputMaybe<Scalars['Int']>;
  calledNumber?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['ID']>;
  thunderCallNotificationId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeHangUpCallArgs = {
  conference_id: Scalars['String'];
};


export type RootMutationTypeImportDealArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeInsertDevAffiliateFromTempInfoArgs = {
  externalId: Scalars['ID'];
  tempInfoId: Scalars['ID'];
};


export type RootMutationTypeLinkConsentIdentifiersArgs = {
  consentEventId: Scalars['ID'];
  howLinked: ConsentHowLinked;
  identifiers: Array<ConsentIdentifierInput>;
};


export type RootMutationTypeLinkIdentifiersToOptOutsArgs = {
  howLinked: ConsentHowLinked;
  identifiers: Array<ConsentIdentifierInput>;
};


export type RootMutationTypeLogSigningErrorArgs = {
  error: SigningErrorInput;
};


export type RootMutationTypeLogViewedDocumentEventArgs = {
  documentViewedEvent: SigningAuditDocumentViewedEvent;
};


export type RootMutationTypeManuallySelectBankArgs = {
  bank: Scalars['String'];
  dealId: Scalars['ID'];
};


export type RootMutationTypeMarkAlertsAsSeenArgs = {
  input?: InputMaybe<MarkAlertsAsSeenInput>;
};


export type RootMutationTypeMarkCustomerNotificationAsSeenArgs = {
  dealId: Scalars['ID'];
  id: Scalars['ID'];
  isCobuyer: Scalars['Boolean'];
};


export type RootMutationTypeMarkCustomerNotificationsAsSeenArgs = {
  dealId: Scalars['ID'];
  isCobuyer: Scalars['Boolean'];
};


export type RootMutationTypeMarkMissedSipNotificationAsSeenArgs = {
  callIds: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeMarkRecipientThreadSeenArgs = {
  dealId: Scalars['Int'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  recipientId: Scalars['Int'];
  recipientType: Scalars['String'];
};


export type RootMutationTypeMarkUnknownNumberThreadSeenArgs = {
  phone: Scalars['String'];
};


export type RootMutationTypeMediaDeleteArgs = {
  filePath: Scalars['String'];
};


export type RootMutationTypeMediaDeleteFromComArgs = {
  dealId: Scalars['ID'];
  filePath: Scalars['String'];
};


export type RootMutationTypeMediaInsertArgs = {
  dealId: Scalars['ID'];
  key: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  type?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeMediaInsertComArgs = {
  dealId: Scalars['ID'];
  key: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};


export type RootMutationTypeMediaRenameArgs = {
  dealId: Scalars['ID'];
  fileName: Scalars['String'];
  filePath: Scalars['String'];
};


export type RootMutationTypeMediaUpdateArgs = {
  dealId: Scalars['ID'];
  has_verified_digital_signature?: InputMaybe<Scalars['Boolean']>;
  has_wet_signature?: InputMaybe<Scalars['Boolean']>;
  is_notarized?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  newFileName?: InputMaybe<Scalars['String']>;
  oldKey: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeMediaUpdateComArgs = {
  dealId: Scalars['ID'];
  newFileName?: InputMaybe<Scalars['String']>;
  oldKey: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeMergeCreditApplicationV2Args = {
  approved_date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imported_date_utc?: InputMaybe<Scalars['DateTime']>;
  set_date?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<DealStateEnum>;
};


export type RootMutationTypeMergeFilesArgs = {
  dealId: Scalars['ID'];
  docs?: InputMaybe<Array<InputMaybe<DealMediaInput>>>;
};


export type RootMutationTypeMessageSendArgs = {
  dealPhoneNumber: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
};


export type RootMutationTypeMessageSendV2Args = {
  dealId?: InputMaybe<Scalars['Int']>;
  dealPhoneNumber: Scalars['String'];
  message: Scalars['String'];
};


export type RootMutationTypeMockDealProcessingArgs = {
  deal_id: Scalars['ID'];
  has_gap: Scalars['Boolean'];
  has_vsc: Scalars['Boolean'];
  is_conditioned: Scalars['Boolean'];
};


export type RootMutationTypeNewEstimateUpsertArgs = {
  newEstimateUpsertInput?: InputMaybe<NewEstimateUpsertInput>;
};


export type RootMutationTypeNoteCreateArgs = {
  note?: InputMaybe<NoteInput>;
};


export type RootMutationTypeNoteDeleteArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeNoteUpdateArgs = {
  note?: InputMaybe<NoteInput>;
};


export type RootMutationTypeNotificationsSeenArgs = {
  notificationIds: Array<Scalars['ID']>;
  seen: Scalars['Boolean'];
};


export type RootMutationTypeOptOutArgs = {
  deal_id?: InputMaybe<Scalars['ID']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeOverrideCalledByFinancialSpecialistArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypePatchDealProductPricesV2Args = {
  input: PatchDealProductPricesInputV2;
};


export type RootMutationTypePayoffRequestCancelArgs = {
  payoffRequestId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypePayoffRequestConfirmArgs = {
  payoffRequest: PayoffRequestConfirmInput;
};


export type RootMutationTypePayoffRequestFailArgs = {
  payoffRequest: PayoffRequestInput;
};


export type RootMutationTypePayoffRequestFailureRequestArgs = {
  payoffRequest: PayoffRequestInput;
};


export type RootMutationTypePayoffRequestUpdateArgs = {
  payoffRequest: PayoffRequestInput;
};


export type RootMutationTypePayoffUpdateArgs = {
  dealId: Scalars['ID'];
  payoffInfo: PayoffInput;
};


export type RootMutationTypePayoffUpdateV2Args = {
  dealId: Scalars['ID'];
  doubleTaxApplicable?: InputMaybe<Scalars['Boolean']>;
  payoffInfo: PayoffInput;
};


export type RootMutationTypePodUpsertArgs = {
  pod?: InputMaybe<BasePodInput>;
};


export type RootMutationTypePodUpsertAndPodUsersUpdateArgs = {
  newPod: PodInput;
  oldPod?: InputMaybe<PodInput>;
};


export type RootMutationTypeProcessPaperworkArgs = {
  id: Scalars['ID'];
  paperwork_type: Scalars['String'];
  state: Scalars['String'];
};


export type RootMutationTypeRecordConsentDecisionArgs = {
  decision: ConsentDecisionInput;
};


export type RootMutationTypeRegisterDealerArgs = {
  dealer?: InputMaybe<DealerInput>;
};


export type RootMutationTypeRegisterProductArgs = {
  dealer_id: Scalars['ID'];
  product_id: Scalars['ID'];
  provider_dealer_code: Scalars['String'];
};


export type RootMutationTypeRemoveDealBookmarkArgs = {
  dealId: Scalars['Int'];
};


export type RootMutationTypeRequestBootV2Args = {
  bootDeal?: InputMaybe<Scalars['Boolean']>;
  bootReason: BootReasonInputV2;
  id: Scalars['Int'];
  partialNote?: InputMaybe<NoteInputV2>;
  requestBoot: Scalars['Boolean'];
  requestConfirmation?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeResendEmailsArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeResetPasswordAndSendEmailArgs = {
  password?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeResetProcessorAssignmentArgs = {
  dealId: Scalars['ID'];
  fiId: Scalars['ID'];
};


export type RootMutationTypeResolveDealIssueArgs = {
  id: Scalars['ID'];
  resolved: Scalars['Boolean'];
};


export type RootMutationTypeResolveFundingRequirementArgs = {
  id: Scalars['Int'];
  resolved: Scalars['Boolean'];
};


export type RootMutationTypeRestoreCobuyerFromCreditApplicationV2Args = {
  creditApplicationId: Scalars['Int'];
  dealId: Scalars['Int'];
};


export type RootMutationTypeRetrieveEntityIdentitiesArgs = {
  entityId: Scalars['String'];
};


export type RootMutationTypeReviveBootArgs = {
  id: Scalars['ID'];
  reassign?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeReviveBootV2Args = {
  id: Scalars['Int'];
  reassign?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeSaveConsentArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ConsentNameEnumType>;
  version?: InputMaybe<Scalars['Int']>;
};


export type RootMutationTypeSaveNewCustomerCallOutcomeArgs = {
  call_id: Scalars['String'];
  outcome?: InputMaybe<Scalars['String']>;
  outcome_description?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeSecureLinkCustomerUpdateArgs = {
  ssn: Scalars['String'];
  token: Scalars['String'];
};


export type RootMutationTypeSelectCreditDecisionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeSelectCreditDecisionV2Args = {
  id: Scalars['ID'];
};


export type RootMutationTypeSelectDealProductVscRateArgs = {
  input: SelectDealProductVscRateInput;
};


export type RootMutationTypeSelectPackageSlotArgs = {
  input: SelectPackageSlotInput;
};


export type RootMutationTypeSendContractsArgs = {
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeSendDevAffiliateToThunderArgs = {
  externalId: Scalars['String'];
};


export type RootMutationTypeSendDocumentsWithAdobeAndUpdateStateArgs = {
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>>;
  state: DealStateEnum;
};


export type RootMutationTypeSendPaymentEstimateEmailAndTextArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeSendPaymentEstimateEmailAndTextAffiliateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeSendRoiDocumentsWithAdobeArgs = {
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeSendThirdPartyPayoffArgs = {
  dealId: Scalars['ID'];
  keys: Array<Scalars['String']>;
};


export type RootMutationTypeSetDealProductManualTermArgs = {
  input: SetDealProductManualTermInputV2;
};


export type RootMutationTypeSetDealSubscriptionArgs = {
  dealId: Scalars['Int'];
  subscribed: Scalars['Boolean'];
};


export type RootMutationTypeSetNotePinnedArgs = {
  id: Scalars['ID'];
  isPinned: Scalars['Boolean'];
};


export type RootMutationTypeSetReadyForSignaturesStatusArgs = {
  dealId: Scalars['ID'];
  documentProgressStatus?: InputMaybe<DocumentProgressStatus>;
};


export type RootMutationTypeSkipTimelineStepArgs = {
  dealId: Scalars['ID'];
  documentProgressStatus?: InputMaybe<DocumentProgressStatus>;
};


export type RootMutationTypeSoftDeleteUserArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeStoreSignatureDataArgs = {
  customer_id: Scalars['ID'];
  initials_data_url?: InputMaybe<Scalars['String']>;
  initials_strokes?: InputMaybe<Scalars['String']>;
  signature_data_url?: InputMaybe<Scalars['String']>;
  signature_strokes?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeSubmitAfterHoursSelfServePayoffArgs = {
  dealId: Scalars['ID'];
  goodThroughDate: Scalars['DateTime'];
  vehiclePayoff: Scalars['Float'];
};


export type RootMutationTypeSubmitCreditApplicationV2Args = {
  id: Scalars['ID'];
  lenderIds: Array<InputMaybe<Scalars['String']>>;
};


export type RootMutationTypeSubmitMarketplaceSelfServePayoffArgs = {
  dealId: Scalars['ID'];
  goodThroughDate: Scalars['DateTime'];
  vehiclePayoff: Scalars['Float'];
};


export type RootMutationTypeSubmitToProvidersArgs = {
  deal?: InputMaybe<DealInput>;
  lenderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationTypeSubmitToProvidersV2Args = {
  dealId: Scalars['ID'];
  lenderIds: Array<Scalars['String']>;
};


export type RootMutationTypeTemporaryInfoImportArgs = {
  id: Scalars['ID'];
  importType?: InputMaybe<ImportType>;
  transformType: TransformType;
};


export type RootMutationTypeTemporaryInfoImportAffiliateArgs = {
  id: Scalars['ID'];
  importType?: InputMaybe<ImportType>;
  transformType: TransformType;
};


export type RootMutationTypeTemporaryInfoSsnUpdateArgs = {
  isCobuyer: Scalars['Boolean'];
  ssn: Scalars['String'];
  tempInfoId: Scalars['ID'];
};


export type RootMutationTypeTemporaryInfoUpdateArgs = {
  info?: InputMaybe<TemporaryInfoInput>;
};


export type RootMutationTypeTemporaryInfoUpdateAffiliateArgs = {
  info?: InputMaybe<TemporaryInfoInput>;
};


export type RootMutationTypeTransformLendingTreeLeadToDealArgs = {
  affiliate: AffiliateInput;
};


export type RootMutationTypeUndoTieDownDecisionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeUnlinkTemporaryInfoArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeUnlockDealArgs = {
  dealId: Scalars['ID'];
};


export type RootMutationTypeUpdateArticleArgs = {
  article?: InputMaybe<ArticleInput>;
};


export type RootMutationTypeUpdateCarArgs = {
  car?: InputMaybe<CarInput>;
};


export type RootMutationTypeUpdateCreditAppOnDealArgs = {
  input: CreditAppInput;
};


export type RootMutationTypeUpdateCreditApplicationV2Args = {
  input: CreditApplicationUpdateInput;
};


export type RootMutationTypeUpdateCustomDateArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID'];
};


export type RootMutationTypeUpdateCustomerArgs = {
  customer?: InputMaybe<CustomerInput>;
  dealId?: InputMaybe<Scalars['Int']>;
};


export type RootMutationTypeUpdateCustomerAndAddressArgs = {
  customer?: InputMaybe<CustomerInput>;
  dealId?: InputMaybe<Scalars['Int']>;
};


export type RootMutationTypeUpdateCustomerContactInfoAccordionArgs = {
  customerContactInfo?: InputMaybe<CustomerContactInfoInput>;
  customerId?: InputMaybe<Scalars['Int']>;
  dealId: Scalars['Int'];
};


export type RootMutationTypeUpdateDealContactV2Args = {
  contactData?: InputMaybe<DealContactInput>;
  contactId?: InputMaybe<Scalars['Int']>;
  dealId: Scalars['Int'];
};


export type RootMutationTypeUpdateDealNeedsElectronicSignatureVerificationArgs = {
  deal_id: Scalars['ID'];
  needs_electronic_signature_verification: Scalars['Boolean'];
};


export type RootMutationTypeUpdateDealPackageConfigSlotArgs = {
  input: UpdateDealPackageConfigSlotInput;
};


export type RootMutationTypeUpdateDealProductRatesArgs = {
  input: UpdateDealProductRatesInput;
};


export type RootMutationTypeUpdateDealProductsV2Args = {
  input: UpdateDealProductsInputV2;
};


export type RootMutationTypeUpdateDealV2Args = {
  input: DealInput;
};


export type RootMutationTypeUpdateEmploymentInfoArgs = {
  input: EmploymentInfoInput;
};


export type RootMutationTypeUpdateFinancialInfoV2Args = {
  id: Scalars['Int'];
  input: FinancialInfoInputV2Input;
};


export type RootMutationTypeUpdateInsuranceInfoArgs = {
  expiration_date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  insurance_company?: InputMaybe<Scalars['String']>;
  policy_no?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateNoteTextArgs = {
  id: Scalars['ID'];
  input: UpdateNoteTextInput;
};


export type RootMutationTypeUpdateOriginalLesseeV2Args = {
  dealId: Scalars['Int'];
  originalLessee?: InputMaybe<OriginalLesseeV2Input>;
};


export type RootMutationTypeUpdatePayoffClerkArgs = {
  payoff_clerk_id?: InputMaybe<Scalars['String']>;
  payoff_request_id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeUpdatePersonalInformationArgs = {
  input: PersonalInfoInput;
};


export type RootMutationTypeUpdateProcessorArgs = {
  dealId: Scalars['ID'];
  fiId: Scalars['ID'];
  processor?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateReferrerArgs = {
  data?: InputMaybe<ReferrerUpdateInput>;
  id: Scalars['Int'];
};


export type RootMutationTypeUpdateResidentialInfoArgs = {
  input: ResidentialInfoInput;
};


export type RootMutationTypeUpdateReviewArgs = {
  review?: InputMaybe<ReviewInput>;
};


export type RootMutationTypeUpdateSsnArgs = {
  ssn: Scalars['String'];
  ssnId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeUpdateStructuringFollowUpNotesArgs = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};


export type RootMutationTypeUpdateSubscriptionToNotificationsStatusArgs = {
  dealId: Scalars['ID'];
  subscribeToNotifications: Scalars['Boolean'];
};


export type RootMutationTypeUpdateTitlingOptionsArgs = {
  input: TitlingInput;
};


export type RootMutationTypeUpdateUserArgs = {
  allAuth0RoleIds: Array<Scalars['String']>;
  updateUserInput: UpdateUserInput;
};


export type RootMutationTypeUpdateUserCallStatusArgs = {
  status: CallStatus;
};


export type RootMutationTypeUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};


export type RootMutationTypeUpdateUserSettingsArgs = {
  accept_ai_touched_deals: Scalars['Boolean'];
  accept_overnight_deals: Scalars['Boolean'];
  accept_unseen_deals: Scalars['Boolean'];
  accept_with_upcoming_appointment: Scalars['Boolean'];
  assignment_mode: AssignmentMode;
  auto_assign_deals: Scalars['Boolean'];
  deals_with_bank_fees: Scalars['Boolean'];
  deals_with_direct_pay: Scalars['Boolean'];
  deals_with_double_tax: Scalars['Boolean'];
  deals_with_down_payment: Scalars['Boolean'];
  deals_with_gap: Scalars['Boolean'];
  deals_with_stipulations: Scalars['Boolean'];
  deals_with_vsc: Scalars['Boolean'];
  frequency_minutes: Scalars['Int'];
  hours: Scalars['String'];
  id: Scalars['String'];
  max_auto_assign_deals: Scalars['Int'];
  on_vacation: Scalars['Boolean'];
  user_type: UserType;
};


export type RootMutationTypeUpdateVerificationSessionArgs = {
  code: Scalars['String'];
  entityId: Scalars['String'];
  verificationSessionId: Scalars['String'];
};


export type RootMutationTypeUploadAndSendMediaArgs = {
  contentType: Scalars['String'];
  dealId: Scalars['Int'];
  dealPhoneNumber: Scalars['String'];
  fileData: Scalars['String'];
  fileName: Scalars['String'];
};


export type RootMutationTypeUploadDocumentArgs = {
  bytes?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<TtDocumentName>;
};


export type RootMutationTypeUploadDocumentToRouteOneArgs = {
  dealId: Scalars['ID'];
  doc: UploadDocumentsInput;
  subscriptionArgs?: InputMaybe<DocumentPreparationProgressSubscriptionArgs>;
  withCobuyer: Scalars['Boolean'];
};


export type RootMutationTypeUploadDocumentToRouteOneV2Args = {
  dealId: Scalars['ID'];
  doc: UploadDocumentsInput;
  withCobuyer: Scalars['Boolean'];
};


export type RootMutationTypeUploadDocumentsToCudlArgs = {
  dealId: Scalars['ID'];
  keys: Array<Scalars['String']>;
};


export type RootMutationTypeUploadDriversLicenseArgs = {
  bytes?: InputMaybe<Scalars['String']>;
  includeGender?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpsertDealPackageConfigsArgs = {
  input: UpsertDealPackageConfigsInput;
};


export type RootMutationTypeUpsertOriginalLesseeArgs = {
  deal_id: Scalars['Int'];
  original_lessee: OriginalLesseeInput;
};


export type RootMutationTypeVehicleInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};


export type RootMutationTypeVerifyAccountArgs = {
  deal_id?: InputMaybe<Scalars['ID']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']>;
  ssn_last_4?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeVerifyFinixPaymentInstrumentResolverArgs = {
  identity: Scalars['String'];
  instrument: Scalars['String'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  inProgressCalls?: Maybe<Array<Maybe<Conference>>>;
  onAICloser?: Maybe<Deal>;
  onAICloserCallStatus?: Maybe<AiCloserCallStatus>;
  /** Signals that the advisor bar's stats changed for the chosen pool. */
  onAdvisorSummaryStatsUpdate: Scalars['Boolean'];
  onAffiliateDuplicateFound?: Maybe<AffiliateDuplicateFound>;
  onAlertCreated: Array<Alert>;
  onAlertRecipientsChanged: AlertRecipientsChangedPayload;
  onAlertsMarkedSeen: AlertsMarkedSeenPayload;
  onContractDistributionUpdated?: Maybe<ContractDistribution>;
  onCreditDecisionCreated?: Maybe<CreditDecisionCreatedPayload>;
  onCreditDecisionSelected?: Maybe<SelectCreditDecision>;
  onCustomDateUpdated?: Maybe<CustomDateUpdatedPayload>;
  onDashboardDocumentUpload?: Maybe<DashboardDocumentUpload>;
  onDealActivityLogged?: Maybe<DealActivityLoggedSubscriptionPayload>;
  onDealComplete?: Maybe<Array<Maybe<Deal>>>;
  onDealImported?: Maybe<DealImported>;
  onDealIssueResolutionStatusChanged: DealIssueResolutionStatusChanged;
  onDealIssuesUpdated: Array<DealIssue>;
  onDealLockStatus?: Maybe<DealLockStatusSubscriptionPayload>;
  onDealMoved?: Maybe<DealMovedSubscriptionPayload>;
  onDealTieDownsChanged: DealTieDown;
  onDealUpdate?: Maybe<Array<Maybe<Deal>>>;
  onDocumentPreparationProgress?: Maybe<DocumentPreparationProgress>;
  onDocumentProgressStatus?: Maybe<Array<Maybe<Deal>>>;
  onDownPaymentReceived?: Maybe<DownPaymentReceived>;
  onDuplicatedDealImport?: Maybe<DuplicatedDealImport>;
  onDuplicatedInfo?: Maybe<DuplicatedInfo>;
  onEmbeddedInsuranceNotification?: Maybe<EmbeddedInsuranceNotification>;
  onFollowUpUpdate?: Maybe<Array<Maybe<Deal>>>;
  /** Signals that the FS bar's stats changed for the chosen pool. */
  onFsSummaryStatsUpdate?: Maybe<Scalars['Boolean']>;
  onFundingRequirementResolutionStatusChanged: FundingRequirementResolutionStatusChanged;
  onFundingRequirementsUpdated: Array<FundingRequirement>;
  onMessageCreatedV2?: Maybe<MessageV2>;
  onMessageNotificationsMarkedSeen: MessageNotificationsMarkedSeen;
  onMessageReceivedV2?: Maybe<MessageV2>;
  onMessageStatusUpdatedV2?: Maybe<MessageV2>;
  onMissedSipCall?: Maybe<OnMissedSipCall>;
  onNewMessage?: Maybe<MessageData>;
  onNoDealNotification?: Maybe<Array<Maybe<Notification>>>;
  onNoteCreated: Array<Note>;
  onNoteDeleted: Array<Scalars['ID']>;
  onNoteUpdated: Array<Note>;
  onPayoffQueueUpdate?: Maybe<PayoffQueueUpdate>;
  onPayoffRequestStatusUpdate?: Maybe<PayoffRequestStatusUpdateWithMessage>;
  onPayoffRequestStatusUpdateV2?: Maybe<PayoffRequestStatusUpdateV2WithMessage>;
  onPayoffRequestUpdate?: Maybe<PayoffRequestPopulated>;
  /** Signals that the pod bar's stats changed for the chosen pool. */
  onPodSummaryStatsUpdate: Scalars['Boolean'];
  onPriorityQueueUpdate: PriorityQueueUpdate;
  onSecureLinkCreated?: Maybe<SecureLinkNotification>;
  onSecureLinkExpired?: Maybe<SecureLinkNotification>;
  onSipRegistrationFailure?: Maybe<OnSipRegistrationFailure>;
  onStructuringFollowUpUpdate?: Maybe<Array<Maybe<Deal>>>;
  onTagsCreated?: Maybe<TagsPayload>;
  onTagsDeleted?: Maybe<TagsPayload>;
  onTemporaryRegistrationTagsDealsUpdated?: Maybe<Array<Maybe<Deal>>>;
  onTieDownChanged: TieDown;
  onTransactionCreated?: Maybe<FinancialInfo>;
  onUnknownNumberMessageReceived: Scalars['String'];
  onWaitingQueue?: Maybe<OnWaitingQueue>;
  switchCallStatus?: Maybe<Scalars['String']>;
};


export type RootSubscriptionTypeOnAiCloserArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnAiCloserCallStatusArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnAdvisorSummaryStatsUpdateArgs = {
  pool: StatsPool;
};


export type RootSubscriptionTypeOnAlertCreatedArgs = {
  filter?: InputMaybe<AlertsFilter>;
};


export type RootSubscriptionTypeOnContractDistributionUpdatedArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnCreditDecisionCreatedArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnCreditDecisionSelectedArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnCustomDateUpdatedArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnDealActivityLoggedArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnDealCompleteArgs = {
  endDate: Scalars['DateTime'];
  sources: Array<InputMaybe<Scalars['String']>>;
  startDate: Scalars['DateTime'];
  types: Array<InputMaybe<DealType>>;
};


export type RootSubscriptionTypeOnDealIssueResolutionStatusChangedArgs = {
  dealIds: Array<Scalars['Int']>;
};


export type RootSubscriptionTypeOnDealIssuesUpdatedArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnDealLockStatusArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnDealMovedArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnDealTieDownsChangedArgs = {
  dealId: Scalars['ID'];
};


export type RootSubscriptionTypeOnDealUpdateArgs = {
  dealIds?: InputMaybe<Array<Scalars['ID']>>;
  sources: Array<Scalars['String']>;
  types?: InputMaybe<Array<DealType>>;
};


export type RootSubscriptionTypeOnDocumentPreparationProgressArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnDocumentProgressStatusArgs = {
  deal_id?: InputMaybe<Scalars['ID']>;
  fundingClerkOnly?: InputMaybe<Scalars['Boolean']>;
};


export type RootSubscriptionTypeOnFollowUpUpdateArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
  followUpStatus?: InputMaybe<FollowUpStatusEnum>;
  followUpType?: InputMaybe<FollowUpTypeEnum>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
};


export type RootSubscriptionTypeOnFsSummaryStatsUpdateArgs = {
  pool: StatsPool;
};


export type RootSubscriptionTypeOnFundingRequirementResolutionStatusChangedArgs = {
  dealIds: Array<Scalars['Int']>;
};


export type RootSubscriptionTypeOnFundingRequirementsUpdatedArgs = {
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnMessageCreatedV2Args = {
  activePhoneNumber: Scalars['String'];
  dealId?: InputMaybe<Scalars['Int']>;
  notifiedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type RootSubscriptionTypeOnMessageReceivedV2Args = {
  activePhoneNumber: Scalars['String'];
  dealId: Scalars['Int'];
};


export type RootSubscriptionTypeOnMessageStatusUpdatedV2Args = {
  activePhoneNumber: Scalars['String'];
};


export type RootSubscriptionTypeOnNewMessageArgs = {
  activePhoneNumber?: InputMaybe<Scalars['String']>;
  dealPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isNotification?: InputMaybe<Scalars['Boolean']>;
  isWidgetOpen?: InputMaybe<Scalars['Boolean']>;
};


export type RootSubscriptionTypeOnNoteCreatedArgs = {
  filter?: InputMaybe<NotesFilter>;
};


export type RootSubscriptionTypeOnNoteDeletedArgs = {
  filter?: InputMaybe<NotesFilter>;
};


export type RootSubscriptionTypeOnNoteUpdatedArgs = {
  filter?: InputMaybe<NotesFilter>;
};


export type RootSubscriptionTypeOnPayoffRequestStatusUpdateArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type RootSubscriptionTypeOnPayoffRequestStatusUpdateV2Args = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type RootSubscriptionTypeOnPodSummaryStatsUpdateArgs = {
  pool: StatsPool;
};


export type RootSubscriptionTypeOnPriorityQueueUpdateArgs = {
  assignment?: InputMaybe<DealAssignmentFilter>;
  fsPodScoped?: InputMaybe<Scalars['Boolean']>;
  states: Array<DealStateEnum>;
};


export type RootSubscriptionTypeOnSecureLinkCreatedArgs = {
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type RootSubscriptionTypeOnSecureLinkExpiredArgs = {
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type RootSubscriptionTypeOnStructuringFollowUpUpdateArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  dealId?: InputMaybe<Scalars['ID']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
};


export type RootSubscriptionTypeOnTagsCreatedArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type RootSubscriptionTypeOnTagsDeletedArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type RootSubscriptionTypeOnTieDownChangedArgs = {
  dealId?: InputMaybe<Scalars['ID']>;
};


export type RootSubscriptionTypeOnTransactionCreatedArgs = {
  dealId: Scalars['ID'];
};

export type SaveConsent = {
  __typename?: 'SaveConsent';
  consent?: Maybe<Consent>;
  isNew?: Maybe<Scalars['Boolean']>;
};

export type SecureLinkNotification = {
  __typename?: 'SecureLinkNotification';
  customer_id: Scalars['ID'];
  deal_id: Scalars['ID'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  reason: SecureLinkNotificationReason;
};

export enum SecureLinkNotificationReason {
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Used = 'USED'
}

export enum SecureLinkStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED'
}

export type SelectCreditDecision = {
  __typename?: 'SelectCreditDecision';
  creditDecision?: Maybe<CreditDecision>;
  financialInfo: FinancialInfo;
};

export type SelectCreditDecisionV2Result = {
  __typename?: 'SelectCreditDecisionV2Result';
  creditDecision: CreditDecision;
  financialInfo: FinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type SelectDealProductVscRateInput = {
  dealId: Scalars['Int'];
  penRateId: Scalars['Int'];
};

export type SelectDealProductVscRateResult = {
  __typename?: 'SelectDealProductVscRateResult';
  paymentOptions: PaymentOptionsV2;
  vscDealProduct: DealProduct;
};

export type SelectPackageSlotInput = {
  dealId: Scalars['Int'];
  selectedPackageSlotIndex: Scalars['Int'];
};

export type SendReferralLinkPayload = {
  __typename?: 'SendReferralLinkPayload';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SetDealProductManualTermInputV2 = {
  dealId: Scalars['Int'];
  slug: ProductSlug;
  termMiles: Scalars['Int'];
  termMonths: Scalars['Int'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  purpose?: Maybe<Scalars['String']>;
  tracker_url?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SidebarAppointmentV2 = {
  __typename?: 'SidebarAppointmentV2';
  customerId?: Maybe<Scalars['ID']>;
  dateUtc: Scalars['DateTime'];
  dealId: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  followUpId: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  status: FollowUpStatusEnum;
  type: FollowUpTypeEnum;
  tz?: Maybe<Scalars['String']>;
};

export type SignatureData = {
  __typename?: 'SignatureData';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  initials_data_url?: Maybe<Scalars['String']>;
  initials_strokes?: Maybe<Scalars['String']>;
  signature_data_url?: Maybe<Scalars['String']>;
  signature_strokes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SignaturePacketStatus = {
  __typename?: 'SignaturePacketStatus';
  documents: Array<SigningDocumentStatus>;
  sentAt?: Maybe<Scalars['DateTime']>;
};

export type SigningDocumentStatus = {
  __typename?: 'SigningDocumentStatus';
  buyerSigned: Scalars['Boolean'];
  cobuyerSigned?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  requiresCobuyerSignature: Scalars['Boolean'];
  signatureStatus: DocumentSignatureStatus;
  signedUrl?: Maybe<Scalars['String']>;
};

export enum SigningErrorEnum {
  ApplyDealerSignature = 'APPLY_DEALER_SIGNATURE',
  ApplySignature = 'APPLY_SIGNATURE',
  FinalizeSigning = 'FINALIZE_SIGNING',
  GenerationDate = 'GENERATION_DATE',
  RetrieveDocuments = 'RETRIEVE_DOCUMENTS',
  RetrieveDocumentPdf = 'RETRIEVE_DOCUMENT_PDF'
}

export enum SigningSolutionEnum {
  AdobeSign = 'adobe_sign',
  RouteOne = 'route_one'
}

/** A document the current deal configuration intentionally did not generate. */
export type SkippedDocument = {
  __typename?: 'SkippedDocument';
  filename: Scalars['String'];
  mediaType: DealMediaTypeEnum;
};

export type SocialProofStats = {
  __typename?: 'SocialProofStats';
  allTimeFundedCount?: Maybe<Scalars['Int']>;
  customerCountByState?: Maybe<Scalars['Int']>;
  customerState?: Maybe<Scalars['String']>;
  nationalBrandCount?: Maybe<Scalars['Int']>;
  trustpilotRating?: Maybe<Scalars['Float']>;
  trustpilotReviewCount?: Maybe<Scalars['Int']>;
  vehicleBrand?: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortingType = {
  direction?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
};

export type SortingTypeV2 = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<DealSortColumn>;
};

export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type StateCount = {
  __typename?: 'StateCount';
  count?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

export enum StatesTaxedOnWarranty {
  Ar = 'AR',
  Ct = 'CT',
  Fl = 'FL',
  Hi = 'HI',
  Ks = 'KS',
  Me = 'ME',
  Ne = 'NE',
  Nj = 'NJ',
  Ny = 'NY',
  Oh = 'OH',
  Pa = 'PA',
  Sd = 'SD',
  Tn = 'TN',
  Ut = 'UT',
  Wi = 'WI',
  Wy = 'WY'
}

export enum StatsPool {
  Company = 'COMPANY',
  Me = 'ME',
  MyPod = 'MY_POD'
}

export enum StatsTimeFrame {
  LastSevenDays = 'LAST_SEVEN_DAYS',
  MonthToDate = 'MONTH_TO_DATE',
  Today = 'TODAY'
}

export type StructuringFollowUp = {
  __typename?: 'StructuringFollowUp';
  created_at?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  creator_id?: Maybe<Scalars['ID']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<StructuringFollowUpStatus>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type StructuringFollowUpInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  creator_id?: InputMaybe<Scalars['ID']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StructuringFollowUpStatus>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export enum StructuringFollowUpSortColumn {
  Advisor = 'advisor',
  Customer = 'customer',
  Date = 'date',
  DealState = 'dealState',
  StructuringManager = 'structuringManager'
}

export enum StructuringFollowUpStatus {
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS'
}

export type Summary = {
  __typename?: 'Summary';
  points?: Maybe<SummaryPoints>;
  score: Scalars['Int'];
  summary?: Maybe<Scalars['String']>;
};

export type SummaryPoints = {
  __typename?: 'SummaryPoints';
  equity?: Maybe<Scalars['String']>;
  mileage_overage?: Maybe<Scalars['String']>;
  popularity?: Maybe<Scalars['String']>;
  reliability?: Maybe<Scalars['String']>;
  replacement_cost?: Maybe<Scalars['String']>;
};

export type SupportedLienholderResponse = {
  __typename?: 'SupportedLienholderResponse';
  isSupported: Scalars['Boolean'];
  missingRequiredFields: Array<LienholderRequirement>;
  requiredFields: Array<LienholderRequirement>;
  requirementsMet: Scalars['Boolean'];
};

export type TtConditionFilterInput = {
  buyerIsNotLessee?: InputMaybe<Scalars['Boolean']>;
  canVerifyDigitalSignatures?: InputMaybe<Scalars['Boolean']>;
  currentAddress?: InputMaybe<Scalars['String']>;
  driversLicenseAddress?: InputMaybe<Scalars['String']>;
  driversLicenseState?: InputMaybe<Scalars['String']>;
  hasCobuyer?: InputMaybe<Scalars['Boolean']>;
  jurisdictionState?: InputMaybe<Scalars['String']>;
  lienholder?: InputMaybe<Scalars['String']>;
  movedStateDuringLease?: InputMaybe<Scalars['Boolean']>;
  newBank?: InputMaybe<TtNewBankEnum>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']>;
  transferringRegistration?: InputMaybe<Scalars['Boolean']>;
  vehicleAge?: InputMaybe<Scalars['Int']>;
};

export type TtDocumentConditionsFields = {
  __typename?: 'TTDocumentConditionsFields';
  description?: Maybe<Scalars['String']>;
  variables?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TtDocumentFields = {
  __typename?: 'TTDocumentFields';
  conditions?: Maybe<Array<Maybe<TtDocumentConditionsFields>>>;
  documentTypeId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  supportsImageExtraction?: Maybe<Scalars['Boolean']>;
  type?: Maybe<TtDocumentTypeFields>;
  validations?: Maybe<Array<Maybe<TtValidation>>>;
};

export enum TtDocumentName {
  AcuraSpecificOdometerStatement = 'AcuraSpecificOdometerStatement',
  ApplicationForCopyOfRegistration = 'ApplicationForCopyOfRegistration',
  BackOfDriversLicense = 'BackOfDriversLicense',
  BillOfSale = 'BillOfSale',
  CaliforniaSpecialInterestLicensePlateApplication = 'CaliforniaSpecialInterestLicensePlateApplication',
  CobuyerBackOfDriversLicense = 'CobuyerBackOfDriversLicense',
  CobuyerDriversLicense = 'CobuyerDriversLicense',
  CobuyerElectronicRegistrationAndTitleAgreement = 'CobuyerElectronicRegistrationAndTitleAgreement',
  CobuyerJointTenancyWithRightsOfSurvivorship = 'CobuyerJointTenancyWithRightsOfSurvivorship',
  CobuyerOdometerStatement = 'CobuyerOdometerStatement',
  CobuyerPowerOfAttorney = 'CobuyerPowerOfAttorney',
  CobuyerProcessorPowerOfAttorney = 'CobuyerProcessorPowerOfAttorney',
  CobuyerRegistrationSpecificPowerOfAttorney = 'CobuyerRegistrationSpecificPowerOfAttorney',
  CobuyerSecurePowerOfAttorney = 'CobuyerSecurePowerOfAttorney',
  CobuyerStateSpecificOdometerStatement = 'CobuyerStateSpecificOdometerStatement',
  CobuyerStateSpecificPowerOfAttorney = 'CobuyerStateSpecificPowerOfAttorney',
  CobuyerSupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause = 'CobuyerSupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause',
  DriversLicense = 'DriversLicense',
  ElectronicRegistrationAndTitleAgreement = 'ElectronicRegistrationAndTitleAgreement',
  ElectronicSignatureAttestation = 'ElectronicSignatureAttestation',
  ElectronicSignatureCertification = 'ElectronicSignatureCertification',
  Emissions = 'Emissions',
  GmAssignmentOfTitleDamageDisclosure = 'GMAssignmentOfTitleDamageDisclosure',
  GmLeasePacket = 'GMLeasePacket',
  HondaSpecificOdometerStatement = 'HondaSpecificOdometerStatement',
  IdahoSalesTaxExemption = 'IdahoSalesTaxExemption',
  JointOdometerStatement = 'JointOdometerStatement',
  LaSpecificMercedesSpecificFloodDamageDisclosure = 'LASpecificMercedesSpecificFloodDamageDisclosure',
  LeaseEndPayoffAuthorization = 'LeaseEndPayoffAuthorization',
  LexusSpecificPowerOfAttorney = 'LexusSpecificPowerOfAttorney',
  LicensePlate = 'LicensePlate',
  LienholderSpecificBillOfSale = 'LienholderSpecificBillOfSale',
  LienholderSpecificOdometerStatement = 'LienholderSpecificOdometerStatement',
  Odometer = 'Odometer',
  OdometerStatement = 'OdometerStatement',
  OhioSpecificHondaSpecificOdometerStatement = 'OhioSpecificHondaSpecificOdometerStatement',
  OhioSpecificHondaSpecificPowerOfAttorney = 'OhioSpecificHondaSpecificPowerOfAttorney',
  PlateTransferLetter = 'PlateTransferLetter',
  PorscheSpecificOdometerStatement = 'PorscheSpecificOdometerStatement',
  PorscheSpecificPayoffInstructions = 'PorscheSpecificPayoffInstructions',
  PowerOfAttorney = 'PowerOfAttorney',
  ProcessorPowerOfAttorney = 'ProcessorPowerOfAttorney',
  ProofOfInsurance = 'ProofOfInsurance',
  ProofOfResidence = 'ProofOfResidence',
  ProofOfResidence2 = 'ProofOfResidence2',
  PropertyTaxReceipt = 'PropertyTaxReceipt',
  PurchaseOrder = 'PurchaseOrder',
  Registration = 'Registration',
  RegistrationSpecificPowerOfAttorney = 'RegistrationSpecificPowerOfAttorney',
  SafetyInspection = 'SafetyInspection',
  SalesTaxExemption = 'SalesTaxExemption',
  SecurePowerOfAttorney = 'SecurePowerOfAttorney',
  SmogInspection = 'SmogInspection',
  StateSpecificBillOfSale = 'StateSpecificBillOfSale',
  StateSpecificDamageDisclosure = 'StateSpecificDamageDisclosure',
  StateSpecificOdometerStatement = 'StateSpecificOdometerStatement',
  StateSpecificPowerOfAttorney = 'StateSpecificPowerOfAttorney',
  SupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause = 'SupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause',
  TaterDocumentPacket = 'TaterDocumentPacket',
  TeslaSpecificDocumentPacket = 'TeslaSpecificDocumentPacket',
  TitleApp = 'TitleApp',
  ToyotaSpecificPowerOfAttorney = 'ToyotaSpecificPowerOfAttorney',
  UsBankSpecificAlabamaSpecificAirbagDisclosure = 'USBankSpecificAlabamaSpecificAirbagDisclosure',
  UsBankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'USBankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation',
  VinInspection = 'VINInspection'
}

export type TtDocumentTypeFields = {
  __typename?: 'TTDocumentTypeFields';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  parameters?: Maybe<Array<Maybe<TtParameterFields>>>;
};

export type TtFeesInput = {
  address?: InputMaybe<Scalars['String']>;
  bookValue?: InputMaybe<Scalars['Float']>;
  city?: InputMaybe<Scalars['String']>;
  cobuyerAddress?: InputMaybe<Scalars['String']>;
  cobuyerCity?: InputMaybe<Scalars['String']>;
  cobuyerCounty?: InputMaybe<Scalars['String']>;
  cobuyerDob?: InputMaybe<Scalars['String']>;
  cobuyerEmail?: InputMaybe<Scalars['String']>;
  cobuyerFirstName?: InputMaybe<Scalars['String']>;
  cobuyerLastName?: InputMaybe<Scalars['String']>;
  cobuyerMiddleName?: InputMaybe<Scalars['String']>;
  cobuyerPhone?: InputMaybe<Scalars['String']>;
  cobuyerState?: InputMaybe<StateAbbreviation>;
  cobuyerSuffix?: InputMaybe<Scalars['String']>;
  cobuyerZip?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  docFee?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  estimatedPayoff?: InputMaybe<Scalars['Float']>;
  firstName?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<TtFuelType>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insurancePolicyExpirationDate?: InputMaybe<Scalars['String']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  mailingCity?: InputMaybe<Scalars['String']>;
  mailingCounty?: InputMaybe<Scalars['String']>;
  mailingState?: InputMaybe<StateAbbreviation>;
  mailingZipCode?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  newBank?: InputMaybe<Scalars['String']>;
  newBankAddress?: InputMaybe<Scalars['String']>;
  newBankAddress2?: InputMaybe<Scalars['String']>;
  newBankCity?: InputMaybe<Scalars['String']>;
  newBankEltCode?: InputMaybe<Scalars['String']>;
  newBankState?: InputMaybe<StateAbbreviation>;
  newBankZip?: InputMaybe<Scalars['String']>;
  newBankZipPlus4?: InputMaybe<Scalars['String']>;
  odometerReading?: InputMaybe<Scalars['Int']>;
  payoff?: InputMaybe<Scalars['Float']>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']>;
  payoffWithoutSalesTax?: InputMaybe<Scalars['Float']>;
  previouslyTitledState?: InputMaybe<StateAbbreviation>;
  retailBookValue?: InputMaybe<Scalars['Float']>;
  salesTax?: InputMaybe<Scalars['Float']>;
  signedDate?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateAbbreviation>;
  suffix?: InputMaybe<Scalars['String']>;
  titleRegistrationOption?: InputMaybe<Scalars['String']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']>;
  trim?: InputMaybe<Scalars['String']>;
  uniqueId?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<TtVehicleType>;
  vin?: InputMaybe<Scalars['String']>;
  warranty?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum TtFuelType {
  Diesel = 'Diesel',
  Electric = 'Electric',
  Gasoline = 'Gasoline',
  Hybrid = 'Hybrid',
  PlugInHybrid = 'PlugInHybrid'
}

export enum TtGetFeesSourceType {
  ComDevTool = 'COM_DEV_TOOL',
  ComEnterPayoff = 'COM_ENTER_PAYOFF',
  ComImportInfo = 'COM_IMPORT_INFO',
  ComPaymentCalculator = 'COM_PAYMENT_CALCULATOR',
  ComPrequalification = 'COM_PREQUALIFICATION',
  ComSoftPull = 'COM_SOFT_PULL',
  D2DGetTaxesAndFees = 'D2D_GET_TAXES_AND_FEES',
  D2DPrequalification = 'D2D_PREQUALIFICATION',
  DdAutoStructure = 'DD_AUTO_STRUCTURE',
  DdCalcFees = 'DD_CALC_FEES',
  DdLendingTree = 'DD_LENDING_TREE',
  DdMoveToStructuring = 'DD_MOVE_TO_STRUCTURING',
  DdPaymentEstimate = 'DD_PAYMENT_ESTIMATE',
  DdPayoffTax = 'DD_PAYOFF_TAX',
  DdPrequalification = 'DD_PREQUALIFICATION',
  MktPaymentCalculator = 'MKT_PAYMENT_CALCULATOR',
  NoneGetTaxesAndFeesInput = 'NONE_GET_TAXES_AND_FEES_INPUT',
  NonePaymentEstimateLogic = 'NONE_PAYMENT_ESTIMATE_LOGIC'
}

export type TtJurisdiction = {
  __typename?: 'TTJurisdiction';
  allowPlateTransfer?: Maybe<Scalars['Boolean']>;
  allowRegistrationTransfer?: Maybe<Scalars['Boolean']>;
  hasRegistrationOnly?: Maybe<Scalars['Boolean']>;
  hasTitleAndRegistration?: Maybe<Scalars['Boolean']>;
  hasTitleOnly?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  products?: Maybe<TtttProductFieldsConnection>;
  registrationProduct?: Maybe<TtProductFields>;
  requireWalkIn?: Maybe<Scalars['Boolean']>;
  supportedProcessors?: Maybe<Array<Maybe<Processor>>>;
  titleProduct?: Maybe<TtProductFields>;
};


export type TtJurisdictionProductsArgs = {
  filter?: InputMaybe<TtProductFilter>;
};

export enum TtNewBankEnum {
  Afcu = 'AFCU',
  AllyFinancial = 'AllyFinancial',
  ArraFinance = 'ArraFinance',
  CapitalOne = 'CapitalOne',
  Chase = 'Chase',
  ConsumerPortfolioServices = 'ConsumerPortfolioServices',
  ExeterFinance = 'ExeterFinance',
  FifthThird = 'FifthThird',
  FirstInterstate = 'FirstInterstate',
  GlobalLendingServices = 'GlobalLendingServices',
  Iccu = 'ICCU',
  InnoFiAutoFinance = 'InnoFiAutoFinance',
  LentegrityAutoFinance = 'LentegrityAutoFinance',
  Lookout = 'Lookout',
  Mechanics = 'Mechanics',
  MountainAmerica = 'MountainAmerica',
  Occu = 'OCCU',
  Pnc = 'PNC',
  PrestigeFinancial = 'PrestigeFinancial',
  Santander = 'Santander',
  SantanderConsumerInc = 'SantanderConsumerInc',
  Td = 'TD',
  Upgrade = 'Upgrade',
  WellsFargo = 'WellsFargo',
  Westlake = 'Westlake',
  Wings = 'Wings'
}

export type TtPageInfo = {
  __typename?: 'TTPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type TtParameterFields = {
  __typename?: 'TTParameterFields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TtProductFields = {
  __typename?: 'TTProductFields';
  documents?: Maybe<TtttDocumentFieldsConnection>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<TtProductType>;
  validations?: Maybe<Array<Maybe<TtValidation>>>;
};


export type TtProductFieldsDocumentsArgs = {
  conditions?: InputMaybe<TtConditionFilterInput>;
};

export type TtProductFilter = {
  types?: InputMaybe<Array<InputMaybe<TtProductType>>>;
};

export enum TtProductType {
  Payoff = 'Payoff',
  Registration = 'Registration',
  Title = 'Title'
}

export type TtttDocumentFieldsConnection = {
  __typename?: 'TTTTDocumentFieldsConnection';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<TtDocumentFields>>>;
  pageInfo?: Maybe<TtPageInfo>;
};

export type TtttProductFieldsConnection = {
  __typename?: 'TTTTProductFieldsConnection';
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<TtProductFields>>>;
  pageInfo?: Maybe<TtPageInfo>;
};

export type TtValidation = {
  __typename?: 'TTValidation';
  description?: Maybe<Scalars['String']>;
  internalDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum TtValidationName {
  CobuyerOnInsurance = 'CobuyerOnInsurance',
  DigitalSignature = 'DigitalSignature',
  DigitalWetSignature = 'DigitalWetSignature',
  DriversLicenseAddressMatch = 'DriversLicenseAddressMatch',
  DriversLicenseNameMatch = 'DriversLicenseNameMatch',
  DriversLicenseStateMatch = 'DriversLicenseStateMatch',
  InsuranceNameMatch = 'InsuranceNameMatch',
  InsuranceNotExpired = 'InsuranceNotExpired',
  InsuranceStateMatch = 'InsuranceStateMatch',
  InsuranceVinMatch = 'InsuranceVinMatch',
  LiabilityInsuranceRequired = 'LiabilityInsuranceRequired',
  NotarizationRequired = 'NotarizationRequired',
  RegistrationNotExpired = 'RegistrationNotExpired',
  RegistrationNotExpired60Days = 'RegistrationNotExpired60Days',
  RegistrationNotExpired90Days = 'RegistrationNotExpired90Days',
  RegistrationPictureRequired = 'RegistrationPictureRequired',
  VerifiedDigitalSignature = 'VerifiedDigitalSignature',
  WetSignature = 'WetSignature'
}

export enum TtVehicleType {
  ExtendedCabPickup = 'ExtendedCabPickup',
  Motorhome = 'Motorhome',
  MultipurposePassengerVehicle = 'MultipurposePassengerVehicle',
  PassengerCar = 'PassengerCar',
  Pickup = 'Pickup',
  Suv = 'SUV',
  Sedan = 'Sedan',
  Truck = 'Truck'
}

export type Tag = {
  __typename?: 'Tag';
  badge_variant?: Maybe<Scalars['Int']>;
  color: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  display_name: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_dashboard_visible: Scalars['Boolean'];
  slug: TagSlugEnum;
  tagged_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum TagSlugEnum {
  AutomaticAssistant = 'automatic_assistant',
  AutomaticEquity = 'automatic_equity',
  AutomaticPayment = 'automatic_payment',
  Bankruptcy = 'bankruptcy',
  ContractExpired = 'contract_expired',
  CreditFrozen = 'credit_frozen',
  DirectPay = 'direct_pay',
  DoubleTax = 'double_tax',
  DownPaymentCompleted = 'down_payment_completed',
  EmailPreferred = 'email_preferred',
  GaBankFees = 'ga_bank_fees',
  GaDownPayment = 'ga_down_payment',
  GaNetsuite = 'ga_netsuite',
  GaPayoffCheck = 'ga_payoff_check',
  GaReserve = 'ga_reserve',
  GaTitlePayment = 'ga_title_payment',
  HeldAtBank = 'held_at_bank',
  HotLead = 'hot_lead',
  InterviewCompleted = 'interview_completed',
  Itin = 'itin',
  LendingTree = 'lending_tree',
  ManagerReview = 'manager_review',
  MortgageCurrent = 'mortgage_current',
  MortgagePastDue = 'mortgage_past_due',
  NeedPo = 'need_po',
  NeedSsc = 'need_ssc',
  NeedVciDocs = 'need_vci_docs',
  NeedsCobuyer = 'needs_cobuyer',
  NeedsConsent = 'needs_consent',
  NeedsIncome = 'needs_income',
  NeedsMoneyDown = 'needs_money_down',
  NeedsRecontracting = 'needs_recontracting',
  NoRoiNeeded = 'no_roi_needed',
  NoStips = 'no_stips',
  OrderVerified = 'order_verified',
  PaymentCalculatorLead = 'payment_calculator_lead',
  PayoffFailed = 'payoff_failed',
  PayoffVerified = 'payoff_verified',
  PicturesCompleted = 'pictures_completed',
  PoCollected = 'po_collected',
  PoeCompleted = 'poe_completed',
  PoiCollected = 'poi_collected',
  PorCollected = 'por_collected',
  PromoJuly2024 = 'promo_july2024',
  ProofOfEmployment = 'proof_of_employment',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidency = 'proof_of_residency',
  RateReductionOffer = 'rate_reduction_offer',
  Recontracted = 'recontracted',
  ReferencesNeeded = 'references_needed',
  Refi = 'refi',
  ReleaseOfInterest = 'release_of_interest',
  Repo = 'repo',
  RoiSent = 'roi_sent',
  RoiSigned = 'roi_signed',
  SentToBank = 'sent_to_bank',
  SpanishSpeaker = 'spanish_speaker',
  StructureUpdated = 'structure_updated',
  StructureViolation = 'structure_violation',
  StructuringPayoff = 'structuring_payoff',
  TextPreferred = 'text_preferred',
  TwoCarDriver = 'two_car_driver',
  Unwind = 'unwind',
  VerifyingInfo = 'verifying_info',
  Vip = 'vip',
  VscGapContracts = 'vsc_gap_contracts',
  WaitingForApproval = 'waiting_for_approval',
  WaitingForDownPayment = 'waiting_for_down_payment',
  WaitingForInsurance = 'waiting_for_insurance',
  WaitingForInterview = 'waiting_for_interview',
  WaitingForLicense = 'waiting_for_license',
  WaitingForPayoff = 'waiting_for_payoff',
  WaitingForPics = 'waiting_for_pics',
  WaitingForSmog = 'waiting_for_smog',
  WaitingForTitle = 'waiting_for_title',
  WaitingForVinInspection = 'waiting_for_vin_inspection',
  WaitingForWetSigs = 'waiting_for_wet_sigs',
  WalkIn = 'walk_in',
  WantsToSell = 'wants_to_sell',
  ZeroBalanceAuto = 'zero_balance_auto',
  ZeroStipCompleted = 'zero_stip_completed'
}

export type TagsInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type TagsPayload = {
  __typename?: 'TagsPayload';
  dealId: Scalars['ID'];
  tags: Array<Tag>;
};

export type ThirdPartyPayoffSend = {
  __typename?: 'ThirdPartyPayoffSend';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  status: ThirdPartyPayoffSendStatus;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum ThirdPartyPayoffSendStatus {
  Sending = 'SENDING',
  SendFailed = 'SEND_FAILED',
  Sent = 'SENT'
}

export type ThunderCallNotification = {
  __typename?: 'ThunderCallNotification';
  ai_call_opener?: Maybe<Scalars['String']>;
  attempt_num: Scalars['Int'];
  campaign_id?: Maybe<Scalars['String']>;
  conversation_history: Scalars['JSON'];
  created_at?: Maybe<Scalars['DateTime']>;
  customer_phone_number: Scalars['String'];
  deal_id?: Maybe<Scalars['Int']>;
  first_name: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  last_name: Scalars['String'];
  lead_id?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  outcome_rep_id?: Maybe<Scalars['String']>;
  outcome_timestamp?: Maybe<Scalars['DateTime']>;
  scheduled_call_time?: Maybe<Scalars['String']>;
  thunder_phone_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ThunderConversationHistory = {
  __typename?: 'ThunderConversationHistory';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  messages: Array<Maybe<ThunderConversationMessage>>;
};

export type ThunderConversationMessage = {
  __typename?: 'ThunderConversationMessage';
  direction: Scalars['String'];
  text: Scalars['String'];
  timestamp: Scalars['String'];
};

export type TieDown = {
  __typename?: 'TieDown';
  /** Snapshot of the deal's bank at submit. */
  bank?: Maybe<Scalars['String']>;
  /** Whether the requesting user may decide (approve/counter/decline/undo) this tie down: a lead of the deal's pod, Review:Tie Downs, or super user. */
  can_review: Scalars['Boolean'];
  /** The pod lead's offered values; populated only while status is countered. */
  countered_values?: Maybe<Array<TieDownCounteredValue>>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<TieDownItem>>;
  note?: Maybe<Scalars['String']>;
  products: Array<ProductSlug>;
  ready_to_sign_today: Scalars['Boolean'];
  review_note?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['DateTime']>;
  reviewed_by?: Maybe<User>;
  reviewed_by_user_id?: Maybe<Scalars['String']>;
  status: TieDownStatus;
  submitted_at: Scalars['DateTime'];
  submitted_by?: Maybe<User>;
  submitted_by_user_id: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type TieDownCounteredValue = {
  __typename?: 'TieDownCounteredValue';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  item_type: TieDownItemType;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** The value the pod lead can get for this target. */
  value: Scalars['Float'];
};

export type TieDownCounteredValueInput = {
  item_type: TieDownItemType;
  value: Scalars['Float'];
};

export type TieDownItem = {
  __typename?: 'TieDownItem';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  /** The rep's hot button: the target the customer cannot move forward without. */
  is_mandatory: Scalars['Boolean'];
  item_type: TieDownItemType;
  mode: TieDownItemMode;
  snapshot_value?: Maybe<Scalars['Float']>;
  target_value: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type TieDownItemInput = {
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  item_type: TieDownItemType;
  mode: TieDownItemMode;
  target_value: Scalars['Float'];
};

export enum TieDownItemMode {
  Exact = 'exact',
  UpTo = 'up_to'
}

export enum TieDownItemType {
  MoneyDown = 'money_down',
  MonthlyPayment = 'monthly_payment',
  Rate = 'rate',
  Term = 'term'
}

export enum TieDownStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Countered = 'countered',
  Declined = 'declined',
  Pending = 'pending'
}

export type Time = {
  __typename?: 'Time';
  days?: Maybe<Scalars['Float']>;
  score: Scalars['Boolean'];
};

export enum TitleRegistrationOption {
  TitleAndNewRegistration = 'title_and_new_registration',
  TitleAndRegistrationTransfer = 'title_and_registration_transfer',
  TitleOnly = 'title_only'
}

export type TitlingAddress = {
  __typename?: 'TitlingAddress';
  id: Scalars['ID'];
  movedStates: Scalars['Boolean'];
};

export type TitlingFinancialInfo = {
  __typename?: 'TitlingFinancialInfo';
  buyerNotLessee: Scalars['Boolean'];
  dealId: Scalars['ID'];
  id: Scalars['ID'];
  needTemporaryRegistrationTags: Scalars['Boolean'];
  plateTransfer: Scalars['Boolean'];
  titleRegistrationOption: TitleRegistrationOption;
};

export type TitlingInput = {
  buyerNotLessee: Scalars['Boolean'];
  dealId: Scalars['ID'];
  movedStates: Scalars['Boolean'];
  needTemporaryRegistrationTags: Scalars['Boolean'];
  originalLesseeDeceased: Scalars['Boolean'];
  plateTransfer: Scalars['Boolean'];
  titleRegistrationOption: TitleRegistrationOption;
};

export type TitlingOptionsResult = {
  __typename?: 'TitlingOptionsResult';
  address: TitlingAddress;
  financialInfo: TitlingFinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type UpdateCreditAppOnDealResponse = {
  __typename?: 'UpdateCreditAppOnDealResponse';
  cobuyer?: Maybe<Customer>;
  contact?: Maybe<DealContact>;
  customer: Customer;
  financial_info: FinancialInfo;
  id: Scalars['Int'];
  odometer_status?: Maybe<OdometerStatus>;
  original_lessee?: Maybe<OriginalLessee>;
  second_contact?: Maybe<DealContact>;
  state: Scalars['String'];
};

export type UpdateDealPackageConfigSlotInput = {
  dealId: Scalars['Int'];
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int'];
};

export type UpdateDealPackageConfigSlotPayload = {
  __typename?: 'UpdateDealPackageConfigSlotPayload';
  financialInfo: FinancialInfo;
  paymentOption: PaymentOptionsPackageV2;
};

export type UpdateDealProductRatesInput = {
  dealId: Scalars['Int'];
  products: Array<DealProductRateInput>;
};

export type UpdateDealProductsInputV2 = {
  dealId: Scalars['Int'];
  packageConfigs?: InputMaybe<Array<DealPackageConfigInput>>;
  products: Array<DealProductInputV2>;
  selectedPackageSlotIndex?: InputMaybe<Scalars['Int']>;
};

export type UpdateNoteTextInput = {
  text: Scalars['String'];
};

export type UpdateUserInput = {
  auth0Roles: Array<InputMaybe<Auth0RoleInput>>;
  email: Scalars['String'];
  huntGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id: Scalars['String'];
  location?: InputMaybe<LocationType>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  recruiterId?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPreferencesInput = {
  alerts?: InputMaybe<AlertPreferencesInput>;
  allDealsTable?: InputMaybe<AllDealsTablePreferencesInput>;
};

export type UploadDocumentsInput = {
  key: Scalars['String'];
  name: Scalars['String'];
};

export type UploadDocumentsToCudlResult = {
  __typename?: 'UploadDocumentsToCUDLResult';
  errors: Array<Scalars['String']>;
  uploadedDocuments: Array<Scalars['String']>;
};

export type UpsertDealPackageConfigsInput = {
  configs: Array<DealPackageConfigInput>;
  dealId: Scalars['Int'];
};

export type UserCreationData = {
  __typename?: 'UserCreationData';
  huntGroups?: Maybe<Array<HuntGroup>>;
  pods?: Maybe<Array<Pod>>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  alerts: AlertPreferences;
  allDealsTable: AllDealsTablePreferences;
  id: Scalars['ID'];
};

export type UserRoles = {
  __typename?: 'UserRoles';
  roles?: Maybe<Array<Maybe<Auth0Role>>>;
};

export enum UserType {
  Ai = 'ai',
  Human = 'human'
}

export type VscLimits = {
  __typename?: 'VSCLimits';
  max_vsc_amount?: Maybe<Scalars['Float']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ValidateReferrer = {
  __typename?: 'ValidateReferrer';
  data?: Maybe<ReferrerDataGraphQlType>;
  valid: Scalars['Boolean'];
};

export type VehicleMileageGql = {
  __typename?: 'VehicleMileageGQL';
  estimatedAverageMiles?: Maybe<Scalars['Float']>;
  eventCount?: Maybe<Scalars['Int']>;
  lastOdometer?: Maybe<Scalars['Int']>;
  lastOdometerDate?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['Int']>;
  resultMessage?: Maybe<Scalars['String']>;
  rollback?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type VehicleUseRequirements = {
  __typename?: 'VehicleUseRequirements';
  commercial_use_allowed?: Maybe<Scalars['Boolean']>;
  personal_use_only?: Maybe<Scalars['Boolean']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']>>>;
  use_restrictions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type VerifyFinixInstrumentGraphQlType = {
  __typename?: 'VerifyFinixInstrumentGraphQLType';
  id?: Maybe<Scalars['String']>;
};

export enum AccidentsEnumType {
  NoAccidents = 'no_accidents',
  OneAccident = 'one_accident',
  TwoOrMoreAccidents = 'two_or_more_accidents'
}

export type AcquisitionOffer = {
  __typename?: 'acquisitionOffer';
  appraisedValue?: Maybe<Scalars['Float']>;
  estimatedFees?: Maybe<Scalars['Float']>;
  offer?: Maybe<Scalars['Float']>;
};

export enum ActorType {
  Applicant = 'Applicant',
  Buyer = 'Buyer',
  CoApplicant = 'CoApplicant',
  CoBuyer = 'CoBuyer',
  Customer = 'Customer',
  Dealer = 'Dealer',
  Guarantor = 'Guarantor',
  Sales = 'Sales'
}

export type AddDocumentsToMediaCenterInput = {
  key?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'address';
  address_line?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_type?: Maybe<AddressTypeEnum>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  monthly_payment?: Maybe<Scalars['Float']>;
  months_at_home?: Maybe<Scalars['Int']>;
  moved_states?: Maybe<Scalars['Boolean']>;
  /** Housing status. Expected canonical values: own, buying, family, rent. Legacy variants may exist. */
  residence_type?: Maybe<Scalars['String']>;
  /** Two-letter state or province abbreviation (for example: UT, AB). */
  state?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  years_at_home?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address_line?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  address_type?: InputMaybe<AddressTypeEnum>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  monthly_payment?: InputMaybe<Scalars['Float']>;
  months_at_home?: InputMaybe<Scalars['Int']>;
  moved_states?: InputMaybe<Scalars['Boolean']>;
  /** Housing status. Expected canonical values: own, buying, family, rent. Legacy variants may exist. */
  residence_type?: InputMaybe<Scalars['String']>;
  /** Two-letter state or province abbreviation (for example: UT, AB). */
  state?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  years_at_home?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Affiliate = {
  __typename?: 'affiliate';
  affiliate_provider?: Maybe<Affiliate_Provider>;
  affiliate_provider_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  decision_accepted?: Maybe<Scalars['Boolean']>;
  decision_response?: Maybe<Lending_Tree_Decision_Response>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lead_request?: Maybe<Scalars['JSONObject']>;
  ssn_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum AffiliateProviderSlug {
  LendingTree = 'lending_tree'
}

export type Affiliate_Provider = {
  __typename?: 'affiliate_provider';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<AffiliateProviderSlug>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Article = {
  __typename?: 'article';
  com_visible?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  thumbnail?: Maybe<Scalars['String']>;
  thumbnail_key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type ArticleImageUploadUrl = {
  __typename?: 'articleImageUploadUrl';
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ArticleInput = {
  com_visible?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  thumbnail_key?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Auction = {
  __typename?: 'auction';
  address_line?: Maybe<Scalars['String']>;
  average_transport_cost?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['String']>;
};

export type AuctionDistances = {
  __typename?: 'auctionDistances';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  transport_cost?: Maybe<Scalars['Int']>;
};

export type AuctionDistancesInput = {
  auctions?: InputMaybe<Array<InputMaybe<Destinations>>>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerState?: InputMaybe<Scalars['String']>;
};

export type AuctionInput = {
  address_line?: InputMaybe<Scalars['String']>;
  average_transport_cost?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum AutoImportVariation {
  DisplayCustomizePackage = 'displayCustomizePackage',
  ImmediateImport = 'immediateImport'
}

export type Bank = {
  __typename?: 'bank';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  auto_structure_buyout?: Maybe<Scalars['Boolean']>;
  auto_structure_refi?: Maybe<Scalars['Boolean']>;
  bank_markups?: Maybe<Array<Maybe<BankMarkup>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']>;
  credit_decision_valid_days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  logo_url?: Maybe<Scalars['String']>;
  /** Canonical lender name stored in LeaseEnd. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  provider?: Maybe<LendingNetwork>;
  provider_lender_id?: Maybe<Scalars['String']>;
  signing_solution?: Maybe<SigningSolutionEnum>;
  slug?: Maybe<TtNewBankEnum>;
  sort_order?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  use_in_states?: Maybe<Array<Maybe<Scalars['String']>>>;
  zip?: Maybe<Scalars['String']>;
};

export type BankInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  auto_structure_buyout?: InputMaybe<Scalars['Boolean']>;
  auto_structure_refi?: InputMaybe<Scalars['Boolean']>;
  bank_markups?: InputMaybe<Array<InputMaybe<BankMarkupInput>>>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  logo_url?: InputMaybe<Scalars['String']>;
  /** Canonical lender name stored in LeaseEnd. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<LendingNetwork>;
  provider_lender_id?: InputMaybe<Scalars['String']>;
  signing_solution?: InputMaybe<SigningSolutionEnum>;
  sort_order?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  use_in_states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  zip?: InputMaybe<Scalars['String']>;
};

export type BankMarkup = {
  __typename?: 'bankMarkup';
  bank_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  max_markup?: Maybe<Scalars['Float']>;
  term_max?: Maybe<Scalars['Int']>;
  term_min?: Maybe<Scalars['Int']>;
};

export type BankMarkupInput = {
  bank_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  max_markup?: InputMaybe<Scalars['Float']>;
  term_max?: InputMaybe<Scalars['Int']>;
  term_min?: InputMaybe<Scalars['Int']>;
};

export type BasePod = {
  __typename?: 'basePod';
  active_reps_override?: Maybe<Scalars['Int']>;
  active_reps_override_set_at?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
  assign_overnight_deals?: Maybe<Scalars['Boolean']>;
  auto_assign_deals?: Maybe<Scalars['Boolean']>;
  closer_commission_rate?: Maybe<Scalars['Float']>;
  closer_commission_type?: Maybe<CommissionType>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  manager_commission_rate?: Maybe<Scalars['Float']>;
  manager_commission_type?: Maybe<CommissionType>;
  name?: Maybe<Scalars['String']>;
  parent_pod_id?: Maybe<Scalars['ID']>;
  pause_auto_assign?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  problem_solver?: Maybe<Scalars['Boolean']>;
  setter_commission_rate?: Maybe<Scalars['Float']>;
  setter_commission_type?: Maybe<CommissionType>;
  special_commission_rate?: Maybe<Scalars['Float']>;
  special_commission_type?: Maybe<CommissionType>;
  team_type?: Maybe<TeamType>;
  updated_at?: Maybe<Scalars['DateTime']>;
  us_states_object?: Maybe<UsStatesObject>;
};

export type BasePodInput = {
  active_reps_override?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assign_overnight_deals?: InputMaybe<Scalars['Boolean']>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']>;
  closer_commission_rate?: InputMaybe<Scalars['Float']>;
  closer_commission_type?: InputMaybe<CommissionType>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  manager_commission_rate?: InputMaybe<Scalars['Float']>;
  manager_commission_type?: InputMaybe<CommissionType>;
  name?: InputMaybe<Scalars['String']>;
  parent_pod_id?: InputMaybe<Scalars['ID']>;
  pause_auto_assign?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  problem_solver?: InputMaybe<Scalars['Boolean']>;
  setter_commission_rate?: InputMaybe<Scalars['Float']>;
  setter_commission_type?: InputMaybe<CommissionType>;
  special_commission_rate?: InputMaybe<Scalars['Float']>;
  special_commission_type?: InputMaybe<CommissionType>;
  team_type?: InputMaybe<TeamType>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  us_states_object?: InputMaybe<UsStatesInputObject>;
};

export type BaseUser = {
  __typename?: 'baseUser';
  assignment_mode?: Maybe<AssignmentMode>;
  auto_assign_deals?: Maybe<Scalars['Boolean']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  frequency_minutes?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  on_vacation?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  recruiter_id?: Maybe<Scalars['String']>;
  twilio_number?: Maybe<Scalars['String']>;
  user_type?: Maybe<UserType>;
};

export type BaseUserInput = {
  assignment_mode?: InputMaybe<AssignmentMode>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']>;
  auto_assign_marketplace_deals?: InputMaybe<Scalars['Boolean']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: InputMaybe<Scalars['String']>;
  can_claim_as_closer?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  frequency_minutes?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationType>;
  max_auto_assign_deals?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  on_vacation?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  photo_url?: InputMaybe<Scalars['String']>;
  recruiter_id?: InputMaybe<Scalars['String']>;
  twilio_number?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserType>;
};

export type BootReasonInput = {
  author_id?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type Call = {
  __typename?: 'call';
  answered_by?: Maybe<Scalars['String']>;
  answered_by_user_id?: Maybe<Scalars['ID']>;
  callDuration?: Maybe<Scalars['String']>;
  callStatus?: Maybe<Scalars['String']>;
  calledCity?: Maybe<Scalars['String']>;
  calledNumber?: Maybe<Scalars['String']>;
  calledState?: Maybe<Scalars['String']>;
  callerName?: Maybe<Scalars['String']>;
  caller_city?: Maybe<Scalars['String']>;
  caller_state?: Maybe<Scalars['String']>;
  conferenceId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  flow?: Maybe<Scalars['String']>;
  fromNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isNewCustomer?: Maybe<Scalars['Boolean']>;
  last_transfer_at?: Maybe<Scalars['DateTime']>;
  new_customer_call_outcome?: Maybe<Scalars['String']>;
  new_customer_call_outcome_description?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  pod_id?: Maybe<Scalars['ID']>;
  recordingSid?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
  selection?: Maybe<Scalars['String']>;
  selection_message?: Maybe<Scalars['String']>;
  transfer_count?: Maybe<Scalars['Int']>;
  twilioNumber?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']>;
  voicemail_recording_url?: Maybe<Scalars['String']>;
};

export type Car = {
  __typename?: 'car';
  book_value?: Maybe<Scalars['Float']>;
  cbb_valuation?: Maybe<CbbValuation>;
  /** Vehicle exterior color. By and large, this value is expected to be title-cased (for example: Black, Gray, White). Common canonical colors include Beige, Black, Blue, Brown, Gold, Gray, Green, Orange, Purple, Red, Silver, White, and Yellow. Legacy records may contain lowercase, nonstandard, or blank values. */
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  fuel_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  jdp_adjusted_clean_retail?: Maybe<Scalars['Float']>;
  jdp_adjusted_clean_trade?: Maybe<Scalars['Float']>;
  jdp_mileage_adjustment?: Maybe<Scalars['Float']>;
  jdp_trim_body?: Maybe<Scalars['String']>;
  jdp_valuation_date?: Maybe<Scalars['Date']>;
  jdp_vehicle_accessories_object?: Maybe<JdpVehicleAccessoriesObject>;
  kbb_lending_mileage_adjustment?: Maybe<Scalars['Float']>;
  kbb_lending_option_adjustment?: Maybe<Scalars['Float']>;
  kbb_retail_mileage_adjustment?: Maybe<Scalars['Float']>;
  kbb_retail_option_adjustment?: Maybe<Scalars['Float']>;
  kbb_selected_options_object?: Maybe<KbbSelectedOptionsObject>;
  kbb_trim_name?: Maybe<Scalars['String']>;
  kbb_valuation_date?: Maybe<Scalars['String']>;
  kbb_vehicle_id?: Maybe<Scalars['Int']>;
  kbb_vehicle_name?: Maybe<Scalars['String']>;
  license_plate_number?: Maybe<Scalars['String']>;
  license_plate_state?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  mileage_unit?: Maybe<MileageUnit>;
  mmr?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  odometer_status?: Maybe<OdometerStatus>;
  payoff?: Maybe<Payoff>;
  registration_expiration?: Maybe<Scalars['DateTime']>;
  retail_book_value?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** Vehicle type classification used by lease/buyout workflows. Expected values: MULTIPURPOSE PASSENGER VEHICLE (MPV), TRUCK, PASSENGER CAR. */
  vehicle_type?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type CarDistinctMake = {
  __typename?: 'carDistinctMake';
  make?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type CarDistinctModel = {
  __typename?: 'carDistinctModel';
  model?: Maybe<Scalars['String']>;
};

export type CarInput = {
  book_value?: InputMaybe<Scalars['Float']>;
  cbb_valuation?: InputMaybe<CbbValuationInput>;
  /** Vehicle exterior color. By and large, this value is expected to be title-cased (for example: Black, Gray, White). Common canonical colors include Beige, Black, Blue, Brown, Gold, Gray, Green, Orange, Purple, Red, Silver, White, and Yellow. Legacy records may contain lowercase, nonstandard, or blank values. */
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  fuel_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  jdp_adjusted_clean_retail?: InputMaybe<Scalars['Float']>;
  jdp_adjusted_clean_trade?: InputMaybe<Scalars['Float']>;
  jdp_mileage_adjustment?: InputMaybe<Scalars['Float']>;
  jdp_trim_body?: InputMaybe<Scalars['String']>;
  jdp_valuation_date?: InputMaybe<Scalars['Date']>;
  jdp_vehicle_accessories_object?: InputMaybe<JdpVehicleAccessoriesObjectInput>;
  kbb_lending_mileage_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_lending_option_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_retail_mileage_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_retail_option_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_selected_options_object?: InputMaybe<KbbSelectedOptionsObjectInput>;
  kbb_trim_name?: InputMaybe<Scalars['String']>;
  kbb_valuation_date?: InputMaybe<Scalars['String']>;
  kbb_vehicle_id?: InputMaybe<Scalars['Int']>;
  kbb_vehicle_name?: InputMaybe<Scalars['String']>;
  license_plate_number?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mileage_unit?: InputMaybe<MileageUnit>;
  mmr?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  odometer_status?: InputMaybe<OdometerStatus>;
  payoff?: InputMaybe<PayoffInput>;
  registration_expiration?: InputMaybe<Scalars['DateTime']>;
  retail_book_value?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** Vehicle type classification used by lease/buyout workflows. Expected values: MULTIPURPOSE PASSENGER VEHICLE (MPV), TRUCK, PASSENGER CAR. */
  vehicle_type?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type CarWarranty = {
  __typename?: 'carWarranty';
  full_miles?: Maybe<Scalars['Int']>;
  full_status?: Maybe<Scalars['String']>;
  full_years?: Maybe<Scalars['Int']>;
  power_train_miles?: Maybe<Scalars['Int']>;
  power_train_status?: Maybe<Scalars['String']>;
  power_train_years?: Maybe<Scalars['Int']>;
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  HsaFsa = 'HSA_FSA',
  NonReloadablePrepaid = 'NON_RELOADABLE_PREPAID',
  ReloadablePrepaid = 'RELOADABLE_PREPAID',
  Unknown = 'UNKNOWN'
}

export type CbbAddDeduct = {
  __typename?: 'cbbAddDeduct';
  auto?: Maybe<Scalars['String']>;
  avg?: Maybe<Scalars['Float']>;
  clean: Scalars['Float'];
  name: Scalars['String'];
  rough?: Maybe<Scalars['Float']>;
  uoc: Scalars['String'];
  xclean?: Maybe<Scalars['Float']>;
};

export type CbbAddDeductInput = {
  auto?: InputMaybe<Scalars['String']>;
  avg?: InputMaybe<Scalars['Float']>;
  clean: Scalars['Float'];
  name: Scalars['String'];
  rough?: InputMaybe<Scalars['Float']>;
  uoc: Scalars['String'];
  xclean?: InputMaybe<Scalars['Float']>;
};

export enum CbbProvince {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK'
}

export type CbbSelectedOption = {
  __typename?: 'cbbSelectedOption';
  clean: Scalars['Float'];
  name: Scalars['String'];
  uoc: Scalars['String'];
};

export type CbbSelectedOptionInput = {
  clean: Scalars['Float'];
  name: Scalars['String'];
  uoc: Scalars['String'];
};

export type CbbTrimResult = {
  __typename?: 'cbbTrimResult';
  vehicles: Array<CbbVehicle>;
  warning: Scalars['Boolean'];
};

export type CbbValuation = {
  __typename?: 'cbbValuation';
  all_options: Array<CbbAddDeduct>;
  data_freq?: Maybe<Scalars['String']>;
  inputs?: Maybe<CbbValuationInputs>;
  lending?: Maybe<CbbValueBreakdown>;
  retail?: Maybe<CbbValueBreakdown>;
  selected_options: Array<CbbSelectedOption>;
  trim_name: Scalars['String'];
  uvc: Scalars['String'];
  valuation_date?: Maybe<Scalars['String']>;
  vehicle_name: Scalars['String'];
};

export type CbbValuationInput = {
  all_options: Array<CbbAddDeductInput>;
  data_freq?: InputMaybe<Scalars['String']>;
  inputs?: InputMaybe<CbbValuationInputsInput>;
  lending?: InputMaybe<CbbValueBreakdownInput>;
  retail?: InputMaybe<CbbValueBreakdownInput>;
  selected_options: Array<CbbSelectedOptionInput>;
  trim_name: Scalars['String'];
  uvc: Scalars['String'];
  valuation_date?: InputMaybe<Scalars['String']>;
  vehicle_name: Scalars['String'];
};

export type CbbValuationInputs = {
  __typename?: 'cbbValuationInputs';
  kilometres: Scalars['Float'];
  province: CbbProvince;
};

export type CbbValuationInputsInput = {
  kilometres: Scalars['Float'];
  province: CbbProvince;
};

export type CbbValueBreakdown = {
  __typename?: 'cbbValueBreakdown';
  adjusted: Scalars['Float'];
  base: Scalars['Float'];
  mileage_adjustment: Scalars['Float'];
  option_adjustment: Scalars['Float'];
  regional_adjustment: Scalars['Float'];
};

export type CbbValueBreakdownInput = {
  adjusted: Scalars['Float'];
  base: Scalars['Float'];
  mileage_adjustment: Scalars['Float'];
  option_adjustment: Scalars['Float'];
  regional_adjustment: Scalars['Float'];
};

export type CbbValuesDataType = {
  dealId?: InputMaybe<Scalars['ID']>;
  kilometres: Scalars['Int'];
  province: CbbProvince;
  uocCodes?: InputMaybe<Array<Scalars['String']>>;
  uvc: Scalars['String'];
  vin: Scalars['String'];
};

export type CbbVehicle = {
  __typename?: 'cbbVehicle';
  add_deduct_list: Array<CbbAddDeduct>;
  class_name?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  model_year?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  trim_name: Scalars['String'];
  uvc: Scalars['String'];
};

export enum CommissionType {
  Flat = 'flat',
  Percentage = 'percentage'
}

export type ConditionRejection = {
  __typename?: 'conditionRejection';
  conditionRejectionText?: Maybe<Scalars['String']>;
};

export type ConditionReport = {
  __typename?: 'conditionReport';
  accidents?: Maybe<AccidentsEnumType>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  exterior?: Maybe<Array<Maybe<ExteriorEnumType>>>;
  id?: Maybe<Scalars['ID']>;
  interior?: Maybe<Array<Maybe<InteriorEnumType>>>;
  lights_on_dash?: Maybe<Scalars['Boolean']>;
  overall_condition?: Maybe<OverallConditionEnumType>;
  score?: Maybe<Scalars['Float']>;
  smoked_in?: Maybe<Scalars['Boolean']>;
  tires?: Maybe<TiresEnumType>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ConditionReportInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  id?: InputMaybe<Scalars['ID']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  score?: InputMaybe<Scalars['Float']>;
  smoked_in?: InputMaybe<Scalars['Boolean']>;
  tires?: InputMaybe<TiresEnumType>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type ConditionReportUpsert = {
  __typename?: 'conditionReportUpsert';
  accidents?: Maybe<AccidentsEnumType>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  exterior?: Maybe<Array<Maybe<ExteriorEnumType>>>;
  id?: Maybe<Scalars['ID']>;
  interior?: Maybe<Array<Maybe<InteriorEnumType>>>;
  lights_on_dash?: Maybe<Scalars['Boolean']>;
  overall_condition?: Maybe<OverallConditionEnumType>;
  smoked_in?: Maybe<Scalars['Boolean']>;
  tires?: Maybe<TiresEnumType>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ConditionReportUpsertInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  id?: InputMaybe<Scalars['ID']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  smoked_in?: InputMaybe<Scalars['Boolean']>;
  tires?: InputMaybe<TiresEnumType>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['String']>;
};

export type Conference = {
  __typename?: 'conference';
  agent_number?: Maybe<Scalars['String']>;
  agent_user_id?: Maybe<Scalars['String']>;
  conference_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_name?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['Int']>;
  deal_state?: Maybe<Scalars['String']>;
  deal_type?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  hunt_group_slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  is_outbound?: Maybe<Scalars['Boolean']>;
  is_thunder?: Maybe<Scalars['Boolean']>;
  next_participant?: Maybe<Scalars['String']>;
  participants_count?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  transferred_from?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Consent = {
  __typename?: 'consent';
  affiliate_id?: Maybe<Scalars['Int']>;
  consent_agreement_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<ConsentNameEnumType>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['String']>;
};

export type ConsentAgreement = {
  __typename?: 'consentAgreement';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<ConsentAgreementTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

export enum ConsentAgreementTypeEnum {
  AchPayment = 'ach_payment',
  CaliforniaDataSharingConsent = 'california_data_sharing_consent',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  HardPull = 'hard_pull',
  MarketplaceAcceptance = 'marketplace_acceptance',
  MarketplaceListing = 'marketplace_listing',
  MarketplaceSmsTextProgram = 'marketplace_sms_text_program',
  Methodfi = 'methodfi',
  SecureLinkBuyerSsn = 'secure_link_buyer_ssn',
  SoftPull = 'soft_pull',
  TermsAndConditions = 'terms_and_conditions'
}

export enum ConsentNameEnumType {
  AchPayment = 'ach_payment',
  CaliforniaDataSharingConsent = 'california_data_sharing_consent',
  CreditScoreHardPull = 'credit_score_hard_pull',
  CreditScoreSoftPull = 'credit_score_soft_pull',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  HistoricalCreditScoreHardPull = 'historical_credit_score_hard_pull',
  MarketplaceAcceptance = 'marketplace_acceptance',
  MarketplaceListing = 'marketplace_listing',
  MarketplaceSmsTextProgram = 'marketplace_sms_text_program',
  Methodfi = 'methodfi',
  SecureLinkBuyerSsn = 'secure_link_buyer_ssn',
  TermsAndConditions = 'terms_and_conditions'
}

export enum ContactType {
  Email = 'email',
  Text = 'text'
}

export type ContractTerm = {
  __typename?: 'contractTerm';
  financedTermQuantity?: Maybe<Scalars['Int']>;
  totalDownPaymentAmount?: Maybe<Scalars['Float']>;
};

export type Contracts = {
  __typename?: 'contracts';
  files?: Maybe<Array<Maybe<File>>>;
};

export type ContractsInput = {
  deal_id?: InputMaybe<Scalars['ID']>;
};

export type CreateEmbeddedInsuranceLeadAndGetLinkGraphQlType = {
  __typename?: 'createEmbeddedInsuranceLeadAndGetLinkGraphQLType';
  url?: Maybe<Scalars['String']>;
};

export type CreateNewEstimateFromFiles = {
  __typename?: 'createNewEstimateFromFiles';
  deal?: Maybe<Deal>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreditApplication = {
  __typename?: 'creditApplication';
  created_at?: Maybe<Scalars['DateTime']>;
  credit_application_data?: Maybe<CreditApplicationData>;
  credit_decisions?: Maybe<Array<Maybe<CreditDecision>>>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  provider?: Maybe<LendingNetwork>;
  /** Provider grouping identifier for related decisions (RouteOne conversation ID or CUDL application ID). */
  provider_decision_group_id?: Maybe<Scalars['String']>;
  r1_credit_app_guid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type CreditApplicationAddress = {
  __typename?: 'creditApplicationAddress';
  address_line?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  monthly_payment?: Maybe<Scalars['Float']>;
  months_at_home?: Maybe<Scalars['Int']>;
  residence_type?: Maybe<ResidenceTypeEnum>;
  state?: Maybe<Scalars['String']>;
  years_at_home?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type CreditApplicationAddressInput = {
  address_line?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  monthly_payment?: InputMaybe<Scalars['Float']>;
  months_at_home?: InputMaybe<Scalars['Int']>;
  residence_type?: InputMaybe<ResidenceTypeEnum>;
  state?: InputMaybe<Scalars['String']>;
  years_at_home?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreditApplicationBuyer = {
  __typename?: 'creditApplicationBuyer';
  address?: Maybe<CreditApplicationAddress>;
  dob?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  employment?: Maybe<CreditApplicationEmployment>;
  first_name?: Maybe<Scalars['String']>;
  home_phone_number?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  mailing_address?: Maybe<CreditApplicationAddress>;
  marital_status?: Maybe<MaritalStatusEnum>;
  middle_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  prev_address?: Maybe<CreditApplicationAddress>;
  prev_employment?: Maybe<CreditApplicationEmployment>;
  ssn_id?: Maybe<Scalars['ID']>;
};

export type CreditApplicationBuyerInput = {
  address?: InputMaybe<CreditApplicationAddressInput>;
  dob?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  employment?: InputMaybe<CreditApplicationEmploymentInput>;
  first_name?: InputMaybe<Scalars['String']>;
  home_phone_number?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mailing_address?: InputMaybe<CreditApplicationAddressInput>;
  marital_status?: InputMaybe<MaritalStatusEnum>;
  middle_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  prev_address?: InputMaybe<CreditApplicationAddressInput>;
  prev_employment?: InputMaybe<CreditApplicationEmploymentInput>;
  ssn_id?: InputMaybe<Scalars['ID']>;
};

export type CreditApplicationCar = {
  __typename?: 'creditApplicationCar';
  book_value?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
  kbb_trim_name?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  retail_book_value?: Maybe<Scalars['Float']>;
  valuation_source?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type CreditApplicationCarInput = {
  book_value?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<Scalars['String']>;
  kbb_trim_name?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  retail_book_value?: InputMaybe<Scalars['Float']>;
  valuation_source?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type CreditApplicationCreateInput = {
  credit_application_data: CreditApplicationDataInput;
  deal_id: Scalars['ID'];
};

export type CreditApplicationData = {
  __typename?: 'creditApplicationData';
  car?: Maybe<CreditApplicationCar>;
  cobuyer?: Maybe<CreditApplicationBuyer>;
  customer?: Maybe<CreditApplicationBuyer>;
  finance?: Maybe<CreditApplicationFinance>;
  relationshipToBuyer?: Maybe<RelationToBuyerEnum>;
};

export type CreditApplicationDataInput = {
  car?: InputMaybe<CreditApplicationCarInput>;
  cobuyer?: InputMaybe<CreditApplicationBuyerInput>;
  customer?: InputMaybe<CreditApplicationBuyerInput>;
  finance?: InputMaybe<CreditApplicationFinanceInput>;
  relationshipToBuyer?: InputMaybe<RelationToBuyerEnum>;
};

export type CreditApplicationEmployment = {
  __typename?: 'creditApplicationEmployment';
  gross_income?: Maybe<Scalars['Float']>;
  job_title?: Maybe<Scalars['String']>;
  months_at_job?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<IncomeIntervalEnum>;
  phone_number?: Maybe<Scalars['String']>;
  status?: Maybe<EmploymentStatusEnum>;
  years_at_job?: Maybe<Scalars['Int']>;
};

export type CreditApplicationEmploymentInput = {
  gross_income?: InputMaybe<Scalars['Float']>;
  job_title?: InputMaybe<Scalars['String']>;
  months_at_job?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<IncomeIntervalEnum>;
  phone_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  years_at_job?: InputMaybe<Scalars['Int']>;
};

export type CreditApplicationFinance = {
  __typename?: 'creditApplicationFinance';
  amount_financed?: Maybe<Scalars['Float']>;
  base_tax_amount?: Maybe<Scalars['Float']>;
  buyer_not_lessee?: Maybe<Scalars['Boolean']>;
  days_to_payment?: Maybe<Scalars['Int']>;
  doc_fee?: Maybe<Scalars['Float']>;
  gap_price?: Maybe<Scalars['Float']>;
  money_down?: Maybe<Scalars['Float']>;
  new_registration_fee?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
  payoff?: Maybe<Scalars['Float']>;
  registration_transfer_fee?: Maybe<Scalars['Float']>;
  sell_rate?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
  title_fee?: Maybe<Scalars['Float']>;
  vsc_price?: Maybe<Scalars['Float']>;
  vsc_term?: Maybe<Scalars['String']>;
  warranty_tax_amount?: Maybe<Scalars['Float']>;
};

export type CreditApplicationFinanceInput = {
  amount_financed?: InputMaybe<Scalars['Float']>;
  base_tax_amount?: InputMaybe<Scalars['Float']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']>;
  days_to_payment?: InputMaybe<Scalars['Int']>;
  doc_fee?: InputMaybe<Scalars['Float']>;
  gap_price?: InputMaybe<Scalars['Float']>;
  money_down?: InputMaybe<Scalars['Float']>;
  new_registration_fee?: InputMaybe<Scalars['Float']>;
  payment?: InputMaybe<Scalars['Float']>;
  payoff?: InputMaybe<Scalars['Float']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']>;
  sell_rate?: InputMaybe<Scalars['Float']>;
  term?: InputMaybe<Scalars['Int']>;
  title_fee?: InputMaybe<Scalars['Float']>;
  vsc_price?: InputMaybe<Scalars['Float']>;
  vsc_term?: InputMaybe<Scalars['String']>;
  warranty_tax_amount?: InputMaybe<Scalars['Float']>;
};

export type CreditApplicationUpdateInput = {
  credit_application_data: CreditApplicationDataInput;
  id: Scalars['ID'];
};

export type CreditDecision = {
  __typename?: 'creditDecision';
  annual_percentage_rate?: Maybe<Scalars['Float']>;
  /** Provider decision status code. Expected values: A (Accepted), D (Denied), O (Conditioned), C (Counteroffer), P (Pending Structure), R (Preliminary), I (Withdrawn), B (Booked), N (New), S (Submitted), OT (Funding). */
  application_status?: Maybe<CreditDecisionStatusEnum>;
  balance_amount?: Maybe<Scalars['Float']>;
  bank?: Maybe<Bank>;
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  lender_fees?: Maybe<Scalars['Float']>;
  lender_structured_requirement?: Maybe<LenderStructuredRequirement>;
  max_markup?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  /** Raw provider-specific decision payload. Shape depends on provider (RouteOne or CUDL). */
  provider_decision_data?: Maybe<ProviderDecisionData>;
  /** Provider grouping identifier shared by related credit decisions (RouteOne conversation ID or CUDL application ID). */
  provider_decision_group_id?: Maybe<Scalars['String']>;
  /** Provider decision identifier (RouteOne application number or CUDL decision ID). */
  provider_decision_id?: Maybe<Scalars['String']>;
  /** Provider lender identifier (RouteOne FSID or CUDL lender ID). */
  provider_lender_id?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum CreditDecisionStatusEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  I = 'I',
  N = 'N',
  O = 'O',
  Ot = 'OT',
  P = 'P',
  R = 'R',
  S = 'S'
}

export enum CreditScore {
  BelowAverage = 'BelowAverage',
  Fair = 'Fair',
  Good = 'Good',
  Great = 'Great'
}

export enum CreditScoreTierEnumType {
  Fair = 'fair',
  Good = 'good',
  NoResponse = 'no_response',
  Poor = 'poor',
  VeryGood = 'very_good'
}

export type Customer = {
  __typename?: 'customer';
  address?: Maybe<Address>;
  auth0_id?: Maybe<Scalars['String']>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  dashboard_visited?: Maybe<Scalars['Boolean']>;
  dl_expiration_date?: Maybe<Scalars['DateTime']>;
  dl_number?: Maybe<Scalars['String']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['Date']>;
  drivers_license_address?: Maybe<Address>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employment?: Maybe<Employment>;
  finished_signing?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: Maybe<Scalars['Boolean']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: Maybe<Scalars['Boolean']>;
  home_phone_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']>;
  mailing_address?: Maybe<Address>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: Maybe<Scalars['String']>;
  password_is_temp?: Maybe<Scalars['Boolean']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: Maybe<Scalars['DateTime']>;
  phone_number?: Maybe<Scalars['String']>;
  prequalification?: Maybe<Prequalification>;
  prev_address?: Maybe<Address>;
  prev_employment?: Maybe<Employment>;
  proof_of_insurance?: Maybe<ProofOfInsurance>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  secure_link?: Maybe<SecureLink>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: Maybe<Scalars['DateTime']>;
  signature_data?: Maybe<SignatureData>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: Maybe<Scalars['ID']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: Maybe<Scalars['Boolean']>;
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  dashboard_visited?: InputMaybe<Scalars['Boolean']>;
  dl_expiration_date?: InputMaybe<Scalars['DateTime']>;
  dl_number?: InputMaybe<Scalars['String']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  drivers_license_address?: InputMaybe<AddressInput>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employment?: InputMaybe<EmploymentInput>;
  first_name?: InputMaybe<Scalars['String']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: InputMaybe<Scalars['Boolean']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: InputMaybe<Scalars['Boolean']>;
  home_phone_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']>;
  mailing_address?: InputMaybe<AddressInput>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: InputMaybe<Scalars['String']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  phone_number?: InputMaybe<Scalars['String']>;
  prev_address?: InputMaybe<AddressInput>;
  prev_employment?: InputMaybe<EmploymentInput>;
  proof_of_insurance?: InputMaybe<ProofOfInsuranceInput>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: InputMaybe<Scalars['DateTime']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: InputMaybe<Scalars['DateTime']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: InputMaybe<Scalars['ID']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type CustomerNotification = {
  __typename?: 'customerNotification';
  auto_mark_as_seen: Scalars['Boolean'];
  call_to_actions?: Maybe<Array<Maybe<CustomerNotificationCallToAction>>>;
  content: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id: Scalars['ID'];
  deal_id: Scalars['ID'];
  dismissed_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  seen_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type CustomerNotificationCallToAction = {
  __typename?: 'customerNotificationCallToAction';
  action: CustomerNotificationCallToActions;
  label: Scalars['String'];
};

export type Deal = {
  __typename?: 'deal';
  after_hours_held_at?: Maybe<Scalars['DateTime']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']>;
  car?: Maybe<Car>;
  closer?: Maybe<User>;
  closer2?: Maybe<User>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']>;
  cobuyer?: Maybe<Customer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']>;
  completion_date_tz?: Maybe<Scalars['String']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']>;
  condition_report?: Maybe<ConditionReport>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  contact?: Maybe<DealContact>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']>;
  creation_date_tz?: Maybe<Scalars['String']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  customer?: Maybe<Customer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']>;
  dealIssues?: Maybe<Array<DealIssue>>;
  deal_assignment_log_entries?: Maybe<Array<Maybe<DealAssignmentLogEntry>>>;
  deal_dates?: Maybe<DealDates>;
  deal_financial_field_changes?: Maybe<Array<Maybe<DealFinancialFieldChange>>>;
  deal_phone_number_changes?: Maybe<Array<Maybe<CustomerPhoneNumberChange>>>;
  deal_pod_changes?: Maybe<Array<Maybe<DealPodChange>>>;
  deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  deal_source_changes?: Maybe<Array<Maybe<DealSourceChange>>>;
  deal_states?: Maybe<Array<Maybe<DealState>>>;
  deal_type_changes?: Maybe<Array<Maybe<DealTypeChange>>>;
  /** Primary queue sort timestamp. Initialized from lane_arrival_utc and updated by lane/state and follow-up events. */
  default_sort_date?: Maybe<Scalars['DateTime']>;
  document_info?: Maybe<DocumentInfo>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']>;
  extracted_document_data?: Maybe<ExtractedDocumentData>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']>;
  financial_info?: Maybe<FinancialInfo>;
  financial_info_acquisition?: Maybe<FinancialInfoAcquisition>;
  follow_up?: Maybe<FollowUp>;
  force_title_only_helper_link?: Maybe<ForceTitleOnlyHelperLink>;
  fs_pod?: Maybe<Pod>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']>;
  fundingRequirements?: Maybe<Array<FundingRequirement>>;
  funding_clerk?: Maybe<User>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']>;
  isCobuyer?: Maybe<Scalars['Boolean']>;
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** UTC timestamp for when the deal entered its current lane/state. */
  lane_arrival_utc?: Maybe<Scalars['DateTime']>;
  /** UTC timestamp of the most recent outgoing customer communication. */
  last_outgoing_communication_date_utc?: Maybe<Scalars['DateTime']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notification_subscribers?: Maybe<Array<Maybe<NotificationSubscriber>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  original_lessee?: Maybe<OriginalLessee>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']>;
  paperwork_type?: Maybe<PaperworkType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  pod?: Maybe<Pod>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  product?: Maybe<Product>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']>;
  referral_source?: Maybe<ReferralSource>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']>;
  roi_document_info?: Maybe<DocumentInfo>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']>;
  second_contact?: Maybe<DealContact>;
  second_turn_financial_specialist?: Maybe<User>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']>;
  selected_deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  selected_dealer_id?: Maybe<Scalars['Int']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']>;
  setter?: Maybe<User>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']>;
  shipping_labels?: Maybe<Array<Maybe<ShippingLabel>>>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']>;
  structuring_follow_up?: Maybe<StructuringFollowUp>;
  structuring_manager?: Maybe<User>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Tag>>;
  temporary_registration_tags_user?: Maybe<User>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  title_clerk?: Maybe<User>;
  title_clerk2?: Maybe<User>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']>;
  titling_pod?: Maybe<Pod>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealInput = {
  after_hours_held_at?: InputMaybe<Scalars['DateTime']>;
  ai_involvement?: InputMaybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: InputMaybe<Scalars['DateTime']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: InputMaybe<Scalars['String']>;
  auto_import_variation?: InputMaybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: InputMaybe<Scalars['JSONObject']>;
  called_by_financial_specialist?: InputMaybe<Scalars['DateTime']>;
  car?: InputMaybe<CarInput>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: InputMaybe<Scalars['ID']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: InputMaybe<Scalars['ID']>;
  cobuyer?: InputMaybe<CustomerInput>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: InputMaybe<Scalars['Int']>;
  completion_date_tz?: InputMaybe<Scalars['String']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: InputMaybe<Scalars['DateTime']>;
  condition_report?: InputMaybe<ConditionReportInput>;
  contact?: InputMaybe<DealContactInput>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: InputMaybe<Scalars['Int']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  creation_date_tz?: InputMaybe<Scalars['String']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerInput>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: InputMaybe<Scalars['Int']>;
  deal_assignment_log_entries?: InputMaybe<Array<InputMaybe<DealAssignmentLogEntryInput>>>;
  deal_dates?: InputMaybe<DealDatesInput>;
  deal_products?: InputMaybe<Array<InputMaybe<DealProductInputV2>>>;
  deal_states?: InputMaybe<Array<InputMaybe<DealStateInput>>>;
  document_info?: InputMaybe<DocumentInfoInput>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: InputMaybe<Scalars['String']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: InputMaybe<Scalars['ID']>;
  financial_info?: InputMaybe<FinancialInfoInput>;
  financial_info_acquisition?: InputMaybe<FinancialInfoAcquisitionInput>;
  follow_up?: InputMaybe<FollowUpInput>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: InputMaybe<Scalars['ID']>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  import_type?: InputMaybe<ImportType>;
  imported_date_utc?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: InputMaybe<Scalars['GUID']>;
  lock_status?: InputMaybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: InputMaybe<Scalars['String']>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  notification_subscribers?: InputMaybe<Array<InputMaybe<NotificationSubscriberInput>>>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
  original_lessee?: InputMaybe<OriginalLesseeInput>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: InputMaybe<Scalars['Int']>;
  paperwork_type?: InputMaybe<PaperworkType>;
  pod?: InputMaybe<PodInput>;
  /** ID of the primary sales pod assignment. */
  pod_id?: InputMaybe<Scalars['ID']>;
  r1_contract_generation_date_utc?: InputMaybe<Scalars['DateTime']>;
  r1_contract_manually_validated?: InputMaybe<Scalars['Boolean']>;
  r1_contract_validation_errors_object?: InputMaybe<R1ContractValidationErrorsInput>;
  r1_contract_validation_started_at?: InputMaybe<Scalars['DateTime']>;
  r1_contract_validation_warnings_object?: InputMaybe<R1ContractValidationWarningsInput>;
  r1_contract_worksheet_created_date_utc?: InputMaybe<Scalars['DateTime']>;
  /** RouteOne deal jacket identifier used for lender and e-contract workflows. */
  r1_jacket_id?: InputMaybe<Scalars['String']>;
  r1_jacket_id_created_date_utc?: InputMaybe<Scalars['DateTime']>;
  referral_source?: InputMaybe<ReferralSourceInput>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: InputMaybe<Scalars['Boolean']>;
  roi_document_info?: InputMaybe<DocumentInfoInput>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: InputMaybe<Scalars['Boolean']>;
  second_contact?: InputMaybe<DealContactInput>;
  second_turn_financial_specialist?: InputMaybe<UserInput>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: InputMaybe<Scalars['ID']>;
  selected_dealer_id?: InputMaybe<Scalars['Int']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: InputMaybe<Scalars['Int']>;
  sent_to_netsuite?: InputMaybe<Scalars['Boolean']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: InputMaybe<Scalars['DateTime']>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: InputMaybe<Scalars['ID']>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: InputMaybe<Scalars['Boolean']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: InputMaybe<Scalars['String']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: InputMaybe<Scalars['String']>;
  structuring_follow_up?: InputMaybe<StructuringFollowUpInput>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: InputMaybe<Scalars['ID']>;
  temporary_registration_tags_user_id?: InputMaybe<Scalars['ID']>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: InputMaybe<Scalars['ID']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: InputMaybe<Scalars['ID']>;
  titling_pod?: InputMaybe<PodInput>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<DealType>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type DealMedia = {
  __typename?: 'dealMedia';
  created_at?: Maybe<Scalars['DateTime']>;
  cudl_document_id?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['ID']>;
  generation_batch?: Maybe<Scalars['DateTime']>;
  has_verified_digital_signature?: Maybe<Scalars['Boolean']>;
  has_wet_signature?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  is_notarized?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  r1_document_id?: Maybe<Scalars['String']>;
  signed_url?: Maybe<Scalars['String']>;
  source?: Maybe<DealMediaSourceEnum>;
  state?: Maybe<DealMediaStateEnum>;
  type?: Maybe<DealMediaTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
  uploaded_by_user_id?: Maybe<Scalars['String']>;
  uploaded_via_com?: Maybe<Scalars['Boolean']>;
  verified?: Maybe<Scalars['Boolean']>;
  wet_signature_required?: Maybe<Scalars['Boolean']>;
};

export type DealMediaInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  cudl_document_id?: InputMaybe<Scalars['String']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  generation_batch?: InputMaybe<Scalars['DateTime']>;
  has_verified_digital_signature?: InputMaybe<Scalars['Boolean']>;
  has_wet_signature?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  is_notarized?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  r1_document_id?: InputMaybe<Scalars['String']>;
  signed_url?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<DealMediaSourceEnum>;
  state?: InputMaybe<DealMediaStateEnum>;
  type?: InputMaybe<DealMediaTypeEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  uploaded_by_user_id?: InputMaybe<Scalars['String']>;
  uploaded_via_com?: InputMaybe<Scalars['Boolean']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  wet_signature_required?: InputMaybe<Scalars['Boolean']>;
};

export enum DealMediaTypeEnum {
  AcuraSpecificOdometerDoc = 'acura_specific_odometer_doc',
  AgreementToFurnishInsurance = 'agreement_to_furnish_insurance',
  AlabamaAirbagDisclosureStatement = 'alabama_airbag_disclosure_statement',
  AllyCertifiedPreOwnedAcknowledgement = 'ally_certified_pre_owned_acknowledgement',
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BookSheet = 'book_sheet',
  BuyersGuide = 'buyers_guide',
  CaliforniaSpecialInterestLicensePlateApplication = 'california_special_interest_license_plate_application',
  CaliforniaStatementOfFacts = 'california_statement_of_facts',
  CaliforniaStatementOfFactsCobuyer = 'california_statement_of_facts_cobuyer',
  CoBuyerConnecticutElectronicRegistrationAndTitleAgreement = 'co_buyer_connecticut_electronic_registration_and_title_agreement',
  CobuyerProcessorPowerOfAttorney = 'cobuyer_processor_power_of_attorney',
  CobuyerRegistrationSpecificPowerOfAttorney = 'cobuyer_registration_specific_power_of_attorney',
  CobuyerSecurePowerOfAttorney = 'cobuyer_secure_power_of_attorney',
  CobuyerStateSpecificOdoDoc = 'cobuyer_state_specific_odo_doc',
  ColoradoCobuyerSupplementalIdentificationClause = 'colorado_cobuyer_supplemental_identification_clause',
  ColoradoJointTenancy = 'colorado_joint_tenancy',
  ColoradoSupplementalIdentificationClause = 'colorado_supplemental_identification_clause',
  ConnecticutElectronicRegistrationAndTitleAgreement = 'connecticut_electronic_registration_and_title_agreement',
  Contract = 'contract',
  CpsGuaranteeOfTitle = 'cps_guarantee_of_title',
  CreditApplication = 'credit_application',
  CreditApproval = 'credit_approval',
  DamageDisclosure = 'damage_disclosure',
  DemandLetter = 'demand_letter',
  DownPayment = 'down_payment',
  ESignConsent = 'e_sign_consent',
  ElectronicSignatureAttestation = 'electronic_signature_attestation',
  ElectronicSignatureCertification = 'electronic_signature_certification',
  ElectronicSignatureVerification = 'electronic_signature_verification',
  Emissions = 'emissions',
  FirstFedCoverLetter = 'first_fed_cover_letter',
  FirstFedOdometerDisclosure = 'first_fed_odometer_disclosure',
  FirstFedPayoffAuthorization = 'first_fed_payoff_authorization',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  GmAssignmentOfTitleDamageDisclosure = 'gm_assignment_of_title_damage_disclosure',
  GmLeasePacket = 'gm_lease_packet',
  HondaSpecificOdometerDoc = 'honda_specific_odometer_doc',
  IdahoSalesTaxExemption = 'idaho_sales_tax_exemption',
  IllinoisLeasedVehicleRegistrationAffirmation = 'illinois_leased_vehicle_registration_affirmation',
  LeaseAgreement = 'lease_agreement',
  LeaseEndAcqContract = 'lease_end_acq_contract',
  LeaseEndCashback = 'lease_end_cashback',
  LeaseendOdoDoc = 'leaseend_odo_doc',
  LeaseendOdoDocCobuyer = 'leaseend_odo_doc_cobuyer',
  LeaseendOdoDocJoint = 'leaseend_odo_doc_joint',
  LicensePlate = 'license_plate',
  LouisianaMercedesDamageDisclosure = 'louisiana_mercedes_damage_disclosure',
  MembershipForm = 'membership_form',
  MontrosePowerOfAttorney = 'montrose_power_of_attorney',
  NewHampshireRegistrationCopyApplication = 'new_hampshire_registration_copy_application',
  NewYorkCpsNoticeOfLien = 'new_york_cps_notice_of_lien',
  OdoDoc = 'odo_doc',
  OdometerPicture = 'odometer_picture',
  OhioHondaSpecificOdometerDoc = 'ohio_honda_specific_odometer_doc',
  Other = 'other',
  PayoffAuthorization = 'payoff_authorization',
  PayoffDocs = 'payoff_docs',
  PayoffPacket = 'payoff_packet',
  PhysicalSignatureCoverLetter = 'physical_signature_cover_letter',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  PorscheSpecificOdometerDoc = 'porsche_specific_odometer_doc',
  PorscheSpecificPayoffInstructions = 'porsche_specific_payoff_instructions',
  PowerOfAttorney = 'power_of_attorney',
  PowerOfAttorneyCobuyer = 'power_of_attorney_cobuyer',
  PrivacyPolicy = 'privacy_policy',
  ProcessorPowerOfAttorney = 'processor_power_of_attorney',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  PurchaseOrder = 'purchase_order',
  R1EContract = 'r1_e_contract',
  RateExceptionForm = 'rate_exception_form',
  ReassignmentDisclosure = 'reassignment_disclosure',
  Registration = 'registration',
  RegistrationComplete = 'registration_complete',
  RegistrationSpecificPowerOfAttorney = 'registration_specific_power_of_attorney',
  ReleaseOfInterest = 'release_of_interest',
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation',
  SafetyInspection = 'safety_inspection',
  SalesTaxExemption = 'sales_tax_exemption',
  SantanderCanadaConditionalSalesContract = 'santander_canada_conditional_sales_contract',
  SantanderCanadaCreditApplication = 'santander_canada_credit_application',
  SantanderCanadaCustomerIdentificationForm = 'santander_canada_customer_identification_form',
  SantanderGuaranteeOfTitle = 'santander_guarantee_of_title',
  SecurePowerOfAttorney = 'secure_power_of_attorney',
  SignedDocs = 'signed_docs',
  SmogInspection = 'smog_inspection',
  StateAndLienholderSpecificPowerOfAttorney = 'state_and_lienholder_specific_power_of_attorney',
  StateSpecificDamageDisclosure = 'state_specific_damage_disclosure',
  StateSpecificDocs = 'state_specific_docs',
  StateSpecificOdoDoc = 'state_specific_odo_doc',
  StateSpecificPowerOfAttorney = 'state_specific_power_of_attorney',
  StateSpecificPowerOfAttorneyCobuyer = 'state_specific_power_of_attorney_cobuyer',
  StateSpecificPurchaseOrder = 'state_specific_purchase_order',
  TaterDocs = 'tater_docs',
  TaxExemption = 'tax_exemption',
  TempTag = 'temp_tag',
  TexasHidalgoDoc = 'texas_hidalgo_doc',
  Title = 'title',
  TitleApplication = 'title_application',
  TitlePacket = 'title_packet',
  TitleRelease = 'title_release',
  VinInspection = 'vin_inspection',
  VscAndGap = 'vsc_and_gap',
  WetSignature = 'wet_signature'
}

export type DealSetter = {
  __typename?: 'dealSetter';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  setter?: Maybe<User>;
  setter_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type DealState = {
  __typename?: 'dealState';
  closing_note_snapshot?: Maybe<ClosingNoteSnapshot>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  /** Workflow state snapshot recorded in deal history. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_date_utc?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']>;
};

export type DealStateInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Workflow state snapshot recorded in deal history. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  updated_date_utc?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type DealerInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  dealership_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  observes_daylight_saving?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Deals = {
  __typename?: 'deals';
  after_hours_held_at?: Maybe<Scalars['DateTime']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']>;
  car?: Maybe<Car>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']>;
  cobuyer?: Maybe<Customer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']>;
  completion_date_tz?: Maybe<Scalars['String']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']>;
  creation_date_tz?: Maybe<Scalars['String']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Customer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']>;
  isCobuyer?: Maybe<Scalars['Boolean']>;
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']>;
  paperwork_type?: Maybe<PaperworkType>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']>;
  selected_dealer_id?: Maybe<Scalars['Int']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Decision = {
  __typename?: 'decision';
  conditionRejection?: Maybe<Array<Maybe<ConditionRejection>>>;
  decisionComments?: Maybe<Array<Maybe<Scalars['String']>>>;
  financing?: Maybe<Financing>;
  stipulations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DecryptedSsn = {
  __typename?: 'decryptedSSN';
  ssn?: Maybe<Scalars['String']>;
  ssnId?: Maybe<Scalars['ID']>;
};

export type Deductible = {
  __typename?: 'deductible';
  amount?: Maybe<Scalars['String']>;
  dealer_cost?: Maybe<Scalars['String']>;
  deductible_type?: Maybe<Scalars['String']>;
  f_i_markup?: Maybe<Scalars['String']>;
  max_retail_price?: Maybe<Scalars['String']>;
  min_retail_price?: Maybe<Scalars['String']>;
  rate_id?: Maybe<Scalars['Int']>;
  reduced_amount?: Maybe<Scalars['String']>;
  retail_price?: Maybe<Scalars['String']>;
};

export type Destinations = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type DetermineApproval = {
  __typename?: 'determineApproval';
  approved?: Maybe<Scalars['Boolean']>;
  failedCriteria?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DetermineApprovalInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  book_value?: InputMaybe<Scalars['Float']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  kbb_trim?: InputMaybe<Scalars['String']>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  smoked_in?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  temporary_info_id?: InputMaybe<Scalars['String']>;
  tires?: InputMaybe<TiresEnumType>;
  vehicle_type?: InputMaybe<Scalars['String']>;
};

export type DetermineApprovalQueryInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  book_value?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<Scalars['String']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  financial_info_acquisition_id?: InputMaybe<Scalars['ID']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  kbb_trim?: InputMaybe<Scalars['String']>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']>;
  mileage?: InputMaybe<Scalars['Float']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  payoff?: InputMaybe<Scalars['Float']>;
  smoked_in?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  tires?: InputMaybe<TiresEnumType>;
  vehicle_type?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type Documents = {
  __typename?: 'documents';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  files?: Maybe<Array<Maybe<File>>>;
  penError?: Maybe<Scalars['String']>;
  /** Documents skipped because their generation conditions were not met. */
  skippedDocuments: Array<SkippedDocument>;
};

export type DocumentsInput = {
  deal_id?: InputMaybe<Scalars['ID']>;
  generation_batch?: InputMaybe<Scalars['String']>;
  internal_media?: InputMaybe<Array<InputMaybe<DealMediaTypeEnum>>>;
};

export enum DownPaymentStatus {
  Completed = 'COMPLETED',
  ManuallyCompleted = 'MANUALLY_COMPLETED',
  Na = 'NA',
  Requested = 'REQUESTED',
  Sent = 'SENT'
}

export type EiRedirectGraphQlType = {
  __typename?: 'eiRedirectGraphQLType';
  url?: Maybe<Scalars['String']>;
};

export type Employment = {
  __typename?: 'employment';
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id?: Maybe<Scalars['ID']>;
  employment_type?: Maybe<EmploymentTypeEnum>;
  gross_income?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  job_title?: Maybe<Scalars['String']>;
  months_at_job?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<IncomeIntervalEnum>;
  phone_number?: Maybe<Scalars['String']>;
  status?: Maybe<EmploymentStatusEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
  years_at_job?: Maybe<Scalars['Int']>;
};

export enum EmploymentEnumType {
  FullTime = 'full_time',
  PartTime = 'part_time'
}

export type EmploymentInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  employment_type?: InputMaybe<EmploymentTypeEnum>;
  gross_income?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  job_title?: InputMaybe<Scalars['String']>;
  months_at_job?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<IncomeIntervalEnum>;
  phone_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  years_at_job?: InputMaybe<Scalars['Int']>;
};

export enum ErrorCodeEnum {
  BadUserInput = 'BAD_USER_INPUT',
  CardPaymentLimitExceeded = 'CARD_PAYMENT_LIMIT_EXCEEDED',
  CardTypeMismatch = 'CARD_TYPE_MISMATCH',
  Forbidden = 'FORBIDDEN',
  LockTimeout = 'LOCK_TIMEOUT',
  NotFound = 'NOT_FOUND',
  ResetGuidError = 'RESET_GUID_ERROR',
  TempInfoNotFound = 'TEMP_INFO_NOT_FOUND',
  Unauthenticated = 'UNAUTHENTICATED'
}

export enum ExteriorEnumType {
  DentsOrDings = 'dents_or_dings',
  GlassWindshieldDamage = 'glass_windshield_damage',
  HailDamage = 'hail_damage',
  MinorScuffs = 'minor_scuffs',
  PaintDamage = 'paint_damage',
  Rusting = 'rusting'
}

export type ExternalCustomer = {
  __typename?: 'externalCustomer';
  address?: Maybe<Address>;
  auth0_id?: Maybe<Scalars['String']>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  dashboard_visited?: Maybe<Scalars['Boolean']>;
  dl_expiration_date?: Maybe<Scalars['DateTime']>;
  dl_number?: Maybe<Scalars['String']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['Date']>;
  drivers_license_address?: Maybe<Address>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employment?: Maybe<Employment>;
  finished_signing?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: Maybe<Scalars['Boolean']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: Maybe<Scalars['Boolean']>;
  home_phone_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']>;
  mailing_address?: Maybe<Address>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: Maybe<Scalars['String']>;
  password_is_temp?: Maybe<Scalars['Boolean']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: Maybe<Scalars['DateTime']>;
  phone_number?: Maybe<Scalars['String']>;
  prequalification?: Maybe<ExternalPrequalification>;
  prev_address?: Maybe<Address>;
  prev_employment?: Maybe<Employment>;
  proof_of_insurance?: Maybe<ProofOfInsurance>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  secure_link?: Maybe<SecureLink>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: Maybe<Scalars['DateTime']>;
  signature_data?: Maybe<SignatureData>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: Maybe<Scalars['ID']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: Maybe<Scalars['Boolean']>;
};

export type ExternalDeal = {
  __typename?: 'externalDeal';
  after_hours_held_at?: Maybe<Scalars['DateTime']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']>;
  came_from_marketplace?: Maybe<Scalars['Boolean']>;
  car?: Maybe<Car>;
  closer?: Maybe<User>;
  closer2?: Maybe<User>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']>;
  cobuyer?: Maybe<ExternalCustomer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']>;
  completion_date_tz?: Maybe<Scalars['String']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']>;
  condition_report?: Maybe<ConditionReport>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  contact?: Maybe<DealContact>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']>;
  creation_date_tz?: Maybe<Scalars['String']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  customer?: Maybe<ExternalCustomer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']>;
  deal_assignment_log_entries?: Maybe<Array<Maybe<DealAssignmentLogEntry>>>;
  deal_dates?: Maybe<DealDates>;
  deal_pod_changes?: Maybe<Array<Maybe<DealPodChange>>>;
  deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  deal_source_changes?: Maybe<Array<Maybe<DealSourceChange>>>;
  deal_states?: Maybe<Array<Maybe<DealState>>>;
  deal_type_changes?: Maybe<Array<Maybe<DealTypeChange>>>;
  /** Primary queue sort timestamp. Initialized from lane_arrival_utc and updated by lane/state and follow-up events. */
  default_sort_date?: Maybe<Scalars['DateTime']>;
  document_info?: Maybe<DocumentInfo>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']>;
  extracted_document_data?: Maybe<ExtractedDocumentData>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']>;
  financial_info?: Maybe<FinancialInfo>;
  financial_info_acquisition?: Maybe<FinancialInfoAcquisition>;
  follow_up?: Maybe<FollowUp>;
  force_title_only_helper_link?: Maybe<ForceTitleOnlyHelperLink>;
  fs_pod?: Maybe<Pod>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']>;
  funding_clerk?: Maybe<User>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']>;
  isCobuyer?: Maybe<Scalars['Boolean']>;
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** UTC timestamp for when the deal entered its current lane/state. */
  lane_arrival_utc?: Maybe<Scalars['DateTime']>;
  /** UTC timestamp of the most recent outgoing customer communication. */
  last_outgoing_communication_date_utc?: Maybe<Scalars['DateTime']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notification_subscribers?: Maybe<Array<Maybe<NotificationSubscriber>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  original_lessee?: Maybe<OriginalLessee>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']>;
  paperwork_type?: Maybe<PaperworkType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  pod?: Maybe<Pod>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  product?: Maybe<Product>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']>;
  referral_source?: Maybe<ReferralSource>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']>;
  roi_document_info?: Maybe<DocumentInfo>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']>;
  second_contact?: Maybe<DealContact>;
  second_turn_financial_specialist?: Maybe<User>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']>;
  selected_deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  selected_dealer_id?: Maybe<Scalars['Int']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']>;
  setter?: Maybe<User>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']>;
  shipping_labels?: Maybe<Array<Maybe<ShippingLabel>>>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']>;
  structuring_follow_up?: Maybe<StructuringFollowUp>;
  structuring_manager?: Maybe<User>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Tag>>;
  temporary_registration_tags_user?: Maybe<User>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  title_clerk?: Maybe<User>;
  title_clerk2?: Maybe<User>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']>;
  titling_pod?: Maybe<Pod>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ExternalDealUploadUrl = {
  __typename?: 'externalDealUploadUrl';
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ExternalPrequalification = {
  __typename?: 'externalPrequalification';
  created_at?: Maybe<Scalars['DateTime']>;
  credit_score_tier?: Maybe<CreditScoreTierEnumType>;
  customer_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  ltv?: Maybe<Scalars['Float']>;
  payment_to_income?: Maybe<Scalars['Float']>;
  prequalification_errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ExternalTempInfoUploadUrl = {
  __typename?: 'externalTempInfoUploadUrl';
  url?: Maybe<Scalars['String']>;
};

export type ExtraTempInfoInputType = {
  address_line?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_chat?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  prequal_id?: InputMaybe<Scalars['ID']>;
  shopping_cart?: InputMaybe<TemporaryShoppingCartDataInput>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ExtractedDocumentData = {
  __typename?: 'extractedDocumentData';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  dl_address?: Maybe<Scalars['String']>;
  dl_city?: Maybe<Scalars['String']>;
  dl_document_number?: Maybe<Scalars['String']>;
  dl_expiration_date?: Maybe<Scalars['String']>;
  dl_first_name?: Maybe<Scalars['String']>;
  dl_last_name?: Maybe<Scalars['String']>;
  dl_middle_name?: Maybe<Scalars['String']>;
  dl_sex?: Maybe<Scalars['String']>;
  dl_state?: Maybe<Scalars['String']>;
  dl_suffix?: Maybe<Scalars['String']>;
  dl_zip?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  insurance_company?: Maybe<Scalars['String']>;
  insurance_company_confidence?: Maybe<Scalars['Int']>;
  insurance_expiration?: Maybe<Scalars['String']>;
  insurance_expiration_confidence?: Maybe<Scalars['Int']>;
  insurance_name?: Maybe<Scalars['String']>;
  insurance_name_confidence?: Maybe<Scalars['Int']>;
  insurance_policy_number?: Maybe<Scalars['String']>;
  insurance_policy_number_confidence?: Maybe<Scalars['Int']>;
  insurance_state?: Maybe<Scalars['String']>;
  insurance_state_confidence?: Maybe<Scalars['Int']>;
  insurance_vin?: Maybe<Scalars['String']>;
  insurance_vin_confidence?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type FinancialInfo = {
  __typename?: 'financialInfo';
  /** Final realized reserve amount in USD. */
  actual_reserve?: Maybe<Scalars['Float']>;
  /** Total financed principal amount in USD. */
  amount_financed?: Maybe<Scalars['Float']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: Maybe<Scalars['String']>;
  bank_fees?: Maybe<Scalars['Float']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: Maybe<Scalars['Boolean']>;
  bank_slug?: Maybe<TtNewBankEnum>;
  base_tax_amount?: Maybe<Scalars['Float']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: Maybe<Scalars['Float']>;
  buyer_not_lessee?: Maybe<Scalars['Boolean']>;
  closer_commission?: Maybe<Scalars['Float']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: Maybe<Scalars['Float']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  credit_card_payment_amount_limit?: Maybe<Scalars['Float']>;
  credit_debit_payment_amount_allowed?: Maybe<Scalars['Float']>;
  credit_payment_amount_allowed?: Maybe<Scalars['Float']>;
  credit_payment_amount_limit?: Maybe<Scalars['Float']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: Maybe<Scalars['Int']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']>;
  debit_payment_amount_allowed?: Maybe<Scalars['Float']>;
  debit_payment_amount_limit?: Maybe<Scalars['Float']>;
  doc_fee?: Maybe<Scalars['Float']>;
  down_payment_status?: Maybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: Maybe<Scalars['String']>;
  first_payment_date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  /** Resolved max markup: prefers selected_credit_decision.max_markup, falls back to bank_markups lookup by bank+term. */
  maxMarkup?: Maybe<Scalars['Float']>;
  /**
   * Deprecated: minimum markup is no longer enforced for any bank; always null.
   * @deprecated Minimum markup is no longer enforced for any bank; always null. Remove from queries.
   */
  minMarkup?: Maybe<Scalars['Float']>;
  money_down?: Maybe<Scalars['Float']>;
  needs_temporary_registration_tags?: Maybe<Scalars['Boolean']>;
  new_lienholder?: Maybe<Bank>;
  new_registration_fee?: Maybe<Scalars['Float']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: Maybe<Scalars['String']>;
  /** Estimated monthly payment amount in USD. */
  payment?: Maybe<Scalars['Float']>;
  plate_transfer?: Maybe<Scalars['Boolean']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['Float']>;
  quick_notes?: Maybe<Scalars['String']>;
  registration_transfer_fee?: Maybe<Scalars['Float']>;
  /** Calculated reserve amount in USD. */
  reserve?: Maybe<Scalars['Float']>;
  sales_tax_rate?: Maybe<Scalars['Float']>;
  selected_credit_decision?: Maybe<CreditDecision>;
  selected_credit_decision_id?: Maybe<Scalars['ID']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: Maybe<Scalars['Float']>;
  setter_commission?: Maybe<Scalars['Float']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['Int']>;
  title_fee?: Maybe<Scalars['Float']>;
  title_registration_option?: Maybe<TitleRegistrationOption>;
  tt_transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: Maybe<Scalars['Float']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: Maybe<Scalars['Float']>;
};

export type FinancialInfoAcquisition = {
  __typename?: 'financialInfoAcquisition';
  appraised_value?: Maybe<Scalars['Float']>;
  auction_fees?: Maybe<Scalars['Float']>;
  auction_id?: Maybe<Scalars['ID']>;
  cash_to_customer?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['ID']>;
  estimated_dealer_fees?: Maybe<Scalars['Float']>;
  gross_profit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  is_approved?: Maybe<Scalars['Boolean']>;
  kbb_lending?: Maybe<Scalars['Float']>;
  max_cash_to_customer?: Maybe<Scalars['Float']>;
  max_total_cost?: Maybe<Scalars['Float']>;
  offer?: Maybe<Scalars['Float']>;
  overriding_user_id?: Maybe<Scalars['String']>;
  sell_price?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  transport_cost?: Maybe<Scalars['Float']>;
};

export type FinancialInfoAcquisitionInput = {
  appraised_value?: InputMaybe<Scalars['Float']>;
  auction_fees?: InputMaybe<Scalars['Float']>;
  auction_id?: InputMaybe<Scalars['ID']>;
  cash_to_customer?: InputMaybe<Scalars['Float']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  estimated_dealer_fees?: InputMaybe<Scalars['Float']>;
  gross_profit?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  is_approved?: InputMaybe<Scalars['Boolean']>;
  kbb_lending?: InputMaybe<Scalars['Float']>;
  max_cash_to_customer?: InputMaybe<Scalars['Float']>;
  max_total_cost?: InputMaybe<Scalars['Float']>;
  offer?: InputMaybe<Scalars['Float']>;
  overriding_user_id?: InputMaybe<Scalars['String']>;
  sell_price?: InputMaybe<Scalars['Float']>;
  total_cost?: InputMaybe<Scalars['Float']>;
  transport_cost?: InputMaybe<Scalars['Float']>;
};

export type FinancialInfoInput = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: InputMaybe<Scalars['String']>;
  bank_fees?: InputMaybe<Scalars['Float']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']>;
  base_tax_amount?: InputMaybe<Scalars['Float']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']>;
  closer_commission?: InputMaybe<Scalars['Float']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  doc_fee?: InputMaybe<Scalars['Float']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']>;
  first_payment_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  money_down?: InputMaybe<Scalars['Float']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']>;
  new_lienholder?: InputMaybe<BankInput>;
  new_registration_fee?: InputMaybe<Scalars['Float']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['Float']>;
  quick_notes?: InputMaybe<Scalars['String']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']>;
  setter_commission?: InputMaybe<Scalars['Float']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
  title_fee?: InputMaybe<Scalars['Float']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']>;
};

export type FinancialInfoPaymentEstimate = {
  __typename?: 'financialInfoPaymentEstimate';
  avg_payment?: Maybe<Scalars['Float']>;
  max_payment?: Maybe<Scalars['Float']>;
  min_payment?: Maybe<Scalars['Float']>;
};

export type Financing = {
  __typename?: 'financing';
  annualPercentageRate?: Maybe<Scalars['Float']>;
  downPaymentAmount?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
};

export type FinixTransfer = {
  __typename?: 'finixTransfer';
  amount?: Maybe<Scalars['Float']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardType?: Maybe<CardType>;
  failureCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maskedNumber?: Maybe<Scalars['String']>;
  state?: Maybe<PaymentState>;
};

export type FlowStatus = {
  __typename?: 'flowStatus';
  car?: Maybe<Car>;
  customerId?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['String']>;
  inFlow?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type FollowUp = {
  __typename?: 'followUp';
  created_at?: Maybe<Scalars['DateTime']>;
  creator?: Maybe<User>;
  creator_id?: Maybe<Scalars['ID']>;
  date_utc?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<FollowUpStatusEnum>;
  type?: Maybe<FollowUpTypeEnum>;
  tz?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type FollowUpInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  creator_id?: InputMaybe<Scalars['ID']>;
  date_utc?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<FollowUpStatusEnum>;
  type?: InputMaybe<FollowUpTypeEnum>;
  tz?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export enum FollowUpStatusEnum {
  Completed = 'completed',
  Deleted = 'deleted',
  Due = 'due',
  Scheduled = 'scheduled'
}

export enum FollowUpTypeEnum {
  Appointment = 'appointment',
  Reminder = 'reminder'
}

export type ForceTitleOnlyHelperLink = {
  __typename?: 'forceTitleOnlyHelperLink';
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type GetAvailableUsers = {
  __typename?: 'getAvailableUsers';
  assignment_mode?: Maybe<AssignmentMode>;
  auto_assign_deals?: Maybe<Scalars['Boolean']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  frequency_minutes?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  in_call?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  on_vacation?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  recruiter_id?: Maybe<Scalars['String']>;
  twilio_number?: Maybe<Scalars['String']>;
  user_type?: Maybe<UserType>;
};

export type GetWaitingCalls = {
  __typename?: 'getWaitingCalls';
  data?: Maybe<Scalars['JSONObject']>;
};

export enum InboxFilterByEnum {
  All = 'all',
  AllSalesPods = 'all_sales_pods',
  AllTitlePods = 'all_title_pods',
  MyLanes = 'my_lanes',
  MyTeams = 'my_teams',
  SalesPod = 'sales_pod',
  TitlePod = 'title_pod',
  YourMessages = 'your_messages'
}

export type InboxMessagesType = {
  __typename?: 'inboxMessagesType';
  messages?: Maybe<Array<Maybe<Message>>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export enum InboxOrderByEnum {
  DateNewest = 'date_newest',
  DateOldest = 'date_oldest',
  Deal = 'deal'
}

export enum InteriorEnumType {
  EntertainmentConsoleDamage = 'entertainment_console_damage',
  RipsOrTears = 'rips_or_tears',
  SmellsOrOdors = 'smells_or_odors',
  Stains = 'stains'
}

export type JdpVehicleAccessories = {
  __typename?: 'jdpVehicleAccessories';
  acccode?: Maybe<Scalars['String']>;
  accdesc?: Maybe<Scalars['String']>;
  accessorycategory?: Maybe<Scalars['String']>;
  excludes?: Maybe<Scalars['String']>;
  includes?: Maybe<Scalars['String']>;
  isadded?: Maybe<Scalars['Int']>;
  isincluded?: Maybe<Scalars['Int']>;
  loan?: Maybe<Scalars['Int']>;
  retail?: Maybe<Scalars['Int']>;
  tradein?: Maybe<Scalars['Int']>;
};

export type JdpVehicleAccessoriesInput = {
  acccode?: InputMaybe<Scalars['String']>;
  accdesc?: InputMaybe<Scalars['String']>;
  accessorycategory?: InputMaybe<Scalars['String']>;
  excludes?: InputMaybe<Scalars['String']>;
  includes?: InputMaybe<Scalars['String']>;
  isadded?: InputMaybe<Scalars['Int']>;
  isincluded?: InputMaybe<Scalars['Int']>;
  loan?: InputMaybe<Scalars['Int']>;
  retail?: InputMaybe<Scalars['Int']>;
  tradein?: InputMaybe<Scalars['Int']>;
};

export type JdpVehicleAccessoriesObject = {
  __typename?: 'jdpVehicleAccessoriesObject';
  vehicle_accessories?: Maybe<Array<Maybe<JdpVehicleAccessories>>>;
};

export type JdpVehicleAccessoriesObjectInput = {
  vehicle_accessories?: InputMaybe<Array<InputMaybe<JdpVehicleAccessoriesInput>>>;
};

export type KbbConfigType = {
  action?: InputMaybe<Scalars['String']>;
  optionId?: InputMaybe<Scalars['Int']>;
};

export type KbbOption = {
  __typename?: 'kbbOption';
  categoryGroup?: Maybe<Scalars['String']>;
  hasRelationships?: Maybe<Scalars['Boolean']>;
  isConfigurable?: Maybe<Scalars['Boolean']>;
  isConsumer?: Maybe<Scalars['Boolean']>;
  isTypical?: Maybe<Scalars['Boolean']>;
  isVinDecoded?: Maybe<Scalars['Boolean']>;
  optionName?: Maybe<Scalars['String']>;
  optionType?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  vehicleId?: Maybe<Scalars['Int']>;
  vehicleOptionId?: Maybe<Scalars['Int']>;
};

export type KbbOptionInput = {
  categoryGroup?: InputMaybe<Scalars['String']>;
  hasRelationships?: InputMaybe<Scalars['Boolean']>;
  isConfigurable?: InputMaybe<Scalars['Boolean']>;
  isConsumer?: InputMaybe<Scalars['Boolean']>;
  isTypical?: InputMaybe<Scalars['Boolean']>;
  isVinDecoded?: InputMaybe<Scalars['Boolean']>;
  optionName?: InputMaybe<Scalars['String']>;
  optionType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['Int']>;
  vehicleOptionId?: InputMaybe<Scalars['Int']>;
};

export type KbbSelectedOptionsType = {
  __typename?: 'kbbSelectedOptionsType';
  categoryGroup?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lendingOptionPrice?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  removed?: Maybe<Scalars['Boolean']>;
  retailOptionPrice?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type KbbValuesDataType = {
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>>>;
  mileage?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['Int']>;
  vehicleOptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type KbbValuesResult = {
  __typename?: 'kbbValuesResult';
  kbbSelectedOptions?: Maybe<Array<Maybe<KbbSelectedOptionsType>>>;
  lending?: Maybe<Scalars['Float']>;
  lendingMileageAdjustment?: Maybe<Scalars['Float']>;
  lendingOptionAdjustment?: Maybe<Scalars['Float']>;
  lendingOptionPrices?: Maybe<Scalars['JSON']>;
  retail?: Maybe<Scalars['Float']>;
  retailMileageAdjustment?: Maybe<Scalars['Float']>;
  retailOptionAdjustment?: Maybe<Scalars['Float']>;
  retailOptionPrices?: Maybe<Scalars['JSON']>;
  valuationDate?: Maybe<Scalars['String']>;
};

export type KbbVinObjectResult = {
  __typename?: 'kbbVinObjectResult';
  vinResults?: Maybe<Array<Maybe<KbbVinResult>>>;
  warning?: Maybe<Scalars['Boolean']>;
};

export type KbbVinResult = {
  __typename?: 'kbbVinResult';
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  trimName?: Maybe<Scalars['String']>;
  vehicleId?: Maybe<Scalars['Int']>;
  vehicleName?: Maybe<Scalars['String']>;
  vehicleOptions?: Maybe<Array<Maybe<KbbOption>>>;
  yearId?: Maybe<Scalars['String']>;
};

export type KeyMetric = {
  __typename?: 'keyMetric';
  keyMetric?: Maybe<Scalars['String']>;
  value?: Maybe<Value>;
};

export type LaneKeyMetric = {
  __typename?: 'laneKeyMetric';
  day_count?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

export type LeaderboardSetterStats = {
  __typename?: 'leaderboardSetterStats';
  numApps?: Maybe<Scalars['Int']>;
  repId?: Maybe<Scalars['String']>;
  repName?: Maybe<Scalars['String']>;
  teamType?: Maybe<TeamType>;
};

export type LenderStructuredRequirement = {
  __typename?: 'lenderStructuredRequirement';
  backend_limits?: Maybe<BackendLimits>;
  contract_funding_rules?: Maybe<ContractFundingRules>;
  created_at?: Maybe<Scalars['DateTime']>;
  credit_decision_id?: Maybe<Scalars['Int']>;
  documentation_requirements?: Maybe<DocumentationRequirements>;
  gap_limits?: Maybe<GapLimits>;
  id?: Maybe<Scalars['ID']>;
  loan_limits?: Maybe<LoanLimits>;
  other?: Maybe<Other>;
  payment_limits?: Maybe<PaymentLimits>;
  updated_at?: Maybe<Scalars['DateTime']>;
  vehicle_use_requirements?: Maybe<VehicleUseRequirements>;
  vsc_limits?: Maybe<VscLimits>;
};

export type Lending_Tree_Decision_Response = {
  __typename?: 'lending_tree_decision_response';
  offers?: Maybe<Array<Maybe<Lending_Tree_Offer>>>;
  partnerDecision?: Maybe<Scalars['String']>;
};

export type Lending_Tree_Decision_Response_Input = {
  offers?: InputMaybe<Array<InputMaybe<Lending_Tree_Offer_Input>>>;
  partnerDecision?: InputMaybe<Scalars['String']>;
};

export type Lending_Tree_Offer = {
  __typename?: 'lending_tree_offer';
  amount?: Maybe<Scalars['Float']>;
  apr?: Maybe<Scalars['Float']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  offerUrl?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['Int']>;
};

export type Lending_Tree_Offer_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  apr?: InputMaybe<Scalars['Float']>;
  monthlyPayment?: InputMaybe<Scalars['Float']>;
  offerUrl?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
};

export enum MaritalStatusEnum {
  Married = 'married',
  NotMarried = 'not_married',
  Separated = 'separated',
  Widowed = 'widowed'
}

export type MarketPrequalification = {
  __typename?: 'marketPrequalification';
  creditScoreTier: Scalars['String'];
  prequalId: Scalars['ID'];
};

export type MediaListData = {
  __typename?: 'mediaListData';
  contentType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MediaListDataInput = {
  contentType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MediaListInputObj = {
  data?: InputMaybe<Array<InputMaybe<MediaListDataInput>>>;
};

export type MediaListObj = {
  __typename?: 'mediaListObj';
  data?: Maybe<Array<Maybe<MediaListData>>>;
};

export type MediaUploadUrl = {
  __typename?: 'mediaUploadUrl';
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'message';
  body?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateCreatedTz?: Maybe<Scalars['String']>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  /** Why the text failed or went undelivered, in plain words; null without an error code. */
  errorReason?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  fromCustomer?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  mediaListObj?: Maybe<MediaListObj>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  senderName?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  /** Twilio's status for the text, e.g. delivered. */
  status?: Maybe<Scalars['String']>;
};

export type MessageDetail = {
  __typename?: 'messageDetail';
  dealIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  dealStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  shortNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MessagesDbPaginated = {
  __typename?: 'messagesDbPaginated';
  hasMoreMessages: Scalars['Boolean'];
  messages: Array<Maybe<Message>>;
};

export type MessagesWithErrors = {
  __typename?: 'messagesWithErrors';
  hasErrors?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Array<Maybe<Message>>>;
};

export type MetricsPages = {
  __typename?: 'metricsPages';
  created_at?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  iframe_url?: Maybe<Scalars['String']>;
  link_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission_name?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MmrResult = {
  __typename?: 'mmrResult';
  average?: Maybe<Scalars['Int']>;
};

export type NewEstimateCustomerInput = {
  address?: InputMaybe<AddressInput>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  dashboard_visited?: InputMaybe<Scalars['Boolean']>;
  dl_expiration_date?: InputMaybe<Scalars['DateTime']>;
  dl_number?: InputMaybe<Scalars['String']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['Date']>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employment?: InputMaybe<EmploymentInput>;
  first_name?: InputMaybe<Scalars['String']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: InputMaybe<Scalars['Boolean']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: InputMaybe<Scalars['Boolean']>;
  home_phone_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: InputMaybe<Scalars['String']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  phone_number?: InputMaybe<Scalars['String']>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: InputMaybe<Scalars['DateTime']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: InputMaybe<Scalars['DateTime']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: InputMaybe<Scalars['ID']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: InputMaybe<Scalars['DateTime']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type NewEstimateFileInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type NewEstimateFinancialInfoInput = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: InputMaybe<Scalars['String']>;
  bank_fees?: InputMaybe<Scalars['Float']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']>;
  base_tax_amount?: InputMaybe<Scalars['Float']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']>;
  closer_commission?: InputMaybe<Scalars['Float']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  doc_fee?: InputMaybe<Scalars['Float']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']>;
  first_payment_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  money_down?: InputMaybe<Scalars['Float']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']>;
  new_registration_fee?: InputMaybe<Scalars['Float']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['Float']>;
  quick_notes?: InputMaybe<Scalars['String']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']>;
  setter_commission?: InputMaybe<Scalars['Float']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['Int']>;
  title_fee?: InputMaybe<Scalars['Float']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']>;
};

export type NewEstimateUpsertInput = {
  called_by_financial_specialist?: InputMaybe<Scalars['DateTime']>;
  car?: InputMaybe<CarInput>;
  closer_id?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  creation_date_tz?: InputMaybe<Scalars['String']>;
  creation_date_utc?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<NewEstimateCustomerInput>;
  financial_info?: InputMaybe<NewEstimateFinancialInfoInput>;
  id?: InputMaybe<Scalars['Int']>;
  needs_electronic_signature_verification?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  referral_source?: InputMaybe<ReferralSourceInput>;
  request_boot?: InputMaybe<Scalars['Boolean']>;
  second_turn_financial_specialist_id?: InputMaybe<Scalars['String']>;
  selected_dealer_id?: InputMaybe<Scalars['Int']>;
  setter_id?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DealType>;
};

export type Note = {
  __typename?: 'note';
  author?: Maybe<User>;
  author_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  creation_date_tz?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  /** Classification for the note event type. Expected values: manual, system, text_outgoing, text_incoming, call_outgoing, call_incoming. */
  note_type?: Maybe<Scalars['String']>;
  notification_id?: Maybe<Scalars['ID']>;
  phone_number?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
  recordingid?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type NoteInput = {
  author_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  creation_date_tz?: InputMaybe<Scalars['String']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Classification for the note event type. Expected values: manual, system, text_outgoing, text_incoming, call_outgoing, call_incoming. */
  note_type?: InputMaybe<Scalars['String']>;
  notification_id?: InputMaybe<Scalars['ID']>;
  phone_number?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  recordingid?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type Notification = {
  __typename?: 'notification';
  call_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id?: Maybe<Scalars['ID']>;
  deal?: Maybe<Deal>;
  deal_contact_id?: Maybe<Scalars['ID']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  /** Deprecated. Human-readable notification text shown in UI; not guaranteed to equal NotificationType enum keys. Alerts will replace this field. */
  message?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  original_lessee_id?: Maybe<Scalars['ID']>;
  text_message?: Maybe<TextMessage>;
  text_message_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<NotificationUser>>>;
};

export type NotificationInput = {
  call_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  deal?: InputMaybe<DealInput>;
  deal_contact_id?: InputMaybe<Scalars['ID']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Deprecated. Human-readable notification text shown in UI; not guaranteed to equal NotificationType enum keys. Alerts will replace this field. */
  message?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  original_lessee_id?: InputMaybe<Scalars['ID']>;
  text_message?: InputMaybe<TextMessageInput>;
  text_message_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<Array<InputMaybe<NotificationUserInput>>>;
};

export type OnMissedSipCall = {
  __typename?: 'onMissedSipCall';
  callInfo?: Maybe<Call>;
  calledUserId?: Maybe<Scalars['String']>;
};

export type OnSipRegistrationFailure = {
  __typename?: 'onSipRegistrationFailure';
  callerNumber?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type OnWaitingQueue = {
  __typename?: 'onWaitingQueue';
  data?: Maybe<Array<Maybe<WaitingCall>>>;
  hunt_group_slug?: Maybe<Scalars['String']>;
};

export type OperatingHoursTimeSlots = {
  __typename?: 'operatingHoursTimeSlots';
  isOpen?: Maybe<Scalars['Boolean']>;
  utcTimeSlots?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export type OptEvent = {
  __typename?: 'optEvent';
  action?: Maybe<OptEventTypeEnum>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  ip?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  opt_in_at?: Maybe<Scalars['DateTime']>;
  phone_number?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  source?: Maybe<OptEventSourceEnum>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['String']>;
};

export type OptEventInput = {
  action?: InputMaybe<OptEventTypeEnum>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  ip?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  opt_in_at?: InputMaybe<Scalars['DateTime']>;
  phone_number?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OptEventSourceEnum>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum OptEventSourceEnum {
  Com = 'com',
  HubspotMigration = 'hubspot_migration',
  LendingTree = 'lending_tree',
  PreFlowPaymentCalculator = 'pre_flow_payment_calculator',
  ReOptDateSelected = 're_opt_date_selected',
  SmsOptIn = 'sms_opt_in',
  Verse = 'verse'
}

export enum OptEventTypeEnum {
  OptIn = 'opt_in',
  OptOut = 'opt_out'
}

export enum OverallConditionEnumType {
  LikeNew = 'like_new',
  NeedsWork = 'needs_work',
  SlightlyUsed = 'slightly_used'
}

export type Payment = {
  __typename?: 'payment';
  amount?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<PaymentState>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type PaymentEstimate = {
  __typename?: 'paymentEstimate';
  estimatedAnnualPercentageRate: Scalars['Float'];
  estimatedTaxesAndFees: Scalars['Float'];
  feeDetails: PaymentEstimateFeeDetails;
  paymentEstimateHigh: Scalars['Float'];
  paymentEstimateLow: Scalars['Float'];
  totalEstimatedLoan: Scalars['Float'];
};

export type PaymentEstimateFeeDetails = {
  __typename?: 'paymentEstimateFeeDetails';
  baseTaxAmount: Scalars['Float'];
  docFee: Scalars['Float'];
  docFeeTaxAmount: Scalars['Float'];
  registrationFee: Scalars['Float'];
  titleFee: Scalars['Float'];
  warrantyTaxAmount: Scalars['Float'];
};

export type PaymentEstimateInput = {
  creditScore: CreditScore;
  feesInputFromDD?: InputMaybe<TtFeesInput>;
  financialInfoId?: InputMaybe<Scalars['ID']>;
  fuelType?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  moneyDown: Scalars['Float'];
  payoff: Scalars['Float'];
  term: Scalars['Int'];
  ttGetFeesSource?: InputMaybe<TtGetFeesSourceType>;
  vehicleType?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export enum PaymentInstrumentType {
  All = 'ALL',
  BankAccount = 'BANK_ACCOUNT',
  PaymentCard = 'PAYMENT_CARD'
}

export enum PaymentMethod {
  BankAccount = 'BANK_ACCOUNT',
  Credit = 'CREDIT',
  CreditDebit = 'CREDIT_DEBIT',
  Debit = 'DEBIT'
}

export type PaymentOptions = {
  __typename?: 'paymentOptions';
  gap?: Maybe<PaymentOptionsGqlTypes>;
  noProducts?: Maybe<PaymentOptionsGqlTypes>;
  vsc?: Maybe<PaymentOptionsGqlTypes>;
  vscPlusGap?: Maybe<PaymentOptionsGqlTypes>;
};

export type PaymentOptionsGqlTypes = {
  __typename?: 'paymentOptionsGQLTypes';
  amountFinanced?: Maybe<Scalars['Float']>;
  buyPayment?: Maybe<Scalars['Float']>;
  closerCommission?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  profit?: Maybe<Scalars['Float']>;
  reserve?: Maybe<Scalars['Float']>;
  sellPayment?: Maybe<Scalars['Float']>;
  setterCommission?: Maybe<Scalars['Float']>;
};

export type PaymentOptionsV2 = {
  __typename?: 'paymentOptionsV2';
  creditDecisions?: Maybe<Array<Maybe<CreditDecision>>>;
  dealId: Scalars['Int'];
  gap: PaymentOptionsGqlTypes;
  noProducts: PaymentOptionsGqlTypes;
  packages: Array<PaymentOptionsPackageV2>;
  retailBookValue?: Maybe<Scalars['Float']>;
  selectedPackageSlotIndex?: Maybe<Scalars['Int']>;
  vsc: PaymentOptionsGqlTypes;
  vscPlusGap: PaymentOptionsGqlTypes;
};

export enum PaymentState {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Returned = 'RETURNED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type Payoff = {
  __typename?: 'payoff';
  account_number?: Maybe<Scalars['String']>;
  cap_cost?: Maybe<Scalars['Float']>;
  cap_reduction?: Maybe<Scalars['Float']>;
  car_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  /** Deprecated. Legacy estimated payoff field retained for backward compatibility. */
  estimated_payoff?: Maybe<Scalars['Float']>;
  /** Date through which the payoff quote is valid. */
  good_through_date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  /** Original lease term length in months. */
  lease_term?: Maybe<Scalars['Float']>;
  lender_name?: Maybe<Scalars['String']>;
  /** Canonical lienholder display name. Expected values: Acura Financial Services, Ally Financial, Audi Financial Services, Bentley Financial Services, Bethpage Federal Credit Union, BMW Financial Services, Cal Automotive, Centennial Lending, Chase Auto Finance, Chrysler Capital (CCAP), D&M Auto Leasing, Fifth Third Bank, Ford Motor Credit, Fusion Auto Finance, Genesis Finance, GM Financial, Honda Financial Services, Hudson Valley Credit Union, Huntington National Bank, Hyundai Motor Finance, Kia Finance, Land Rover Financial Group, Lexus Financial Services, Mazda Financial Services, Mercedes-Benz Financial Services, McLaren Financial Services, Metro Credit Union, Michigan State University Federal Credit Union, Mini Financial Services, NBT Bank, Nissan Finance, Porsche Payment Center, Rockland Federal Credit Union, Santander Consumer USA, Southeast Toyota Financial, Stellantis Financial Services Inc, Subaru Motor Finance, Teachers Federal Credit Union, Tesla Finance, Toyota Financial, U.S. Bank, Visions Federal Credit Union, Volvo Car Financial Services, Volkswagen Credit, Westlake Financial, Other. */
  lienholder_name?: Maybe<Scalars['String']>;
  /** Canonical lienholder slug. Expected values: acura_financial_services, ally, audi_financial_services, bentley_financial_services, bethpage_fcu, bmw_fs, cal_automotive, centennial_lending, chase_auto_finance, chrystler_capital_ccap, dm_auto_leasing, fifth_third_bank, ford_motor_credit, fusion_auto_finance, genesis_finance, gm_financial, honda_financial_services, hudson_valley_cu, huntington_national_bank, hyundai_motor_finance, kia_finance, land_rover_fg, lexus_financial_services, mazda_financial_services, mclaren_financial_services, mercedes_benz_fs, metro_cu, michigan_state_university_fcu, mini_fs, nbt, nissan_finance, other, porche_payment_center, rockland_fcu, santander_consumer_usa, se_toyota, stellantis_financial_services_inc, subaru_motor_finance, teachers_fcu, tesla_finance, toyota, us_bank, visions_fcu, volkswagen_credit, volvo_car_fs, westlake. */
  lienholder_slug?: Maybe<Scalars['String']>;
  /** Lease maturity or contract end date. */
  maturity_date?: Maybe<Scalars['Date']>;
  money_down?: Maybe<Scalars['Float']>;
  money_factor?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
  /** Next scheduled payment due date from lender payoff data. */
  next_payment_date?: Maybe<Scalars['Date']>;
  old_lease_payment?: Maybe<Scalars['Float']>;
  payoff_changes?: Maybe<Array<Maybe<PayoffChange>>>;
  /** True when the stored payoff total is believed to already include sales tax. Payoff Intelligence can set false positives, so this flag may still require review. */
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']>;
  /** Number of payments remaining at time of quote. */
  remaining_payments?: Maybe<Scalars['Float']>;
  residual_amount?: Maybe<Scalars['Float']>;
  residual_percentage?: Maybe<Scalars['Float']>;
  sales_price?: Maybe<Scalars['Float']>;
  /** Sales-tax component extracted from payoff amount in USD. */
  sales_tax_from_payoff?: Maybe<Scalars['Float']>;
  /** True when sales_tax_from_payoff was manually entered instead of auto-derived. */
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']>;
  set_by_label?: Maybe<Scalars['String']>;
  set_by_source?: Maybe<PayoffSetBySource>;
  set_by_user_id?: Maybe<Scalars['String']>;
  termination_fees?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  /** All-in total payoff amount in USD. Despite the column name, this may be populated by automated sources and is not limited to manual user entry. */
  user_entered_total_payoff?: Maybe<Scalars['Float']>;
  /** Current payoff amount in USD from lender quote or user entry. */
  vehicle_payoff?: Maybe<Scalars['Float']>;
  /** Payoff verification lifecycle status. Expected values: customer_provided, edited, sales_tax_review_needed, verified, verified_by_sales_rep. */
  verification_status?: Maybe<PayoffVerificationStatus>;
};

export type PayoffCountMake = {
  __typename?: 'payoffCountMake';
  total?: Maybe<Scalars['Float']>;
};

export type PayoffCountModel = {
  __typename?: 'payoffCountModel';
  total?: Maybe<Scalars['Float']>;
};

export type PayoffDashboard = {
  __typename?: 'payoffDashboard';
  payoffRequests?: Maybe<Array<Maybe<PayoffRequestPopulated>>>;
};

export type PayoffInput = {
  account_number?: InputMaybe<Scalars['String']>;
  cap_cost?: InputMaybe<Scalars['Float']>;
  cap_reduction?: InputMaybe<Scalars['Float']>;
  car_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated. Legacy estimated payoff field retained for backward compatibility. */
  estimated_payoff?: InputMaybe<Scalars['Float']>;
  /** Date through which the payoff quote is valid. */
  good_through_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Original lease term length in months. */
  lease_term?: InputMaybe<Scalars['Float']>;
  lender_name?: InputMaybe<Scalars['String']>;
  /** Canonical lienholder display name. Expected values: Acura Financial Services, Ally Financial, Audi Financial Services, Bentley Financial Services, Bethpage Federal Credit Union, BMW Financial Services, Cal Automotive, Centennial Lending, Chase Auto Finance, Chrysler Capital (CCAP), D&M Auto Leasing, Fifth Third Bank, Ford Motor Credit, Fusion Auto Finance, Genesis Finance, GM Financial, Honda Financial Services, Hudson Valley Credit Union, Huntington National Bank, Hyundai Motor Finance, Kia Finance, Land Rover Financial Group, Lexus Financial Services, Mazda Financial Services, Mercedes-Benz Financial Services, McLaren Financial Services, Metro Credit Union, Michigan State University Federal Credit Union, Mini Financial Services, NBT Bank, Nissan Finance, Porsche Payment Center, Rockland Federal Credit Union, Santander Consumer USA, Southeast Toyota Financial, Stellantis Financial Services Inc, Subaru Motor Finance, Teachers Federal Credit Union, Tesla Finance, Toyota Financial, U.S. Bank, Visions Federal Credit Union, Volvo Car Financial Services, Volkswagen Credit, Westlake Financial, Other. */
  lienholder_name?: InputMaybe<Scalars['String']>;
  /** Canonical lienholder slug. Expected values: acura_financial_services, ally, audi_financial_services, bentley_financial_services, bethpage_fcu, bmw_fs, cal_automotive, centennial_lending, chase_auto_finance, chrystler_capital_ccap, dm_auto_leasing, fifth_third_bank, ford_motor_credit, fusion_auto_finance, genesis_finance, gm_financial, honda_financial_services, hudson_valley_cu, huntington_national_bank, hyundai_motor_finance, kia_finance, land_rover_fg, lexus_financial_services, mazda_financial_services, mclaren_financial_services, mercedes_benz_fs, metro_cu, michigan_state_university_fcu, mini_fs, nbt, nissan_finance, other, porche_payment_center, rockland_fcu, santander_consumer_usa, se_toyota, stellantis_financial_services_inc, subaru_motor_finance, teachers_fcu, tesla_finance, toyota, us_bank, visions_fcu, volkswagen_credit, volvo_car_fs, westlake. */
  lienholder_slug?: InputMaybe<Scalars['String']>;
  /** Lease maturity or contract end date. */
  maturity_date?: InputMaybe<Scalars['Date']>;
  money_down?: InputMaybe<Scalars['Float']>;
  money_factor?: InputMaybe<Scalars['Float']>;
  msrp?: InputMaybe<Scalars['Float']>;
  /** Next scheduled payment due date from lender payoff data. */
  next_payment_date?: InputMaybe<Scalars['Date']>;
  old_lease_payment?: InputMaybe<Scalars['Float']>;
  payoff_changes?: InputMaybe<Array<InputMaybe<PayoffChangeInput>>>;
  /** True when the stored payoff total is believed to already include sales tax. Payoff Intelligence can set false positives, so this flag may still require review. */
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']>;
  /** Number of payments remaining at time of quote. */
  remaining_payments?: InputMaybe<Scalars['Float']>;
  residual_amount?: InputMaybe<Scalars['Float']>;
  residual_percentage?: InputMaybe<Scalars['Float']>;
  sales_price?: InputMaybe<Scalars['Float']>;
  /** Sales-tax component extracted from payoff amount in USD. */
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']>;
  /** True when sales_tax_from_payoff was manually entered instead of auto-derived. */
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']>;
  termination_fees?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  /** All-in total payoff amount in USD. Despite the column name, this may be populated by automated sources and is not limited to manual user entry. */
  user_entered_total_payoff?: InputMaybe<Scalars['Float']>;
  /** Current payoff amount in USD from lender quote or user entry. */
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
  /** Payoff verification lifecycle status. Expected values: customer_provided, edited, sales_tax_review_needed, verified, verified_by_sales_rep. */
  verification_status?: InputMaybe<PayoffVerificationStatus>;
};

export type PayoffRequest = {
  __typename?: 'payoffRequest';
  completed_date?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  fail_reason?: Maybe<Scalars['JSONObject']>;
  good_through_date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']>;
  payoff_clerk_id?: Maybe<Scalars['String']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']>;
  requestor_id?: Maybe<Scalars['String']>;
  sales_tax?: Maybe<Scalars['Float']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
};

export type PayoffRequestConfirmInput = {
  completed_date?: InputMaybe<Scalars['DateTime']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  double_tax_applied?: InputMaybe<Scalars['Boolean']>;
  fail_reason?: InputMaybe<Scalars['JSONObject']>;
  good_through_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  is_payoff_intelligence?: InputMaybe<Scalars['Boolean']>;
  needs_payoff_documents?: InputMaybe<Scalars['Boolean']>;
  payoff_clerk_id?: InputMaybe<Scalars['String']>;
  payoff_documents_uploaded?: InputMaybe<Scalars['Boolean']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']>;
  requestor_id?: InputMaybe<Scalars['String']>;
  sales_tax?: InputMaybe<Scalars['Float']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']>;
  self_serve_submitted_at?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<PayoffRequestStatus>;
  temporary_info_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  user_entered_total_payoff?: InputMaybe<Scalars['Float']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
};

export type PayoffRequestInput = {
  completed_date?: InputMaybe<Scalars['DateTime']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  fail_reason?: InputMaybe<Scalars['JSONObject']>;
  good_through_date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  is_payoff_intelligence?: InputMaybe<Scalars['Boolean']>;
  needs_payoff_documents?: InputMaybe<Scalars['Boolean']>;
  payoff_clerk_id?: InputMaybe<Scalars['String']>;
  payoff_documents_uploaded?: InputMaybe<Scalars['Boolean']>;
  requestor_id?: InputMaybe<Scalars['String']>;
  sales_tax?: InputMaybe<Scalars['Float']>;
  self_serve_submitted_at?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<PayoffRequestStatus>;
  temporary_info_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
};

export type PayoffRequestPopulated = {
  __typename?: 'payoffRequestPopulated';
  completed_date?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']>;
  fail_reason?: Maybe<Scalars['JSONObject']>;
  good_through_date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']>;
  payoff_clerk?: Maybe<User>;
  payoff_clerk_id?: Maybe<Scalars['String']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']>;
  requestor?: Maybe<User>;
  requestor_id?: Maybe<Scalars['String']>;
  sales_tax?: Maybe<Scalars['Float']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info?: Maybe<TemporaryInfo>;
  temporary_info_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
};

export enum PayoffRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailureRequested = 'FAILURE_REQUESTED',
  Fetching = 'FETCHING',
  Pending = 'PENDING'
}

export type PayoffRequestStatusUpdate = {
  __typename?: 'payoffRequestStatusUpdate';
  completed_date?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']>;
  fail_reason?: Maybe<Scalars['JSONObject']>;
  good_through_date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']>;
  payoff_clerk_id?: Maybe<Scalars['String']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']>;
  requestor_id?: Maybe<Scalars['String']>;
  sales_tax?: Maybe<Scalars['Float']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
};

export type PayoffRequestStatusUpdateWithMessage = {
  __typename?: 'payoffRequestStatusUpdateWithMessage';
  message?: Maybe<Scalars['String']>;
  payoffRequest: PayoffRequestStatusUpdate;
};

export enum PayoffSetBySource {
  Manual = 'manual',
  PayoffIntelligence = 'payoff_intelligence',
  PayoffRequest = 'payoff_request'
}

export type PayoffStatsMakeModel = {
  __typename?: 'payoffStatsMakeModel';
  avg_payoff?: Maybe<Scalars['Float']>;
  max_payoff?: Maybe<Scalars['Float']>;
  min_payoff?: Maybe<Scalars['Float']>;
};

export enum PayoffVerificationStatus {
  CustomerProvided = 'customer_provided',
  Edited = 'edited',
  SalesTaxReviewNeeded = 'sales_tax_review_needed',
  Verified = 'verified',
  VerifiedBySalesRep = 'verified_by_sales_rep'
}

export type Pod = {
  __typename?: 'pod';
  active_reps_override?: Maybe<Scalars['Int']>;
  active_reps_override_set_at?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
  assign_overnight_deals?: Maybe<Scalars['Boolean']>;
  auto_assign_deals?: Maybe<Scalars['Boolean']>;
  child_pods?: Maybe<Array<Maybe<BasePod>>>;
  closer_commission_rate?: Maybe<Scalars['Float']>;
  closer_commission_type?: Maybe<CommissionType>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  fundingClerks?: Maybe<Array<Maybe<BaseUser>>>;
  hours?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  leads?: Maybe<Array<Maybe<BaseUser>>>;
  manager_commission_rate?: Maybe<Scalars['Float']>;
  manager_commission_type?: Maybe<CommissionType>;
  managers?: Maybe<Array<Maybe<BaseUser>>>;
  name?: Maybe<Scalars['String']>;
  parent_pod?: Maybe<BasePod>;
  parent_pod_id?: Maybe<Scalars['ID']>;
  pause_auto_assign?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  pod_users?: Maybe<Array<Maybe<PodUser>>>;
  problem_solver?: Maybe<Scalars['Boolean']>;
  setter_commission_rate?: Maybe<Scalars['Float']>;
  setter_commission_type?: Maybe<CommissionType>;
  special_commission_rate?: Maybe<Scalars['Float']>;
  special_commission_type?: Maybe<CommissionType>;
  team_type?: Maybe<TeamType>;
  updated_at?: Maybe<Scalars['DateTime']>;
  us_states_object?: Maybe<UsStatesObject>;
  usersWithoutTeamRole?: Maybe<Array<Maybe<BaseUser>>>;
};

export type PodHours = {
  __typename?: 'podHours';
  beginTime?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

export type PodInput = {
  active_reps_override?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assign_overnight_deals?: InputMaybe<Scalars['Boolean']>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']>;
  child_pods?: InputMaybe<Array<InputMaybe<BasePodInput>>>;
  closer_commission_rate?: InputMaybe<Scalars['Float']>;
  closer_commission_type?: InputMaybe<CommissionType>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  fundingClerks?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  hours?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  manager_commission_rate?: InputMaybe<Scalars['Float']>;
  manager_commission_type?: InputMaybe<CommissionType>;
  managers?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  name?: InputMaybe<Scalars['String']>;
  parent_pod?: InputMaybe<BasePodInput>;
  parent_pod_id?: InputMaybe<Scalars['ID']>;
  pause_auto_assign?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  pod_users?: InputMaybe<Array<InputMaybe<PodUserInput>>>;
  problem_solver?: InputMaybe<Scalars['Boolean']>;
  setter_commission_rate?: InputMaybe<Scalars['Float']>;
  setter_commission_type?: InputMaybe<CommissionType>;
  special_commission_rate?: InputMaybe<Scalars['Float']>;
  special_commission_type?: InputMaybe<CommissionType>;
  team_type?: InputMaybe<TeamType>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  us_states_object?: InputMaybe<UsStatesInputObject>;
  users?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  usersWithoutTeamRole?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
};

export type PodUser = {
  __typename?: 'podUser';
  id?: Maybe<Scalars['ID']>;
  pod_id?: Maybe<Scalars['Int']>;
  team_role?: Maybe<TeamRole>;
  user?: Maybe<BaseUser>;
  user_id?: Maybe<Scalars['String']>;
};

export type PodUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  pod_id?: InputMaybe<Scalars['Int']>;
  team_role?: InputMaybe<TeamRole>;
  user?: InputMaybe<BaseUserInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export enum PotentialRoleEnumType {
  Closer = 'closer',
  NotAssigned = 'not_assigned',
  Setter = 'setter',
  SetterLead = 'setter_lead'
}

export type PotentialUser = {
  __typename?: 'potentialUser';
  added_to_testflight: Scalars['Boolean'];
  created_at?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  email_created: Scalars['Boolean'];
  employment_status: EmploymentEnumType;
  hired: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  interview_scheduled: Scalars['Boolean'];
  login_created: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  potential_role: PotentialRoleEnumType;
  reached_out: Scalars['Boolean'];
  referral_code?: Maybe<Scalars['String']>;
  signup_date: Scalars['DateTime'];
  slack_created: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['DateTime']>;
  zip: Scalars['Int'];
};

export type PotentialUserInput = {
  email: Scalars['String'];
  employment_status: EmploymentEnumType;
  name: Scalars['String'];
  phone: Scalars['String'];
  referral_code?: InputMaybe<Scalars['String']>;
  zip: Scalars['Int'];
};

export type Prequalification = {
  __typename?: 'prequalification';
  created_at?: Maybe<Scalars['DateTime']>;
  credit_score?: Maybe<Scalars['Int']>;
  credit_score_tier?: Maybe<CreditScoreTierEnumType>;
  customer_id?: Maybe<Scalars['ID']>;
  dti?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  input?: Maybe<PrequalificationRequest>;
  lease_monthly_payment?: Maybe<Scalars['Float']>;
  ltv?: Maybe<Scalars['Float']>;
  output?: Maybe<ExperianOutput>;
  payment_to_income?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Product = {
  __typename?: 'product';
  gap_selected?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  provider_dealer_code_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  selected_package?: Maybe<Scalars['String']>;
};

export type ProofOfInsurance = {
  __typename?: 'proofOfInsurance';
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  expires?: Maybe<Scalars['DateTime']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  policy_number?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ProofOfInsuranceInput = {
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  expires?: InputMaybe<Scalars['DateTime']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  policy_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type Provider = {
  __typename?: 'provider';
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

export type PurchaseOrder = {
  __typename?: 'purchaseOrder';
  files?: Maybe<Array<Maybe<File>>>;
};

export type R1CreditDecisionData = {
  __typename?: 'r1CreditDecisionData';
  applicationNumber?: Maybe<Scalars['String']>;
  applicationStatus?: Maybe<CreditDecisionStatusEnum>;
  applicationStatusDetail?: Maybe<Scalars['String']>;
  contractTerm?: Maybe<ContractTerm>;
  decision?: Maybe<Decision>;
};

export type Rate = {
  __typename?: 'rate';
  coverage_name?: Maybe<Scalars['String']>;
  deductible?: Maybe<Deductible>;
  form_id?: Maybe<Scalars['Int']>;
  form_name?: Maybe<Scalars['String']>;
  form_number?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  term_miles?: Maybe<Scalars['String']>;
  term_months?: Maybe<Scalars['String']>;
};

export type RateInput = {
  apr?: InputMaybe<Scalars['Float']>;
  financeTerms?: InputMaybe<Scalars['Int']>;
  financeTermsMileage?: InputMaybe<Scalars['Int']>;
  financedAmount?: InputMaybe<Scalars['Float']>;
  mileage?: InputMaybe<Scalars['Int']>;
  msrp?: InputMaybe<Scalars['Float']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ReferralSource = {
  __typename?: 'referralSource';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  other_source_description?: Maybe<Scalars['String']>;
  source_name?: Maybe<ReferralSourceEnum>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ReferralSourceInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  other_source_description?: InputMaybe<Scalars['String']>;
  source_name?: InputMaybe<ReferralSourceEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export enum RelationToBuyerEnum {
  Child = 'child',
  Other = 'other',
  Parent = 'parent',
  ResidesWith = 'resides_with',
  Spouse = 'spouse'
}

export type ResultAddParticipant = {
  __typename?: 'resultAddParticipant';
  call_already_answered?: Maybe<Scalars['Boolean']>;
  call_already_ended?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type ResultHandleThunderOutboundCall = {
  __typename?: 'resultHandleThunderOutboundCall';
  call_already_answered?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type Review = {
  __typename?: 'review';
  com_visible?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  location?: Maybe<Scalars['String']>;
  review?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ReviewInput = {
  com_visible?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  customer_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type SecureLink = {
  __typename?: 'secureLink';
  created_at?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Customer>;
  customer_id: Scalars['ID'];
  expiration_date: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  link: Scalars['String'];
  notified: Scalars['Boolean'];
  sender?: Maybe<User>;
  sender_id?: Maybe<Scalars['ID']>;
  status: SecureLinkStatus;
  token: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SigningAuditDocumentViewedEvent = {
  deal_id?: InputMaybe<Scalars['ID']>;
  document_id?: InputMaybe<Scalars['String']>;
  document_name?: InputMaybe<Scalars['String']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']>;
};

export type SigningError = {
  __typename?: 'signingError';
  created_at?: Maybe<Scalars['DateTime']>;
  deal_id?: Maybe<Scalars['ID']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<SigningErrorEnum>;
  id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SigningErrorDetail = {
  documentId?: InputMaybe<Scalars['String']>;
  documentName?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  signatureFieldName?: InputMaybe<Scalars['String']>;
};

export type SigningErrorInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deal_id?: InputMaybe<Scalars['ID']>;
  error_details?: InputMaybe<SigningErrorDetail>;
  error_message?: InputMaybe<Scalars['String']>;
  error_type?: InputMaybe<SigningErrorEnum>;
  id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type SmartPayoff = {
  __typename?: 'smartPayoff';
  message?: Maybe<Scalars['String']>;
  payoff?: Maybe<Scalars['Float']>;
  retail_value?: Maybe<Scalars['Float']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SmartPayoffAffiliate = {
  __typename?: 'smartPayoffAffiliate';
  message?: Maybe<Scalars['String']>;
  payoff?: Maybe<Scalars['Float']>;
  retail_value?: Maybe<Scalars['Float']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Surcharge = {
  __typename?: 'surcharge';
  car_status?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export enum TeamRole {
  FundingClerk = 'funding_clerk',
  Lead = 'lead',
  Manager = 'manager'
}

export enum TeamType {
  D2d = 'd2d',
  FinancialSpecialist = 'financial_specialist',
  Inbound = 'inbound',
  Outbound = 'outbound',
  Region = 'region',
  Titling = 'titling'
}

export type TemporaryData = {
  __typename?: 'temporaryData';
  address_line?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  affiliate_external_id?: Maybe<Scalars['String']>;
  affiliate_note?: Maybe<Scalars['String']>;
  affiliate_provider_name?: Maybe<Scalars['String']>;
  assistant_note?: Maybe<Scalars['String']>;
  automatic_equity_note?: Maybe<Scalars['String']>;
  automatically_fetched_payoff?: Maybe<Scalars['Boolean']>;
  book_value?: Maybe<Scalars['Float']>;
  cash_to_customer?: Maybe<Scalars['Float']>;
  cbb_valuation?: Maybe<CbbValuation>;
  city?: Maybe<Scalars['String']>;
  cobuyer_address_line?: Maybe<Scalars['String']>;
  cobuyer_address_line_2?: Maybe<Scalars['String']>;
  cobuyer_city?: Maybe<Scalars['String']>;
  cobuyer_county?: Maybe<Scalars['String']>;
  cobuyer_dob?: Maybe<Scalars['DateTime']>;
  cobuyer_email?: Maybe<Scalars['String']>;
  cobuyer_employer_name?: Maybe<Scalars['String']>;
  cobuyer_employer_phone_number?: Maybe<Scalars['String']>;
  cobuyer_employment_status?: Maybe<Scalars['String']>;
  cobuyer_first_name?: Maybe<Scalars['String']>;
  cobuyer_job_title?: Maybe<Scalars['String']>;
  cobuyer_last_name?: Maybe<Scalars['String']>;
  cobuyer_marital_status?: Maybe<MaritalStatusEnum>;
  cobuyer_months_at_job?: Maybe<Scalars['Int']>;
  cobuyer_pay_frequency?: Maybe<Scalars['String']>;
  cobuyer_phone_number?: Maybe<Scalars['String']>;
  cobuyer_prequalification_errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  cobuyer_previous_address_line?: Maybe<Scalars['String']>;
  cobuyer_previous_address_line_2?: Maybe<Scalars['String']>;
  cobuyer_previous_city?: Maybe<Scalars['String']>;
  cobuyer_previous_county?: Maybe<Scalars['String']>;
  cobuyer_previous_employer_name?: Maybe<Scalars['String']>;
  cobuyer_previous_employer_phone_number?: Maybe<Scalars['String']>;
  cobuyer_previous_job_title?: Maybe<Scalars['String']>;
  cobuyer_previous_months_at_job?: Maybe<Scalars['Int']>;
  cobuyer_previous_state?: Maybe<Scalars['String']>;
  cobuyer_previous_years_at_job?: Maybe<Scalars['Int']>;
  cobuyer_previous_zip?: Maybe<Scalars['String']>;
  cobuyer_primary_residence_monthly_payment?: Maybe<Scalars['Float']>;
  cobuyer_primary_residence_months?: Maybe<Scalars['Int']>;
  cobuyer_primary_residence_type?: Maybe<Scalars['String']>;
  cobuyer_primary_residence_years?: Maybe<Scalars['Int']>;
  cobuyer_relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  cobuyer_salary?: Maybe<Scalars['Float']>;
  cobuyer_secondary_residence_months?: Maybe<Scalars['Int']>;
  cobuyer_secondary_residence_years?: Maybe<Scalars['Int']>;
  cobuyer_ssn_id?: Maybe<Scalars['ID']>;
  cobuyer_state?: Maybe<Scalars['String']>;
  cobuyer_years_at_job?: Maybe<Scalars['Int']>;
  cobuyer_zip?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  condition_report?: Maybe<Scalars['JSON']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['Int']>;
  current_accordion_panel?: Maybe<Scalars['String']>;
  dev_prequal_credit_score?: Maybe<Scalars['Int']>;
  dev_prequal_override?: Maybe<Scalars['Boolean']>;
  device_type?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  doc_fee?: Maybe<Scalars['Float']>;
  down_payment?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  employer_name?: Maybe<Scalars['String']>;
  employer_phone_number?: Maybe<Scalars['String']>;
  employment_status?: Maybe<Scalars['String']>;
  estimated_dealer_fees?: Maybe<Scalars['Float']>;
  first_name?: Maybe<Scalars['String']>;
  fuel_type?: Maybe<Scalars['String']>;
  good_through_date?: Maybe<Scalars['DateTime']>;
  has_full_ssn?: Maybe<Scalars['Boolean']>;
  high_ltv_ratio?: Maybe<Scalars['Boolean']>;
  include_cobuyer?: Maybe<Scalars['Boolean']>;
  is_chat?: Maybe<Scalars['Boolean']>;
  is_hard_pull?: Maybe<Scalars['Boolean']>;
  is_methodfi_flow?: Maybe<Scalars['Boolean']>;
  job_title?: Maybe<Scalars['String']>;
  kbb_all_options?: Maybe<Scalars['JSON']>;
  kbb_lending_mileage_adjustment?: Maybe<Scalars['Float']>;
  kbb_lending_option_adjustment?: Maybe<Scalars['Float']>;
  kbb_retail_mileage_adjustment?: Maybe<Scalars['Float']>;
  kbb_retail_option_adjustment?: Maybe<Scalars['Float']>;
  kbb_selected_options?: Maybe<Scalars['JSON']>;
  kbb_trim_name?: Maybe<Scalars['String']>;
  kbb_valuation_date?: Maybe<Scalars['String']>;
  kbb_vehicle_id?: Maybe<Scalars['Int']>;
  kbb_vehicle_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  last_url?: Maybe<Scalars['String']>;
  lh_account_number?: Maybe<Scalars['String']>;
  license_plate_number?: Maybe<Scalars['String']>;
  license_plate_state?: Maybe<Scalars['String']>;
  lienholder?: Maybe<Scalars['String']>;
  lienholderLogo?: Maybe<Scalars['String']>;
  lienholder_slug?: Maybe<Scalars['String']>;
  likely_address_accepted?: Maybe<Scalars['Boolean']>;
  likely_address_address_line?: Maybe<Scalars['String']>;
  likely_address_address_line_2?: Maybe<Scalars['String']>;
  likely_address_city?: Maybe<Scalars['String']>;
  likely_address_county?: Maybe<Scalars['String']>;
  likely_address_query_run?: Maybe<Scalars['Boolean']>;
  likely_address_query_success?: Maybe<Scalars['Boolean']>;
  likely_address_state?: Maybe<Scalars['String']>;
  likely_address_zip?: Maybe<Scalars['String']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']>;
  make?: Maybe<Scalars['String']>;
  manual_entry?: Maybe<Scalars['Boolean']>;
  marital_status?: Maybe<MaritalStatusEnum>;
  methodfi_flow_variation?: Maybe<Scalars['Int']>;
  middle_name?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  mmr_value?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  months_at_job?: Maybe<Scalars['Int']>;
  moved_states?: Maybe<Scalars['Boolean']>;
  odometer_status?: Maybe<OdometerStatus>;
  old_lease_payment?: Maybe<Scalars['Float']>;
  other_lienholder?: Maybe<Scalars['String']>;
  pay_frequency?: Maybe<Scalars['String']>;
  payment_estimate_high?: Maybe<Scalars['Float']>;
  payment_estimate_low?: Maybe<Scalars['Float']>;
  payoff_duration_time_ms?: Maybe<Scalars['Int']>;
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']>;
  payoff_initiated_time?: Maybe<Scalars['DateTime']>;
  phone_number?: Maybe<Scalars['String']>;
  prequal_id?: Maybe<Scalars['ID']>;
  prequalification_errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  prequalification_success?: Maybe<Scalars['Boolean']>;
  previous_address_line?: Maybe<Scalars['String']>;
  previous_address_line_2?: Maybe<Scalars['String']>;
  previous_city?: Maybe<Scalars['String']>;
  previous_county?: Maybe<Scalars['String']>;
  previous_employer_name?: Maybe<Scalars['String']>;
  previous_employer_phone_number?: Maybe<Scalars['String']>;
  previous_job_title?: Maybe<Scalars['String']>;
  previous_months_at_job?: Maybe<Scalars['Int']>;
  previous_state?: Maybe<Scalars['String']>;
  previous_years_at_job?: Maybe<Scalars['Int']>;
  previous_zip?: Maybe<Scalars['String']>;
  primary_residence_monthly_payment?: Maybe<Scalars['Float']>;
  primary_residence_months?: Maybe<Scalars['Int']>;
  primary_residence_type?: Maybe<Scalars['String']>;
  primary_residence_years?: Maybe<Scalars['Int']>;
  query_params?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  retail_book_value?: Maybe<Scalars['Float']>;
  salary?: Maybe<Scalars['Float']>;
  sales_tax_from_payoff?: Maybe<Scalars['Float']>;
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']>;
  scheduled_call_datetime?: Maybe<Scalars['DateTime']>;
  scheduled_call_datetime_tz?: Maybe<Scalars['String']>;
  secondary_residence_months?: Maybe<Scalars['Int']>;
  secondary_residence_years?: Maybe<Scalars['Int']>;
  sell_timeline?: Maybe<Scalars['String']>;
  shopping_cart?: Maybe<TemporaryShoppingCartData>;
  ssn_id?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  stress_test_payoff_requested?: Maybe<Scalars['Boolean']>;
  taxes?: Maybe<Scalars['Decimal']>;
  taxes_fees?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
  title_only?: Maybe<Scalars['Boolean']>;
  trade_in_preference?: Maybe<Scalars['String']>;
  uploaded_files?: Maybe<Scalars['JSON']>;
  user_entered_total_payoff?: Maybe<Scalars['Float']>;
  vehicle_offer?: Maybe<Scalars['Float']>;
  vehicle_payoff?: Maybe<Scalars['Float']>;
  vehicle_registration_fee?: Maybe<Scalars['Float']>;
  vehicle_type?: Maybe<Scalars['String']>;
  verified_phone_number?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  wants_to_sell?: Maybe<Scalars['Boolean']>;
  year?: Maybe<Scalars['String']>;
  years_at_job?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type TemporaryDataInput = {
  address_line?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  affiliate_external_id?: InputMaybe<Scalars['String']>;
  affiliate_note?: InputMaybe<Scalars['String']>;
  affiliate_provider_name?: InputMaybe<Scalars['String']>;
  assistant_note?: InputMaybe<Scalars['String']>;
  automatic_equity_note?: InputMaybe<Scalars['String']>;
  automatically_fetched_payoff?: InputMaybe<Scalars['Boolean']>;
  book_value?: InputMaybe<Scalars['Float']>;
  cash_to_customer?: InputMaybe<Scalars['Float']>;
  cbb_valuation?: InputMaybe<CbbValuationInput>;
  city?: InputMaybe<Scalars['String']>;
  cobuyer_address_line?: InputMaybe<Scalars['String']>;
  cobuyer_address_line_2?: InputMaybe<Scalars['String']>;
  cobuyer_city?: InputMaybe<Scalars['String']>;
  cobuyer_county?: InputMaybe<Scalars['String']>;
  cobuyer_dob?: InputMaybe<Scalars['DateTime']>;
  cobuyer_email?: InputMaybe<Scalars['String']>;
  cobuyer_employer_name?: InputMaybe<Scalars['String']>;
  cobuyer_employer_phone_number?: InputMaybe<Scalars['String']>;
  cobuyer_employment_status?: InputMaybe<Scalars['String']>;
  cobuyer_first_name?: InputMaybe<Scalars['String']>;
  cobuyer_job_title?: InputMaybe<Scalars['String']>;
  cobuyer_last_name?: InputMaybe<Scalars['String']>;
  cobuyer_marital_status?: InputMaybe<MaritalStatusEnum>;
  cobuyer_months_at_job?: InputMaybe<Scalars['Int']>;
  cobuyer_pay_frequency?: InputMaybe<Scalars['String']>;
  cobuyer_phone_number?: InputMaybe<Scalars['String']>;
  cobuyer_prequalification_errors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cobuyer_previous_address_line?: InputMaybe<Scalars['String']>;
  cobuyer_previous_address_line_2?: InputMaybe<Scalars['String']>;
  cobuyer_previous_city?: InputMaybe<Scalars['String']>;
  cobuyer_previous_county?: InputMaybe<Scalars['String']>;
  cobuyer_previous_employer_name?: InputMaybe<Scalars['String']>;
  cobuyer_previous_employer_phone_number?: InputMaybe<Scalars['String']>;
  cobuyer_previous_job_title?: InputMaybe<Scalars['String']>;
  cobuyer_previous_months_at_job?: InputMaybe<Scalars['Int']>;
  cobuyer_previous_state?: InputMaybe<Scalars['String']>;
  cobuyer_previous_years_at_job?: InputMaybe<Scalars['Int']>;
  cobuyer_previous_zip?: InputMaybe<Scalars['String']>;
  cobuyer_primary_residence_monthly_payment?: InputMaybe<Scalars['Float']>;
  cobuyer_primary_residence_months?: InputMaybe<Scalars['Int']>;
  cobuyer_primary_residence_type?: InputMaybe<Scalars['String']>;
  cobuyer_primary_residence_years?: InputMaybe<Scalars['Int']>;
  cobuyer_relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  cobuyer_salary?: InputMaybe<Scalars['Float']>;
  cobuyer_secondary_residence_months?: InputMaybe<Scalars['Int']>;
  cobuyer_secondary_residence_years?: InputMaybe<Scalars['Int']>;
  cobuyer_ssn_id?: InputMaybe<Scalars['ID']>;
  cobuyer_state?: InputMaybe<Scalars['String']>;
  cobuyer_years_at_job?: InputMaybe<Scalars['Int']>;
  cobuyer_zip?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  condition_report?: InputMaybe<Scalars['JSON']>;
  county?: InputMaybe<Scalars['String']>;
  credit_score?: InputMaybe<Scalars['Int']>;
  current_accordion_panel?: InputMaybe<Scalars['String']>;
  dev_prequal_credit_score?: InputMaybe<Scalars['Int']>;
  dev_prequal_override?: InputMaybe<Scalars['Boolean']>;
  device_type?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['DateTime']>;
  doc_fee?: InputMaybe<Scalars['Float']>;
  down_payment?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  employer_name?: InputMaybe<Scalars['String']>;
  employer_phone_number?: InputMaybe<Scalars['String']>;
  employment_status?: InputMaybe<Scalars['String']>;
  estimated_dealer_fees?: InputMaybe<Scalars['Float']>;
  first_name?: InputMaybe<Scalars['String']>;
  fuel_type?: InputMaybe<Scalars['String']>;
  good_through_date?: InputMaybe<Scalars['DateTime']>;
  has_full_ssn?: InputMaybe<Scalars['Boolean']>;
  high_ltv_ratio?: InputMaybe<Scalars['Boolean']>;
  include_cobuyer?: InputMaybe<Scalars['Boolean']>;
  is_chat?: InputMaybe<Scalars['Boolean']>;
  is_hard_pull?: InputMaybe<Scalars['Boolean']>;
  is_methodfi_flow?: InputMaybe<Scalars['Boolean']>;
  job_title?: InputMaybe<Scalars['String']>;
  kbb_all_options?: InputMaybe<Scalars['JSON']>;
  kbb_lending_mileage_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_lending_option_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_retail_mileage_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_retail_option_adjustment?: InputMaybe<Scalars['Float']>;
  kbb_selected_options?: InputMaybe<Scalars['JSON']>;
  kbb_trim_name?: InputMaybe<Scalars['String']>;
  kbb_valuation_date?: InputMaybe<Scalars['String']>;
  kbb_vehicle_id?: InputMaybe<Scalars['Int']>;
  kbb_vehicle_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  last_url?: InputMaybe<Scalars['String']>;
  lh_account_number?: InputMaybe<Scalars['String']>;
  license_plate_number?: InputMaybe<Scalars['String']>;
  license_plate_state?: InputMaybe<Scalars['String']>;
  lienholder?: InputMaybe<Scalars['String']>;
  lienholderLogo?: InputMaybe<Scalars['String']>;
  lienholder_slug?: InputMaybe<Scalars['String']>;
  likely_address_accepted?: InputMaybe<Scalars['Boolean']>;
  likely_address_address_line?: InputMaybe<Scalars['String']>;
  likely_address_address_line_2?: InputMaybe<Scalars['String']>;
  likely_address_city?: InputMaybe<Scalars['String']>;
  likely_address_county?: InputMaybe<Scalars['String']>;
  likely_address_query_run?: InputMaybe<Scalars['Boolean']>;
  likely_address_query_success?: InputMaybe<Scalars['Boolean']>;
  likely_address_state?: InputMaybe<Scalars['String']>;
  likely_address_zip?: InputMaybe<Scalars['String']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']>;
  make?: InputMaybe<Scalars['String']>;
  manual_entry?: InputMaybe<Scalars['Boolean']>;
  marital_status?: InputMaybe<MaritalStatusEnum>;
  methodfi_flow_variation?: InputMaybe<Scalars['Int']>;
  middle_name?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  mmr_value?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  months_at_job?: InputMaybe<Scalars['Int']>;
  moved_states?: InputMaybe<Scalars['Boolean']>;
  odometer_status?: InputMaybe<OdometerStatus>;
  old_lease_payment?: InputMaybe<Scalars['Float']>;
  other_lienholder?: InputMaybe<Scalars['String']>;
  pay_frequency?: InputMaybe<Scalars['String']>;
  payment_estimate_high?: InputMaybe<Scalars['Float']>;
  payment_estimate_low?: InputMaybe<Scalars['Float']>;
  payoff_duration_time_ms?: InputMaybe<Scalars['Int']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']>;
  payoff_initiated_time?: InputMaybe<Scalars['DateTime']>;
  phone_number?: InputMaybe<Scalars['String']>;
  prequal_id?: InputMaybe<Scalars['ID']>;
  prequalification_errors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prequalification_success?: InputMaybe<Scalars['Boolean']>;
  previous_address_line?: InputMaybe<Scalars['String']>;
  previous_address_line_2?: InputMaybe<Scalars['String']>;
  previous_city?: InputMaybe<Scalars['String']>;
  previous_county?: InputMaybe<Scalars['String']>;
  previous_employer_name?: InputMaybe<Scalars['String']>;
  previous_employer_phone_number?: InputMaybe<Scalars['String']>;
  previous_job_title?: InputMaybe<Scalars['String']>;
  previous_months_at_job?: InputMaybe<Scalars['Int']>;
  previous_state?: InputMaybe<Scalars['String']>;
  previous_years_at_job?: InputMaybe<Scalars['Int']>;
  previous_zip?: InputMaybe<Scalars['String']>;
  primary_residence_monthly_payment?: InputMaybe<Scalars['Float']>;
  primary_residence_months?: InputMaybe<Scalars['Int']>;
  primary_residence_type?: InputMaybe<Scalars['String']>;
  primary_residence_years?: InputMaybe<Scalars['Int']>;
  query_params?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
  retail_book_value?: InputMaybe<Scalars['Float']>;
  salary?: InputMaybe<Scalars['Float']>;
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']>;
  scheduled_call_datetime?: InputMaybe<Scalars['DateTime']>;
  scheduled_call_datetime_tz?: InputMaybe<Scalars['String']>;
  secondary_residence_months?: InputMaybe<Scalars['Int']>;
  secondary_residence_years?: InputMaybe<Scalars['Int']>;
  sell_timeline?: InputMaybe<Scalars['String']>;
  shopping_cart?: InputMaybe<TemporaryShoppingCartDataInput>;
  ssn_id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  stress_test_payoff_requested?: InputMaybe<Scalars['Boolean']>;
  taxes?: InputMaybe<Scalars['Decimal']>;
  taxes_fees?: InputMaybe<Scalars['Float']>;
  term?: InputMaybe<Scalars['Int']>;
  title_only?: InputMaybe<Scalars['Boolean']>;
  trade_in_preference?: InputMaybe<Scalars['String']>;
  uploaded_files?: InputMaybe<Scalars['JSON']>;
  user_entered_total_payoff?: InputMaybe<Scalars['Float']>;
  vehicle_offer?: InputMaybe<Scalars['Float']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
  vehicle_registration_fee?: InputMaybe<Scalars['Float']>;
  vehicle_type?: InputMaybe<Scalars['String']>;
  verified_phone_number?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  wants_to_sell?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['String']>;
  years_at_job?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type TemporaryInfo = {
  __typename?: 'temporaryInfo';
  affiliate_id?: Maybe<Scalars['ID']>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  data: TemporaryData;
  deal_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<TemporaryInfoStatusEnumType>;
};

export type TemporaryInfoInput = {
  data: TemporaryDataInput;
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<TemporaryInfoStatusEnumType>;
};

export enum TemporaryInfoStatusEnumType {
  Duplicate = 'duplicate',
  Imported = 'imported'
}

export type TemporaryShoppingCartData = {
  __typename?: 'temporaryShoppingCartData';
  buyout?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Int']>;
  down_payment?: Maybe<Scalars['Float']>;
  estimated_fees?: Maybe<Scalars['Float']>;
  loan_term?: Maybe<Scalars['Int']>;
  payment_estimate_high?: Maybe<Scalars['Float']>;
  payment_estimate_low?: Maybe<Scalars['Float']>;
};

export type TemporaryShoppingCartDataInput = {
  buyout?: InputMaybe<Scalars['Float']>;
  credit_score?: InputMaybe<Scalars['Int']>;
  down_payment?: InputMaybe<Scalars['Float']>;
  estimated_fees?: InputMaybe<Scalars['Float']>;
  loan_term?: InputMaybe<Scalars['Int']>;
  payment_estimate_high?: InputMaybe<Scalars['Float']>;
  payment_estimate_low?: InputMaybe<Scalars['Float']>;
};

export type TextMessage = {
  __typename?: 'textMessage';
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  date_created?: Maybe<Scalars['String']>;
  date_sent?: Maybe<Scalars['String']>;
  date_updated?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  media?: Maybe<Scalars['String']>;
  media_list_object?: Maybe<MediaListObj>;
  message?: Maybe<Scalars['String']>;
  message_id?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  recipient_phone_number?: Maybe<Scalars['String']>;
  resolved_media?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type TextMessageInput = {
  account_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  date_created?: InputMaybe<Scalars['String']>;
  date_sent?: InputMaybe<Scalars['String']>;
  date_updated?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Scalars['String']>;
  media_list_object?: InputMaybe<MediaListInputObj>;
  message?: InputMaybe<Scalars['String']>;
  message_id?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
  recipient_phone_number?: InputMaybe<Scalars['String']>;
  resolved_media?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export enum TiresEnumType {
  Fine = 'fine',
  NeedReplacing = 'need_replacing',
  New = 'new'
}

export enum TransformType {
  AcquisitionNotApproved = 'ACQUISITION_NOT_APPROVED',
  Affiliate = 'AFFILIATE',
  AffiliateAutomatic = 'AFFILIATE_AUTOMATIC',
  AffiliateInactivityImport = 'AFFILIATE_INACTIVITY_IMPORT',
  AutomaticAssistant = 'AUTOMATIC_ASSISTANT',
  AutomaticEquity = 'AUTOMATIC_EQUITY',
  AutomaticPayment = 'AUTOMATIC_PAYMENT',
  AutoStructureBegin = 'AUTO_STRUCTURE_BEGIN',
  Canada = 'CANADA',
  FrozenOrLockedCredit = 'FROZEN_OR_LOCKED_CREDIT',
  InactivityImport = 'INACTIVITY_IMPORT',
  LienholderNotApproved = 'LIENHOLDER_NOT_APPROVED',
  ManualImportPostSoftPull = 'MANUAL_IMPORT_POST_SOFT_PULL',
  ManualImportPreSoftPull = 'MANUAL_IMPORT_PRE_SOFT_PULL',
  MarketingNurture = 'MARKETING_NURTURE',
  MarketingNurturePaymentCalculator = 'MARKETING_NURTURE_PAYMENT_CALCULATOR',
  NoKbbFailure = 'NO_KBB_FAILURE',
  OtherLienholder = 'OTHER_LIENHOLDER',
  PayoffRequestFailure = 'PAYOFF_REQUEST_FAILURE',
  PayoffRequestInProgress = 'PAYOFF_REQUEST_IN_PROGRESS',
  PayoffRequestSuccess = 'PAYOFF_REQUEST_SUCCESS',
  PiUnavailable = 'PI_UNAVAILABLE',
  SoftPullFailure = 'SOFT_PULL_FAILURE',
  SoftPullFailureAutoImport = 'SOFT_PULL_FAILURE_AUTO_IMPORT',
  SoftPullSuccessAutoImport = 'SOFT_PULL_SUCCESS_AUTO_IMPORT'
}

export type TwilioNumber = {
  __typename?: 'twilioNumber';
  friendlyName?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type UsStatesInputObject = {
  states?: InputMaybe<Array<InputMaybe<StateAbbreviation>>>;
};

export type UsStatesObject = {
  __typename?: 'usStatesObject';
  states?: Maybe<Array<Maybe<StateAbbreviation>>>;
};

export type User = {
  __typename?: 'user';
  assignment_mode?: Maybe<AssignmentMode>;
  auth0_roles?: Maybe<UserRoles>;
  autoAssignEligibility?: Maybe<UserAutoAssignEligibility>;
  auto_assign_deals?: Maybe<Scalars['Boolean']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  frequency_minutes?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['String']>;
  huntGroups?: Maybe<Array<Maybe<HuntGroup>>>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  on_vacation?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  pods?: Maybe<Array<Maybe<Pod>>>;
  recruiter_id?: Maybe<Scalars['String']>;
  titlingPods?: Maybe<Array<Maybe<Pod>>>;
  twilio_number?: Maybe<Scalars['String']>;
  user_type?: Maybe<UserType>;
};

export type UserAutoAssignEligibility = {
  __typename?: 'userAutoAssignEligibility';
  accept_ai_touched_deals: Scalars['Boolean'];
  accept_overnight_deals: Scalars['Boolean'];
  accept_unseen_deals: Scalars['Boolean'];
  accept_with_upcoming_appointment: Scalars['Boolean'];
  deals_with_bank_fees: Scalars['Boolean'];
  deals_with_direct_pay: Scalars['Boolean'];
  deals_with_double_tax: Scalars['Boolean'];
  deals_with_down_payment: Scalars['Boolean'];
  deals_with_gap: Scalars['Boolean'];
  deals_with_stipulations: Scalars['Boolean'];
  deals_with_vsc: Scalars['Boolean'];
  user_id: Scalars['String'];
};

export type UserInput = {
  assignment_mode?: InputMaybe<AssignmentMode>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']>;
  auto_assign_marketplace_deals?: InputMaybe<Scalars['Boolean']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: InputMaybe<Scalars['String']>;
  can_claim_as_closer?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  frequency_minutes?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationType>;
  max_auto_assign_deals?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  on_vacation?: InputMaybe<Scalars['Boolean']>;
  phone_number?: InputMaybe<Scalars['String']>;
  photo_url?: InputMaybe<Scalars['String']>;
  pods?: InputMaybe<Array<InputMaybe<PodInput>>>;
  recruiter_id?: InputMaybe<Scalars['String']>;
  titlingPods?: InputMaybe<Array<InputMaybe<PodInput>>>;
  twilio_number?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserType>;
};

export type Value = {
  __typename?: 'value';
  buyout?: Maybe<Scalars['Float']>;
  refi?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type VisibleArticles = {
  __typename?: 'visibleArticles';
  results?: Maybe<Array<Maybe<Article>>>;
  total?: Maybe<Scalars['Int']>;
};

export type VscRateOption = {
  __typename?: 'vscRateOption';
  cost: Scalars['Float'];
  coverageName: Scalars['String'];
  formName: Scalars['String'];
  penFormId: Scalars['Int'];
  penRateId: Scalars['Int'];
  penSessionId: Scalars['String'];
  price: Scalars['Float'];
  retailPrice: Scalars['Float'];
  termMiles: Scalars['Int'];
  termMonths: Scalars['Int'];
};

export type WaitingCall = {
  __typename?: 'waitingCall';
  conference_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_name?: Maybe<Scalars['String']>;
  deal_id?: Maybe<Scalars['Int']>;
  deal_state?: Maybe<Scalars['String']>;
  deal_type?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  hunt_group_slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  is_thunder?: Maybe<Scalars['Boolean']>;
  partner_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  processing_started_at?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['String']>;
  thunder_data?: Maybe<Scalars['JSONObject']>;
  to?: Maybe<Scalars['String']>;
  transferred_from?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type AcquisitionOfferQueryVariables = Exact<{
  accidents: AccidentsEnumType;
  mileage: Scalars['Int'];
  mmr_value: Scalars['Float'];
  book_value: Scalars['Int'];
  vehicle_type?: InputMaybe<Scalars['String']>;
  lienholder?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
}>;


export type AcquisitionOfferQuery = { __typename?: 'Query', acquisitionOffer?: { __typename?: 'acquisitionOffer', offer?: number | null | undefined, appraisedValue?: number | null | undefined } | null | undefined };

export type AddressDetailQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}>;


export type AddressDetailQuery = { __typename?: 'Query', addressDetail?: { __typename?: 'AddressDetail', city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined } | null | undefined };

export type AffiliateByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type AffiliateByPhoneNumberQuery = { __typename?: 'Query', affiliateByPhoneNumber?: { __typename?: 'affiliate', id?: number | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined, external_id?: string | null | undefined, lead_request?: any | null | undefined, ssn_id?: number | null | undefined, decision_accepted?: boolean | null | undefined, affiliate_provider_id?: number | null | undefined, decision_response?: { __typename?: 'lending_tree_decision_response', partnerDecision?: string | null | undefined, offers?: Array<{ __typename?: 'lending_tree_offer', amount?: number | null | undefined, term?: number | null | undefined, apr?: number | null | undefined, monthlyPayment?: number | null | undefined, offerUrl?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, affiliate_provider?: { __typename?: 'affiliate_provider', id?: number | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined, slug?: AffiliateProviderSlug | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined };

export type TransformLendingTreeLeadToDealMutationVariables = Exact<{
  affiliate: AffiliateInput;
}>;


export type TransformLendingTreeLeadToDealMutation = { __typename?: 'RootMutationType', transformLendingTreeLeadToDeal?: { __typename?: 'deal', id?: number | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined, state?: string | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, customer_id?: number | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, email?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, year?: string | null | undefined, vin?: string | null | undefined } | null | undefined } | null | undefined };

export type OnAffiliateDuplicateFoundSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAffiliateDuplicateFoundSubscription = { __typename?: 'RootSubscriptionType', onAffiliateDuplicateFound?: { __typename?: 'AffiliateDuplicateFound', deal_id: number, first_name: string, last_name: string } | null | undefined };

export type CreateAffiliateApiKeyMutationVariables = Exact<{
  affiliateApiKey: AffiliateApiKeyInput;
}>;


export type CreateAffiliateApiKeyMutation = { __typename?: 'RootMutationType', createAffiliateApiKey?: string | null | undefined };

export type DeactivateAffiliateApiKeyMutationVariables = Exact<{
  affiliateApiKeyId: Scalars['String'];
}>;


export type DeactivateAffiliateApiKeyMutation = { __typename?: 'RootMutationType', deactivateAffiliateApiKey?: boolean | null | undefined };

export type GetAffiliateApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAffiliateApiKeysQuery = { __typename?: 'Query', getAffiliateApiKeys?: Array<{ __typename?: 'AffiliateApiKey', id?: number | null | undefined, affiliate_provider_id?: string | null | undefined, name?: string | null | undefined, is_active?: boolean | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined } | null | undefined> | null | undefined };

export type AffiliateProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type AffiliateProvidersQuery = { __typename?: 'Query', affiliateProviders?: Array<{ __typename?: 'AffiliateProviderRead', id?: number | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined } | null | undefined> | null | undefined };

export type CreateAffiliateProviderMutationVariables = Exact<{
  affiliateProvider: AffiliateProviderInput;
}>;


export type CreateAffiliateProviderMutation = { __typename?: 'RootMutationType', createAffiliateProvider?: { __typename?: 'AffiliateProviderRead', id?: number | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined } | null | undefined };

export type CreateArticleMutationVariables = Exact<{
  article?: InputMaybe<ArticleInput>;
}>;


export type CreateArticleMutation = { __typename?: 'RootMutationType', createArticle?: { __typename?: 'article', id?: number | null | undefined } | null | undefined };

export type ArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticlesQuery = { __typename?: 'Query', articles?: Array<{ __typename?: 'article', id?: number | null | undefined, title?: string | null | undefined, headline?: string | null | undefined, url?: string | null | undefined, com_visible?: boolean | null | undefined, created_at?: any | null | undefined, thumbnail_key?: string | null | undefined, thumbnail?: string | null | undefined } | null | undefined> | null | undefined };

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteArticleMutation = { __typename?: 'RootMutationType', deleteArticle?: { __typename?: 'article', id?: number | null | undefined } | null | undefined };

export type UpdateArticleMutationVariables = Exact<{
  article?: InputMaybe<ArticleInput>;
}>;


export type UpdateArticleMutation = { __typename?: 'RootMutationType', updateArticle?: { __typename?: 'article', id?: number | null | undefined, title?: string | null | undefined, headline?: string | null | undefined, url?: string | null | undefined, com_visible?: boolean | null | undefined, created_at?: any | null | undefined, thumbnail_key?: string | null | undefined, thumbnail?: string | null | undefined } | null | undefined };

export type AuctionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuctionsQuery = { __typename?: 'Query', auctions?: Array<{ __typename?: 'auction', id?: number | null | undefined, name?: string | null | undefined, address_line?: string | null | undefined, zip?: string | null | undefined, state?: string | null | undefined } | null | undefined> | null | undefined };

export type AuctionUpsertMutationVariables = Exact<{
  auction?: InputMaybe<AuctionInput>;
}>;


export type AuctionUpsertMutation = { __typename?: 'RootMutationType', auctionUpsert?: { __typename?: 'auction', id?: number | null | undefined } | null | undefined };

export type AuctionDistancesQueryVariables = Exact<{
  data?: InputMaybe<AuctionDistancesInput>;
}>;


export type AuctionDistancesQuery = { __typename?: 'Query', auctionDistances?: { __typename?: 'auctionDistances', name?: string | null | undefined, transport_cost?: number | null | undefined, id?: number | null | undefined } | null | undefined };

export type AuctionAverageTransportCostQueryVariables = Exact<{
  id: Scalars['ID'];
  customerAddress: Scalars['String'];
}>;


export type AuctionAverageTransportCostQuery = { __typename?: 'Query', auctionAverageTransportCost?: number | null | undefined };

export type GetAuth0RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuth0RolesQuery = { __typename?: 'Query', getAuth0Roles?: Array<{ __typename?: 'Auth0Role', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined };

export type BanksQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  selectedBank?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['Int']>;
}>;


export type BanksQuery = { __typename?: 'Query', banks?: Array<{ __typename?: 'bank', id?: number | null | undefined, name?: string | null | undefined, slug?: TtNewBankEnum | null | undefined, provider?: LendingNetwork | null | undefined, provider_lender_id?: string | null | undefined, active?: boolean | null | undefined, display_name?: string | null | undefined, bank_markups?: Array<{ __typename?: 'bankMarkup', term_min?: number | null | undefined, term_max?: number | null | undefined, max_markup?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type BankInfoQueryVariables = Exact<{
  deal_id: Scalars['ID'];
}>;


export type BankInfoQuery = { __typename?: 'Query', bankInfo?: { __typename?: 'bank', name?: string | null | undefined, address?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, phone?: string | null | undefined, provider_lender_id?: string | null | undefined } | null | undefined };

export type GetUserCallHistoryQueryVariables = Exact<{
  items_per_page: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type GetUserCallHistoryQuery = { __typename?: 'Query', getUserCallHistory?: { __typename?: 'PaginatedCallHistory', totalRecords?: number | null | undefined, newMissedCallIds?: Array<string | null | undefined> | null | undefined, calls?: Array<{ __typename?: 'call', id?: string | null | undefined, callStatus?: string | null | undefined, direction?: string | null | undefined, twilioNumber?: string | null | undefined, fromNumber?: string | null | undefined, calledNumber?: string | null | undefined, user_id?: number | null | undefined, recordingSid?: string | null | undefined, recordingUrl?: string | null | undefined, outcome?: string | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined, created_at?: any | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AiCallPayloadQueryVariables = Exact<{
  dealId: Scalars['String'];
}>;


export type AiCallPayloadQuery = { __typename?: 'Query', aiCallPayload?: { __typename?: 'AICallPayload', dealId?: string | null | undefined, dealSource?: string | null | undefined, driverName?: string | null | undefined, repName?: string | null | undefined, vehicleYearMakeModel?: string | null | undefined, vehicleMileage?: string | null | undefined, payoffAmount?: string | null | undefined, bankName?: string | null | undefined, termInMonths?: string | null | undefined, sellRate?: string | null | undefined, buyRate?: string | null | undefined, monthlyPaymentWithVSCGAP?: string | null | undefined, monthlyPaymentWithVSC?: string | null | undefined, monthlyPaymentWithGap?: string | null | undefined, monthlyPaymentWithNoCoverage?: string | null | undefined, firstPaymentDate?: string | null | undefined, vscYears?: string | null | undefined, vscMiles?: string | null | undefined, currentMiles__vscMiles?: string | null | undefined, originalWarrantyYears?: string | null | undefined, originalWarrantyMiles?: string | null | undefined, lienholderName?: string | null | undefined, maxMarkup?: string | null | undefined, moneyDown?: string | null | undefined, isBuyerNotLessee?: string | null | undefined, isTitleOnly?: string | null | undefined, isLesseeOnlyOrDoubleTax?: string | null | undefined, isWalkInRequired?: string | null | undefined, isDirectPayDeal?: string | null | undefined, isRegTransferEligible?: string | null | undefined } | null | undefined };

export type CallOutMutationVariables = Exact<{
  calledNumber: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  thunderCallerIdOverride?: InputMaybe<Scalars['String']>;
}>;


export type CallOutMutation = { __typename?: 'RootMutationType', callOut?: { __typename?: 'call', calledNumber?: string | null | undefined, id?: string | null | undefined } | null | undefined };

export type CallOutWithAiMutationVariables = Exact<{
  payload: AiCallInputPayload;
  calledNumber: Scalars['String'];
}>;


export type CallOutWithAiMutation = { __typename?: 'RootMutationType', callOutWithAi?: string | null | undefined };

export type HangUpCallMutationVariables = Exact<{
  conference_id: Scalars['String'];
}>;


export type HangUpCallMutation = { __typename?: 'RootMutationType', hangUpCall?: boolean | null | undefined };

export type SaveNewCustomerCallOutcomeMutationVariables = Exact<{
  call_id: Scalars['String'];
  outcome?: InputMaybe<Scalars['String']>;
  outcome_description?: InputMaybe<Scalars['String']>;
}>;


export type SaveNewCustomerCallOutcomeMutation = { __typename?: 'RootMutationType', saveNewCustomerCallOutcome?: { __typename?: 'call', id?: string | null | undefined } | null | undefined };

export type OnMissedSipCallSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnMissedSipCallSubscription = { __typename?: 'RootSubscriptionType', onMissedSipCall?: { __typename?: 'onMissedSipCall', callInfo?: { __typename?: 'call', id?: string | null | undefined, fromNumber?: string | null | undefined, deal_id?: number | null | undefined, calledNumber?: string | null | undefined, outcome?: string | null | undefined, recordingSid?: string | null | undefined, recordingUrl?: string | null | undefined, callStatus?: string | null | undefined, direction?: string | null | undefined, twilioNumber?: string | null | undefined, user_id?: number | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined } | null | undefined } | null | undefined };

export type GetCallHistoryQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  agentUserId?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
  flowType?: InputMaybe<Scalars['String']>;
  huntGroupSlug?: InputMaybe<Scalars['String']>;
  hasEventType?: InputMaybe<Scalars['String']>;
  callSid?: InputMaybe<Scalars['String']>;
  conferenceId?: InputMaybe<Scalars['String']>;
}>;


export type GetCallHistoryQuery = { __typename?: 'Query', getCallHistory: { __typename?: 'CallHistoryResult', totalRecords: number, calls: Array<{ __typename?: 'CallHistoryItem', id: string, conference_id?: string | null | undefined, direction?: string | null | undefined, flow?: string | null | undefined, outcome?: string | null | undefined, fromNumber?: string | null | undefined, calledNumber?: string | null | undefined, twilioNumber?: string | null | undefined, agent_name?: string | null | undefined, user_id?: string | null | undefined, created_at: string, callDuration?: string | null | undefined, deal_id?: number | null | undefined, recording_url?: string | null | undefined, sip_failure_count?: number | null | undefined, was_transferred?: boolean | null | undefined, voicemail_reason?: string | null | undefined, hunt_group_slug?: string | null | undefined, customer_name?: string | null | undefined, hunt_group_name?: string | null | undefined, participants?: string | null | undefined }> } };

export type GetCallLifecycleQueryVariables = Exact<{
  conferenceId?: InputMaybe<Scalars['String']>;
  callId?: InputMaybe<Scalars['String']>;
}>;


export type GetCallLifecycleQuery = { __typename?: 'Query', getCallLifecycle?: { __typename?: 'CallLifecycle', call: { __typename?: 'CallHistoryItem', id: string, conference_id?: string | null | undefined, direction?: string | null | undefined, flow?: string | null | undefined, outcome?: string | null | undefined, fromNumber?: string | null | undefined, calledNumber?: string | null | undefined, twilioNumber?: string | null | undefined, agent_name?: string | null | undefined, user_id?: string | null | undefined, created_at: string, callDuration?: string | null | undefined, deal_id?: number | null | undefined, recording_url?: string | null | undefined, sip_failure_count?: number | null | undefined, was_transferred?: boolean | null | undefined, voicemail_reason?: string | null | undefined, hunt_group_slug?: string | null | undefined, customer_name?: string | null | undefined, hunt_group_name?: string | null | undefined }, participants: Array<{ __typename?: 'CdrParticipantInLifecycle', id: number, conference_id?: string | null | undefined, participant_user_id?: string | null | undefined, participant_number?: string | null | undefined, joined_at?: string | null | undefined, concluded_at?: string | null | undefined, transferred?: boolean | null | undefined, transferred_from_number?: string | null | undefined, call_id?: string | null | undefined }>, events: Array<{ __typename?: 'CallEvent', id: number, event_type: string, participant_label?: string | null | undefined, participant_number?: string | null | undefined, participant_user_id?: string | null | undefined, participant_user_name?: string | null | undefined, sequence_number?: number | null | undefined, hunt_group_slug?: string | null | undefined, reason?: string | null | undefined, sip_response_code?: string | null | undefined, error_code?: string | null | undefined, error_message?: string | null | undefined, occurred_at: string }> } | null | undefined };

export type GetCallHistoryStatsQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  agentUserId?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
  flowType?: InputMaybe<Scalars['String']>;
}>;


export type GetCallHistoryStatsQuery = { __typename?: 'Query', getCallHistoryStats: { __typename?: 'CallHistoryStats', totalCalls: number, answeredCalls: number, voicemailCalls: number, sipFailures: number, transferredCalls: number, avgDurationSeconds?: number | null | undefined, callsByDay: Array<{ __typename?: 'DayCount', date: string, count: number }>, callsByOutcome: Array<{ __typename?: 'OutcomeCount', outcome: string, count: number }>, callsByFlowType: Array<{ __typename?: 'FlowCount', flow: string, count: number }> } };

export type CarDetailVinQueryVariables = Exact<{
  vin?: InputMaybe<Scalars['String']>;
}>;


export type CarDetailVinQuery = { __typename?: 'Query', carDetailVin?: { __typename?: 'car', year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined } | null | undefined };

export type CarDetailLicensePlateQueryVariables = Exact<{
  license_plate_state: Scalars['String'];
  license_plate_number: Scalars['String'];
}>;


export type CarDetailLicensePlateQuery = { __typename?: 'Query', carDetailLicensePlate?: { __typename?: 'car', vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined } | null | undefined };

export type GetWarrantyInfoQueryVariables = Exact<{
  make: Scalars['String'];
  mileage: Scalars['Int'];
  year: Scalars['String'];
}>;


export type GetWarrantyInfoQuery = { __typename?: 'Query', getWarrantyInfo?: { __typename?: 'carWarranty', full_years?: number | null | undefined, full_miles?: number | null | undefined, full_status?: string | null | undefined, power_train_years?: number | null | undefined, power_train_miles?: number | null | undefined, power_train_status?: string | null | undefined } | null | undefined };

export type VehicleInfoUpsertMutationVariables = Exact<{
  deal?: InputMaybe<DealInput>;
}>;


export type VehicleInfoUpsertMutation = { __typename?: 'RootMutationType', vehicleInfoUpsert?: { __typename?: 'deal', id?: number | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, license_plate_number?: string | null | undefined, license_plate_state?: string | null | undefined, vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, mileage?: number | null | undefined, color?: string | null | undefined, book_value?: number | null | undefined, retail_book_value?: number | null | undefined, jdp_adjusted_clean_trade?: number | null | undefined, jdp_adjusted_clean_retail?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, kbb_trim_name?: string | null | undefined, mmr?: number | null | undefined, registration_expiration?: any | null | undefined, odometer_status?: OdometerStatus | null | undefined, kbb_selected_options_object?: { __typename?: 'KbbSelectedOptionsObject', selected_options?: Array<{ __typename?: 'kbbSelectedOptionsType', id?: number | null | undefined, name?: string | null | undefined, type?: string | null | undefined, lendingOptionPrice?: number | null | undefined, retailOptionPrice?: number | null | undefined, removed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, cbb_valuation?: { __typename?: 'cbbValuation', uvc: string, trim_name: string, vehicle_name: string, valuation_date?: string | null | undefined, data_freq?: string | null | undefined, all_options: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }>, selected_options: Array<{ __typename?: 'cbbSelectedOption', uoc: string, name: string, clean: number }>, inputs?: { __typename?: 'cbbValuationInputs', kilometres: number, province: CbbProvince } | null | undefined, lending?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined, retail?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined } | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, account_number?: string | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, good_through_date?: any | null | undefined, lease_term?: number | null | undefined, remaining_payments?: number | null | undefined, msrp?: number | null | undefined, residual_percentage?: number | null | undefined, sales_price?: number | null | undefined, cap_reduction?: number | null | undefined, money_down?: number | null | undefined, money_factor?: number | null | undefined, termination_fees?: number | null | undefined, cap_cost?: number | null | undefined, residual_amount?: number | null | undefined, estimated_payoff?: number | null | undefined, old_lease_payment?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined, user_entered_total_payoff?: number | null | undefined, maturity_date?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type VehicleMileageQueryVariables = Exact<{
  vin: Scalars['String'];
}>;


export type VehicleMileageQuery = { __typename?: 'Query', vehicleMileage?: { __typename?: 'VehicleMileageGQL', estimatedAverageMiles?: number | null | undefined, eventCount?: number | null | undefined, lastOdometer?: number | null | undefined, lastOdometerDate?: string | null | undefined, resultCode?: number | null | undefined, resultMessage?: string | null | undefined, rollback?: string | null | undefined, vin?: string | null | undefined } | null | undefined };

export type UpdateCarMutationVariables = Exact<{
  car: CarInput;
}>;


export type UpdateCarMutation = { __typename?: 'RootMutationType', updateCar?: { __typename?: 'car', id?: number | null | undefined, book_value?: number | null | undefined, retail_book_value?: number | null | undefined, kbb_lending_mileage_adjustment?: number | null | undefined, kbb_retail_mileage_adjustment?: number | null | undefined, kbb_lending_option_adjustment?: number | null | undefined, kbb_retail_option_adjustment?: number | null | undefined, kbb_valuation_date?: string | null | undefined, kbb_vehicle_name?: string | null | undefined, kbb_trim_name?: string | null | undefined, registration_expiration?: any | null | undefined, kbb_selected_options_object?: { __typename?: 'KbbSelectedOptionsObject', selected_options?: Array<{ __typename?: 'kbbSelectedOptionsType', id?: number | null | undefined, name?: string | null | undefined, type?: string | null | undefined, lendingOptionPrice?: number | null | undefined, retailOptionPrice?: number | null | undefined, removed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, cbb_valuation?: { __typename?: 'cbbValuation', uvc: string, trim_name: string, vehicle_name: string, valuation_date?: string | null | undefined, data_freq?: string | null | undefined, all_options: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }>, selected_options: Array<{ __typename?: 'cbbSelectedOption', uoc: string, name: string, clean: number }>, inputs?: { __typename?: 'cbbValuationInputs', kilometres: number, province: CbbProvince } | null | undefined, lending?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined, retail?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined } | null | undefined } | null | undefined };

export type CbbVinQueryVariables = Exact<{
  vin: Scalars['String'];
  dealId?: InputMaybe<Scalars['ID']>;
}>;


export type CbbVinQuery = { __typename?: 'Query', cbbVin: { __typename?: 'cbbTrimResult', warning: boolean, vehicles: Array<{ __typename?: 'cbbVehicle', uvc: string, trim_name: string, model_year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, add_deduct_list: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }> }> } };

export type CbbValuesQueryVariables = Exact<{
  data: CbbValuesDataType;
}>;


export type CbbValuesQuery = { __typename?: 'Query', cbbValues?: { __typename?: 'cbbValuation', uvc: string, trim_name: string, vehicle_name: string, valuation_date?: string | null | undefined, data_freq?: string | null | undefined, all_options: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }>, selected_options: Array<{ __typename?: 'cbbSelectedOption', uoc: string, name: string, clean: number }>, inputs?: { __typename?: 'cbbValuationInputs', kilometres: number, province: CbbProvince } | null | undefined, lending?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined, retail?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined } | null | undefined };

export type ConditionReportUpsertMutationVariables = Exact<{
  conditionReport?: InputMaybe<ConditionReportUpsertInput>;
}>;


export type ConditionReportUpsertMutation = { __typename?: 'RootMutationType', conditionReportUpsert?: { __typename?: 'conditionReportUpsert', id?: number | null | undefined } | null | undefined };

export type DetermineApprovalQueryQueryVariables = Exact<{
  data?: InputMaybe<DetermineApprovalQueryInput>;
}>;


export type DetermineApprovalQueryQuery = { __typename?: 'Query', determineApprovalQuery?: { __typename?: 'determineApproval', approved?: boolean | null | undefined, failedCriteria?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type SaveConsentMutationVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ConsentNameEnumType>;
}>;


export type SaveConsentMutation = { __typename?: 'RootMutationType', saveConsent: { __typename?: 'SaveConsent', isNew?: boolean | null | undefined, consent?: { __typename?: 'consent', id?: number | null | undefined, type?: ConsentNameEnumType | null | undefined } | null | undefined } };

export type GenerateContractsQueryVariables = Exact<{
  data?: InputMaybe<ContractsInput>;
}>;


export type GenerateContractsQuery = { __typename?: 'Query', generateContracts?: { __typename?: 'contracts', files?: Array<{ __typename?: 'File', url?: string | null | undefined, filename?: string | null | undefined, key?: string | null | undefined, mediaType?: DealMediaTypeEnum | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteContractsMutationVariables = Exact<{
  filePaths: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type DeleteContractsMutation = { __typename?: 'RootMutationType', deleteContracts?: boolean | null | undefined };

export type SendContractsMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type SendContractsMutation = { __typename?: 'RootMutationType', sendContracts?: boolean | null | undefined };

export type CreditApplicationSubmissionsQueryVariables = Exact<{
  filter?: InputMaybe<CreditApplicationSubmissionFilter>;
}>;


export type CreditApplicationSubmissionsQuery = { __typename?: 'Query', creditApplicationSubmissions: Array<{ __typename?: 'CreditApplicationSubmission', id?: number | null | undefined, created_at?: any | null | undefined, credit_applications?: Array<{ __typename?: 'creditApplication', id?: number | null | undefined, credit_decisions?: Array<{ __typename?: 'creditDecision', id?: number | null | undefined, updated_at?: any | null | undefined, provider_lender_id?: string | null | undefined, provider_decision_id?: string | null | undefined, application_status?: CreditDecisionStatusEnum | null | undefined, term?: number | null | undefined, annual_percentage_rate?: number | null | undefined, max_markup?: number | null | undefined, created_at?: any | null | undefined, balance_amount?: number | null | undefined, lender_fees?: number | null | undefined, lender_structured_requirement?: { __typename?: 'lenderStructuredRequirement', documentation_requirements?: { __typename?: 'DocumentationRequirements', poi_required?: boolean | null | undefined, por_required?: boolean | null | undefined, bankruptcy_discharge_required?: boolean | null | undefined, employment_verification_required?: boolean | null | undefined } | null | undefined } | null | undefined, provider_decision_data?: { __typename?: 'CUDLVehicleLoanApplication', ID?: string | null | undefined, Decision?: { __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined } | null | undefined, Decisions?: { __typename?: 'CUDLDecisions', Decision?: Array<{ __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined } | { __typename?: 'r1CreditDecisionData', applicationNumber?: string | null | undefined, applicationStatus?: CreditDecisionStatusEnum | null | undefined, applicationStatusDetail?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> };

export type SelectCreditDecisionFragmentFragment = { __typename?: 'SelectCreditDecision', creditDecision?: { __typename?: 'creditDecision', id?: number | null | undefined } | null | undefined, financialInfo: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, bank_fees?: number | null | undefined, selected_credit_decision_id?: number | null | undefined, term?: number | null | undefined, sell_rate?: number | null | undefined, buy_rate?: number | null | undefined, first_payment_date?: any | null | undefined } };

export type CudlDecisionBaseFragmentFragment = { __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined };

export type CudlDecisionDetailsFragmentFragment = { __typename?: 'CUDLDecision', Stipulations?: { __typename?: 'CUDLStipulations', Stipulation?: Array<string | null | undefined> | null | undefined } | null | undefined, Reasons?: { __typename?: 'CUDLReasons', DecisionReason?: Array<{ __typename?: 'CUDLDecisionReason', Description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, OtherData?: { __typename?: 'CUDLDecisionOtherData', ReferralReasons?: { __typename?: 'CUDLReferralReasons', ReferralReason?: Array<{ __typename?: 'CUDLReferralReason', ReferralReasonText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type ProviderDecisionBaseFragmentFragment = { __typename?: 'creditDecision', provider_decision_data?: { __typename?: 'CUDLVehicleLoanApplication', ID?: string | null | undefined, Decision?: { __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined } | null | undefined, Decisions?: { __typename?: 'CUDLDecisions', Decision?: Array<{ __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined } | { __typename?: 'r1CreditDecisionData', applicationNumber?: string | null | undefined, applicationStatus?: CreditDecisionStatusEnum | null | undefined, applicationStatusDetail?: string | null | undefined } | null | undefined };

export type ProviderDecisionDetailsFragmentFragment = { __typename?: 'creditDecision', provider_decision_data?: { __typename?: 'CUDLVehicleLoanApplication', ID?: string | null | undefined, Decision?: { __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined, Stipulations?: { __typename?: 'CUDLStipulations', Stipulation?: Array<string | null | undefined> | null | undefined } | null | undefined, Reasons?: { __typename?: 'CUDLReasons', DecisionReason?: Array<{ __typename?: 'CUDLDecisionReason', Description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, OtherData?: { __typename?: 'CUDLDecisionOtherData', ReferralReasons?: { __typename?: 'CUDLReferralReasons', ReferralReason?: Array<{ __typename?: 'CUDLReferralReason', ReferralReasonText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined, Decisions?: { __typename?: 'CUDLDecisions', Decision?: Array<{ __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined, Stipulations?: { __typename?: 'CUDLStipulations', Stipulation?: Array<string | null | undefined> | null | undefined } | null | undefined, Reasons?: { __typename?: 'CUDLReasons', DecisionReason?: Array<{ __typename?: 'CUDLDecisionReason', Description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, OtherData?: { __typename?: 'CUDLDecisionOtherData', ReferralReasons?: { __typename?: 'CUDLReferralReasons', ReferralReason?: Array<{ __typename?: 'CUDLReferralReason', ReferralReasonText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, Comments?: { __typename?: 'CUDLComments', Comment?: Array<{ __typename?: 'CUDLComment', ID?: string | null | undefined, Subject?: string | null | undefined, Body?: string | null | undefined, Source?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | { __typename?: 'r1CreditDecisionData', applicationNumber?: string | null | undefined, applicationStatus?: CreditDecisionStatusEnum | null | undefined, applicationStatusDetail?: string | null | undefined, decision?: { __typename?: 'decision', stipulations?: Array<string | null | undefined> | null | undefined, decisionComments?: Array<string | null | undefined> | null | undefined, conditionRejection?: Array<{ __typename?: 'conditionRejection', conditionRejectionText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type CreditDecisionDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CreditDecisionDataQuery = { __typename?: 'Query', creditDecisionV2?: { __typename?: 'creditDecision', id?: number | null | undefined, application_status?: CreditDecisionStatusEnum | null | undefined, provider_decision_data?: { __typename?: 'CUDLVehicleLoanApplication', ID?: string | null | undefined, Decision?: { __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined, Stipulations?: { __typename?: 'CUDLStipulations', Stipulation?: Array<string | null | undefined> | null | undefined } | null | undefined, Reasons?: { __typename?: 'CUDLReasons', DecisionReason?: Array<{ __typename?: 'CUDLDecisionReason', Description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, OtherData?: { __typename?: 'CUDLDecisionOtherData', ReferralReasons?: { __typename?: 'CUDLReferralReasons', ReferralReason?: Array<{ __typename?: 'CUDLReferralReason', ReferralReasonText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined, Decisions?: { __typename?: 'CUDLDecisions', Decision?: Array<{ __typename?: 'CUDLDecision', ID?: string | null | undefined, IsCurrent?: boolean | null | undefined, Stipulations?: { __typename?: 'CUDLStipulations', Stipulation?: Array<string | null | undefined> | null | undefined } | null | undefined, Reasons?: { __typename?: 'CUDLReasons', DecisionReason?: Array<{ __typename?: 'CUDLDecisionReason', Description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, OtherData?: { __typename?: 'CUDLDecisionOtherData', ReferralReasons?: { __typename?: 'CUDLReferralReasons', ReferralReason?: Array<{ __typename?: 'CUDLReferralReason', ReferralReasonText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, Comments?: { __typename?: 'CUDLComments', Comment?: Array<{ __typename?: 'CUDLComment', ID?: string | null | undefined, Subject?: string | null | undefined, Body?: string | null | undefined, Source?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | { __typename?: 'r1CreditDecisionData', applicationNumber?: string | null | undefined, applicationStatus?: CreditDecisionStatusEnum | null | undefined, applicationStatusDetail?: string | null | undefined, decision?: { __typename?: 'decision', stipulations?: Array<string | null | undefined> | null | undefined, decisionComments?: Array<string | null | undefined> | null | undefined, conditionRejection?: Array<{ __typename?: 'conditionRejection', conditionRejectionText?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreditDecisionApplicationNumberQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CreditDecisionApplicationNumberQuery = { __typename?: 'Query', creditDecisionV2?: { __typename?: 'creditDecision', id?: number | null | undefined, provider_decision_id?: string | null | undefined } | null | undefined };

export type SelectCreditDecisionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SelectCreditDecisionMutation = { __typename?: 'RootMutationType', selectCreditDecision?: { __typename?: 'SelectCreditDecision', creditDecision?: { __typename?: 'creditDecision', id?: number | null | undefined } | null | undefined, financialInfo: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, bank_fees?: number | null | undefined, selected_credit_decision_id?: number | null | undefined, term?: number | null | undefined, sell_rate?: number | null | undefined, buy_rate?: number | null | undefined, first_payment_date?: any | null | undefined } } | null | undefined };

export type OnCreditDecisionSelectedSubscriptionVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type OnCreditDecisionSelectedSubscription = { __typename?: 'RootSubscriptionType', onCreditDecisionSelected?: { __typename?: 'SelectCreditDecision', creditDecision?: { __typename?: 'creditDecision', id?: number | null | undefined } | null | undefined, financialInfo: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, bank_fees?: number | null | undefined, selected_credit_decision_id?: number | null | undefined, term?: number | null | undefined, sell_rate?: number | null | undefined, buy_rate?: number | null | undefined, first_payment_date?: any | null | undefined } } | null | undefined };

export type GetCreditDecisionByProviderLenderQueryVariables = Exact<{
  deal_id: Scalars['ID'];
  provider_lender_id: Scalars['String'];
}>;


export type GetCreditDecisionByProviderLenderQuery = { __typename?: 'Query', getCreditDecisionByProviderLender?: { __typename?: 'creditDecision', id?: number | null | undefined, provider_decision_id?: string | null | undefined } | null | undefined };

export type UpdateCustomerMutationVariables = Exact<{
  customer?: InputMaybe<CustomerInput>;
}>;


export type UpdateCustomerMutation = { __typename?: 'RootMutationType', updateCustomer?: { __typename?: 'customer', id?: number | null | undefined } | null | undefined };

export type UpdateCustomerAndAddressMutationVariables = Exact<{
  customer?: InputMaybe<CustomerInput>;
}>;


export type UpdateCustomerAndAddressMutation = { __typename?: 'RootMutationType', updateCustomerAndAddress?: { __typename?: 'customer', id?: number | null | undefined } | null | undefined };

export type UpdateInsuranceInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  insurance_company?: InputMaybe<Scalars['String']>;
  policy_no?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateInsuranceInfoMutation = { __typename?: 'RootMutationType', updateInsuranceInfo?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, expires?: any | null | undefined, policy_number?: string | null | undefined } | null | undefined };

export type DashboardDealCacheFragmentFragment = { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, lane_arrival_utc?: any | null | undefined, default_sort_date?: any | null | undefined };

export type AssignmentUsersFragmentFragment = { __typename?: 'deal', pod_id?: number | null | undefined, fs_pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, structuring_manager_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, fs_pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type TitleUsersFragmentFragment = { __typename?: 'deal', titling_pod_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined, leads?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined };

export type PersonCreditAppOnDealFragment = { __typename?: 'customer', id?: number | null | undefined, dob?: any | null | undefined, auth0_id?: string | null | undefined, ssn_id?: number | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, email?: string | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, home_phone_number?: string | null | undefined, phone_number?: string | null | undefined, marital_status?: string | null | undefined, lives_with_other_buyer?: boolean | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, monthly_payment?: number | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, residence_type?: string | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined } | null | undefined, mailing_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined };

export type ContactPersonFragment = { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined };

export type AddressFragmentFragment = { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined };

export type OriginalLesseeFragmentFragment = { __typename?: 'OriginalLessee', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, address_line?: string | null | undefined, ssn_id?: number | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, county?: string | null | undefined };

export type DealersQueryVariables = Exact<{ [key: string]: never; }>;


export type DealersQuery = { __typename?: 'Query', dealers: Array<{ __typename?: 'Dealer', id: number, name: string }> };

export type GetBootedDealsQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBootedDealsQuery = { __typename?: 'Query', getBootedDeals?: { __typename?: 'PaginatedBootedDeals', totalRecords?: number | null | undefined, results?: Array<{ __typename?: 'deal', id?: number | null | undefined, source?: string | null | undefined, boot_reason?: any | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, deal_dates?: { __typename?: 'DealDates', id?: number | null | undefined, deal_id?: number | null | undefined, dates?: any | null | undefined, custom_dates?: any | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetRelationshipToDealByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type GetRelationshipToDealByPhoneNumberQuery = { __typename?: 'Query', getRelationshipToDealByPhoneNumber?: { __typename?: 'GetRelationshipToDealByPhoneNumberResponse', relationship: string } | null | undefined };

export type SearchDealsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchDealsQuery = { __typename?: 'Query', searchDeals: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, source?: string | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, setter_id?: number | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, email?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', vin?: string | null | undefined } | null | undefined }> };

export type TemplateInfoQueryVariables = Exact<{
  id: Scalars['ID'];
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
}>;


export type TemplateInfoQuery = { __typename?: 'Query', deal?: { __typename?: 'deal', car?: { __typename?: 'car', year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, payoff?: { __typename?: 'payoff', lienholder_name?: string | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', money_down?: number | null | undefined } | null | undefined } | null | undefined };

export type DashboardDealsQueryVariables = Exact<{
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']>;
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  fsPodIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
  closerLocation?: InputMaybe<LocationType>;
  loadAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type DashboardDealsQuery = { __typename?: 'Query', dashboardDeals?: { __typename?: 'DashboardDealsWithCounts', hasMore?: boolean | null | undefined, stateCounts?: Array<{ __typename?: 'StateCount', state?: string | null | undefined, count?: number | null | undefined } | null | undefined> | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, state?: string | null | undefined, lane_arrival_utc?: any | null | undefined, default_sort_date?: any | null | undefined, paperwork_type?: PaperworkType | null | undefined, request_boot?: boolean | null | undefined, boot_reason?: any | null | undefined, created_at?: any | null | undefined, lock_status?: DealLockStatus | null | undefined, closer_id?: number | null | undefined, structuring_manager_id?: number | null | undefined, hasRecentCommunication?: boolean | null | undefined, called_by_financial_specialist?: any | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, display_name: string, color: string, is_dashboard_visible: boolean }> | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, middle_name?: string | null | undefined, phone_number?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, state?: string | null | undefined, county?: string | null | undefined } | null | undefined, secure_link?: { __typename?: 'secureLink', id?: number | null | undefined, expiration_date: any } | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, fs_pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined } | null | undefined, deal_dates?: { __typename?: 'DealDates', id?: number | null | undefined, dates?: any | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_slug?: string | null | undefined, lienholder_name?: string | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, processor?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CompletedDealsQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  userId?: InputMaybe<Scalars['String']>;
  dealState?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
}>;


export type CompletedDealsQuery = { __typename?: 'Query', completedDeals?: { __typename?: 'PaginatedDeals', totalRecords?: number | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, state?: string | null | undefined, completion_date_utc?: any | null | undefined, completion_date_tz?: string | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, address?: { __typename?: 'address', state?: string | null | undefined } | null | undefined } | null | undefined, setter?: { __typename?: 'user', name?: string | null | undefined } | null | undefined, closer?: { __typename?: 'user', name?: string | null | undefined } | null | undefined, closer2?: { __typename?: 'user', name?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, payoff?: { __typename?: 'payoff', lienholder_name?: string | null | undefined, lender_name?: string | null | undefined, good_through_date?: any | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', bank?: string | null | undefined, amount_financed?: number | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, deal_dates?: { __typename?: 'DealDates', dates?: any | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type NavBarTextNotificationsQueryVariables = Exact<{
  sources: Array<Scalars['String']> | Scalars['String'];
  types: Array<DealType> | DealType;
  podIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']>;
}>;


export type NavBarTextNotificationsQuery = { __typename?: 'Query', navBarTextNotifications?: { __typename?: 'NavBarTextNotifications', booted: boolean, completed: boolean, followUp: boolean } | null | undefined };

export type DuplicateDealsQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  homePhoneNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  matchBootedDeals: Scalars['Boolean'];
}>;


export type DuplicateDealsQuery = { __typename?: 'Query', duplicateDeals?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type SubmitToProvidersMutationVariables = Exact<{
  deal?: InputMaybe<DealInput>;
  lenderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SubmitToProvidersMutation = { __typename?: 'RootMutationType', submitToProviders?: { __typename?: 'deal', has_funding_jacket?: boolean | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined } | null | undefined } | null | undefined };

export type DealDetailNetsuiteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DealDetailNetsuiteMutation = { __typename?: 'RootMutationType', dealDetailNetsuite?: { __typename?: 'deal', id?: number | null | undefined, sent_to_netsuite?: boolean | null | undefined } | null | undefined };

export type DealUpdateAssignmentsMutationVariables = Exact<{
  id: Scalars['ID'];
  type?: InputMaybe<DealType>;
  pod_id?: InputMaybe<Scalars['ID']>;
  fs_pod_id?: InputMaybe<Scalars['ID']>;
  setter_id?: InputMaybe<Scalars['String']>;
  closer_id?: InputMaybe<Scalars['String']>;
  closer2_id?: InputMaybe<Scalars['String']>;
  structuring_manager_id?: InputMaybe<Scalars['String']>;
  funding_clerk_id?: InputMaybe<Scalars['String']>;
  titling_pod_id?: InputMaybe<Scalars['ID']>;
  title_clerk_id?: InputMaybe<Scalars['String']>;
  title_clerk2_id?: InputMaybe<Scalars['String']>;
  deal_source?: InputMaybe<Scalars['String']>;
}>;


export type DealUpdateAssignmentsMutation = { __typename?: 'RootMutationType', dealUpdateAssignments?: { __typename?: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, pod_id?: number | null | undefined, fs_pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, structuring_manager_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, titling_pod_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, car?: { __typename?: 'car', payoff?: { __typename?: 'payoff', lender_name?: string | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', address?: { __typename?: 'address', moved_states?: boolean | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', bank?: string | null | undefined, title_registration_option?: TitleRegistrationOption | null | undefined, plate_transfer?: boolean | null | undefined, buyer_not_lessee?: boolean | null | undefined, sales_tax_rate?: number | null | undefined, base_tax_amount?: number | null | undefined, warranty_tax_amount?: number | null | undefined, new_registration_fee?: number | null | undefined, title_fee?: number | null | undefined } | null | undefined, fs_pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, location?: LocationType | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined, leads?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined } | null | undefined };

export type DealUpdateStateMutationVariables = Exact<{
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
  clearSetDate?: InputMaybe<Scalars['Boolean']>;
  clearApprovedDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type DealUpdateStateMutation = { __typename?: 'RootMutationType', dealUpdateState?: { __typename?: 'DealWithErrors', errors?: Array<string | null | undefined> | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, first_payment_date?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ReviveBootMutationVariables = Exact<{
  id: Scalars['ID'];
  reassign?: InputMaybe<Scalars['Boolean']>;
}>;


export type ReviveBootMutation = { __typename?: 'RootMutationType', reviveBoot?: boolean | null | undefined };

export type ImportDealMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImportDealMutation = { __typename?: 'RootMutationType', importDeal?: { __typename?: 'deal', id?: number | null | undefined } | null | undefined };

export type DealTagsUpsertMutationVariables = Exact<{
  dealId: Scalars['ID'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DealTagsUpsertMutation = { __typename?: 'RootMutationType', dealTagsUpsert: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean }> };

export type DealAssignMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  assignee_id?: InputMaybe<Scalars['String']>;
  deal_state?: InputMaybe<Scalars['String']>;
  role: Scalars['String'];
  allow_reassign?: InputMaybe<Scalars['Boolean']>;
}>;


export type DealAssignMutation = { __typename?: 'RootMutationType', dealAssign?: { __typename?: 'deal', id?: number | null | undefined } | null | undefined };

export type DealUpdateRequestBootMutationVariables = Exact<{
  id: Scalars['ID'];
  request_boot: Scalars['Boolean'];
  boot_reason: BootReasonInput;
  partial_note?: InputMaybe<NoteInput>;
  boot_deal?: InputMaybe<Scalars['Boolean']>;
}>;


export type DealUpdateRequestBootMutation = { __typename?: 'RootMutationType', dealUpdateRequestBoot?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, request_boot?: boolean | null | undefined, boot_reason?: any | null | undefined } | null | undefined };

export type ProcessPaperworkMutationVariables = Exact<{
  id: Scalars['ID'];
  state: Scalars['String'];
  paperwork_type: Scalars['String'];
}>;


export type ProcessPaperworkMutation = { __typename?: 'RootMutationType', processPaperwork?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, lane_arrival_utc?: any | null | undefined, default_sort_date?: any | null | undefined } | null | undefined };

export type UpdateCreditAppOnDealMutationVariables = Exact<{
  input: CreditAppInput;
}>;


export type UpdateCreditAppOnDealMutation = { __typename?: 'RootMutationType', updateCreditAppOnDeal?: { __typename?: 'UpdateCreditAppOnDealResponse', id: number, state: string, odometer_status?: OdometerStatus | null | undefined, customer: { __typename?: 'customer', id?: number | null | undefined, dob?: any | null | undefined, auth0_id?: string | null | undefined, ssn_id?: number | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, email?: string | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, home_phone_number?: string | null | undefined, phone_number?: string | null | undefined, marital_status?: string | null | undefined, lives_with_other_buyer?: boolean | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, monthly_payment?: number | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, residence_type?: string | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined } | null | undefined, mailing_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined }, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, dob?: any | null | undefined, auth0_id?: string | null | undefined, ssn_id?: number | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, email?: string | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, home_phone_number?: string | null | undefined, phone_number?: string | null | undefined, marital_status?: string | null | undefined, lives_with_other_buyer?: boolean | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, monthly_payment?: number | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, residence_type?: string | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined } | null | undefined, mailing_address?: { __typename?: 'address', id?: number | null | undefined, address_type?: AddressTypeEnum | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, zip?: string | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined } | null | undefined, original_lessee?: { __typename?: 'OriginalLessee', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, address_line?: string | null | undefined, ssn_id?: number | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, county?: string | null | undefined } | null | undefined, financial_info: { __typename?: 'financialInfo', id?: number | null | undefined, term?: number | null | undefined, money_down?: number | null | undefined, buyer_not_lessee?: boolean | null | undefined, doc_fee?: number | null | undefined, warranty_tax_amount?: number | null | undefined, new_registration_fee?: number | null | undefined, registration_transfer_fee?: number | null | undefined, base_tax_amount?: number | null | undefined, sales_tax_rate?: number | null | undefined }, contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined } | null | undefined } | null | undefined };

export type UpsertOriginalLesseeMutationVariables = Exact<{
  deal_id: Scalars['Int'];
  original_lessee: OriginalLesseeInput;
}>;


export type UpsertOriginalLesseeMutation = { __typename?: 'RootMutationType', upsertOriginalLessee?: { __typename?: 'OriginalLessee', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, address_line?: string | null | undefined, ssn_id?: number | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, county?: string | null | undefined } | null | undefined };

export type OverrideCalledByFinancialSpecialistMutationVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type OverrideCalledByFinancialSpecialistMutation = { __typename?: 'RootMutationType', overrideCalledByFinancialSpecialist?: { __typename?: 'deal', id?: number | null | undefined, called_by_financial_specialist?: any | null | undefined } | null | undefined };

export type UpdateDealNeedsElectronicSignatureVerificationMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  needs_electronic_signature_verification: Scalars['Boolean'];
}>;


export type UpdateDealNeedsElectronicSignatureVerificationMutation = { __typename?: 'RootMutationType', updateDealNeedsElectronicSignatureVerification?: { __typename?: 'deal', id?: number | null | undefined, needs_electronic_signature_verification?: boolean | null | undefined } | null | undefined };

export type DuplicateDealMutationVariables = Exact<{
  dealId: Scalars['ID'];
  duplicationType: DuplicateTypeEnum;
}>;


export type DuplicateDealMutation = { __typename?: 'RootMutationType', duplicateDeal: { __typename?: 'deal', id?: number | null | undefined } };

export type OnDealCompleteSubscriptionVariables = Exact<{
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type OnDealCompleteSubscription = { __typename?: 'RootSubscriptionType', onDealComplete?: Array<{ __typename?: 'deal', id?: number | null | undefined } | null | undefined> | null | undefined };

export type OnDealUpdateSubscriptionVariables = Exact<{
  sources: Array<Scalars['String']> | Scalars['String'];
  types?: InputMaybe<Array<DealType> | DealType>;
  dealIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OnDealUpdateSubscription = { __typename?: 'RootSubscriptionType', onDealUpdate?: Array<{ __typename?: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, state?: string | null | undefined, created_at?: any | null | undefined, creation_date_tz?: string | null | undefined, completion_date_utc?: any | null | undefined, lane_arrival_utc?: any | null | undefined, default_sort_date?: any | null | undefined, needs_electronic_signature_verification?: boolean | null | undefined, called_by_financial_specialist?: any | null | undefined, assigned_sms_phone_number?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, request_boot?: boolean | null | undefined, boot_reason?: any | null | undefined, lock_status?: DealLockStatus | null | undefined, fs_pod_id?: number | null | undefined, pod_id?: number | null | undefined, titling_pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, structuring_manager_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, display_name: string, color: string, is_dashboard_visible: boolean }> | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, mileage?: number | null | undefined, vin?: string | null | undefined, mmr?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, vehicle_payoff?: number | null | undefined, good_through_date?: any | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, secure_link?: { __typename?: 'secureLink', id?: number | null | undefined, expiration_date: any } | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, amount_financed?: number | null | undefined } | null | undefined, deal_dates?: { __typename?: 'DealDates', id?: number | null | undefined, deal_id?: number | null | undefined, dates?: any | null | undefined, custom_dates?: any | null | undefined } | null | undefined, fs_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, titlingPods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, titlingPods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type OnDealLockStatusSubscriptionVariables = Exact<{
  dealId: Scalars['Int'];
}>;


export type OnDealLockStatusSubscription = { __typename?: 'RootSubscriptionType', onDealLockStatus?: { __typename?: 'DealLockStatusSubscriptionPayload', dealId: number, lockStatus?: DealLockStatus | null | undefined } | null | undefined };

export type CustomDatesUpdateMutationVariables = Exact<{
  dealId: Scalars['ID'];
  dateKey: CustomDateKeyEnum;
  date: Scalars['DateTime'];
}>;


export type CustomDatesUpdateMutation = { __typename?: 'RootMutationType', customDatesUpdate?: { __typename?: 'DealDates', id?: number | null | undefined, custom_dates?: any | null | undefined } | null | undefined };

export type DealPackageConfigFragmentFragment = { __typename?: 'DealPackageConfig', slotIndex: number, selectedProductSlugs: Array<ProductSlug> };

export type DealPackageConfigsQueryVariables = Exact<{
  dealId: Scalars['Int'];
}>;


export type DealPackageConfigsQuery = { __typename?: 'Query', dealPackageConfigs: Array<{ __typename?: 'DealPackageConfig', slotIndex: number, selectedProductSlugs: Array<ProductSlug> }> };

export type UpsertDealPackageConfigsMutationVariables = Exact<{
  input: UpsertDealPackageConfigsInput;
}>;


export type UpsertDealPackageConfigsMutation = { __typename?: 'RootMutationType', upsertDealPackageConfigs: Array<{ __typename?: 'DealPackageConfig', slotIndex: number, selectedProductSlugs: Array<ProductSlug> }> };

export type SetDealProductManualTermMutationVariables = Exact<{
  input: SetDealProductManualTermInputV2;
}>;


export type SetDealProductManualTermMutation = { __typename?: 'RootMutationType', setDealProductManualTerm: { __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, term?: string | null | undefined, pen_session_id?: string | null | undefined, pen_rate_id?: number | null | undefined, pen_form_id?: number | null | undefined, pen_contract_number?: string | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string } | null | undefined } };

export type SelectDealProductVscRateMutationVariables = Exact<{
  input: SelectDealProductVscRateInput;
}>;


export type SelectDealProductVscRateMutation = { __typename?: 'RootMutationType', selectDealProductVscRate: { __typename?: 'SelectDealProductVscRateResult', vscDealProduct: { __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, term?: string | null | undefined, coverage_type?: string | null | undefined, pen_session_id?: string | null | undefined, pen_rate_id?: number | null | undefined, pen_form_id?: number | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string } | null | undefined }, paymentOptions: { __typename?: 'paymentOptionsV2', selectedPackageSlotIndex?: number | null | undefined } } };

export type DealProductFragmentFragment = { __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, tax_amount?: number | null | undefined, pen_rate_id?: number | null | undefined, pen_session_id?: string | null | undefined, pen_form_id?: number | null | undefined, pen_contract_number?: string | null | undefined, term?: string | null | undefined, coverage_type?: string | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string, display_order: number } | null | undefined };

export type DealProductsV2QueryVariables = Exact<{
  dealId: Scalars['Int'];
}>;


export type DealProductsV2Query = { __typename?: 'Query', dealProductsV2: Array<{ __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, tax_amount?: number | null | undefined, pen_rate_id?: number | null | undefined, pen_session_id?: string | null | undefined, pen_form_id?: number | null | undefined, pen_contract_number?: string | null | undefined, term?: string | null | undefined, coverage_type?: string | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string, display_order: number } | null | undefined }> };

export type PatchDealProductPricesV2MutationVariables = Exact<{
  input: PatchDealProductPricesInputV2;
}>;


export type PatchDealProductPricesV2Mutation = { __typename?: 'RootMutationType', patchDealProductPricesV2: Array<{ __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, tax_amount?: number | null | undefined, pen_rate_id?: number | null | undefined, pen_session_id?: string | null | undefined, pen_form_id?: number | null | undefined, pen_contract_number?: string | null | undefined, term?: string | null | undefined, coverage_type?: string | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string, display_order: number } | null | undefined }> };

export type UpdateDealProductsV2MutationVariables = Exact<{
  input: UpdateDealProductsInputV2;
}>;


export type UpdateDealProductsV2Mutation = { __typename?: 'RootMutationType', updateDealProductsV2: { __typename?: 'deal', id?: number | null | undefined, selected_package_slot_index?: number | null | undefined, deal_products?: Array<{ __typename?: 'DealProduct', id: number, deal_id: number, product_catalog_id: number, price?: number | null | undefined, cost?: number | null | undefined, tax_amount?: number | null | undefined, pen_rate_id?: number | null | undefined, pen_session_id?: string | null | undefined, pen_form_id?: number | null | undefined, pen_contract_number?: string | null | undefined, term?: string | null | undefined, coverage_type?: string | null | undefined, product_catalog?: { __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string, display_order: number } | null | undefined } | null | undefined> | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, option_type?: string | null | undefined } | null | undefined } };

export type ReferralSourceFragmentFragment = { __typename?: 'referralSource', id?: number | null | undefined, source_name?: ReferralSourceEnum | null | undefined, other_source_description?: string | null | undefined };

export type DealStatesQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type DealStatesQuery = { __typename?: 'Query', dealStates?: Array<{ __typename?: 'dealState', id?: number | null | undefined, state?: string | null | undefined, updated_date_utc?: any | null | undefined, updated_at?: any | null | undefined, user?: { __typename?: 'user', name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type CreateDdDevDealMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDdDevDealMutation = { __typename?: 'RootMutationType', createDdDevDeal?: number | null | undefined };

export type FileFragmentFragment = { __typename?: 'File', url?: string | null | undefined, filename?: string | null | undefined, key?: string | null | undefined, mediaType?: DealMediaTypeEnum | null | undefined };

export type GenerateDocumentsQueryVariables = Exact<{
  data?: InputMaybe<DocumentsInput>;
}>;


export type GenerateDocumentsQuery = { __typename?: 'Query', generateDocuments?: { __typename?: 'documents', errors?: Array<string | null | undefined> | null | undefined, files?: Array<{ __typename?: 'File', url?: string | null | undefined, filename?: string | null | undefined, key?: string | null | undefined, mediaType?: DealMediaTypeEnum | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GenerateRoiDocumentsQueryVariables = Exact<{
  data?: InputMaybe<DocumentsInput>;
}>;


export type GenerateRoiDocumentsQuery = { __typename?: 'Query', generateROIDocuments?: { __typename?: 'documents', errors?: Array<string | null | undefined> | null | undefined, files?: Array<{ __typename?: 'File', url?: string | null | undefined, filename?: string | null | undefined, key?: string | null | undefined, mediaType?: DealMediaTypeEnum | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RetrieveDealDocsUploadedToR1QueryVariables = Exact<{
  dealId: Scalars['ID'];
  includePdfBinary?: InputMaybe<Scalars['Boolean']>;
}>;


export type RetrieveDealDocsUploadedToR1Query = { __typename?: 'Query', retrieveDealDocsUploadedToR1?: Array<{ __typename?: 'DealDocument', displayName?: string | null | undefined, documentName?: string | null | undefined, documentType?: string | null | undefined, signatureStatus?: DocumentSignatureStatus | null | undefined, completedAt?: any | null | undefined } | null | undefined> | null | undefined };

export type ValidateBankContractQueryVariables = Exact<{
  deal_id: Scalars['ID'];
}>;


export type ValidateBankContractQuery = { __typename?: 'Query', validateBankContract?: boolean | null | undefined };

export type LatestThirdPartyPayoffSendQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type LatestThirdPartyPayoffSendQuery = { __typename?: 'Query', latestThirdPartyPayoffSend?: { __typename?: 'ThirdPartyPayoffSend', id?: number | null | undefined, status: ThirdPartyPayoffSendStatus, created_at?: any | null | undefined } | null | undefined };

export type GeneratePurchaseOrderQueryVariables = Exact<{
  deal_id: Scalars['ID'];
}>;


export type GeneratePurchaseOrderQuery = { __typename?: 'Query', generatePurchaseOrder?: { __typename?: 'purchaseOrder', files?: Array<{ __typename?: 'File', url?: string | null | undefined, filename?: string | null | undefined, key?: string | null | undefined, mediaType?: DealMediaTypeEnum | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UploadDocumentToRouteOneMutationVariables = Exact<{
  dealId: Scalars['ID'];
  doc: UploadDocumentsInput;
  withCobuyer: Scalars['Boolean'];
}>;


export type UploadDocumentToRouteOneMutation = { __typename?: 'RootMutationType', uploadDocumentToRouteOne?: boolean | null | undefined };

export type SetReadyForSignaturesStatusMutationVariables = Exact<{
  dealId: Scalars['ID'];
  documentProgressStatus?: InputMaybe<DocumentProgressStatus>;
}>;


export type SetReadyForSignaturesStatusMutation = { __typename?: 'RootMutationType', setReadyForSignaturesStatus?: boolean | null | undefined };

export type MergeFilesMutationVariables = Exact<{
  dealId: Scalars['ID'];
  docs?: InputMaybe<Array<InputMaybe<DealMediaInput>> | InputMaybe<DealMediaInput>>;
}>;


export type MergeFilesMutation = { __typename?: 'RootMutationType', mergeFiles?: { __typename?: 'MergedDocuments', url: string, filename: string, key: string } | null | undefined };

export type AddDocumentsToMediaCenterMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  files: Array<InputMaybe<AddDocumentsToMediaCenterInput>> | InputMaybe<AddDocumentsToMediaCenterInput>;
}>;


export type AddDocumentsToMediaCenterMutation = { __typename?: 'RootMutationType', addDocumentsToMediaCenter?: boolean | null | undefined };

export type SendDocumentsWithAdobeAndUpdateStateMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  state: DealStateEnum;
}>;


export type SendDocumentsWithAdobeAndUpdateStateMutation = { __typename?: 'RootMutationType', sendDocumentsWithAdobeAndUpdateState?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined } | null | undefined };

export type SendRoiDocumentsWithAdobeMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  keys: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type SendRoiDocumentsWithAdobeMutation = { __typename?: 'RootMutationType', sendROIDocumentsWithAdobe?: { __typename?: 'deal', id?: number | null | undefined, roi_document_info?: { __typename?: 'DocumentInfo', id?: number | null | undefined, adobe_agreement_id?: string | null | undefined } | null | undefined } | null | undefined };

export type UploadDocumentsToCudlMutationVariables = Exact<{
  dealId: Scalars['ID'];
  keys: Array<Scalars['String']> | Scalars['String'];
}>;


export type UploadDocumentsToCudlMutation = { __typename?: 'RootMutationType', uploadDocumentsToCUDL?: { __typename?: 'UploadDocumentsToCUDLResult', uploadedDocuments: Array<string>, errors: Array<string> } | null | undefined };

export type SendThirdPartyPayoffMutationVariables = Exact<{
  dealId: Scalars['ID'];
  keys: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendThirdPartyPayoffMutation = { __typename?: 'RootMutationType', sendThirdPartyPayoff: { __typename?: 'ThirdPartyPayoffSend', id?: number | null | undefined, status: ThirdPartyPayoffSendStatus, created_at?: any | null | undefined } };

export type OnDocumentProgressStatusSubscriptionVariables = Exact<{
  fundingClerkOnly?: InputMaybe<Scalars['Boolean']>;
  deal_id?: InputMaybe<Scalars['ID']>;
}>;


export type OnDocumentProgressStatusSubscription = { __typename?: 'RootSubscriptionType', onDocumentProgressStatus?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, document_progress_status?: string | null | undefined, r1_contract_manually_validated?: boolean | null | undefined, r1_contract_validation_errors_object?: { __typename?: 'R1ContractValidationErrors', errors?: Array<string | null | undefined> | null | undefined } | null | undefined, r1_contract_validation_warnings_object?: { __typename?: 'R1ContractValidationWarnings', warnings?: Array<string | null | undefined> | null | undefined } | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type OnDashboardDocumentUploadSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDashboardDocumentUploadSubscription = { __typename?: 'RootSubscriptionType', onDashboardDocumentUpload?: { __typename?: 'DashboardDocumentUpload', fileType: string, deal: { __typename?: 'deal', id?: number | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined } } | null | undefined };

export type OnDownPaymentReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDownPaymentReceivedSubscription = { __typename?: 'RootSubscriptionType', onDownPaymentReceived?: { __typename?: 'DownPaymentReceived', amount: number, dealId: number, firstName: string, lastName: string, type: string } | null | undefined };

export type CreateEmbeddedInsuranceLeadAndGetLinkMutationVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type CreateEmbeddedInsuranceLeadAndGetLinkMutation = { __typename?: 'RootMutationType', createEmbeddedInsuranceLeadAndGetLink?: { __typename?: 'createEmbeddedInsuranceLeadAndGetLinkGraphQLType', url?: string | null | undefined } | null | undefined };

export type OnEmbeddedInsuranceNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnEmbeddedInsuranceNotificationSubscription = { __typename?: 'RootSubscriptionType', onEmbeddedInsuranceNotification?: { __typename?: 'EmbeddedInsuranceNotification', deal_id: number, customer_id: number, first_name: string, last_name: string, success: boolean, filename?: string | null | undefined } | null | undefined };

export type DealFragmentFragment = { __typename: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, completion_date_utc?: any | null | undefined, completion_date_tz?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, request_boot?: boolean | null | undefined, boot_reason?: any | null | undefined, has_funding_jacket?: boolean | null | undefined, document_progress_status?: string | null | undefined, selected_dealer_id?: number | null | undefined, r1_contract_manually_validated?: boolean | null | undefined, signing_on_com?: boolean | null | undefined, pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, titling_pod_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, r1_contract_validation_errors_object?: { __typename?: 'R1ContractValidationErrors', errors?: Array<string | null | undefined> | null | undefined } | null | undefined, r1_contract_validation_warnings_object?: { __typename?: 'R1ContractValidationWarnings', warnings?: Array<string | null | undefined> | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined, leads?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, license_plate_number?: string | null | undefined, license_plate_state?: string | null | undefined, vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, mileage?: number | null | undefined, mileage_unit?: MileageUnit | null | undefined, color?: string | null | undefined, book_value?: number | null | undefined, retail_book_value?: number | null | undefined, jdp_adjusted_clean_trade?: number | null | undefined, jdp_adjusted_clean_retail?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, kbb_trim_name?: string | null | undefined, mmr?: number | null | undefined, registration_expiration?: any | null | undefined, odometer_status?: OdometerStatus | null | undefined, kbb_selected_options_object?: { __typename?: 'KbbSelectedOptionsObject', selected_options?: Array<{ __typename?: 'kbbSelectedOptionsType', id?: number | null | undefined, name?: string | null | undefined, type?: string | null | undefined, lendingOptionPrice?: number | null | undefined, retailOptionPrice?: number | null | undefined, removed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, cbb_valuation?: { __typename?: 'cbbValuation', uvc: string, trim_name: string, vehicle_name: string, valuation_date?: string | null | undefined, data_freq?: string | null | undefined, all_options: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }>, selected_options: Array<{ __typename?: 'cbbSelectedOption', uoc: string, name: string, clean: number }>, inputs?: { __typename?: 'cbbValuationInputs', kilometres: number, province: CbbProvince } | null | undefined, lending?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined, retail?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined } | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, account_number?: string | null | undefined, vehicle_payoff?: number | null | undefined, good_through_date?: any | null | undefined, lease_term?: number | null | undefined, remaining_payments?: number | null | undefined, msrp?: number | null | undefined, residual_percentage?: number | null | undefined, sales_price?: number | null | undefined, cap_reduction?: number | null | undefined, money_down?: number | null | undefined, money_factor?: number | null | undefined, termination_fees?: number | null | undefined, cap_cost?: number | null | undefined, residual_amount?: number | null | undefined, estimated_payoff?: number | null | undefined, old_lease_payment?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined, user_entered_total_payoff?: number | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, email?: string | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, dob?: any | null | undefined, lives_with_other_buyer?: boolean | null | undefined, marital_status?: string | null | undefined, auth0_id?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, email?: string | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, dob?: any | null | undefined, lives_with_other_buyer?: boolean | null | undefined, marital_status?: string | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined } | null | undefined, contact?: { __typename?: 'DealContact', id?: number | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, deal_id?: number | null | undefined, money_down?: number | null | undefined, base_tax_amount?: number | null | undefined, warranty_tax_amount?: number | null | undefined, title_fee?: number | null | undefined, new_registration_fee?: number | null | undefined, registration_transfer_fee?: number | null | undefined, doc_fee?: number | null | undefined, sales_tax_rate?: number | null | undefined, days_to_payment?: number | null | undefined, first_payment_date?: any | null | undefined, sell_rate?: number | null | undefined, buy_rate?: number | null | undefined, term?: number | null | undefined, bank?: string | null | undefined, payment?: number | null | undefined, amount_financed?: number | null | undefined, profit?: number | null | undefined, setter_commission?: number | null | undefined, closer_commission?: number | null | undefined, option_type?: string | null | undefined, plate_transfer?: boolean | null | undefined, title_registration_option?: TitleRegistrationOption | null | undefined, processor?: string | null | undefined, tt_transaction_id?: string | null | undefined, buyer_not_lessee?: boolean | null | undefined, new_lienholder?: { __typename?: 'bank', name?: string | null | undefined, provider_lender_id?: string | null | undefined, address?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, condition_report?: { __typename?: 'conditionReport', id?: number | null | undefined, deal_id?: number | null | undefined, accidents?: AccidentsEnumType | null | undefined, tires?: TiresEnumType | null | undefined, exterior?: Array<ExteriorEnumType | null | undefined> | null | undefined, interior?: Array<InteriorEnumType | null | undefined> | null | undefined, smoked_in?: boolean | null | undefined, lights_on_dash?: boolean | null | undefined, overall_condition?: OverallConditionEnumType | null | undefined, score?: number | null | undefined } | null | undefined, document_info?: { __typename?: 'DocumentInfo', id?: number | null | undefined, adobe_agreement_id?: string | null | undefined } | null | undefined, roi_document_info?: { __typename?: 'DocumentInfo', id?: number | null | undefined, adobe_agreement_id?: string | null | undefined } | null | undefined, deal_states?: Array<{ __typename?: 'dealState', id?: number | null | undefined, deal_id?: number | null | undefined, state?: string | null | undefined, updated_date_utc?: any | null | undefined, user_id?: number | null | undefined, user?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, deal_dates?: { __typename?: 'DealDates', id?: number | null | undefined, deal_id?: number | null | undefined, dates?: any | null | undefined, custom_dates?: any | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, referral_source?: { __typename?: 'referralSource', id?: number | null | undefined, source_name?: ReferralSourceEnum | null | undefined, other_source_description?: string | null | undefined } | null | undefined };

export type NewEstimateUpsertMutationVariables = Exact<{
  newEstimateUpsertInput?: InputMaybe<NewEstimateUpsertInput>;
}>;


export type NewEstimateUpsertMutation = { __typename?: 'RootMutationType', newEstimateUpsert?: { __typename: 'deal', id?: number | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, state?: string | null | undefined, country?: Country | null | undefined, completion_date_utc?: any | null | undefined, completion_date_tz?: string | null | undefined, paperwork_type?: PaperworkType | null | undefined, request_boot?: boolean | null | undefined, boot_reason?: any | null | undefined, has_funding_jacket?: boolean | null | undefined, document_progress_status?: string | null | undefined, selected_dealer_id?: number | null | undefined, r1_contract_manually_validated?: boolean | null | undefined, signing_on_com?: boolean | null | undefined, pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, titling_pod_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, r1_contract_validation_errors_object?: { __typename?: 'R1ContractValidationErrors', errors?: Array<string | null | undefined> | null | undefined } | null | undefined, r1_contract_validation_warnings_object?: { __typename?: 'R1ContractValidationWarnings', warnings?: Array<string | null | undefined> | null | undefined } | null | undefined, pod?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, titling_pod?: { __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined, leads?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, license_plate_number?: string | null | undefined, license_plate_state?: string | null | undefined, vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, mileage?: number | null | undefined, mileage_unit?: MileageUnit | null | undefined, color?: string | null | undefined, book_value?: number | null | undefined, retail_book_value?: number | null | undefined, jdp_adjusted_clean_trade?: number | null | undefined, jdp_adjusted_clean_retail?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, kbb_trim_name?: string | null | undefined, mmr?: number | null | undefined, registration_expiration?: any | null | undefined, odometer_status?: OdometerStatus | null | undefined, kbb_selected_options_object?: { __typename?: 'KbbSelectedOptionsObject', selected_options?: Array<{ __typename?: 'kbbSelectedOptionsType', id?: number | null | undefined, name?: string | null | undefined, type?: string | null | undefined, lendingOptionPrice?: number | null | undefined, retailOptionPrice?: number | null | undefined, removed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, cbb_valuation?: { __typename?: 'cbbValuation', uvc: string, trim_name: string, vehicle_name: string, valuation_date?: string | null | undefined, data_freq?: string | null | undefined, all_options: Array<{ __typename?: 'cbbAddDeduct', uoc: string, name: string, clean: number, xclean?: number | null | undefined, avg?: number | null | undefined, rough?: number | null | undefined, auto?: string | null | undefined }>, selected_options: Array<{ __typename?: 'cbbSelectedOption', uoc: string, name: string, clean: number }>, inputs?: { __typename?: 'cbbValuationInputs', kilometres: number, province: CbbProvince } | null | undefined, lending?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined, retail?: { __typename?: 'cbbValueBreakdown', adjusted: number, base: number, mileage_adjustment: number, option_adjustment: number, regional_adjustment: number } | null | undefined } | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, account_number?: string | null | undefined, vehicle_payoff?: number | null | undefined, good_through_date?: any | null | undefined, lease_term?: number | null | undefined, remaining_payments?: number | null | undefined, msrp?: number | null | undefined, residual_percentage?: number | null | undefined, sales_price?: number | null | undefined, cap_reduction?: number | null | undefined, money_down?: number | null | undefined, money_factor?: number | null | undefined, termination_fees?: number | null | undefined, cap_cost?: number | null | undefined, residual_amount?: number | null | undefined, estimated_payoff?: number | null | undefined, old_lease_payment?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined, user_entered_total_payoff?: number | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, email?: string | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, dob?: any | null | undefined, lives_with_other_buyer?: boolean | null | undefined, marital_status?: string | null | undefined, auth0_id?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, name_suffix?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, email?: string | null | undefined, has_full_ssn?: boolean | null | undefined, has_itin?: boolean | null | undefined, dob?: any | null | undefined, lives_with_other_buyer?: boolean | null | undefined, marital_status?: string | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, prev_address?: { __typename?: 'address', id?: number | null | undefined, address_line?: string | null | undefined, address_line_2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, county?: string | null | undefined, country?: Country | null | undefined, address_type?: AddressTypeEnum | null | undefined, residence_type?: string | null | undefined, years_at_home?: number | null | undefined, months_at_home?: number | null | undefined, monthly_payment?: number | null | undefined, moved_states?: boolean | null | undefined } | null | undefined, employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, prev_employment?: { __typename?: 'employment', id?: number | null | undefined, status?: EmploymentStatusEnum | null | undefined, name?: string | null | undefined, job_title?: string | null | undefined, phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, gross_income?: number | null | undefined, pay_frequency?: IncomeIntervalEnum | null | undefined } | null | undefined, proof_of_insurance?: { __typename?: 'proofOfInsurance', id?: number | null | undefined, company_name?: string | null | undefined, policy_number?: string | null | undefined, expires?: any | null | undefined } | null | undefined } | null | undefined, contact?: { __typename?: 'DealContact', id?: number | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined, first_name?: string | null | undefined, middle_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, deal_id?: number | null | undefined, money_down?: number | null | undefined, base_tax_amount?: number | null | undefined, warranty_tax_amount?: number | null | undefined, title_fee?: number | null | undefined, new_registration_fee?: number | null | undefined, registration_transfer_fee?: number | null | undefined, doc_fee?: number | null | undefined, sales_tax_rate?: number | null | undefined, days_to_payment?: number | null | undefined, first_payment_date?: any | null | undefined, sell_rate?: number | null | undefined, buy_rate?: number | null | undefined, term?: number | null | undefined, bank?: string | null | undefined, payment?: number | null | undefined, amount_financed?: number | null | undefined, profit?: number | null | undefined, setter_commission?: number | null | undefined, closer_commission?: number | null | undefined, option_type?: string | null | undefined, plate_transfer?: boolean | null | undefined, title_registration_option?: TitleRegistrationOption | null | undefined, processor?: string | null | undefined, tt_transaction_id?: string | null | undefined, buyer_not_lessee?: boolean | null | undefined, new_lienholder?: { __typename?: 'bank', name?: string | null | undefined, provider_lender_id?: string | null | undefined, address?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, condition_report?: { __typename?: 'conditionReport', id?: number | null | undefined, deal_id?: number | null | undefined, accidents?: AccidentsEnumType | null | undefined, tires?: TiresEnumType | null | undefined, exterior?: Array<ExteriorEnumType | null | undefined> | null | undefined, interior?: Array<InteriorEnumType | null | undefined> | null | undefined, smoked_in?: boolean | null | undefined, lights_on_dash?: boolean | null | undefined, overall_condition?: OverallConditionEnumType | null | undefined, score?: number | null | undefined } | null | undefined, document_info?: { __typename?: 'DocumentInfo', id?: number | null | undefined, adobe_agreement_id?: string | null | undefined } | null | undefined, roi_document_info?: { __typename?: 'DocumentInfo', id?: number | null | undefined, adobe_agreement_id?: string | null | undefined } | null | undefined, deal_states?: Array<{ __typename?: 'dealState', id?: number | null | undefined, deal_id?: number | null | undefined, state?: string | null | undefined, updated_date_utc?: any | null | undefined, user_id?: number | null | undefined, user?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, deal_dates?: { __typename?: 'DealDates', id?: number | null | undefined, deal_id?: number | null | undefined, dates?: any | null | undefined, custom_dates?: any | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, referral_source?: { __typename?: 'referralSource', id?: number | null | undefined, source_name?: ReferralSourceEnum | null | undefined, other_source_description?: string | null | undefined } | null | undefined } | null | undefined };

export type ManuallySelectBankMutationVariables = Exact<{
  dealId: Scalars['ID'];
  bank: Scalars['String'];
}>;


export type ManuallySelectBankMutation = { __typename?: 'RootMutationType', manuallySelectBank: { __typename?: 'financialInfo', id?: number | null | undefined, bank?: string | null | undefined, selected_credit_decision_id?: number | null | undefined, first_payment_date?: any | null | undefined } };

export type UpdateProcessorMutationVariables = Exact<{
  dealId: Scalars['ID'];
  fiId: Scalars['ID'];
  processor?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProcessorMutation = { __typename?: 'RootMutationType', updateProcessor?: { __typename?: 'financialInfo', id?: number | null | undefined, processor?: string | null | undefined } | null | undefined };

export type ResetProcessorAssignmentMutationVariables = Exact<{
  dealId: Scalars['ID'];
  fiId: Scalars['ID'];
}>;


export type ResetProcessorAssignmentMutation = { __typename?: 'RootMutationType', resetProcessorAssignment?: { __typename?: 'financialInfo', id?: number | null | undefined, tt_transaction_id?: string | null | undefined } | null | undefined };

export type OnTransactionCreatedSubscriptionVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type OnTransactionCreatedSubscription = { __typename?: 'RootSubscriptionType', onTransactionCreated?: { __typename?: 'financialInfo', deal_id?: number | null | undefined, tt_transaction_id?: string | null | undefined } | null | undefined };

export type FinancialInfoAcquisitionUpsertMutationVariables = Exact<{
  financialInfoAcquisition?: InputMaybe<FinancialInfoAcquisitionInput>;
  id: Scalars['ID'];
  state: Scalars['String'];
  car_id?: InputMaybe<Scalars['ID']>;
  mmr?: InputMaybe<Scalars['Float']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']>;
  override?: InputMaybe<Scalars['Boolean']>;
  clear_override?: InputMaybe<Scalars['Boolean']>;
}>;


export type FinancialInfoAcquisitionUpsertMutation = { __typename?: 'RootMutationType', financialInfoAcquisitionUpsert?: { __typename?: 'financialInfoAcquisition', id?: number | null | undefined } | null | undefined };

export type GetFollowUpDealsPaginatedQueryVariables = Exact<{
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']>;
  bootRequested?: InputMaybe<Scalars['Boolean']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  sortColumn: Scalars['String'];
  sortDirection: Scalars['String'];
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  resultsPerPage?: InputMaybe<Scalars['Int']>;
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetFollowUpDealsPaginatedQuery = { __typename?: 'Query', getFollowUpDealsPaginated?: { __typename?: 'PaginatedDeals', totalRecords?: number | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined, creator?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FollowUpQueryVariables = Exact<{
  deal_id: Scalars['ID'];
}>;


export type FollowUpQuery = { __typename?: 'Query', followUp?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined } | null | undefined };

export type FollowUpInsertMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  type: FollowUpTypeEnum;
  date_utc: Scalars['DateTime'];
  tz: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type FollowUpInsertMutation = { __typename?: 'RootMutationType', followUpInsert?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined } | null | undefined };

export type FollowUpUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  type: FollowUpTypeEnum;
  date_utc: Scalars['DateTime'];
  tz: Scalars['String'];
  deal_id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type FollowUpUpdateMutation = { __typename?: 'RootMutationType', followUpUpdate?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined } | null | undefined };

export type FollowUpDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FollowUpDeleteMutation = { __typename?: 'RootMutationType', followUpDelete?: { __typename?: 'followUp', id?: number | null | undefined } | null | undefined };

export type OnFollowUpUpdateSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  types?: InputMaybe<Array<InputMaybe<DealType>> | InputMaybe<DealType>>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']>;
  followUpType?: InputMaybe<FollowUpTypeEnum>;
  followUpStatus?: InputMaybe<FollowUpStatusEnum>;
}>;


export type OnFollowUpUpdateSubscription = { __typename?: 'RootSubscriptionType', onFollowUpUpdate?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, source?: string | null | undefined, type?: DealType | null | undefined, structuring_manager_id?: number | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_follow_up?: { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, color: string, display_name: string, is_active: boolean, is_dashboard_visible: boolean, slug: TagSlugEnum }> | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, creator_id?: number | null | undefined, deal_id?: number | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined, status?: FollowUpStatusEnum | null | undefined, tz?: string | null | undefined, type?: FollowUpTypeEnum | null | undefined, creator?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, user_type?: UserType | null | undefined, assignment_mode?: AssignmentMode | null | undefined, frequency_minutes?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type InProgressCallsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InProgressCallsSubscription = { __typename?: 'RootSubscriptionType', inProgressCalls?: Array<{ __typename?: 'conference', id?: number | null | undefined, from?: string | null | undefined, to?: string | null | undefined, conference_id?: string | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, deal_id?: number | null | undefined, customer_name?: string | null | undefined, agent_user_id?: string | null | undefined, deal_state?: string | null | undefined, deal_type?: string | null | undefined, is_thunder?: boolean | null | undefined, hunt_group_slug?: string | null | undefined, is_outbound?: boolean | null | undefined } | null | undefined> | null | undefined };

export type JdpValuesQueryVariables = Exact<{
  vin: Scalars['String'];
  mileage: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
}>;


export type JdpValuesQuery = { __typename?: 'Query', jdpValues?: { __typename?: 'car', jdp_mileage_adjustment?: number | null | undefined, jdp_adjusted_clean_retail?: number | null | undefined, jdp_adjusted_clean_trade?: number | null | undefined, jdp_trim_body?: string | null | undefined, jdp_valuation_date?: any | null | undefined, jdp_vehicle_accessories_object?: { __typename?: 'jdpVehicleAccessoriesObject', vehicle_accessories?: Array<{ __typename?: 'jdpVehicleAccessories', acccode?: string | null | undefined, accdesc?: string | null | undefined, accessorycategory?: string | null | undefined, excludes?: string | null | undefined, includes?: string | null | undefined, isadded?: number | null | undefined, isincluded?: number | null | undefined, loan?: number | null | undefined, retail?: number | null | undefined, tradein?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type CreateJdpBookSheetMutationVariables = Exact<{
  dealId: Scalars['ID'];
  customerState: Scalars['String'];
}>;


export type CreateJdpBookSheetMutation = { __typename?: 'RootMutationType', createJDPBookSheet?: boolean | null | undefined };

export type KbbVinQueryVariables = Exact<{
  vin: Scalars['String'];
}>;


export type KbbVinQuery = { __typename?: 'Query', kbbVin?: { __typename?: 'kbbVinObjectResult', warning?: boolean | null | undefined, vinResults?: Array<{ __typename?: 'kbbVinResult', vehicleId?: number | null | undefined, modelName?: string | null | undefined, trimName?: string | null | undefined, makeName?: string | null | undefined, yearId?: string | null | undefined, vehicleName?: string | null | undefined, vehicleOptions?: Array<{ __typename?: 'kbbOption', categoryGroup?: string | null | undefined, hasRelationships?: boolean | null | undefined, isConfigurable?: boolean | null | undefined, isConsumer?: boolean | null | undefined, isTypical?: boolean | null | undefined, isVinDecoded?: boolean | null | undefined, optionName?: string | null | undefined, optionType?: string | null | undefined, sortOrder?: number | null | undefined, vehicleId?: number | null | undefined, vehicleOptionId?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type KbbValuesQueryVariables = Exact<{
  data: KbbValuesDataType;
}>;


export type KbbValuesQuery = { __typename?: 'Query', kbbValues?: { __typename?: 'kbbValuesResult', retail?: number | null | undefined, retailMileageAdjustment?: number | null | undefined, retailOptionAdjustment?: number | null | undefined, retailOptionPrices?: any | null | undefined, lending?: number | null | undefined, lendingMileageAdjustment?: number | null | undefined, lendingOptionAdjustment?: number | null | undefined, lendingOptionPrices?: any | null | undefined, valuationDate?: string | null | undefined, kbbSelectedOptions?: Array<{ __typename?: 'kbbSelectedOptionsType', id?: number | null | undefined, name?: string | null | undefined, type?: string | null | undefined, removed?: boolean | null | undefined, lendingOptionPrice?: number | null | undefined, retailOptionPrice?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CalculateOptionsQueryVariables = Exact<{
  vehicleId: Scalars['Int'];
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>> | InputMaybe<KbbOptionInput>>;
  startingVehicleOptions?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  configToModify?: InputMaybe<Array<InputMaybe<KbbConfigType>> | InputMaybe<KbbConfigType>>;
  vin: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
}>;


export type CalculateOptionsQuery = { __typename?: 'Query', calculateOptions?: Array<{ __typename?: 'kbbOption', vehicleOptionId?: number | null | undefined, optionName?: string | null | undefined, optionType?: string | null | undefined, categoryGroup?: string | null | undefined } | null | undefined> | null | undefined };

export type CreateKbbBookSheetMutationVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type CreateKbbBookSheetMutation = { __typename?: 'RootMutationType', createKBBBookSheet?: boolean | null | undefined };

export type KeyMetricsQueryVariables = Exact<{
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
  pod_ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type KeyMetricsQuery = { __typename?: 'Query', keyMetrics?: Array<{ __typename?: 'keyMetric', keyMetric?: string | null | undefined, value?: { __typename?: 'value', buyout?: number | null | undefined, refi?: number | null | undefined, total?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type LaneKeyMetricsQueryVariables = Exact<{
  today?: InputMaybe<Scalars['DateTime']>;
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
}>;


export type LaneKeyMetricsQuery = { __typename?: 'Query', laneKeyMetrics?: Array<{ __typename?: 'laneKeyMetric', state?: string | null | undefined, day_count?: number | null | undefined } | null | undefined> | null | undefined };

export type LaneKeyMetricsReaderQueryVariables = Exact<{
  today?: InputMaybe<Scalars['DateTime']>;
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  types: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
}>;


export type LaneKeyMetricsReaderQuery = { __typename?: 'Query', laneKeyMetricsReader?: Array<{ __typename?: 'laneKeyMetric', state?: string | null | undefined, day_count?: number | null | undefined } | null | undefined> | null | undefined };

export type LenderFragmentFragment = { __typename?: 'Lender', id?: string | null | undefined, name?: string | null | undefined };

export type LendersQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type LendersQuery = { __typename?: 'Query', lenders?: Array<{ __typename?: 'Lender', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined };

export type MediaQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type MediaQuery = { __typename?: 'Query', media?: Array<{ __typename?: 'dealMedia', id?: number | null | undefined, key?: string | null | undefined, signed_url?: string | null | undefined, type?: DealMediaTypeEnum | null | undefined, metadata?: any | null | undefined, deal_id?: number | null | undefined, verified?: boolean | null | undefined, state?: DealMediaStateEnum | null | undefined, source?: DealMediaSourceEnum | null | undefined, has_verified_digital_signature?: boolean | null | undefined, has_wet_signature?: boolean | null | undefined, is_notarized?: boolean | null | undefined, cudl_document_id?: string | null | undefined, created_at?: any | null | undefined } | null | undefined> | null | undefined };

export type GetUploadUrlQueryVariables = Exact<{
  dealId: Scalars['ID'];
  fileName: Scalars['String'];
}>;


export type GetUploadUrlQuery = { __typename?: 'Query', getUploadUrl?: { __typename?: 'mediaUploadUrl', key?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type ArticleImageUploadUrlQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type ArticleImageUploadUrlQuery = { __typename?: 'Query', articleImageUploadUrl?: { __typename?: 'articleImageUploadUrl', url?: string | null | undefined, key?: string | null | undefined } | null | undefined };

export type GetBase64StringFromS3ObjectQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetBase64StringFromS3ObjectQuery = { __typename?: 'Query', getBase64StringFromS3Object?: string | null | undefined };

export type MediaInsertMutationVariables = Exact<{
  key: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  dealId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
}>;


export type MediaInsertMutation = { __typename?: 'RootMutationType', mediaInsert?: { __typename?: 'dealMedia', id?: number | null | undefined, key?: string | null | undefined, signed_url?: string | null | undefined, type?: DealMediaTypeEnum | null | undefined, metadata?: any | null | undefined, deal_id?: number | null | undefined, has_verified_digital_signature?: boolean | null | undefined, has_wet_signature?: boolean | null | undefined, is_notarized?: boolean | null | undefined } | null | undefined };

export type MediaDeleteMutationVariables = Exact<{
  filePath: Scalars['String'];
}>;


export type MediaDeleteMutation = { __typename?: 'RootMutationType', mediaDelete?: boolean | null | undefined };

export type DeleteAndReplaceFilesMutationVariables = Exact<{
  deal_id: Scalars['ID'];
  files_to_delete: Array<InputMaybe<AddDocumentsToMediaCenterInput>> | InputMaybe<AddDocumentsToMediaCenterInput>;
  files_to_upload: Array<InputMaybe<AddDocumentsToMediaCenterInput>> | InputMaybe<AddDocumentsToMediaCenterInput>;
}>;


export type DeleteAndReplaceFilesMutation = { __typename?: 'RootMutationType', deleteAndReplaceFiles?: boolean | null | undefined };

export type MediaRenameMutationVariables = Exact<{
  dealId: Scalars['ID'];
  filePath: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type MediaRenameMutation = { __typename?: 'RootMutationType', mediaRename?: boolean | null | undefined };

export type MediaUpdateMutationVariables = Exact<{
  dealId: Scalars['ID'];
  oldKey: Scalars['String'];
  newFileName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  has_verified_digital_signature?: InputMaybe<Scalars['Boolean']>;
  has_wet_signature?: InputMaybe<Scalars['Boolean']>;
  is_notarized?: InputMaybe<Scalars['Boolean']>;
}>;


export type MediaUpdateMutation = { __typename?: 'RootMutationType', mediaUpdate?: { __typename?: 'dealMedia', id?: number | null | undefined, key?: string | null | undefined, signed_url?: string | null | undefined, type?: DealMediaTypeEnum | null | undefined, metadata?: any | null | undefined, deal_id?: number | null | undefined, verified?: boolean | null | undefined, has_verified_digital_signature?: boolean | null | undefined, has_wet_signature?: boolean | null | undefined, is_notarized?: boolean | null | undefined } | null | undefined };

export type MessageFragmentFragment = { __typename?: 'message', id?: number | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, senderName?: string | null | undefined, dateCreated?: any | null | undefined, status?: string | null | undefined, errorReason?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type InboxQueryVariables = Exact<{
  filterBy?: InputMaybe<InboxFilterByEnum>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  orderBy?: InputMaybe<InboxOrderByEnum>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
}>;


export type InboxQuery = { __typename?: 'Query', inbox?: { __typename?: 'inboxMessagesType', totalRecords?: number | null | undefined, messages?: Array<{ __typename?: 'message', id?: number | null | undefined, from?: string | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, dateCreated?: any | null | undefined, dateCreatedTz?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined } | null | undefined, contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, closer2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, funding_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, titlingPods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, title_clerk2?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, titlingPods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type MessageTemplatesByTypeQueryVariables = Exact<{
  type?: InputMaybe<MessageTemplateType>;
}>;


export type MessageTemplatesByTypeQuery = { __typename?: 'Query', messageTemplatesByType?: Array<{ __typename?: 'MessageTemplate', id?: number | null | undefined, title: string, category: MessageTemplateCategory } | null | undefined> | null | undefined };

export type MessageTemplateByKeyQueryVariables = Exact<{
  key: MessageTemplateKey;
}>;


export type MessageTemplateByKeyQuery = { __typename?: 'Query', messageTemplateByKey?: { __typename?: 'MessageTemplate', id?: number | null | undefined, title: string, body: string, category: MessageTemplateCategory, type: MessageTemplateType, key?: string | null | undefined } | null | undefined };

export type MessagesQueryVariables = Exact<{
  dealPhoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type MessagesQuery = { __typename?: 'Query', messages?: { __typename?: 'messagesWithErrors', hasErrors?: boolean | null | undefined, messages?: Array<{ __typename?: 'message', id?: number | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, senderName?: string | null | undefined, dateCreated?: any | null | undefined, status?: string | null | undefined, errorReason?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type MessagesDbPaginatedQueryVariables = Exact<{
  dealPhoneNumber: Scalars['String'];
  dealId: Scalars['String'];
  page: Scalars['Int'];
}>;


export type MessagesDbPaginatedQuery = { __typename?: 'Query', messagesDbPaginated?: { __typename?: 'messagesDbPaginated', hasMoreMessages: boolean, messages: Array<{ __typename?: 'message', id?: number | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, senderName?: string | null | undefined, dateCreated?: any | null | undefined, status?: string | null | undefined, errorReason?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SuggestedMessageQueryVariables = Exact<{
  dealId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  customerId: Scalars['ID'];
  draftMessage?: InputMaybe<Scalars['String']>;
}>;


export type SuggestedMessageQuery = { __typename?: 'Query', suggestedMessage?: string | null | undefined };

export type FillMessageTemplateMutationVariables = Exact<{
  input: FillMessageTemplateInput;
}>;


export type FillMessageTemplateMutation = { __typename?: 'RootMutationType', fillMessageTemplate: { __typename?: 'FillMessageTemplateResult', renderedMessage: string } };

export type MessageSendMutationVariables = Exact<{
  message: Scalars['String'];
  dealPhoneNumber: Scalars['String'];
  id: Scalars['ID'];
}>;


export type MessageSendMutation = { __typename?: 'RootMutationType', messageSend?: { __typename?: 'message', id?: number | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, senderName?: string | null | undefined, dateCreated?: any | null | undefined, status?: string | null | undefined, errorReason?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type FileSendMutationVariables = Exact<{
  file: Scalars['String'];
  dealPhoneNumber: Scalars['String'];
  id: Scalars['ID'];
}>;


export type FileSendMutation = { __typename?: 'RootMutationType', fileSend?: { __typename?: 'message', id?: number | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, senderName?: string | null | undefined, dateCreated?: any | null | undefined, status?: string | null | undefined, errorReason?: string | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type OnNewMessageSubscriptionVariables = Exact<{
  dealPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isNotification?: InputMaybe<Scalars['Boolean']>;
  isWidgetOpen?: InputMaybe<Scalars['Boolean']>;
  activePhoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type OnNewMessageSubscription = { __typename?: 'RootSubscriptionType', onNewMessage?: { __typename?: 'MessageData', message?: { __typename?: 'message', id?: number | null | undefined, from?: string | null | undefined, fromCustomer?: boolean | null | undefined, body?: string | null | undefined, dateCreated?: any | null | undefined, mediaListObj?: { __typename?: 'mediaListObj', data?: Array<{ __typename?: 'mediaListData', url?: string | null | undefined, contentType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, pod_id?: number | null | undefined, titling_pod_id?: number | null | undefined, setter_id?: number | null | undefined, closer_id?: number | null | undefined, closer2_id?: number | null | undefined, funding_clerk_id?: number | null | undefined, title_clerk_id?: number | null | undefined, title_clerk2_id?: number | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined } | null | undefined, cobuyer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined } | null | undefined, contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined } | null | undefined, second_contact?: { __typename?: 'DealContact', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, relation_to_buyer?: RelationToBuyerEnum | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, year?: string | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, notification_subscribers?: Array<{ __typename?: 'NotificationSubscriber', id?: number | null | undefined, deal_id?: number | null | undefined, subscriber_id?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, messageDetail?: { __typename?: 'messageDetail', shortNames?: Array<string | null | undefined> | null | undefined, dealIds?: Array<number | null | undefined> | null | undefined, dealStates?: Array<string | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type MetricsPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type MetricsPagesQuery = { __typename?: 'Query', metricsPages?: Array<{ __typename?: 'metricsPages', id?: number | null | undefined, name?: string | null | undefined, link_name?: string | null | undefined, iframe_url?: string | null | undefined, permission_name?: string | null | undefined, sort_order?: number | null | undefined } | null | undefined> | null | undefined };

export type MmrQueryVariables = Exact<{
  vin: Scalars['String'];
  mileage: Scalars['Int'];
  color: Scalars['String'];
  grade: Scalars['Float'];
  trim: Scalars['String'];
  state: Scalars['String'];
}>;


export type MmrQuery = { __typename?: 'Query', mmr?: { __typename?: 'mmrResult', average?: number | null | undefined } | null | undefined };

export type NoteCreateMutationVariables = Exact<{
  note?: InputMaybe<NoteInput>;
}>;


export type NoteCreateMutation = { __typename?: 'RootMutationType', noteCreate?: { __typename?: 'note', id?: number | null | undefined } | null | undefined };

export type NoteUpdateMutationVariables = Exact<{
  note?: InputMaybe<NoteInput>;
}>;


export type NoteUpdateMutation = { __typename?: 'RootMutationType', noteUpdate?: { __typename?: 'note', id?: number | null | undefined } | null | undefined };

export type NoteDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NoteDeleteMutation = { __typename?: 'RootMutationType', noteDelete?: { __typename?: 'note', id?: number | null | undefined } | null | undefined };

export type NotesQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type NotesQuery = { __typename?: 'Query', notes?: Array<{ __typename?: 'note', id?: number | null | undefined, author_id?: string | null | undefined, text?: string | null | undefined, deal_id?: number | null | undefined, created_at?: any | null | undefined, creation_date_tz?: string | null | undefined, note_type?: string | null | undefined, pinned?: boolean | null | undefined, recordingid?: string | null | undefined, author?: { __typename?: 'user', name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type TaughtCallUrlQueryVariables = Exact<{
  noteId?: InputMaybe<Scalars['Int']>;
}>;


export type TaughtCallUrlQuery = { __typename?: 'Query', taughtCallUrl?: string | null | undefined };

export type NotificationFragmentFragment = { __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined };

export type DealUnreadMessageCountQueryVariables = Exact<{
  dealId: Scalars['Int'];
}>;


export type DealUnreadMessageCountQuery = { __typename?: 'Query', dealUnreadMessageCount: { __typename?: 'DealUnreadMessageCount', byRecipient: Array<{ __typename?: 'RecipientUnreadCount', recipientId: number, phoneNumber: string, count: number, missedCallCount: number }> } };

export type NotificationsSeenMutationVariables = Exact<{
  notificationIds: Array<Scalars['ID']> | Scalars['ID'];
  seen: Scalars['Boolean'];
}>;


export type NotificationsSeenMutation = { __typename?: 'RootMutationType', notificationsSeen?: boolean | null | undefined };

export type MarkRecipientThreadSeenMutationVariables = Exact<{
  dealId: Scalars['Int'];
  recipientType: Scalars['String'];
  recipientId: Scalars['Int'];
  phoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type MarkRecipientThreadSeenMutation = { __typename?: 'RootMutationType', markRecipientThreadSeen: { __typename?: 'DealUnreadMessageCount', byRecipient: Array<{ __typename?: 'RecipientUnreadCount', recipientId: number, phoneNumber: string, count: number, missedCallCount: number }> } };

export type OnNoDealNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNoDealNotificationSubscription = { __typename?: 'RootSubscriptionType', onNoDealNotification?: Array<{ __typename?: 'notification', id?: number | null | undefined } | null | undefined> | null | undefined };

export type MarkMissedSipNotificationAsSeenMutationVariables = Exact<{
  callIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type MarkMissedSipNotificationAsSeenMutation = { __typename?: 'RootMutationType', markMissedSipNotificationAsSeen?: boolean | null | undefined };

export type UpdateSubscriptionToNotificationsStatusMutationVariables = Exact<{
  dealId: Scalars['ID'];
  subscribeToNotifications: Scalars['Boolean'];
}>;


export type UpdateSubscriptionToNotificationsStatusMutation = { __typename?: 'RootMutationType', updateSubscriptionToNotificationsStatus?: { __typename?: 'NotificationSubscriber', id?: number | null | undefined, deal_id?: number | null | undefined, subscriber_id?: string | null | undefined } | null | undefined };

export type PaymentOptionFragmentFragment = { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined };

export type PaymentOptionsQueryVariables = Exact<{
  data?: InputMaybe<PaymentOptionsInput>;
}>;


export type PaymentOptionsQuery = { __typename?: 'Query', paymentOptions?: { __typename?: 'paymentOptions', vscPlusGap?: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined } | null | undefined, vsc?: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined } | null | undefined, gap?: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined } | null | undefined, noProducts?: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined } | null | undefined } | null | undefined };

export type PaymentEstimateQueryVariables = Exact<{
  data?: InputMaybe<PaymentEstimateInput>;
}>;


export type PaymentEstimateQuery = { __typename?: 'Query', paymentEstimate?: { __typename?: 'paymentEstimate', paymentEstimateLow: number, paymentEstimateHigh: number, estimatedTaxesAndFees: number, totalEstimatedLoan: number, estimatedAnnualPercentageRate: number } | null | undefined };

export type PaymentOptionV2FragmentFragment = { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined };

export type PaymentOptionsPackageProductV2FragmentFragment = { __typename?: 'PaymentOptionsPackageProductV2', productCatalogId?: number | null | undefined, slug: ProductSlug, price: number, cost: number, taxAmount: number };

export type PaymentOptionsPackageV2FragmentFragment = { __typename?: 'PaymentOptionsPackageV2', slotIndex: number, selectedProductSlugs: Array<ProductSlug>, legacyOptionType: string, isSelected: boolean, amountFinanced: number, buyPayment: number, sellPayment: number, profit: number, setterCommission: number, closerCommission: number, reserve: number, products: Array<{ __typename?: 'PaymentOptionsPackageProductV2', productCatalogId?: number | null | undefined, slug: ProductSlug, price: number, cost: number, taxAmount: number }> };

export type PaymentOptionsV2QueryVariables = Exact<{
  input: PaymentOptionsV2Input;
}>;


export type PaymentOptionsV2Query = { __typename?: 'Query', paymentOptionsV2: { __typename?: 'paymentOptionsV2', dealId: number, selectedPackageSlotIndex?: number | null | undefined, vscPlusGap: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined }, vsc: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined }, gap: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined }, noProducts: { __typename?: 'paymentOptionsGQLTypes', name: string, amountFinanced?: number | null | undefined, buyPayment?: number | null | undefined, sellPayment?: number | null | undefined, profit?: number | null | undefined, setterCommission?: number | null | undefined, closerCommission?: number | null | undefined, reserve?: number | null | undefined }, packages: Array<{ __typename?: 'PaymentOptionsPackageV2', slotIndex: number, selectedProductSlugs: Array<ProductSlug>, legacyOptionType: string, isSelected: boolean, amountFinanced: number, buyPayment: number, sellPayment: number, profit: number, setterCommission: number, closerCommission: number, reserve: number, products: Array<{ __typename?: 'PaymentOptionsPackageProductV2', productCatalogId?: number | null | undefined, slug: ProductSlug, price: number, cost: number, taxAmount: number }> }> } };

export type PayoffFragmentFragment = { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, account_number?: string | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, good_through_date?: any | null | undefined, lease_term?: number | null | undefined, remaining_payments?: number | null | undefined, msrp?: number | null | undefined, residual_percentage?: number | null | undefined, sales_price?: number | null | undefined, cap_reduction?: number | null | undefined, money_down?: number | null | undefined, money_factor?: number | null | undefined, termination_fees?: number | null | undefined, cap_cost?: number | null | undefined, residual_amount?: number | null | undefined, estimated_payoff?: number | null | undefined, old_lease_payment?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined, user_entered_total_payoff?: number | null | undefined, maturity_date?: any | null | undefined };

export type PayoffUpdateMutationVariables = Exact<{
  dealId: Scalars['ID'];
  payoff: PayoffInput;
}>;


export type PayoffUpdateMutation = { __typename?: 'RootMutationType', payoffUpdate?: { __typename?: 'payoff', id?: number | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined, account_number?: string | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, good_through_date?: any | null | undefined, lease_term?: number | null | undefined, remaining_payments?: number | null | undefined, msrp?: number | null | undefined, residual_percentage?: number | null | undefined, sales_price?: number | null | undefined, cap_reduction?: number | null | undefined, money_down?: number | null | undefined, money_factor?: number | null | undefined, termination_fees?: number | null | undefined, cap_cost?: number | null | undefined, residual_amount?: number | null | undefined, estimated_payoff?: number | null | undefined, old_lease_payment?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, next_payment_date?: any | null | undefined, user_entered_total_payoff?: number | null | undefined, maturity_date?: any | null | undefined } | null | undefined };

export type PayoffRequestPopulatedFragmentFragment = { __typename?: 'payoffRequestPopulated', id?: number | null | undefined, created_at?: any | null | undefined, deal_id?: number | null | undefined, temporary_info_id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax?: number | null | undefined, completed_date?: any | null | undefined, good_through_date?: any | null | undefined, fail_reason?: any | null | undefined, payoff_clerk_id?: string | null | undefined, needs_payoff_documents?: boolean | null | undefined, payoff_documents_uploaded?: boolean | null | undefined, is_payoff_intelligence?: boolean | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, closer_id?: number | null | undefined, created_at?: any | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, account_number?: string | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, city?: string | null | undefined, county?: string | null | undefined, zip?: string | null | undefined, state?: string | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, buyer_not_lessee?: boolean | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, temporary_info?: { __typename?: 'temporaryInfo', id?: number | null | undefined, data: { __typename?: 'temporaryData', state?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, lh_account_number?: string | null | undefined, lienholder?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, zip?: string | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined } } | null | undefined, payoff_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, requestor?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined };

export type CheckSupportedLienholderQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['Int']>;
  lienholderSlug?: InputMaybe<Scalars['String']>;
}>;


export type CheckSupportedLienholderQuery = { __typename?: 'Query', checkSupportedLienholder: { __typename?: 'SupportedLienholderResponse', isSupported: boolean, requirementsMet: boolean, requiredFields: Array<LienholderRequirement>, missingRequiredFields: Array<LienholderRequirement> } };

export type PayoffDashboardDealsQueryVariables = Exact<{ [key: string]: never; }>;


export type PayoffDashboardDealsQuery = { __typename?: 'Query', payoffDashboardDeals?: { __typename?: 'payoffDashboard', payoffRequests?: Array<{ __typename?: 'payoffRequestPopulated', id?: number | null | undefined, created_at?: any | null | undefined, deal_id?: number | null | undefined, temporary_info_id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax?: number | null | undefined, completed_date?: any | null | undefined, good_through_date?: any | null | undefined, fail_reason?: any | null | undefined, payoff_clerk_id?: string | null | undefined, needs_payoff_documents?: boolean | null | undefined, payoff_documents_uploaded?: boolean | null | undefined, is_payoff_intelligence?: boolean | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, closer_id?: number | null | undefined, created_at?: any | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, account_number?: string | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, city?: string | null | undefined, county?: string | null | undefined, zip?: string | null | undefined, state?: string | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, buyer_not_lessee?: boolean | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, temporary_info?: { __typename?: 'temporaryInfo', id?: number | null | undefined, data: { __typename?: 'temporaryData', state?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, lh_account_number?: string | null | undefined, lienholder?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, zip?: string | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined } } | null | undefined, payoff_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, requestor?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PayoffRequestQueryVariables = Exact<{
  deal_id?: InputMaybe<Scalars['ID']>;
}>;


export type PayoffRequestQuery = { __typename?: 'Query', payoffRequest?: { __typename?: 'payoffRequest', id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined } | null | undefined };

export type AcquirePayoffForDealMutationVariables = Exact<{
  dealId: Scalars['Int'];
  payloadFields: Array<Scalars['String']> | Scalars['String'];
}>;


export type AcquirePayoffForDealMutation = { __typename?: 'RootMutationType', acquirePayoffForDeal: { __typename?: 'AcquirePayoffResponse', received: boolean } };

export type PayoffRequestConfirmMutationVariables = Exact<{
  payoffRequest: PayoffRequestConfirmInput;
}>;


export type PayoffRequestConfirmMutation = { __typename?: 'RootMutationType', payoffRequestConfirm?: { __typename?: 'payoffRequest', id?: number | null | undefined, vehicle_payoff?: number | null | undefined, good_through_date?: any | null | undefined } | null | undefined };

export type PayoffRequestUpdateMutationVariables = Exact<{
  payoffRequest: PayoffRequestInput;
}>;


export type PayoffRequestUpdateMutation = { __typename?: 'RootMutationType', payoffRequestUpdate?: { __typename?: 'payoffRequest', id?: number | null | undefined } | null | undefined };

export type UpdatePayoffClerkMutationVariables = Exact<{
  payoff_request_id?: InputMaybe<Scalars['ID']>;
  payoff_clerk_id?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePayoffClerkMutation = { __typename?: 'RootMutationType', updatePayoffClerk?: boolean | null | undefined };

export type PayoffRequestFailureRequestMutationVariables = Exact<{
  payoffRequest: PayoffRequestInput;
}>;


export type PayoffRequestFailureRequestMutation = { __typename?: 'RootMutationType', payoffRequestFailureRequest?: { __typename?: 'payoffRequest', id?: number | null | undefined, fail_reason?: any | null | undefined } | null | undefined };

export type PayoffRequestFailMutationVariables = Exact<{
  payoffRequest: PayoffRequestInput;
}>;


export type PayoffRequestFailMutation = { __typename?: 'RootMutationType', payoffRequestFail?: { __typename?: 'payoffRequest', id?: number | null | undefined, fail_reason?: any | null | undefined } | null | undefined };

export type CreatePayoffRequestMutationVariables = Exact<{
  dealId: Scalars['ID'];
  digitalPayoffAvailable: Scalars['Boolean'];
  doubleTaxApplicable: Scalars['Boolean'];
}>;


export type CreatePayoffRequestMutation = { __typename?: 'RootMutationType', createPayoffRequest?: { __typename?: 'payoffRequest', deal_id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax?: number | null | undefined, completed_date?: any | null | undefined, good_through_date?: any | null | undefined } | null | undefined };

export type PayoffRequestCancelMutationVariables = Exact<{
  payoffRequestId: Scalars['ID'];
}>;


export type PayoffRequestCancelMutation = { __typename?: 'RootMutationType', payoffRequestCancel?: { __typename?: 'payoffRequest', id?: number | null | undefined } | null | undefined };

export type OnPayoffRequestUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPayoffRequestUpdateSubscription = { __typename?: 'RootSubscriptionType', onPayoffRequestUpdate?: { __typename?: 'payoffRequestPopulated', id?: number | null | undefined, created_at?: any | null | undefined, deal_id?: number | null | undefined, temporary_info_id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax?: number | null | undefined, completed_date?: any | null | undefined, good_through_date?: any | null | undefined, fail_reason?: any | null | undefined, payoff_clerk_id?: string | null | undefined, needs_payoff_documents?: boolean | null | undefined, payoff_documents_uploaded?: boolean | null | undefined, is_payoff_intelligence?: boolean | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, closer_id?: number | null | undefined, created_at?: any | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, account_number?: string | null | undefined, lienholder_name?: string | null | undefined, lienholder_slug?: string | null | undefined, lender_name?: string | null | undefined } | null | undefined } | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, home_phone_number?: string | null | undefined, address?: { __typename?: 'address', id?: number | null | undefined, city?: string | null | undefined, county?: string | null | undefined, zip?: string | null | undefined, state?: string | null | undefined } | null | undefined } | null | undefined, financial_info?: { __typename?: 'financialInfo', id?: number | null | undefined, buyer_not_lessee?: boolean | null | undefined } | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, temporary_info?: { __typename?: 'temporaryInfo', id?: number | null | undefined, data: { __typename?: 'temporaryData', state?: string | null | undefined, city?: string | null | undefined, county?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined, mileage?: number | null | undefined, lh_account_number?: string | null | undefined, lienholder?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, ssn_id?: number | null | undefined, dob?: any | null | undefined, phone_number?: string | null | undefined, zip?: string | null | undefined, vehicle_type?: string | null | undefined, fuel_type?: string | null | undefined } } | null | undefined, payoff_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, requestor?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined };

export type OnPayoffRequestStatusUpdateSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
}>;


export type OnPayoffRequestStatusUpdateSubscription = { __typename?: 'RootSubscriptionType', onPayoffRequestStatusUpdate?: { __typename?: 'payoffRequestStatusUpdateWithMessage', message?: string | null | undefined, payoffRequest: { __typename?: 'payoffRequestStatusUpdate', id?: number | null | undefined, deal_id?: number | null | undefined, temporary_info_id?: number | null | undefined, status?: PayoffRequestStatus | null | undefined, vehicle_payoff?: number | null | undefined, good_through_date?: any | null | undefined, sales_tax?: number | null | undefined, completed_date?: any | null | undefined, fail_reason?: any | null | undefined, created_at?: any | null | undefined, updated_at?: any | null | undefined, deal?: { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, payoff?: { __typename?: 'payoff', id?: number | null | undefined, verification_status?: PayoffVerificationStatus | null | undefined, user_entered_total_payoff?: number | null | undefined, vehicle_payoff?: number | null | undefined, sales_tax_from_payoff?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, sales_tax_from_payoff_entered_manually?: boolean | null | undefined, good_through_date?: any | null | undefined } | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean }> | null | undefined } | null | undefined } } | null | undefined };

export type PodsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  pod_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  team_type?: InputMaybe<Array<InputMaybe<TeamType>> | InputMaybe<TeamType>>;
  includeDetails?: InputMaybe<Scalars['Boolean']>;
  hideArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type PodsQuery = { __typename?: 'Query', pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined, hours?: string | null | undefined, archived?: boolean | null | undefined, team_type?: TeamType | null | undefined, created_at?: any | null | undefined, manager_commission_rate?: number | null | undefined, manager_commission_type?: CommissionType | null | undefined, special_commission_rate?: number | null | undefined, special_commission_type?: CommissionType | null | undefined, closer_commission_rate?: number | null | undefined, closer_commission_type?: CommissionType | null | undefined, setter_commission_rate?: number | null | undefined, setter_commission_type?: CommissionType | null | undefined, auto_assign_deals?: boolean | null | undefined, pause_auto_assign?: boolean | null | undefined, assign_overnight_deals?: boolean | null | undefined, active_reps_override?: number | null | undefined, active_reps_override_set_at?: any | null | undefined, problem_solver?: boolean | null | undefined, parent_pod_id?: number | null | undefined, managers?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, leads?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, fundingClerks?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, us_states_object?: { __typename?: 'usStatesObject', states?: Array<StateAbbreviation | null | undefined> | null | undefined } | null | undefined, pod_users?: Array<{ __typename?: 'podUser', id?: number | null | undefined, user_id?: string | null | undefined, pod_id?: number | null | undefined, team_role?: TeamRole | null | undefined, user?: { __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, parent_pod?: { __typename?: 'basePod', id?: number | null | undefined, name?: string | null | undefined } | null | undefined, child_pods?: Array<{ __typename?: 'basePod', id?: number | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, usersWithoutTeamRole?: Array<{ __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type PodUpsertAndPodUsersUpdateMutationVariables = Exact<{
  newPod: PodInput;
  oldPod?: InputMaybe<PodInput>;
}>;


export type PodUpsertAndPodUsersUpdateMutation = { __typename?: 'RootMutationType', podUpsertAndPodUsersUpdate?: { __typename?: 'basePod', id?: number | null | undefined } | null | undefined };

export type PodUpsertMutationVariables = Exact<{
  pod?: InputMaybe<BasePodInput>;
}>;


export type PodUpsertMutation = { __typename?: 'RootMutationType', podUpsert?: { __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined, hours?: string | null | undefined, archived?: boolean | null | undefined, closer_commission_rate?: number | null | undefined, team_type?: TeamType | null | undefined, problem_solver?: boolean | null | undefined, us_states_object?: { __typename?: 'usStatesObject', states?: Array<StateAbbreviation | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type ArchivePodMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type ArchivePodMutation = { __typename?: 'RootMutationType', archivePod?: any | null | undefined };

export type TitlingPodsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type TitlingPodsAllQuery = { __typename?: 'Query', titlingPodsAll?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined, problem_solver?: boolean | null | undefined, archived?: boolean | null | undefined, us_states_object?: { __typename?: 'usStatesObject', states?: Array<StateAbbreviation | null | undefined> | null | undefined } | null | undefined, pod_users?: Array<{ __typename?: 'podUser', id?: number | null | undefined, user_id?: string | null | undefined, pod_id?: number | null | undefined, team_role?: TeamRole | null | undefined, user?: { __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type PrequalificationRequestFragmentFragment = { __typename?: 'PrequalificationRequest', first_name?: string | null | undefined, last_name?: string | null | undefined, zip?: string | null | undefined, gross_income?: number | null | undefined, pay_frequency?: string | null | undefined, vehicle_payoff?: number | null | undefined, lending_book_value?: number | null | undefined, money_down?: number | null | undefined, income_sources?: number | null | undefined };

export type PrequalificationFragmentFragment = { __typename?: 'prequalification', id?: number | null | undefined, credit_score?: number | null | undefined, ltv?: number | null | undefined, payment_to_income?: number | null | undefined, dti?: number | null | undefined, customer_id?: number | null | undefined, credit_score_tier?: CreditScoreTierEnumType | null | undefined, input?: { __typename?: 'PrequalificationRequest', first_name?: string | null | undefined, last_name?: string | null | undefined, zip?: string | null | undefined, gross_income?: number | null | undefined, pay_frequency?: string | null | undefined, vehicle_payoff?: number | null | undefined, lending_book_value?: number | null | undefined, money_down?: number | null | undefined, income_sources?: number | null | undefined } | null | undefined, output?: { __typename?: 'ExperianOutput', errors?: Array<string> | null | undefined } | null | undefined };

export type PrequalificationCreditReportNameFragmentFragment = { __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined };

export type PrequalificationCreditReportTradelineFragmentFragment = { __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined };

export type PrequalificationCreditReportFragmentFragment = { __typename?: 'PrequalificationCreditReport', informationalMessages?: Array<string> | null | undefined, names?: { __typename?: 'PrequalificationCreditReportNames', customerName?: { __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined, aliases: Array<{ __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined> } | null | undefined, addresses?: Array<{ __typename?: 'PrequalificationCreditReportAddress', city?: string | null | undefined, state?: string | null | undefined, zipCode?: string | null | undefined, streetName?: string | null | undefined, streetPrefix?: string | null | undefined, streetSuffix?: string | null | undefined, firstReportedDate?: string | null | undefined }> | null | undefined, employments?: Array<{ __typename?: 'PrequalificationCreditReportEmployment', addressExtraLine?: string | null | undefined, addressFirstLine?: string | null | undefined, addressSecondLine?: string | null | undefined, firstReportedDate?: string | null | undefined, lastUpdatedDate?: string | null | undefined, name?: string | null | undefined, source?: string | null | undefined, zipCode?: string | null | undefined }> | null | undefined, scoreFactors?: Array<{ __typename?: 'PrequalificationCreditScoreScoreFactor', code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, tradelines?: { __typename?: 'PrequalificationCreditReportTradelines', revolving: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, installment: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, unknown: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }> } | null | undefined };

export type GetDdSoftPullQueryVariables = Exact<{
  dealId: Scalars['ID'];
  paymentEstimateInput: PaymentEstimateInput;
  shouldForceRetry?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDdSoftPullQuery = { __typename?: 'Query', getDDSoftPull: { __typename?: 'DDSoftPull', customer: { __typename?: 'prequalification', id?: number | null | undefined, credit_score?: number | null | undefined, ltv?: number | null | undefined, payment_to_income?: number | null | undefined, dti?: number | null | undefined, customer_id?: number | null | undefined, credit_score_tier?: CreditScoreTierEnumType | null | undefined, input?: { __typename?: 'PrequalificationRequest', first_name?: string | null | undefined, last_name?: string | null | undefined, zip?: string | null | undefined, gross_income?: number | null | undefined, pay_frequency?: string | null | undefined, vehicle_payoff?: number | null | undefined, lending_book_value?: number | null | undefined, money_down?: number | null | undefined, income_sources?: number | null | undefined } | null | undefined, output?: { __typename?: 'ExperianOutput', errors?: Array<string> | null | undefined } | null | undefined }, cobuyer?: { __typename?: 'prequalification', id?: number | null | undefined, credit_score?: number | null | undefined, ltv?: number | null | undefined, payment_to_income?: number | null | undefined, dti?: number | null | undefined, customer_id?: number | null | undefined, credit_score_tier?: CreditScoreTierEnumType | null | undefined, input?: { __typename?: 'PrequalificationRequest', first_name?: string | null | undefined, last_name?: string | null | undefined, zip?: string | null | undefined, gross_income?: number | null | undefined, pay_frequency?: string | null | undefined, vehicle_payoff?: number | null | undefined, lending_book_value?: number | null | undefined, money_down?: number | null | undefined, income_sources?: number | null | undefined } | null | undefined, output?: { __typename?: 'ExperianOutput', errors?: Array<string> | null | undefined } | null | undefined } | null | undefined } };

export type ExperianCreditReportQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type ExperianCreditReportQuery = { __typename?: 'Query', experianCreditReport?: { __typename?: 'PrequalificationCreditReports', customer: { __typename?: 'PrequalificationCreditReport', informationalMessages?: Array<string> | null | undefined, names?: { __typename?: 'PrequalificationCreditReportNames', customerName?: { __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined, aliases: Array<{ __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined> } | null | undefined, addresses?: Array<{ __typename?: 'PrequalificationCreditReportAddress', city?: string | null | undefined, state?: string | null | undefined, zipCode?: string | null | undefined, streetName?: string | null | undefined, streetPrefix?: string | null | undefined, streetSuffix?: string | null | undefined, firstReportedDate?: string | null | undefined }> | null | undefined, employments?: Array<{ __typename?: 'PrequalificationCreditReportEmployment', addressExtraLine?: string | null | undefined, addressFirstLine?: string | null | undefined, addressSecondLine?: string | null | undefined, firstReportedDate?: string | null | undefined, lastUpdatedDate?: string | null | undefined, name?: string | null | undefined, source?: string | null | undefined, zipCode?: string | null | undefined }> | null | undefined, scoreFactors?: Array<{ __typename?: 'PrequalificationCreditScoreScoreFactor', code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, tradelines?: { __typename?: 'PrequalificationCreditReportTradelines', revolving: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, installment: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, unknown: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }> } | null | undefined }, cobuyer?: { __typename?: 'PrequalificationCreditReport', informationalMessages?: Array<string> | null | undefined, names?: { __typename?: 'PrequalificationCreditReportNames', customerName?: { __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined, aliases: Array<{ __typename?: 'PrequalificationCreditReportName', firstName: string, middleName?: string | null | undefined, surname: string, secondSurname?: string | null | undefined, generationCode?: string | null | undefined } | null | undefined> } | null | undefined, addresses?: Array<{ __typename?: 'PrequalificationCreditReportAddress', city?: string | null | undefined, state?: string | null | undefined, zipCode?: string | null | undefined, streetName?: string | null | undefined, streetPrefix?: string | null | undefined, streetSuffix?: string | null | undefined, firstReportedDate?: string | null | undefined }> | null | undefined, employments?: Array<{ __typename?: 'PrequalificationCreditReportEmployment', addressExtraLine?: string | null | undefined, addressFirstLine?: string | null | undefined, addressSecondLine?: string | null | undefined, firstReportedDate?: string | null | undefined, lastUpdatedDate?: string | null | undefined, name?: string | null | undefined, source?: string | null | undefined, zipCode?: string | null | undefined }> | null | undefined, scoreFactors?: Array<{ __typename?: 'PrequalificationCreditScoreScoreFactor', code?: string | null | undefined, description?: string | null | undefined }> | null | undefined, tradelines?: { __typename?: 'PrequalificationCreditReportTradelines', revolving: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, installment: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }>, unknown: Array<{ __typename?: 'PrequalificationCreditReportTradeline', subscriberName?: string | null | undefined, accountNumber?: string | null | undefined, kob?: string | null | undefined, status?: string | null | undefined, accountType?: string | null | undefined, openDate?: string | null | undefined, balanceDate?: string | null | undefined, amount1?: string | null | undefined, amount1Qualifier?: string | null | undefined, amount2?: string | null | undefined, amount2Qualifier?: string | null | undefined, amountPastDue?: string | null | undefined, balanceAmount?: string | null | undefined, openOrClosed?: string | null | undefined, ecoa?: string | null | undefined, monthlyPaymentAmount?: string | null | undefined, monthsHistory?: string | null | undefined, terms?: string | null | undefined, delinquency30Days?: string | null | undefined, delinquency60Days?: string | null | undefined, delinquency90to180Days?: string | null | undefined, paymentHistory?: string | null | undefined }> } | null | undefined } | null | undefined } | null | undefined };

export type RateFragmentFragment = { __typename?: 'rate', form_id?: number | null | undefined, session_id?: string | null | undefined, coverage_name?: string | null | undefined, term_miles?: string | null | undefined, term_months?: string | null | undefined, deductible?: { __typename?: 'deductible', rate_id?: number | null | undefined, amount?: string | null | undefined, dealer_cost?: string | null | undefined, deductible_type?: string | null | undefined, f_i_markup?: string | null | undefined, max_retail_price?: string | null | undefined, min_retail_price?: string | null | undefined, retail_price?: string | null | undefined } | null | undefined };

export type VscRatesQueryVariables = Exact<{
  bank: Scalars['String'];
  deal_id: Scalars['ID'];
  data?: InputMaybe<RateInput>;
}>;


export type VscRatesQuery = { __typename?: 'Query', vscRates?: Array<{ __typename?: 'rate', form_id?: number | null | undefined, session_id?: string | null | undefined, coverage_name?: string | null | undefined, term_miles?: string | null | undefined, term_months?: string | null | undefined, deductible?: { __typename?: 'deductible', rate_id?: number | null | undefined, amount?: string | null | undefined, dealer_cost?: string | null | undefined, deductible_type?: string | null | undefined, f_i_markup?: string | null | undefined, max_retail_price?: string | null | undefined, min_retail_price?: string | null | undefined, retail_price?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GapRatesQueryVariables = Exact<{
  bank: Scalars['String'];
  deal_id: Scalars['ID'];
  data?: InputMaybe<RateInput>;
}>;


export type GapRatesQuery = { __typename?: 'Query', gapRates?: Array<{ __typename?: 'rate', form_id?: number | null | undefined, session_id?: string | null | undefined, coverage_name?: string | null | undefined, term_miles?: string | null | undefined, term_months?: string | null | undefined, deductible?: { __typename?: 'deductible', rate_id?: number | null | undefined, amount?: string | null | undefined, dealer_cost?: string | null | undefined, deductible_type?: string | null | undefined, f_i_markup?: string | null | undefined, max_retail_price?: string | null | undefined, min_retail_price?: string | null | undefined, retail_price?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type TireWheelRatesQueryVariables = Exact<{
  bank: Scalars['String'];
  deal_id: Scalars['ID'];
  data?: InputMaybe<RateInput>;
}>;


export type TireWheelRatesQuery = { __typename?: 'Query', tireWheelRates?: Array<{ __typename?: 'rate', form_id?: number | null | undefined, session_id?: string | null | undefined, coverage_name?: string | null | undefined, term_miles?: string | null | undefined, term_months?: string | null | undefined, deductible?: { __typename?: 'deductible', rate_id?: number | null | undefined, amount?: string | null | undefined, dealer_cost?: string | null | undefined, deductible_type?: string | null | undefined, f_i_markup?: string | null | undefined, max_retail_price?: string | null | undefined, min_retail_price?: string | null | undefined, retail_price?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type KeyReplacementRatesQueryVariables = Exact<{
  bank: Scalars['String'];
  deal_id: Scalars['ID'];
  data?: InputMaybe<RateInput>;
}>;


export type KeyReplacementRatesQuery = { __typename?: 'Query', keyReplacementRates?: Array<{ __typename?: 'rate', form_id?: number | null | undefined, session_id?: string | null | undefined, coverage_name?: string | null | undefined, term_miles?: string | null | undefined, term_months?: string | null | undefined, deductible?: { __typename?: 'deductible', rate_id?: number | null | undefined, amount?: string | null | undefined, dealer_cost?: string | null | undefined, deductible_type?: string | null | undefined, f_i_markup?: string | null | undefined, max_retail_price?: string | null | undefined, min_retail_price?: string | null | undefined, retail_price?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type ProductsCatalogV2QueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsCatalogV2Query = { __typename?: 'Query', productsCatalogV2: Array<{ __typename?: 'ProductCatalogV2', id: number, slug: ProductSlug, name: string, is_user_selectable: boolean, display_order: number, is_active: boolean, base_price: number, base_cost: number, bonus_amount: number, metadata?: any | null | undefined }> };

export type CreateReviewMutationVariables = Exact<{
  review?: InputMaybe<ReviewInput>;
}>;


export type CreateReviewMutation = { __typename?: 'RootMutationType', createReview?: { __typename?: 'review', id?: number | null | undefined } | null | undefined };

export type ReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewsQuery = { __typename?: 'Query', reviews?: Array<{ __typename?: 'review', id?: number | null | undefined, customer_name?: string | null | undefined, review?: string | null | undefined, com_visible?: boolean | null | undefined, created_at?: any | null | undefined, location?: string | null | undefined } | null | undefined> | null | undefined };

export type DeleteReviewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReviewMutation = { __typename?: 'RootMutationType', deleteReview?: { __typename?: 'review', id?: number | null | undefined } | null | undefined };

export type UpdateReviewMutationVariables = Exact<{
  review?: InputMaybe<ReviewInput>;
}>;


export type UpdateReviewMutation = { __typename?: 'RootMutationType', updateReview?: { __typename?: 'review', id?: number | null | undefined, customer_name?: string | null | undefined, review?: string | null | undefined, com_visible?: boolean | null | undefined, created_at?: any | null | undefined, location?: string | null | undefined } | null | undefined };

export type SecureLinkNotificationFragmentFragment = { __typename?: 'SecureLinkNotification', reason: SecureLinkNotificationReason, deal_id: number, customer_id: number, first_name: string, last_name: string };

export type CreateAndSendSecureLinkMutationVariables = Exact<{
  customerId: Scalars['ID'];
  expiresInHours: Scalars['Int'];
  sendText: Scalars['Boolean'];
  sendEmail: Scalars['Boolean'];
}>;


export type CreateAndSendSecureLinkMutation = { __typename?: 'RootMutationType', createAndSendSecureLink?: { __typename?: 'CreateAndSendSecureLinkResult', success: boolean, textError?: string | null | undefined, emailError?: string | null | undefined } | null | undefined };

export type UnlockDealMutationVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type UnlockDealMutation = { __typename?: 'RootMutationType', unlockDeal?: boolean | null | undefined };

export type OnSecureLinkCreatedSubscriptionVariables = Exact<{
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OnSecureLinkCreatedSubscription = { __typename?: 'RootSubscriptionType', onSecureLinkCreated?: { __typename?: 'SecureLinkNotification', reason: SecureLinkNotificationReason, deal_id: number, customer_id: number, first_name: string, last_name: string } | null | undefined };

export type OnSecureLinkExpiredSubscriptionVariables = Exact<{
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OnSecureLinkExpiredSubscription = { __typename?: 'RootSubscriptionType', onSecureLinkExpired?: { __typename?: 'SecureLinkNotification', reason: SecureLinkNotificationReason, deal_id: number, customer_id: number, first_name: string, last_name: string } | null | undefined };

export type DecryptSsnMutationVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  tempInfoId?: InputMaybe<Scalars['ID']>;
  originalLesseeId?: InputMaybe<Scalars['ID']>;
}>;


export type DecryptSsnMutation = { __typename?: 'RootMutationType', decryptSSN?: { __typename?: 'decryptedSSN', ssn?: string | null | undefined, ssnId?: number | null | undefined } | null | undefined };

export type UpdateSsnMutationVariables = Exact<{
  ssnId?: InputMaybe<Scalars['ID']>;
  ssn: Scalars['String'];
}>;


export type UpdateSsnMutation = { __typename?: 'RootMutationType', updateSSN?: number | null | undefined };

export type ComparePrequalSocialsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  cobuyerId?: InputMaybe<Scalars['ID']>;
}>;


export type ComparePrequalSocialsQuery = { __typename?: 'Query', comparePrequalSocials?: { __typename?: 'ComparePrequalSocials', customerMatches?: boolean | null | undefined, cobuyerMatches?: boolean | null | undefined } | null | undefined };

export type StructuringFollowUpFragmentFragment = { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined };

export type StructuringFollowUpDealFragmentFragment = { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, structuring_manager_id?: number | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_follow_up?: { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, color: string, display_name: string, is_dashboard_visible: boolean }> | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, type?: FollowUpTypeEnum | null | undefined, status?: FollowUpStatusEnum | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined } | null | undefined };

export type StructuringFollowUpQueryVariables = Exact<{
  dealId: Scalars['ID'];
}>;


export type StructuringFollowUpQuery = { __typename?: 'Query', structuringFollowUp?: { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined } | null | undefined };

export type StructuringFollowUpDealsQueryVariables = Exact<{
  sortColumn: StructuringFollowUpSortColumn;
  sortDirection: SortDirection;
  sources: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  dealTypes: Array<InputMaybe<DealType>> | InputMaybe<DealType>;
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  bootRequested?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  showActiveTags?: InputMaybe<Scalars['Boolean']>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']>;
}>;


export type StructuringFollowUpDealsQuery = { __typename?: 'Query', structuringFollowUpDeals?: { __typename?: 'PaginatedDeals', totalRecords?: number | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, structuring_manager_id?: number | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_follow_up?: { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, color: string, display_name: string, is_dashboard_visible: boolean }> | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, type?: FollowUpTypeEnum | null | undefined, status?: FollowUpStatusEnum | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateStructuringFollowUpMutationVariables = Exact<{
  dealId: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type CreateStructuringFollowUpMutation = { __typename?: 'RootMutationType', createStructuringFollowUp?: boolean | null | undefined };

export type UpdateStructuringFollowUpNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type UpdateStructuringFollowUpNotesMutation = { __typename?: 'RootMutationType', updateStructuringFollowUpNotes?: boolean | null | undefined };

export type DeleteStructuringFollowUpMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStructuringFollowUpMutation = { __typename?: 'RootMutationType', deleteStructuringFollowUp?: boolean | null | undefined };

export type OnStructuringFollowUpUpdateSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  types?: InputMaybe<Array<InputMaybe<DealType>> | InputMaybe<DealType>>;
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type OnStructuringFollowUpUpdateSubscription = { __typename?: 'RootSubscriptionType', onStructuringFollowUpUpdate?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, type?: DealType | null | undefined, source?: string | null | undefined, structuring_manager_id?: number | null | undefined, customer?: { __typename?: 'customer', id?: number | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined, setter?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_manager?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, structuring_follow_up?: { __typename?: 'StructuringFollowUp', id?: number | null | undefined, created_at?: any | null | undefined, status?: StructuringFollowUpStatus | null | undefined, creator_id?: number | null | undefined, notes?: string | null | undefined } | null | undefined, tags?: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, color: string, display_name: string, is_dashboard_visible: boolean }> | null | undefined, notifications?: Array<{ __typename?: 'notification', id?: number | null | undefined, message?: string | null | undefined, customer_id?: number | null | undefined, deal_contact_id?: number | null | undefined, original_lessee_id?: number | null | undefined, created_at?: any | null | undefined, users?: Array<{ __typename?: 'NotificationUser', id?: number | null | undefined, user_id?: string | null | undefined, seen_at?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, follow_up?: { __typename?: 'followUp', id?: number | null | undefined, type?: FollowUpTypeEnum | null | undefined, status?: FollowUpStatusEnum | null | undefined, date_utc?: any | null | undefined, note?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type TagFragmentFragment = { __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean };

export type TagsQueryVariables = Exact<{
  input?: InputMaybe<TagsInput>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean }> };

export type OnTagsCreatedSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
}>;


export type OnTagsCreatedSubscription = { __typename?: 'RootSubscriptionType', onTagsCreated?: { __typename?: 'TagsPayload', dealId: number, tags: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean }> } | null | undefined };

export type OnTagsDeletedSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']>;
}>;


export type OnTagsDeletedSubscription = { __typename?: 'RootSubscriptionType', onTagsDeleted?: { __typename?: 'TagsPayload', dealId: number, tags: Array<{ __typename?: 'Tag', id: number, badge_variant?: number | null | undefined, slug: TagSlugEnum, display_name: string, color: string, is_active: boolean, is_dashboard_visible: boolean }> } | null | undefined };

export type JurisdictionQueryVariables = Exact<{
  state: StateAbbreviation;
  county?: InputMaybe<Scalars['String']>;
  types: Array<TtProductType> | TtProductType;
  conditions?: InputMaybe<TtConditionFilterInput>;
}>;


export type JurisdictionQuery = { __typename?: 'Query', jurisdiction?: { __typename?: 'TTJurisdiction', id?: number | null | undefined, hasRegistrationOnly?: boolean | null | undefined, hasTitleOnly?: boolean | null | undefined, hasTitleAndRegistration?: boolean | null | undefined, allowRegistrationTransfer?: boolean | null | undefined, allowPlateTransfer?: boolean | null | undefined, requireWalkIn?: boolean | null | undefined, supportedProcessors?: Array<Processor | null | undefined> | null | undefined, products?: { __typename?: 'TTTTProductFieldsConnection', items?: Array<{ __typename?: 'TTProductFields', id?: number | null | undefined, type?: TtProductType | null | undefined, documents?: { __typename?: 'TTTTDocumentFieldsConnection', count?: number | null | undefined, items?: Array<{ __typename?: 'TTDocumentFields', type?: { __typename?: 'TTDocumentTypeFields', id?: number | null | undefined, name?: string | null | undefined } | null | undefined, validations?: Array<{ __typename?: 'TTValidation', internalDescription?: string | null | undefined, description?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, validations?: Array<{ __typename?: 'TTValidation', name?: string | null | undefined, description?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type GetFeesQueryVariables = Exact<{
  uniqueId?: InputMaybe<Scalars['String']>;
  state: StateAbbreviation;
  previouslyTitledState: StateAbbreviation;
  city: Scalars['String'];
  county: Scalars['String'];
  zip: Scalars['String'];
  vin: Scalars['String'];
  make: Scalars['String'];
  model: Scalars['String'];
  year: Scalars['Int'];
  vehicleType: TtVehicleType;
  fuelType: TtFuelType;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  retailBookValue: Scalars['Float'];
  bookValue: Scalars['Float'];
  docFee: Scalars['Float'];
  payoff: Scalars['Float'];
  estimatedPayoff: Scalars['Float'];
  ssn: Scalars['String'];
  warranty: Scalars['Float'];
  financialInfoId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type GetFeesQuery = { __typename?: 'Query', getFees?: { __typename?: 'FeeGQL', state?: StateAbbreviation | null | undefined, totalFeeAmount?: number | null | undefined, salesTaxRate?: number | null | undefined, baseTaxAmount?: number | null | undefined, warrantyTaxAmount?: number | null | undefined, taxProcessor?: string | null | undefined, feeProcessor?: string | null | undefined, docFeeTaxAmount?: number | null | undefined, registrationTransferFee?: number | null | undefined } | null | undefined };

export type UploadDocumentMutationVariables = Exact<{
  bytes: Scalars['String'];
  documentType: TtDocumentName;
}>;


export type UploadDocumentMutation = { __typename?: 'RootMutationType', uploadDocument?: { __typename?: 'ExtractedDocumentGQL', documentName?: number | null | undefined, key?: string | null | undefined, fields?: Array<{ __typename?: 'ExtractedField', confidence?: number | null | undefined, name?: string | null | undefined, value?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UploadDriversLicenseMutationVariables = Exact<{
  bytes: Scalars['String'];
  includeGender?: InputMaybe<Scalars['Boolean']>;
}>;


export type UploadDriversLicenseMutation = { __typename?: 'RootMutationType', uploadDriversLicense?: { __typename?: 'DriversLicenseGQL', firstName?: string | null | undefined, middleName?: string | null | undefined, lastName?: string | null | undefined, address?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, expirationDate?: any | null | undefined, sex?: string | null | undefined, documentNumber?: string | null | undefined } | null | undefined };

export type CreateTransactionMutationVariables = Exact<{
  input: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'RootMutationType', createTransaction?: number | null | undefined };

export type TemporaryInfoFragmentFragment = { __typename?: 'temporaryInfo', id?: number | null | undefined, data: { __typename?: 'temporaryData', vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, fuel_type?: string | null | undefined, vehicle_type?: string | null | undefined, color?: string | null | undefined, mileage?: number | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, lienholder?: string | null | undefined, lienholderLogo?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, address_line?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, previous_address_line?: string | null | undefined, previous_city?: string | null | undefined, previous_state?: string | null | undefined, previous_zip?: string | null | undefined, scheduled_call_datetime?: any | null | undefined, scheduled_call_datetime_tz?: string | null | undefined, primary_residence_type?: string | null | undefined, primary_residence_years?: number | null | undefined, primary_residence_months?: number | null | undefined, primary_residence_monthly_payment?: number | null | undefined, secondary_residence_years?: number | null | undefined, secondary_residence_months?: number | null | undefined, dob?: any | null | undefined, ssn_id?: number | null | undefined, good_through_date?: any | null | undefined, employer_name?: string | null | undefined, job_title?: string | null | undefined, employer_phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, salary?: number | null | undefined, previous_employer_name?: string | null | undefined, previous_job_title?: string | null | undefined, previous_employer_phone_number?: string | null | undefined, previous_years_at_job?: number | null | undefined, previous_months_at_job?: number | null | undefined, retail_book_value?: number | null | undefined, kbb_retail_mileage_adjustment?: number | null | undefined, kbb_retail_option_adjustment?: number | null | undefined, book_value?: number | null | undefined, kbb_lending_mileage_adjustment?: number | null | undefined, kbb_lending_option_adjustment?: number | null | undefined, kbb_valuation_date?: string | null | undefined, kbb_vehicle_name?: string | null | undefined, kbb_trim_name?: string | null | undefined, kbb_selected_options?: any | null | undefined, credit_score?: number | null | undefined, term?: number | null | undefined, rate?: number | null | undefined, down_payment?: number | null | undefined, taxes_fees?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, old_lease_payment?: number | null | undefined, vehicle_payoff?: number | null | undefined } };

export type SearchWebLeadsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchWebLeadsQuery = { __typename?: 'Query', searchWebLeads?: Array<{ __typename?: 'temporaryInfo', id?: number | null | undefined, deal_id?: number | null | undefined, data: { __typename?: 'temporaryData', first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, vin?: string | null | undefined } } | null | undefined> | null | undefined };

export type TemporaryInfoAuthenticatedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TemporaryInfoAuthenticatedQuery = { __typename?: 'Query', temporaryInfoAuthenticated?: { __typename?: 'temporaryInfo', id?: number | null | undefined, consents?: Array<{ __typename?: 'consent', type?: ConsentNameEnumType | null | undefined } | null | undefined> | null | undefined, data: { __typename?: 'temporaryData', vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, fuel_type?: string | null | undefined, vehicle_type?: string | null | undefined, color?: string | null | undefined, mileage?: number | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, lienholder?: string | null | undefined, lienholderLogo?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, address_line?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, previous_address_line?: string | null | undefined, previous_city?: string | null | undefined, previous_state?: string | null | undefined, previous_zip?: string | null | undefined, scheduled_call_datetime?: any | null | undefined, scheduled_call_datetime_tz?: string | null | undefined, primary_residence_type?: string | null | undefined, primary_residence_years?: number | null | undefined, primary_residence_months?: number | null | undefined, primary_residence_monthly_payment?: number | null | undefined, secondary_residence_years?: number | null | undefined, secondary_residence_months?: number | null | undefined, dob?: any | null | undefined, ssn_id?: number | null | undefined, good_through_date?: any | null | undefined, employer_name?: string | null | undefined, job_title?: string | null | undefined, employer_phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, salary?: number | null | undefined, previous_employer_name?: string | null | undefined, previous_job_title?: string | null | undefined, previous_employer_phone_number?: string | null | undefined, previous_years_at_job?: number | null | undefined, previous_months_at_job?: number | null | undefined, retail_book_value?: number | null | undefined, kbb_retail_mileage_adjustment?: number | null | undefined, kbb_retail_option_adjustment?: number | null | undefined, book_value?: number | null | undefined, kbb_lending_mileage_adjustment?: number | null | undefined, kbb_lending_option_adjustment?: number | null | undefined, kbb_valuation_date?: string | null | undefined, kbb_vehicle_name?: string | null | undefined, kbb_trim_name?: string | null | undefined, kbb_selected_options?: any | null | undefined, credit_score?: number | null | undefined, term?: number | null | undefined, rate?: number | null | undefined, down_payment?: number | null | undefined, taxes_fees?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, old_lease_payment?: number | null | undefined, vehicle_payoff?: number | null | undefined } } | null | undefined };

export type TemporaryInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TemporaryInfoQuery = { __typename?: 'Query', temporaryInfo?: { __typename?: 'temporaryInfo', id?: number | null | undefined, data: { __typename?: 'temporaryData', vin?: string | null | undefined, year?: string | null | undefined, make?: string | null | undefined, model?: string | null | undefined, fuel_type?: string | null | undefined, vehicle_type?: string | null | undefined, color?: string | null | undefined, mileage?: number | null | undefined, phone_number?: string | null | undefined, email?: string | null | undefined, lienholder?: string | null | undefined, lienholderLogo?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, address_line?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, previous_address_line?: string | null | undefined, previous_city?: string | null | undefined, previous_state?: string | null | undefined, previous_zip?: string | null | undefined, scheduled_call_datetime?: any | null | undefined, scheduled_call_datetime_tz?: string | null | undefined, primary_residence_type?: string | null | undefined, primary_residence_years?: number | null | undefined, primary_residence_months?: number | null | undefined, primary_residence_monthly_payment?: number | null | undefined, secondary_residence_years?: number | null | undefined, secondary_residence_months?: number | null | undefined, dob?: any | null | undefined, ssn_id?: number | null | undefined, good_through_date?: any | null | undefined, employer_name?: string | null | undefined, job_title?: string | null | undefined, employer_phone_number?: string | null | undefined, years_at_job?: number | null | undefined, months_at_job?: number | null | undefined, salary?: number | null | undefined, previous_employer_name?: string | null | undefined, previous_job_title?: string | null | undefined, previous_employer_phone_number?: string | null | undefined, previous_years_at_job?: number | null | undefined, previous_months_at_job?: number | null | undefined, retail_book_value?: number | null | undefined, kbb_retail_mileage_adjustment?: number | null | undefined, kbb_retail_option_adjustment?: number | null | undefined, book_value?: number | null | undefined, kbb_lending_mileage_adjustment?: number | null | undefined, kbb_lending_option_adjustment?: number | null | undefined, kbb_valuation_date?: string | null | undefined, kbb_vehicle_name?: string | null | undefined, kbb_trim_name?: string | null | undefined, kbb_selected_options?: any | null | undefined, credit_score?: number | null | undefined, term?: number | null | undefined, rate?: number | null | undefined, down_payment?: number | null | undefined, taxes_fees?: number | null | undefined, payoff_includes_sales_tax?: boolean | null | undefined, old_lease_payment?: number | null | undefined, vehicle_payoff?: number | null | undefined } } | null | undefined };

export type TemporaryInfoImportMutationVariables = Exact<{
  id: Scalars['ID'];
  transformType: TransformType;
  importType: ImportType;
}>;


export type TemporaryInfoImportMutation = { __typename?: 'RootMutationType', temporaryInfoImport?: { __typename?: 'deal', id?: number | null | undefined } | null | undefined };

export type OnDealImportedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDealImportedSubscription = { __typename?: 'RootSubscriptionType', onDealImported?: { __typename?: 'DealImported', deal_id: number, first_name: string, last_name: string } | null | undefined };

export type OnDuplicatedInfoSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDuplicatedInfoSubscription = { __typename?: 'RootSubscriptionType', onDuplicatedInfo?: { __typename?: 'DuplicatedInfo', deal_id: number, first_name: string, last_name: string, state: string } | null | undefined };

export type OnDuplicatedDealImportSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDuplicatedDealImportSubscription = { __typename?: 'RootSubscriptionType', onDuplicatedDealImport?: { __typename?: 'DuplicatedDealImport', deal_id: number, first_name: string, last_name: string } | null | undefined };

export type TemporaryRegistrationTagsDealFragment = { __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, temporary_registration_tags_user?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, address?: { __typename?: 'address', state?: string | null | undefined } | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, registration_expiration?: any | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, deal_dates?: { __typename?: 'DealDates', custom_dates?: any | null | undefined } | null | undefined, shipping_labels?: Array<{ __typename?: 'ShippingLabel', tracking_number?: string | null | undefined, tracker_url?: string | null | undefined } | null | undefined> | null | undefined, financial_info?: { __typename?: 'financialInfo', needs_temporary_registration_tags?: boolean | null | undefined } | null | undefined };

export type TemporaryRegistrationTagsDealsQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type TemporaryRegistrationTagsDealsQuery = { __typename?: 'Query', temporaryRegistrationTagsDeals?: { __typename?: 'PaginatedDeals', totalRecords?: number | null | undefined, deals?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, temporary_registration_tags_user?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, address?: { __typename?: 'address', state?: string | null | undefined } | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, registration_expiration?: any | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, deal_dates?: { __typename?: 'DealDates', custom_dates?: any | null | undefined } | null | undefined, shipping_labels?: Array<{ __typename?: 'ShippingLabel', tracking_number?: string | null | undefined, tracker_url?: string | null | undefined } | null | undefined> | null | undefined, financial_info?: { __typename?: 'financialInfo', needs_temporary_registration_tags?: boolean | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type OnTemporaryRegistrationTagsDealsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTemporaryRegistrationTagsDealsUpdatedSubscription = { __typename?: 'RootSubscriptionType', onTemporaryRegistrationTagsDealsUpdated?: Array<{ __typename?: 'deal', id?: number | null | undefined, state?: string | null | undefined, temporary_registration_tags_user?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, customer?: { __typename?: 'customer', first_name?: string | null | undefined, last_name?: string | null | undefined, phone_number?: string | null | undefined, address?: { __typename?: 'address', state?: string | null | undefined } | null | undefined } | null | undefined, car?: { __typename?: 'car', id?: number | null | undefined, registration_expiration?: any | null | undefined } | null | undefined, closer?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, title_clerk?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, deal_dates?: { __typename?: 'DealDates', custom_dates?: any | null | undefined } | null | undefined, shipping_labels?: Array<{ __typename?: 'ShippingLabel', tracking_number?: string | null | undefined, tracker_url?: string | null | undefined } | null | undefined> | null | undefined, financial_info?: { __typename?: 'financialInfo', needs_temporary_registration_tags?: boolean | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GetThunderConversationHistoryQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type GetThunderConversationHistoryQuery = { __typename?: 'Query', getThunderConversationHistoryByPhoneNumber?: { __typename?: 'ThunderConversationHistory', id: string, firstName: string, lastName: string, messages: Array<{ __typename?: 'ThunderConversationMessage', text: string, timestamp: string, direction: string } | null | undefined> } | null | undefined };

export type HandleThunderOutboundCallMutationVariables = Exact<{
  hunt_group_slug?: InputMaybe<Scalars['String']>;
  thunder_call_notification_id?: InputMaybe<Scalars['ID']>;
  waiting_call_id?: InputMaybe<Scalars['ID']>;
}>;


export type HandleThunderOutboundCallMutation = { __typename?: 'RootMutationType', handleThunderOutboundCall?: { __typename?: 'resultHandleThunderOutboundCall', status?: string | null | undefined, call_already_answered?: boolean | null | undefined } | null | undefined };

export type MyUnfinishedThunderClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUnfinishedThunderClaimsQuery = { __typename?: 'Query', myUnfinishedThunderClaims: Array<{ __typename?: 'ThunderCallNotification', id?: number | null | undefined, customer_phone_number: string, first_name: string, last_name: string, scheduled_call_time?: string | null | undefined, attempt_num: number, ai_call_opener?: string | null | undefined, thunder_phone_number?: string | null | undefined } | null | undefined> };

export type HandleThunderOutboundCallOutcomeMutationVariables = Exact<{
  calledNumber: Scalars['String'];
  answered?: InputMaybe<Scalars['Boolean']>;
  attemptNum?: InputMaybe<Scalars['Int']>;
  thunderCallNotificationId?: InputMaybe<Scalars['ID']>;
  dealId?: InputMaybe<Scalars['ID']>;
}>;


export type HandleThunderOutboundCallOutcomeMutation = { __typename?: 'RootMutationType', handleThunderOutboundCallOutcome?: boolean | null | undefined };

export type GetTwilioNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTwilioNumbersQuery = { __typename?: 'Query', getTwilioNumbers?: Array<{ __typename?: 'twilioNumber', number?: string | null | undefined, friendlyName?: string | null | undefined } | null | undefined> | null | undefined };

export type UserAutoAssignEligibilityFragmentFragment = { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean };

export type UserFragmentFragment = { __typename?: 'user', id?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, phone_number?: string | null | undefined, twilio_number?: string | null | undefined, created_at?: any | null | undefined, recruiter_id?: string | null | undefined, location?: LocationType | null | undefined, hours?: string | null | undefined, on_vacation?: boolean | null | undefined, auto_assign_deals?: boolean | null | undefined, max_auto_assign_deals?: number | null | undefined, user_type?: UserType | null | undefined, assignment_mode?: AssignmentMode | null | undefined, frequency_minutes?: number | null | undefined, can_claim_as_closer?: boolean | null | undefined, auth0_roles?: { __typename?: 'UserRoles', roles?: Array<{ __typename?: 'Auth0Role', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, autoAssignEligibility?: { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean } | null | undefined };

export type GetUsersQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  podId?: InputMaybe<Scalars['ID']>;
  roleNames?: InputMaybe<Array<InputMaybe<Auth0RoleName>> | InputMaybe<Auth0RoleName>>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  teamType?: InputMaybe<TeamType>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers?: { __typename?: 'PaginatedUser', totalRecords?: number | null | undefined, results?: Array<{ __typename?: 'user', id?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, phone_number?: string | null | undefined, twilio_number?: string | null | undefined, created_at?: any | null | undefined, recruiter_id?: string | null | undefined, location?: LocationType | null | undefined, hours?: string | null | undefined, on_vacation?: boolean | null | undefined, auto_assign_deals?: boolean | null | undefined, max_auto_assign_deals?: number | null | undefined, user_type?: UserType | null | undefined, assignment_mode?: AssignmentMode | null | undefined, frequency_minutes?: number | null | undefined, can_claim_as_closer?: boolean | null | undefined, auth0_roles?: { __typename?: 'UserRoles', roles?: Array<{ __typename?: 'Auth0Role', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, autoAssignEligibility?: { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetUsersForManagementQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  podId?: InputMaybe<Scalars['ID']>;
  roleNames?: InputMaybe<Array<InputMaybe<Auth0RoleName>> | InputMaybe<Auth0RoleName>>;
  sortColumn?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  teamType?: InputMaybe<TeamType>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersForManagementQuery = { __typename?: 'Query', getUsers?: { __typename?: 'PaginatedUser', totalRecords?: number | null | undefined, results?: Array<{ __typename?: 'user', id?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, phone_number?: string | null | undefined, twilio_number?: string | null | undefined, created_at?: any | null | undefined, recruiter_id?: string | null | undefined, location?: LocationType | null | undefined, hours?: string | null | undefined, on_vacation?: boolean | null | undefined, auto_assign_deals?: boolean | null | undefined, max_auto_assign_deals?: number | null | undefined, user_type?: UserType | null | undefined, assignment_mode?: AssignmentMode | null | undefined, frequency_minutes?: number | null | undefined, can_claim_as_closer?: boolean | null | undefined, huntGroups?: Array<{ __typename?: 'HuntGroup', id?: number | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, auth0_roles?: { __typename?: 'UserRoles', roles?: Array<{ __typename?: 'Auth0Role', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, color?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined, autoAssignEligibility?: { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type TitlingUsersQueryVariables = Exact<{
  titling_pod_id?: InputMaybe<Scalars['ID']>;
}>;


export type TitlingUsersQuery = { __typename?: 'Query', titlingUsers?: Array<{ __typename?: 'podUser', user_id?: string | null | undefined, pod_id?: number | null | undefined, team_role?: TeamRole | null | undefined, user?: { __typename?: 'baseUser', id?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, deleted_at?: any | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GetAvailableUsersAndAllHuntGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableUsersAndAllHuntGroupsQuery = { __typename?: 'Query', getAvailableUsers?: Array<{ __typename?: 'getAvailableUsers', id?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, phone_number?: string | null | undefined, twilio_number?: string | null | undefined, call_status?: string | null | undefined, in_call?: string | null | undefined } | null | undefined> | null | undefined, getAllHuntGroups?: Array<{ __typename?: 'HuntGroup', id?: number | null | undefined, name?: string | null | undefined, phone_number?: string | null | undefined, slug?: string | null | undefined } | null | undefined> | null | undefined };

export type LoggedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedUserQuery = { __typename?: 'Query', loggedUser?: { __typename?: 'user', id?: string | null | undefined, name?: string | null | undefined, call_status?: string | null | undefined, can_claim_as_closer?: boolean | null | undefined, hours?: string | null | undefined, on_vacation?: boolean | null | undefined, twilio_number?: string | null | undefined, auto_assign_deals?: boolean | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, team_type?: TeamType | null | undefined } | null | undefined> | null | undefined, autoAssignEligibility?: { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean } | null | undefined } | null | undefined };

export type UserTitlingPodsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTitlingPodsQuery = { __typename?: 'Query', userTitlingPods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined, problem_solver?: boolean | null | undefined, archived?: boolean | null | undefined, us_states_object?: { __typename?: 'usStatesObject', states?: Array<StateAbbreviation | null | undefined> | null | undefined } | null | undefined, pod_users?: Array<{ __typename?: 'podUser', id?: number | null | undefined, user_id?: string | null | undefined, pod_id?: number | null | undefined, team_role?: TeamRole | null | undefined, user?: { __typename?: 'baseUser', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type UserPermissionsQueryVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type UserPermissionsQuery = { __typename?: 'Query', userPermissions?: Array<string | null | undefined> | null | undefined };

export type GetUserTwilioNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTwilioNumberQuery = { __typename?: 'Query', getUserTwilioNumber?: string | null | undefined };

export type GetUserCreationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCreationDataQuery = { __typename?: 'Query', getUserCreationData?: { __typename?: 'UserCreationData', huntGroups?: Array<{ __typename?: 'HuntGroup', id?: number | null | undefined, name?: string | null | undefined, slug?: string | null | undefined }> | null | undefined, pods?: Array<{ __typename?: 'pod', id?: number | null | undefined, name?: string | null | undefined, color?: string | null | undefined }> | null | undefined } | null | undefined };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'RootMutationType', createUser?: { __typename?: 'user', id?: string | null | undefined } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
  allAuth0RoleIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'RootMutationType', updateUser?: { __typename?: 'user', id?: string | null | undefined } | null | undefined };

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars['String'];
  hours: Scalars['String'];
  on_vacation: Scalars['Boolean'];
  auto_assign_deals: Scalars['Boolean'];
  max_auto_assign_deals: Scalars['Int'];
  user_type: UserType;
  assignment_mode: AssignmentMode;
  frequency_minutes: Scalars['Int'];
  accept_overnight_deals: Scalars['Boolean'];
  accept_unseen_deals: Scalars['Boolean'];
  accept_with_upcoming_appointment: Scalars['Boolean'];
  accept_ai_touched_deals: Scalars['Boolean'];
  deals_with_stipulations: Scalars['Boolean'];
  deals_with_vsc: Scalars['Boolean'];
  deals_with_gap: Scalars['Boolean'];
  deals_with_double_tax: Scalars['Boolean'];
  deals_with_direct_pay: Scalars['Boolean'];
  deals_with_bank_fees: Scalars['Boolean'];
  deals_with_down_payment: Scalars['Boolean'];
}>;


export type UpdateUserSettingsMutation = { __typename?: 'RootMutationType', updateUserSettings?: { __typename?: 'user', id?: string | null | undefined, hours?: string | null | undefined, on_vacation?: boolean | null | undefined, auto_assign_deals?: boolean | null | undefined, max_auto_assign_deals?: number | null | undefined, autoAssignEligibility?: { __typename?: 'userAutoAssignEligibility', user_id: string, accept_overnight_deals: boolean, accept_unseen_deals: boolean, accept_with_upcoming_appointment: boolean, accept_ai_touched_deals: boolean, deals_with_stipulations: boolean, deals_with_vsc: boolean, deals_with_gap: boolean, deals_with_double_tax: boolean, deals_with_direct_pay: boolean, deals_with_bank_fees: boolean, deals_with_down_payment: boolean } | null | undefined } | null | undefined };

export type SoftDeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftDeleteUserMutation = { __typename?: 'RootMutationType', softDeleteUser?: boolean | null | undefined };

export type UpdateUserCallStatusMutationVariables = Exact<{
  status: CallStatus;
}>;


export type UpdateUserCallStatusMutation = { __typename?: 'RootMutationType', updateUserCallStatus?: { __typename?: 'user', id?: string | null | undefined, call_status?: string | null | undefined } | null | undefined };

export type SwitchCallStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SwitchCallStatusSubscription = { __typename?: 'RootSubscriptionType', switchCallStatus?: string | null | undefined };

export type OnSipRegistrationFailureSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnSipRegistrationFailureSubscription = { __typename?: 'RootSubscriptionType', onSipRegistrationFailure?: { __typename?: 'onSipRegistrationFailure', userId?: string | null | undefined, message?: string | null | undefined, callerNumber?: string | null | undefined } | null | undefined };

export type GetWaitingCallsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaitingCallsQuery = { __typename?: 'Query', getWaitingCalls?: { __typename?: 'getWaitingCalls', data?: any | null | undefined } | null | undefined };

export type CallInProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type CallInProgressQuery = { __typename?: 'Query', callInProgress?: { __typename?: 'conference', from?: string | null | undefined, to?: string | null | undefined, customer_name?: string | null | undefined, deal_id?: number | null | undefined, deal_state?: string | null | undefined, deal_type?: string | null | undefined, is_thunder?: boolean | null | undefined, id?: number | null | undefined, conference_id?: string | null | undefined, agent_user_id?: string | null | undefined, hunt_group_slug?: string | null | undefined, is_outbound?: boolean | null | undefined } | null | undefined };

export type AddParticipantMutationVariables = Exact<{
  hunt_group_slug?: InputMaybe<Scalars['String']>;
  conference_id?: InputMaybe<Scalars['String']>;
  agent_phone?: InputMaybe<Scalars['String']>;
  new_agent_phone?: InputMaybe<Scalars['String']>;
  new_agent_user_id?: InputMaybe<Scalars['String']>;
  waiting_call_id?: InputMaybe<Scalars['ID']>;
}>;


export type AddParticipantMutation = { __typename?: 'RootMutationType', addParticipant?: { __typename?: 'resultAddParticipant', status?: string | null | undefined, call_already_answered?: boolean | null | undefined } | null | undefined };

export type OnWaitingQueueSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWaitingQueueSubscription = { __typename?: 'RootSubscriptionType', onWaitingQueue?: { __typename?: 'onWaitingQueue', hunt_group_slug?: string | null | undefined, data?: Array<{ __typename?: 'waitingCall', id?: number | null | undefined, from?: string | null | undefined, conference_id?: string | null | undefined, phone_number?: string | null | undefined, started_at?: string | null | undefined, deal_id?: number | null | undefined, deal_state?: string | null | undefined, is_thunder?: boolean | null | undefined, customer_name?: string | null | undefined, hunt_group_slug?: string | null | undefined, thunder_data?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export const SelectCreditDecisionFragmentFragmentDoc = gql`
    fragment SelectCreditDecisionFragment on SelectCreditDecision {
  creditDecision {
    id
  }
  financialInfo {
    id
    bank
    bank_fees
    selected_credit_decision_id
    term
    sell_rate
    buy_rate
    first_payment_date
  }
}
    `;
export const CudlDecisionBaseFragmentFragmentDoc = gql`
    fragment CUDLDecisionBaseFragment on CUDLDecision {
  ID
  IsCurrent
}
    `;
export const ProviderDecisionBaseFragmentFragmentDoc = gql`
    fragment ProviderDecisionBaseFragment on creditDecision {
  provider_decision_data {
    ... on r1CreditDecisionData {
      applicationNumber
      applicationStatus
      applicationStatusDetail
    }
    ... on CUDLVehicleLoanApplication {
      ID
      Decision {
        ...CUDLDecisionBaseFragment
      }
      Decisions {
        Decision {
          ...CUDLDecisionBaseFragment
        }
      }
    }
  }
}
    ${CudlDecisionBaseFragmentFragmentDoc}`;
export const CudlDecisionDetailsFragmentFragmentDoc = gql`
    fragment CUDLDecisionDetailsFragment on CUDLDecision {
  Stipulations {
    Stipulation
  }
  Reasons {
    DecisionReason {
      Description
    }
  }
  OtherData {
    ReferralReasons {
      ReferralReason {
        ReferralReasonText
      }
    }
  }
}
    `;
export const ProviderDecisionDetailsFragmentFragmentDoc = gql`
    fragment ProviderDecisionDetailsFragment on creditDecision {
  provider_decision_data {
    ... on r1CreditDecisionData {
      applicationNumber
      applicationStatus
      applicationStatusDetail
      decision {
        stipulations
        decisionComments
        conditionRejection {
          conditionRejectionText
        }
      }
    }
    ... on CUDLVehicleLoanApplication {
      ID
      Decision {
        ...CUDLDecisionBaseFragment
        ...CUDLDecisionDetailsFragment
      }
      Decisions {
        Decision {
          ...CUDLDecisionBaseFragment
          ...CUDLDecisionDetailsFragment
        }
      }
      Comments {
        Comment {
          ID
          Subject
          Body
          Source
        }
      }
    }
  }
}
    ${CudlDecisionBaseFragmentFragmentDoc}
${CudlDecisionDetailsFragmentFragmentDoc}`;
export const DashboardDealCacheFragmentFragmentDoc = gql`
    fragment DashboardDealCacheFragment on deal {
  id
  state
  paperwork_type
  lane_arrival_utc
  default_sort_date
}
    `;
export const AssignmentUsersFragmentFragmentDoc = gql`
    fragment AssignmentUsersFragment on deal {
  pod_id
  fs_pod_id
  fs_pod {
    id
    name
    color
  }
  pod {
    id
    name
    color
  }
  setter_id
  setter {
    id
    name
    pods {
      id
    }
  }
  closer_id
  closer {
    id
    name
    location
    pods {
      id
    }
  }
  closer2_id
  closer2 {
    id
    name
    location
    pods {
      id
    }
  }
  structuring_manager_id
  structuring_manager {
    id
    name
    pods {
      id
    }
  }
  funding_clerk_id
  funding_clerk {
    id
    name
    pods {
      id
    }
  }
}
    `;
export const TitleUsersFragmentFragmentDoc = gql`
    fragment TitleUsersFragment on deal {
  titling_pod_id
  titling_pod {
    id
    color
    name
    leads {
      id
      name
    }
  }
  title_clerk_id
  title_clerk {
    id
    name
    deleted_at
  }
  title_clerk2_id
  title_clerk2 {
    id
    name
    deleted_at
  }
}
    `;
export const PersonCreditAppOnDealFragmentDoc = gql`
    fragment PersonCreditAppOnDeal on customer {
  id
  dob
  auth0_id
  ssn_id
  has_full_ssn
  has_itin
  email
  first_name
  middle_name
  last_name
  name_suffix
  home_phone_number
  phone_number
  marital_status
  lives_with_other_buyer
  address {
    id
    address_type
    address_line
    address_line_2
    city
    county
    state
    country
    zip
    monthly_payment
    years_at_home
    months_at_home
    residence_type
  }
  prev_address {
    id
    address_type
    address_line
    address_line_2
    city
    county
    state
    country
    zip
    years_at_home
    months_at_home
  }
  mailing_address {
    id
    address_type
    address_line
    address_line_2
    city
    state
    county
    country
    zip
  }
  employment {
    id
    status
    name
    job_title
    phone_number
    years_at_job
    months_at_job
    gross_income
    pay_frequency
  }
  prev_employment {
    id
    name
    job_title
    years_at_job
    months_at_job
  }
  proof_of_insurance {
    id
    company_name
    policy_number
    expires
  }
}
    `;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPerson on DealContact {
  id
  first_name
  middle_name
  last_name
  phone_number
  email
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on address {
  id
  address_line
  address_line_2
  zip
  city
  state
  county
  country
  address_type
  residence_type
  years_at_home
  months_at_home
  monthly_payment
  moved_states
}
    `;
export const OriginalLesseeFragmentFragmentDoc = gql`
    fragment OriginalLesseeFragment on OriginalLessee {
  id
  first_name
  last_name
  phone_number
  email
  address_line
  ssn_id
  city
  state
  zip
  county
}
    `;
export const DealPackageConfigFragmentFragmentDoc = gql`
    fragment DealPackageConfigFragment on DealPackageConfig {
  slotIndex
  selectedProductSlugs
}
    `;
export const DealProductFragmentFragmentDoc = gql`
    fragment DealProductFragment on DealProduct {
  id
  deal_id
  product_catalog_id
  price
  cost
  tax_amount
  pen_rate_id
  pen_session_id
  pen_form_id
  pen_contract_number
  term
  coverage_type
  product_catalog {
    id
    slug
    name
    display_order
  }
}
    `;
export const ReferralSourceFragmentFragmentDoc = gql`
    fragment ReferralSourceFragment on referralSource {
  id
  source_name
  other_source_description
}
    `;
export const FileFragmentFragmentDoc = gql`
    fragment FileFragment on File {
  url
  filename
  key
  mediaType
}
    `;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on notification {
  id
  message
  customer_id
  deal_contact_id
  original_lessee_id
  created_at
  users {
    id
    user_id
    seen_at
  }
}
    `;
export const DealFragmentFragmentDoc = gql`
    fragment DealFragment on deal {
  __typename
  id
  type
  source
  state
  country
  completion_date_utc
  completion_date_tz
  paperwork_type
  request_boot
  boot_reason
  has_funding_jacket
  document_progress_status
  selected_dealer_id
  r1_contract_validation_errors_object {
    errors
  }
  r1_contract_validation_warnings_object {
    warnings
  }
  r1_contract_manually_validated
  signing_on_com
  pod_id
  pod {
    id
    name
    color
  }
  setter_id
  setter {
    id
    name
    pods {
      id
    }
  }
  closer_id
  closer {
    id
    name
    pods {
      id
    }
  }
  closer2_id
  closer2 {
    id
    name
    pods {
      id
    }
  }
  funding_clerk_id
  funding_clerk {
    id
    name
    pods {
      id
    }
  }
  titling_pod_id
  titling_pod {
    id
    color
    name
    leads {
      id
      name
    }
  }
  title_clerk_id
  title_clerk {
    id
    name
    deleted_at
  }
  title_clerk2_id
  title_clerk2 {
    id
    name
    deleted_at
  }
  car {
    id
    license_plate_number
    license_plate_state
    vin
    year
    make
    model
    mileage
    mileage_unit
    color
    book_value
    retail_book_value
    jdp_adjusted_clean_trade
    jdp_adjusted_clean_retail
    vehicle_type
    fuel_type
    kbb_trim_name
    mmr
    registration_expiration
    odometer_status
    kbb_selected_options_object {
      selected_options {
        id
        name
        type
        lendingOptionPrice
        retailOptionPrice
        removed
      }
    }
    cbb_valuation {
      uvc
      trim_name
      vehicle_name
      all_options {
        uoc
        name
        clean
        xclean
        avg
        rough
        auto
      }
      selected_options {
        uoc
        name
        clean
      }
      valuation_date
      data_freq
      inputs {
        kilometres
        province
      }
      lending {
        adjusted
        base
        mileage_adjustment
        option_adjustment
        regional_adjustment
      }
      retail {
        adjusted
        base
        mileage_adjustment
        option_adjustment
        regional_adjustment
      }
    }
    payoff {
      id
      lienholder_name
      lienholder_slug
      lender_name
      account_number
      vehicle_payoff
      good_through_date
      lease_term
      remaining_payments
      msrp
      residual_percentage
      sales_price
      cap_reduction
      money_down
      money_factor
      termination_fees
      cap_cost
      residual_amount
      estimated_payoff
      old_lease_payment
      sales_tax_from_payoff
      payoff_includes_sales_tax
      sales_tax_from_payoff_entered_manually
      verification_status
      next_payment_date
      user_entered_total_payoff
    }
  }
  customer {
    id
    first_name
    middle_name
    last_name
    name_suffix
    phone_number
    home_phone_number
    email
    has_full_ssn
    has_itin
    dob
    address {
      id
      address_line
      address_line_2
      zip
      city
      state
      county
      country
      address_type
      residence_type
      years_at_home
      months_at_home
      monthly_payment
      moved_states
    }
    prev_address {
      id
      address_line
      address_line_2
      zip
      city
      state
      county
      country
      address_type
      residence_type
      years_at_home
      months_at_home
      monthly_payment
      moved_states
    }
    employment {
      id
      status
      name
      job_title
      phone_number
      years_at_job
      months_at_job
      gross_income
      pay_frequency
    }
    prev_employment {
      id
      status
      name
      job_title
      phone_number
      years_at_job
      months_at_job
      gross_income
      pay_frequency
    }
    proof_of_insurance {
      id
      company_name
      policy_number
      expires
    }
    lives_with_other_buyer
    marital_status
    auth0_id
  }
  cobuyer {
    id
    first_name
    middle_name
    last_name
    name_suffix
    phone_number
    home_phone_number
    email
    has_full_ssn
    has_itin
    dob
    address {
      id
      address_line
      address_line_2
      zip
      city
      state
      county
      country
      address_type
      residence_type
      years_at_home
      months_at_home
      monthly_payment
      moved_states
    }
    prev_address {
      id
      address_line
      address_line_2
      zip
      city
      state
      county
      country
      address_type
      residence_type
      years_at_home
      months_at_home
      monthly_payment
      moved_states
    }
    employment {
      id
      status
      name
      job_title
      phone_number
      years_at_job
      months_at_job
      gross_income
      pay_frequency
    }
    prev_employment {
      id
      status
      name
      job_title
      phone_number
      years_at_job
      months_at_job
      gross_income
      pay_frequency
    }
    proof_of_insurance {
      id
      company_name
      policy_number
      expires
    }
    lives_with_other_buyer
    marital_status
    relation_to_buyer
  }
  contact {
    id
    relation_to_buyer
    first_name
    middle_name
    last_name
    phone_number
  }
  second_contact {
    id
    relation_to_buyer
    first_name
    middle_name
    last_name
    phone_number
  }
  financial_info {
    id
    deal_id
    money_down
    base_tax_amount
    warranty_tax_amount
    title_fee
    new_registration_fee
    registration_transfer_fee
    doc_fee
    sales_tax_rate
    days_to_payment
    first_payment_date
    sell_rate
    buy_rate
    term
    bank
    payment
    amount_financed
    profit
    setter_commission
    closer_commission
    option_type
    plate_transfer
    title_registration_option
    processor
    tt_transaction_id
    buyer_not_lessee
    new_lienholder {
      name
      provider_lender_id
      address
      city
      state
      zip
    }
  }
  condition_report {
    id
    deal_id
    accidents
    tires
    exterior
    interior
    smoked_in
    lights_on_dash
    overall_condition
    score
  }
  document_info {
    id
    adobe_agreement_id
  }
  roi_document_info {
    id
    adobe_agreement_id
  }
  deal_states {
    id
    deal_id
    state
    updated_date_utc
    user_id
    user {
      id
      name
    }
  }
  deal_dates {
    id
    deal_id
    dates
    custom_dates
  }
  notifications {
    ...NotificationFragment
  }
  referral_source {
    id
    source_name
    other_source_description
  }
}
    ${NotificationFragmentFragmentDoc}`;
export const LenderFragmentFragmentDoc = gql`
    fragment LenderFragment on Lender {
  id
  name
}
    `;
export const MessageFragmentFragmentDoc = gql`
    fragment MessageFragment on message {
  id
  fromCustomer
  body
  senderName
  dateCreated
  status
  errorReason
  mediaListObj {
    data {
      url
      contentType
    }
  }
}
    `;
export const PaymentOptionFragmentFragmentDoc = gql`
    fragment PaymentOptionFragment on paymentOptionsGQLTypes {
  name
  amountFinanced
  buyPayment
  sellPayment
  profit
  setterCommission
  closerCommission
  reserve
}
    `;
export const PaymentOptionV2FragmentFragmentDoc = gql`
    fragment PaymentOptionV2Fragment on paymentOptionsGQLTypes {
  name
  amountFinanced
  buyPayment
  sellPayment
  profit
  setterCommission
  closerCommission
  reserve
}
    `;
export const PaymentOptionsPackageProductV2FragmentFragmentDoc = gql`
    fragment PaymentOptionsPackageProductV2Fragment on PaymentOptionsPackageProductV2 {
  productCatalogId
  slug
  price
  cost
  taxAmount
}
    `;
export const PaymentOptionsPackageV2FragmentFragmentDoc = gql`
    fragment PaymentOptionsPackageV2Fragment on PaymentOptionsPackageV2 {
  slotIndex
  selectedProductSlugs
  legacyOptionType
  isSelected
  amountFinanced
  buyPayment
  sellPayment
  profit
  setterCommission
  closerCommission
  reserve
  products {
    ...PaymentOptionsPackageProductV2Fragment
  }
}
    ${PaymentOptionsPackageProductV2FragmentFragmentDoc}`;
export const PayoffFragmentFragmentDoc = gql`
    fragment PayoffFragment on payoff {
  id
  lienholder_name
  lienholder_slug
  lender_name
  account_number
  vehicle_payoff
  sales_tax_from_payoff
  good_through_date
  lease_term
  remaining_payments
  msrp
  residual_percentage
  sales_price
  cap_reduction
  money_down
  money_factor
  termination_fees
  cap_cost
  residual_amount
  estimated_payoff
  old_lease_payment
  payoff_includes_sales_tax
  sales_tax_from_payoff_entered_manually
  verification_status
  next_payment_date
  user_entered_total_payoff
  maturity_date
}
    `;
export const PayoffRequestPopulatedFragmentFragmentDoc = gql`
    fragment PayoffRequestPopulatedFragment on payoffRequestPopulated {
  id
  created_at
  deal_id
  deal {
    id
    closer {
      id
      name
    }
    car {
      id
      vehicle_type
      fuel_type
      year
      make
      model
      vin
      mileage
      payoff {
        id
        account_number
        lienholder_name
        lienholder_slug
        lender_name
      }
    }
    customer {
      id
      first_name
      last_name
      ssn_id
      dob
      phone_number
      home_phone_number
      address {
        id
        city
        county
        zip
        state
      }
    }
    financial_info {
      id
      buyer_not_lessee
    }
    closer_id
    created_at
    notifications {
      ...NotificationFragment
    }
  }
  temporary_info_id
  temporary_info {
    id
    data {
      state
      city
      county
      year
      make
      model
      vin
      mileage
      lh_account_number
      lienholder
      first_name
      last_name
      ssn_id
      dob
      phone_number
      zip
      vehicle_type
      fuel_type
    }
  }
  status
  vehicle_payoff
  sales_tax
  completed_date
  good_through_date
  created_at
  fail_reason
  payoff_clerk_id
  payoff_clerk {
    id
    name
  }
  needs_payoff_documents
  payoff_documents_uploaded
  requestor {
    id
    name
  }
  is_payoff_intelligence
}
    ${NotificationFragmentFragmentDoc}`;
export const PrequalificationRequestFragmentFragmentDoc = gql`
    fragment PrequalificationRequestFragment on PrequalificationRequest {
  first_name
  last_name
  zip
  gross_income
  pay_frequency
  vehicle_payoff
  lending_book_value
  money_down
  income_sources
}
    `;
export const PrequalificationFragmentFragmentDoc = gql`
    fragment PrequalificationFragment on prequalification {
  id
  input {
    ...PrequalificationRequestFragment
  }
  output {
    errors
  }
  credit_score
  ltv
  payment_to_income
  dti
  customer_id
  credit_score_tier
}
    ${PrequalificationRequestFragmentFragmentDoc}`;
export const PrequalificationCreditReportNameFragmentFragmentDoc = gql`
    fragment PrequalificationCreditReportNameFragment on PrequalificationCreditReportName {
  firstName
  middleName
  surname
  secondSurname
  generationCode
}
    `;
export const PrequalificationCreditReportTradelineFragmentFragmentDoc = gql`
    fragment PrequalificationCreditReportTradelineFragment on PrequalificationCreditReportTradeline {
  subscriberName
  accountNumber
  kob
  status
  accountType
  openDate
  balanceDate
  amount1
  amount1Qualifier
  amount2
  amount2Qualifier
  amountPastDue
  balanceAmount
  openOrClosed
  ecoa
  monthlyPaymentAmount
  monthsHistory
  terms
  delinquency30Days
  delinquency60Days
  delinquency90to180Days
  paymentHistory
}
    `;
export const PrequalificationCreditReportFragmentFragmentDoc = gql`
    fragment PrequalificationCreditReportFragment on PrequalificationCreditReport {
  names {
    customerName {
      ...PrequalificationCreditReportNameFragment
    }
    aliases {
      ...PrequalificationCreditReportNameFragment
    }
  }
  addresses {
    city
    state
    zipCode
    streetName
    streetPrefix
    streetSuffix
    firstReportedDate
  }
  employments {
    addressExtraLine
    addressFirstLine
    addressSecondLine
    firstReportedDate
    lastUpdatedDate
    name
    source
    zipCode
  }
  informationalMessages
  scoreFactors {
    code
    description
  }
  tradelines {
    revolving {
      ...PrequalificationCreditReportTradelineFragment
    }
    installment {
      ...PrequalificationCreditReportTradelineFragment
    }
    unknown {
      ...PrequalificationCreditReportTradelineFragment
    }
  }
}
    ${PrequalificationCreditReportNameFragmentFragmentDoc}
${PrequalificationCreditReportTradelineFragmentFragmentDoc}`;
export const RateFragmentFragmentDoc = gql`
    fragment RateFragment on rate {
  form_id
  session_id
  coverage_name
  term_miles
  term_months
  deductible {
    rate_id
    amount
    dealer_cost
    deductible_type
    f_i_markup
    max_retail_price
    min_retail_price
    retail_price
  }
}
    `;
export const SecureLinkNotificationFragmentFragmentDoc = gql`
    fragment SecureLinkNotificationFragment on SecureLinkNotification {
  reason
  deal_id
  customer_id
  first_name
  last_name
}
    `;
export const StructuringFollowUpFragmentFragmentDoc = gql`
    fragment StructuringFollowUpFragment on StructuringFollowUp {
  id
  created_at
  status
  creator_id
  notes
}
    `;
export const StructuringFollowUpDealFragmentFragmentDoc = gql`
    fragment StructuringFollowUpDealFragment on deal {
  id
  state
  type
  source
  customer {
    id
    first_name
    last_name
  }
  setter {
    id
    name
  }
  structuring_manager_id
  structuring_manager {
    id
    name
  }
  structuring_follow_up {
    ...StructuringFollowUpFragment
  }
  tags {
    id
    badge_variant
    color
    display_name
    is_dashboard_visible
    badge_variant
  }
  notifications {
    ...NotificationFragment
  }
  follow_up {
    id
    type
    status
    date_utc
    note
  }
}
    ${StructuringFollowUpFragmentFragmentDoc}
${NotificationFragmentFragmentDoc}`;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  id
  badge_variant
  slug
  display_name
  color
  is_active
  is_dashboard_visible
  badge_variant
}
    `;
export const TemporaryInfoFragmentFragmentDoc = gql`
    fragment TemporaryInfoFragment on temporaryInfo {
  id
  data {
    vin
    year
    make
    model
    fuel_type
    vehicle_type
    color
    mileage
    phone_number
    email
    lienholder
    lienholderLogo
    first_name
    last_name
    address_line
    city
    state
    zip
    previous_address_line
    previous_city
    previous_state
    previous_zip
    scheduled_call_datetime
    scheduled_call_datetime_tz
    primary_residence_type
    primary_residence_years
    primary_residence_months
    primary_residence_monthly_payment
    secondary_residence_years
    secondary_residence_months
    dob
    ssn_id
    good_through_date
    employer_name
    job_title
    employer_phone_number
    years_at_job
    months_at_job
    salary
    previous_employer_name
    previous_job_title
    previous_employer_phone_number
    previous_years_at_job
    previous_months_at_job
    retail_book_value
    kbb_retail_mileage_adjustment
    kbb_retail_option_adjustment
    book_value
    kbb_lending_mileage_adjustment
    kbb_lending_option_adjustment
    kbb_valuation_date
    kbb_vehicle_name
    kbb_trim_name
    kbb_selected_options
    credit_score
    term
    rate
    down_payment
    taxes_fees
    payoff_includes_sales_tax
    old_lease_payment
    vehicle_payoff
  }
}
    `;
export const TemporaryRegistrationTagsDealFragmentDoc = gql`
    fragment TemporaryRegistrationTagsDeal on deal {
  id
  state
  temporary_registration_tags_user {
    id
    name
  }
  customer {
    first_name
    last_name
    phone_number
    address {
      state
    }
  }
  car {
    id
    registration_expiration
  }
  closer {
    id
    name
  }
  title_clerk {
    id
    name
  }
  deal_dates {
    custom_dates
  }
  shipping_labels {
    tracking_number
    tracker_url
  }
  financial_info {
    needs_temporary_registration_tags
  }
}
    `;
export const UserAutoAssignEligibilityFragmentFragmentDoc = gql`
    fragment UserAutoAssignEligibilityFragment on userAutoAssignEligibility {
  user_id
  accept_overnight_deals
  accept_unseen_deals
  accept_with_upcoming_appointment
  accept_ai_touched_deals
  deals_with_stipulations
  deals_with_vsc
  deals_with_gap
  deals_with_double_tax
  deals_with_direct_pay
  deals_with_bank_fees
  deals_with_down_payment
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on user {
  id
  email
  name
  phone_number
  twilio_number
  created_at
  recruiter_id
  location
  auth0_roles {
    roles {
      id
      name
    }
  }
  pods {
    id
    color
    name
  }
  hours
  on_vacation
  auto_assign_deals
  max_auto_assign_deals
  user_type
  assignment_mode
  frequency_minutes
  can_claim_as_closer
  autoAssignEligibility {
    ...UserAutoAssignEligibilityFragment
  }
}
    ${UserAutoAssignEligibilityFragmentFragmentDoc}`;
export const AcquisitionOfferDocument = gql`
    query acquisitionOffer($accidents: accidentsEnumType!, $mileage: Int!, $mmr_value: Float!, $book_value: Int!, $vehicle_type: String, $lienholder: String, $make: String) {
  acquisitionOffer(
    accidents: $accidents
    mileage: $mileage
    mmr_value: $mmr_value
    book_value: $book_value
    vehicle_type: $vehicle_type
    lienholder: $lienholder
    make: $make
  ) {
    offer
    appraisedValue
  }
}
    `;

/**
 * __useAcquisitionOfferQuery__
 *
 * To run a query within a React component, call `useAcquisitionOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcquisitionOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcquisitionOfferQuery({
 *   variables: {
 *      accidents: // value for 'accidents'
 *      mileage: // value for 'mileage'
 *      mmr_value: // value for 'mmr_value'
 *      book_value: // value for 'book_value'
 *      vehicle_type: // value for 'vehicle_type'
 *      lienholder: // value for 'lienholder'
 *      make: // value for 'make'
 *   },
 * });
 */
export function useAcquisitionOfferQuery(baseOptions: Apollo.QueryHookOptions<AcquisitionOfferQuery, AcquisitionOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcquisitionOfferQuery, AcquisitionOfferQueryVariables>(AcquisitionOfferDocument, options);
      }
export function useAcquisitionOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcquisitionOfferQuery, AcquisitionOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcquisitionOfferQuery, AcquisitionOfferQueryVariables>(AcquisitionOfferDocument, options);
        }
export type AcquisitionOfferQueryHookResult = ReturnType<typeof useAcquisitionOfferQuery>;
export type AcquisitionOfferLazyQueryHookResult = ReturnType<typeof useAcquisitionOfferLazyQuery>;
export type AcquisitionOfferQueryResult = Apollo.QueryResult<AcquisitionOfferQuery, AcquisitionOfferQueryVariables>;
export const AddressDetailDocument = gql`
    query addressDetail($address: String, $zipCode: String) {
  addressDetail(address: $address, zipCode: $zipCode) {
    city
    county
    state
  }
}
    `;

/**
 * __useAddressDetailQuery__
 *
 * To run a query within a React component, call `useAddressDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressDetailQuery({
 *   variables: {
 *      address: // value for 'address'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useAddressDetailQuery(baseOptions?: Apollo.QueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressDetailQuery, AddressDetailQueryVariables>(AddressDetailDocument, options);
      }
export function useAddressDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressDetailQuery, AddressDetailQueryVariables>(AddressDetailDocument, options);
        }
export type AddressDetailQueryHookResult = ReturnType<typeof useAddressDetailQuery>;
export type AddressDetailLazyQueryHookResult = ReturnType<typeof useAddressDetailLazyQuery>;
export type AddressDetailQueryResult = Apollo.QueryResult<AddressDetailQuery, AddressDetailQueryVariables>;
export const AffiliateByPhoneNumberDocument = gql`
    query AffiliateByPhoneNumber($phoneNumber: String!) {
  affiliateByPhoneNumber(phoneNumber: $phoneNumber) {
    id
    created_at
    updated_at
    external_id
    lead_request
    ssn_id
    decision_accepted
    affiliate_provider_id
    decision_response {
      partnerDecision
      offers {
        amount
        term
        apr
        monthlyPayment
        offerUrl
      }
    }
    affiliate_provider {
      id
      created_at
      updated_at
      slug
      name
    }
  }
}
    `;

/**
 * __useAffiliateByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useAffiliateByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateByPhoneNumberQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useAffiliateByPhoneNumberQuery(baseOptions: Apollo.QueryHookOptions<AffiliateByPhoneNumberQuery, AffiliateByPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliateByPhoneNumberQuery, AffiliateByPhoneNumberQueryVariables>(AffiliateByPhoneNumberDocument, options);
      }
export function useAffiliateByPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliateByPhoneNumberQuery, AffiliateByPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliateByPhoneNumberQuery, AffiliateByPhoneNumberQueryVariables>(AffiliateByPhoneNumberDocument, options);
        }
export type AffiliateByPhoneNumberQueryHookResult = ReturnType<typeof useAffiliateByPhoneNumberQuery>;
export type AffiliateByPhoneNumberLazyQueryHookResult = ReturnType<typeof useAffiliateByPhoneNumberLazyQuery>;
export type AffiliateByPhoneNumberQueryResult = Apollo.QueryResult<AffiliateByPhoneNumberQuery, AffiliateByPhoneNumberQueryVariables>;
export const TransformLendingTreeLeadToDealDocument = gql`
    mutation TransformLendingTreeLeadToDeal($affiliate: AffiliateInput!) {
  transformLendingTreeLeadToDeal(affiliate: $affiliate) {
    id
    created_at
    updated_at
    state
    type
    source
    customer_id
    customer {
      id
      first_name
      last_name
      email
    }
    car {
      id
      make
      model
      year
      vin
    }
  }
}
    `;
export type TransformLendingTreeLeadToDealMutationFn = Apollo.MutationFunction<TransformLendingTreeLeadToDealMutation, TransformLendingTreeLeadToDealMutationVariables>;

/**
 * __useTransformLendingTreeLeadToDealMutation__
 *
 * To run a mutation, you first call `useTransformLendingTreeLeadToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformLendingTreeLeadToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformLendingTreeLeadToDealMutation, { data, loading, error }] = useTransformLendingTreeLeadToDealMutation({
 *   variables: {
 *      affiliate: // value for 'affiliate'
 *   },
 * });
 */
export function useTransformLendingTreeLeadToDealMutation(baseOptions?: Apollo.MutationHookOptions<TransformLendingTreeLeadToDealMutation, TransformLendingTreeLeadToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransformLendingTreeLeadToDealMutation, TransformLendingTreeLeadToDealMutationVariables>(TransformLendingTreeLeadToDealDocument, options);
      }
export type TransformLendingTreeLeadToDealMutationHookResult = ReturnType<typeof useTransformLendingTreeLeadToDealMutation>;
export type TransformLendingTreeLeadToDealMutationResult = Apollo.MutationResult<TransformLendingTreeLeadToDealMutation>;
export type TransformLendingTreeLeadToDealMutationOptions = Apollo.BaseMutationOptions<TransformLendingTreeLeadToDealMutation, TransformLendingTreeLeadToDealMutationVariables>;
export const OnAffiliateDuplicateFoundDocument = gql`
    subscription onAffiliateDuplicateFound {
  onAffiliateDuplicateFound {
    deal_id
    first_name
    last_name
  }
}
    `;

/**
 * __useOnAffiliateDuplicateFoundSubscription__
 *
 * To run a query within a React component, call `useOnAffiliateDuplicateFoundSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAffiliateDuplicateFoundSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAffiliateDuplicateFoundSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAffiliateDuplicateFoundSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnAffiliateDuplicateFoundSubscription, OnAffiliateDuplicateFoundSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAffiliateDuplicateFoundSubscription, OnAffiliateDuplicateFoundSubscriptionVariables>(OnAffiliateDuplicateFoundDocument, options);
      }
export type OnAffiliateDuplicateFoundSubscriptionHookResult = ReturnType<typeof useOnAffiliateDuplicateFoundSubscription>;
export type OnAffiliateDuplicateFoundSubscriptionResult = Apollo.SubscriptionResult<OnAffiliateDuplicateFoundSubscription>;
export const CreateAffiliateApiKeyDocument = gql`
    mutation createAffiliateApiKey($affiliateApiKey: AffiliateApiKeyInput!) {
  createAffiliateApiKey(affiliateApiKey: $affiliateApiKey)
}
    `;
export type CreateAffiliateApiKeyMutationFn = Apollo.MutationFunction<CreateAffiliateApiKeyMutation, CreateAffiliateApiKeyMutationVariables>;

/**
 * __useCreateAffiliateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateAffiliateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliateApiKeyMutation, { data, loading, error }] = useCreateAffiliateApiKeyMutation({
 *   variables: {
 *      affiliateApiKey: // value for 'affiliateApiKey'
 *   },
 * });
 */
export function useCreateAffiliateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliateApiKeyMutation, CreateAffiliateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliateApiKeyMutation, CreateAffiliateApiKeyMutationVariables>(CreateAffiliateApiKeyDocument, options);
      }
export type CreateAffiliateApiKeyMutationHookResult = ReturnType<typeof useCreateAffiliateApiKeyMutation>;
export type CreateAffiliateApiKeyMutationResult = Apollo.MutationResult<CreateAffiliateApiKeyMutation>;
export type CreateAffiliateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateAffiliateApiKeyMutation, CreateAffiliateApiKeyMutationVariables>;
export const DeactivateAffiliateApiKeyDocument = gql`
    mutation deactivateAffiliateApiKey($affiliateApiKeyId: String!) {
  deactivateAffiliateApiKey(affiliateApiKeyId: $affiliateApiKeyId)
}
    `;
export type DeactivateAffiliateApiKeyMutationFn = Apollo.MutationFunction<DeactivateAffiliateApiKeyMutation, DeactivateAffiliateApiKeyMutationVariables>;

/**
 * __useDeactivateAffiliateApiKeyMutation__
 *
 * To run a mutation, you first call `useDeactivateAffiliateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAffiliateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAffiliateApiKeyMutation, { data, loading, error }] = useDeactivateAffiliateApiKeyMutation({
 *   variables: {
 *      affiliateApiKeyId: // value for 'affiliateApiKeyId'
 *   },
 * });
 */
export function useDeactivateAffiliateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAffiliateApiKeyMutation, DeactivateAffiliateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAffiliateApiKeyMutation, DeactivateAffiliateApiKeyMutationVariables>(DeactivateAffiliateApiKeyDocument, options);
      }
export type DeactivateAffiliateApiKeyMutationHookResult = ReturnType<typeof useDeactivateAffiliateApiKeyMutation>;
export type DeactivateAffiliateApiKeyMutationResult = Apollo.MutationResult<DeactivateAffiliateApiKeyMutation>;
export type DeactivateAffiliateApiKeyMutationOptions = Apollo.BaseMutationOptions<DeactivateAffiliateApiKeyMutation, DeactivateAffiliateApiKeyMutationVariables>;
export const GetAffiliateApiKeysDocument = gql`
    query getAffiliateApiKeys {
  getAffiliateApiKeys {
    id
    affiliate_provider_id
    name
    is_active
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetAffiliateApiKeysQuery__
 *
 * To run a query within a React component, call `useGetAffiliateApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffiliateApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffiliateApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAffiliateApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetAffiliateApiKeysQuery, GetAffiliateApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffiliateApiKeysQuery, GetAffiliateApiKeysQueryVariables>(GetAffiliateApiKeysDocument, options);
      }
export function useGetAffiliateApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffiliateApiKeysQuery, GetAffiliateApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffiliateApiKeysQuery, GetAffiliateApiKeysQueryVariables>(GetAffiliateApiKeysDocument, options);
        }
export type GetAffiliateApiKeysQueryHookResult = ReturnType<typeof useGetAffiliateApiKeysQuery>;
export type GetAffiliateApiKeysLazyQueryHookResult = ReturnType<typeof useGetAffiliateApiKeysLazyQuery>;
export type GetAffiliateApiKeysQueryResult = Apollo.QueryResult<GetAffiliateApiKeysQuery, GetAffiliateApiKeysQueryVariables>;
export const AffiliateProvidersDocument = gql`
    query affiliateProviders {
  affiliateProviders {
    id
    name
    slug
    created_at
    updated_at
  }
}
    `;

/**
 * __useAffiliateProvidersQuery__
 *
 * To run a query within a React component, call `useAffiliateProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAffiliateProvidersQuery(baseOptions?: Apollo.QueryHookOptions<AffiliateProvidersQuery, AffiliateProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliateProvidersQuery, AffiliateProvidersQueryVariables>(AffiliateProvidersDocument, options);
      }
export function useAffiliateProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliateProvidersQuery, AffiliateProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliateProvidersQuery, AffiliateProvidersQueryVariables>(AffiliateProvidersDocument, options);
        }
export type AffiliateProvidersQueryHookResult = ReturnType<typeof useAffiliateProvidersQuery>;
export type AffiliateProvidersLazyQueryHookResult = ReturnType<typeof useAffiliateProvidersLazyQuery>;
export type AffiliateProvidersQueryResult = Apollo.QueryResult<AffiliateProvidersQuery, AffiliateProvidersQueryVariables>;
export const CreateAffiliateProviderDocument = gql`
    mutation createAffiliateProvider($affiliateProvider: AffiliateProviderInput!) {
  createAffiliateProvider(affiliateProvider: $affiliateProvider) {
    id
    name
    slug
    created_at
    updated_at
  }
}
    `;
export type CreateAffiliateProviderMutationFn = Apollo.MutationFunction<CreateAffiliateProviderMutation, CreateAffiliateProviderMutationVariables>;

/**
 * __useCreateAffiliateProviderMutation__
 *
 * To run a mutation, you first call `useCreateAffiliateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliateProviderMutation, { data, loading, error }] = useCreateAffiliateProviderMutation({
 *   variables: {
 *      affiliateProvider: // value for 'affiliateProvider'
 *   },
 * });
 */
export function useCreateAffiliateProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliateProviderMutation, CreateAffiliateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliateProviderMutation, CreateAffiliateProviderMutationVariables>(CreateAffiliateProviderDocument, options);
      }
export type CreateAffiliateProviderMutationHookResult = ReturnType<typeof useCreateAffiliateProviderMutation>;
export type CreateAffiliateProviderMutationResult = Apollo.MutationResult<CreateAffiliateProviderMutation>;
export type CreateAffiliateProviderMutationOptions = Apollo.BaseMutationOptions<CreateAffiliateProviderMutation, CreateAffiliateProviderMutationVariables>;
export const CreateArticleDocument = gql`
    mutation createArticle($article: articleInput) {
  createArticle(article: $article) {
    id
  }
}
    `;
export type CreateArticleMutationFn = Apollo.MutationFunction<CreateArticleMutation, CreateArticleMutationVariables>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      article: // value for 'article'
 *   },
 * });
 */
export function useCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, options);
      }
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>;
export const ArticlesDocument = gql`
    query articles {
  articles {
    id
    title
    headline
    url
    com_visible
    created_at
    thumbnail_key
    thumbnail
  }
}
    `;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlesQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, options);
      }
export function useArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, options);
        }
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQueryHookResult = ReturnType<typeof useArticlesLazyQuery>;
export type ArticlesQueryResult = Apollo.QueryResult<ArticlesQuery, ArticlesQueryVariables>;
export const DeleteArticleDocument = gql`
    mutation deleteArticle($id: ID!) {
  deleteArticle(id: $id) {
    id
  }
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<DeleteArticleMutation, DeleteArticleMutationVariables>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, options);
      }
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation updateArticle($article: articleInput) {
  updateArticle(article: $article) {
    id
    title
    headline
    url
    com_visible
    created_at
    thumbnail_key
    thumbnail
  }
}
    `;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      article: // value for 'article'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const AuctionsDocument = gql`
    query auctions {
  auctions {
    id
    name
    address_line
    zip
    state
  }
}
    `;

/**
 * __useAuctionsQuery__
 *
 * To run a query within a React component, call `useAuctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuctionsQuery(baseOptions?: Apollo.QueryHookOptions<AuctionsQuery, AuctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuctionsQuery, AuctionsQueryVariables>(AuctionsDocument, options);
      }
export function useAuctionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuctionsQuery, AuctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuctionsQuery, AuctionsQueryVariables>(AuctionsDocument, options);
        }
export type AuctionsQueryHookResult = ReturnType<typeof useAuctionsQuery>;
export type AuctionsLazyQueryHookResult = ReturnType<typeof useAuctionsLazyQuery>;
export type AuctionsQueryResult = Apollo.QueryResult<AuctionsQuery, AuctionsQueryVariables>;
export const AuctionUpsertDocument = gql`
    mutation auctionUpsert($auction: auctionInput) {
  auctionUpsert(auction: $auction) {
    id
  }
}
    `;
export type AuctionUpsertMutationFn = Apollo.MutationFunction<AuctionUpsertMutation, AuctionUpsertMutationVariables>;

/**
 * __useAuctionUpsertMutation__
 *
 * To run a mutation, you first call `useAuctionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuctionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auctionUpsertMutation, { data, loading, error }] = useAuctionUpsertMutation({
 *   variables: {
 *      auction: // value for 'auction'
 *   },
 * });
 */
export function useAuctionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<AuctionUpsertMutation, AuctionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuctionUpsertMutation, AuctionUpsertMutationVariables>(AuctionUpsertDocument, options);
      }
export type AuctionUpsertMutationHookResult = ReturnType<typeof useAuctionUpsertMutation>;
export type AuctionUpsertMutationResult = Apollo.MutationResult<AuctionUpsertMutation>;
export type AuctionUpsertMutationOptions = Apollo.BaseMutationOptions<AuctionUpsertMutation, AuctionUpsertMutationVariables>;
export const AuctionDistancesDocument = gql`
    query auctionDistances($data: auctionDistancesInput) {
  auctionDistances(data: $data) {
    name
    transport_cost
    id
  }
}
    `;

/**
 * __useAuctionDistancesQuery__
 *
 * To run a query within a React component, call `useAuctionDistancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuctionDistancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuctionDistancesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuctionDistancesQuery(baseOptions?: Apollo.QueryHookOptions<AuctionDistancesQuery, AuctionDistancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuctionDistancesQuery, AuctionDistancesQueryVariables>(AuctionDistancesDocument, options);
      }
export function useAuctionDistancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuctionDistancesQuery, AuctionDistancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuctionDistancesQuery, AuctionDistancesQueryVariables>(AuctionDistancesDocument, options);
        }
export type AuctionDistancesQueryHookResult = ReturnType<typeof useAuctionDistancesQuery>;
export type AuctionDistancesLazyQueryHookResult = ReturnType<typeof useAuctionDistancesLazyQuery>;
export type AuctionDistancesQueryResult = Apollo.QueryResult<AuctionDistancesQuery, AuctionDistancesQueryVariables>;
export const AuctionAverageTransportCostDocument = gql`
    query auctionAverageTransportCost($id: ID!, $customerAddress: String!) {
  auctionAverageTransportCost(id: $id, customerAddress: $customerAddress)
}
    `;

/**
 * __useAuctionAverageTransportCostQuery__
 *
 * To run a query within a React component, call `useAuctionAverageTransportCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuctionAverageTransportCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuctionAverageTransportCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *      customerAddress: // value for 'customerAddress'
 *   },
 * });
 */
export function useAuctionAverageTransportCostQuery(baseOptions: Apollo.QueryHookOptions<AuctionAverageTransportCostQuery, AuctionAverageTransportCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuctionAverageTransportCostQuery, AuctionAverageTransportCostQueryVariables>(AuctionAverageTransportCostDocument, options);
      }
export function useAuctionAverageTransportCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuctionAverageTransportCostQuery, AuctionAverageTransportCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuctionAverageTransportCostQuery, AuctionAverageTransportCostQueryVariables>(AuctionAverageTransportCostDocument, options);
        }
export type AuctionAverageTransportCostQueryHookResult = ReturnType<typeof useAuctionAverageTransportCostQuery>;
export type AuctionAverageTransportCostLazyQueryHookResult = ReturnType<typeof useAuctionAverageTransportCostLazyQuery>;
export type AuctionAverageTransportCostQueryResult = Apollo.QueryResult<AuctionAverageTransportCostQuery, AuctionAverageTransportCostQueryVariables>;
export const GetAuth0RolesDocument = gql`
    query getAuth0Roles {
  getAuth0Roles {
    id
    name
  }
}
    `;

/**
 * __useGetAuth0RolesQuery__
 *
 * To run a query within a React component, call `useGetAuth0RolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0RolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0RolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuth0RolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAuth0RolesQuery, GetAuth0RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuth0RolesQuery, GetAuth0RolesQueryVariables>(GetAuth0RolesDocument, options);
      }
export function useGetAuth0RolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuth0RolesQuery, GetAuth0RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuth0RolesQuery, GetAuth0RolesQueryVariables>(GetAuth0RolesDocument, options);
        }
export type GetAuth0RolesQueryHookResult = ReturnType<typeof useGetAuth0RolesQuery>;
export type GetAuth0RolesLazyQueryHookResult = ReturnType<typeof useGetAuth0RolesLazyQuery>;
export type GetAuth0RolesQueryResult = Apollo.QueryResult<GetAuth0RolesQuery, GetAuth0RolesQueryVariables>;
export const BanksDocument = gql`
    query banks($state: String, $county: String, $active: Boolean, $selectedBank: String, $dealId: Int) {
  banks(
    state: $state
    county: $county
    active: $active
    selectedBank: $selectedBank
    dealId: $dealId
  ) {
    id
    name
    slug
    provider
    provider_lender_id
    active
    display_name
    bank_markups {
      term_min
      term_max
      max_markup
    }
  }
}
    `;

/**
 * __useBanksQuery__
 *
 * To run a query within a React component, call `useBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanksQuery({
 *   variables: {
 *      state: // value for 'state'
 *      county: // value for 'county'
 *      active: // value for 'active'
 *      selectedBank: // value for 'selectedBank'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useBanksQuery(baseOptions?: Apollo.QueryHookOptions<BanksQuery, BanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BanksQuery, BanksQueryVariables>(BanksDocument, options);
      }
export function useBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BanksQuery, BanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BanksQuery, BanksQueryVariables>(BanksDocument, options);
        }
export type BanksQueryHookResult = ReturnType<typeof useBanksQuery>;
export type BanksLazyQueryHookResult = ReturnType<typeof useBanksLazyQuery>;
export type BanksQueryResult = Apollo.QueryResult<BanksQuery, BanksQueryVariables>;
export const BankInfoDocument = gql`
    query bankInfo($deal_id: ID!) {
  bankInfo(deal_id: $deal_id) {
    name
    address
    city
    state
    zip
    phone
    provider_lender_id
  }
}
    `;

/**
 * __useBankInfoQuery__
 *
 * To run a query within a React component, call `useBankInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankInfoQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useBankInfoQuery(baseOptions: Apollo.QueryHookOptions<BankInfoQuery, BankInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankInfoQuery, BankInfoQueryVariables>(BankInfoDocument, options);
      }
export function useBankInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankInfoQuery, BankInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankInfoQuery, BankInfoQueryVariables>(BankInfoDocument, options);
        }
export type BankInfoQueryHookResult = ReturnType<typeof useBankInfoQuery>;
export type BankInfoLazyQueryHookResult = ReturnType<typeof useBankInfoLazyQuery>;
export type BankInfoQueryResult = Apollo.QueryResult<BankInfoQuery, BankInfoQueryVariables>;
export const GetUserCallHistoryDocument = gql`
    query getUserCallHistory($items_per_page: Int!, $page: Int!) {
  getUserCallHistory(items_per_page: $items_per_page, page: $page) {
    calls {
      id
      callStatus
      direction
      twilioNumber
      fromNumber
      calledNumber
      user_id
      recordingSid
      recordingUrl
      outcome
      calledCity
      calledState
      created_at
      deal {
        id
        state
        customer {
          id
          first_name
          last_name
          phone_number
        }
        cobuyer {
          id
          first_name
          last_name
          phone_number
        }
        contact {
          id
          first_name
          last_name
          phone_number
        }
        second_contact {
          id
          first_name
          last_name
          phone_number
        }
      }
    }
    totalRecords
    newMissedCallIds
  }
}
    `;

/**
 * __useGetUserCallHistoryQuery__
 *
 * To run a query within a React component, call `useGetUserCallHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCallHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCallHistoryQuery({
 *   variables: {
 *      items_per_page: // value for 'items_per_page'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetUserCallHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetUserCallHistoryQuery, GetUserCallHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCallHistoryQuery, GetUserCallHistoryQueryVariables>(GetUserCallHistoryDocument, options);
      }
export function useGetUserCallHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCallHistoryQuery, GetUserCallHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCallHistoryQuery, GetUserCallHistoryQueryVariables>(GetUserCallHistoryDocument, options);
        }
export type GetUserCallHistoryQueryHookResult = ReturnType<typeof useGetUserCallHistoryQuery>;
export type GetUserCallHistoryLazyQueryHookResult = ReturnType<typeof useGetUserCallHistoryLazyQuery>;
export type GetUserCallHistoryQueryResult = Apollo.QueryResult<GetUserCallHistoryQuery, GetUserCallHistoryQueryVariables>;
export const AiCallPayloadDocument = gql`
    query aiCallPayload($dealId: String!) {
  aiCallPayload(dealId: $dealId) {
    dealId
    dealSource
    driverName
    repName
    vehicleYearMakeModel
    vehicleMileage
    payoffAmount
    bankName
    termInMonths
    sellRate
    buyRate
    monthlyPaymentWithVSCGAP
    monthlyPaymentWithVSC
    monthlyPaymentWithGap
    monthlyPaymentWithNoCoverage
    firstPaymentDate
    vscYears
    vscMiles
    currentMiles__vscMiles
    originalWarrantyYears
    originalWarrantyMiles
    lienholderName
    maxMarkup
    moneyDown
    isBuyerNotLessee
    isTitleOnly
    isLesseeOnlyOrDoubleTax
    isWalkInRequired
    isDirectPayDeal
    isRegTransferEligible
  }
}
    `;

/**
 * __useAiCallPayloadQuery__
 *
 * To run a query within a React component, call `useAiCallPayloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiCallPayloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiCallPayloadQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useAiCallPayloadQuery(baseOptions: Apollo.QueryHookOptions<AiCallPayloadQuery, AiCallPayloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiCallPayloadQuery, AiCallPayloadQueryVariables>(AiCallPayloadDocument, options);
      }
export function useAiCallPayloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiCallPayloadQuery, AiCallPayloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiCallPayloadQuery, AiCallPayloadQueryVariables>(AiCallPayloadDocument, options);
        }
export type AiCallPayloadQueryHookResult = ReturnType<typeof useAiCallPayloadQuery>;
export type AiCallPayloadLazyQueryHookResult = ReturnType<typeof useAiCallPayloadLazyQuery>;
export type AiCallPayloadQueryResult = Apollo.QueryResult<AiCallPayloadQuery, AiCallPayloadQueryVariables>;
export const CallOutDocument = gql`
    mutation callOut($calledNumber: String!, $id: ID, $thunderCallerIdOverride: String) {
  callOut(
    calledNumber: $calledNumber
    id: $id
    thunderCallerIdOverride: $thunderCallerIdOverride
  ) {
    calledNumber
    id
  }
}
    `;
export type CallOutMutationFn = Apollo.MutationFunction<CallOutMutation, CallOutMutationVariables>;

/**
 * __useCallOutMutation__
 *
 * To run a mutation, you first call `useCallOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callOutMutation, { data, loading, error }] = useCallOutMutation({
 *   variables: {
 *      calledNumber: // value for 'calledNumber'
 *      id: // value for 'id'
 *      thunderCallerIdOverride: // value for 'thunderCallerIdOverride'
 *   },
 * });
 */
export function useCallOutMutation(baseOptions?: Apollo.MutationHookOptions<CallOutMutation, CallOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallOutMutation, CallOutMutationVariables>(CallOutDocument, options);
      }
export type CallOutMutationHookResult = ReturnType<typeof useCallOutMutation>;
export type CallOutMutationResult = Apollo.MutationResult<CallOutMutation>;
export type CallOutMutationOptions = Apollo.BaseMutationOptions<CallOutMutation, CallOutMutationVariables>;
export const CallOutWithAiDocument = gql`
    mutation callOutWithAi($payload: AICallInputPayload!, $calledNumber: String!) {
  callOutWithAi(payload: $payload, calledNumber: $calledNumber)
}
    `;
export type CallOutWithAiMutationFn = Apollo.MutationFunction<CallOutWithAiMutation, CallOutWithAiMutationVariables>;

/**
 * __useCallOutWithAiMutation__
 *
 * To run a mutation, you first call `useCallOutWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallOutWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callOutWithAiMutation, { data, loading, error }] = useCallOutWithAiMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      calledNumber: // value for 'calledNumber'
 *   },
 * });
 */
export function useCallOutWithAiMutation(baseOptions?: Apollo.MutationHookOptions<CallOutWithAiMutation, CallOutWithAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallOutWithAiMutation, CallOutWithAiMutationVariables>(CallOutWithAiDocument, options);
      }
export type CallOutWithAiMutationHookResult = ReturnType<typeof useCallOutWithAiMutation>;
export type CallOutWithAiMutationResult = Apollo.MutationResult<CallOutWithAiMutation>;
export type CallOutWithAiMutationOptions = Apollo.BaseMutationOptions<CallOutWithAiMutation, CallOutWithAiMutationVariables>;
export const HangUpCallDocument = gql`
    mutation hangUpCall($conference_id: String!) {
  hangUpCall(conference_id: $conference_id)
}
    `;
export type HangUpCallMutationFn = Apollo.MutationFunction<HangUpCallMutation, HangUpCallMutationVariables>;

/**
 * __useHangUpCallMutation__
 *
 * To run a mutation, you first call `useHangUpCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHangUpCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hangUpCallMutation, { data, loading, error }] = useHangUpCallMutation({
 *   variables: {
 *      conference_id: // value for 'conference_id'
 *   },
 * });
 */
export function useHangUpCallMutation(baseOptions?: Apollo.MutationHookOptions<HangUpCallMutation, HangUpCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HangUpCallMutation, HangUpCallMutationVariables>(HangUpCallDocument, options);
      }
export type HangUpCallMutationHookResult = ReturnType<typeof useHangUpCallMutation>;
export type HangUpCallMutationResult = Apollo.MutationResult<HangUpCallMutation>;
export type HangUpCallMutationOptions = Apollo.BaseMutationOptions<HangUpCallMutation, HangUpCallMutationVariables>;
export const SaveNewCustomerCallOutcomeDocument = gql`
    mutation saveNewCustomerCallOutcome($call_id: String!, $outcome: String, $outcome_description: String) {
  saveNewCustomerCallOutcome(
    call_id: $call_id
    outcome: $outcome
    outcome_description: $outcome_description
  ) {
    id
  }
}
    `;
export type SaveNewCustomerCallOutcomeMutationFn = Apollo.MutationFunction<SaveNewCustomerCallOutcomeMutation, SaveNewCustomerCallOutcomeMutationVariables>;

/**
 * __useSaveNewCustomerCallOutcomeMutation__
 *
 * To run a mutation, you first call `useSaveNewCustomerCallOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewCustomerCallOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewCustomerCallOutcomeMutation, { data, loading, error }] = useSaveNewCustomerCallOutcomeMutation({
 *   variables: {
 *      call_id: // value for 'call_id'
 *      outcome: // value for 'outcome'
 *      outcome_description: // value for 'outcome_description'
 *   },
 * });
 */
export function useSaveNewCustomerCallOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<SaveNewCustomerCallOutcomeMutation, SaveNewCustomerCallOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNewCustomerCallOutcomeMutation, SaveNewCustomerCallOutcomeMutationVariables>(SaveNewCustomerCallOutcomeDocument, options);
      }
export type SaveNewCustomerCallOutcomeMutationHookResult = ReturnType<typeof useSaveNewCustomerCallOutcomeMutation>;
export type SaveNewCustomerCallOutcomeMutationResult = Apollo.MutationResult<SaveNewCustomerCallOutcomeMutation>;
export type SaveNewCustomerCallOutcomeMutationOptions = Apollo.BaseMutationOptions<SaveNewCustomerCallOutcomeMutation, SaveNewCustomerCallOutcomeMutationVariables>;
export const OnMissedSipCallDocument = gql`
    subscription onMissedSipCall {
  onMissedSipCall {
    callInfo {
      id
      fromNumber
      deal_id
      calledNumber
      outcome
      recordingSid
      recordingUrl
      callStatus
      direction
      twilioNumber
      user_id
      calledCity
      calledState
    }
  }
}
    `;

/**
 * __useOnMissedSipCallSubscription__
 *
 * To run a query within a React component, call `useOnMissedSipCallSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMissedSipCallSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMissedSipCallSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMissedSipCallSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnMissedSipCallSubscription, OnMissedSipCallSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMissedSipCallSubscription, OnMissedSipCallSubscriptionVariables>(OnMissedSipCallDocument, options);
      }
export type OnMissedSipCallSubscriptionHookResult = ReturnType<typeof useOnMissedSipCallSubscription>;
export type OnMissedSipCallSubscriptionResult = Apollo.SubscriptionResult<OnMissedSipCallSubscription>;
export const GetCallHistoryDocument = gql`
    query getCallHistory($page: Int, $itemsPerPage: Int, $dateFrom: String, $dateTo: String, $agentUserId: String, $outcome: String, $flowType: String, $huntGroupSlug: String, $hasEventType: String, $callSid: String, $conferenceId: String) {
  getCallHistory(
    page: $page
    itemsPerPage: $itemsPerPage
    dateFrom: $dateFrom
    dateTo: $dateTo
    agentUserId: $agentUserId
    outcome: $outcome
    flowType: $flowType
    huntGroupSlug: $huntGroupSlug
    hasEventType: $hasEventType
    callSid: $callSid
    conferenceId: $conferenceId
  ) {
    calls {
      id
      conference_id
      direction
      flow
      outcome
      fromNumber
      calledNumber
      twilioNumber
      agent_name
      user_id
      created_at
      callDuration
      deal_id
      recording_url
      sip_failure_count
      was_transferred
      voicemail_reason
      hunt_group_slug
      customer_name
      hunt_group_name
      participants
    }
    totalRecords
  }
}
    `;

/**
 * __useGetCallHistoryQuery__
 *
 * To run a query within a React component, call `useGetCallHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallHistoryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      agentUserId: // value for 'agentUserId'
 *      outcome: // value for 'outcome'
 *      flowType: // value for 'flowType'
 *      huntGroupSlug: // value for 'huntGroupSlug'
 *      hasEventType: // value for 'hasEventType'
 *      callSid: // value for 'callSid'
 *      conferenceId: // value for 'conferenceId'
 *   },
 * });
 */
export function useGetCallHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetCallHistoryQuery, GetCallHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallHistoryQuery, GetCallHistoryQueryVariables>(GetCallHistoryDocument, options);
      }
export function useGetCallHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallHistoryQuery, GetCallHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallHistoryQuery, GetCallHistoryQueryVariables>(GetCallHistoryDocument, options);
        }
export type GetCallHistoryQueryHookResult = ReturnType<typeof useGetCallHistoryQuery>;
export type GetCallHistoryLazyQueryHookResult = ReturnType<typeof useGetCallHistoryLazyQuery>;
export type GetCallHistoryQueryResult = Apollo.QueryResult<GetCallHistoryQuery, GetCallHistoryQueryVariables>;
export const GetCallLifecycleDocument = gql`
    query getCallLifecycle($conferenceId: String, $callId: String) {
  getCallLifecycle(conferenceId: $conferenceId, callId: $callId) {
    call {
      id
      conference_id
      direction
      flow
      outcome
      fromNumber
      calledNumber
      twilioNumber
      agent_name
      user_id
      created_at
      callDuration
      deal_id
      recording_url
      sip_failure_count
      was_transferred
      voicemail_reason
      hunt_group_slug
      customer_name
      hunt_group_name
    }
    participants {
      id
      conference_id
      participant_user_id
      participant_number
      joined_at
      concluded_at
      transferred
      transferred_from_number
      call_id
    }
    events {
      id
      event_type
      participant_label
      participant_number
      participant_user_id
      participant_user_name
      sequence_number
      hunt_group_slug
      reason
      sip_response_code
      error_code
      error_message
      occurred_at
    }
  }
}
    `;

/**
 * __useGetCallLifecycleQuery__
 *
 * To run a query within a React component, call `useGetCallLifecycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallLifecycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallLifecycleQuery({
 *   variables: {
 *      conferenceId: // value for 'conferenceId'
 *      callId: // value for 'callId'
 *   },
 * });
 */
export function useGetCallLifecycleQuery(baseOptions?: Apollo.QueryHookOptions<GetCallLifecycleQuery, GetCallLifecycleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallLifecycleQuery, GetCallLifecycleQueryVariables>(GetCallLifecycleDocument, options);
      }
export function useGetCallLifecycleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallLifecycleQuery, GetCallLifecycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallLifecycleQuery, GetCallLifecycleQueryVariables>(GetCallLifecycleDocument, options);
        }
export type GetCallLifecycleQueryHookResult = ReturnType<typeof useGetCallLifecycleQuery>;
export type GetCallLifecycleLazyQueryHookResult = ReturnType<typeof useGetCallLifecycleLazyQuery>;
export type GetCallLifecycleQueryResult = Apollo.QueryResult<GetCallLifecycleQuery, GetCallLifecycleQueryVariables>;
export const GetCallHistoryStatsDocument = gql`
    query getCallHistoryStats($dateFrom: String, $dateTo: String, $agentUserId: String, $outcome: String, $flowType: String) {
  getCallHistoryStats(
    dateFrom: $dateFrom
    dateTo: $dateTo
    agentUserId: $agentUserId
    outcome: $outcome
    flowType: $flowType
  ) {
    totalCalls
    answeredCalls
    voicemailCalls
    sipFailures
    transferredCalls
    avgDurationSeconds
    callsByDay {
      date
      count
    }
    callsByOutcome {
      outcome
      count
    }
    callsByFlowType {
      flow
      count
    }
  }
}
    `;

/**
 * __useGetCallHistoryStatsQuery__
 *
 * To run a query within a React component, call `useGetCallHistoryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallHistoryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallHistoryStatsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      agentUserId: // value for 'agentUserId'
 *      outcome: // value for 'outcome'
 *      flowType: // value for 'flowType'
 *   },
 * });
 */
export function useGetCallHistoryStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetCallHistoryStatsQuery, GetCallHistoryStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallHistoryStatsQuery, GetCallHistoryStatsQueryVariables>(GetCallHistoryStatsDocument, options);
      }
export function useGetCallHistoryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallHistoryStatsQuery, GetCallHistoryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallHistoryStatsQuery, GetCallHistoryStatsQueryVariables>(GetCallHistoryStatsDocument, options);
        }
export type GetCallHistoryStatsQueryHookResult = ReturnType<typeof useGetCallHistoryStatsQuery>;
export type GetCallHistoryStatsLazyQueryHookResult = ReturnType<typeof useGetCallHistoryStatsLazyQuery>;
export type GetCallHistoryStatsQueryResult = Apollo.QueryResult<GetCallHistoryStatsQuery, GetCallHistoryStatsQueryVariables>;
export const CarDetailVinDocument = gql`
    query carDetailVin($vin: String) {
  carDetailVin(vin: $vin) {
    year
    make
    model
    vehicle_type
    fuel_type
  }
}
    `;

/**
 * __useCarDetailVinQuery__
 *
 * To run a query within a React component, call `useCarDetailVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDetailVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDetailVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useCarDetailVinQuery(baseOptions?: Apollo.QueryHookOptions<CarDetailVinQuery, CarDetailVinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarDetailVinQuery, CarDetailVinQueryVariables>(CarDetailVinDocument, options);
      }
export function useCarDetailVinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDetailVinQuery, CarDetailVinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarDetailVinQuery, CarDetailVinQueryVariables>(CarDetailVinDocument, options);
        }
export type CarDetailVinQueryHookResult = ReturnType<typeof useCarDetailVinQuery>;
export type CarDetailVinLazyQueryHookResult = ReturnType<typeof useCarDetailVinLazyQuery>;
export type CarDetailVinQueryResult = Apollo.QueryResult<CarDetailVinQuery, CarDetailVinQueryVariables>;
export const CarDetailLicensePlateDocument = gql`
    query carDetailLicensePlate($license_plate_state: String!, $license_plate_number: String!) {
  carDetailLicensePlate(
    license_plate_state: $license_plate_state
    license_plate_number: $license_plate_number
  ) {
    vin
    year
    make
    model
    vehicle_type
    fuel_type
  }
}
    `;

/**
 * __useCarDetailLicensePlateQuery__
 *
 * To run a query within a React component, call `useCarDetailLicensePlateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDetailLicensePlateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDetailLicensePlateQuery({
 *   variables: {
 *      license_plate_state: // value for 'license_plate_state'
 *      license_plate_number: // value for 'license_plate_number'
 *   },
 * });
 */
export function useCarDetailLicensePlateQuery(baseOptions: Apollo.QueryHookOptions<CarDetailLicensePlateQuery, CarDetailLicensePlateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarDetailLicensePlateQuery, CarDetailLicensePlateQueryVariables>(CarDetailLicensePlateDocument, options);
      }
export function useCarDetailLicensePlateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDetailLicensePlateQuery, CarDetailLicensePlateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarDetailLicensePlateQuery, CarDetailLicensePlateQueryVariables>(CarDetailLicensePlateDocument, options);
        }
export type CarDetailLicensePlateQueryHookResult = ReturnType<typeof useCarDetailLicensePlateQuery>;
export type CarDetailLicensePlateLazyQueryHookResult = ReturnType<typeof useCarDetailLicensePlateLazyQuery>;
export type CarDetailLicensePlateQueryResult = Apollo.QueryResult<CarDetailLicensePlateQuery, CarDetailLicensePlateQueryVariables>;
export const GetWarrantyInfoDocument = gql`
    query getWarrantyInfo($make: String!, $mileage: Int!, $year: String!) {
  getWarrantyInfo(make: $make, mileage: $mileage, year: $year) {
    full_years
    full_miles
    full_status
    power_train_years
    power_train_miles
    power_train_status
  }
}
    `;

/**
 * __useGetWarrantyInfoQuery__
 *
 * To run a query within a React component, call `useGetWarrantyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyInfoQuery({
 *   variables: {
 *      make: // value for 'make'
 *      mileage: // value for 'mileage'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetWarrantyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantyInfoQuery, GetWarrantyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyInfoQuery, GetWarrantyInfoQueryVariables>(GetWarrantyInfoDocument, options);
      }
export function useGetWarrantyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyInfoQuery, GetWarrantyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyInfoQuery, GetWarrantyInfoQueryVariables>(GetWarrantyInfoDocument, options);
        }
export type GetWarrantyInfoQueryHookResult = ReturnType<typeof useGetWarrantyInfoQuery>;
export type GetWarrantyInfoLazyQueryHookResult = ReturnType<typeof useGetWarrantyInfoLazyQuery>;
export type GetWarrantyInfoQueryResult = Apollo.QueryResult<GetWarrantyInfoQuery, GetWarrantyInfoQueryVariables>;
export const VehicleInfoUpsertDocument = gql`
    mutation vehicleInfoUpsert($deal: dealInput) {
  vehicleInfoUpsert(deal: $deal) {
    id
    car {
      id
      license_plate_number
      license_plate_state
      vin
      year
      make
      model
      mileage
      color
      book_value
      retail_book_value
      jdp_adjusted_clean_trade
      jdp_adjusted_clean_retail
      vehicle_type
      fuel_type
      kbb_trim_name
      mmr
      registration_expiration
      odometer_status
      kbb_selected_options_object {
        selected_options {
          id
          name
          type
          lendingOptionPrice
          retailOptionPrice
          removed
        }
      }
      cbb_valuation {
        uvc
        trim_name
        vehicle_name
        all_options {
          uoc
          name
          clean
          xclean
          avg
          rough
          auto
        }
        selected_options {
          uoc
          name
          clean
        }
        valuation_date
        data_freq
        inputs {
          kilometres
          province
        }
        lending {
          adjusted
          base
          mileage_adjustment
          option_adjustment
          regional_adjustment
        }
        retail {
          adjusted
          base
          mileage_adjustment
          option_adjustment
          regional_adjustment
        }
      }
      payoff {
        ...PayoffFragment
      }
    }
  }
}
    ${PayoffFragmentFragmentDoc}`;
export type VehicleInfoUpsertMutationFn = Apollo.MutationFunction<VehicleInfoUpsertMutation, VehicleInfoUpsertMutationVariables>;

/**
 * __useVehicleInfoUpsertMutation__
 *
 * To run a mutation, you first call `useVehicleInfoUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVehicleInfoUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vehicleInfoUpsertMutation, { data, loading, error }] = useVehicleInfoUpsertMutation({
 *   variables: {
 *      deal: // value for 'deal'
 *   },
 * });
 */
export function useVehicleInfoUpsertMutation(baseOptions?: Apollo.MutationHookOptions<VehicleInfoUpsertMutation, VehicleInfoUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VehicleInfoUpsertMutation, VehicleInfoUpsertMutationVariables>(VehicleInfoUpsertDocument, options);
      }
export type VehicleInfoUpsertMutationHookResult = ReturnType<typeof useVehicleInfoUpsertMutation>;
export type VehicleInfoUpsertMutationResult = Apollo.MutationResult<VehicleInfoUpsertMutation>;
export type VehicleInfoUpsertMutationOptions = Apollo.BaseMutationOptions<VehicleInfoUpsertMutation, VehicleInfoUpsertMutationVariables>;
export const VehicleMileageDocument = gql`
    query vehicleMileage($vin: String!) {
  vehicleMileage(vin: $vin) {
    estimatedAverageMiles
    eventCount
    lastOdometer
    lastOdometerDate
    resultCode
    resultMessage
    rollback
    vin
  }
}
    `;

/**
 * __useVehicleMileageQuery__
 *
 * To run a query within a React component, call `useVehicleMileageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleMileageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleMileageQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useVehicleMileageQuery(baseOptions: Apollo.QueryHookOptions<VehicleMileageQuery, VehicleMileageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleMileageQuery, VehicleMileageQueryVariables>(VehicleMileageDocument, options);
      }
export function useVehicleMileageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleMileageQuery, VehicleMileageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleMileageQuery, VehicleMileageQueryVariables>(VehicleMileageDocument, options);
        }
export type VehicleMileageQueryHookResult = ReturnType<typeof useVehicleMileageQuery>;
export type VehicleMileageLazyQueryHookResult = ReturnType<typeof useVehicleMileageLazyQuery>;
export type VehicleMileageQueryResult = Apollo.QueryResult<VehicleMileageQuery, VehicleMileageQueryVariables>;
export const UpdateCarDocument = gql`
    mutation updateCar($car: carInput!) {
  updateCar(car: $car) {
    id
    book_value
    retail_book_value
    kbb_lending_mileage_adjustment
    kbb_retail_mileage_adjustment
    kbb_lending_option_adjustment
    kbb_retail_option_adjustment
    kbb_valuation_date
    kbb_vehicle_name
    kbb_trim_name
    kbb_selected_options_object {
      selected_options {
        id
        name
        type
        lendingOptionPrice
        retailOptionPrice
        removed
      }
    }
    cbb_valuation {
      uvc
      trim_name
      vehicle_name
      all_options {
        uoc
        name
        clean
        xclean
        avg
        rough
        auto
      }
      selected_options {
        uoc
        name
        clean
      }
      valuation_date
      data_freq
      inputs {
        kilometres
        province
      }
      lending {
        adjusted
        base
        mileage_adjustment
        option_adjustment
        regional_adjustment
      }
      retail {
        adjusted
        base
        mileage_adjustment
        option_adjustment
        regional_adjustment
      }
    }
    registration_expiration
  }
}
    `;
export type UpdateCarMutationFn = Apollo.MutationFunction<UpdateCarMutation, UpdateCarMutationVariables>;

/**
 * __useUpdateCarMutation__
 *
 * To run a mutation, you first call `useUpdateCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarMutation, { data, loading, error }] = useUpdateCarMutation({
 *   variables: {
 *      car: // value for 'car'
 *   },
 * });
 */
export function useUpdateCarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarMutation, UpdateCarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarMutation, UpdateCarMutationVariables>(UpdateCarDocument, options);
      }
export type UpdateCarMutationHookResult = ReturnType<typeof useUpdateCarMutation>;
export type UpdateCarMutationResult = Apollo.MutationResult<UpdateCarMutation>;
export type UpdateCarMutationOptions = Apollo.BaseMutationOptions<UpdateCarMutation, UpdateCarMutationVariables>;
export const CbbVinDocument = gql`
    query cbbVin($vin: String!, $dealId: ID) {
  cbbVin(vin: $vin, dealId: $dealId) {
    warning
    vehicles {
      uvc
      trim_name
      model_year
      make
      model
      add_deduct_list {
        uoc
        name
        clean
        xclean
        avg
        rough
        auto
      }
    }
  }
}
    `;

/**
 * __useCbbVinQuery__
 *
 * To run a query within a React component, call `useCbbVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbbVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCbbVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCbbVinQuery(baseOptions: Apollo.QueryHookOptions<CbbVinQuery, CbbVinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CbbVinQuery, CbbVinQueryVariables>(CbbVinDocument, options);
      }
export function useCbbVinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CbbVinQuery, CbbVinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CbbVinQuery, CbbVinQueryVariables>(CbbVinDocument, options);
        }
export type CbbVinQueryHookResult = ReturnType<typeof useCbbVinQuery>;
export type CbbVinLazyQueryHookResult = ReturnType<typeof useCbbVinLazyQuery>;
export type CbbVinQueryResult = Apollo.QueryResult<CbbVinQuery, CbbVinQueryVariables>;
export const CbbValuesDocument = gql`
    query cbbValues($data: cbbValuesDataType!) {
  cbbValues(data: $data) {
    uvc
    trim_name
    vehicle_name
    all_options {
      uoc
      name
      clean
      xclean
      avg
      rough
      auto
    }
    selected_options {
      uoc
      name
      clean
    }
    valuation_date
    data_freq
    inputs {
      kilometres
      province
    }
    lending {
      adjusted
      base
      mileage_adjustment
      option_adjustment
      regional_adjustment
    }
    retail {
      adjusted
      base
      mileage_adjustment
      option_adjustment
      regional_adjustment
    }
  }
}
    `;

/**
 * __useCbbValuesQuery__
 *
 * To run a query within a React component, call `useCbbValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbbValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCbbValuesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCbbValuesQuery(baseOptions: Apollo.QueryHookOptions<CbbValuesQuery, CbbValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CbbValuesQuery, CbbValuesQueryVariables>(CbbValuesDocument, options);
      }
export function useCbbValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CbbValuesQuery, CbbValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CbbValuesQuery, CbbValuesQueryVariables>(CbbValuesDocument, options);
        }
export type CbbValuesQueryHookResult = ReturnType<typeof useCbbValuesQuery>;
export type CbbValuesLazyQueryHookResult = ReturnType<typeof useCbbValuesLazyQuery>;
export type CbbValuesQueryResult = Apollo.QueryResult<CbbValuesQuery, CbbValuesQueryVariables>;
export const ConditionReportUpsertDocument = gql`
    mutation conditionReportUpsert($conditionReport: conditionReportUpsertInput) {
  conditionReportUpsert(conditionReport: $conditionReport) {
    id
  }
}
    `;
export type ConditionReportUpsertMutationFn = Apollo.MutationFunction<ConditionReportUpsertMutation, ConditionReportUpsertMutationVariables>;

/**
 * __useConditionReportUpsertMutation__
 *
 * To run a mutation, you first call `useConditionReportUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConditionReportUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [conditionReportUpsertMutation, { data, loading, error }] = useConditionReportUpsertMutation({
 *   variables: {
 *      conditionReport: // value for 'conditionReport'
 *   },
 * });
 */
export function useConditionReportUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ConditionReportUpsertMutation, ConditionReportUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConditionReportUpsertMutation, ConditionReportUpsertMutationVariables>(ConditionReportUpsertDocument, options);
      }
export type ConditionReportUpsertMutationHookResult = ReturnType<typeof useConditionReportUpsertMutation>;
export type ConditionReportUpsertMutationResult = Apollo.MutationResult<ConditionReportUpsertMutation>;
export type ConditionReportUpsertMutationOptions = Apollo.BaseMutationOptions<ConditionReportUpsertMutation, ConditionReportUpsertMutationVariables>;
export const DetermineApprovalQueryDocument = gql`
    query determineApprovalQuery($data: determineApprovalQueryInput) {
  determineApprovalQuery(data: $data) {
    approved
    failedCriteria
  }
}
    `;

/**
 * __useDetermineApprovalQueryQuery__
 *
 * To run a query within a React component, call `useDetermineApprovalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetermineApprovalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetermineApprovalQueryQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDetermineApprovalQueryQuery(baseOptions?: Apollo.QueryHookOptions<DetermineApprovalQueryQuery, DetermineApprovalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetermineApprovalQueryQuery, DetermineApprovalQueryQueryVariables>(DetermineApprovalQueryDocument, options);
      }
export function useDetermineApprovalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetermineApprovalQueryQuery, DetermineApprovalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetermineApprovalQueryQuery, DetermineApprovalQueryQueryVariables>(DetermineApprovalQueryDocument, options);
        }
export type DetermineApprovalQueryQueryHookResult = ReturnType<typeof useDetermineApprovalQueryQuery>;
export type DetermineApprovalQueryLazyQueryHookResult = ReturnType<typeof useDetermineApprovalQueryLazyQuery>;
export type DetermineApprovalQueryQueryResult = Apollo.QueryResult<DetermineApprovalQueryQuery, DetermineApprovalQueryQueryVariables>;
export const SaveConsentDocument = gql`
    mutation saveConsent($dealId: ID, $type: consentNameEnumType) {
  saveConsent(dealId: $dealId, type: $type) {
    isNew
    consent {
      id
      type
    }
  }
}
    `;
export type SaveConsentMutationFn = Apollo.MutationFunction<SaveConsentMutation, SaveConsentMutationVariables>;

/**
 * __useSaveConsentMutation__
 *
 * To run a mutation, you first call `useSaveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConsentMutation, { data, loading, error }] = useSaveConsentMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSaveConsentMutation(baseOptions?: Apollo.MutationHookOptions<SaveConsentMutation, SaveConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConsentMutation, SaveConsentMutationVariables>(SaveConsentDocument, options);
      }
export type SaveConsentMutationHookResult = ReturnType<typeof useSaveConsentMutation>;
export type SaveConsentMutationResult = Apollo.MutationResult<SaveConsentMutation>;
export type SaveConsentMutationOptions = Apollo.BaseMutationOptions<SaveConsentMutation, SaveConsentMutationVariables>;
export const GenerateContractsDocument = gql`
    query generateContracts($data: contractsInput) {
  generateContracts(data: $data) {
    files {
      url
      filename
      key
      mediaType
    }
  }
}
    `;

/**
 * __useGenerateContractsQuery__
 *
 * To run a query within a React component, call `useGenerateContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateContractsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateContractsQuery(baseOptions?: Apollo.QueryHookOptions<GenerateContractsQuery, GenerateContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateContractsQuery, GenerateContractsQueryVariables>(GenerateContractsDocument, options);
      }
export function useGenerateContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateContractsQuery, GenerateContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateContractsQuery, GenerateContractsQueryVariables>(GenerateContractsDocument, options);
        }
export type GenerateContractsQueryHookResult = ReturnType<typeof useGenerateContractsQuery>;
export type GenerateContractsLazyQueryHookResult = ReturnType<typeof useGenerateContractsLazyQuery>;
export type GenerateContractsQueryResult = Apollo.QueryResult<GenerateContractsQuery, GenerateContractsQueryVariables>;
export const DeleteContractsDocument = gql`
    mutation deleteContracts($filePaths: [String]!) {
  deleteContracts(filePaths: $filePaths)
}
    `;
export type DeleteContractsMutationFn = Apollo.MutationFunction<DeleteContractsMutation, DeleteContractsMutationVariables>;

/**
 * __useDeleteContractsMutation__
 *
 * To run a mutation, you first call `useDeleteContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractsMutation, { data, loading, error }] = useDeleteContractsMutation({
 *   variables: {
 *      filePaths: // value for 'filePaths'
 *   },
 * });
 */
export function useDeleteContractsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractsMutation, DeleteContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractsMutation, DeleteContractsMutationVariables>(DeleteContractsDocument, options);
      }
export type DeleteContractsMutationHookResult = ReturnType<typeof useDeleteContractsMutation>;
export type DeleteContractsMutationResult = Apollo.MutationResult<DeleteContractsMutation>;
export type DeleteContractsMutationOptions = Apollo.BaseMutationOptions<DeleteContractsMutation, DeleteContractsMutationVariables>;
export const SendContractsDocument = gql`
    mutation sendContracts($deal_id: ID!, $keys: [String]!) {
  sendContracts(deal_id: $deal_id, keys: $keys)
}
    `;
export type SendContractsMutationFn = Apollo.MutationFunction<SendContractsMutation, SendContractsMutationVariables>;

/**
 * __useSendContractsMutation__
 *
 * To run a mutation, you first call `useSendContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContractsMutation, { data, loading, error }] = useSendContractsMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useSendContractsMutation(baseOptions?: Apollo.MutationHookOptions<SendContractsMutation, SendContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContractsMutation, SendContractsMutationVariables>(SendContractsDocument, options);
      }
export type SendContractsMutationHookResult = ReturnType<typeof useSendContractsMutation>;
export type SendContractsMutationResult = Apollo.MutationResult<SendContractsMutation>;
export type SendContractsMutationOptions = Apollo.BaseMutationOptions<SendContractsMutation, SendContractsMutationVariables>;
export const CreditApplicationSubmissionsDocument = gql`
    query creditApplicationSubmissions($filter: CreditApplicationSubmissionFilter) {
  creditApplicationSubmissions(filter: $filter) {
    id
    created_at
    credit_applications {
      id
      credit_decisions {
        id
        updated_at
        lender_structured_requirement {
          documentation_requirements {
            poi_required
            por_required
            bankruptcy_discharge_required
            employment_verification_required
          }
        }
        provider_lender_id
        provider_decision_id
        ...ProviderDecisionBaseFragment
        application_status
        term
        annual_percentage_rate
        max_markup
        created_at
        balance_amount
        lender_fees
      }
    }
  }
}
    ${ProviderDecisionBaseFragmentFragmentDoc}`;

/**
 * __useCreditApplicationSubmissionsQuery__
 *
 * To run a query within a React component, call `useCreditApplicationSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditApplicationSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditApplicationSubmissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreditApplicationSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<CreditApplicationSubmissionsQuery, CreditApplicationSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditApplicationSubmissionsQuery, CreditApplicationSubmissionsQueryVariables>(CreditApplicationSubmissionsDocument, options);
      }
export function useCreditApplicationSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditApplicationSubmissionsQuery, CreditApplicationSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditApplicationSubmissionsQuery, CreditApplicationSubmissionsQueryVariables>(CreditApplicationSubmissionsDocument, options);
        }
export type CreditApplicationSubmissionsQueryHookResult = ReturnType<typeof useCreditApplicationSubmissionsQuery>;
export type CreditApplicationSubmissionsLazyQueryHookResult = ReturnType<typeof useCreditApplicationSubmissionsLazyQuery>;
export type CreditApplicationSubmissionsQueryResult = Apollo.QueryResult<CreditApplicationSubmissionsQuery, CreditApplicationSubmissionsQueryVariables>;
export const CreditDecisionDataDocument = gql`
    query creditDecisionData($id: Int!) {
  creditDecisionV2(id: $id) {
    id
    application_status
    ...ProviderDecisionDetailsFragment
  }
}
    ${ProviderDecisionDetailsFragmentFragmentDoc}`;

/**
 * __useCreditDecisionDataQuery__
 *
 * To run a query within a React component, call `useCreditDecisionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditDecisionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditDecisionDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditDecisionDataQuery(baseOptions: Apollo.QueryHookOptions<CreditDecisionDataQuery, CreditDecisionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditDecisionDataQuery, CreditDecisionDataQueryVariables>(CreditDecisionDataDocument, options);
      }
export function useCreditDecisionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditDecisionDataQuery, CreditDecisionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditDecisionDataQuery, CreditDecisionDataQueryVariables>(CreditDecisionDataDocument, options);
        }
export type CreditDecisionDataQueryHookResult = ReturnType<typeof useCreditDecisionDataQuery>;
export type CreditDecisionDataLazyQueryHookResult = ReturnType<typeof useCreditDecisionDataLazyQuery>;
export type CreditDecisionDataQueryResult = Apollo.QueryResult<CreditDecisionDataQuery, CreditDecisionDataQueryVariables>;
export const CreditDecisionApplicationNumberDocument = gql`
    query creditDecisionApplicationNumber($id: Int!) {
  creditDecisionV2(id: $id) {
    id
    provider_decision_id
  }
}
    `;

/**
 * __useCreditDecisionApplicationNumberQuery__
 *
 * To run a query within a React component, call `useCreditDecisionApplicationNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditDecisionApplicationNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditDecisionApplicationNumberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditDecisionApplicationNumberQuery(baseOptions: Apollo.QueryHookOptions<CreditDecisionApplicationNumberQuery, CreditDecisionApplicationNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditDecisionApplicationNumberQuery, CreditDecisionApplicationNumberQueryVariables>(CreditDecisionApplicationNumberDocument, options);
      }
export function useCreditDecisionApplicationNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditDecisionApplicationNumberQuery, CreditDecisionApplicationNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditDecisionApplicationNumberQuery, CreditDecisionApplicationNumberQueryVariables>(CreditDecisionApplicationNumberDocument, options);
        }
export type CreditDecisionApplicationNumberQueryHookResult = ReturnType<typeof useCreditDecisionApplicationNumberQuery>;
export type CreditDecisionApplicationNumberLazyQueryHookResult = ReturnType<typeof useCreditDecisionApplicationNumberLazyQuery>;
export type CreditDecisionApplicationNumberQueryResult = Apollo.QueryResult<CreditDecisionApplicationNumberQuery, CreditDecisionApplicationNumberQueryVariables>;
export const SelectCreditDecisionDocument = gql`
    mutation selectCreditDecision($id: ID!) {
  selectCreditDecision(id: $id) {
    ...SelectCreditDecisionFragment
  }
}
    ${SelectCreditDecisionFragmentFragmentDoc}`;
export type SelectCreditDecisionMutationFn = Apollo.MutationFunction<SelectCreditDecisionMutation, SelectCreditDecisionMutationVariables>;

/**
 * __useSelectCreditDecisionMutation__
 *
 * To run a mutation, you first call `useSelectCreditDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectCreditDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectCreditDecisionMutation, { data, loading, error }] = useSelectCreditDecisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectCreditDecisionMutation(baseOptions?: Apollo.MutationHookOptions<SelectCreditDecisionMutation, SelectCreditDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectCreditDecisionMutation, SelectCreditDecisionMutationVariables>(SelectCreditDecisionDocument, options);
      }
export type SelectCreditDecisionMutationHookResult = ReturnType<typeof useSelectCreditDecisionMutation>;
export type SelectCreditDecisionMutationResult = Apollo.MutationResult<SelectCreditDecisionMutation>;
export type SelectCreditDecisionMutationOptions = Apollo.BaseMutationOptions<SelectCreditDecisionMutation, SelectCreditDecisionMutationVariables>;
export const OnCreditDecisionSelectedDocument = gql`
    subscription onCreditDecisionSelected($dealId: ID!) {
  onCreditDecisionSelected(dealId: $dealId) {
    ...SelectCreditDecisionFragment
  }
}
    ${SelectCreditDecisionFragmentFragmentDoc}`;

/**
 * __useOnCreditDecisionSelectedSubscription__
 *
 * To run a query within a React component, call `useOnCreditDecisionSelectedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreditDecisionSelectedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreditDecisionSelectedSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnCreditDecisionSelectedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCreditDecisionSelectedSubscription, OnCreditDecisionSelectedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreditDecisionSelectedSubscription, OnCreditDecisionSelectedSubscriptionVariables>(OnCreditDecisionSelectedDocument, options);
      }
export type OnCreditDecisionSelectedSubscriptionHookResult = ReturnType<typeof useOnCreditDecisionSelectedSubscription>;
export type OnCreditDecisionSelectedSubscriptionResult = Apollo.SubscriptionResult<OnCreditDecisionSelectedSubscription>;
export const GetCreditDecisionByProviderLenderDocument = gql`
    query getCreditDecisionByProviderLender($deal_id: ID!, $provider_lender_id: String!) {
  getCreditDecisionByProviderLender(
    deal_id: $deal_id
    provider_lender_id: $provider_lender_id
  ) {
    id
    provider_decision_id
  }
}
    `;

/**
 * __useGetCreditDecisionByProviderLenderQuery__
 *
 * To run a query within a React component, call `useGetCreditDecisionByProviderLenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditDecisionByProviderLenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditDecisionByProviderLenderQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      provider_lender_id: // value for 'provider_lender_id'
 *   },
 * });
 */
export function useGetCreditDecisionByProviderLenderQuery(baseOptions: Apollo.QueryHookOptions<GetCreditDecisionByProviderLenderQuery, GetCreditDecisionByProviderLenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditDecisionByProviderLenderQuery, GetCreditDecisionByProviderLenderQueryVariables>(GetCreditDecisionByProviderLenderDocument, options);
      }
export function useGetCreditDecisionByProviderLenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditDecisionByProviderLenderQuery, GetCreditDecisionByProviderLenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditDecisionByProviderLenderQuery, GetCreditDecisionByProviderLenderQueryVariables>(GetCreditDecisionByProviderLenderDocument, options);
        }
export type GetCreditDecisionByProviderLenderQueryHookResult = ReturnType<typeof useGetCreditDecisionByProviderLenderQuery>;
export type GetCreditDecisionByProviderLenderLazyQueryHookResult = ReturnType<typeof useGetCreditDecisionByProviderLenderLazyQuery>;
export type GetCreditDecisionByProviderLenderQueryResult = Apollo.QueryResult<GetCreditDecisionByProviderLenderQuery, GetCreditDecisionByProviderLenderQueryVariables>;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($customer: customerInput) {
  updateCustomer(customer: $customer) {
    id
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateCustomerAndAddressDocument = gql`
    mutation updateCustomerAndAddress($customer: customerInput) {
  updateCustomerAndAddress(customer: $customer) {
    id
  }
}
    `;
export type UpdateCustomerAndAddressMutationFn = Apollo.MutationFunction<UpdateCustomerAndAddressMutation, UpdateCustomerAndAddressMutationVariables>;

/**
 * __useUpdateCustomerAndAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAndAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAndAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAndAddressMutation, { data, loading, error }] = useUpdateCustomerAndAddressMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useUpdateCustomerAndAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerAndAddressMutation, UpdateCustomerAndAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerAndAddressMutation, UpdateCustomerAndAddressMutationVariables>(UpdateCustomerAndAddressDocument, options);
      }
export type UpdateCustomerAndAddressMutationHookResult = ReturnType<typeof useUpdateCustomerAndAddressMutation>;
export type UpdateCustomerAndAddressMutationResult = Apollo.MutationResult<UpdateCustomerAndAddressMutation>;
export type UpdateCustomerAndAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerAndAddressMutation, UpdateCustomerAndAddressMutationVariables>;
export const UpdateInsuranceInfoDocument = gql`
    mutation updateInsuranceInfo($id: ID!, $insurance_company: String, $policy_no: String, $expiration_date: Date) {
  updateInsuranceInfo(
    id: $id
    insurance_company: $insurance_company
    policy_no: $policy_no
    expiration_date: $expiration_date
  ) {
    id
    company_name
    expires
    policy_number
  }
}
    `;
export type UpdateInsuranceInfoMutationFn = Apollo.MutationFunction<UpdateInsuranceInfoMutation, UpdateInsuranceInfoMutationVariables>;

/**
 * __useUpdateInsuranceInfoMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceInfoMutation, { data, loading, error }] = useUpdateInsuranceInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      insurance_company: // value for 'insurance_company'
 *      policy_no: // value for 'policy_no'
 *      expiration_date: // value for 'expiration_date'
 *   },
 * });
 */
export function useUpdateInsuranceInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuranceInfoMutation, UpdateInsuranceInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuranceInfoMutation, UpdateInsuranceInfoMutationVariables>(UpdateInsuranceInfoDocument, options);
      }
export type UpdateInsuranceInfoMutationHookResult = ReturnType<typeof useUpdateInsuranceInfoMutation>;
export type UpdateInsuranceInfoMutationResult = Apollo.MutationResult<UpdateInsuranceInfoMutation>;
export type UpdateInsuranceInfoMutationOptions = Apollo.BaseMutationOptions<UpdateInsuranceInfoMutation, UpdateInsuranceInfoMutationVariables>;
export const DealersDocument = gql`
    query dealers {
  dealers {
    id
    name
  }
}
    `;

/**
 * __useDealersQuery__
 *
 * To run a query within a React component, call `useDealersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealersQuery(baseOptions?: Apollo.QueryHookOptions<DealersQuery, DealersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealersQuery, DealersQueryVariables>(DealersDocument, options);
      }
export function useDealersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealersQuery, DealersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealersQuery, DealersQueryVariables>(DealersDocument, options);
        }
export type DealersQueryHookResult = ReturnType<typeof useDealersQuery>;
export type DealersLazyQueryHookResult = ReturnType<typeof useDealersLazyQuery>;
export type DealersQueryResult = Apollo.QueryResult<DealersQuery, DealersQueryVariables>;
export const GetBootedDealsDocument = gql`
    query getBootedDeals($currentPage: Int, $itemsPerPage: Int, $sortColumn: String, $sortDirection: SortDirection, $assignedToMeFilter: Boolean, $assignedToDeletedUsersFilter: Boolean, $startDate: DateTime!, $endDate: DateTime!, $sources: [String]!, $types: [DealType]!, $podIds: [ID], $unreadMessagesFilter: Boolean, $showActiveTags: Boolean, $showMatureFollowUps: Boolean) {
  getBootedDeals(
    currentPage: $currentPage
    itemsPerPage: $itemsPerPage
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    assignedToMeFilter: $assignedToMeFilter
    assignedToDeletedUsersFilter: $assignedToDeletedUsersFilter
    startDate: $startDate
    endDate: $endDate
    sources: $sources
    types: $types
    podIds: $podIds
    unreadMessagesFilter: $unreadMessagesFilter
    showActiveTags: $showActiveTags
    showMatureFollowUps: $showMatureFollowUps
  ) {
    results {
      id
      source
      boot_reason
      car {
        id
        year
        make
        model
      }
      customer {
        id
        first_name
        last_name
      }
      notifications {
        ...NotificationFragment
      }
      deal_dates {
        id
        deal_id
        dates
        custom_dates
      }
    }
    totalRecords
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useGetBootedDealsQuery__
 *
 * To run a query within a React component, call `useGetBootedDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBootedDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBootedDealsQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      assignedToMeFilter: // value for 'assignedToMeFilter'
 *      assignedToDeletedUsersFilter: // value for 'assignedToDeletedUsersFilter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      podIds: // value for 'podIds'
 *      unreadMessagesFilter: // value for 'unreadMessagesFilter'
 *      showActiveTags: // value for 'showActiveTags'
 *      showMatureFollowUps: // value for 'showMatureFollowUps'
 *   },
 * });
 */
export function useGetBootedDealsQuery(baseOptions: Apollo.QueryHookOptions<GetBootedDealsQuery, GetBootedDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBootedDealsQuery, GetBootedDealsQueryVariables>(GetBootedDealsDocument, options);
      }
export function useGetBootedDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBootedDealsQuery, GetBootedDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBootedDealsQuery, GetBootedDealsQueryVariables>(GetBootedDealsDocument, options);
        }
export type GetBootedDealsQueryHookResult = ReturnType<typeof useGetBootedDealsQuery>;
export type GetBootedDealsLazyQueryHookResult = ReturnType<typeof useGetBootedDealsLazyQuery>;
export type GetBootedDealsQueryResult = Apollo.QueryResult<GetBootedDealsQuery, GetBootedDealsQueryVariables>;
export const GetRelationshipToDealByPhoneNumberDocument = gql`
    query getRelationshipToDealByPhoneNumber($phoneNumber: String!) {
  getRelationshipToDealByPhoneNumber(phoneNumber: $phoneNumber) {
    relationship
  }
}
    `;

/**
 * __useGetRelationshipToDealByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetRelationshipToDealByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelationshipToDealByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelationshipToDealByPhoneNumberQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetRelationshipToDealByPhoneNumberQuery(baseOptions: Apollo.QueryHookOptions<GetRelationshipToDealByPhoneNumberQuery, GetRelationshipToDealByPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelationshipToDealByPhoneNumberQuery, GetRelationshipToDealByPhoneNumberQueryVariables>(GetRelationshipToDealByPhoneNumberDocument, options);
      }
export function useGetRelationshipToDealByPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelationshipToDealByPhoneNumberQuery, GetRelationshipToDealByPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelationshipToDealByPhoneNumberQuery, GetRelationshipToDealByPhoneNumberQueryVariables>(GetRelationshipToDealByPhoneNumberDocument, options);
        }
export type GetRelationshipToDealByPhoneNumberQueryHookResult = ReturnType<typeof useGetRelationshipToDealByPhoneNumberQuery>;
export type GetRelationshipToDealByPhoneNumberLazyQueryHookResult = ReturnType<typeof useGetRelationshipToDealByPhoneNumberLazyQuery>;
export type GetRelationshipToDealByPhoneNumberQueryResult = Apollo.QueryResult<GetRelationshipToDealByPhoneNumberQuery, GetRelationshipToDealByPhoneNumberQueryVariables>;
export const SearchDealsDocument = gql`
    query searchDeals($query: String!) {
  searchDeals(query: $query) {
    id
    state
    source
    closer_id
    closer2_id
    setter_id
    customer {
      first_name
      middle_name
      last_name
      phone_number
      home_phone_number
      email
    }
    car {
      vin
    }
  }
}
    `;

/**
 * __useSearchDealsQuery__
 *
 * To run a query within a React component, call `useSearchDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDealsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchDealsQuery(baseOptions: Apollo.QueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
      }
export function useSearchDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDealsQuery, SearchDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDealsQuery, SearchDealsQueryVariables>(SearchDealsDocument, options);
        }
export type SearchDealsQueryHookResult = ReturnType<typeof useSearchDealsQuery>;
export type SearchDealsLazyQueryHookResult = ReturnType<typeof useSearchDealsLazyQuery>;
export type SearchDealsQueryResult = Apollo.QueryResult<SearchDealsQuery, SearchDealsQueryVariables>;
export const TemplateInfoDocument = gql`
    query templateInfo($id: ID!, $sources: [String]!, $types: [DealType]!) {
  deal(id: $id, sources: $sources, types: $types) {
    car {
      year
      make
      model
      payoff {
        lienholder_name
      }
    }
    financial_info {
      money_down
    }
  }
}
    `;

/**
 * __useTemplateInfoQuery__
 *
 * To run a query within a React component, call `useTemplateInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useTemplateInfoQuery(baseOptions: Apollo.QueryHookOptions<TemplateInfoQuery, TemplateInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateInfoQuery, TemplateInfoQueryVariables>(TemplateInfoDocument, options);
      }
export function useTemplateInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateInfoQuery, TemplateInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateInfoQuery, TemplateInfoQueryVariables>(TemplateInfoDocument, options);
        }
export type TemplateInfoQueryHookResult = ReturnType<typeof useTemplateInfoQuery>;
export type TemplateInfoLazyQueryHookResult = ReturnType<typeof useTemplateInfoLazyQuery>;
export type TemplateInfoQueryResult = Apollo.QueryResult<TemplateInfoQuery, TemplateInfoQueryVariables>;
export const DashboardDealsDocument = gql`
    query dashboardDeals($assignedToMeFilter: Boolean, $bootRequestedFilter: Boolean, $assignedToDeletedUsersFilter: Boolean, $unreadMessagesFilter: Boolean, $sources: [String]!, $types: [DealType]!, $states: [String], $showScheduledFollowUps: Boolean, $podIds: [ID], $fsPodIds: [ID], $userId: String, $permissions: [String], $showActiveTags: Boolean, $showMatureFollowUps: Boolean, $closerLocation: LocationType, $loadAll: Boolean) {
  dashboardDeals(
    loadAll: $loadAll
    assignedToMeFilter: $assignedToMeFilter
    bootRequestedFilter: $bootRequestedFilter
    assignedToDeletedUsersFilter: $assignedToDeletedUsersFilter
    unreadMessagesFilter: $unreadMessagesFilter
    sources: $sources
    types: $types
    states: $states
    showScheduledFollowUps: $showScheduledFollowUps
    podIds: $podIds
    fsPodIds: $fsPodIds
    userId: $userId
    permissions: $permissions
    showActiveTags: $showActiveTags
    showMatureFollowUps: $showMatureFollowUps
    closerLocation: $closerLocation
  ) {
    hasMore
    stateCounts {
      state
      count
    }
    deals {
      id
      type
      source
      state
      lane_arrival_utc
      default_sort_date
      paperwork_type
      request_boot
      boot_reason
      created_at
      lock_status
      tags {
        id
        badge_variant
        display_name
        color
        is_dashboard_visible
        badge_variant
      }
      customer {
        id
        first_name
        last_name
        middle_name
        phone_number
        address {
          id
          state
          county
        }
        secure_link {
          id
          expiration_date
        }
      }
      pod {
        id
        name
        color
      }
      fs_pod {
        id
        name
      }
      setter {
        id
        name
      }
      closer_id
      closer {
        id
        name
        location
      }
      closer2 {
        id
        name
        location
      }
      structuring_manager_id
      structuring_manager {
        id
        name
      }
      funding_clerk {
        id
        name
      }
      titling_pod {
        id
        color
        name
      }
      title_clerk {
        id
        name
      }
      title_clerk2 {
        id
        name
      }
      notifications {
        ...NotificationFragment
      }
      follow_up {
        id
        creator_id
        deal_id
        date_utc
        note
        status
        tz
        type
      }
      deal_dates {
        id
        dates
      }
      car {
        id
        payoff {
          id
          lienholder_slug
          lienholder_name
        }
      }
      financial_info {
        id
        bank
        processor
      }
      hasRecentCommunication
      called_by_financial_specialist
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useDashboardDealsQuery__
 *
 * To run a query within a React component, call `useDashboardDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDealsQuery({
 *   variables: {
 *      assignedToMeFilter: // value for 'assignedToMeFilter'
 *      bootRequestedFilter: // value for 'bootRequestedFilter'
 *      assignedToDeletedUsersFilter: // value for 'assignedToDeletedUsersFilter'
 *      unreadMessagesFilter: // value for 'unreadMessagesFilter'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      states: // value for 'states'
 *      showScheduledFollowUps: // value for 'showScheduledFollowUps'
 *      podIds: // value for 'podIds'
 *      fsPodIds: // value for 'fsPodIds'
 *      userId: // value for 'userId'
 *      permissions: // value for 'permissions'
 *      showActiveTags: // value for 'showActiveTags'
 *      showMatureFollowUps: // value for 'showMatureFollowUps'
 *      closerLocation: // value for 'closerLocation'
 *      loadAll: // value for 'loadAll'
 *   },
 * });
 */
export function useDashboardDealsQuery(baseOptions: Apollo.QueryHookOptions<DashboardDealsQuery, DashboardDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardDealsQuery, DashboardDealsQueryVariables>(DashboardDealsDocument, options);
      }
export function useDashboardDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardDealsQuery, DashboardDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardDealsQuery, DashboardDealsQueryVariables>(DashboardDealsDocument, options);
        }
export type DashboardDealsQueryHookResult = ReturnType<typeof useDashboardDealsQuery>;
export type DashboardDealsLazyQueryHookResult = ReturnType<typeof useDashboardDealsLazyQuery>;
export type DashboardDealsQueryResult = Apollo.QueryResult<DashboardDealsQuery, DashboardDealsQueryVariables>;
export const CompletedDealsDocument = gql`
    query completedDeals($currentPage: Int, $itemsPerPage: Int, $assignedToMeFilter: Boolean, $bootRequestedFilter: Boolean, $assignedToDeletedUsersFilter: Boolean, $startDate: DateTime!, $endDate: DateTime!, $sources: [String]!, $types: [DealType]!, $userId: String, $dealState: String, $addressState: String, $podIds: [ID], $notifications: Boolean, $showActiveTags: Boolean, $showMatureFollowUps: Boolean) {
  completedDeals(
    currentPage: $currentPage
    itemsPerPage: $itemsPerPage
    assignedToMeFilter: $assignedToMeFilter
    bootRequestedFilter: $bootRequestedFilter
    assignedToDeletedUsersFilter: $assignedToDeletedUsersFilter
    startDate: $startDate
    endDate: $endDate
    sources: $sources
    types: $types
    dealState: $dealState
    userId: $userId
    addressState: $addressState
    podIds: $podIds
    notifications: $notifications
    showActiveTags: $showActiveTags
    showMatureFollowUps: $showMatureFollowUps
  ) {
    deals {
      id
      type
      state
      completion_date_utc
      completion_date_tz
      customer {
        first_name
        last_name
        name_suffix
        address {
          state
        }
      }
      setter {
        name
      }
      closer {
        name
      }
      closer2 {
        name
      }
      car {
        year
        make
        model
        vin
        payoff {
          lienholder_name
          lender_name
          good_through_date
        }
      }
      financial_info {
        bank
        amount_financed
      }
      notifications {
        ...NotificationFragment
      }
      deal_dates {
        dates
      }
    }
    totalRecords
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useCompletedDealsQuery__
 *
 * To run a query within a React component, call `useCompletedDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedDealsQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      assignedToMeFilter: // value for 'assignedToMeFilter'
 *      bootRequestedFilter: // value for 'bootRequestedFilter'
 *      assignedToDeletedUsersFilter: // value for 'assignedToDeletedUsersFilter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      userId: // value for 'userId'
 *      dealState: // value for 'dealState'
 *      addressState: // value for 'addressState'
 *      podIds: // value for 'podIds'
 *      notifications: // value for 'notifications'
 *      showActiveTags: // value for 'showActiveTags'
 *      showMatureFollowUps: // value for 'showMatureFollowUps'
 *   },
 * });
 */
export function useCompletedDealsQuery(baseOptions: Apollo.QueryHookOptions<CompletedDealsQuery, CompletedDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedDealsQuery, CompletedDealsQueryVariables>(CompletedDealsDocument, options);
      }
export function useCompletedDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedDealsQuery, CompletedDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedDealsQuery, CompletedDealsQueryVariables>(CompletedDealsDocument, options);
        }
export type CompletedDealsQueryHookResult = ReturnType<typeof useCompletedDealsQuery>;
export type CompletedDealsLazyQueryHookResult = ReturnType<typeof useCompletedDealsLazyQuery>;
export type CompletedDealsQueryResult = Apollo.QueryResult<CompletedDealsQuery, CompletedDealsQueryVariables>;
export const NavBarTextNotificationsDocument = gql`
    query navBarTextNotifications($sources: [String!]!, $types: [DealType!]!, $podIds: [ID!], $assignedToMeFilter: Boolean, $bootRequestedFilter: Boolean) {
  navBarTextNotifications(
    sources: $sources
    types: $types
    podIds: $podIds
    assignedToMeFilter: $assignedToMeFilter
    bootRequestedFilter: $bootRequestedFilter
  ) {
    booted
    completed
    followUp
  }
}
    `;

/**
 * __useNavBarTextNotificationsQuery__
 *
 * To run a query within a React component, call `useNavBarTextNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavBarTextNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavBarTextNotificationsQuery({
 *   variables: {
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      podIds: // value for 'podIds'
 *      assignedToMeFilter: // value for 'assignedToMeFilter'
 *      bootRequestedFilter: // value for 'bootRequestedFilter'
 *   },
 * });
 */
export function useNavBarTextNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NavBarTextNotificationsQuery, NavBarTextNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavBarTextNotificationsQuery, NavBarTextNotificationsQueryVariables>(NavBarTextNotificationsDocument, options);
      }
export function useNavBarTextNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavBarTextNotificationsQuery, NavBarTextNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavBarTextNotificationsQuery, NavBarTextNotificationsQueryVariables>(NavBarTextNotificationsDocument, options);
        }
export type NavBarTextNotificationsQueryHookResult = ReturnType<typeof useNavBarTextNotificationsQuery>;
export type NavBarTextNotificationsLazyQueryHookResult = ReturnType<typeof useNavBarTextNotificationsLazyQuery>;
export type NavBarTextNotificationsQueryResult = Apollo.QueryResult<NavBarTextNotificationsQuery, NavBarTextNotificationsQueryVariables>;
export const DuplicateDealsDocument = gql`
    query duplicateDeals($dealId: ID, $firstName: String, $middleName: String, $lastName: String, $phoneNumber: String, $homePhoneNumber: String, $email: String, $vin: String, $matchBootedDeals: Boolean!) {
  duplicateDeals(
    dealId: $dealId
    firstName: $firstName
    middleName: $middleName
    lastName: $lastName
    phoneNumber: $phoneNumber
    homePhoneNumber: $homePhoneNumber
    email: $email
    vin: $vin
    matchBootedDeals: $matchBootedDeals
  ) {
    id
    state
    setter {
      id
      name
      pods {
        id
        name
        color
      }
    }
    closer {
      id
      name
      pods {
        id
        name
        color
      }
    }
    closer2 {
      id
      name
      pods {
        id
        name
        color
      }
    }
    structuring_manager {
      id
      name
      pods {
        id
        name
        color
      }
    }
    funding_clerk {
      id
      name
      pods {
        id
        name
        color
      }
    }
    title_clerk {
      id
      name
      pods {
        id
        name
        color
      }
    }
    title_clerk2 {
      id
      name
      pods {
        id
        name
        color
      }
    }
    customer {
      first_name
      middle_name
      last_name
      phone_number
      email
    }
    car {
      year
      make
      model
      vin
    }
  }
}
    `;

/**
 * __useDuplicateDealsQuery__
 *
 * To run a query within a React component, call `useDuplicateDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateDealsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      homePhoneNumber: // value for 'homePhoneNumber'
 *      email: // value for 'email'
 *      vin: // value for 'vin'
 *      matchBootedDeals: // value for 'matchBootedDeals'
 *   },
 * });
 */
export function useDuplicateDealsQuery(baseOptions: Apollo.QueryHookOptions<DuplicateDealsQuery, DuplicateDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateDealsQuery, DuplicateDealsQueryVariables>(DuplicateDealsDocument, options);
      }
export function useDuplicateDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateDealsQuery, DuplicateDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateDealsQuery, DuplicateDealsQueryVariables>(DuplicateDealsDocument, options);
        }
export type DuplicateDealsQueryHookResult = ReturnType<typeof useDuplicateDealsQuery>;
export type DuplicateDealsLazyQueryHookResult = ReturnType<typeof useDuplicateDealsLazyQuery>;
export type DuplicateDealsQueryResult = Apollo.QueryResult<DuplicateDealsQuery, DuplicateDealsQueryVariables>;
export const SubmitToProvidersDocument = gql`
    mutation submitToProviders($deal: dealInput, $lenderIds: [String]) {
  submitToProviders(deal: $deal, lenderIds: $lenderIds) {
    has_funding_jacket
    financial_info {
      id
    }
  }
}
    `;
export type SubmitToProvidersMutationFn = Apollo.MutationFunction<SubmitToProvidersMutation, SubmitToProvidersMutationVariables>;

/**
 * __useSubmitToProvidersMutation__
 *
 * To run a mutation, you first call `useSubmitToProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitToProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitToProvidersMutation, { data, loading, error }] = useSubmitToProvidersMutation({
 *   variables: {
 *      deal: // value for 'deal'
 *      lenderIds: // value for 'lenderIds'
 *   },
 * });
 */
export function useSubmitToProvidersMutation(baseOptions?: Apollo.MutationHookOptions<SubmitToProvidersMutation, SubmitToProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitToProvidersMutation, SubmitToProvidersMutationVariables>(SubmitToProvidersDocument, options);
      }
export type SubmitToProvidersMutationHookResult = ReturnType<typeof useSubmitToProvidersMutation>;
export type SubmitToProvidersMutationResult = Apollo.MutationResult<SubmitToProvidersMutation>;
export type SubmitToProvidersMutationOptions = Apollo.BaseMutationOptions<SubmitToProvidersMutation, SubmitToProvidersMutationVariables>;
export const DealDetailNetsuiteDocument = gql`
    mutation dealDetailNetsuite($id: ID!) {
  dealDetailNetsuite(id: $id) {
    id
    sent_to_netsuite
  }
}
    `;
export type DealDetailNetsuiteMutationFn = Apollo.MutationFunction<DealDetailNetsuiteMutation, DealDetailNetsuiteMutationVariables>;

/**
 * __useDealDetailNetsuiteMutation__
 *
 * To run a mutation, you first call `useDealDetailNetsuiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealDetailNetsuiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealDetailNetsuiteMutation, { data, loading, error }] = useDealDetailNetsuiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealDetailNetsuiteMutation(baseOptions?: Apollo.MutationHookOptions<DealDetailNetsuiteMutation, DealDetailNetsuiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealDetailNetsuiteMutation, DealDetailNetsuiteMutationVariables>(DealDetailNetsuiteDocument, options);
      }
export type DealDetailNetsuiteMutationHookResult = ReturnType<typeof useDealDetailNetsuiteMutation>;
export type DealDetailNetsuiteMutationResult = Apollo.MutationResult<DealDetailNetsuiteMutation>;
export type DealDetailNetsuiteMutationOptions = Apollo.BaseMutationOptions<DealDetailNetsuiteMutation, DealDetailNetsuiteMutationVariables>;
export const DealUpdateAssignmentsDocument = gql`
    mutation dealUpdateAssignments($id: ID!, $type: DealType, $pod_id: ID, $fs_pod_id: ID, $setter_id: String, $closer_id: String, $closer2_id: String, $structuring_manager_id: String, $funding_clerk_id: String, $titling_pod_id: ID, $title_clerk_id: String, $title_clerk2_id: String, $deal_source: String) {
  dealUpdateAssignments(
    id: $id
    type: $type
    pod_id: $pod_id
    fs_pod_id: $fs_pod_id
    setter_id: $setter_id
    closer_id: $closer_id
    closer2_id: $closer2_id
    structuring_manager_id: $structuring_manager_id
    funding_clerk_id: $funding_clerk_id
    titling_pod_id: $titling_pod_id
    title_clerk_id: $title_clerk_id
    title_clerk2_id: $title_clerk2_id
    deal_source: $deal_source
  ) {
    id
    type
    ...AssignmentUsersFragment
    ...TitleUsersFragment
    source
    car {
      payoff {
        lender_name
        lienholder_name
        lienholder_slug
      }
    }
    customer {
      address {
        moved_states
      }
    }
    financial_info {
      bank
      title_registration_option
      plate_transfer
      buyer_not_lessee
      sales_tax_rate
      base_tax_amount
      warranty_tax_amount
      new_registration_fee
      title_fee
    }
  }
}
    ${AssignmentUsersFragmentFragmentDoc}
${TitleUsersFragmentFragmentDoc}`;
export type DealUpdateAssignmentsMutationFn = Apollo.MutationFunction<DealUpdateAssignmentsMutation, DealUpdateAssignmentsMutationVariables>;

/**
 * __useDealUpdateAssignmentsMutation__
 *
 * To run a mutation, you first call `useDealUpdateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealUpdateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealUpdateAssignmentsMutation, { data, loading, error }] = useDealUpdateAssignmentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      pod_id: // value for 'pod_id'
 *      fs_pod_id: // value for 'fs_pod_id'
 *      setter_id: // value for 'setter_id'
 *      closer_id: // value for 'closer_id'
 *      closer2_id: // value for 'closer2_id'
 *      structuring_manager_id: // value for 'structuring_manager_id'
 *      funding_clerk_id: // value for 'funding_clerk_id'
 *      titling_pod_id: // value for 'titling_pod_id'
 *      title_clerk_id: // value for 'title_clerk_id'
 *      title_clerk2_id: // value for 'title_clerk2_id'
 *      deal_source: // value for 'deal_source'
 *   },
 * });
 */
export function useDealUpdateAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<DealUpdateAssignmentsMutation, DealUpdateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealUpdateAssignmentsMutation, DealUpdateAssignmentsMutationVariables>(DealUpdateAssignmentsDocument, options);
      }
export type DealUpdateAssignmentsMutationHookResult = ReturnType<typeof useDealUpdateAssignmentsMutation>;
export type DealUpdateAssignmentsMutationResult = Apollo.MutationResult<DealUpdateAssignmentsMutation>;
export type DealUpdateAssignmentsMutationOptions = Apollo.BaseMutationOptions<DealUpdateAssignmentsMutation, DealUpdateAssignmentsMutationVariables>;
export const DealUpdateStateDocument = gql`
    mutation dealUpdateState($id: ID!, $state: String, $clearSetDate: Boolean, $clearApprovedDate: Boolean) {
  dealUpdateState(
    id: $id
    state: $state
    clearSetDate: $clearSetDate
    clearApprovedDate: $clearApprovedDate
  ) {
    deal {
      id
      state
      financial_info {
        id
        first_payment_date
      }
    }
    errors
  }
}
    `;
export type DealUpdateStateMutationFn = Apollo.MutationFunction<DealUpdateStateMutation, DealUpdateStateMutationVariables>;

/**
 * __useDealUpdateStateMutation__
 *
 * To run a mutation, you first call `useDealUpdateStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealUpdateStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealUpdateStateMutation, { data, loading, error }] = useDealUpdateStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      clearSetDate: // value for 'clearSetDate'
 *      clearApprovedDate: // value for 'clearApprovedDate'
 *   },
 * });
 */
export function useDealUpdateStateMutation(baseOptions?: Apollo.MutationHookOptions<DealUpdateStateMutation, DealUpdateStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealUpdateStateMutation, DealUpdateStateMutationVariables>(DealUpdateStateDocument, options);
      }
export type DealUpdateStateMutationHookResult = ReturnType<typeof useDealUpdateStateMutation>;
export type DealUpdateStateMutationResult = Apollo.MutationResult<DealUpdateStateMutation>;
export type DealUpdateStateMutationOptions = Apollo.BaseMutationOptions<DealUpdateStateMutation, DealUpdateStateMutationVariables>;
export const ReviveBootDocument = gql`
    mutation reviveBoot($id: ID!, $reassign: Boolean) {
  reviveBoot(id: $id, reassign: $reassign)
}
    `;
export type ReviveBootMutationFn = Apollo.MutationFunction<ReviveBootMutation, ReviveBootMutationVariables>;

/**
 * __useReviveBootMutation__
 *
 * To run a mutation, you first call `useReviveBootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviveBootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviveBootMutation, { data, loading, error }] = useReviveBootMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reassign: // value for 'reassign'
 *   },
 * });
 */
export function useReviveBootMutation(baseOptions?: Apollo.MutationHookOptions<ReviveBootMutation, ReviveBootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviveBootMutation, ReviveBootMutationVariables>(ReviveBootDocument, options);
      }
export type ReviveBootMutationHookResult = ReturnType<typeof useReviveBootMutation>;
export type ReviveBootMutationResult = Apollo.MutationResult<ReviveBootMutation>;
export type ReviveBootMutationOptions = Apollo.BaseMutationOptions<ReviveBootMutation, ReviveBootMutationVariables>;
export const ImportDealDocument = gql`
    mutation importDeal($id: ID!) {
  importDeal(id: $id) {
    id
  }
}
    `;
export type ImportDealMutationFn = Apollo.MutationFunction<ImportDealMutation, ImportDealMutationVariables>;

/**
 * __useImportDealMutation__
 *
 * To run a mutation, you first call `useImportDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDealMutation, { data, loading, error }] = useImportDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportDealMutation(baseOptions?: Apollo.MutationHookOptions<ImportDealMutation, ImportDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDealMutation, ImportDealMutationVariables>(ImportDealDocument, options);
      }
export type ImportDealMutationHookResult = ReturnType<typeof useImportDealMutation>;
export type ImportDealMutationResult = Apollo.MutationResult<ImportDealMutation>;
export type ImportDealMutationOptions = Apollo.BaseMutationOptions<ImportDealMutation, ImportDealMutationVariables>;
export const DealTagsUpsertDocument = gql`
    mutation dealTagsUpsert($dealId: ID!, $tagIds: [ID!]!) {
  dealTagsUpsert(dealId: $dealId, tagIds: $tagIds) {
    id
    badge_variant
    slug
    display_name
    color
    is_active
    is_dashboard_visible
    badge_variant
  }
}
    `;
export type DealTagsUpsertMutationFn = Apollo.MutationFunction<DealTagsUpsertMutation, DealTagsUpsertMutationVariables>;

/**
 * __useDealTagsUpsertMutation__
 *
 * To run a mutation, you first call `useDealTagsUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealTagsUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealTagsUpsertMutation, { data, loading, error }] = useDealTagsUpsertMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useDealTagsUpsertMutation(baseOptions?: Apollo.MutationHookOptions<DealTagsUpsertMutation, DealTagsUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealTagsUpsertMutation, DealTagsUpsertMutationVariables>(DealTagsUpsertDocument, options);
      }
export type DealTagsUpsertMutationHookResult = ReturnType<typeof useDealTagsUpsertMutation>;
export type DealTagsUpsertMutationResult = Apollo.MutationResult<DealTagsUpsertMutation>;
export type DealTagsUpsertMutationOptions = Apollo.BaseMutationOptions<DealTagsUpsertMutation, DealTagsUpsertMutationVariables>;
export const DealAssignDocument = gql`
    mutation dealAssign($deal_id: ID!, $assignee_id: String, $deal_state: String, $role: String!, $allow_reassign: Boolean) {
  dealAssign(
    deal_id: $deal_id
    assignee_id: $assignee_id
    deal_state: $deal_state
    role: $role
    allow_reassign: $allow_reassign
  ) {
    id
  }
}
    `;
export type DealAssignMutationFn = Apollo.MutationFunction<DealAssignMutation, DealAssignMutationVariables>;

/**
 * __useDealAssignMutation__
 *
 * To run a mutation, you first call `useDealAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealAssignMutation, { data, loading, error }] = useDealAssignMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      assignee_id: // value for 'assignee_id'
 *      deal_state: // value for 'deal_state'
 *      role: // value for 'role'
 *      allow_reassign: // value for 'allow_reassign'
 *   },
 * });
 */
export function useDealAssignMutation(baseOptions?: Apollo.MutationHookOptions<DealAssignMutation, DealAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealAssignMutation, DealAssignMutationVariables>(DealAssignDocument, options);
      }
export type DealAssignMutationHookResult = ReturnType<typeof useDealAssignMutation>;
export type DealAssignMutationResult = Apollo.MutationResult<DealAssignMutation>;
export type DealAssignMutationOptions = Apollo.BaseMutationOptions<DealAssignMutation, DealAssignMutationVariables>;
export const DealUpdateRequestBootDocument = gql`
    mutation dealUpdateRequestBoot($id: ID!, $request_boot: Boolean!, $boot_reason: bootReasonInput!, $partial_note: noteInput, $boot_deal: Boolean) {
  dealUpdateRequestBoot(
    id: $id
    request_boot: $request_boot
    boot_reason: $boot_reason
    partial_note: $partial_note
    boot_deal: $boot_deal
  ) {
    id
    state
    request_boot
    boot_reason
  }
}
    `;
export type DealUpdateRequestBootMutationFn = Apollo.MutationFunction<DealUpdateRequestBootMutation, DealUpdateRequestBootMutationVariables>;

/**
 * __useDealUpdateRequestBootMutation__
 *
 * To run a mutation, you first call `useDealUpdateRequestBootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealUpdateRequestBootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealUpdateRequestBootMutation, { data, loading, error }] = useDealUpdateRequestBootMutation({
 *   variables: {
 *      id: // value for 'id'
 *      request_boot: // value for 'request_boot'
 *      boot_reason: // value for 'boot_reason'
 *      partial_note: // value for 'partial_note'
 *      boot_deal: // value for 'boot_deal'
 *   },
 * });
 */
export function useDealUpdateRequestBootMutation(baseOptions?: Apollo.MutationHookOptions<DealUpdateRequestBootMutation, DealUpdateRequestBootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DealUpdateRequestBootMutation, DealUpdateRequestBootMutationVariables>(DealUpdateRequestBootDocument, options);
      }
export type DealUpdateRequestBootMutationHookResult = ReturnType<typeof useDealUpdateRequestBootMutation>;
export type DealUpdateRequestBootMutationResult = Apollo.MutationResult<DealUpdateRequestBootMutation>;
export type DealUpdateRequestBootMutationOptions = Apollo.BaseMutationOptions<DealUpdateRequestBootMutation, DealUpdateRequestBootMutationVariables>;
export const ProcessPaperworkDocument = gql`
    mutation processPaperwork($id: ID!, $state: String!, $paperwork_type: String!) {
  processPaperwork(id: $id, state: $state, paperwork_type: $paperwork_type) {
    ...DashboardDealCacheFragment
  }
}
    ${DashboardDealCacheFragmentFragmentDoc}`;
export type ProcessPaperworkMutationFn = Apollo.MutationFunction<ProcessPaperworkMutation, ProcessPaperworkMutationVariables>;

/**
 * __useProcessPaperworkMutation__
 *
 * To run a mutation, you first call `useProcessPaperworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPaperworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPaperworkMutation, { data, loading, error }] = useProcessPaperworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      paperwork_type: // value for 'paperwork_type'
 *   },
 * });
 */
export function useProcessPaperworkMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPaperworkMutation, ProcessPaperworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPaperworkMutation, ProcessPaperworkMutationVariables>(ProcessPaperworkDocument, options);
      }
export type ProcessPaperworkMutationHookResult = ReturnType<typeof useProcessPaperworkMutation>;
export type ProcessPaperworkMutationResult = Apollo.MutationResult<ProcessPaperworkMutation>;
export type ProcessPaperworkMutationOptions = Apollo.BaseMutationOptions<ProcessPaperworkMutation, ProcessPaperworkMutationVariables>;
export const UpdateCreditAppOnDealDocument = gql`
    mutation updateCreditAppOnDeal($input: CreditAppInput!) {
  updateCreditAppOnDeal(input: $input) {
    id
    state
    odometer_status
    customer {
      ...PersonCreditAppOnDeal
    }
    cobuyer {
      ...PersonCreditAppOnDeal
    }
    original_lessee {
      ...OriginalLesseeFragment
    }
    financial_info {
      id
      term
      money_down
      buyer_not_lessee
      doc_fee
      warranty_tax_amount
      new_registration_fee
      registration_transfer_fee
      base_tax_amount
      sales_tax_rate
    }
    contact {
      ...ContactPerson
    }
    second_contact {
      ...ContactPerson
    }
  }
}
    ${PersonCreditAppOnDealFragmentDoc}
${OriginalLesseeFragmentFragmentDoc}
${ContactPersonFragmentDoc}`;
export type UpdateCreditAppOnDealMutationFn = Apollo.MutationFunction<UpdateCreditAppOnDealMutation, UpdateCreditAppOnDealMutationVariables>;

/**
 * __useUpdateCreditAppOnDealMutation__
 *
 * To run a mutation, you first call `useUpdateCreditAppOnDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditAppOnDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditAppOnDealMutation, { data, loading, error }] = useUpdateCreditAppOnDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditAppOnDealMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditAppOnDealMutation, UpdateCreditAppOnDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditAppOnDealMutation, UpdateCreditAppOnDealMutationVariables>(UpdateCreditAppOnDealDocument, options);
      }
export type UpdateCreditAppOnDealMutationHookResult = ReturnType<typeof useUpdateCreditAppOnDealMutation>;
export type UpdateCreditAppOnDealMutationResult = Apollo.MutationResult<UpdateCreditAppOnDealMutation>;
export type UpdateCreditAppOnDealMutationOptions = Apollo.BaseMutationOptions<UpdateCreditAppOnDealMutation, UpdateCreditAppOnDealMutationVariables>;
export const UpsertOriginalLesseeDocument = gql`
    mutation upsertOriginalLessee($deal_id: Int!, $original_lessee: OriginalLesseeInput!) {
  upsertOriginalLessee(deal_id: $deal_id, original_lessee: $original_lessee) {
    ...OriginalLesseeFragment
  }
}
    ${OriginalLesseeFragmentFragmentDoc}`;
export type UpsertOriginalLesseeMutationFn = Apollo.MutationFunction<UpsertOriginalLesseeMutation, UpsertOriginalLesseeMutationVariables>;

/**
 * __useUpsertOriginalLesseeMutation__
 *
 * To run a mutation, you first call `useUpsertOriginalLesseeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOriginalLesseeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOriginalLesseeMutation, { data, loading, error }] = useUpsertOriginalLesseeMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      original_lessee: // value for 'original_lessee'
 *   },
 * });
 */
export function useUpsertOriginalLesseeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOriginalLesseeMutation, UpsertOriginalLesseeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOriginalLesseeMutation, UpsertOriginalLesseeMutationVariables>(UpsertOriginalLesseeDocument, options);
      }
export type UpsertOriginalLesseeMutationHookResult = ReturnType<typeof useUpsertOriginalLesseeMutation>;
export type UpsertOriginalLesseeMutationResult = Apollo.MutationResult<UpsertOriginalLesseeMutation>;
export type UpsertOriginalLesseeMutationOptions = Apollo.BaseMutationOptions<UpsertOriginalLesseeMutation, UpsertOriginalLesseeMutationVariables>;
export const OverrideCalledByFinancialSpecialistDocument = gql`
    mutation overrideCalledByFinancialSpecialist($dealId: ID!) {
  overrideCalledByFinancialSpecialist(dealId: $dealId) {
    id
    called_by_financial_specialist
  }
}
    `;
export type OverrideCalledByFinancialSpecialistMutationFn = Apollo.MutationFunction<OverrideCalledByFinancialSpecialistMutation, OverrideCalledByFinancialSpecialistMutationVariables>;

/**
 * __useOverrideCalledByFinancialSpecialistMutation__
 *
 * To run a mutation, you first call `useOverrideCalledByFinancialSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideCalledByFinancialSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideCalledByFinancialSpecialistMutation, { data, loading, error }] = useOverrideCalledByFinancialSpecialistMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOverrideCalledByFinancialSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<OverrideCalledByFinancialSpecialistMutation, OverrideCalledByFinancialSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideCalledByFinancialSpecialistMutation, OverrideCalledByFinancialSpecialistMutationVariables>(OverrideCalledByFinancialSpecialistDocument, options);
      }
export type OverrideCalledByFinancialSpecialistMutationHookResult = ReturnType<typeof useOverrideCalledByFinancialSpecialistMutation>;
export type OverrideCalledByFinancialSpecialistMutationResult = Apollo.MutationResult<OverrideCalledByFinancialSpecialistMutation>;
export type OverrideCalledByFinancialSpecialistMutationOptions = Apollo.BaseMutationOptions<OverrideCalledByFinancialSpecialistMutation, OverrideCalledByFinancialSpecialistMutationVariables>;
export const UpdateDealNeedsElectronicSignatureVerificationDocument = gql`
    mutation updateDealNeedsElectronicSignatureVerification($deal_id: ID!, $needs_electronic_signature_verification: Boolean!) {
  updateDealNeedsElectronicSignatureVerification(
    deal_id: $deal_id
    needs_electronic_signature_verification: $needs_electronic_signature_verification
  ) {
    id
    needs_electronic_signature_verification
  }
}
    `;
export type UpdateDealNeedsElectronicSignatureVerificationMutationFn = Apollo.MutationFunction<UpdateDealNeedsElectronicSignatureVerificationMutation, UpdateDealNeedsElectronicSignatureVerificationMutationVariables>;

/**
 * __useUpdateDealNeedsElectronicSignatureVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateDealNeedsElectronicSignatureVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealNeedsElectronicSignatureVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealNeedsElectronicSignatureVerificationMutation, { data, loading, error }] = useUpdateDealNeedsElectronicSignatureVerificationMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      needs_electronic_signature_verification: // value for 'needs_electronic_signature_verification'
 *   },
 * });
 */
export function useUpdateDealNeedsElectronicSignatureVerificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealNeedsElectronicSignatureVerificationMutation, UpdateDealNeedsElectronicSignatureVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealNeedsElectronicSignatureVerificationMutation, UpdateDealNeedsElectronicSignatureVerificationMutationVariables>(UpdateDealNeedsElectronicSignatureVerificationDocument, options);
      }
export type UpdateDealNeedsElectronicSignatureVerificationMutationHookResult = ReturnType<typeof useUpdateDealNeedsElectronicSignatureVerificationMutation>;
export type UpdateDealNeedsElectronicSignatureVerificationMutationResult = Apollo.MutationResult<UpdateDealNeedsElectronicSignatureVerificationMutation>;
export type UpdateDealNeedsElectronicSignatureVerificationMutationOptions = Apollo.BaseMutationOptions<UpdateDealNeedsElectronicSignatureVerificationMutation, UpdateDealNeedsElectronicSignatureVerificationMutationVariables>;
export const DuplicateDealDocument = gql`
    mutation duplicateDeal($dealId: ID!, $duplicationType: DuplicateTypeEnum!) {
  duplicateDeal(dealId: $dealId, duplicationType: $duplicationType) {
    id
  }
}
    `;
export type DuplicateDealMutationFn = Apollo.MutationFunction<DuplicateDealMutation, DuplicateDealMutationVariables>;

/**
 * __useDuplicateDealMutation__
 *
 * To run a mutation, you first call `useDuplicateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDealMutation, { data, loading, error }] = useDuplicateDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      duplicationType: // value for 'duplicationType'
 *   },
 * });
 */
export function useDuplicateDealMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateDealMutation, DuplicateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateDealMutation, DuplicateDealMutationVariables>(DuplicateDealDocument, options);
      }
export type DuplicateDealMutationHookResult = ReturnType<typeof useDuplicateDealMutation>;
export type DuplicateDealMutationResult = Apollo.MutationResult<DuplicateDealMutation>;
export type DuplicateDealMutationOptions = Apollo.BaseMutationOptions<DuplicateDealMutation, DuplicateDealMutationVariables>;
export const OnDealCompleteDocument = gql`
    subscription onDealComplete($sources: [String]!, $types: [DealType]!, $startDate: DateTime!, $endDate: DateTime!) {
  onDealComplete(
    sources: $sources
    types: $types
    startDate: $startDate
    endDate: $endDate
  ) {
    id
  }
}
    `;

/**
 * __useOnDealCompleteSubscription__
 *
 * To run a query within a React component, call `useOnDealCompleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDealCompleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDealCompleteSubscription({
 *   variables: {
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useOnDealCompleteSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDealCompleteSubscription, OnDealCompleteSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDealCompleteSubscription, OnDealCompleteSubscriptionVariables>(OnDealCompleteDocument, options);
      }
export type OnDealCompleteSubscriptionHookResult = ReturnType<typeof useOnDealCompleteSubscription>;
export type OnDealCompleteSubscriptionResult = Apollo.SubscriptionResult<OnDealCompleteSubscription>;
export const OnDealUpdateDocument = gql`
    subscription onDealUpdate($sources: [String!]!, $types: [DealType!], $dealIds: [ID!]) {
  onDealUpdate(sources: $sources, types: $types, dealIds: $dealIds) {
    id
    type
    source
    state
    created_at
    creation_date_tz
    completion_date_utc
    lane_arrival_utc
    default_sort_date
    needs_electronic_signature_verification
    called_by_financial_specialist
    assigned_sms_phone_number
    paperwork_type
    request_boot
    boot_reason
    lock_status
    tags {
      id
      badge_variant
      display_name
      color
      is_dashboard_visible
      badge_variant
    }
    car {
      id
      year
      make
      model
      mileage
      vin
      mmr
      payoff {
        id
        lienholder_name
        lienholder_slug
        lender_name
        vehicle_payoff
        good_through_date
        verification_status
        next_payment_date
      }
    }
    customer {
      id
      first_name
      middle_name
      last_name
      phone_number
      address {
        ...AddressFragment
      }
      secure_link {
        id
        expiration_date
      }
    }
    cobuyer {
      id
      first_name
      middle_name
      last_name
      phone_number
    }
    notifications {
      ...NotificationFragment
    }
    financial_info {
      id
      bank
      amount_financed
    }
    deal_dates {
      id
      deal_id
      dates
      custom_dates
    }
    fs_pod_id
    fs_pod {
      id
      color
      name
    }
    pod_id
    pod {
      id
      color
      name
    }
    titling_pod_id
    titling_pod {
      id
      color
      name
    }
    setter_id
    setter {
      id
      name
      pods {
        id
        name
        color
      }
    }
    closer_id
    closer {
      id
      name
      pods {
        id
        name
        color
      }
    }
    closer2_id
    closer2 {
      id
      name
      pods {
        id
        name
        color
      }
    }
    structuring_manager_id
    structuring_manager {
      id
      name
      pods {
        id
        name
        color
      }
    }
    funding_clerk_id
    funding_clerk {
      id
      name
      pods {
        id
        name
        color
      }
    }
    title_clerk_id
    title_clerk {
      id
      name
      titlingPods {
        id
        name
        color
      }
    }
    title_clerk2_id
    title_clerk2 {
      id
      name
      titlingPods {
        id
        name
        color
      }
    }
    follow_up {
      id
      creator_id
      deal_id
      date_utc
      note
      status
      tz
      type
    }
  }
}
    ${AddressFragmentFragmentDoc}
${NotificationFragmentFragmentDoc}`;

/**
 * __useOnDealUpdateSubscription__
 *
 * To run a query within a React component, call `useOnDealUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDealUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDealUpdateSubscription({
 *   variables: {
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      dealIds: // value for 'dealIds'
 *   },
 * });
 */
export function useOnDealUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDealUpdateSubscription, OnDealUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDealUpdateSubscription, OnDealUpdateSubscriptionVariables>(OnDealUpdateDocument, options);
      }
export type OnDealUpdateSubscriptionHookResult = ReturnType<typeof useOnDealUpdateSubscription>;
export type OnDealUpdateSubscriptionResult = Apollo.SubscriptionResult<OnDealUpdateSubscription>;
export const OnDealLockStatusDocument = gql`
    subscription onDealLockStatus($dealId: Int!) {
  onDealLockStatus(dealId: $dealId) {
    dealId
    lockStatus
  }
}
    `;

/**
 * __useOnDealLockStatusSubscription__
 *
 * To run a query within a React component, call `useOnDealLockStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDealLockStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDealLockStatusSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnDealLockStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDealLockStatusSubscription, OnDealLockStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDealLockStatusSubscription, OnDealLockStatusSubscriptionVariables>(OnDealLockStatusDocument, options);
      }
export type OnDealLockStatusSubscriptionHookResult = ReturnType<typeof useOnDealLockStatusSubscription>;
export type OnDealLockStatusSubscriptionResult = Apollo.SubscriptionResult<OnDealLockStatusSubscription>;
export const CustomDatesUpdateDocument = gql`
    mutation customDatesUpdate($dealId: ID!, $dateKey: CustomDateKeyEnum!, $date: DateTime!) {
  customDatesUpdate(dealId: $dealId, dateKey: $dateKey, date: $date) {
    id
    custom_dates
  }
}
    `;
export type CustomDatesUpdateMutationFn = Apollo.MutationFunction<CustomDatesUpdateMutation, CustomDatesUpdateMutationVariables>;

/**
 * __useCustomDatesUpdateMutation__
 *
 * To run a mutation, you first call `useCustomDatesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDatesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDatesUpdateMutation, { data, loading, error }] = useCustomDatesUpdateMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dateKey: // value for 'dateKey'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCustomDatesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CustomDatesUpdateMutation, CustomDatesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDatesUpdateMutation, CustomDatesUpdateMutationVariables>(CustomDatesUpdateDocument, options);
      }
export type CustomDatesUpdateMutationHookResult = ReturnType<typeof useCustomDatesUpdateMutation>;
export type CustomDatesUpdateMutationResult = Apollo.MutationResult<CustomDatesUpdateMutation>;
export type CustomDatesUpdateMutationOptions = Apollo.BaseMutationOptions<CustomDatesUpdateMutation, CustomDatesUpdateMutationVariables>;
export const DealPackageConfigsDocument = gql`
    query dealPackageConfigs($dealId: Int!) {
  dealPackageConfigs(dealId: $dealId) {
    ...DealPackageConfigFragment
  }
}
    ${DealPackageConfigFragmentFragmentDoc}`;

/**
 * __useDealPackageConfigsQuery__
 *
 * To run a query within a React component, call `useDealPackageConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealPackageConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealPackageConfigsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealPackageConfigsQuery(baseOptions: Apollo.QueryHookOptions<DealPackageConfigsQuery, DealPackageConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealPackageConfigsQuery, DealPackageConfigsQueryVariables>(DealPackageConfigsDocument, options);
      }
export function useDealPackageConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealPackageConfigsQuery, DealPackageConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealPackageConfigsQuery, DealPackageConfigsQueryVariables>(DealPackageConfigsDocument, options);
        }
export type DealPackageConfigsQueryHookResult = ReturnType<typeof useDealPackageConfigsQuery>;
export type DealPackageConfigsLazyQueryHookResult = ReturnType<typeof useDealPackageConfigsLazyQuery>;
export type DealPackageConfigsQueryResult = Apollo.QueryResult<DealPackageConfigsQuery, DealPackageConfigsQueryVariables>;
export const UpsertDealPackageConfigsDocument = gql`
    mutation upsertDealPackageConfigs($input: UpsertDealPackageConfigsInput!) {
  upsertDealPackageConfigs(input: $input) {
    ...DealPackageConfigFragment
  }
}
    ${DealPackageConfigFragmentFragmentDoc}`;
export type UpsertDealPackageConfigsMutationFn = Apollo.MutationFunction<UpsertDealPackageConfigsMutation, UpsertDealPackageConfigsMutationVariables>;

/**
 * __useUpsertDealPackageConfigsMutation__
 *
 * To run a mutation, you first call `useUpsertDealPackageConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDealPackageConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDealPackageConfigsMutation, { data, loading, error }] = useUpsertDealPackageConfigsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDealPackageConfigsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDealPackageConfigsMutation, UpsertDealPackageConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDealPackageConfigsMutation, UpsertDealPackageConfigsMutationVariables>(UpsertDealPackageConfigsDocument, options);
      }
export type UpsertDealPackageConfigsMutationHookResult = ReturnType<typeof useUpsertDealPackageConfigsMutation>;
export type UpsertDealPackageConfigsMutationResult = Apollo.MutationResult<UpsertDealPackageConfigsMutation>;
export type UpsertDealPackageConfigsMutationOptions = Apollo.BaseMutationOptions<UpsertDealPackageConfigsMutation, UpsertDealPackageConfigsMutationVariables>;
export const SetDealProductManualTermDocument = gql`
    mutation setDealProductManualTerm($input: SetDealProductManualTermInputV2!) {
  setDealProductManualTerm(input: $input) {
    id
    deal_id
    product_catalog_id
    price
    cost
    term
    pen_session_id
    pen_rate_id
    pen_form_id
    pen_contract_number
    product_catalog {
      id
      slug
      name
    }
  }
}
    `;
export type SetDealProductManualTermMutationFn = Apollo.MutationFunction<SetDealProductManualTermMutation, SetDealProductManualTermMutationVariables>;

/**
 * __useSetDealProductManualTermMutation__
 *
 * To run a mutation, you first call `useSetDealProductManualTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealProductManualTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealProductManualTermMutation, { data, loading, error }] = useSetDealProductManualTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDealProductManualTermMutation(baseOptions?: Apollo.MutationHookOptions<SetDealProductManualTermMutation, SetDealProductManualTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDealProductManualTermMutation, SetDealProductManualTermMutationVariables>(SetDealProductManualTermDocument, options);
      }
export type SetDealProductManualTermMutationHookResult = ReturnType<typeof useSetDealProductManualTermMutation>;
export type SetDealProductManualTermMutationResult = Apollo.MutationResult<SetDealProductManualTermMutation>;
export type SetDealProductManualTermMutationOptions = Apollo.BaseMutationOptions<SetDealProductManualTermMutation, SetDealProductManualTermMutationVariables>;
export const SelectDealProductVscRateDocument = gql`
    mutation selectDealProductVscRate($input: SelectDealProductVscRateInput!) {
  selectDealProductVscRate(input: $input) {
    vscDealProduct {
      id
      deal_id
      product_catalog_id
      price
      cost
      term
      coverage_type
      pen_session_id
      pen_rate_id
      pen_form_id
      product_catalog {
        id
        slug
        name
      }
    }
    paymentOptions {
      selectedPackageSlotIndex
    }
  }
}
    `;
export type SelectDealProductVscRateMutationFn = Apollo.MutationFunction<SelectDealProductVscRateMutation, SelectDealProductVscRateMutationVariables>;

/**
 * __useSelectDealProductVscRateMutation__
 *
 * To run a mutation, you first call `useSelectDealProductVscRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectDealProductVscRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectDealProductVscRateMutation, { data, loading, error }] = useSelectDealProductVscRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectDealProductVscRateMutation(baseOptions?: Apollo.MutationHookOptions<SelectDealProductVscRateMutation, SelectDealProductVscRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectDealProductVscRateMutation, SelectDealProductVscRateMutationVariables>(SelectDealProductVscRateDocument, options);
      }
export type SelectDealProductVscRateMutationHookResult = ReturnType<typeof useSelectDealProductVscRateMutation>;
export type SelectDealProductVscRateMutationResult = Apollo.MutationResult<SelectDealProductVscRateMutation>;
export type SelectDealProductVscRateMutationOptions = Apollo.BaseMutationOptions<SelectDealProductVscRateMutation, SelectDealProductVscRateMutationVariables>;
export const DealProductsV2Document = gql`
    query dealProductsV2($dealId: Int!) {
  dealProductsV2(dealId: $dealId) {
    ...DealProductFragment
  }
}
    ${DealProductFragmentFragmentDoc}`;

/**
 * __useDealProductsV2Query__
 *
 * To run a query within a React component, call `useDealProductsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDealProductsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealProductsV2Query({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealProductsV2Query(baseOptions: Apollo.QueryHookOptions<DealProductsV2Query, DealProductsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealProductsV2Query, DealProductsV2QueryVariables>(DealProductsV2Document, options);
      }
export function useDealProductsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealProductsV2Query, DealProductsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealProductsV2Query, DealProductsV2QueryVariables>(DealProductsV2Document, options);
        }
export type DealProductsV2QueryHookResult = ReturnType<typeof useDealProductsV2Query>;
export type DealProductsV2LazyQueryHookResult = ReturnType<typeof useDealProductsV2LazyQuery>;
export type DealProductsV2QueryResult = Apollo.QueryResult<DealProductsV2Query, DealProductsV2QueryVariables>;
export const PatchDealProductPricesV2Document = gql`
    mutation patchDealProductPricesV2($input: PatchDealProductPricesInputV2!) {
  patchDealProductPricesV2(input: $input) {
    ...DealProductFragment
  }
}
    ${DealProductFragmentFragmentDoc}`;
export type PatchDealProductPricesV2MutationFn = Apollo.MutationFunction<PatchDealProductPricesV2Mutation, PatchDealProductPricesV2MutationVariables>;

/**
 * __usePatchDealProductPricesV2Mutation__
 *
 * To run a mutation, you first call `usePatchDealProductPricesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchDealProductPricesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchDealProductPricesV2Mutation, { data, loading, error }] = usePatchDealProductPricesV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchDealProductPricesV2Mutation(baseOptions?: Apollo.MutationHookOptions<PatchDealProductPricesV2Mutation, PatchDealProductPricesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchDealProductPricesV2Mutation, PatchDealProductPricesV2MutationVariables>(PatchDealProductPricesV2Document, options);
      }
export type PatchDealProductPricesV2MutationHookResult = ReturnType<typeof usePatchDealProductPricesV2Mutation>;
export type PatchDealProductPricesV2MutationResult = Apollo.MutationResult<PatchDealProductPricesV2Mutation>;
export type PatchDealProductPricesV2MutationOptions = Apollo.BaseMutationOptions<PatchDealProductPricesV2Mutation, PatchDealProductPricesV2MutationVariables>;
export const UpdateDealProductsV2Document = gql`
    mutation updateDealProductsV2($input: UpdateDealProductsInputV2!) {
  updateDealProductsV2(input: $input) {
    id
    selected_package_slot_index
    deal_products {
      id
      deal_id
      product_catalog_id
      price
      cost
      tax_amount
      pen_rate_id
      pen_session_id
      pen_form_id
      pen_contract_number
      term
      coverage_type
      product_catalog {
        id
        slug
        name
        display_order
      }
    }
    financial_info {
      id
      option_type
    }
  }
}
    `;
export type UpdateDealProductsV2MutationFn = Apollo.MutationFunction<UpdateDealProductsV2Mutation, UpdateDealProductsV2MutationVariables>;

/**
 * __useUpdateDealProductsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateDealProductsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealProductsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealProductsV2Mutation, { data, loading, error }] = useUpdateDealProductsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealProductsV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealProductsV2Mutation, UpdateDealProductsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealProductsV2Mutation, UpdateDealProductsV2MutationVariables>(UpdateDealProductsV2Document, options);
      }
export type UpdateDealProductsV2MutationHookResult = ReturnType<typeof useUpdateDealProductsV2Mutation>;
export type UpdateDealProductsV2MutationResult = Apollo.MutationResult<UpdateDealProductsV2Mutation>;
export type UpdateDealProductsV2MutationOptions = Apollo.BaseMutationOptions<UpdateDealProductsV2Mutation, UpdateDealProductsV2MutationVariables>;
export const DealStatesDocument = gql`
    query dealStates($dealId: ID!) {
  dealStates(dealId: $dealId) {
    id
    state
    updated_date_utc
    updated_at
    user {
      name
    }
  }
}
    `;

/**
 * __useDealStatesQuery__
 *
 * To run a query within a React component, call `useDealStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealStatesQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealStatesQuery(baseOptions: Apollo.QueryHookOptions<DealStatesQuery, DealStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealStatesQuery, DealStatesQueryVariables>(DealStatesDocument, options);
      }
export function useDealStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealStatesQuery, DealStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealStatesQuery, DealStatesQueryVariables>(DealStatesDocument, options);
        }
export type DealStatesQueryHookResult = ReturnType<typeof useDealStatesQuery>;
export type DealStatesLazyQueryHookResult = ReturnType<typeof useDealStatesLazyQuery>;
export type DealStatesQueryResult = Apollo.QueryResult<DealStatesQuery, DealStatesQueryVariables>;
export const CreateDdDevDealDocument = gql`
    mutation createDdDevDeal {
  createDdDevDeal
}
    `;
export type CreateDdDevDealMutationFn = Apollo.MutationFunction<CreateDdDevDealMutation, CreateDdDevDealMutationVariables>;

/**
 * __useCreateDdDevDealMutation__
 *
 * To run a mutation, you first call `useCreateDdDevDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDdDevDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDdDevDealMutation, { data, loading, error }] = useCreateDdDevDealMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDdDevDealMutation(baseOptions?: Apollo.MutationHookOptions<CreateDdDevDealMutation, CreateDdDevDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDdDevDealMutation, CreateDdDevDealMutationVariables>(CreateDdDevDealDocument, options);
      }
export type CreateDdDevDealMutationHookResult = ReturnType<typeof useCreateDdDevDealMutation>;
export type CreateDdDevDealMutationResult = Apollo.MutationResult<CreateDdDevDealMutation>;
export type CreateDdDevDealMutationOptions = Apollo.BaseMutationOptions<CreateDdDevDealMutation, CreateDdDevDealMutationVariables>;
export const GenerateDocumentsDocument = gql`
    query generateDocuments($data: documentsInput) {
  generateDocuments(data: $data) {
    files {
      ...FileFragment
    }
    errors
  }
}
    ${FileFragmentFragmentDoc}`;

/**
 * __useGenerateDocumentsQuery__
 *
 * To run a query within a React component, call `useGenerateDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDocumentsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GenerateDocumentsQuery, GenerateDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateDocumentsQuery, GenerateDocumentsQueryVariables>(GenerateDocumentsDocument, options);
      }
export function useGenerateDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateDocumentsQuery, GenerateDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateDocumentsQuery, GenerateDocumentsQueryVariables>(GenerateDocumentsDocument, options);
        }
export type GenerateDocumentsQueryHookResult = ReturnType<typeof useGenerateDocumentsQuery>;
export type GenerateDocumentsLazyQueryHookResult = ReturnType<typeof useGenerateDocumentsLazyQuery>;
export type GenerateDocumentsQueryResult = Apollo.QueryResult<GenerateDocumentsQuery, GenerateDocumentsQueryVariables>;
export const GenerateRoiDocumentsDocument = gql`
    query generateROIDocuments($data: documentsInput) {
  generateROIDocuments(data: $data) {
    files {
      ...FileFragment
    }
    errors
  }
}
    ${FileFragmentFragmentDoc}`;

/**
 * __useGenerateRoiDocumentsQuery__
 *
 * To run a query within a React component, call `useGenerateRoiDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateRoiDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateRoiDocumentsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGenerateRoiDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GenerateRoiDocumentsQuery, GenerateRoiDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateRoiDocumentsQuery, GenerateRoiDocumentsQueryVariables>(GenerateRoiDocumentsDocument, options);
      }
export function useGenerateRoiDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateRoiDocumentsQuery, GenerateRoiDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateRoiDocumentsQuery, GenerateRoiDocumentsQueryVariables>(GenerateRoiDocumentsDocument, options);
        }
export type GenerateRoiDocumentsQueryHookResult = ReturnType<typeof useGenerateRoiDocumentsQuery>;
export type GenerateRoiDocumentsLazyQueryHookResult = ReturnType<typeof useGenerateRoiDocumentsLazyQuery>;
export type GenerateRoiDocumentsQueryResult = Apollo.QueryResult<GenerateRoiDocumentsQuery, GenerateRoiDocumentsQueryVariables>;
export const RetrieveDealDocsUploadedToR1Document = gql`
    query retrieveDealDocsUploadedToR1($dealId: ID!, $includePdfBinary: Boolean) {
  retrieveDealDocsUploadedToR1(
    dealId: $dealId
    includePdfBinary: $includePdfBinary
  ) {
    displayName
    documentName
    documentType
    signatureStatus
    completedAt
  }
}
    `;

/**
 * __useRetrieveDealDocsUploadedToR1Query__
 *
 * To run a query within a React component, call `useRetrieveDealDocsUploadedToR1Query` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveDealDocsUploadedToR1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveDealDocsUploadedToR1Query({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      includePdfBinary: // value for 'includePdfBinary'
 *   },
 * });
 */
export function useRetrieveDealDocsUploadedToR1Query(baseOptions: Apollo.QueryHookOptions<RetrieveDealDocsUploadedToR1Query, RetrieveDealDocsUploadedToR1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveDealDocsUploadedToR1Query, RetrieveDealDocsUploadedToR1QueryVariables>(RetrieveDealDocsUploadedToR1Document, options);
      }
export function useRetrieveDealDocsUploadedToR1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveDealDocsUploadedToR1Query, RetrieveDealDocsUploadedToR1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveDealDocsUploadedToR1Query, RetrieveDealDocsUploadedToR1QueryVariables>(RetrieveDealDocsUploadedToR1Document, options);
        }
export type RetrieveDealDocsUploadedToR1QueryHookResult = ReturnType<typeof useRetrieveDealDocsUploadedToR1Query>;
export type RetrieveDealDocsUploadedToR1LazyQueryHookResult = ReturnType<typeof useRetrieveDealDocsUploadedToR1LazyQuery>;
export type RetrieveDealDocsUploadedToR1QueryResult = Apollo.QueryResult<RetrieveDealDocsUploadedToR1Query, RetrieveDealDocsUploadedToR1QueryVariables>;
export const ValidateBankContractDocument = gql`
    query validateBankContract($deal_id: ID!) {
  validateBankContract(deal_id: $deal_id)
}
    `;

/**
 * __useValidateBankContractQuery__
 *
 * To run a query within a React component, call `useValidateBankContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBankContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBankContractQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useValidateBankContractQuery(baseOptions: Apollo.QueryHookOptions<ValidateBankContractQuery, ValidateBankContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBankContractQuery, ValidateBankContractQueryVariables>(ValidateBankContractDocument, options);
      }
export function useValidateBankContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBankContractQuery, ValidateBankContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBankContractQuery, ValidateBankContractQueryVariables>(ValidateBankContractDocument, options);
        }
export type ValidateBankContractQueryHookResult = ReturnType<typeof useValidateBankContractQuery>;
export type ValidateBankContractLazyQueryHookResult = ReturnType<typeof useValidateBankContractLazyQuery>;
export type ValidateBankContractQueryResult = Apollo.QueryResult<ValidateBankContractQuery, ValidateBankContractQueryVariables>;
export const LatestThirdPartyPayoffSendDocument = gql`
    query latestThirdPartyPayoffSend($dealId: ID!) {
  latestThirdPartyPayoffSend(dealId: $dealId) {
    id
    status
    created_at
  }
}
    `;

/**
 * __useLatestThirdPartyPayoffSendQuery__
 *
 * To run a query within a React component, call `useLatestThirdPartyPayoffSendQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestThirdPartyPayoffSendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestThirdPartyPayoffSendQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useLatestThirdPartyPayoffSendQuery(baseOptions: Apollo.QueryHookOptions<LatestThirdPartyPayoffSendQuery, LatestThirdPartyPayoffSendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestThirdPartyPayoffSendQuery, LatestThirdPartyPayoffSendQueryVariables>(LatestThirdPartyPayoffSendDocument, options);
      }
export function useLatestThirdPartyPayoffSendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestThirdPartyPayoffSendQuery, LatestThirdPartyPayoffSendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestThirdPartyPayoffSendQuery, LatestThirdPartyPayoffSendQueryVariables>(LatestThirdPartyPayoffSendDocument, options);
        }
export type LatestThirdPartyPayoffSendQueryHookResult = ReturnType<typeof useLatestThirdPartyPayoffSendQuery>;
export type LatestThirdPartyPayoffSendLazyQueryHookResult = ReturnType<typeof useLatestThirdPartyPayoffSendLazyQuery>;
export type LatestThirdPartyPayoffSendQueryResult = Apollo.QueryResult<LatestThirdPartyPayoffSendQuery, LatestThirdPartyPayoffSendQueryVariables>;
export const GeneratePurchaseOrderDocument = gql`
    query generatePurchaseOrder($deal_id: ID!) {
  generatePurchaseOrder(deal_id: $deal_id) {
    files {
      ...FileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;

/**
 * __useGeneratePurchaseOrderQuery__
 *
 * To run a query within a React component, call `useGeneratePurchaseOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePurchaseOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePurchaseOrderQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useGeneratePurchaseOrderQuery(baseOptions: Apollo.QueryHookOptions<GeneratePurchaseOrderQuery, GeneratePurchaseOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneratePurchaseOrderQuery, GeneratePurchaseOrderQueryVariables>(GeneratePurchaseOrderDocument, options);
      }
export function useGeneratePurchaseOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneratePurchaseOrderQuery, GeneratePurchaseOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneratePurchaseOrderQuery, GeneratePurchaseOrderQueryVariables>(GeneratePurchaseOrderDocument, options);
        }
export type GeneratePurchaseOrderQueryHookResult = ReturnType<typeof useGeneratePurchaseOrderQuery>;
export type GeneratePurchaseOrderLazyQueryHookResult = ReturnType<typeof useGeneratePurchaseOrderLazyQuery>;
export type GeneratePurchaseOrderQueryResult = Apollo.QueryResult<GeneratePurchaseOrderQuery, GeneratePurchaseOrderQueryVariables>;
export const UploadDocumentToRouteOneDocument = gql`
    mutation uploadDocumentToRouteOne($dealId: ID!, $doc: UploadDocumentsInput!, $withCobuyer: Boolean!) {
  uploadDocumentToRouteOne(dealId: $dealId, doc: $doc, withCobuyer: $withCobuyer)
}
    `;
export type UploadDocumentToRouteOneMutationFn = Apollo.MutationFunction<UploadDocumentToRouteOneMutation, UploadDocumentToRouteOneMutationVariables>;

/**
 * __useUploadDocumentToRouteOneMutation__
 *
 * To run a mutation, you first call `useUploadDocumentToRouteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentToRouteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentToRouteOneMutation, { data, loading, error }] = useUploadDocumentToRouteOneMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      doc: // value for 'doc'
 *      withCobuyer: // value for 'withCobuyer'
 *   },
 * });
 */
export function useUploadDocumentToRouteOneMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentToRouteOneMutation, UploadDocumentToRouteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentToRouteOneMutation, UploadDocumentToRouteOneMutationVariables>(UploadDocumentToRouteOneDocument, options);
      }
export type UploadDocumentToRouteOneMutationHookResult = ReturnType<typeof useUploadDocumentToRouteOneMutation>;
export type UploadDocumentToRouteOneMutationResult = Apollo.MutationResult<UploadDocumentToRouteOneMutation>;
export type UploadDocumentToRouteOneMutationOptions = Apollo.BaseMutationOptions<UploadDocumentToRouteOneMutation, UploadDocumentToRouteOneMutationVariables>;
export const SetReadyForSignaturesStatusDocument = gql`
    mutation setReadyForSignaturesStatus($dealId: ID!, $documentProgressStatus: DocumentProgressStatus) {
  setReadyForSignaturesStatus(
    dealId: $dealId
    documentProgressStatus: $documentProgressStatus
  )
}
    `;
export type SetReadyForSignaturesStatusMutationFn = Apollo.MutationFunction<SetReadyForSignaturesStatusMutation, SetReadyForSignaturesStatusMutationVariables>;

/**
 * __useSetReadyForSignaturesStatusMutation__
 *
 * To run a mutation, you first call `useSetReadyForSignaturesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReadyForSignaturesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReadyForSignaturesStatusMutation, { data, loading, error }] = useSetReadyForSignaturesStatusMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      documentProgressStatus: // value for 'documentProgressStatus'
 *   },
 * });
 */
export function useSetReadyForSignaturesStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetReadyForSignaturesStatusMutation, SetReadyForSignaturesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReadyForSignaturesStatusMutation, SetReadyForSignaturesStatusMutationVariables>(SetReadyForSignaturesStatusDocument, options);
      }
export type SetReadyForSignaturesStatusMutationHookResult = ReturnType<typeof useSetReadyForSignaturesStatusMutation>;
export type SetReadyForSignaturesStatusMutationResult = Apollo.MutationResult<SetReadyForSignaturesStatusMutation>;
export type SetReadyForSignaturesStatusMutationOptions = Apollo.BaseMutationOptions<SetReadyForSignaturesStatusMutation, SetReadyForSignaturesStatusMutationVariables>;
export const MergeFilesDocument = gql`
    mutation mergeFiles($dealId: ID!, $docs: [dealMediaInput]) {
  mergeFiles(dealId: $dealId, docs: $docs) {
    url
    filename
    key
  }
}
    `;
export type MergeFilesMutationFn = Apollo.MutationFunction<MergeFilesMutation, MergeFilesMutationVariables>;

/**
 * __useMergeFilesMutation__
 *
 * To run a mutation, you first call `useMergeFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeFilesMutation, { data, loading, error }] = useMergeFilesMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      docs: // value for 'docs'
 *   },
 * });
 */
export function useMergeFilesMutation(baseOptions?: Apollo.MutationHookOptions<MergeFilesMutation, MergeFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeFilesMutation, MergeFilesMutationVariables>(MergeFilesDocument, options);
      }
export type MergeFilesMutationHookResult = ReturnType<typeof useMergeFilesMutation>;
export type MergeFilesMutationResult = Apollo.MutationResult<MergeFilesMutation>;
export type MergeFilesMutationOptions = Apollo.BaseMutationOptions<MergeFilesMutation, MergeFilesMutationVariables>;
export const AddDocumentsToMediaCenterDocument = gql`
    mutation addDocumentsToMediaCenter($deal_id: ID!, $files: [addDocumentsToMediaCenterInput]!) {
  addDocumentsToMediaCenter(deal_id: $deal_id, files: $files)
}
    `;
export type AddDocumentsToMediaCenterMutationFn = Apollo.MutationFunction<AddDocumentsToMediaCenterMutation, AddDocumentsToMediaCenterMutationVariables>;

/**
 * __useAddDocumentsToMediaCenterMutation__
 *
 * To run a mutation, you first call `useAddDocumentsToMediaCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentsToMediaCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentsToMediaCenterMutation, { data, loading, error }] = useAddDocumentsToMediaCenterMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddDocumentsToMediaCenterMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentsToMediaCenterMutation, AddDocumentsToMediaCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentsToMediaCenterMutation, AddDocumentsToMediaCenterMutationVariables>(AddDocumentsToMediaCenterDocument, options);
      }
export type AddDocumentsToMediaCenterMutationHookResult = ReturnType<typeof useAddDocumentsToMediaCenterMutation>;
export type AddDocumentsToMediaCenterMutationResult = Apollo.MutationResult<AddDocumentsToMediaCenterMutation>;
export type AddDocumentsToMediaCenterMutationOptions = Apollo.BaseMutationOptions<AddDocumentsToMediaCenterMutation, AddDocumentsToMediaCenterMutationVariables>;
export const SendDocumentsWithAdobeAndUpdateStateDocument = gql`
    mutation sendDocumentsWithAdobeAndUpdateState($deal_id: ID!, $keys: [String]!, $state: DealStateEnum!) {
  sendDocumentsWithAdobeAndUpdateState(
    deal_id: $deal_id
    keys: $keys
    state: $state
  ) {
    id
    state
  }
}
    `;
export type SendDocumentsWithAdobeAndUpdateStateMutationFn = Apollo.MutationFunction<SendDocumentsWithAdobeAndUpdateStateMutation, SendDocumentsWithAdobeAndUpdateStateMutationVariables>;

/**
 * __useSendDocumentsWithAdobeAndUpdateStateMutation__
 *
 * To run a mutation, you first call `useSendDocumentsWithAdobeAndUpdateStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDocumentsWithAdobeAndUpdateStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDocumentsWithAdobeAndUpdateStateMutation, { data, loading, error }] = useSendDocumentsWithAdobeAndUpdateStateMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      keys: // value for 'keys'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSendDocumentsWithAdobeAndUpdateStateMutation(baseOptions?: Apollo.MutationHookOptions<SendDocumentsWithAdobeAndUpdateStateMutation, SendDocumentsWithAdobeAndUpdateStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDocumentsWithAdobeAndUpdateStateMutation, SendDocumentsWithAdobeAndUpdateStateMutationVariables>(SendDocumentsWithAdobeAndUpdateStateDocument, options);
      }
export type SendDocumentsWithAdobeAndUpdateStateMutationHookResult = ReturnType<typeof useSendDocumentsWithAdobeAndUpdateStateMutation>;
export type SendDocumentsWithAdobeAndUpdateStateMutationResult = Apollo.MutationResult<SendDocumentsWithAdobeAndUpdateStateMutation>;
export type SendDocumentsWithAdobeAndUpdateStateMutationOptions = Apollo.BaseMutationOptions<SendDocumentsWithAdobeAndUpdateStateMutation, SendDocumentsWithAdobeAndUpdateStateMutationVariables>;
export const SendRoiDocumentsWithAdobeDocument = gql`
    mutation sendROIDocumentsWithAdobe($deal_id: ID!, $keys: [String]!) {
  sendROIDocumentsWithAdobe(deal_id: $deal_id, keys: $keys) {
    id
    roi_document_info {
      id
      adobe_agreement_id
    }
  }
}
    `;
export type SendRoiDocumentsWithAdobeMutationFn = Apollo.MutationFunction<SendRoiDocumentsWithAdobeMutation, SendRoiDocumentsWithAdobeMutationVariables>;

/**
 * __useSendRoiDocumentsWithAdobeMutation__
 *
 * To run a mutation, you first call `useSendRoiDocumentsWithAdobeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRoiDocumentsWithAdobeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRoiDocumentsWithAdobeMutation, { data, loading, error }] = useSendRoiDocumentsWithAdobeMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useSendRoiDocumentsWithAdobeMutation(baseOptions?: Apollo.MutationHookOptions<SendRoiDocumentsWithAdobeMutation, SendRoiDocumentsWithAdobeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRoiDocumentsWithAdobeMutation, SendRoiDocumentsWithAdobeMutationVariables>(SendRoiDocumentsWithAdobeDocument, options);
      }
export type SendRoiDocumentsWithAdobeMutationHookResult = ReturnType<typeof useSendRoiDocumentsWithAdobeMutation>;
export type SendRoiDocumentsWithAdobeMutationResult = Apollo.MutationResult<SendRoiDocumentsWithAdobeMutation>;
export type SendRoiDocumentsWithAdobeMutationOptions = Apollo.BaseMutationOptions<SendRoiDocumentsWithAdobeMutation, SendRoiDocumentsWithAdobeMutationVariables>;
export const UploadDocumentsToCudlDocument = gql`
    mutation uploadDocumentsToCUDL($dealId: ID!, $keys: [String!]!) {
  uploadDocumentsToCUDL(dealId: $dealId, keys: $keys) {
    uploadedDocuments
    errors
  }
}
    `;
export type UploadDocumentsToCudlMutationFn = Apollo.MutationFunction<UploadDocumentsToCudlMutation, UploadDocumentsToCudlMutationVariables>;

/**
 * __useUploadDocumentsToCudlMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsToCudlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsToCudlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsToCudlMutation, { data, loading, error }] = useUploadDocumentsToCudlMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useUploadDocumentsToCudlMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentsToCudlMutation, UploadDocumentsToCudlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentsToCudlMutation, UploadDocumentsToCudlMutationVariables>(UploadDocumentsToCudlDocument, options);
      }
export type UploadDocumentsToCudlMutationHookResult = ReturnType<typeof useUploadDocumentsToCudlMutation>;
export type UploadDocumentsToCudlMutationResult = Apollo.MutationResult<UploadDocumentsToCudlMutation>;
export type UploadDocumentsToCudlMutationOptions = Apollo.BaseMutationOptions<UploadDocumentsToCudlMutation, UploadDocumentsToCudlMutationVariables>;
export const SendThirdPartyPayoffDocument = gql`
    mutation sendThirdPartyPayoff($dealId: ID!, $keys: [String!]!) {
  sendThirdPartyPayoff(dealId: $dealId, keys: $keys) {
    id
    status
    created_at
  }
}
    `;
export type SendThirdPartyPayoffMutationFn = Apollo.MutationFunction<SendThirdPartyPayoffMutation, SendThirdPartyPayoffMutationVariables>;

/**
 * __useSendThirdPartyPayoffMutation__
 *
 * To run a mutation, you first call `useSendThirdPartyPayoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendThirdPartyPayoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendThirdPartyPayoffMutation, { data, loading, error }] = useSendThirdPartyPayoffMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useSendThirdPartyPayoffMutation(baseOptions?: Apollo.MutationHookOptions<SendThirdPartyPayoffMutation, SendThirdPartyPayoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendThirdPartyPayoffMutation, SendThirdPartyPayoffMutationVariables>(SendThirdPartyPayoffDocument, options);
      }
export type SendThirdPartyPayoffMutationHookResult = ReturnType<typeof useSendThirdPartyPayoffMutation>;
export type SendThirdPartyPayoffMutationResult = Apollo.MutationResult<SendThirdPartyPayoffMutation>;
export type SendThirdPartyPayoffMutationOptions = Apollo.BaseMutationOptions<SendThirdPartyPayoffMutation, SendThirdPartyPayoffMutationVariables>;
export const OnDocumentProgressStatusDocument = gql`
    subscription onDocumentProgressStatus($fundingClerkOnly: Boolean, $deal_id: ID) {
  onDocumentProgressStatus(fundingClerkOnly: $fundingClerkOnly, deal_id: $deal_id) {
    id
    state
    paperwork_type
    document_progress_status
    r1_contract_validation_errors_object {
      errors
    }
    r1_contract_validation_warnings_object {
      warnings
    }
    r1_contract_manually_validated
    customer {
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useOnDocumentProgressStatusSubscription__
 *
 * To run a query within a React component, call `useOnDocumentProgressStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDocumentProgressStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDocumentProgressStatusSubscription({
 *   variables: {
 *      fundingClerkOnly: // value for 'fundingClerkOnly'
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useOnDocumentProgressStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDocumentProgressStatusSubscription, OnDocumentProgressStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDocumentProgressStatusSubscription, OnDocumentProgressStatusSubscriptionVariables>(OnDocumentProgressStatusDocument, options);
      }
export type OnDocumentProgressStatusSubscriptionHookResult = ReturnType<typeof useOnDocumentProgressStatusSubscription>;
export type OnDocumentProgressStatusSubscriptionResult = Apollo.SubscriptionResult<OnDocumentProgressStatusSubscription>;
export const OnDashboardDocumentUploadDocument = gql`
    subscription onDashboardDocumentUpload {
  onDashboardDocumentUpload {
    deal {
      id
      customer {
        first_name
        last_name
      }
    }
    fileType
  }
}
    `;

/**
 * __useOnDashboardDocumentUploadSubscription__
 *
 * To run a query within a React component, call `useOnDashboardDocumentUploadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDashboardDocumentUploadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDashboardDocumentUploadSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDashboardDocumentUploadSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDashboardDocumentUploadSubscription, OnDashboardDocumentUploadSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDashboardDocumentUploadSubscription, OnDashboardDocumentUploadSubscriptionVariables>(OnDashboardDocumentUploadDocument, options);
      }
export type OnDashboardDocumentUploadSubscriptionHookResult = ReturnType<typeof useOnDashboardDocumentUploadSubscription>;
export type OnDashboardDocumentUploadSubscriptionResult = Apollo.SubscriptionResult<OnDashboardDocumentUploadSubscription>;
export const OnDownPaymentReceivedDocument = gql`
    subscription onDownPaymentReceived {
  onDownPaymentReceived {
    amount
    dealId
    firstName
    lastName
    type
  }
}
    `;

/**
 * __useOnDownPaymentReceivedSubscription__
 *
 * To run a query within a React component, call `useOnDownPaymentReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDownPaymentReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDownPaymentReceivedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDownPaymentReceivedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDownPaymentReceivedSubscription, OnDownPaymentReceivedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDownPaymentReceivedSubscription, OnDownPaymentReceivedSubscriptionVariables>(OnDownPaymentReceivedDocument, options);
      }
export type OnDownPaymentReceivedSubscriptionHookResult = ReturnType<typeof useOnDownPaymentReceivedSubscription>;
export type OnDownPaymentReceivedSubscriptionResult = Apollo.SubscriptionResult<OnDownPaymentReceivedSubscription>;
export const CreateEmbeddedInsuranceLeadAndGetLinkDocument = gql`
    mutation createEmbeddedInsuranceLeadAndGetLink($dealId: ID!) {
  createEmbeddedInsuranceLeadAndGetLink(dealId: $dealId) {
    url
  }
}
    `;
export type CreateEmbeddedInsuranceLeadAndGetLinkMutationFn = Apollo.MutationFunction<CreateEmbeddedInsuranceLeadAndGetLinkMutation, CreateEmbeddedInsuranceLeadAndGetLinkMutationVariables>;

/**
 * __useCreateEmbeddedInsuranceLeadAndGetLinkMutation__
 *
 * To run a mutation, you first call `useCreateEmbeddedInsuranceLeadAndGetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmbeddedInsuranceLeadAndGetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmbeddedInsuranceLeadAndGetLinkMutation, { data, loading, error }] = useCreateEmbeddedInsuranceLeadAndGetLinkMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCreateEmbeddedInsuranceLeadAndGetLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmbeddedInsuranceLeadAndGetLinkMutation, CreateEmbeddedInsuranceLeadAndGetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmbeddedInsuranceLeadAndGetLinkMutation, CreateEmbeddedInsuranceLeadAndGetLinkMutationVariables>(CreateEmbeddedInsuranceLeadAndGetLinkDocument, options);
      }
export type CreateEmbeddedInsuranceLeadAndGetLinkMutationHookResult = ReturnType<typeof useCreateEmbeddedInsuranceLeadAndGetLinkMutation>;
export type CreateEmbeddedInsuranceLeadAndGetLinkMutationResult = Apollo.MutationResult<CreateEmbeddedInsuranceLeadAndGetLinkMutation>;
export type CreateEmbeddedInsuranceLeadAndGetLinkMutationOptions = Apollo.BaseMutationOptions<CreateEmbeddedInsuranceLeadAndGetLinkMutation, CreateEmbeddedInsuranceLeadAndGetLinkMutationVariables>;
export const OnEmbeddedInsuranceNotificationDocument = gql`
    subscription onEmbeddedInsuranceNotification {
  onEmbeddedInsuranceNotification {
    deal_id
    customer_id
    first_name
    last_name
    success
    filename
  }
}
    `;

/**
 * __useOnEmbeddedInsuranceNotificationSubscription__
 *
 * To run a query within a React component, call `useOnEmbeddedInsuranceNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEmbeddedInsuranceNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEmbeddedInsuranceNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnEmbeddedInsuranceNotificationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnEmbeddedInsuranceNotificationSubscription, OnEmbeddedInsuranceNotificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnEmbeddedInsuranceNotificationSubscription, OnEmbeddedInsuranceNotificationSubscriptionVariables>(OnEmbeddedInsuranceNotificationDocument, options);
      }
export type OnEmbeddedInsuranceNotificationSubscriptionHookResult = ReturnType<typeof useOnEmbeddedInsuranceNotificationSubscription>;
export type OnEmbeddedInsuranceNotificationSubscriptionResult = Apollo.SubscriptionResult<OnEmbeddedInsuranceNotificationSubscription>;
export const NewEstimateUpsertDocument = gql`
    mutation newEstimateUpsert($newEstimateUpsertInput: newEstimateUpsertInput) {
  newEstimateUpsert(newEstimateUpsertInput: $newEstimateUpsertInput) {
    ...DealFragment
  }
}
    ${DealFragmentFragmentDoc}`;
export type NewEstimateUpsertMutationFn = Apollo.MutationFunction<NewEstimateUpsertMutation, NewEstimateUpsertMutationVariables>;

/**
 * __useNewEstimateUpsertMutation__
 *
 * To run a mutation, you first call `useNewEstimateUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewEstimateUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newEstimateUpsertMutation, { data, loading, error }] = useNewEstimateUpsertMutation({
 *   variables: {
 *      newEstimateUpsertInput: // value for 'newEstimateUpsertInput'
 *   },
 * });
 */
export function useNewEstimateUpsertMutation(baseOptions?: Apollo.MutationHookOptions<NewEstimateUpsertMutation, NewEstimateUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewEstimateUpsertMutation, NewEstimateUpsertMutationVariables>(NewEstimateUpsertDocument, options);
      }
export type NewEstimateUpsertMutationHookResult = ReturnType<typeof useNewEstimateUpsertMutation>;
export type NewEstimateUpsertMutationResult = Apollo.MutationResult<NewEstimateUpsertMutation>;
export type NewEstimateUpsertMutationOptions = Apollo.BaseMutationOptions<NewEstimateUpsertMutation, NewEstimateUpsertMutationVariables>;
export const ManuallySelectBankDocument = gql`
    mutation manuallySelectBank($dealId: ID!, $bank: String!) {
  manuallySelectBank(dealId: $dealId, bank: $bank) {
    id
    bank
    selected_credit_decision_id
    first_payment_date
  }
}
    `;
export type ManuallySelectBankMutationFn = Apollo.MutationFunction<ManuallySelectBankMutation, ManuallySelectBankMutationVariables>;

/**
 * __useManuallySelectBankMutation__
 *
 * To run a mutation, you first call `useManuallySelectBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallySelectBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallySelectBankMutation, { data, loading, error }] = useManuallySelectBankMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      bank: // value for 'bank'
 *   },
 * });
 */
export function useManuallySelectBankMutation(baseOptions?: Apollo.MutationHookOptions<ManuallySelectBankMutation, ManuallySelectBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManuallySelectBankMutation, ManuallySelectBankMutationVariables>(ManuallySelectBankDocument, options);
      }
export type ManuallySelectBankMutationHookResult = ReturnType<typeof useManuallySelectBankMutation>;
export type ManuallySelectBankMutationResult = Apollo.MutationResult<ManuallySelectBankMutation>;
export type ManuallySelectBankMutationOptions = Apollo.BaseMutationOptions<ManuallySelectBankMutation, ManuallySelectBankMutationVariables>;
export const UpdateProcessorDocument = gql`
    mutation updateProcessor($dealId: ID!, $fiId: ID!, $processor: String) {
  updateProcessor(dealId: $dealId, fiId: $fiId, processor: $processor) {
    id
    processor
  }
}
    `;
export type UpdateProcessorMutationFn = Apollo.MutationFunction<UpdateProcessorMutation, UpdateProcessorMutationVariables>;

/**
 * __useUpdateProcessorMutation__
 *
 * To run a mutation, you first call `useUpdateProcessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessorMutation, { data, loading, error }] = useUpdateProcessorMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fiId: // value for 'fiId'
 *      processor: // value for 'processor'
 *   },
 * });
 */
export function useUpdateProcessorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessorMutation, UpdateProcessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessorMutation, UpdateProcessorMutationVariables>(UpdateProcessorDocument, options);
      }
export type UpdateProcessorMutationHookResult = ReturnType<typeof useUpdateProcessorMutation>;
export type UpdateProcessorMutationResult = Apollo.MutationResult<UpdateProcessorMutation>;
export type UpdateProcessorMutationOptions = Apollo.BaseMutationOptions<UpdateProcessorMutation, UpdateProcessorMutationVariables>;
export const ResetProcessorAssignmentDocument = gql`
    mutation resetProcessorAssignment($dealId: ID!, $fiId: ID!) {
  resetProcessorAssignment(dealId: $dealId, fiId: $fiId) {
    id
    tt_transaction_id
  }
}
    `;
export type ResetProcessorAssignmentMutationFn = Apollo.MutationFunction<ResetProcessorAssignmentMutation, ResetProcessorAssignmentMutationVariables>;

/**
 * __useResetProcessorAssignmentMutation__
 *
 * To run a mutation, you first call `useResetProcessorAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetProcessorAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetProcessorAssignmentMutation, { data, loading, error }] = useResetProcessorAssignmentMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fiId: // value for 'fiId'
 *   },
 * });
 */
export function useResetProcessorAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetProcessorAssignmentMutation, ResetProcessorAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetProcessorAssignmentMutation, ResetProcessorAssignmentMutationVariables>(ResetProcessorAssignmentDocument, options);
      }
export type ResetProcessorAssignmentMutationHookResult = ReturnType<typeof useResetProcessorAssignmentMutation>;
export type ResetProcessorAssignmentMutationResult = Apollo.MutationResult<ResetProcessorAssignmentMutation>;
export type ResetProcessorAssignmentMutationOptions = Apollo.BaseMutationOptions<ResetProcessorAssignmentMutation, ResetProcessorAssignmentMutationVariables>;
export const OnTransactionCreatedDocument = gql`
    subscription onTransactionCreated($dealId: ID!) {
  onTransactionCreated(dealId: $dealId) {
    deal_id
    tt_transaction_id
  }
}
    `;

/**
 * __useOnTransactionCreatedSubscription__
 *
 * To run a query within a React component, call `useOnTransactionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTransactionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTransactionCreatedSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnTransactionCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnTransactionCreatedSubscription, OnTransactionCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTransactionCreatedSubscription, OnTransactionCreatedSubscriptionVariables>(OnTransactionCreatedDocument, options);
      }
export type OnTransactionCreatedSubscriptionHookResult = ReturnType<typeof useOnTransactionCreatedSubscription>;
export type OnTransactionCreatedSubscriptionResult = Apollo.SubscriptionResult<OnTransactionCreatedSubscription>;
export const FinancialInfoAcquisitionUpsertDocument = gql`
    mutation financialInfoAcquisitionUpsert($financialInfoAcquisition: financialInfoAcquisitionInput, $id: ID!, $state: String!, $car_id: ID, $mmr: Float, $vehicle_payoff: Float, $override: Boolean, $clear_override: Boolean) {
  financialInfoAcquisitionUpsert(
    financialInfoAcquisition: $financialInfoAcquisition
    id: $id
    state: $state
    car_id: $car_id
    mmr: $mmr
    vehicle_payoff: $vehicle_payoff
    override: $override
    clear_override: $clear_override
  ) {
    id
  }
}
    `;
export type FinancialInfoAcquisitionUpsertMutationFn = Apollo.MutationFunction<FinancialInfoAcquisitionUpsertMutation, FinancialInfoAcquisitionUpsertMutationVariables>;

/**
 * __useFinancialInfoAcquisitionUpsertMutation__
 *
 * To run a mutation, you first call `useFinancialInfoAcquisitionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialInfoAcquisitionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialInfoAcquisitionUpsertMutation, { data, loading, error }] = useFinancialInfoAcquisitionUpsertMutation({
 *   variables: {
 *      financialInfoAcquisition: // value for 'financialInfoAcquisition'
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      car_id: // value for 'car_id'
 *      mmr: // value for 'mmr'
 *      vehicle_payoff: // value for 'vehicle_payoff'
 *      override: // value for 'override'
 *      clear_override: // value for 'clear_override'
 *   },
 * });
 */
export function useFinancialInfoAcquisitionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<FinancialInfoAcquisitionUpsertMutation, FinancialInfoAcquisitionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialInfoAcquisitionUpsertMutation, FinancialInfoAcquisitionUpsertMutationVariables>(FinancialInfoAcquisitionUpsertDocument, options);
      }
export type FinancialInfoAcquisitionUpsertMutationHookResult = ReturnType<typeof useFinancialInfoAcquisitionUpsertMutation>;
export type FinancialInfoAcquisitionUpsertMutationResult = Apollo.MutationResult<FinancialInfoAcquisitionUpsertMutation>;
export type FinancialInfoAcquisitionUpsertMutationOptions = Apollo.BaseMutationOptions<FinancialInfoAcquisitionUpsertMutation, FinancialInfoAcquisitionUpsertMutationVariables>;
export const GetFollowUpDealsPaginatedDocument = gql`
    query getFollowUpDealsPaginated($assignedToMeFilter: Boolean, $scheduledByMeFilter: Boolean, $bootRequested: Boolean, $assignedToDeletedUsersFilter: Boolean, $notifications: Boolean, $page: Int, $podIds: [ID], $sortColumn: String!, $sortDirection: String!, $sources: [String]!, $types: [DealType]!, $resultsPerPage: Int, $showActiveTags: Boolean, $showMatureFollowUps: Boolean) {
  getFollowUpDealsPaginated(
    assignedToMeFilter: $assignedToMeFilter
    scheduledByMeFilter: $scheduledByMeFilter
    bootRequested: $bootRequested
    assignedToDeletedUsersFilter: $assignedToDeletedUsersFilter
    notifications: $notifications
    page: $page
    podIds: $podIds
    resultsPerPage: $resultsPerPage
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    sources: $sources
    types: $types
    showActiveTags: $showActiveTags
    showMatureFollowUps: $showMatureFollowUps
  ) {
    deals {
      id
      state
      customer {
        id
        first_name
        last_name
        phone_number
      }
      follow_up {
        id
        creator_id
        deal_id
        date_utc
        note
        status
        tz
        type
        creator {
          id
          name
        }
      }
      notifications {
        ...NotificationFragment
      }
    }
    totalRecords
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useGetFollowUpDealsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetFollowUpDealsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowUpDealsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowUpDealsPaginatedQuery({
 *   variables: {
 *      assignedToMeFilter: // value for 'assignedToMeFilter'
 *      scheduledByMeFilter: // value for 'scheduledByMeFilter'
 *      bootRequested: // value for 'bootRequested'
 *      assignedToDeletedUsersFilter: // value for 'assignedToDeletedUsersFilter'
 *      notifications: // value for 'notifications'
 *      page: // value for 'page'
 *      podIds: // value for 'podIds'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      showActiveTags: // value for 'showActiveTags'
 *      showMatureFollowUps: // value for 'showMatureFollowUps'
 *   },
 * });
 */
export function useGetFollowUpDealsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetFollowUpDealsPaginatedQuery, GetFollowUpDealsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowUpDealsPaginatedQuery, GetFollowUpDealsPaginatedQueryVariables>(GetFollowUpDealsPaginatedDocument, options);
      }
export function useGetFollowUpDealsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowUpDealsPaginatedQuery, GetFollowUpDealsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowUpDealsPaginatedQuery, GetFollowUpDealsPaginatedQueryVariables>(GetFollowUpDealsPaginatedDocument, options);
        }
export type GetFollowUpDealsPaginatedQueryHookResult = ReturnType<typeof useGetFollowUpDealsPaginatedQuery>;
export type GetFollowUpDealsPaginatedLazyQueryHookResult = ReturnType<typeof useGetFollowUpDealsPaginatedLazyQuery>;
export type GetFollowUpDealsPaginatedQueryResult = Apollo.QueryResult<GetFollowUpDealsPaginatedQuery, GetFollowUpDealsPaginatedQueryVariables>;
export const FollowUpDocument = gql`
    query followUp($deal_id: ID!) {
  followUp(deal_id: $deal_id) {
    id
    creator_id
    deal_id
    date_utc
    note
    status
    tz
    type
  }
}
    `;

/**
 * __useFollowUpQuery__
 *
 * To run a query within a React component, call `useFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useFollowUpQuery(baseOptions: Apollo.QueryHookOptions<FollowUpQuery, FollowUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpQuery, FollowUpQueryVariables>(FollowUpDocument, options);
      }
export function useFollowUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpQuery, FollowUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpQuery, FollowUpQueryVariables>(FollowUpDocument, options);
        }
export type FollowUpQueryHookResult = ReturnType<typeof useFollowUpQuery>;
export type FollowUpLazyQueryHookResult = ReturnType<typeof useFollowUpLazyQuery>;
export type FollowUpQueryResult = Apollo.QueryResult<FollowUpQuery, FollowUpQueryVariables>;
export const FollowUpInsertDocument = gql`
    mutation followUpInsert($deal_id: ID!, $type: followUpTypeEnum!, $date_utc: DateTime!, $tz: String!, $note: String) {
  followUpInsert(
    deal_id: $deal_id
    type: $type
    date_utc: $date_utc
    tz: $tz
    note: $note
  ) {
    id
    creator_id
    deal_id
    date_utc
    note
    status
    tz
    type
  }
}
    `;
export type FollowUpInsertMutationFn = Apollo.MutationFunction<FollowUpInsertMutation, FollowUpInsertMutationVariables>;

/**
 * __useFollowUpInsertMutation__
 *
 * To run a mutation, you first call `useFollowUpInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUpInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUpInsertMutation, { data, loading, error }] = useFollowUpInsertMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      type: // value for 'type'
 *      date_utc: // value for 'date_utc'
 *      tz: // value for 'tz'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useFollowUpInsertMutation(baseOptions?: Apollo.MutationHookOptions<FollowUpInsertMutation, FollowUpInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUpInsertMutation, FollowUpInsertMutationVariables>(FollowUpInsertDocument, options);
      }
export type FollowUpInsertMutationHookResult = ReturnType<typeof useFollowUpInsertMutation>;
export type FollowUpInsertMutationResult = Apollo.MutationResult<FollowUpInsertMutation>;
export type FollowUpInsertMutationOptions = Apollo.BaseMutationOptions<FollowUpInsertMutation, FollowUpInsertMutationVariables>;
export const FollowUpUpdateDocument = gql`
    mutation followUpUpdate($id: ID!, $type: followUpTypeEnum!, $date_utc: DateTime!, $tz: String!, $deal_id: ID!, $note: String) {
  followUpUpdate(
    id: $id
    type: $type
    date_utc: $date_utc
    tz: $tz
    deal_id: $deal_id
    note: $note
  ) {
    id
    creator_id
    deal_id
    date_utc
    note
    status
    tz
    type
  }
}
    `;
export type FollowUpUpdateMutationFn = Apollo.MutationFunction<FollowUpUpdateMutation, FollowUpUpdateMutationVariables>;

/**
 * __useFollowUpUpdateMutation__
 *
 * To run a mutation, you first call `useFollowUpUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUpUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUpUpdateMutation, { data, loading, error }] = useFollowUpUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      date_utc: // value for 'date_utc'
 *      tz: // value for 'tz'
 *      deal_id: // value for 'deal_id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useFollowUpUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FollowUpUpdateMutation, FollowUpUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUpUpdateMutation, FollowUpUpdateMutationVariables>(FollowUpUpdateDocument, options);
      }
export type FollowUpUpdateMutationHookResult = ReturnType<typeof useFollowUpUpdateMutation>;
export type FollowUpUpdateMutationResult = Apollo.MutationResult<FollowUpUpdateMutation>;
export type FollowUpUpdateMutationOptions = Apollo.BaseMutationOptions<FollowUpUpdateMutation, FollowUpUpdateMutationVariables>;
export const FollowUpDeleteDocument = gql`
    mutation followUpDelete($id: ID!) {
  followUpDelete(id: $id) {
    id
  }
}
    `;
export type FollowUpDeleteMutationFn = Apollo.MutationFunction<FollowUpDeleteMutation, FollowUpDeleteMutationVariables>;

/**
 * __useFollowUpDeleteMutation__
 *
 * To run a mutation, you first call `useFollowUpDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUpDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUpDeleteMutation, { data, loading, error }] = useFollowUpDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFollowUpDeleteMutation(baseOptions?: Apollo.MutationHookOptions<FollowUpDeleteMutation, FollowUpDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUpDeleteMutation, FollowUpDeleteMutationVariables>(FollowUpDeleteDocument, options);
      }
export type FollowUpDeleteMutationHookResult = ReturnType<typeof useFollowUpDeleteMutation>;
export type FollowUpDeleteMutationResult = Apollo.MutationResult<FollowUpDeleteMutation>;
export type FollowUpDeleteMutationOptions = Apollo.BaseMutationOptions<FollowUpDeleteMutation, FollowUpDeleteMutationVariables>;
export const OnFollowUpUpdateDocument = gql`
    subscription onFollowUpUpdate($dealId: ID, $sources: [String], $types: [DealType], $scheduledByMeFilter: Boolean, $followUpType: followUpTypeEnum, $followUpStatus: followUpStatusEnum) {
  onFollowUpUpdate(
    dealId: $dealId
    sources: $sources
    types: $types
    scheduledByMeFilter: $scheduledByMeFilter
    followUpType: $followUpType
    followUpStatus: $followUpStatus
  ) {
    id
    state
    source
    type
    setter {
      id
      name
    }
    structuring_manager_id
    structuring_manager {
      id
      name
    }
    structuring_follow_up {
      id
      created_at
      status
      creator_id
      notes
    }
    tags {
      id
      badge_variant
      color
      display_name
      is_active
      is_dashboard_visible
      slug
      badge_variant
    }
    notifications {
      ...NotificationFragment
    }
    customer {
      id
      first_name
      last_name
    }
    follow_up {
      id
      creator_id
      deal_id
      date_utc
      note
      status
      tz
      type
      creator {
        id
        name
        user_type
        assignment_mode
        frequency_minutes
      }
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useOnFollowUpUpdateSubscription__
 *
 * To run a query within a React component, call `useOnFollowUpUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFollowUpUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFollowUpUpdateSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      scheduledByMeFilter: // value for 'scheduledByMeFilter'
 *      followUpType: // value for 'followUpType'
 *      followUpStatus: // value for 'followUpStatus'
 *   },
 * });
 */
export function useOnFollowUpUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnFollowUpUpdateSubscription, OnFollowUpUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnFollowUpUpdateSubscription, OnFollowUpUpdateSubscriptionVariables>(OnFollowUpUpdateDocument, options);
      }
export type OnFollowUpUpdateSubscriptionHookResult = ReturnType<typeof useOnFollowUpUpdateSubscription>;
export type OnFollowUpUpdateSubscriptionResult = Apollo.SubscriptionResult<OnFollowUpUpdateSubscription>;
export const InProgressCallsDocument = gql`
    subscription inProgressCalls {
  inProgressCalls {
    id
    from
    to
    conference_id
    phone_number
    agent_number
    deal_id
    customer_name
    agent_user_id
    deal_state
    deal_type
    is_thunder
    hunt_group_slug
    is_outbound
  }
}
    `;

/**
 * __useInProgressCallsSubscription__
 *
 * To run a query within a React component, call `useInProgressCallsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInProgressCallsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProgressCallsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInProgressCallsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InProgressCallsSubscription, InProgressCallsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InProgressCallsSubscription, InProgressCallsSubscriptionVariables>(InProgressCallsDocument, options);
      }
export type InProgressCallsSubscriptionHookResult = ReturnType<typeof useInProgressCallsSubscription>;
export type InProgressCallsSubscriptionResult = Apollo.SubscriptionResult<InProgressCallsSubscription>;
export const JdpValuesDocument = gql`
    query jdpValues($vin: String!, $mileage: Float!, $stateCode: String) {
  jdpValues(vin: $vin, mileage: $mileage, stateCode: $stateCode) {
    jdp_mileage_adjustment
    jdp_adjusted_clean_retail
    jdp_adjusted_clean_trade
    jdp_trim_body
    jdp_valuation_date
    jdp_vehicle_accessories_object {
      vehicle_accessories {
        acccode
        accdesc
        accessorycategory
        excludes
        includes
        isadded
        isincluded
        loan
        retail
        tradein
      }
    }
  }
}
    `;

/**
 * __useJdpValuesQuery__
 *
 * To run a query within a React component, call `useJdpValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJdpValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJdpValuesQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *      mileage: // value for 'mileage'
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useJdpValuesQuery(baseOptions: Apollo.QueryHookOptions<JdpValuesQuery, JdpValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JdpValuesQuery, JdpValuesQueryVariables>(JdpValuesDocument, options);
      }
export function useJdpValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JdpValuesQuery, JdpValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JdpValuesQuery, JdpValuesQueryVariables>(JdpValuesDocument, options);
        }
export type JdpValuesQueryHookResult = ReturnType<typeof useJdpValuesQuery>;
export type JdpValuesLazyQueryHookResult = ReturnType<typeof useJdpValuesLazyQuery>;
export type JdpValuesQueryResult = Apollo.QueryResult<JdpValuesQuery, JdpValuesQueryVariables>;
export const CreateJdpBookSheetDocument = gql`
    mutation createJDPBookSheet($dealId: ID!, $customerState: String!) {
  createJDPBookSheet(dealId: $dealId, customerState: $customerState)
}
    `;
export type CreateJdpBookSheetMutationFn = Apollo.MutationFunction<CreateJdpBookSheetMutation, CreateJdpBookSheetMutationVariables>;

/**
 * __useCreateJdpBookSheetMutation__
 *
 * To run a mutation, you first call `useCreateJdpBookSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJdpBookSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJdpBookSheetMutation, { data, loading, error }] = useCreateJdpBookSheetMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      customerState: // value for 'customerState'
 *   },
 * });
 */
export function useCreateJdpBookSheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateJdpBookSheetMutation, CreateJdpBookSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJdpBookSheetMutation, CreateJdpBookSheetMutationVariables>(CreateJdpBookSheetDocument, options);
      }
export type CreateJdpBookSheetMutationHookResult = ReturnType<typeof useCreateJdpBookSheetMutation>;
export type CreateJdpBookSheetMutationResult = Apollo.MutationResult<CreateJdpBookSheetMutation>;
export type CreateJdpBookSheetMutationOptions = Apollo.BaseMutationOptions<CreateJdpBookSheetMutation, CreateJdpBookSheetMutationVariables>;
export const KbbVinDocument = gql`
    query kbbVin($vin: String!) {
  kbbVin(vin: $vin) {
    warning
    vinResults {
      vehicleId
      vehicleOptions {
        categoryGroup
        hasRelationships
        isConfigurable
        isConsumer
        isTypical
        isVinDecoded
        optionName
        optionType
        sortOrder
        vehicleId
        vehicleOptionId
      }
      modelName
      trimName
      makeName
      yearId
      vehicleName
    }
  }
}
    `;

/**
 * __useKbbVinQuery__
 *
 * To run a query within a React component, call `useKbbVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useKbbVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKbbVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useKbbVinQuery(baseOptions: Apollo.QueryHookOptions<KbbVinQuery, KbbVinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KbbVinQuery, KbbVinQueryVariables>(KbbVinDocument, options);
      }
export function useKbbVinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KbbVinQuery, KbbVinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KbbVinQuery, KbbVinQueryVariables>(KbbVinDocument, options);
        }
export type KbbVinQueryHookResult = ReturnType<typeof useKbbVinQuery>;
export type KbbVinLazyQueryHookResult = ReturnType<typeof useKbbVinLazyQuery>;
export type KbbVinQueryResult = Apollo.QueryResult<KbbVinQuery, KbbVinQueryVariables>;
export const KbbValuesDocument = gql`
    query kbbValues($data: kbbValuesDataType!) {
  kbbValues(data: $data) {
    retail
    retailMileageAdjustment
    retailOptionAdjustment
    retailOptionPrices
    lending
    lendingMileageAdjustment
    lendingOptionAdjustment
    lendingOptionPrices
    valuationDate
    kbbSelectedOptions {
      id
      name
      type
      removed
      lendingOptionPrice
      retailOptionPrice
    }
  }
}
    `;

/**
 * __useKbbValuesQuery__
 *
 * To run a query within a React component, call `useKbbValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKbbValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKbbValuesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useKbbValuesQuery(baseOptions: Apollo.QueryHookOptions<KbbValuesQuery, KbbValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KbbValuesQuery, KbbValuesQueryVariables>(KbbValuesDocument, options);
      }
export function useKbbValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KbbValuesQuery, KbbValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KbbValuesQuery, KbbValuesQueryVariables>(KbbValuesDocument, options);
        }
export type KbbValuesQueryHookResult = ReturnType<typeof useKbbValuesQuery>;
export type KbbValuesLazyQueryHookResult = ReturnType<typeof useKbbValuesLazyQuery>;
export type KbbValuesQueryResult = Apollo.QueryResult<KbbValuesQuery, KbbValuesQueryVariables>;
export const CalculateOptionsDocument = gql`
    query calculateOptions($vehicleId: Int!, $allKbbVehicleOptions: [kbbOptionInput], $startingVehicleOptions: [Int], $configToModify: [kbbConfigType], $vin: String!, $color: String) {
  calculateOptions(
    vehicleId: $vehicleId
    allKbbVehicleOptions: $allKbbVehicleOptions
    startingVehicleOptions: $startingVehicleOptions
    configToModify: $configToModify
    vin: $vin
    color: $color
  ) {
    vehicleOptionId
    optionName
    optionType
    categoryGroup
  }
}
    `;

/**
 * __useCalculateOptionsQuery__
 *
 * To run a query within a React component, call `useCalculateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateOptionsQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      allKbbVehicleOptions: // value for 'allKbbVehicleOptions'
 *      startingVehicleOptions: // value for 'startingVehicleOptions'
 *      configToModify: // value for 'configToModify'
 *      vin: // value for 'vin'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCalculateOptionsQuery(baseOptions: Apollo.QueryHookOptions<CalculateOptionsQuery, CalculateOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateOptionsQuery, CalculateOptionsQueryVariables>(CalculateOptionsDocument, options);
      }
export function useCalculateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateOptionsQuery, CalculateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateOptionsQuery, CalculateOptionsQueryVariables>(CalculateOptionsDocument, options);
        }
export type CalculateOptionsQueryHookResult = ReturnType<typeof useCalculateOptionsQuery>;
export type CalculateOptionsLazyQueryHookResult = ReturnType<typeof useCalculateOptionsLazyQuery>;
export type CalculateOptionsQueryResult = Apollo.QueryResult<CalculateOptionsQuery, CalculateOptionsQueryVariables>;
export const CreateKbbBookSheetDocument = gql`
    mutation createKBBBookSheet($dealId: ID!) {
  createKBBBookSheet(dealId: $dealId)
}
    `;
export type CreateKbbBookSheetMutationFn = Apollo.MutationFunction<CreateKbbBookSheetMutation, CreateKbbBookSheetMutationVariables>;

/**
 * __useCreateKbbBookSheetMutation__
 *
 * To run a mutation, you first call `useCreateKbbBookSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKbbBookSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKbbBookSheetMutation, { data, loading, error }] = useCreateKbbBookSheetMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCreateKbbBookSheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateKbbBookSheetMutation, CreateKbbBookSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKbbBookSheetMutation, CreateKbbBookSheetMutationVariables>(CreateKbbBookSheetDocument, options);
      }
export type CreateKbbBookSheetMutationHookResult = ReturnType<typeof useCreateKbbBookSheetMutation>;
export type CreateKbbBookSheetMutationResult = Apollo.MutationResult<CreateKbbBookSheetMutation>;
export type CreateKbbBookSheetMutationOptions = Apollo.BaseMutationOptions<CreateKbbBookSheetMutation, CreateKbbBookSheetMutationVariables>;
export const KeyMetricsDocument = gql`
    query keyMetrics($start_date: DateTime!, $end_date: DateTime!, $pod_ids: [String]!) {
  keyMetrics(start_date: $start_date, end_date: $end_date, pod_ids: $pod_ids) {
    keyMetric
    value {
      buyout
      refi
      total
    }
  }
}
    `;

/**
 * __useKeyMetricsQuery__
 *
 * To run a query within a React component, call `useKeyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyMetricsQuery({
 *   variables: {
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      pod_ids: // value for 'pod_ids'
 *   },
 * });
 */
export function useKeyMetricsQuery(baseOptions: Apollo.QueryHookOptions<KeyMetricsQuery, KeyMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyMetricsQuery, KeyMetricsQueryVariables>(KeyMetricsDocument, options);
      }
export function useKeyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyMetricsQuery, KeyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyMetricsQuery, KeyMetricsQueryVariables>(KeyMetricsDocument, options);
        }
export type KeyMetricsQueryHookResult = ReturnType<typeof useKeyMetricsQuery>;
export type KeyMetricsLazyQueryHookResult = ReturnType<typeof useKeyMetricsLazyQuery>;
export type KeyMetricsQueryResult = Apollo.QueryResult<KeyMetricsQuery, KeyMetricsQueryVariables>;
export const LaneKeyMetricsDocument = gql`
    query laneKeyMetrics($today: DateTime, $sources: [String]!, $types: [DealType]!) {
  laneKeyMetrics(today: $today, sources: $sources, types: $types) {
    state
    day_count
  }
}
    `;

/**
 * __useLaneKeyMetricsQuery__
 *
 * To run a query within a React component, call `useLaneKeyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaneKeyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaneKeyMetricsQuery({
 *   variables: {
 *      today: // value for 'today'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useLaneKeyMetricsQuery(baseOptions: Apollo.QueryHookOptions<LaneKeyMetricsQuery, LaneKeyMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LaneKeyMetricsQuery, LaneKeyMetricsQueryVariables>(LaneKeyMetricsDocument, options);
      }
export function useLaneKeyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LaneKeyMetricsQuery, LaneKeyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LaneKeyMetricsQuery, LaneKeyMetricsQueryVariables>(LaneKeyMetricsDocument, options);
        }
export type LaneKeyMetricsQueryHookResult = ReturnType<typeof useLaneKeyMetricsQuery>;
export type LaneKeyMetricsLazyQueryHookResult = ReturnType<typeof useLaneKeyMetricsLazyQuery>;
export type LaneKeyMetricsQueryResult = Apollo.QueryResult<LaneKeyMetricsQuery, LaneKeyMetricsQueryVariables>;
export const LaneKeyMetricsReaderDocument = gql`
    query laneKeyMetricsReader($today: DateTime, $sources: [String]!, $types: [DealType]!) {
  laneKeyMetricsReader(today: $today, sources: $sources, types: $types) {
    state
    day_count
  }
}
    `;

/**
 * __useLaneKeyMetricsReaderQuery__
 *
 * To run a query within a React component, call `useLaneKeyMetricsReaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaneKeyMetricsReaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaneKeyMetricsReaderQuery({
 *   variables: {
 *      today: // value for 'today'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useLaneKeyMetricsReaderQuery(baseOptions: Apollo.QueryHookOptions<LaneKeyMetricsReaderQuery, LaneKeyMetricsReaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LaneKeyMetricsReaderQuery, LaneKeyMetricsReaderQueryVariables>(LaneKeyMetricsReaderDocument, options);
      }
export function useLaneKeyMetricsReaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LaneKeyMetricsReaderQuery, LaneKeyMetricsReaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LaneKeyMetricsReaderQuery, LaneKeyMetricsReaderQueryVariables>(LaneKeyMetricsReaderDocument, options);
        }
export type LaneKeyMetricsReaderQueryHookResult = ReturnType<typeof useLaneKeyMetricsReaderQuery>;
export type LaneKeyMetricsReaderLazyQueryHookResult = ReturnType<typeof useLaneKeyMetricsReaderLazyQuery>;
export type LaneKeyMetricsReaderQueryResult = Apollo.QueryResult<LaneKeyMetricsReaderQuery, LaneKeyMetricsReaderQueryVariables>;
export const LendersDocument = gql`
    query lenders($query: String!) {
  lenders(query: $query) {
    ...LenderFragment
  }
}
    ${LenderFragmentFragmentDoc}`;

/**
 * __useLendersQuery__
 *
 * To run a query within a React component, call `useLendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLendersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useLendersQuery(baseOptions: Apollo.QueryHookOptions<LendersQuery, LendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LendersQuery, LendersQueryVariables>(LendersDocument, options);
      }
export function useLendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LendersQuery, LendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LendersQuery, LendersQueryVariables>(LendersDocument, options);
        }
export type LendersQueryHookResult = ReturnType<typeof useLendersQuery>;
export type LendersLazyQueryHookResult = ReturnType<typeof useLendersLazyQuery>;
export type LendersQueryResult = Apollo.QueryResult<LendersQuery, LendersQueryVariables>;
export const MediaDocument = gql`
    query media($dealId: ID!) {
  media(dealId: $dealId) {
    id
    key
    signed_url
    type
    metadata
    deal_id
    verified
    state
    source
    has_verified_digital_signature
    has_wet_signature
    is_notarized
    cudl_document_id
    created_at
  }
}
    `;

/**
 * __useMediaQuery__
 *
 * To run a query within a React component, call `useMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useMediaQuery(baseOptions: Apollo.QueryHookOptions<MediaQuery, MediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaQuery, MediaQueryVariables>(MediaDocument, options);
      }
export function useMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaQuery, MediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaQuery, MediaQueryVariables>(MediaDocument, options);
        }
export type MediaQueryHookResult = ReturnType<typeof useMediaQuery>;
export type MediaLazyQueryHookResult = ReturnType<typeof useMediaLazyQuery>;
export type MediaQueryResult = Apollo.QueryResult<MediaQuery, MediaQueryVariables>;
export const GetUploadUrlDocument = gql`
    query getUploadUrl($dealId: ID!, $fileName: String!) {
  getUploadUrl(dealId: $dealId, fileName: $fileName) {
    key
    url
  }
}
    `;

/**
 * __useGetUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadUrlQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
      }
export function useGetUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
        }
export type GetUploadUrlQueryHookResult = ReturnType<typeof useGetUploadUrlQuery>;
export type GetUploadUrlLazyQueryHookResult = ReturnType<typeof useGetUploadUrlLazyQuery>;
export type GetUploadUrlQueryResult = Apollo.QueryResult<GetUploadUrlQuery, GetUploadUrlQueryVariables>;
export const ArticleImageUploadUrlDocument = gql`
    query articleImageUploadUrl($fileName: String!) {
  articleImageUploadUrl(fileName: $fileName) {
    url
    key
  }
}
    `;

/**
 * __useArticleImageUploadUrlQuery__
 *
 * To run a query within a React component, call `useArticleImageUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleImageUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleImageUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useArticleImageUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<ArticleImageUploadUrlQuery, ArticleImageUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleImageUploadUrlQuery, ArticleImageUploadUrlQueryVariables>(ArticleImageUploadUrlDocument, options);
      }
export function useArticleImageUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleImageUploadUrlQuery, ArticleImageUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleImageUploadUrlQuery, ArticleImageUploadUrlQueryVariables>(ArticleImageUploadUrlDocument, options);
        }
export type ArticleImageUploadUrlQueryHookResult = ReturnType<typeof useArticleImageUploadUrlQuery>;
export type ArticleImageUploadUrlLazyQueryHookResult = ReturnType<typeof useArticleImageUploadUrlLazyQuery>;
export type ArticleImageUploadUrlQueryResult = Apollo.QueryResult<ArticleImageUploadUrlQuery, ArticleImageUploadUrlQueryVariables>;
export const GetBase64StringFromS3ObjectDocument = gql`
    query getBase64StringFromS3Object($key: String!) {
  getBase64StringFromS3Object(key: $key)
}
    `;

/**
 * __useGetBase64StringFromS3ObjectQuery__
 *
 * To run a query within a React component, call `useGetBase64StringFromS3ObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBase64StringFromS3ObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBase64StringFromS3ObjectQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetBase64StringFromS3ObjectQuery(baseOptions: Apollo.QueryHookOptions<GetBase64StringFromS3ObjectQuery, GetBase64StringFromS3ObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBase64StringFromS3ObjectQuery, GetBase64StringFromS3ObjectQueryVariables>(GetBase64StringFromS3ObjectDocument, options);
      }
export function useGetBase64StringFromS3ObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBase64StringFromS3ObjectQuery, GetBase64StringFromS3ObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBase64StringFromS3ObjectQuery, GetBase64StringFromS3ObjectQueryVariables>(GetBase64StringFromS3ObjectDocument, options);
        }
export type GetBase64StringFromS3ObjectQueryHookResult = ReturnType<typeof useGetBase64StringFromS3ObjectQuery>;
export type GetBase64StringFromS3ObjectLazyQueryHookResult = ReturnType<typeof useGetBase64StringFromS3ObjectLazyQuery>;
export type GetBase64StringFromS3ObjectQueryResult = Apollo.QueryResult<GetBase64StringFromS3ObjectQuery, GetBase64StringFromS3ObjectQueryVariables>;
export const MediaInsertDocument = gql`
    mutation mediaInsert($key: String!, $type: String, $dealId: ID!, $metadata: JSONObject) {
  mediaInsert(key: $key, type: $type, dealId: $dealId, metadata: $metadata) {
    id
    key
    signed_url
    type
    metadata
    deal_id
    has_verified_digital_signature
    has_wet_signature
    is_notarized
  }
}
    `;
export type MediaInsertMutationFn = Apollo.MutationFunction<MediaInsertMutation, MediaInsertMutationVariables>;

/**
 * __useMediaInsertMutation__
 *
 * To run a mutation, you first call `useMediaInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaInsertMutation, { data, loading, error }] = useMediaInsertMutation({
 *   variables: {
 *      key: // value for 'key'
 *      type: // value for 'type'
 *      dealId: // value for 'dealId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useMediaInsertMutation(baseOptions?: Apollo.MutationHookOptions<MediaInsertMutation, MediaInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaInsertMutation, MediaInsertMutationVariables>(MediaInsertDocument, options);
      }
export type MediaInsertMutationHookResult = ReturnType<typeof useMediaInsertMutation>;
export type MediaInsertMutationResult = Apollo.MutationResult<MediaInsertMutation>;
export type MediaInsertMutationOptions = Apollo.BaseMutationOptions<MediaInsertMutation, MediaInsertMutationVariables>;
export const MediaDeleteDocument = gql`
    mutation mediaDelete($filePath: String!) {
  mediaDelete(filePath: $filePath)
}
    `;
export type MediaDeleteMutationFn = Apollo.MutationFunction<MediaDeleteMutation, MediaDeleteMutationVariables>;

/**
 * __useMediaDeleteMutation__
 *
 * To run a mutation, you first call `useMediaDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaDeleteMutation, { data, loading, error }] = useMediaDeleteMutation({
 *   variables: {
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useMediaDeleteMutation(baseOptions?: Apollo.MutationHookOptions<MediaDeleteMutation, MediaDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaDeleteMutation, MediaDeleteMutationVariables>(MediaDeleteDocument, options);
      }
export type MediaDeleteMutationHookResult = ReturnType<typeof useMediaDeleteMutation>;
export type MediaDeleteMutationResult = Apollo.MutationResult<MediaDeleteMutation>;
export type MediaDeleteMutationOptions = Apollo.BaseMutationOptions<MediaDeleteMutation, MediaDeleteMutationVariables>;
export const DeleteAndReplaceFilesDocument = gql`
    mutation deleteAndReplaceFiles($deal_id: ID!, $files_to_delete: [addDocumentsToMediaCenterInput]!, $files_to_upload: [addDocumentsToMediaCenterInput]!) {
  deleteAndReplaceFiles(
    deal_id: $deal_id
    files_to_delete: $files_to_delete
    files_to_upload: $files_to_upload
  )
}
    `;
export type DeleteAndReplaceFilesMutationFn = Apollo.MutationFunction<DeleteAndReplaceFilesMutation, DeleteAndReplaceFilesMutationVariables>;

/**
 * __useDeleteAndReplaceFilesMutation__
 *
 * To run a mutation, you first call `useDeleteAndReplaceFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAndReplaceFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAndReplaceFilesMutation, { data, loading, error }] = useDeleteAndReplaceFilesMutation({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *      files_to_delete: // value for 'files_to_delete'
 *      files_to_upload: // value for 'files_to_upload'
 *   },
 * });
 */
export function useDeleteAndReplaceFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAndReplaceFilesMutation, DeleteAndReplaceFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAndReplaceFilesMutation, DeleteAndReplaceFilesMutationVariables>(DeleteAndReplaceFilesDocument, options);
      }
export type DeleteAndReplaceFilesMutationHookResult = ReturnType<typeof useDeleteAndReplaceFilesMutation>;
export type DeleteAndReplaceFilesMutationResult = Apollo.MutationResult<DeleteAndReplaceFilesMutation>;
export type DeleteAndReplaceFilesMutationOptions = Apollo.BaseMutationOptions<DeleteAndReplaceFilesMutation, DeleteAndReplaceFilesMutationVariables>;
export const MediaRenameDocument = gql`
    mutation mediaRename($dealId: ID!, $filePath: String!, $fileName: String!) {
  mediaRename(dealId: $dealId, filePath: $filePath, fileName: $fileName)
}
    `;
export type MediaRenameMutationFn = Apollo.MutationFunction<MediaRenameMutation, MediaRenameMutationVariables>;

/**
 * __useMediaRenameMutation__
 *
 * To run a mutation, you first call `useMediaRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaRenameMutation, { data, loading, error }] = useMediaRenameMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      filePath: // value for 'filePath'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useMediaRenameMutation(baseOptions?: Apollo.MutationHookOptions<MediaRenameMutation, MediaRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaRenameMutation, MediaRenameMutationVariables>(MediaRenameDocument, options);
      }
export type MediaRenameMutationHookResult = ReturnType<typeof useMediaRenameMutation>;
export type MediaRenameMutationResult = Apollo.MutationResult<MediaRenameMutation>;
export type MediaRenameMutationOptions = Apollo.BaseMutationOptions<MediaRenameMutation, MediaRenameMutationVariables>;
export const MediaUpdateDocument = gql`
    mutation mediaUpdate($dealId: ID!, $oldKey: String!, $newFileName: String, $type: String, $metadata: JSONObject, $verified: Boolean, $has_verified_digital_signature: Boolean, $has_wet_signature: Boolean, $is_notarized: Boolean) {
  mediaUpdate(
    dealId: $dealId
    oldKey: $oldKey
    newFileName: $newFileName
    type: $type
    metadata: $metadata
    verified: $verified
    has_verified_digital_signature: $has_verified_digital_signature
    has_wet_signature: $has_wet_signature
    is_notarized: $is_notarized
  ) {
    id
    key
    signed_url
    type
    metadata
    deal_id
    verified
    has_verified_digital_signature
    has_wet_signature
    is_notarized
  }
}
    `;
export type MediaUpdateMutationFn = Apollo.MutationFunction<MediaUpdateMutation, MediaUpdateMutationVariables>;

/**
 * __useMediaUpdateMutation__
 *
 * To run a mutation, you first call `useMediaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaUpdateMutation, { data, loading, error }] = useMediaUpdateMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      oldKey: // value for 'oldKey'
 *      newFileName: // value for 'newFileName'
 *      type: // value for 'type'
 *      metadata: // value for 'metadata'
 *      verified: // value for 'verified'
 *      has_verified_digital_signature: // value for 'has_verified_digital_signature'
 *      has_wet_signature: // value for 'has_wet_signature'
 *      is_notarized: // value for 'is_notarized'
 *   },
 * });
 */
export function useMediaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MediaUpdateMutation, MediaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaUpdateMutation, MediaUpdateMutationVariables>(MediaUpdateDocument, options);
      }
export type MediaUpdateMutationHookResult = ReturnType<typeof useMediaUpdateMutation>;
export type MediaUpdateMutationResult = Apollo.MutationResult<MediaUpdateMutation>;
export type MediaUpdateMutationOptions = Apollo.BaseMutationOptions<MediaUpdateMutation, MediaUpdateMutationVariables>;
export const InboxDocument = gql`
    query inbox($filterBy: inboxFilterByEnum, $podIds: [ID], $orderBy: inboxOrderByEnum, $unreadOnly: Boolean, $page: Int, $itemsPerPage: Int) {
  inbox(
    filterBy: $filterBy
    podIds: $podIds
    orderBy: $orderBy
    unreadOnly: $unreadOnly
    page: $page
    itemsPerPage: $itemsPerPage
  ) {
    messages {
      id
      from
      fromCustomer
      body
      dateCreated
      dateCreatedTz
      mediaListObj {
        data {
          url
          contentType
        }
      }
      notifications {
        ...NotificationFragment
        deal {
          id
          state
          car {
            id
            year
            make
            model
          }
          customer {
            id
            first_name
            last_name
            phone_number
            home_phone_number
          }
          cobuyer {
            id
            first_name
            last_name
            phone_number
            home_phone_number
          }
          contact {
            id
            first_name
            last_name
            phone_number
          }
          second_contact {
            id
            first_name
            last_name
            phone_number
          }
          setter {
            id
            name
            pods {
              id
              name
              color
            }
          }
          closer {
            id
            name
            pods {
              id
              name
              color
            }
          }
          closer2 {
            id
            name
            pods {
              id
              name
              color
            }
          }
          funding_clerk {
            id
            name
            pods {
              id
              name
              color
            }
          }
          title_clerk {
            id
            name
            titlingPods {
              id
              name
              color
            }
          }
          title_clerk2 {
            id
            name
            titlingPods {
              id
              name
              color
            }
          }
        }
      }
    }
    totalRecords
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useInboxQuery__
 *
 * To run a query within a React component, call `useInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxQuery({
 *   variables: {
 *      filterBy: // value for 'filterBy'
 *      podIds: // value for 'podIds'
 *      orderBy: // value for 'orderBy'
 *      unreadOnly: // value for 'unreadOnly'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useInboxQuery(baseOptions?: Apollo.QueryHookOptions<InboxQuery, InboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxQuery, InboxQueryVariables>(InboxDocument, options);
      }
export function useInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxQuery, InboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxQuery, InboxQueryVariables>(InboxDocument, options);
        }
export type InboxQueryHookResult = ReturnType<typeof useInboxQuery>;
export type InboxLazyQueryHookResult = ReturnType<typeof useInboxLazyQuery>;
export type InboxQueryResult = Apollo.QueryResult<InboxQuery, InboxQueryVariables>;
export const MessageTemplatesByTypeDocument = gql`
    query messageTemplatesByType($type: MessageTemplateType) {
  messageTemplatesByType(type: $type) {
    id
    title
    category
  }
}
    `;

/**
 * __useMessageTemplatesByTypeQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMessageTemplatesByTypeQuery(baseOptions?: Apollo.QueryHookOptions<MessageTemplatesByTypeQuery, MessageTemplatesByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplatesByTypeQuery, MessageTemplatesByTypeQueryVariables>(MessageTemplatesByTypeDocument, options);
      }
export function useMessageTemplatesByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesByTypeQuery, MessageTemplatesByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplatesByTypeQuery, MessageTemplatesByTypeQueryVariables>(MessageTemplatesByTypeDocument, options);
        }
export type MessageTemplatesByTypeQueryHookResult = ReturnType<typeof useMessageTemplatesByTypeQuery>;
export type MessageTemplatesByTypeLazyQueryHookResult = ReturnType<typeof useMessageTemplatesByTypeLazyQuery>;
export type MessageTemplatesByTypeQueryResult = Apollo.QueryResult<MessageTemplatesByTypeQuery, MessageTemplatesByTypeQueryVariables>;
export const MessageTemplateByKeyDocument = gql`
    query messageTemplateByKey($key: MessageTemplateKey!) {
  messageTemplateByKey(key: $key) {
    id
    title
    body
    category
    type
    key
  }
}
    `;

/**
 * __useMessageTemplateByKeyQuery__
 *
 * To run a query within a React component, call `useMessageTemplateByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplateByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplateByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useMessageTemplateByKeyQuery(baseOptions: Apollo.QueryHookOptions<MessageTemplateByKeyQuery, MessageTemplateByKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplateByKeyQuery, MessageTemplateByKeyQueryVariables>(MessageTemplateByKeyDocument, options);
      }
export function useMessageTemplateByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplateByKeyQuery, MessageTemplateByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplateByKeyQuery, MessageTemplateByKeyQueryVariables>(MessageTemplateByKeyDocument, options);
        }
export type MessageTemplateByKeyQueryHookResult = ReturnType<typeof useMessageTemplateByKeyQuery>;
export type MessageTemplateByKeyLazyQueryHookResult = ReturnType<typeof useMessageTemplateByKeyLazyQuery>;
export type MessageTemplateByKeyQueryResult = Apollo.QueryResult<MessageTemplateByKeyQuery, MessageTemplateByKeyQueryVariables>;
export const MessagesDocument = gql`
    query messages($dealPhoneNumber: String) {
  messages(dealPhoneNumber: $dealPhoneNumber) {
    messages {
      ...MessageFragment
    }
    hasErrors
  }
}
    ${MessageFragmentFragmentDoc}`;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      dealPhoneNumber: // value for 'dealPhoneNumber'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions?: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const MessagesDbPaginatedDocument = gql`
    query messagesDbPaginated($dealPhoneNumber: String!, $dealId: String!, $page: Int!) {
  messagesDbPaginated(
    dealPhoneNumber: $dealPhoneNumber
    dealId: $dealId
    page: $page
  ) {
    messages {
      ...MessageFragment
    }
    hasMoreMessages
  }
}
    ${MessageFragmentFragmentDoc}`;

/**
 * __useMessagesDbPaginatedQuery__
 *
 * To run a query within a React component, call `useMessagesDbPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesDbPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesDbPaginatedQuery({
 *   variables: {
 *      dealPhoneNumber: // value for 'dealPhoneNumber'
 *      dealId: // value for 'dealId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMessagesDbPaginatedQuery(baseOptions: Apollo.QueryHookOptions<MessagesDbPaginatedQuery, MessagesDbPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesDbPaginatedQuery, MessagesDbPaginatedQueryVariables>(MessagesDbPaginatedDocument, options);
      }
export function useMessagesDbPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesDbPaginatedQuery, MessagesDbPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesDbPaginatedQuery, MessagesDbPaginatedQueryVariables>(MessagesDbPaginatedDocument, options);
        }
export type MessagesDbPaginatedQueryHookResult = ReturnType<typeof useMessagesDbPaginatedQuery>;
export type MessagesDbPaginatedLazyQueryHookResult = ReturnType<typeof useMessagesDbPaginatedLazyQuery>;
export type MessagesDbPaginatedQueryResult = Apollo.QueryResult<MessagesDbPaginatedQuery, MessagesDbPaginatedQueryVariables>;
export const SuggestedMessageDocument = gql`
    query suggestedMessage($dealId: ID!, $phoneNumber: String!, $customerId: ID!, $draftMessage: String) {
  suggestedMessage(
    dealId: $dealId
    phoneNumber: $phoneNumber
    customerId: $customerId
    draftMessage: $draftMessage
  )
}
    `;

/**
 * __useSuggestedMessageQuery__
 *
 * To run a query within a React component, call `useSuggestedMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedMessageQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      phoneNumber: // value for 'phoneNumber'
 *      customerId: // value for 'customerId'
 *      draftMessage: // value for 'draftMessage'
 *   },
 * });
 */
export function useSuggestedMessageQuery(baseOptions: Apollo.QueryHookOptions<SuggestedMessageQuery, SuggestedMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedMessageQuery, SuggestedMessageQueryVariables>(SuggestedMessageDocument, options);
      }
export function useSuggestedMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedMessageQuery, SuggestedMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedMessageQuery, SuggestedMessageQueryVariables>(SuggestedMessageDocument, options);
        }
export type SuggestedMessageQueryHookResult = ReturnType<typeof useSuggestedMessageQuery>;
export type SuggestedMessageLazyQueryHookResult = ReturnType<typeof useSuggestedMessageLazyQuery>;
export type SuggestedMessageQueryResult = Apollo.QueryResult<SuggestedMessageQuery, SuggestedMessageQueryVariables>;
export const FillMessageTemplateDocument = gql`
    mutation fillMessageTemplate($input: FillMessageTemplateInput!) {
  fillMessageTemplate(input: $input) {
    renderedMessage
  }
}
    `;
export type FillMessageTemplateMutationFn = Apollo.MutationFunction<FillMessageTemplateMutation, FillMessageTemplateMutationVariables>;

/**
 * __useFillMessageTemplateMutation__
 *
 * To run a mutation, you first call `useFillMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillMessageTemplateMutation, { data, loading, error }] = useFillMessageTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<FillMessageTemplateMutation, FillMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FillMessageTemplateMutation, FillMessageTemplateMutationVariables>(FillMessageTemplateDocument, options);
      }
export type FillMessageTemplateMutationHookResult = ReturnType<typeof useFillMessageTemplateMutation>;
export type FillMessageTemplateMutationResult = Apollo.MutationResult<FillMessageTemplateMutation>;
export type FillMessageTemplateMutationOptions = Apollo.BaseMutationOptions<FillMessageTemplateMutation, FillMessageTemplateMutationVariables>;
export const MessageSendDocument = gql`
    mutation messageSend($message: String!, $dealPhoneNumber: String!, $id: ID!) {
  messageSend(message: $message, dealPhoneNumber: $dealPhoneNumber, id: $id) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type MessageSendMutationFn = Apollo.MutationFunction<MessageSendMutation, MessageSendMutationVariables>;

/**
 * __useMessageSendMutation__
 *
 * To run a mutation, you first call `useMessageSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageSendMutation, { data, loading, error }] = useMessageSendMutation({
 *   variables: {
 *      message: // value for 'message'
 *      dealPhoneNumber: // value for 'dealPhoneNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageSendMutation(baseOptions?: Apollo.MutationHookOptions<MessageSendMutation, MessageSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MessageSendMutation, MessageSendMutationVariables>(MessageSendDocument, options);
      }
export type MessageSendMutationHookResult = ReturnType<typeof useMessageSendMutation>;
export type MessageSendMutationResult = Apollo.MutationResult<MessageSendMutation>;
export type MessageSendMutationOptions = Apollo.BaseMutationOptions<MessageSendMutation, MessageSendMutationVariables>;
export const FileSendDocument = gql`
    mutation fileSend($file: String!, $dealPhoneNumber: String!, $id: ID!) {
  fileSend(file: $file, dealPhoneNumber: $dealPhoneNumber, id: $id) {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export type FileSendMutationFn = Apollo.MutationFunction<FileSendMutation, FileSendMutationVariables>;

/**
 * __useFileSendMutation__
 *
 * To run a mutation, you first call `useFileSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSendMutation, { data, loading, error }] = useFileSendMutation({
 *   variables: {
 *      file: // value for 'file'
 *      dealPhoneNumber: // value for 'dealPhoneNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileSendMutation(baseOptions?: Apollo.MutationHookOptions<FileSendMutation, FileSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileSendMutation, FileSendMutationVariables>(FileSendDocument, options);
      }
export type FileSendMutationHookResult = ReturnType<typeof useFileSendMutation>;
export type FileSendMutationResult = Apollo.MutationResult<FileSendMutation>;
export type FileSendMutationOptions = Apollo.BaseMutationOptions<FileSendMutation, FileSendMutationVariables>;
export const OnNewMessageDocument = gql`
    subscription onNewMessage($dealPhoneNumbers: [String], $isNotification: Boolean, $isWidgetOpen: Boolean, $activePhoneNumber: String) {
  onNewMessage(
    dealPhoneNumbers: $dealPhoneNumbers
    isNotification: $isNotification
    isWidgetOpen: $isWidgetOpen
    activePhoneNumber: $activePhoneNumber
  ) {
    message {
      id
      from
      fromCustomer
      body
      dateCreated
      mediaListObj {
        data {
          url
          contentType
        }
      }
    }
    deals {
      id
      state
      customer {
        id
        first_name
        last_name
        phone_number
        home_phone_number
      }
      cobuyer {
        id
        first_name
        last_name
        phone_number
        home_phone_number
        relation_to_buyer
      }
      contact {
        id
        first_name
        last_name
        phone_number
        relation_to_buyer
      }
      second_contact {
        id
        first_name
        last_name
        phone_number
        relation_to_buyer
      }
      car {
        id
        make
        model
        year
      }
      notifications {
        ...NotificationFragment
      }
      notification_subscribers {
        id
        deal_id
        subscriber_id
      }
      pod_id
      titling_pod_id
      setter_id
      closer_id
      closer2_id
      funding_clerk_id
      title_clerk_id
      title_clerk2_id
    }
    messageDetail {
      shortNames
      dealIds
      dealStates
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useOnNewMessageSubscription__
 *
 * To run a query within a React component, call `useOnNewMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewMessageSubscription({
 *   variables: {
 *      dealPhoneNumbers: // value for 'dealPhoneNumbers'
 *      isNotification: // value for 'isNotification'
 *      isWidgetOpen: // value for 'isWidgetOpen'
 *      activePhoneNumber: // value for 'activePhoneNumber'
 *   },
 * });
 */
export function useOnNewMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNewMessageSubscription, OnNewMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNewMessageSubscription, OnNewMessageSubscriptionVariables>(OnNewMessageDocument, options);
      }
export type OnNewMessageSubscriptionHookResult = ReturnType<typeof useOnNewMessageSubscription>;
export type OnNewMessageSubscriptionResult = Apollo.SubscriptionResult<OnNewMessageSubscription>;
export const MetricsPagesDocument = gql`
    query metricsPages {
  metricsPages {
    id
    name
    link_name
    iframe_url
    permission_name
    sort_order
  }
}
    `;

/**
 * __useMetricsPagesQuery__
 *
 * To run a query within a React component, call `useMetricsPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetricsPagesQuery(baseOptions?: Apollo.QueryHookOptions<MetricsPagesQuery, MetricsPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsPagesQuery, MetricsPagesQueryVariables>(MetricsPagesDocument, options);
      }
export function useMetricsPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsPagesQuery, MetricsPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsPagesQuery, MetricsPagesQueryVariables>(MetricsPagesDocument, options);
        }
export type MetricsPagesQueryHookResult = ReturnType<typeof useMetricsPagesQuery>;
export type MetricsPagesLazyQueryHookResult = ReturnType<typeof useMetricsPagesLazyQuery>;
export type MetricsPagesQueryResult = Apollo.QueryResult<MetricsPagesQuery, MetricsPagesQueryVariables>;
export const MmrDocument = gql`
    query mmr($vin: String!, $mileage: Int!, $color: String!, $grade: Float!, $trim: String!, $state: String!) {
  mmr(
    vin: $vin
    mileage: $mileage
    color: $color
    grade: $grade
    trim: $trim
    state: $state
  ) {
    average
  }
}
    `;

/**
 * __useMmrQuery__
 *
 * To run a query within a React component, call `useMmrQuery` and pass it any options that fit your needs.
 * When your component renders, `useMmrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMmrQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *      mileage: // value for 'mileage'
 *      color: // value for 'color'
 *      grade: // value for 'grade'
 *      trim: // value for 'trim'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useMmrQuery(baseOptions: Apollo.QueryHookOptions<MmrQuery, MmrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MmrQuery, MmrQueryVariables>(MmrDocument, options);
      }
export function useMmrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MmrQuery, MmrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MmrQuery, MmrQueryVariables>(MmrDocument, options);
        }
export type MmrQueryHookResult = ReturnType<typeof useMmrQuery>;
export type MmrLazyQueryHookResult = ReturnType<typeof useMmrLazyQuery>;
export type MmrQueryResult = Apollo.QueryResult<MmrQuery, MmrQueryVariables>;
export const NoteCreateDocument = gql`
    mutation noteCreate($note: noteInput) {
  noteCreate(note: $note) {
    id
  }
}
    `;
export type NoteCreateMutationFn = Apollo.MutationFunction<NoteCreateMutation, NoteCreateMutationVariables>;

/**
 * __useNoteCreateMutation__
 *
 * To run a mutation, you first call `useNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteCreateMutation, { data, loading, error }] = useNoteCreateMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useNoteCreateMutation(baseOptions?: Apollo.MutationHookOptions<NoteCreateMutation, NoteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteCreateMutation, NoteCreateMutationVariables>(NoteCreateDocument, options);
      }
export type NoteCreateMutationHookResult = ReturnType<typeof useNoteCreateMutation>;
export type NoteCreateMutationResult = Apollo.MutationResult<NoteCreateMutation>;
export type NoteCreateMutationOptions = Apollo.BaseMutationOptions<NoteCreateMutation, NoteCreateMutationVariables>;
export const NoteUpdateDocument = gql`
    mutation noteUpdate($note: noteInput) {
  noteUpdate(note: $note) {
    id
  }
}
    `;
export type NoteUpdateMutationFn = Apollo.MutationFunction<NoteUpdateMutation, NoteUpdateMutationVariables>;

/**
 * __useNoteUpdateMutation__
 *
 * To run a mutation, you first call `useNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpdateMutation, { data, loading, error }] = useNoteUpdateMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpdateMutation, NoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpdateMutation, NoteUpdateMutationVariables>(NoteUpdateDocument, options);
      }
export type NoteUpdateMutationHookResult = ReturnType<typeof useNoteUpdateMutation>;
export type NoteUpdateMutationResult = Apollo.MutationResult<NoteUpdateMutation>;
export type NoteUpdateMutationOptions = Apollo.BaseMutationOptions<NoteUpdateMutation, NoteUpdateMutationVariables>;
export const NoteDeleteDocument = gql`
    mutation noteDelete($id: ID!) {
  noteDelete(id: $id) {
    id
  }
}
    `;
export type NoteDeleteMutationFn = Apollo.MutationFunction<NoteDeleteMutation, NoteDeleteMutationVariables>;

/**
 * __useNoteDeleteMutation__
 *
 * To run a mutation, you first call `useNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteDeleteMutation, { data, loading, error }] = useNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<NoteDeleteMutation, NoteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteDeleteMutation, NoteDeleteMutationVariables>(NoteDeleteDocument, options);
      }
export type NoteDeleteMutationHookResult = ReturnType<typeof useNoteDeleteMutation>;
export type NoteDeleteMutationResult = Apollo.MutationResult<NoteDeleteMutation>;
export type NoteDeleteMutationOptions = Apollo.BaseMutationOptions<NoteDeleteMutation, NoteDeleteMutationVariables>;
export const NotesDocument = gql`
    query notes($dealId: ID!) {
  notes(deal_id: $dealId) {
    id
    author_id
    text
    deal_id
    created_at
    creation_date_tz
    note_type
    pinned
    recordingid
    author {
      name
    }
  }
}
    `;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useNotesQuery(baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const TaughtCallUrlDocument = gql`
    query taughtCallUrl($noteId: Int) {
  taughtCallUrl(noteId: $noteId)
}
    `;

/**
 * __useTaughtCallUrlQuery__
 *
 * To run a query within a React component, call `useTaughtCallUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaughtCallUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaughtCallUrlQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useTaughtCallUrlQuery(baseOptions?: Apollo.QueryHookOptions<TaughtCallUrlQuery, TaughtCallUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaughtCallUrlQuery, TaughtCallUrlQueryVariables>(TaughtCallUrlDocument, options);
      }
export function useTaughtCallUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaughtCallUrlQuery, TaughtCallUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaughtCallUrlQuery, TaughtCallUrlQueryVariables>(TaughtCallUrlDocument, options);
        }
export type TaughtCallUrlQueryHookResult = ReturnType<typeof useTaughtCallUrlQuery>;
export type TaughtCallUrlLazyQueryHookResult = ReturnType<typeof useTaughtCallUrlLazyQuery>;
export type TaughtCallUrlQueryResult = Apollo.QueryResult<TaughtCallUrlQuery, TaughtCallUrlQueryVariables>;
export const DealUnreadMessageCountDocument = gql`
    query dealUnreadMessageCount($dealId: Int!) {
  dealUnreadMessageCount(dealId: $dealId) {
    byRecipient {
      recipientId
      phoneNumber
      count
      missedCallCount
    }
  }
}
    `;

/**
 * __useDealUnreadMessageCountQuery__
 *
 * To run a query within a React component, call `useDealUnreadMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealUnreadMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealUnreadMessageCountQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealUnreadMessageCountQuery(baseOptions: Apollo.QueryHookOptions<DealUnreadMessageCountQuery, DealUnreadMessageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealUnreadMessageCountQuery, DealUnreadMessageCountQueryVariables>(DealUnreadMessageCountDocument, options);
      }
export function useDealUnreadMessageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealUnreadMessageCountQuery, DealUnreadMessageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealUnreadMessageCountQuery, DealUnreadMessageCountQueryVariables>(DealUnreadMessageCountDocument, options);
        }
export type DealUnreadMessageCountQueryHookResult = ReturnType<typeof useDealUnreadMessageCountQuery>;
export type DealUnreadMessageCountLazyQueryHookResult = ReturnType<typeof useDealUnreadMessageCountLazyQuery>;
export type DealUnreadMessageCountQueryResult = Apollo.QueryResult<DealUnreadMessageCountQuery, DealUnreadMessageCountQueryVariables>;
export const NotificationsSeenDocument = gql`
    mutation notificationsSeen($notificationIds: [ID!]!, $seen: Boolean!) {
  notificationsSeen(notificationIds: $notificationIds, seen: $seen)
}
    `;
export type NotificationsSeenMutationFn = Apollo.MutationFunction<NotificationsSeenMutation, NotificationsSeenMutationVariables>;

/**
 * __useNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsSeenMutation, { data, loading, error }] = useNotificationsSeenMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *      seen: // value for 'seen'
 *   },
 * });
 */
export function useNotificationsSeenMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsSeenMutation, NotificationsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsSeenMutation, NotificationsSeenMutationVariables>(NotificationsSeenDocument, options);
      }
export type NotificationsSeenMutationHookResult = ReturnType<typeof useNotificationsSeenMutation>;
export type NotificationsSeenMutationResult = Apollo.MutationResult<NotificationsSeenMutation>;
export type NotificationsSeenMutationOptions = Apollo.BaseMutationOptions<NotificationsSeenMutation, NotificationsSeenMutationVariables>;
export const MarkRecipientThreadSeenDocument = gql`
    mutation markRecipientThreadSeen($dealId: Int!, $recipientType: String!, $recipientId: Int!, $phoneNumber: String) {
  markRecipientThreadSeen(
    dealId: $dealId
    recipientType: $recipientType
    recipientId: $recipientId
    phoneNumber: $phoneNumber
  ) {
    byRecipient {
      recipientId
      phoneNumber
      count
      missedCallCount
    }
  }
}
    `;
export type MarkRecipientThreadSeenMutationFn = Apollo.MutationFunction<MarkRecipientThreadSeenMutation, MarkRecipientThreadSeenMutationVariables>;

/**
 * __useMarkRecipientThreadSeenMutation__
 *
 * To run a mutation, you first call `useMarkRecipientThreadSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRecipientThreadSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRecipientThreadSeenMutation, { data, loading, error }] = useMarkRecipientThreadSeenMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      recipientType: // value for 'recipientType'
 *      recipientId: // value for 'recipientId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useMarkRecipientThreadSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkRecipientThreadSeenMutation, MarkRecipientThreadSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRecipientThreadSeenMutation, MarkRecipientThreadSeenMutationVariables>(MarkRecipientThreadSeenDocument, options);
      }
export type MarkRecipientThreadSeenMutationHookResult = ReturnType<typeof useMarkRecipientThreadSeenMutation>;
export type MarkRecipientThreadSeenMutationResult = Apollo.MutationResult<MarkRecipientThreadSeenMutation>;
export type MarkRecipientThreadSeenMutationOptions = Apollo.BaseMutationOptions<MarkRecipientThreadSeenMutation, MarkRecipientThreadSeenMutationVariables>;
export const OnNoDealNotificationDocument = gql`
    subscription onNoDealNotification {
  onNoDealNotification {
    id
  }
}
    `;

/**
 * __useOnNoDealNotificationSubscription__
 *
 * To run a query within a React component, call `useOnNoDealNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNoDealNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNoDealNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNoDealNotificationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNoDealNotificationSubscription, OnNoDealNotificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNoDealNotificationSubscription, OnNoDealNotificationSubscriptionVariables>(OnNoDealNotificationDocument, options);
      }
export type OnNoDealNotificationSubscriptionHookResult = ReturnType<typeof useOnNoDealNotificationSubscription>;
export type OnNoDealNotificationSubscriptionResult = Apollo.SubscriptionResult<OnNoDealNotificationSubscription>;
export const MarkMissedSipNotificationAsSeenDocument = gql`
    mutation markMissedSipNotificationAsSeen($callIds: [String]!) {
  markMissedSipNotificationAsSeen(callIds: $callIds)
}
    `;
export type MarkMissedSipNotificationAsSeenMutationFn = Apollo.MutationFunction<MarkMissedSipNotificationAsSeenMutation, MarkMissedSipNotificationAsSeenMutationVariables>;

/**
 * __useMarkMissedSipNotificationAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkMissedSipNotificationAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMissedSipNotificationAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMissedSipNotificationAsSeenMutation, { data, loading, error }] = useMarkMissedSipNotificationAsSeenMutation({
 *   variables: {
 *      callIds: // value for 'callIds'
 *   },
 * });
 */
export function useMarkMissedSipNotificationAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkMissedSipNotificationAsSeenMutation, MarkMissedSipNotificationAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMissedSipNotificationAsSeenMutation, MarkMissedSipNotificationAsSeenMutationVariables>(MarkMissedSipNotificationAsSeenDocument, options);
      }
export type MarkMissedSipNotificationAsSeenMutationHookResult = ReturnType<typeof useMarkMissedSipNotificationAsSeenMutation>;
export type MarkMissedSipNotificationAsSeenMutationResult = Apollo.MutationResult<MarkMissedSipNotificationAsSeenMutation>;
export type MarkMissedSipNotificationAsSeenMutationOptions = Apollo.BaseMutationOptions<MarkMissedSipNotificationAsSeenMutation, MarkMissedSipNotificationAsSeenMutationVariables>;
export const UpdateSubscriptionToNotificationsStatusDocument = gql`
    mutation updateSubscriptionToNotificationsStatus($dealId: ID!, $subscribeToNotifications: Boolean!) {
  updateSubscriptionToNotificationsStatus(
    dealId: $dealId
    subscribeToNotifications: $subscribeToNotifications
  ) {
    id
    deal_id
    subscriber_id
  }
}
    `;
export type UpdateSubscriptionToNotificationsStatusMutationFn = Apollo.MutationFunction<UpdateSubscriptionToNotificationsStatusMutation, UpdateSubscriptionToNotificationsStatusMutationVariables>;

/**
 * __useUpdateSubscriptionToNotificationsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionToNotificationsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionToNotificationsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionToNotificationsStatusMutation, { data, loading, error }] = useUpdateSubscriptionToNotificationsStatusMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      subscribeToNotifications: // value for 'subscribeToNotifications'
 *   },
 * });
 */
export function useUpdateSubscriptionToNotificationsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionToNotificationsStatusMutation, UpdateSubscriptionToNotificationsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionToNotificationsStatusMutation, UpdateSubscriptionToNotificationsStatusMutationVariables>(UpdateSubscriptionToNotificationsStatusDocument, options);
      }
export type UpdateSubscriptionToNotificationsStatusMutationHookResult = ReturnType<typeof useUpdateSubscriptionToNotificationsStatusMutation>;
export type UpdateSubscriptionToNotificationsStatusMutationResult = Apollo.MutationResult<UpdateSubscriptionToNotificationsStatusMutation>;
export type UpdateSubscriptionToNotificationsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionToNotificationsStatusMutation, UpdateSubscriptionToNotificationsStatusMutationVariables>;
export const PaymentOptionsDocument = gql`
    query paymentOptions($data: PaymentOptionsInput) {
  paymentOptions(data: $data) {
    vscPlusGap {
      ...PaymentOptionFragment
    }
    vsc {
      ...PaymentOptionFragment
    }
    gap {
      ...PaymentOptionFragment
    }
    noProducts {
      ...PaymentOptionFragment
    }
  }
}
    ${PaymentOptionFragmentFragmentDoc}`;

/**
 * __usePaymentOptionsQuery__
 *
 * To run a query within a React component, call `usePaymentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentOptionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentOptionsQuery, PaymentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentOptionsQuery, PaymentOptionsQueryVariables>(PaymentOptionsDocument, options);
      }
export function usePaymentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentOptionsQuery, PaymentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentOptionsQuery, PaymentOptionsQueryVariables>(PaymentOptionsDocument, options);
        }
export type PaymentOptionsQueryHookResult = ReturnType<typeof usePaymentOptionsQuery>;
export type PaymentOptionsLazyQueryHookResult = ReturnType<typeof usePaymentOptionsLazyQuery>;
export type PaymentOptionsQueryResult = Apollo.QueryResult<PaymentOptionsQuery, PaymentOptionsQueryVariables>;
export const PaymentEstimateDocument = gql`
    query paymentEstimate($data: paymentEstimateInput) {
  paymentEstimate(data: $data) {
    paymentEstimateLow
    paymentEstimateHigh
    estimatedTaxesAndFees
    totalEstimatedLoan
    estimatedAnnualPercentageRate
  }
}
    `;

/**
 * __usePaymentEstimateQuery__
 *
 * To run a query within a React component, call `usePaymentEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentEstimateQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePaymentEstimateQuery(baseOptions?: Apollo.QueryHookOptions<PaymentEstimateQuery, PaymentEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentEstimateQuery, PaymentEstimateQueryVariables>(PaymentEstimateDocument, options);
      }
export function usePaymentEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentEstimateQuery, PaymentEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentEstimateQuery, PaymentEstimateQueryVariables>(PaymentEstimateDocument, options);
        }
export type PaymentEstimateQueryHookResult = ReturnType<typeof usePaymentEstimateQuery>;
export type PaymentEstimateLazyQueryHookResult = ReturnType<typeof usePaymentEstimateLazyQuery>;
export type PaymentEstimateQueryResult = Apollo.QueryResult<PaymentEstimateQuery, PaymentEstimateQueryVariables>;
export const PaymentOptionsV2Document = gql`
    query paymentOptionsV2($input: PaymentOptionsV2Input!) {
  paymentOptionsV2(input: $input) {
    dealId
    selectedPackageSlotIndex
    vscPlusGap {
      ...PaymentOptionV2Fragment
    }
    vsc {
      ...PaymentOptionV2Fragment
    }
    gap {
      ...PaymentOptionV2Fragment
    }
    noProducts {
      ...PaymentOptionV2Fragment
    }
    packages {
      ...PaymentOptionsPackageV2Fragment
    }
  }
}
    ${PaymentOptionV2FragmentFragmentDoc}
${PaymentOptionsPackageV2FragmentFragmentDoc}`;

/**
 * __usePaymentOptionsV2Query__
 *
 * To run a query within a React component, call `usePaymentOptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePaymentOptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentOptionsV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentOptionsV2Query(baseOptions: Apollo.QueryHookOptions<PaymentOptionsV2Query, PaymentOptionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentOptionsV2Query, PaymentOptionsV2QueryVariables>(PaymentOptionsV2Document, options);
      }
export function usePaymentOptionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentOptionsV2Query, PaymentOptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentOptionsV2Query, PaymentOptionsV2QueryVariables>(PaymentOptionsV2Document, options);
        }
export type PaymentOptionsV2QueryHookResult = ReturnType<typeof usePaymentOptionsV2Query>;
export type PaymentOptionsV2LazyQueryHookResult = ReturnType<typeof usePaymentOptionsV2LazyQuery>;
export type PaymentOptionsV2QueryResult = Apollo.QueryResult<PaymentOptionsV2Query, PaymentOptionsV2QueryVariables>;
export const PayoffUpdateDocument = gql`
    mutation payoffUpdate($dealId: ID!, $payoff: payoffInput!) {
  payoffUpdate(dealId: $dealId, payoffInfo: $payoff) {
    ...PayoffFragment
  }
}
    ${PayoffFragmentFragmentDoc}`;
export type PayoffUpdateMutationFn = Apollo.MutationFunction<PayoffUpdateMutation, PayoffUpdateMutationVariables>;

/**
 * __usePayoffUpdateMutation__
 *
 * To run a mutation, you first call `usePayoffUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffUpdateMutation, { data, loading, error }] = usePayoffUpdateMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      payoff: // value for 'payoff'
 *   },
 * });
 */
export function usePayoffUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PayoffUpdateMutation, PayoffUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffUpdateMutation, PayoffUpdateMutationVariables>(PayoffUpdateDocument, options);
      }
export type PayoffUpdateMutationHookResult = ReturnType<typeof usePayoffUpdateMutation>;
export type PayoffUpdateMutationResult = Apollo.MutationResult<PayoffUpdateMutation>;
export type PayoffUpdateMutationOptions = Apollo.BaseMutationOptions<PayoffUpdateMutation, PayoffUpdateMutationVariables>;
export const CheckSupportedLienholderDocument = gql`
    query checkSupportedLienholder($dealId: Int, $lienholderSlug: String) {
  checkSupportedLienholder(dealId: $dealId, lienholderSlug: $lienholderSlug) {
    isSupported
    requirementsMet
    requiredFields
    missingRequiredFields
  }
}
    `;

/**
 * __useCheckSupportedLienholderQuery__
 *
 * To run a query within a React component, call `useCheckSupportedLienholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSupportedLienholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSupportedLienholderQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      lienholderSlug: // value for 'lienholderSlug'
 *   },
 * });
 */
export function useCheckSupportedLienholderQuery(baseOptions?: Apollo.QueryHookOptions<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>(CheckSupportedLienholderDocument, options);
      }
export function useCheckSupportedLienholderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>(CheckSupportedLienholderDocument, options);
        }
export type CheckSupportedLienholderQueryHookResult = ReturnType<typeof useCheckSupportedLienholderQuery>;
export type CheckSupportedLienholderLazyQueryHookResult = ReturnType<typeof useCheckSupportedLienholderLazyQuery>;
export type CheckSupportedLienholderQueryResult = Apollo.QueryResult<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>;
export const PayoffDashboardDealsDocument = gql`
    query payoffDashboardDeals {
  payoffDashboardDeals {
    payoffRequests {
      ...PayoffRequestPopulatedFragment
    }
  }
}
    ${PayoffRequestPopulatedFragmentFragmentDoc}`;

/**
 * __usePayoffDashboardDealsQuery__
 *
 * To run a query within a React component, call `usePayoffDashboardDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoffDashboardDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoffDashboardDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayoffDashboardDealsQuery(baseOptions?: Apollo.QueryHookOptions<PayoffDashboardDealsQuery, PayoffDashboardDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoffDashboardDealsQuery, PayoffDashboardDealsQueryVariables>(PayoffDashboardDealsDocument, options);
      }
export function usePayoffDashboardDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoffDashboardDealsQuery, PayoffDashboardDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoffDashboardDealsQuery, PayoffDashboardDealsQueryVariables>(PayoffDashboardDealsDocument, options);
        }
export type PayoffDashboardDealsQueryHookResult = ReturnType<typeof usePayoffDashboardDealsQuery>;
export type PayoffDashboardDealsLazyQueryHookResult = ReturnType<typeof usePayoffDashboardDealsLazyQuery>;
export type PayoffDashboardDealsQueryResult = Apollo.QueryResult<PayoffDashboardDealsQuery, PayoffDashboardDealsQueryVariables>;
export const PayoffRequestDocument = gql`
    query payoffRequest($deal_id: ID) {
  payoffRequest(deal_id: $deal_id) {
    id
    status
  }
}
    `;

/**
 * __usePayoffRequestQuery__
 *
 * To run a query within a React component, call `usePayoffRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoffRequestQuery({
 *   variables: {
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function usePayoffRequestQuery(baseOptions?: Apollo.QueryHookOptions<PayoffRequestQuery, PayoffRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoffRequestQuery, PayoffRequestQueryVariables>(PayoffRequestDocument, options);
      }
export function usePayoffRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoffRequestQuery, PayoffRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoffRequestQuery, PayoffRequestQueryVariables>(PayoffRequestDocument, options);
        }
export type PayoffRequestQueryHookResult = ReturnType<typeof usePayoffRequestQuery>;
export type PayoffRequestLazyQueryHookResult = ReturnType<typeof usePayoffRequestLazyQuery>;
export type PayoffRequestQueryResult = Apollo.QueryResult<PayoffRequestQuery, PayoffRequestQueryVariables>;
export const AcquirePayoffForDealDocument = gql`
    mutation acquirePayoffForDeal($dealId: Int!, $payloadFields: [String!]!) {
  acquirePayoffForDeal(dealId: $dealId, payloadFields: $payloadFields) {
    received
  }
}
    `;
export type AcquirePayoffForDealMutationFn = Apollo.MutationFunction<AcquirePayoffForDealMutation, AcquirePayoffForDealMutationVariables>;

/**
 * __useAcquirePayoffForDealMutation__
 *
 * To run a mutation, you first call `useAcquirePayoffForDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquirePayoffForDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquirePayoffForDealMutation, { data, loading, error }] = useAcquirePayoffForDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      payloadFields: // value for 'payloadFields'
 *   },
 * });
 */
export function useAcquirePayoffForDealMutation(baseOptions?: Apollo.MutationHookOptions<AcquirePayoffForDealMutation, AcquirePayoffForDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcquirePayoffForDealMutation, AcquirePayoffForDealMutationVariables>(AcquirePayoffForDealDocument, options);
      }
export type AcquirePayoffForDealMutationHookResult = ReturnType<typeof useAcquirePayoffForDealMutation>;
export type AcquirePayoffForDealMutationResult = Apollo.MutationResult<AcquirePayoffForDealMutation>;
export type AcquirePayoffForDealMutationOptions = Apollo.BaseMutationOptions<AcquirePayoffForDealMutation, AcquirePayoffForDealMutationVariables>;
export const PayoffRequestConfirmDocument = gql`
    mutation payoffRequestConfirm($payoffRequest: payoffRequestConfirmInput!) {
  payoffRequestConfirm(payoffRequest: $payoffRequest) {
    id
    vehicle_payoff
    good_through_date
  }
}
    `;
export type PayoffRequestConfirmMutationFn = Apollo.MutationFunction<PayoffRequestConfirmMutation, PayoffRequestConfirmMutationVariables>;

/**
 * __usePayoffRequestConfirmMutation__
 *
 * To run a mutation, you first call `usePayoffRequestConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffRequestConfirmMutation, { data, loading, error }] = usePayoffRequestConfirmMutation({
 *   variables: {
 *      payoffRequest: // value for 'payoffRequest'
 *   },
 * });
 */
export function usePayoffRequestConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PayoffRequestConfirmMutation, PayoffRequestConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffRequestConfirmMutation, PayoffRequestConfirmMutationVariables>(PayoffRequestConfirmDocument, options);
      }
export type PayoffRequestConfirmMutationHookResult = ReturnType<typeof usePayoffRequestConfirmMutation>;
export type PayoffRequestConfirmMutationResult = Apollo.MutationResult<PayoffRequestConfirmMutation>;
export type PayoffRequestConfirmMutationOptions = Apollo.BaseMutationOptions<PayoffRequestConfirmMutation, PayoffRequestConfirmMutationVariables>;
export const PayoffRequestUpdateDocument = gql`
    mutation payoffRequestUpdate($payoffRequest: payoffRequestInput!) {
  payoffRequestUpdate(payoffRequest: $payoffRequest) {
    id
  }
}
    `;
export type PayoffRequestUpdateMutationFn = Apollo.MutationFunction<PayoffRequestUpdateMutation, PayoffRequestUpdateMutationVariables>;

/**
 * __usePayoffRequestUpdateMutation__
 *
 * To run a mutation, you first call `usePayoffRequestUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffRequestUpdateMutation, { data, loading, error }] = usePayoffRequestUpdateMutation({
 *   variables: {
 *      payoffRequest: // value for 'payoffRequest'
 *   },
 * });
 */
export function usePayoffRequestUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PayoffRequestUpdateMutation, PayoffRequestUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffRequestUpdateMutation, PayoffRequestUpdateMutationVariables>(PayoffRequestUpdateDocument, options);
      }
export type PayoffRequestUpdateMutationHookResult = ReturnType<typeof usePayoffRequestUpdateMutation>;
export type PayoffRequestUpdateMutationResult = Apollo.MutationResult<PayoffRequestUpdateMutation>;
export type PayoffRequestUpdateMutationOptions = Apollo.BaseMutationOptions<PayoffRequestUpdateMutation, PayoffRequestUpdateMutationVariables>;
export const UpdatePayoffClerkDocument = gql`
    mutation updatePayoffClerk($payoff_request_id: ID, $payoff_clerk_id: String) {
  updatePayoffClerk(
    payoff_request_id: $payoff_request_id
    payoff_clerk_id: $payoff_clerk_id
  )
}
    `;
export type UpdatePayoffClerkMutationFn = Apollo.MutationFunction<UpdatePayoffClerkMutation, UpdatePayoffClerkMutationVariables>;

/**
 * __useUpdatePayoffClerkMutation__
 *
 * To run a mutation, you first call `useUpdatePayoffClerkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoffClerkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoffClerkMutation, { data, loading, error }] = useUpdatePayoffClerkMutation({
 *   variables: {
 *      payoff_request_id: // value for 'payoff_request_id'
 *      payoff_clerk_id: // value for 'payoff_clerk_id'
 *   },
 * });
 */
export function useUpdatePayoffClerkMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayoffClerkMutation, UpdatePayoffClerkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayoffClerkMutation, UpdatePayoffClerkMutationVariables>(UpdatePayoffClerkDocument, options);
      }
export type UpdatePayoffClerkMutationHookResult = ReturnType<typeof useUpdatePayoffClerkMutation>;
export type UpdatePayoffClerkMutationResult = Apollo.MutationResult<UpdatePayoffClerkMutation>;
export type UpdatePayoffClerkMutationOptions = Apollo.BaseMutationOptions<UpdatePayoffClerkMutation, UpdatePayoffClerkMutationVariables>;
export const PayoffRequestFailureRequestDocument = gql`
    mutation payoffRequestFailureRequest($payoffRequest: payoffRequestInput!) {
  payoffRequestFailureRequest(payoffRequest: $payoffRequest) {
    id
    fail_reason
  }
}
    `;
export type PayoffRequestFailureRequestMutationFn = Apollo.MutationFunction<PayoffRequestFailureRequestMutation, PayoffRequestFailureRequestMutationVariables>;

/**
 * __usePayoffRequestFailureRequestMutation__
 *
 * To run a mutation, you first call `usePayoffRequestFailureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestFailureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffRequestFailureRequestMutation, { data, loading, error }] = usePayoffRequestFailureRequestMutation({
 *   variables: {
 *      payoffRequest: // value for 'payoffRequest'
 *   },
 * });
 */
export function usePayoffRequestFailureRequestMutation(baseOptions?: Apollo.MutationHookOptions<PayoffRequestFailureRequestMutation, PayoffRequestFailureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffRequestFailureRequestMutation, PayoffRequestFailureRequestMutationVariables>(PayoffRequestFailureRequestDocument, options);
      }
export type PayoffRequestFailureRequestMutationHookResult = ReturnType<typeof usePayoffRequestFailureRequestMutation>;
export type PayoffRequestFailureRequestMutationResult = Apollo.MutationResult<PayoffRequestFailureRequestMutation>;
export type PayoffRequestFailureRequestMutationOptions = Apollo.BaseMutationOptions<PayoffRequestFailureRequestMutation, PayoffRequestFailureRequestMutationVariables>;
export const PayoffRequestFailDocument = gql`
    mutation payoffRequestFail($payoffRequest: payoffRequestInput!) {
  payoffRequestFail(payoffRequest: $payoffRequest) {
    id
    fail_reason
  }
}
    `;
export type PayoffRequestFailMutationFn = Apollo.MutationFunction<PayoffRequestFailMutation, PayoffRequestFailMutationVariables>;

/**
 * __usePayoffRequestFailMutation__
 *
 * To run a mutation, you first call `usePayoffRequestFailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestFailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffRequestFailMutation, { data, loading, error }] = usePayoffRequestFailMutation({
 *   variables: {
 *      payoffRequest: // value for 'payoffRequest'
 *   },
 * });
 */
export function usePayoffRequestFailMutation(baseOptions?: Apollo.MutationHookOptions<PayoffRequestFailMutation, PayoffRequestFailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffRequestFailMutation, PayoffRequestFailMutationVariables>(PayoffRequestFailDocument, options);
      }
export type PayoffRequestFailMutationHookResult = ReturnType<typeof usePayoffRequestFailMutation>;
export type PayoffRequestFailMutationResult = Apollo.MutationResult<PayoffRequestFailMutation>;
export type PayoffRequestFailMutationOptions = Apollo.BaseMutationOptions<PayoffRequestFailMutation, PayoffRequestFailMutationVariables>;
export const CreatePayoffRequestDocument = gql`
    mutation createPayoffRequest($dealId: ID!, $digitalPayoffAvailable: Boolean!, $doubleTaxApplicable: Boolean!) {
  createPayoffRequest(
    dealId: $dealId
    digitalPayoffAvailable: $digitalPayoffAvailable
    doubleTaxApplicable: $doubleTaxApplicable
  ) {
    deal_id
    status
    vehicle_payoff
    sales_tax
    completed_date
    good_through_date
  }
}
    `;
export type CreatePayoffRequestMutationFn = Apollo.MutationFunction<CreatePayoffRequestMutation, CreatePayoffRequestMutationVariables>;

/**
 * __useCreatePayoffRequestMutation__
 *
 * To run a mutation, you first call `useCreatePayoffRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoffRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoffRequestMutation, { data, loading, error }] = useCreatePayoffRequestMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      digitalPayoffAvailable: // value for 'digitalPayoffAvailable'
 *      doubleTaxApplicable: // value for 'doubleTaxApplicable'
 *   },
 * });
 */
export function useCreatePayoffRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayoffRequestMutation, CreatePayoffRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayoffRequestMutation, CreatePayoffRequestMutationVariables>(CreatePayoffRequestDocument, options);
      }
export type CreatePayoffRequestMutationHookResult = ReturnType<typeof useCreatePayoffRequestMutation>;
export type CreatePayoffRequestMutationResult = Apollo.MutationResult<CreatePayoffRequestMutation>;
export type CreatePayoffRequestMutationOptions = Apollo.BaseMutationOptions<CreatePayoffRequestMutation, CreatePayoffRequestMutationVariables>;
export const PayoffRequestCancelDocument = gql`
    mutation payoffRequestCancel($payoffRequestId: ID!) {
  payoffRequestCancel(payoffRequestId: $payoffRequestId) {
    id
  }
}
    `;
export type PayoffRequestCancelMutationFn = Apollo.MutationFunction<PayoffRequestCancelMutation, PayoffRequestCancelMutationVariables>;

/**
 * __usePayoffRequestCancelMutation__
 *
 * To run a mutation, you first call `usePayoffRequestCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayoffRequestCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payoffRequestCancelMutation, { data, loading, error }] = usePayoffRequestCancelMutation({
 *   variables: {
 *      payoffRequestId: // value for 'payoffRequestId'
 *   },
 * });
 */
export function usePayoffRequestCancelMutation(baseOptions?: Apollo.MutationHookOptions<PayoffRequestCancelMutation, PayoffRequestCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayoffRequestCancelMutation, PayoffRequestCancelMutationVariables>(PayoffRequestCancelDocument, options);
      }
export type PayoffRequestCancelMutationHookResult = ReturnType<typeof usePayoffRequestCancelMutation>;
export type PayoffRequestCancelMutationResult = Apollo.MutationResult<PayoffRequestCancelMutation>;
export type PayoffRequestCancelMutationOptions = Apollo.BaseMutationOptions<PayoffRequestCancelMutation, PayoffRequestCancelMutationVariables>;
export const OnPayoffRequestUpdateDocument = gql`
    subscription onPayoffRequestUpdate {
  onPayoffRequestUpdate {
    ...PayoffRequestPopulatedFragment
  }
}
    ${PayoffRequestPopulatedFragmentFragmentDoc}`;

/**
 * __useOnPayoffRequestUpdateSubscription__
 *
 * To run a query within a React component, call `useOnPayoffRequestUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPayoffRequestUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPayoffRequestUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnPayoffRequestUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnPayoffRequestUpdateSubscription, OnPayoffRequestUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPayoffRequestUpdateSubscription, OnPayoffRequestUpdateSubscriptionVariables>(OnPayoffRequestUpdateDocument, options);
      }
export type OnPayoffRequestUpdateSubscriptionHookResult = ReturnType<typeof useOnPayoffRequestUpdateSubscription>;
export type OnPayoffRequestUpdateSubscriptionResult = Apollo.SubscriptionResult<OnPayoffRequestUpdateSubscription>;
export const OnPayoffRequestStatusUpdateDocument = gql`
    subscription onPayoffRequestStatusUpdate($dealId: ID) {
  onPayoffRequestStatusUpdate(dealId: $dealId) {
    payoffRequest {
      id
      deal_id
      temporary_info_id
      status
      vehicle_payoff
      good_through_date
      sales_tax
      completed_date
      fail_reason
      created_at
      updated_at
      deal {
        id
        state
        customer {
          first_name
          last_name
        }
        car {
          id
          payoff {
            id
            verification_status
            user_entered_total_payoff
            vehicle_payoff
            sales_tax_from_payoff
            payoff_includes_sales_tax
            sales_tax_from_payoff_entered_manually
            good_through_date
          }
        }
        tags {
          id
          badge_variant
          slug
          display_name
          color
          is_active
          is_dashboard_visible
          badge_variant
        }
      }
    }
    message
  }
}
    `;

/**
 * __useOnPayoffRequestStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useOnPayoffRequestStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPayoffRequestStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPayoffRequestStatusUpdateSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnPayoffRequestStatusUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnPayoffRequestStatusUpdateSubscription, OnPayoffRequestStatusUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPayoffRequestStatusUpdateSubscription, OnPayoffRequestStatusUpdateSubscriptionVariables>(OnPayoffRequestStatusUpdateDocument, options);
      }
export type OnPayoffRequestStatusUpdateSubscriptionHookResult = ReturnType<typeof useOnPayoffRequestStatusUpdateSubscription>;
export type OnPayoffRequestStatusUpdateSubscriptionResult = Apollo.SubscriptionResult<OnPayoffRequestStatusUpdateSubscription>;
export const PodsDocument = gql`
    query pods($userId: String, $permissions: [String], $pod_ids: [ID], $team_type: [teamType], $includeDetails: Boolean = false, $hideArchived: Boolean = false) {
  pods(
    userId: $userId
    permissions: $permissions
    pod_ids: $pod_ids
    team_type: $team_type
    hideArchived: $hideArchived
  ) {
    id
    name
    color
    hours
    archived
    team_type
    created_at
    manager_commission_rate
    manager_commission_type
    special_commission_rate
    special_commission_type
    closer_commission_rate
    closer_commission_type
    setter_commission_rate
    setter_commission_type
    auto_assign_deals
    pause_auto_assign
    assign_overnight_deals
    active_reps_override
    active_reps_override_set_at
    managers @include(if: $includeDetails) {
      id
      name
    }
    leads @include(if: $includeDetails) {
      id
      name
    }
    fundingClerks @include(if: $includeDetails) {
      id
      name
    }
    problem_solver
    us_states_object {
      states
    }
    parent_pod_id
    pod_users @include(if: $includeDetails) {
      id
      user_id
      pod_id
      team_role
      user {
        id
        name
      }
    }
    parent_pod @include(if: $includeDetails) {
      id
      name
    }
    child_pods @include(if: $includeDetails) {
      id
      name
    }
    usersWithoutTeamRole @include(if: $includeDetails) {
      id
      name
    }
  }
}
    `;

/**
 * __usePodsQuery__
 *
 * To run a query within a React component, call `usePodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      permissions: // value for 'permissions'
 *      pod_ids: // value for 'pod_ids'
 *      team_type: // value for 'team_type'
 *      includeDetails: // value for 'includeDetails'
 *      hideArchived: // value for 'hideArchived'
 *   },
 * });
 */
export function usePodsQuery(baseOptions?: Apollo.QueryHookOptions<PodsQuery, PodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodsQuery, PodsQueryVariables>(PodsDocument, options);
      }
export function usePodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodsQuery, PodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodsQuery, PodsQueryVariables>(PodsDocument, options);
        }
export type PodsQueryHookResult = ReturnType<typeof usePodsQuery>;
export type PodsLazyQueryHookResult = ReturnType<typeof usePodsLazyQuery>;
export type PodsQueryResult = Apollo.QueryResult<PodsQuery, PodsQueryVariables>;
export const PodUpsertAndPodUsersUpdateDocument = gql`
    mutation podUpsertAndPodUsersUpdate($newPod: podInput!, $oldPod: podInput) {
  podUpsertAndPodUsersUpdate(newPod: $newPod, oldPod: $oldPod) {
    id
  }
}
    `;
export type PodUpsertAndPodUsersUpdateMutationFn = Apollo.MutationFunction<PodUpsertAndPodUsersUpdateMutation, PodUpsertAndPodUsersUpdateMutationVariables>;

/**
 * __usePodUpsertAndPodUsersUpdateMutation__
 *
 * To run a mutation, you first call `usePodUpsertAndPodUsersUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePodUpsertAndPodUsersUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [podUpsertAndPodUsersUpdateMutation, { data, loading, error }] = usePodUpsertAndPodUsersUpdateMutation({
 *   variables: {
 *      newPod: // value for 'newPod'
 *      oldPod: // value for 'oldPod'
 *   },
 * });
 */
export function usePodUpsertAndPodUsersUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PodUpsertAndPodUsersUpdateMutation, PodUpsertAndPodUsersUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PodUpsertAndPodUsersUpdateMutation, PodUpsertAndPodUsersUpdateMutationVariables>(PodUpsertAndPodUsersUpdateDocument, options);
      }
export type PodUpsertAndPodUsersUpdateMutationHookResult = ReturnType<typeof usePodUpsertAndPodUsersUpdateMutation>;
export type PodUpsertAndPodUsersUpdateMutationResult = Apollo.MutationResult<PodUpsertAndPodUsersUpdateMutation>;
export type PodUpsertAndPodUsersUpdateMutationOptions = Apollo.BaseMutationOptions<PodUpsertAndPodUsersUpdateMutation, PodUpsertAndPodUsersUpdateMutationVariables>;
export const PodUpsertDocument = gql`
    mutation podUpsert($pod: basePodInput) {
  podUpsert(pod: $pod) {
    id
    name
    color
    hours
    archived
    closer_commission_rate
    team_type
    problem_solver
    us_states_object {
      states
    }
  }
}
    `;
export type PodUpsertMutationFn = Apollo.MutationFunction<PodUpsertMutation, PodUpsertMutationVariables>;

/**
 * __usePodUpsertMutation__
 *
 * To run a mutation, you first call `usePodUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePodUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [podUpsertMutation, { data, loading, error }] = usePodUpsertMutation({
 *   variables: {
 *      pod: // value for 'pod'
 *   },
 * });
 */
export function usePodUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PodUpsertMutation, PodUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PodUpsertMutation, PodUpsertMutationVariables>(PodUpsertDocument, options);
      }
export type PodUpsertMutationHookResult = ReturnType<typeof usePodUpsertMutation>;
export type PodUpsertMutationResult = Apollo.MutationResult<PodUpsertMutation>;
export type PodUpsertMutationOptions = Apollo.BaseMutationOptions<PodUpsertMutation, PodUpsertMutationVariables>;
export const ArchivePodDocument = gql`
    mutation archivePod($id: ID!, $name: String!) {
  archivePod(id: $id, name: $name)
}
    `;
export type ArchivePodMutationFn = Apollo.MutationFunction<ArchivePodMutation, ArchivePodMutationVariables>;

/**
 * __useArchivePodMutation__
 *
 * To run a mutation, you first call `useArchivePodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePodMutation, { data, loading, error }] = useArchivePodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useArchivePodMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePodMutation, ArchivePodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePodMutation, ArchivePodMutationVariables>(ArchivePodDocument, options);
      }
export type ArchivePodMutationHookResult = ReturnType<typeof useArchivePodMutation>;
export type ArchivePodMutationResult = Apollo.MutationResult<ArchivePodMutation>;
export type ArchivePodMutationOptions = Apollo.BaseMutationOptions<ArchivePodMutation, ArchivePodMutationVariables>;
export const TitlingPodsAllDocument = gql`
    query titlingPodsAll {
  titlingPodsAll {
    id
    name
    color
    us_states_object {
      states
    }
    problem_solver
    archived
    pod_users {
      id
      user_id
      pod_id
      team_role
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTitlingPodsAllQuery__
 *
 * To run a query within a React component, call `useTitlingPodsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlingPodsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlingPodsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useTitlingPodsAllQuery(baseOptions?: Apollo.QueryHookOptions<TitlingPodsAllQuery, TitlingPodsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlingPodsAllQuery, TitlingPodsAllQueryVariables>(TitlingPodsAllDocument, options);
      }
export function useTitlingPodsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlingPodsAllQuery, TitlingPodsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlingPodsAllQuery, TitlingPodsAllQueryVariables>(TitlingPodsAllDocument, options);
        }
export type TitlingPodsAllQueryHookResult = ReturnType<typeof useTitlingPodsAllQuery>;
export type TitlingPodsAllLazyQueryHookResult = ReturnType<typeof useTitlingPodsAllLazyQuery>;
export type TitlingPodsAllQueryResult = Apollo.QueryResult<TitlingPodsAllQuery, TitlingPodsAllQueryVariables>;
export const GetDdSoftPullDocument = gql`
    query getDDSoftPull($dealId: ID!, $paymentEstimateInput: paymentEstimateInput!, $shouldForceRetry: Boolean) {
  getDDSoftPull(
    dealId: $dealId
    paymentEstimateInput: $paymentEstimateInput
    shouldForceRetry: $shouldForceRetry
  ) {
    customer {
      ...PrequalificationFragment
    }
    cobuyer {
      ...PrequalificationFragment
    }
  }
}
    ${PrequalificationFragmentFragmentDoc}`;

/**
 * __useGetDdSoftPullQuery__
 *
 * To run a query within a React component, call `useGetDdSoftPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdSoftPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdSoftPullQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      paymentEstimateInput: // value for 'paymentEstimateInput'
 *      shouldForceRetry: // value for 'shouldForceRetry'
 *   },
 * });
 */
export function useGetDdSoftPullQuery(baseOptions: Apollo.QueryHookOptions<GetDdSoftPullQuery, GetDdSoftPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDdSoftPullQuery, GetDdSoftPullQueryVariables>(GetDdSoftPullDocument, options);
      }
export function useGetDdSoftPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDdSoftPullQuery, GetDdSoftPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDdSoftPullQuery, GetDdSoftPullQueryVariables>(GetDdSoftPullDocument, options);
        }
export type GetDdSoftPullQueryHookResult = ReturnType<typeof useGetDdSoftPullQuery>;
export type GetDdSoftPullLazyQueryHookResult = ReturnType<typeof useGetDdSoftPullLazyQuery>;
export type GetDdSoftPullQueryResult = Apollo.QueryResult<GetDdSoftPullQuery, GetDdSoftPullQueryVariables>;
export const ExperianCreditReportDocument = gql`
    query experianCreditReport($dealId: ID!) {
  experianCreditReport(dealId: $dealId) {
    customer {
      ...PrequalificationCreditReportFragment
    }
    cobuyer {
      ...PrequalificationCreditReportFragment
    }
  }
}
    ${PrequalificationCreditReportFragmentFragmentDoc}`;

/**
 * __useExperianCreditReportQuery__
 *
 * To run a query within a React component, call `useExperianCreditReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperianCreditReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperianCreditReportQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useExperianCreditReportQuery(baseOptions: Apollo.QueryHookOptions<ExperianCreditReportQuery, ExperianCreditReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperianCreditReportQuery, ExperianCreditReportQueryVariables>(ExperianCreditReportDocument, options);
      }
export function useExperianCreditReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperianCreditReportQuery, ExperianCreditReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperianCreditReportQuery, ExperianCreditReportQueryVariables>(ExperianCreditReportDocument, options);
        }
export type ExperianCreditReportQueryHookResult = ReturnType<typeof useExperianCreditReportQuery>;
export type ExperianCreditReportLazyQueryHookResult = ReturnType<typeof useExperianCreditReportLazyQuery>;
export type ExperianCreditReportQueryResult = Apollo.QueryResult<ExperianCreditReportQuery, ExperianCreditReportQueryVariables>;
export const VscRatesDocument = gql`
    query vscRates($bank: String!, $deal_id: ID!, $data: rateInput) {
  vscRates(bank: $bank, deal_id: $deal_id, data: $data) {
    ...RateFragment
  }
}
    ${RateFragmentFragmentDoc}`;

/**
 * __useVscRatesQuery__
 *
 * To run a query within a React component, call `useVscRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVscRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVscRatesQuery({
 *   variables: {
 *      bank: // value for 'bank'
 *      deal_id: // value for 'deal_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVscRatesQuery(baseOptions: Apollo.QueryHookOptions<VscRatesQuery, VscRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VscRatesQuery, VscRatesQueryVariables>(VscRatesDocument, options);
      }
export function useVscRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VscRatesQuery, VscRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VscRatesQuery, VscRatesQueryVariables>(VscRatesDocument, options);
        }
export type VscRatesQueryHookResult = ReturnType<typeof useVscRatesQuery>;
export type VscRatesLazyQueryHookResult = ReturnType<typeof useVscRatesLazyQuery>;
export type VscRatesQueryResult = Apollo.QueryResult<VscRatesQuery, VscRatesQueryVariables>;
export const GapRatesDocument = gql`
    query gapRates($bank: String!, $deal_id: ID!, $data: rateInput) {
  gapRates(bank: $bank, deal_id: $deal_id, data: $data) {
    ...RateFragment
  }
}
    ${RateFragmentFragmentDoc}`;

/**
 * __useGapRatesQuery__
 *
 * To run a query within a React component, call `useGapRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGapRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGapRatesQuery({
 *   variables: {
 *      bank: // value for 'bank'
 *      deal_id: // value for 'deal_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGapRatesQuery(baseOptions: Apollo.QueryHookOptions<GapRatesQuery, GapRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GapRatesQuery, GapRatesQueryVariables>(GapRatesDocument, options);
      }
export function useGapRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GapRatesQuery, GapRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GapRatesQuery, GapRatesQueryVariables>(GapRatesDocument, options);
        }
export type GapRatesQueryHookResult = ReturnType<typeof useGapRatesQuery>;
export type GapRatesLazyQueryHookResult = ReturnType<typeof useGapRatesLazyQuery>;
export type GapRatesQueryResult = Apollo.QueryResult<GapRatesQuery, GapRatesQueryVariables>;
export const TireWheelRatesDocument = gql`
    query tireWheelRates($bank: String!, $deal_id: ID!, $data: rateInput) {
  tireWheelRates(bank: $bank, deal_id: $deal_id, data: $data) {
    ...RateFragment
  }
}
    ${RateFragmentFragmentDoc}`;

/**
 * __useTireWheelRatesQuery__
 *
 * To run a query within a React component, call `useTireWheelRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTireWheelRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTireWheelRatesQuery({
 *   variables: {
 *      bank: // value for 'bank'
 *      deal_id: // value for 'deal_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTireWheelRatesQuery(baseOptions: Apollo.QueryHookOptions<TireWheelRatesQuery, TireWheelRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TireWheelRatesQuery, TireWheelRatesQueryVariables>(TireWheelRatesDocument, options);
      }
export function useTireWheelRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TireWheelRatesQuery, TireWheelRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TireWheelRatesQuery, TireWheelRatesQueryVariables>(TireWheelRatesDocument, options);
        }
export type TireWheelRatesQueryHookResult = ReturnType<typeof useTireWheelRatesQuery>;
export type TireWheelRatesLazyQueryHookResult = ReturnType<typeof useTireWheelRatesLazyQuery>;
export type TireWheelRatesQueryResult = Apollo.QueryResult<TireWheelRatesQuery, TireWheelRatesQueryVariables>;
export const KeyReplacementRatesDocument = gql`
    query keyReplacementRates($bank: String!, $deal_id: ID!, $data: rateInput) {
  keyReplacementRates(bank: $bank, deal_id: $deal_id, data: $data) {
    ...RateFragment
  }
}
    ${RateFragmentFragmentDoc}`;

/**
 * __useKeyReplacementRatesQuery__
 *
 * To run a query within a React component, call `useKeyReplacementRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyReplacementRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyReplacementRatesQuery({
 *   variables: {
 *      bank: // value for 'bank'
 *      deal_id: // value for 'deal_id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useKeyReplacementRatesQuery(baseOptions: Apollo.QueryHookOptions<KeyReplacementRatesQuery, KeyReplacementRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyReplacementRatesQuery, KeyReplacementRatesQueryVariables>(KeyReplacementRatesDocument, options);
      }
export function useKeyReplacementRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyReplacementRatesQuery, KeyReplacementRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyReplacementRatesQuery, KeyReplacementRatesQueryVariables>(KeyReplacementRatesDocument, options);
        }
export type KeyReplacementRatesQueryHookResult = ReturnType<typeof useKeyReplacementRatesQuery>;
export type KeyReplacementRatesLazyQueryHookResult = ReturnType<typeof useKeyReplacementRatesLazyQuery>;
export type KeyReplacementRatesQueryResult = Apollo.QueryResult<KeyReplacementRatesQuery, KeyReplacementRatesQueryVariables>;
export const ProductsCatalogV2Document = gql`
    query productsCatalogV2 {
  productsCatalogV2 {
    id
    slug
    name
    is_user_selectable
    display_order
    is_active
    base_price
    base_cost
    bonus_amount
    metadata
  }
}
    `;

/**
 * __useProductsCatalogV2Query__
 *
 * To run a query within a React component, call `useProductsCatalogV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogV2Query({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogV2Query(baseOptions?: Apollo.QueryHookOptions<ProductsCatalogV2Query, ProductsCatalogV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsCatalogV2Query, ProductsCatalogV2QueryVariables>(ProductsCatalogV2Document, options);
      }
export function useProductsCatalogV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsCatalogV2Query, ProductsCatalogV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsCatalogV2Query, ProductsCatalogV2QueryVariables>(ProductsCatalogV2Document, options);
        }
export type ProductsCatalogV2QueryHookResult = ReturnType<typeof useProductsCatalogV2Query>;
export type ProductsCatalogV2LazyQueryHookResult = ReturnType<typeof useProductsCatalogV2LazyQuery>;
export type ProductsCatalogV2QueryResult = Apollo.QueryResult<ProductsCatalogV2Query, ProductsCatalogV2QueryVariables>;
export const CreateReviewDocument = gql`
    mutation createReview($review: reviewInput) {
  createReview(review: $review) {
    id
  }
}
    `;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const ReviewsDocument = gql`
    query reviews {
  reviews {
    id
    customer_name
    review
    com_visible
    created_at
    location
  }
}
    `;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewsQuery(baseOptions?: Apollo.QueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
      }
export function useReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
        }
export type ReviewsQueryHookResult = ReturnType<typeof useReviewsQuery>;
export type ReviewsLazyQueryHookResult = ReturnType<typeof useReviewsLazyQuery>;
export type ReviewsQueryResult = Apollo.QueryResult<ReviewsQuery, ReviewsQueryVariables>;
export const DeleteReviewDocument = gql`
    mutation deleteReview($id: ID!) {
  deleteReview(id: $id) {
    id
  }
}
    `;
export type DeleteReviewMutationFn = Apollo.MutationFunction<DeleteReviewMutation, DeleteReviewMutationVariables>;

/**
 * __useDeleteReviewMutation__
 *
 * To run a mutation, you first call `useDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewMutation, { data, loading, error }] = useDeleteReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewMutation, DeleteReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewMutation, DeleteReviewMutationVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewMutationHookResult = ReturnType<typeof useDeleteReviewMutation>;
export type DeleteReviewMutationResult = Apollo.MutationResult<DeleteReviewMutation>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<DeleteReviewMutation, DeleteReviewMutationVariables>;
export const UpdateReviewDocument = gql`
    mutation updateReview($review: reviewInput) {
  updateReview(review: $review) {
    id
    customer_name
    review
    com_visible
    created_at
    location
  }
}
    `;
export type UpdateReviewMutationFn = Apollo.MutationFunction<UpdateReviewMutation, UpdateReviewMutationVariables>;

/**
 * __useUpdateReviewMutation__
 *
 * To run a mutation, you first call `useUpdateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewMutation, { data, loading, error }] = useUpdateReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *   },
 * });
 */
export function useUpdateReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReviewMutation, UpdateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, options);
      }
export type UpdateReviewMutationHookResult = ReturnType<typeof useUpdateReviewMutation>;
export type UpdateReviewMutationResult = Apollo.MutationResult<UpdateReviewMutation>;
export type UpdateReviewMutationOptions = Apollo.BaseMutationOptions<UpdateReviewMutation, UpdateReviewMutationVariables>;
export const CreateAndSendSecureLinkDocument = gql`
    mutation createAndSendSecureLink($customerId: ID!, $expiresInHours: Int!, $sendText: Boolean!, $sendEmail: Boolean!) {
  createAndSendSecureLink(
    customerId: $customerId
    expiresInHours: $expiresInHours
    sendText: $sendText
    sendEmail: $sendEmail
  ) {
    success
    textError
    emailError
  }
}
    `;
export type CreateAndSendSecureLinkMutationFn = Apollo.MutationFunction<CreateAndSendSecureLinkMutation, CreateAndSendSecureLinkMutationVariables>;

/**
 * __useCreateAndSendSecureLinkMutation__
 *
 * To run a mutation, you first call `useCreateAndSendSecureLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndSendSecureLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndSendSecureLinkMutation, { data, loading, error }] = useCreateAndSendSecureLinkMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      expiresInHours: // value for 'expiresInHours'
 *      sendText: // value for 'sendText'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useCreateAndSendSecureLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndSendSecureLinkMutation, CreateAndSendSecureLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndSendSecureLinkMutation, CreateAndSendSecureLinkMutationVariables>(CreateAndSendSecureLinkDocument, options);
      }
export type CreateAndSendSecureLinkMutationHookResult = ReturnType<typeof useCreateAndSendSecureLinkMutation>;
export type CreateAndSendSecureLinkMutationResult = Apollo.MutationResult<CreateAndSendSecureLinkMutation>;
export type CreateAndSendSecureLinkMutationOptions = Apollo.BaseMutationOptions<CreateAndSendSecureLinkMutation, CreateAndSendSecureLinkMutationVariables>;
export const UnlockDealDocument = gql`
    mutation unlockDeal($dealId: ID!) {
  unlockDeal(dealId: $dealId)
}
    `;
export type UnlockDealMutationFn = Apollo.MutationFunction<UnlockDealMutation, UnlockDealMutationVariables>;

/**
 * __useUnlockDealMutation__
 *
 * To run a mutation, you first call `useUnlockDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockDealMutation, { data, loading, error }] = useUnlockDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useUnlockDealMutation(baseOptions?: Apollo.MutationHookOptions<UnlockDealMutation, UnlockDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockDealMutation, UnlockDealMutationVariables>(UnlockDealDocument, options);
      }
export type UnlockDealMutationHookResult = ReturnType<typeof useUnlockDealMutation>;
export type UnlockDealMutationResult = Apollo.MutationResult<UnlockDealMutation>;
export type UnlockDealMutationOptions = Apollo.BaseMutationOptions<UnlockDealMutation, UnlockDealMutationVariables>;
export const OnSecureLinkCreatedDocument = gql`
    subscription onSecureLinkCreated($customerIds: [ID!]) {
  onSecureLinkCreated(customerIds: $customerIds) {
    ...SecureLinkNotificationFragment
  }
}
    ${SecureLinkNotificationFragmentFragmentDoc}`;

/**
 * __useOnSecureLinkCreatedSubscription__
 *
 * To run a query within a React component, call `useOnSecureLinkCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSecureLinkCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSecureLinkCreatedSubscription({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useOnSecureLinkCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnSecureLinkCreatedSubscription, OnSecureLinkCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSecureLinkCreatedSubscription, OnSecureLinkCreatedSubscriptionVariables>(OnSecureLinkCreatedDocument, options);
      }
export type OnSecureLinkCreatedSubscriptionHookResult = ReturnType<typeof useOnSecureLinkCreatedSubscription>;
export type OnSecureLinkCreatedSubscriptionResult = Apollo.SubscriptionResult<OnSecureLinkCreatedSubscription>;
export const OnSecureLinkExpiredDocument = gql`
    subscription onSecureLinkExpired($customerIds: [ID!]) {
  onSecureLinkExpired(customerIds: $customerIds) {
    ...SecureLinkNotificationFragment
  }
}
    ${SecureLinkNotificationFragmentFragmentDoc}`;

/**
 * __useOnSecureLinkExpiredSubscription__
 *
 * To run a query within a React component, call `useOnSecureLinkExpiredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSecureLinkExpiredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSecureLinkExpiredSubscription({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useOnSecureLinkExpiredSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnSecureLinkExpiredSubscription, OnSecureLinkExpiredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSecureLinkExpiredSubscription, OnSecureLinkExpiredSubscriptionVariables>(OnSecureLinkExpiredDocument, options);
      }
export type OnSecureLinkExpiredSubscriptionHookResult = ReturnType<typeof useOnSecureLinkExpiredSubscription>;
export type OnSecureLinkExpiredSubscriptionResult = Apollo.SubscriptionResult<OnSecureLinkExpiredSubscription>;
export const DecryptSsnDocument = gql`
    mutation decryptSSN($customerId: ID, $tempInfoId: ID, $originalLesseeId: ID) {
  decryptSSN(
    customerId: $customerId
    tempInfoId: $tempInfoId
    originalLesseeId: $originalLesseeId
  ) {
    ssn
    ssnId
  }
}
    `;
export type DecryptSsnMutationFn = Apollo.MutationFunction<DecryptSsnMutation, DecryptSsnMutationVariables>;

/**
 * __useDecryptSsnMutation__
 *
 * To run a mutation, you first call `useDecryptSsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecryptSsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decryptSsnMutation, { data, loading, error }] = useDecryptSsnMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      tempInfoId: // value for 'tempInfoId'
 *      originalLesseeId: // value for 'originalLesseeId'
 *   },
 * });
 */
export function useDecryptSsnMutation(baseOptions?: Apollo.MutationHookOptions<DecryptSsnMutation, DecryptSsnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecryptSsnMutation, DecryptSsnMutationVariables>(DecryptSsnDocument, options);
      }
export type DecryptSsnMutationHookResult = ReturnType<typeof useDecryptSsnMutation>;
export type DecryptSsnMutationResult = Apollo.MutationResult<DecryptSsnMutation>;
export type DecryptSsnMutationOptions = Apollo.BaseMutationOptions<DecryptSsnMutation, DecryptSsnMutationVariables>;
export const UpdateSsnDocument = gql`
    mutation updateSSN($ssnId: ID, $ssn: String!) {
  updateSSN(ssnId: $ssnId, ssn: $ssn)
}
    `;
export type UpdateSsnMutationFn = Apollo.MutationFunction<UpdateSsnMutation, UpdateSsnMutationVariables>;

/**
 * __useUpdateSsnMutation__
 *
 * To run a mutation, you first call `useUpdateSsnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsnMutation, { data, loading, error }] = useUpdateSsnMutation({
 *   variables: {
 *      ssnId: // value for 'ssnId'
 *      ssn: // value for 'ssn'
 *   },
 * });
 */
export function useUpdateSsnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsnMutation, UpdateSsnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsnMutation, UpdateSsnMutationVariables>(UpdateSsnDocument, options);
      }
export type UpdateSsnMutationHookResult = ReturnType<typeof useUpdateSsnMutation>;
export type UpdateSsnMutationResult = Apollo.MutationResult<UpdateSsnMutation>;
export type UpdateSsnMutationOptions = Apollo.BaseMutationOptions<UpdateSsnMutation, UpdateSsnMutationVariables>;
export const ComparePrequalSocialsDocument = gql`
    query comparePrequalSocials($customerId: ID, $cobuyerId: ID) {
  comparePrequalSocials(customerId: $customerId, cobuyerId: $cobuyerId) {
    customerMatches
    cobuyerMatches
  }
}
    `;

/**
 * __useComparePrequalSocialsQuery__
 *
 * To run a query within a React component, call `useComparePrequalSocialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparePrequalSocialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparePrequalSocialsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      cobuyerId: // value for 'cobuyerId'
 *   },
 * });
 */
export function useComparePrequalSocialsQuery(baseOptions?: Apollo.QueryHookOptions<ComparePrequalSocialsQuery, ComparePrequalSocialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparePrequalSocialsQuery, ComparePrequalSocialsQueryVariables>(ComparePrequalSocialsDocument, options);
      }
export function useComparePrequalSocialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparePrequalSocialsQuery, ComparePrequalSocialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparePrequalSocialsQuery, ComparePrequalSocialsQueryVariables>(ComparePrequalSocialsDocument, options);
        }
export type ComparePrequalSocialsQueryHookResult = ReturnType<typeof useComparePrequalSocialsQuery>;
export type ComparePrequalSocialsLazyQueryHookResult = ReturnType<typeof useComparePrequalSocialsLazyQuery>;
export type ComparePrequalSocialsQueryResult = Apollo.QueryResult<ComparePrequalSocialsQuery, ComparePrequalSocialsQueryVariables>;
export const StructuringFollowUpDocument = gql`
    query structuringFollowUp($dealId: ID!) {
  structuringFollowUp(dealId: $dealId) {
    ...StructuringFollowUpFragment
  }
}
    ${StructuringFollowUpFragmentFragmentDoc}`;

/**
 * __useStructuringFollowUpQuery__
 *
 * To run a query within a React component, call `useStructuringFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuringFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuringFollowUpQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useStructuringFollowUpQuery(baseOptions: Apollo.QueryHookOptions<StructuringFollowUpQuery, StructuringFollowUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuringFollowUpQuery, StructuringFollowUpQueryVariables>(StructuringFollowUpDocument, options);
      }
export function useStructuringFollowUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuringFollowUpQuery, StructuringFollowUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuringFollowUpQuery, StructuringFollowUpQueryVariables>(StructuringFollowUpDocument, options);
        }
export type StructuringFollowUpQueryHookResult = ReturnType<typeof useStructuringFollowUpQuery>;
export type StructuringFollowUpLazyQueryHookResult = ReturnType<typeof useStructuringFollowUpLazyQuery>;
export type StructuringFollowUpQueryResult = Apollo.QueryResult<StructuringFollowUpQuery, StructuringFollowUpQueryVariables>;
export const StructuringFollowUpDealsDocument = gql`
    query structuringFollowUpDeals($sortColumn: StructuringFollowUpSortColumn!, $sortDirection: SortDirection!, $sources: [String]!, $dealTypes: [DealType]!, $assignedToMe: Boolean, $bootRequested: Boolean, $notifications: Boolean, $podIds: [ID], $page: Int!, $pageSize: Int!, $showActiveTags: Boolean, $showScheduledFollowUps: Boolean) {
  structuringFollowUpDeals(
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    sources: $sources
    dealTypes: $dealTypes
    assignedToMe: $assignedToMe
    bootRequested: $bootRequested
    notifications: $notifications
    podIds: $podIds
    page: $page
    pageSize: $pageSize
    showActiveTags: $showActiveTags
    showScheduledFollowUps: $showScheduledFollowUps
  ) {
    deals {
      ...StructuringFollowUpDealFragment
    }
    totalRecords
  }
}
    ${StructuringFollowUpDealFragmentFragmentDoc}`;

/**
 * __useStructuringFollowUpDealsQuery__
 *
 * To run a query within a React component, call `useStructuringFollowUpDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuringFollowUpDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuringFollowUpDealsQuery({
 *   variables: {
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      sources: // value for 'sources'
 *      dealTypes: // value for 'dealTypes'
 *      assignedToMe: // value for 'assignedToMe'
 *      bootRequested: // value for 'bootRequested'
 *      notifications: // value for 'notifications'
 *      podIds: // value for 'podIds'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      showActiveTags: // value for 'showActiveTags'
 *      showScheduledFollowUps: // value for 'showScheduledFollowUps'
 *   },
 * });
 */
export function useStructuringFollowUpDealsQuery(baseOptions: Apollo.QueryHookOptions<StructuringFollowUpDealsQuery, StructuringFollowUpDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuringFollowUpDealsQuery, StructuringFollowUpDealsQueryVariables>(StructuringFollowUpDealsDocument, options);
      }
export function useStructuringFollowUpDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuringFollowUpDealsQuery, StructuringFollowUpDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuringFollowUpDealsQuery, StructuringFollowUpDealsQueryVariables>(StructuringFollowUpDealsDocument, options);
        }
export type StructuringFollowUpDealsQueryHookResult = ReturnType<typeof useStructuringFollowUpDealsQuery>;
export type StructuringFollowUpDealsLazyQueryHookResult = ReturnType<typeof useStructuringFollowUpDealsLazyQuery>;
export type StructuringFollowUpDealsQueryResult = Apollo.QueryResult<StructuringFollowUpDealsQuery, StructuringFollowUpDealsQueryVariables>;
export const CreateStructuringFollowUpDocument = gql`
    mutation createStructuringFollowUp($dealId: ID!, $notes: String!) {
  createStructuringFollowUp(dealId: $dealId, notes: $notes)
}
    `;
export type CreateStructuringFollowUpMutationFn = Apollo.MutationFunction<CreateStructuringFollowUpMutation, CreateStructuringFollowUpMutationVariables>;

/**
 * __useCreateStructuringFollowUpMutation__
 *
 * To run a mutation, you first call `useCreateStructuringFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStructuringFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStructuringFollowUpMutation, { data, loading, error }] = useCreateStructuringFollowUpMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateStructuringFollowUpMutation(baseOptions?: Apollo.MutationHookOptions<CreateStructuringFollowUpMutation, CreateStructuringFollowUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStructuringFollowUpMutation, CreateStructuringFollowUpMutationVariables>(CreateStructuringFollowUpDocument, options);
      }
export type CreateStructuringFollowUpMutationHookResult = ReturnType<typeof useCreateStructuringFollowUpMutation>;
export type CreateStructuringFollowUpMutationResult = Apollo.MutationResult<CreateStructuringFollowUpMutation>;
export type CreateStructuringFollowUpMutationOptions = Apollo.BaseMutationOptions<CreateStructuringFollowUpMutation, CreateStructuringFollowUpMutationVariables>;
export const UpdateStructuringFollowUpNotesDocument = gql`
    mutation updateStructuringFollowUpNotes($id: ID!, $notes: String!) {
  updateStructuringFollowUpNotes(id: $id, notes: $notes)
}
    `;
export type UpdateStructuringFollowUpNotesMutationFn = Apollo.MutationFunction<UpdateStructuringFollowUpNotesMutation, UpdateStructuringFollowUpNotesMutationVariables>;

/**
 * __useUpdateStructuringFollowUpNotesMutation__
 *
 * To run a mutation, you first call `useUpdateStructuringFollowUpNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStructuringFollowUpNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStructuringFollowUpNotesMutation, { data, loading, error }] = useUpdateStructuringFollowUpNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateStructuringFollowUpNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStructuringFollowUpNotesMutation, UpdateStructuringFollowUpNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStructuringFollowUpNotesMutation, UpdateStructuringFollowUpNotesMutationVariables>(UpdateStructuringFollowUpNotesDocument, options);
      }
export type UpdateStructuringFollowUpNotesMutationHookResult = ReturnType<typeof useUpdateStructuringFollowUpNotesMutation>;
export type UpdateStructuringFollowUpNotesMutationResult = Apollo.MutationResult<UpdateStructuringFollowUpNotesMutation>;
export type UpdateStructuringFollowUpNotesMutationOptions = Apollo.BaseMutationOptions<UpdateStructuringFollowUpNotesMutation, UpdateStructuringFollowUpNotesMutationVariables>;
export const DeleteStructuringFollowUpDocument = gql`
    mutation deleteStructuringFollowUp($id: ID!) {
  deleteStructuringFollowUp(id: $id)
}
    `;
export type DeleteStructuringFollowUpMutationFn = Apollo.MutationFunction<DeleteStructuringFollowUpMutation, DeleteStructuringFollowUpMutationVariables>;

/**
 * __useDeleteStructuringFollowUpMutation__
 *
 * To run a mutation, you first call `useDeleteStructuringFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStructuringFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStructuringFollowUpMutation, { data, loading, error }] = useDeleteStructuringFollowUpMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStructuringFollowUpMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStructuringFollowUpMutation, DeleteStructuringFollowUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStructuringFollowUpMutation, DeleteStructuringFollowUpMutationVariables>(DeleteStructuringFollowUpDocument, options);
      }
export type DeleteStructuringFollowUpMutationHookResult = ReturnType<typeof useDeleteStructuringFollowUpMutation>;
export type DeleteStructuringFollowUpMutationResult = Apollo.MutationResult<DeleteStructuringFollowUpMutation>;
export type DeleteStructuringFollowUpMutationOptions = Apollo.BaseMutationOptions<DeleteStructuringFollowUpMutation, DeleteStructuringFollowUpMutationVariables>;
export const OnStructuringFollowUpUpdateDocument = gql`
    subscription onStructuringFollowUpUpdate($dealId: ID, $sources: [String], $types: [DealType], $assignedToMe: Boolean, $podIds: [ID]) {
  onStructuringFollowUpUpdate(
    dealId: $dealId
    sources: $sources
    types: $types
    assignedToMe: $assignedToMe
    podIds: $podIds
  ) {
    ...StructuringFollowUpDealFragment
  }
}
    ${StructuringFollowUpDealFragmentFragmentDoc}`;

/**
 * __useOnStructuringFollowUpUpdateSubscription__
 *
 * To run a query within a React component, call `useOnStructuringFollowUpUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStructuringFollowUpUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStructuringFollowUpUpdateSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      sources: // value for 'sources'
 *      types: // value for 'types'
 *      assignedToMe: // value for 'assignedToMe'
 *      podIds: // value for 'podIds'
 *   },
 * });
 */
export function useOnStructuringFollowUpUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnStructuringFollowUpUpdateSubscription, OnStructuringFollowUpUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnStructuringFollowUpUpdateSubscription, OnStructuringFollowUpUpdateSubscriptionVariables>(OnStructuringFollowUpUpdateDocument, options);
      }
export type OnStructuringFollowUpUpdateSubscriptionHookResult = ReturnType<typeof useOnStructuringFollowUpUpdateSubscription>;
export type OnStructuringFollowUpUpdateSubscriptionResult = Apollo.SubscriptionResult<OnStructuringFollowUpUpdateSubscription>;
export const TagsDocument = gql`
    query tags($input: TagsInput) {
  tags(input: $input) {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const OnTagsCreatedDocument = gql`
    subscription onTagsCreated($dealId: ID) {
  onTagsCreated(dealId: $dealId) {
    dealId
    tags {
      ...TagFragment
    }
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useOnTagsCreatedSubscription__
 *
 * To run a query within a React component, call `useOnTagsCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTagsCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTagsCreatedSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnTagsCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnTagsCreatedSubscription, OnTagsCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTagsCreatedSubscription, OnTagsCreatedSubscriptionVariables>(OnTagsCreatedDocument, options);
      }
export type OnTagsCreatedSubscriptionHookResult = ReturnType<typeof useOnTagsCreatedSubscription>;
export type OnTagsCreatedSubscriptionResult = Apollo.SubscriptionResult<OnTagsCreatedSubscription>;
export const OnTagsDeletedDocument = gql`
    subscription onTagsDeleted($dealId: ID) {
  onTagsDeleted(dealId: $dealId) {
    dealId
    tags {
      ...TagFragment
    }
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useOnTagsDeletedSubscription__
 *
 * To run a query within a React component, call `useOnTagsDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTagsDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTagsDeletedSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnTagsDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnTagsDeletedSubscription, OnTagsDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTagsDeletedSubscription, OnTagsDeletedSubscriptionVariables>(OnTagsDeletedDocument, options);
      }
export type OnTagsDeletedSubscriptionHookResult = ReturnType<typeof useOnTagsDeletedSubscription>;
export type OnTagsDeletedSubscriptionResult = Apollo.SubscriptionResult<OnTagsDeletedSubscription>;
export const JurisdictionDocument = gql`
    query jurisdiction($state: StateAbbreviation!, $county: String, $types: [TTProductType!]!, $conditions: TTConditionFilterInput) {
  jurisdiction(state: $state, county: $county) {
    id
    hasRegistrationOnly
    hasTitleOnly
    hasTitleAndRegistration
    allowRegistrationTransfer
    allowPlateTransfer
    requireWalkIn
    supportedProcessors
    products(filter: {types: $types}) {
      items {
        id
        type
        documents(conditions: $conditions) {
          count
          items {
            type {
              id
              name
            }
            validations {
              internalDescription
              description
              name
            }
          }
        }
        validations {
          name
          description
        }
      }
    }
  }
}
    `;

/**
 * __useJurisdictionQuery__
 *
 * To run a query within a React component, call `useJurisdictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useJurisdictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJurisdictionQuery({
 *   variables: {
 *      state: // value for 'state'
 *      county: // value for 'county'
 *      types: // value for 'types'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useJurisdictionQuery(baseOptions: Apollo.QueryHookOptions<JurisdictionQuery, JurisdictionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JurisdictionQuery, JurisdictionQueryVariables>(JurisdictionDocument, options);
      }
export function useJurisdictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JurisdictionQuery, JurisdictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JurisdictionQuery, JurisdictionQueryVariables>(JurisdictionDocument, options);
        }
export type JurisdictionQueryHookResult = ReturnType<typeof useJurisdictionQuery>;
export type JurisdictionLazyQueryHookResult = ReturnType<typeof useJurisdictionLazyQuery>;
export type JurisdictionQueryResult = Apollo.QueryResult<JurisdictionQuery, JurisdictionQueryVariables>;
export const GetFeesDocument = gql`
    query getFees($uniqueId: String, $state: StateAbbreviation!, $previouslyTitledState: StateAbbreviation!, $city: String!, $county: String!, $zip: String!, $vin: String!, $make: String!, $model: String!, $year: Int!, $vehicleType: TTVehicleType!, $fuelType: TTFuelType!, $firstName: String!, $lastName: String!, $retailBookValue: Float!, $bookValue: Float!, $docFee: Float!, $payoff: Float!, $estimatedPayoff: Float!, $ssn: String!, $warranty: Float!, $financialInfoId: ID, $source: String) {
  getFees(
    uniqueId: $uniqueId
    state: $state
    previouslyTitledState: $previouslyTitledState
    city: $city
    county: $county
    zip: $zip
    vin: $vin
    make: $make
    model: $model
    year: $year
    vehicleType: $vehicleType
    fuelType: $fuelType
    firstName: $firstName
    lastName: $lastName
    retailBookValue: $retailBookValue
    bookValue: $bookValue
    docFee: $docFee
    payoff: $payoff
    estimatedPayoff: $estimatedPayoff
    ssn: $ssn
    warranty: $warranty
    financialInfoId: $financialInfoId
    source: $source
  ) {
    state
    totalFeeAmount
    salesTaxRate
    baseTaxAmount
    warrantyTaxAmount
    taxProcessor
    feeProcessor
    docFeeTaxAmount
    registrationTransferFee
  }
}
    `;

/**
 * __useGetFeesQuery__
 *
 * To run a query within a React component, call `useGetFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeesQuery({
 *   variables: {
 *      uniqueId: // value for 'uniqueId'
 *      state: // value for 'state'
 *      previouslyTitledState: // value for 'previouslyTitledState'
 *      city: // value for 'city'
 *      county: // value for 'county'
 *      zip: // value for 'zip'
 *      vin: // value for 'vin'
 *      make: // value for 'make'
 *      model: // value for 'model'
 *      year: // value for 'year'
 *      vehicleType: // value for 'vehicleType'
 *      fuelType: // value for 'fuelType'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      retailBookValue: // value for 'retailBookValue'
 *      bookValue: // value for 'bookValue'
 *      docFee: // value for 'docFee'
 *      payoff: // value for 'payoff'
 *      estimatedPayoff: // value for 'estimatedPayoff'
 *      ssn: // value for 'ssn'
 *      warranty: // value for 'warranty'
 *      financialInfoId: // value for 'financialInfoId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetFeesQuery(baseOptions: Apollo.QueryHookOptions<GetFeesQuery, GetFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeesQuery, GetFeesQueryVariables>(GetFeesDocument, options);
      }
export function useGetFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeesQuery, GetFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeesQuery, GetFeesQueryVariables>(GetFeesDocument, options);
        }
export type GetFeesQueryHookResult = ReturnType<typeof useGetFeesQuery>;
export type GetFeesLazyQueryHookResult = ReturnType<typeof useGetFeesLazyQuery>;
export type GetFeesQueryResult = Apollo.QueryResult<GetFeesQuery, GetFeesQueryVariables>;
export const UploadDocumentDocument = gql`
    mutation uploadDocument($bytes: String!, $documentType: TTDocumentName!) {
  uploadDocument(bytes: $bytes, documentType: $documentType) {
    documentName
    key
    fields {
      confidence
      name
      value
    }
  }
}
    `;
export type UploadDocumentMutationFn = Apollo.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      bytes: // value for 'bytes'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UploadDriversLicenseDocument = gql`
    mutation uploadDriversLicense($bytes: String!, $includeGender: Boolean) {
  uploadDriversLicense(bytes: $bytes, includeGender: $includeGender) {
    firstName
    middleName
    lastName
    address
    city
    state
    zip
    expirationDate
    sex
    documentNumber
  }
}
    `;
export type UploadDriversLicenseMutationFn = Apollo.MutationFunction<UploadDriversLicenseMutation, UploadDriversLicenseMutationVariables>;

/**
 * __useUploadDriversLicenseMutation__
 *
 * To run a mutation, you first call `useUploadDriversLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDriversLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDriversLicenseMutation, { data, loading, error }] = useUploadDriversLicenseMutation({
 *   variables: {
 *      bytes: // value for 'bytes'
 *      includeGender: // value for 'includeGender'
 *   },
 * });
 */
export function useUploadDriversLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UploadDriversLicenseMutation, UploadDriversLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDriversLicenseMutation, UploadDriversLicenseMutationVariables>(UploadDriversLicenseDocument, options);
      }
export type UploadDriversLicenseMutationHookResult = ReturnType<typeof useUploadDriversLicenseMutation>;
export type UploadDriversLicenseMutationResult = Apollo.MutationResult<UploadDriversLicenseMutation>;
export type UploadDriversLicenseMutationOptions = Apollo.BaseMutationOptions<UploadDriversLicenseMutation, UploadDriversLicenseMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation createTransaction($input: CreateTransactionInput!) {
  createTransaction(input: $input)
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const SearchWebLeadsDocument = gql`
    query searchWebLeads($query: String!) {
  searchWebLeads(query: $query) {
    id
    deal_id
    data {
      first_name
      last_name
      phone_number
      email
      vin
    }
  }
}
    `;

/**
 * __useSearchWebLeadsQuery__
 *
 * To run a query within a React component, call `useSearchWebLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWebLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWebLeadsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchWebLeadsQuery(baseOptions: Apollo.QueryHookOptions<SearchWebLeadsQuery, SearchWebLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchWebLeadsQuery, SearchWebLeadsQueryVariables>(SearchWebLeadsDocument, options);
      }
export function useSearchWebLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWebLeadsQuery, SearchWebLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchWebLeadsQuery, SearchWebLeadsQueryVariables>(SearchWebLeadsDocument, options);
        }
export type SearchWebLeadsQueryHookResult = ReturnType<typeof useSearchWebLeadsQuery>;
export type SearchWebLeadsLazyQueryHookResult = ReturnType<typeof useSearchWebLeadsLazyQuery>;
export type SearchWebLeadsQueryResult = Apollo.QueryResult<SearchWebLeadsQuery, SearchWebLeadsQueryVariables>;
export const TemporaryInfoAuthenticatedDocument = gql`
    query temporaryInfoAuthenticated($id: ID!) {
  temporaryInfoAuthenticated(id: $id) {
    ...TemporaryInfoFragment
    consents {
      type
    }
  }
}
    ${TemporaryInfoFragmentFragmentDoc}`;

/**
 * __useTemporaryInfoAuthenticatedQuery__
 *
 * To run a query within a React component, call `useTemporaryInfoAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryInfoAuthenticatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemporaryInfoAuthenticatedQuery(baseOptions: Apollo.QueryHookOptions<TemporaryInfoAuthenticatedQuery, TemporaryInfoAuthenticatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemporaryInfoAuthenticatedQuery, TemporaryInfoAuthenticatedQueryVariables>(TemporaryInfoAuthenticatedDocument, options);
      }
export function useTemporaryInfoAuthenticatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemporaryInfoAuthenticatedQuery, TemporaryInfoAuthenticatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemporaryInfoAuthenticatedQuery, TemporaryInfoAuthenticatedQueryVariables>(TemporaryInfoAuthenticatedDocument, options);
        }
export type TemporaryInfoAuthenticatedQueryHookResult = ReturnType<typeof useTemporaryInfoAuthenticatedQuery>;
export type TemporaryInfoAuthenticatedLazyQueryHookResult = ReturnType<typeof useTemporaryInfoAuthenticatedLazyQuery>;
export type TemporaryInfoAuthenticatedQueryResult = Apollo.QueryResult<TemporaryInfoAuthenticatedQuery, TemporaryInfoAuthenticatedQueryVariables>;
export const TemporaryInfoDocument = gql`
    query temporaryInfo($id: ID!) {
  temporaryInfo(id: $id) {
    ...TemporaryInfoFragment
  }
}
    ${TemporaryInfoFragmentFragmentDoc}`;

/**
 * __useTemporaryInfoQuery__
 *
 * To run a query within a React component, call `useTemporaryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemporaryInfoQuery(baseOptions: Apollo.QueryHookOptions<TemporaryInfoQuery, TemporaryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemporaryInfoQuery, TemporaryInfoQueryVariables>(TemporaryInfoDocument, options);
      }
export function useTemporaryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemporaryInfoQuery, TemporaryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemporaryInfoQuery, TemporaryInfoQueryVariables>(TemporaryInfoDocument, options);
        }
export type TemporaryInfoQueryHookResult = ReturnType<typeof useTemporaryInfoQuery>;
export type TemporaryInfoLazyQueryHookResult = ReturnType<typeof useTemporaryInfoLazyQuery>;
export type TemporaryInfoQueryResult = Apollo.QueryResult<TemporaryInfoQuery, TemporaryInfoQueryVariables>;
export const TemporaryInfoImportDocument = gql`
    mutation temporaryInfoImport($id: ID!, $transformType: transformType!, $importType: ImportType!) {
  temporaryInfoImport(
    id: $id
    transformType: $transformType
    importType: $importType
  ) {
    id
  }
}
    `;
export type TemporaryInfoImportMutationFn = Apollo.MutationFunction<TemporaryInfoImportMutation, TemporaryInfoImportMutationVariables>;

/**
 * __useTemporaryInfoImportMutation__
 *
 * To run a mutation, you first call `useTemporaryInfoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryInfoImportMutation, { data, loading, error }] = useTemporaryInfoImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      transformType: // value for 'transformType'
 *      importType: // value for 'importType'
 *   },
 * });
 */
export function useTemporaryInfoImportMutation(baseOptions?: Apollo.MutationHookOptions<TemporaryInfoImportMutation, TemporaryInfoImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemporaryInfoImportMutation, TemporaryInfoImportMutationVariables>(TemporaryInfoImportDocument, options);
      }
export type TemporaryInfoImportMutationHookResult = ReturnType<typeof useTemporaryInfoImportMutation>;
export type TemporaryInfoImportMutationResult = Apollo.MutationResult<TemporaryInfoImportMutation>;
export type TemporaryInfoImportMutationOptions = Apollo.BaseMutationOptions<TemporaryInfoImportMutation, TemporaryInfoImportMutationVariables>;
export const OnDealImportedDocument = gql`
    subscription onDealImported {
  onDealImported {
    deal_id
    first_name
    last_name
  }
}
    `;

/**
 * __useOnDealImportedSubscription__
 *
 * To run a query within a React component, call `useOnDealImportedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDealImportedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDealImportedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDealImportedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDealImportedSubscription, OnDealImportedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDealImportedSubscription, OnDealImportedSubscriptionVariables>(OnDealImportedDocument, options);
      }
export type OnDealImportedSubscriptionHookResult = ReturnType<typeof useOnDealImportedSubscription>;
export type OnDealImportedSubscriptionResult = Apollo.SubscriptionResult<OnDealImportedSubscription>;
export const OnDuplicatedInfoDocument = gql`
    subscription onDuplicatedInfo {
  onDuplicatedInfo {
    deal_id
    first_name
    last_name
    state
  }
}
    `;

/**
 * __useOnDuplicatedInfoSubscription__
 *
 * To run a query within a React component, call `useOnDuplicatedInfoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDuplicatedInfoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDuplicatedInfoSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDuplicatedInfoSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDuplicatedInfoSubscription, OnDuplicatedInfoSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDuplicatedInfoSubscription, OnDuplicatedInfoSubscriptionVariables>(OnDuplicatedInfoDocument, options);
      }
export type OnDuplicatedInfoSubscriptionHookResult = ReturnType<typeof useOnDuplicatedInfoSubscription>;
export type OnDuplicatedInfoSubscriptionResult = Apollo.SubscriptionResult<OnDuplicatedInfoSubscription>;
export const OnDuplicatedDealImportDocument = gql`
    subscription onDuplicatedDealImport {
  onDuplicatedDealImport {
    deal_id
    first_name
    last_name
  }
}
    `;

/**
 * __useOnDuplicatedDealImportSubscription__
 *
 * To run a query within a React component, call `useOnDuplicatedDealImportSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDuplicatedDealImportSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDuplicatedDealImportSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDuplicatedDealImportSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDuplicatedDealImportSubscription, OnDuplicatedDealImportSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDuplicatedDealImportSubscription, OnDuplicatedDealImportSubscriptionVariables>(OnDuplicatedDealImportDocument, options);
      }
export type OnDuplicatedDealImportSubscriptionHookResult = ReturnType<typeof useOnDuplicatedDealImportSubscription>;
export type OnDuplicatedDealImportSubscriptionResult = Apollo.SubscriptionResult<OnDuplicatedDealImportSubscription>;
export const TemporaryRegistrationTagsDealsDocument = gql`
    query temporaryRegistrationTagsDeals($currentPage: Int, $itemsPerPage: Int, $sortColumn: String, $sortDirection: SortDirection) {
  temporaryRegistrationTagsDeals(
    currentPage: $currentPage
    itemsPerPage: $itemsPerPage
    sortColumn: $sortColumn
    sortDirection: $sortDirection
  ) {
    deals {
      ...TemporaryRegistrationTagsDeal
    }
    totalRecords
  }
}
    ${TemporaryRegistrationTagsDealFragmentDoc}`;

/**
 * __useTemporaryRegistrationTagsDealsQuery__
 *
 * To run a query within a React component, call `useTemporaryRegistrationTagsDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryRegistrationTagsDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryRegistrationTagsDealsQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useTemporaryRegistrationTagsDealsQuery(baseOptions?: Apollo.QueryHookOptions<TemporaryRegistrationTagsDealsQuery, TemporaryRegistrationTagsDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemporaryRegistrationTagsDealsQuery, TemporaryRegistrationTagsDealsQueryVariables>(TemporaryRegistrationTagsDealsDocument, options);
      }
export function useTemporaryRegistrationTagsDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemporaryRegistrationTagsDealsQuery, TemporaryRegistrationTagsDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemporaryRegistrationTagsDealsQuery, TemporaryRegistrationTagsDealsQueryVariables>(TemporaryRegistrationTagsDealsDocument, options);
        }
export type TemporaryRegistrationTagsDealsQueryHookResult = ReturnType<typeof useTemporaryRegistrationTagsDealsQuery>;
export type TemporaryRegistrationTagsDealsLazyQueryHookResult = ReturnType<typeof useTemporaryRegistrationTagsDealsLazyQuery>;
export type TemporaryRegistrationTagsDealsQueryResult = Apollo.QueryResult<TemporaryRegistrationTagsDealsQuery, TemporaryRegistrationTagsDealsQueryVariables>;
export const OnTemporaryRegistrationTagsDealsUpdatedDocument = gql`
    subscription onTemporaryRegistrationTagsDealsUpdated {
  onTemporaryRegistrationTagsDealsUpdated {
    ...TemporaryRegistrationTagsDeal
  }
}
    ${TemporaryRegistrationTagsDealFragmentDoc}`;

/**
 * __useOnTemporaryRegistrationTagsDealsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnTemporaryRegistrationTagsDealsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTemporaryRegistrationTagsDealsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTemporaryRegistrationTagsDealsUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnTemporaryRegistrationTagsDealsUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnTemporaryRegistrationTagsDealsUpdatedSubscription, OnTemporaryRegistrationTagsDealsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTemporaryRegistrationTagsDealsUpdatedSubscription, OnTemporaryRegistrationTagsDealsUpdatedSubscriptionVariables>(OnTemporaryRegistrationTagsDealsUpdatedDocument, options);
      }
export type OnTemporaryRegistrationTagsDealsUpdatedSubscriptionHookResult = ReturnType<typeof useOnTemporaryRegistrationTagsDealsUpdatedSubscription>;
export type OnTemporaryRegistrationTagsDealsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnTemporaryRegistrationTagsDealsUpdatedSubscription>;
export const GetThunderConversationHistoryDocument = gql`
    query GetThunderConversationHistory($phoneNumber: String!) {
  getThunderConversationHistoryByPhoneNumber(phoneNumber: $phoneNumber) {
    id
    firstName
    lastName
    messages {
      text
      timestamp
      direction
    }
  }
}
    `;

/**
 * __useGetThunderConversationHistoryQuery__
 *
 * To run a query within a React component, call `useGetThunderConversationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThunderConversationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThunderConversationHistoryQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetThunderConversationHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetThunderConversationHistoryQuery, GetThunderConversationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThunderConversationHistoryQuery, GetThunderConversationHistoryQueryVariables>(GetThunderConversationHistoryDocument, options);
      }
export function useGetThunderConversationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThunderConversationHistoryQuery, GetThunderConversationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThunderConversationHistoryQuery, GetThunderConversationHistoryQueryVariables>(GetThunderConversationHistoryDocument, options);
        }
export type GetThunderConversationHistoryQueryHookResult = ReturnType<typeof useGetThunderConversationHistoryQuery>;
export type GetThunderConversationHistoryLazyQueryHookResult = ReturnType<typeof useGetThunderConversationHistoryLazyQuery>;
export type GetThunderConversationHistoryQueryResult = Apollo.QueryResult<GetThunderConversationHistoryQuery, GetThunderConversationHistoryQueryVariables>;
export const HandleThunderOutboundCallDocument = gql`
    mutation handleThunderOutboundCall($hunt_group_slug: String, $thunder_call_notification_id: ID, $waiting_call_id: ID) {
  handleThunderOutboundCall(
    hunt_group_slug: $hunt_group_slug
    thunder_call_notification_id: $thunder_call_notification_id
    waiting_call_id: $waiting_call_id
  ) {
    status
    call_already_answered
  }
}
    `;
export type HandleThunderOutboundCallMutationFn = Apollo.MutationFunction<HandleThunderOutboundCallMutation, HandleThunderOutboundCallMutationVariables>;

/**
 * __useHandleThunderOutboundCallMutation__
 *
 * To run a mutation, you first call `useHandleThunderOutboundCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleThunderOutboundCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleThunderOutboundCallMutation, { data, loading, error }] = useHandleThunderOutboundCallMutation({
 *   variables: {
 *      hunt_group_slug: // value for 'hunt_group_slug'
 *      thunder_call_notification_id: // value for 'thunder_call_notification_id'
 *      waiting_call_id: // value for 'waiting_call_id'
 *   },
 * });
 */
export function useHandleThunderOutboundCallMutation(baseOptions?: Apollo.MutationHookOptions<HandleThunderOutboundCallMutation, HandleThunderOutboundCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleThunderOutboundCallMutation, HandleThunderOutboundCallMutationVariables>(HandleThunderOutboundCallDocument, options);
      }
export type HandleThunderOutboundCallMutationHookResult = ReturnType<typeof useHandleThunderOutboundCallMutation>;
export type HandleThunderOutboundCallMutationResult = Apollo.MutationResult<HandleThunderOutboundCallMutation>;
export type HandleThunderOutboundCallMutationOptions = Apollo.BaseMutationOptions<HandleThunderOutboundCallMutation, HandleThunderOutboundCallMutationVariables>;
export const MyUnfinishedThunderClaimsDocument = gql`
    query myUnfinishedThunderClaims {
  myUnfinishedThunderClaims {
    id
    customer_phone_number
    first_name
    last_name
    scheduled_call_time
    attempt_num
    ai_call_opener
    thunder_phone_number
  }
}
    `;

/**
 * __useMyUnfinishedThunderClaimsQuery__
 *
 * To run a query within a React component, call `useMyUnfinishedThunderClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUnfinishedThunderClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUnfinishedThunderClaimsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUnfinishedThunderClaimsQuery(baseOptions?: Apollo.QueryHookOptions<MyUnfinishedThunderClaimsQuery, MyUnfinishedThunderClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyUnfinishedThunderClaimsQuery, MyUnfinishedThunderClaimsQueryVariables>(MyUnfinishedThunderClaimsDocument, options);
      }
export function useMyUnfinishedThunderClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyUnfinishedThunderClaimsQuery, MyUnfinishedThunderClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyUnfinishedThunderClaimsQuery, MyUnfinishedThunderClaimsQueryVariables>(MyUnfinishedThunderClaimsDocument, options);
        }
export type MyUnfinishedThunderClaimsQueryHookResult = ReturnType<typeof useMyUnfinishedThunderClaimsQuery>;
export type MyUnfinishedThunderClaimsLazyQueryHookResult = ReturnType<typeof useMyUnfinishedThunderClaimsLazyQuery>;
export type MyUnfinishedThunderClaimsQueryResult = Apollo.QueryResult<MyUnfinishedThunderClaimsQuery, MyUnfinishedThunderClaimsQueryVariables>;
export const HandleThunderOutboundCallOutcomeDocument = gql`
    mutation handleThunderOutboundCallOutcome($calledNumber: String!, $answered: Boolean, $attemptNum: Int, $thunderCallNotificationId: ID, $dealId: ID) {
  handleThunderOutboundCallOutcome(
    calledNumber: $calledNumber
    answered: $answered
    attemptNum: $attemptNum
    thunderCallNotificationId: $thunderCallNotificationId
    dealId: $dealId
  )
}
    `;
export type HandleThunderOutboundCallOutcomeMutationFn = Apollo.MutationFunction<HandleThunderOutboundCallOutcomeMutation, HandleThunderOutboundCallOutcomeMutationVariables>;

/**
 * __useHandleThunderOutboundCallOutcomeMutation__
 *
 * To run a mutation, you first call `useHandleThunderOutboundCallOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleThunderOutboundCallOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleThunderOutboundCallOutcomeMutation, { data, loading, error }] = useHandleThunderOutboundCallOutcomeMutation({
 *   variables: {
 *      calledNumber: // value for 'calledNumber'
 *      answered: // value for 'answered'
 *      attemptNum: // value for 'attemptNum'
 *      thunderCallNotificationId: // value for 'thunderCallNotificationId'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useHandleThunderOutboundCallOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<HandleThunderOutboundCallOutcomeMutation, HandleThunderOutboundCallOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleThunderOutboundCallOutcomeMutation, HandleThunderOutboundCallOutcomeMutationVariables>(HandleThunderOutboundCallOutcomeDocument, options);
      }
export type HandleThunderOutboundCallOutcomeMutationHookResult = ReturnType<typeof useHandleThunderOutboundCallOutcomeMutation>;
export type HandleThunderOutboundCallOutcomeMutationResult = Apollo.MutationResult<HandleThunderOutboundCallOutcomeMutation>;
export type HandleThunderOutboundCallOutcomeMutationOptions = Apollo.BaseMutationOptions<HandleThunderOutboundCallOutcomeMutation, HandleThunderOutboundCallOutcomeMutationVariables>;
export const GetTwilioNumbersDocument = gql`
    query getTwilioNumbers {
  getTwilioNumbers {
    number
    friendlyName
  }
}
    `;

/**
 * __useGetTwilioNumbersQuery__
 *
 * To run a query within a React component, call `useGetTwilioNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTwilioNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetTwilioNumbersQuery, GetTwilioNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioNumbersQuery, GetTwilioNumbersQueryVariables>(GetTwilioNumbersDocument, options);
      }
export function useGetTwilioNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioNumbersQuery, GetTwilioNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioNumbersQuery, GetTwilioNumbersQueryVariables>(GetTwilioNumbersDocument, options);
        }
export type GetTwilioNumbersQueryHookResult = ReturnType<typeof useGetTwilioNumbersQuery>;
export type GetTwilioNumbersLazyQueryHookResult = ReturnType<typeof useGetTwilioNumbersLazyQuery>;
export type GetTwilioNumbersQueryResult = Apollo.QueryResult<GetTwilioNumbersQuery, GetTwilioNumbersQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($currentPage: Int, $itemsPerPage: Int, $podId: ID, $roleNames: [Auth0RoleName], $sortColumn: String, $sortDirection: SortDirection, $teamType: teamType, $userIds: [String], $searchText: String) {
  getUsers(
    currentPage: $currentPage
    itemsPerPage: $itemsPerPage
    podId: $podId
    roleNames: $roleNames
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    teamType: $teamType
    userIds: $userIds
    searchText: $searchText
  ) {
    results {
      ...UserFragment
    }
    totalRecords
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      podId: // value for 'podId'
 *      roleNames: // value for 'roleNames'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      teamType: // value for 'teamType'
 *      userIds: // value for 'userIds'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersForManagementDocument = gql`
    query getUsersForManagement($currentPage: Int, $itemsPerPage: Int, $podId: ID, $roleNames: [Auth0RoleName], $sortColumn: String, $sortDirection: SortDirection, $teamType: teamType, $userIds: [String], $searchText: String) {
  getUsers(
    currentPage: $currentPage
    itemsPerPage: $itemsPerPage
    podId: $podId
    roleNames: $roleNames
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    teamType: $teamType
    userIds: $userIds
    searchText: $searchText
  ) {
    results {
      ...UserFragment
      huntGroups {
        id
        name
      }
    }
    totalRecords
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useGetUsersForManagementQuery__
 *
 * To run a query within a React component, call `useGetUsersForManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForManagementQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      podId: // value for 'podId'
 *      roleNames: // value for 'roleNames'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      teamType: // value for 'teamType'
 *      userIds: // value for 'userIds'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUsersForManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersForManagementQuery, GetUsersForManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForManagementQuery, GetUsersForManagementQueryVariables>(GetUsersForManagementDocument, options);
      }
export function useGetUsersForManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForManagementQuery, GetUsersForManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForManagementQuery, GetUsersForManagementQueryVariables>(GetUsersForManagementDocument, options);
        }
export type GetUsersForManagementQueryHookResult = ReturnType<typeof useGetUsersForManagementQuery>;
export type GetUsersForManagementLazyQueryHookResult = ReturnType<typeof useGetUsersForManagementLazyQuery>;
export type GetUsersForManagementQueryResult = Apollo.QueryResult<GetUsersForManagementQuery, GetUsersForManagementQueryVariables>;
export const TitlingUsersDocument = gql`
    query titlingUsers($titling_pod_id: ID) {
  titlingUsers(titling_pod_id: $titling_pod_id) {
    user_id
    pod_id
    team_role
    user {
      id
      email
      name
      nickname
      deleted_at
    }
  }
}
    `;

/**
 * __useTitlingUsersQuery__
 *
 * To run a query within a React component, call `useTitlingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlingUsersQuery({
 *   variables: {
 *      titling_pod_id: // value for 'titling_pod_id'
 *   },
 * });
 */
export function useTitlingUsersQuery(baseOptions?: Apollo.QueryHookOptions<TitlingUsersQuery, TitlingUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlingUsersQuery, TitlingUsersQueryVariables>(TitlingUsersDocument, options);
      }
export function useTitlingUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlingUsersQuery, TitlingUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlingUsersQuery, TitlingUsersQueryVariables>(TitlingUsersDocument, options);
        }
export type TitlingUsersQueryHookResult = ReturnType<typeof useTitlingUsersQuery>;
export type TitlingUsersLazyQueryHookResult = ReturnType<typeof useTitlingUsersLazyQuery>;
export type TitlingUsersQueryResult = Apollo.QueryResult<TitlingUsersQuery, TitlingUsersQueryVariables>;
export const GetAvailableUsersAndAllHuntGroupsDocument = gql`
    query getAvailableUsersAndAllHuntGroups {
  getAvailableUsers {
    id
    email
    name
    nickname
    phone_number
    twilio_number
    call_status
    in_call
  }
  getAllHuntGroups {
    id
    name
    phone_number
    slug
  }
}
    `;

/**
 * __useGetAvailableUsersAndAllHuntGroupsQuery__
 *
 * To run a query within a React component, call `useGetAvailableUsersAndAllHuntGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableUsersAndAllHuntGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableUsersAndAllHuntGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableUsersAndAllHuntGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableUsersAndAllHuntGroupsQuery, GetAvailableUsersAndAllHuntGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableUsersAndAllHuntGroupsQuery, GetAvailableUsersAndAllHuntGroupsQueryVariables>(GetAvailableUsersAndAllHuntGroupsDocument, options);
      }
export function useGetAvailableUsersAndAllHuntGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableUsersAndAllHuntGroupsQuery, GetAvailableUsersAndAllHuntGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableUsersAndAllHuntGroupsQuery, GetAvailableUsersAndAllHuntGroupsQueryVariables>(GetAvailableUsersAndAllHuntGroupsDocument, options);
        }
export type GetAvailableUsersAndAllHuntGroupsQueryHookResult = ReturnType<typeof useGetAvailableUsersAndAllHuntGroupsQuery>;
export type GetAvailableUsersAndAllHuntGroupsLazyQueryHookResult = ReturnType<typeof useGetAvailableUsersAndAllHuntGroupsLazyQuery>;
export type GetAvailableUsersAndAllHuntGroupsQueryResult = Apollo.QueryResult<GetAvailableUsersAndAllHuntGroupsQuery, GetAvailableUsersAndAllHuntGroupsQueryVariables>;
export const LoggedUserDocument = gql`
    query loggedUser {
  loggedUser {
    id
    name
    call_status
    can_claim_as_closer
    hours
    on_vacation
    twilio_number
    auto_assign_deals
    pods {
      id
      name
      team_type
    }
    autoAssignEligibility {
      ...UserAutoAssignEligibilityFragment
    }
  }
}
    ${UserAutoAssignEligibilityFragmentFragmentDoc}`;

/**
 * __useLoggedUserQuery__
 *
 * To run a query within a React component, call `useLoggedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedUserQuery(baseOptions?: Apollo.QueryHookOptions<LoggedUserQuery, LoggedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedUserQuery, LoggedUserQueryVariables>(LoggedUserDocument, options);
      }
export function useLoggedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedUserQuery, LoggedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedUserQuery, LoggedUserQueryVariables>(LoggedUserDocument, options);
        }
export type LoggedUserQueryHookResult = ReturnType<typeof useLoggedUserQuery>;
export type LoggedUserLazyQueryHookResult = ReturnType<typeof useLoggedUserLazyQuery>;
export type LoggedUserQueryResult = Apollo.QueryResult<LoggedUserQuery, LoggedUserQueryVariables>;
export const UserTitlingPodsDocument = gql`
    query userTitlingPods {
  userTitlingPods {
    id
    name
    color
    us_states_object {
      states
    }
    problem_solver
    archived
    pod_users {
      id
      user_id
      pod_id
      team_role
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserTitlingPodsQuery__
 *
 * To run a query within a React component, call `useUserTitlingPodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTitlingPodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTitlingPodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTitlingPodsQuery(baseOptions?: Apollo.QueryHookOptions<UserTitlingPodsQuery, UserTitlingPodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTitlingPodsQuery, UserTitlingPodsQueryVariables>(UserTitlingPodsDocument, options);
      }
export function useUserTitlingPodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTitlingPodsQuery, UserTitlingPodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTitlingPodsQuery, UserTitlingPodsQueryVariables>(UserTitlingPodsDocument, options);
        }
export type UserTitlingPodsQueryHookResult = ReturnType<typeof useUserTitlingPodsQuery>;
export type UserTitlingPodsLazyQueryHookResult = ReturnType<typeof useUserTitlingPodsLazyQuery>;
export type UserTitlingPodsQueryResult = Apollo.QueryResult<UserTitlingPodsQuery, UserTitlingPodsQueryVariables>;
export const UserPermissionsDocument = gql`
    query userPermissions($user_id: String!) {
  userPermissions(user_id: $user_id)
}
    `;

/**
 * __useUserPermissionsQuery__
 *
 * To run a query within a React component, call `useUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<UserPermissionsQuery, UserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPermissionsQuery, UserPermissionsQueryVariables>(UserPermissionsDocument, options);
      }
export function useUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPermissionsQuery, UserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPermissionsQuery, UserPermissionsQueryVariables>(UserPermissionsDocument, options);
        }
export type UserPermissionsQueryHookResult = ReturnType<typeof useUserPermissionsQuery>;
export type UserPermissionsLazyQueryHookResult = ReturnType<typeof useUserPermissionsLazyQuery>;
export type UserPermissionsQueryResult = Apollo.QueryResult<UserPermissionsQuery, UserPermissionsQueryVariables>;
export const GetUserTwilioNumberDocument = gql`
    query getUserTwilioNumber {
  getUserTwilioNumber
}
    `;

/**
 * __useGetUserTwilioNumberQuery__
 *
 * To run a query within a React component, call `useGetUserTwilioNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTwilioNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTwilioNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTwilioNumberQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTwilioNumberQuery, GetUserTwilioNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTwilioNumberQuery, GetUserTwilioNumberQueryVariables>(GetUserTwilioNumberDocument, options);
      }
export function useGetUserTwilioNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTwilioNumberQuery, GetUserTwilioNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTwilioNumberQuery, GetUserTwilioNumberQueryVariables>(GetUserTwilioNumberDocument, options);
        }
export type GetUserTwilioNumberQueryHookResult = ReturnType<typeof useGetUserTwilioNumberQuery>;
export type GetUserTwilioNumberLazyQueryHookResult = ReturnType<typeof useGetUserTwilioNumberLazyQuery>;
export type GetUserTwilioNumberQueryResult = Apollo.QueryResult<GetUserTwilioNumberQuery, GetUserTwilioNumberQueryVariables>;
export const GetUserCreationDataDocument = gql`
    query getUserCreationData {
  getUserCreationData {
    huntGroups {
      id
      name
      slug
    }
    pods {
      id
      name
      color
    }
  }
}
    `;

/**
 * __useGetUserCreationDataQuery__
 *
 * To run a query within a React component, call `useGetUserCreationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCreationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCreationDataQuery, GetUserCreationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCreationDataQuery, GetUserCreationDataQueryVariables>(GetUserCreationDataDocument, options);
      }
export function useGetUserCreationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCreationDataQuery, GetUserCreationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCreationDataQuery, GetUserCreationDataQueryVariables>(GetUserCreationDataDocument, options);
        }
export type GetUserCreationDataQueryHookResult = ReturnType<typeof useGetUserCreationDataQuery>;
export type GetUserCreationDataLazyQueryHookResult = ReturnType<typeof useGetUserCreationDataLazyQuery>;
export type GetUserCreationDataQueryResult = Apollo.QueryResult<GetUserCreationDataQuery, GetUserCreationDataQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($createUserInput: CreateUserInput!) {
  createUser(createUserInput: $createUserInput) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      createUserInput: // value for 'createUserInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($updateUserInput: UpdateUserInput!, $allAuth0RoleIds: [String!]!) {
  updateUser(updateUserInput: $updateUserInput, allAuth0RoleIds: $allAuth0RoleIds) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *      allAuth0RoleIds: // value for 'allAuth0RoleIds'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($id: String!, $hours: String!, $on_vacation: Boolean!, $auto_assign_deals: Boolean!, $max_auto_assign_deals: Int!, $user_type: UserType!, $assignment_mode: AssignmentMode!, $frequency_minutes: Int!, $accept_overnight_deals: Boolean!, $accept_unseen_deals: Boolean!, $accept_with_upcoming_appointment: Boolean!, $accept_ai_touched_deals: Boolean!, $deals_with_stipulations: Boolean!, $deals_with_vsc: Boolean!, $deals_with_gap: Boolean!, $deals_with_double_tax: Boolean!, $deals_with_direct_pay: Boolean!, $deals_with_bank_fees: Boolean!, $deals_with_down_payment: Boolean!) {
  updateUserSettings(
    id: $id
    hours: $hours
    on_vacation: $on_vacation
    auto_assign_deals: $auto_assign_deals
    max_auto_assign_deals: $max_auto_assign_deals
    user_type: $user_type
    assignment_mode: $assignment_mode
    frequency_minutes: $frequency_minutes
    accept_overnight_deals: $accept_overnight_deals
    accept_unseen_deals: $accept_unseen_deals
    accept_with_upcoming_appointment: $accept_with_upcoming_appointment
    accept_ai_touched_deals: $accept_ai_touched_deals
    deals_with_stipulations: $deals_with_stipulations
    deals_with_vsc: $deals_with_vsc
    deals_with_gap: $deals_with_gap
    deals_with_double_tax: $deals_with_double_tax
    deals_with_direct_pay: $deals_with_direct_pay
    deals_with_bank_fees: $deals_with_bank_fees
    deals_with_down_payment: $deals_with_down_payment
  ) {
    id
    hours
    on_vacation
    auto_assign_deals
    max_auto_assign_deals
    autoAssignEligibility {
      ...UserAutoAssignEligibilityFragment
    }
  }
}
    ${UserAutoAssignEligibilityFragmentFragmentDoc}`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hours: // value for 'hours'
 *      on_vacation: // value for 'on_vacation'
 *      auto_assign_deals: // value for 'auto_assign_deals'
 *      max_auto_assign_deals: // value for 'max_auto_assign_deals'
 *      user_type: // value for 'user_type'
 *      assignment_mode: // value for 'assignment_mode'
 *      frequency_minutes: // value for 'frequency_minutes'
 *      accept_overnight_deals: // value for 'accept_overnight_deals'
 *      accept_unseen_deals: // value for 'accept_unseen_deals'
 *      accept_with_upcoming_appointment: // value for 'accept_with_upcoming_appointment'
 *      accept_ai_touched_deals: // value for 'accept_ai_touched_deals'
 *      deals_with_stipulations: // value for 'deals_with_stipulations'
 *      deals_with_vsc: // value for 'deals_with_vsc'
 *      deals_with_gap: // value for 'deals_with_gap'
 *      deals_with_double_tax: // value for 'deals_with_double_tax'
 *      deals_with_direct_pay: // value for 'deals_with_direct_pay'
 *      deals_with_bank_fees: // value for 'deals_with_bank_fees'
 *      deals_with_down_payment: // value for 'deals_with_down_payment'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const SoftDeleteUserDocument = gql`
    mutation softDeleteUser($id: String!) {
  softDeleteUser(id: $id)
}
    `;
export type SoftDeleteUserMutationFn = Apollo.MutationFunction<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;

/**
 * __useSoftDeleteUserMutation__
 *
 * To run a mutation, you first call `useSoftDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteUserMutation, { data, loading, error }] = useSoftDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>(SoftDeleteUserDocument, options);
      }
export type SoftDeleteUserMutationHookResult = ReturnType<typeof useSoftDeleteUserMutation>;
export type SoftDeleteUserMutationResult = Apollo.MutationResult<SoftDeleteUserMutation>;
export type SoftDeleteUserMutationOptions = Apollo.BaseMutationOptions<SoftDeleteUserMutation, SoftDeleteUserMutationVariables>;
export const UpdateUserCallStatusDocument = gql`
    mutation updateUserCallStatus($status: CallStatus!) {
  updateUserCallStatus(status: $status) {
    id
    call_status
  }
}
    `;
export type UpdateUserCallStatusMutationFn = Apollo.MutationFunction<UpdateUserCallStatusMutation, UpdateUserCallStatusMutationVariables>;

/**
 * __useUpdateUserCallStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserCallStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCallStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCallStatusMutation, { data, loading, error }] = useUpdateUserCallStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateUserCallStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCallStatusMutation, UpdateUserCallStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCallStatusMutation, UpdateUserCallStatusMutationVariables>(UpdateUserCallStatusDocument, options);
      }
export type UpdateUserCallStatusMutationHookResult = ReturnType<typeof useUpdateUserCallStatusMutation>;
export type UpdateUserCallStatusMutationResult = Apollo.MutationResult<UpdateUserCallStatusMutation>;
export type UpdateUserCallStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserCallStatusMutation, UpdateUserCallStatusMutationVariables>;
export const SwitchCallStatusDocument = gql`
    subscription switchCallStatus {
  switchCallStatus
}
    `;

/**
 * __useSwitchCallStatusSubscription__
 *
 * To run a query within a React component, call `useSwitchCallStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSwitchCallStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchCallStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSwitchCallStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SwitchCallStatusSubscription, SwitchCallStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SwitchCallStatusSubscription, SwitchCallStatusSubscriptionVariables>(SwitchCallStatusDocument, options);
      }
export type SwitchCallStatusSubscriptionHookResult = ReturnType<typeof useSwitchCallStatusSubscription>;
export type SwitchCallStatusSubscriptionResult = Apollo.SubscriptionResult<SwitchCallStatusSubscription>;
export const OnSipRegistrationFailureDocument = gql`
    subscription onSipRegistrationFailure {
  onSipRegistrationFailure {
    userId
    message
    callerNumber
  }
}
    `;

/**
 * __useOnSipRegistrationFailureSubscription__
 *
 * To run a query within a React component, call `useOnSipRegistrationFailureSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSipRegistrationFailureSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSipRegistrationFailureSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnSipRegistrationFailureSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnSipRegistrationFailureSubscription, OnSipRegistrationFailureSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSipRegistrationFailureSubscription, OnSipRegistrationFailureSubscriptionVariables>(OnSipRegistrationFailureDocument, options);
      }
export type OnSipRegistrationFailureSubscriptionHookResult = ReturnType<typeof useOnSipRegistrationFailureSubscription>;
export type OnSipRegistrationFailureSubscriptionResult = Apollo.SubscriptionResult<OnSipRegistrationFailureSubscription>;
export const GetWaitingCallsDocument = gql`
    query getWaitingCalls {
  getWaitingCalls {
    data
  }
}
    `;

/**
 * __useGetWaitingCallsQuery__
 *
 * To run a query within a React component, call `useGetWaitingCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingCallsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaitingCallsQuery(baseOptions?: Apollo.QueryHookOptions<GetWaitingCallsQuery, GetWaitingCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaitingCallsQuery, GetWaitingCallsQueryVariables>(GetWaitingCallsDocument, options);
      }
export function useGetWaitingCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaitingCallsQuery, GetWaitingCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaitingCallsQuery, GetWaitingCallsQueryVariables>(GetWaitingCallsDocument, options);
        }
export type GetWaitingCallsQueryHookResult = ReturnType<typeof useGetWaitingCallsQuery>;
export type GetWaitingCallsLazyQueryHookResult = ReturnType<typeof useGetWaitingCallsLazyQuery>;
export type GetWaitingCallsQueryResult = Apollo.QueryResult<GetWaitingCallsQuery, GetWaitingCallsQueryVariables>;
export const CallInProgressDocument = gql`
    query callInProgress {
  callInProgress {
    from
    to
    customer_name
    deal_id
    deal_state
    deal_type
    is_thunder
    id
    conference_id
    agent_user_id
    hunt_group_slug
    is_outbound
  }
}
    `;

/**
 * __useCallInProgressQuery__
 *
 * To run a query within a React component, call `useCallInProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallInProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallInProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useCallInProgressQuery(baseOptions?: Apollo.QueryHookOptions<CallInProgressQuery, CallInProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallInProgressQuery, CallInProgressQueryVariables>(CallInProgressDocument, options);
      }
export function useCallInProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallInProgressQuery, CallInProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallInProgressQuery, CallInProgressQueryVariables>(CallInProgressDocument, options);
        }
export type CallInProgressQueryHookResult = ReturnType<typeof useCallInProgressQuery>;
export type CallInProgressLazyQueryHookResult = ReturnType<typeof useCallInProgressLazyQuery>;
export type CallInProgressQueryResult = Apollo.QueryResult<CallInProgressQuery, CallInProgressQueryVariables>;
export const AddParticipantDocument = gql`
    mutation addParticipant($hunt_group_slug: String, $conference_id: String, $agent_phone: String, $new_agent_phone: String, $new_agent_user_id: String, $waiting_call_id: ID) {
  addParticipant(
    hunt_group_slug: $hunt_group_slug
    conference_id: $conference_id
    agent_phone: $agent_phone
    new_agent_phone: $new_agent_phone
    new_agent_user_id: $new_agent_user_id
    waiting_call_id: $waiting_call_id
  ) {
    status
    call_already_answered
  }
}
    `;
export type AddParticipantMutationFn = Apollo.MutationFunction<AddParticipantMutation, AddParticipantMutationVariables>;

/**
 * __useAddParticipantMutation__
 *
 * To run a mutation, you first call `useAddParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addParticipantMutation, { data, loading, error }] = useAddParticipantMutation({
 *   variables: {
 *      hunt_group_slug: // value for 'hunt_group_slug'
 *      conference_id: // value for 'conference_id'
 *      agent_phone: // value for 'agent_phone'
 *      new_agent_phone: // value for 'new_agent_phone'
 *      new_agent_user_id: // value for 'new_agent_user_id'
 *      waiting_call_id: // value for 'waiting_call_id'
 *   },
 * });
 */
export function useAddParticipantMutation(baseOptions?: Apollo.MutationHookOptions<AddParticipantMutation, AddParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddParticipantMutation, AddParticipantMutationVariables>(AddParticipantDocument, options);
      }
export type AddParticipantMutationHookResult = ReturnType<typeof useAddParticipantMutation>;
export type AddParticipantMutationResult = Apollo.MutationResult<AddParticipantMutation>;
export type AddParticipantMutationOptions = Apollo.BaseMutationOptions<AddParticipantMutation, AddParticipantMutationVariables>;
export const OnWaitingQueueDocument = gql`
    subscription onWaitingQueue {
  onWaitingQueue {
    data {
      id
      from
      conference_id
      phone_number
      started_at
      deal_id
      deal_state
      is_thunder
      customer_name
      hunt_group_slug
      thunder_data
    }
    hunt_group_slug
  }
}
    `;

/**
 * __useOnWaitingQueueSubscription__
 *
 * To run a query within a React component, call `useOnWaitingQueueSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnWaitingQueueSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnWaitingQueueSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnWaitingQueueSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnWaitingQueueSubscription, OnWaitingQueueSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnWaitingQueueSubscription, OnWaitingQueueSubscriptionVariables>(OnWaitingQueueDocument, options);
      }
export type OnWaitingQueueSubscriptionHookResult = ReturnType<typeof useOnWaitingQueueSubscription>;
export type OnWaitingQueueSubscriptionResult = Apollo.SubscriptionResult<OnWaitingQueueSubscription>;